export const QUESTIONS = [
  {
    "id": 1,
    "question": "Which will accomplish a specific task for the user?",
    "choice_a": "Driver",
    "choice_b": "Application",
    "choice_c": "Operating system",
    "choice_d": "Filesystem",
    "correct_answer": "B",
    "explanation": "An application is written to perform a specific task for the user of the operating system, such as word processing or data analysis. Drivers allow the operating system to communicate with the hardware. The operating system and the filesystem assist in running applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      9,
      14,
      87,
      3
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 2,
    "question": "Which operating system is a workstation that operates solely in the cloud?",
    "choice_a": "Linux",
    "choice_b": "Android",
    "choice_c": "Windows 11",
    "choice_d": "ChromeOS",
    "correct_answer": "D",
    "explanation": "The Google ChromeOS is a workstation that operates solely in the cloud, because all the data is stored in the cloud. Cloud-based operating systems require an Internet connection to access information. Android and Windows 11 use cloud storage, but they are not considered cloud-based operating systems. Linux is strictly a workstation operating system.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      5,
      6,
      1,
      16
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 3,
    "question": "Which term defines the precompiled instructions that are programmed and allows an operating system and its applications to operate?",
    "choice_a": "Shell",
    "choice_b": "Source",
    "choice_c": "GUI",
    "choice_d": "Multithreading",
    "correct_answer": "B",
    "explanation": "The source, also known as the source code, is the code to be compiled, and this allows the operating system and applications to execute. The shell is a component of the operating system that allows execution of applications. The GUI is a graphical extension of the shell to allow the execution of applications. Multithreading is a term used to describe how an application can create multiple simultaneous requests to the processor.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      1,
      3,
      7,
      5,
      2
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 4,
    "question": "Which term best describes the Android operating system?",
    "choice_a": "Server",
    "choice_b": "Workstation",
    "choice_c": "Mobile",
    "choice_d": "Cloud-based",
    "correct_answer": "C",
    "explanation": "The Android operating system is a mobile operating system often used with tablets and smartphones. A server is an operating system that is optimized to serve information. A workstation is an operating system that is optimized to execute and display the information retrieved from a server operating system. A cloud-based operating system is an operating system that requires network connectivity to access applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      5,
      1,
      2,
      3
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 5,
    "question": "Which Windows Update branch will allow you to install preview releases of updates for Windows 11?",
    "choice_a": "Semi-Annual Channel",
    "choice_b": "Semi-Annual Channel (Targeted)",
    "choice_c": "Long-Term Servicing Channel",
    "choice_d": "Insider Program",
    "correct_answer": "D",
    "explanation": "The Insider Program allows for the installation of brand-new features before they are publicly released. The Semi-Annual Channel is normally delayed by three to four months. The Semi-Annual Channel (Targeted) branch will install updates as they are released to the general public. The Long-Term Servicing Channel never installs new features during the life of the version of Windows.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      53,
      52,
      46,
      47,
      5
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 6,
    "question": "Which tool will allow you to ready the operating system for imaging?",
    "choice_a": "Microsoft Deployment Toolkit",
    "choice_b": "Windows Assessment and Deployment Kit",
    "choice_c": "<code>sysprep.exe</code>",
    "choice_d": "Windows Imaging",
    "correct_answer": "C",
    "explanation": "The <code>sysprep.exe</code> utility will allow you to ready the operating system for imaging, by resetting specific information, such as the computer name. The Microsoft Deployment Toolkit can assist in creating the steps, but it calls on the <code>sysprep</code> tool. The Windows Assessment and Deployment Kit allows you to customize the Windows operating system for imaging, but it does not ready the operating system for imaging. Windows Imaging (WIM) is a file format to contain the image.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      13,
      52,
      1,
      30,
      28
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 7,
    "question": "Which element of the boot process holds the information that instructs the operating system to load from a specific partition?",
    "choice_a": "<code>winload.efi</code>",
    "choice_b": "<code>bootmgr</code>",
    "choice_c": "<code>winresume.exe</code>",
    "choice_d": "BCD",
    "correct_answer": "D",
    "explanation": "The Boot Configuration Data (BCD) holds the information that instructs the Windows Boot Manager (<code>bootmgr</code>) to load the operating system from a specific partition. <code>winload.efi</code> loads the operating system kernel. <code>bootmgr</code> is the initial bootstrap program that reads the BCD. <code>winresume.exe</code> is used when resuming a previous session that has been suspended.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      54,
      45,
      51,
      44,
      50
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 8,
    "question": "You need to configure a static IP address for Windows 11. Which of the following will allow you to perform this task?",
    "choice_a": "The Network & Sharing Center",
    "choice_b": "Windows Defender Firewall",
    "choice_c": "The Network & Internet Settings screen",
    "choice_d": "The VPN settings screen",
    "correct_answer": "C",
    "explanation": "By clicking the Start menu, then Settings, and choosing Network & Internet you can configure the properties of the network adapter to setup a static IP address. The Network & Sharing Center is used to view the network connection firewall profile and connection status. The Windows Defender Firewall is used to protect the operating system from malicious network connectivity. The VPN settings screen allows you to configure a virtual private network (VPN) connection.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      70,
      34,
      66,
      58,
      71
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 9,
    "question": "Which filesystem performs on-the-fly defragmentation?",
    "choice_a": "FAT",
    "choice_b": "NTFS",
    "choice_c": "ext4",
    "choice_d": "FAT32",
    "correct_answer": "C",
    "explanation": "The ext4 filesystem does not suffer from fragmentation, because it performs on-the-fly defragmentation. FAT is a 16-bit filesystem that suffers from fragmentation. NTFS is a journaled filesystem that suffers from fragmentation. FAT32 is a 32-bit filesystem that suffers from fragmentation.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      37,
      97,
      39,
      36,
      102
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 10,
    "question": "Which place can you find updates for Apple operating systems?",
    "choice_a": "iTunes",
    "choice_b": "App Store",
    "choice_c": "Keychain",
    "choice_d": "Mission Control",
    "correct_answer": "B",
    "explanation": "The App Store is where you can find updates for the Apple operating system. iTunes is used to purchase and download music, videos and other content. The Keychain is used to store credentials on behalf of the user. Mission Control is used to view all of the currently running applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      74,
      95,
      84,
      87,
      5
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 11,
    "question": "Which macOS feature is similar to Windows File Explorer?",
    "choice_a": "Keychain",
    "choice_b": "iCloud",
    "choice_c": "Spotlight",
    "choice_d": "Finder",
    "correct_answer": "D",
    "explanation": "The macOS Finder is the equivalent to the Windows File Explorer. The Keychain is a password management system for the operating system. iCloud is a cloud-based storage and backup service. Spotlight helps you find applications, documents and other files.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      85,
      84,
      25,
      87,
      88
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 12,
    "question": "You want to find all files in the <code>/home</code> directory and subdirectories that contain the word <code>password</code>. Which command should you use?",
    "choice_a": "<code>find /home -name \"password\"</code>",
    "choice_b": "<code>grep -r \"password\" /home</code>",
    "choice_c": "<code>ls /home | grep \"password\"</code>",
    "choice_d": "<code>grep \"password\" /home</code>",
    "correct_answer": "B",
    "explanation": "The <code>grep -r</code> command searches recursively for the word <code>password</code> in all files within the <code>/home</code> directory. The <code>find /home -name \"password\"</code> command will not recursively search the <code>/home</code> directory. The <code>ls /home | grep \"password\"</code> command will only return files with password in the name. The <code>grep \"password\" /home</code> command will not recursively search directories.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      105,
      98,
      104,
      106,
      99
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 13,
    "question": "Your system log files report an ongoing attempt to gain access to a single account. This attempt has been unsuccessful to this point. What type of attack are you most likely experiencing?",
    "choice_a": "Password-guessing attack",
    "choice_b": "Rootkit attack",
    "choice_c": "Worm attack",
    "choice_d": "TCP/IP hijacking",
    "correct_answer": "A",
    "explanation": "A password-guessing attack occurs when a user account is repeatedly attacked using a variety of passwords. A rootkit attack would not be immediately seen and not shown as an ongoing effort. A worm attack would not be visible as an ongoing attempt to gain access. TCP/IP hijacking is a form of an on-path (formerly man-in-the-middle) attack.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      148,
      160,
      157,
      129,
      209
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 14,
    "question": "One of the vice presidents of the company calls a meeting with the information technology department after a recent trip to competitors\u2019 sites. She reports that many of the companies she visited granted access to their buildings only after fingerprint scans, and she wants similar technology employed at this company. Of the following, which technology relies on a physical attribute of the user for authentication?",
    "choice_a": "Smartcard",
    "choice_b": "Biometrics",
    "choice_c": "Geo-fencing",
    "choice_d": "Tokens",
    "correct_answer": "B",
    "explanation": "Biometrics relies on a physical characteristic of the user to verify identity. Biometric devices typically use either a hand pattern or a retinal scan to accomplish this. Smartcards contain a private certificate key and are protected with a passphrase. Geo-fencing uses GPS coordinates to require that authentication only happens within those parameters. Tokens are rotating numerical keys that you must physically have with you.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      115,
      120,
      113,
      191,
      114
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 15,
    "question": "What type of malware is able to conceal itself from many parts of the operating system and will obtain/retain elevated privileges?",
    "choice_a": "Worm",
    "choice_b": "Trojan",
    "choice_c": "Rootkit",
    "choice_d": "Botnet",
    "correct_answer": "C",
    "explanation": "Rootkits are software programs that have the ability to hide certain things from the operating system. A worm is malware that replicates itself and infects other system. Trojans are programs that enter a system or network under the guise of another program. A botnet is a group of infected computers that can be remotely controlled via a command and control server.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      129,
      128,
      133,
      117,
      170
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 16,
    "question": "Which component of physical security addresses outer-level access control?",
    "choice_a": "Fences",
    "choice_b": "Access control vestibule",
    "choice_c": "Multifactor authentication",
    "choice_d": "Strong passwords",
    "correct_answer": "A",
    "explanation": "Fences are intended to delay or deter entrance into a facility\u2019s outer-level of access. Access control vestibules are used for mid-layer access control to prevent tailgating. Multifactor authentication (MFA) is used for mid- and inner-layer access control. Strong passwords are used for mid- and inner-layer access control.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      112,
      108,
      111,
      110,
      116
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 17,
    "question": "Which type of device can detect weapons on a person entering a facility?",
    "choice_a": "Biometrics",
    "choice_b": "Magnetometer",
    "choice_c": "Motion sensor",
    "choice_d": "Badge reader",
    "correct_answer": "B",
    "explanation": "A magnetometer, also known as a metal detector, can detect weapons on a person entering a facility. Biometrics are used to authenticate someone based on their physical traits. A motion sensor is used to detect motion. A badge reader is used to scan security ID badges.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      116,
      115,
      108,
      110,
      120
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 18,
    "question": "A user wants to ensure that all contacts from their mobile device are copied onto their computer before migrating to a new device. Which of the following processes can accomplish this?",
    "choice_a": "Mirroring",
    "choice_b": "Synchronization",
    "choice_c": "Calling each contact",
    "choice_d": "Attaching the contacts to an email",
    "correct_answer": "B",
    "explanation": "Synchronization can copy all contacts, programs, email messages, pictures, music, and videos between a mobile device and a computer. Mirroring is a term reserved for when devices replicate themselves to similar devices. Calling the contacts won\u2019t achieve the desired result, and emailing contacts is inefficient and does not immediately result in placing the contacts on the computer.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      197,
      124,
      198,
      232,
      196
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 19,
    "question": "Which feature of Windows Defender Firewall allows you to create custom rules for applications?",
    "choice_a": "Real-time protection",
    "choice_b": "Cloud-delivered protection",
    "choice_c": "Advanced Security MMC",
    "choice_d": "Tamper protection",
    "correct_answer": "C",
    "explanation": "The Advanced Security MMC allows you to create custom rules for applications in Windows Defender Firewall. Real-time protection provides real-time antivirus and antimalware protection. Cloud-delivered protection allows for the automatic submission of malware samples. Tamper protection notifies you if Windows Defender Antivirus is turned off or tampered with.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      173,
      187,
      154,
      153,
      138
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 20,
    "question": "A technician is configuring a new Windows computer for a home office. Which of the following steps should the technician take to secure the workstation?",
    "choice_a": "Rename default accounts.",
    "choice_b": "Configure Single Sign-On.",
    "choice_c": "Disable Windows Update.",
    "choice_d": "Disable Action Center pop-ups.",
    "correct_answer": "A",
    "explanation": "Renaming the default accounts on the new Windows computer is the easiest way to secure the operating system. Configuring Single Sign-On should only be performed if a resource is required that only uses SSO as authentication. Disabling Windows Update will do the opposite of securing the operating system. Disabling Action Center pop-ups will also do the opposite of securing the operating system.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      160,
      167,
      170,
      153,
      148
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 21,
    "question": "You need to protect files on the desktop operating system with encryption, but find out you do not have a TPM. What can you use to protect the files?",
    "choice_a": "BitLocker",
    "choice_b": "Encrypted File System",
    "choice_c": "BitLocker To Go",
    "choice_d": "Full drive encryption",
    "correct_answer": "B",
    "explanation": "Encrypted File System (EFS) will encrypt and protect files on an NTFS filesystem without the need of the TPM. BitLocker requires a TPM and therefore will not work. BitLocker To Go is used with removable media. Full drive encryption is used with mobile devices.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      174,
      172,
      156,
      171,
      200
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 22,
    "question": "Which is a benefit of setup of a device with a Microsoft account?",
    "choice_a": "Access to the online store",
    "choice_b": "Automatic synchronization of OneDrive",
    "choice_c": "Active Directory authentication",
    "choice_d": "Offline authentication",
    "correct_answer": "B",
    "explanation": "When you set up a device with a Microsoft account, you automatically synchronize files in OneDrive, along with other known folders. Access to the online store can be achieved by launching the Microsoft Store and logging in; it does not require the user to log into the operating system with the Microsoft account. Active Directory authentication is applicable if the workstation is joined to an Active Directory domain. Offline authentication is the default method if you are not signing in with a Microsoft account.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      166,
      125,
      122,
      170,
      167
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 23,
    "question": "Which critical system generally requires third-party tools to troubleshoot performance problems?",
    "choice_a": "RAM",
    "choice_b": "CPU",
    "choice_c": "Graphics",
    "choice_d": "Network",
    "correct_answer": "C",
    "explanation": "Graphics cards usually require third-party tools to diagnosis performance problems. RAM problems can be diagnosed inside the operating system from Task Manager. CPU problems can be diagnosed inside the operating system from Task Manager. Network problems can be diagnosed inside the operating system from Task Manager.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      201,
      207,
      204,
      216,
      219
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 24,
    "question": "What is the last step that should be performed when removing malware?",
    "choice_a": "Investigate and verify symptoms.",
    "choice_b": "Enable System Protection.",
    "choice_c": "Educate the end user.",
    "choice_d": "Schedule scans and run updates.",
    "correct_answer": "C",
    "explanation": "The last step in the malware removal process is the education of the end user to prevent future occurrences of infection. Investigate and verify malware symptoms is the first step in the malware removal process. Enabling System protection is one of the last steps, but it is not the last step. Scheduling scans and running updates should be performed after you have remediated the malware.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      220,
      217,
      139,
      209,
      138
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 25,
    "question": "Your mobile device is suffering from an intermittent wireless connection. What is recommended to alleviate signal drops?",
    "choice_a": "Shortening the SSID",
    "choice_b": "Using the 5 GHz band",
    "choice_c": "Reducing power on the WAP",
    "choice_d": "Using the 2.4 GHz band",
    "correct_answer": "B",
    "explanation": "By using the 5 GHz wireless band you can limit the amount of interference from external devices such as microwave ovens and Bluetooth devices. Shortening the SSID will have no effect on intermittent signal drops. Reducing power on the WAP will have no effect on intermittent signal drops. Using the 2.4 GHz band will probably make signal drops worse.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      181,
      185,
      182,
      183,
      194
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 26,
    "question": "You are receiving USB controller resource warning messages. What should you try to resolve the issue?",
    "choice_a": "Move USB devices around on the USB ports.",
    "choice_b": "Manually allot more endpoints.",
    "choice_c": "Upgrade drivers for the USB devices.",
    "choice_d": "Manually increase the output amperage.",
    "correct_answer": "A",
    "explanation": "Moving USB devices around on the USB ports is the first step in remediating USB issues related to resources. USB 2.0 devices should be consolidated to USB 2.0 ports and the same should be done for USB 3.0 devices. You cannot manually allot endpoints for USB devices. Upgrading the drivers for the USB devices will not solve power issues or endpoint issues; drivers for the USB controller should be updated. You cannot manually increase the output amperage for USB devices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      201,
      204,
      219,
      226,
      227
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 27,
    "question": "Why is time drift a big problem on virtual machines?",
    "choice_a": "Lack of configuration for the NTP server",
    "choice_b": "Availability of the NTP server",
    "choice_c": "Shared physical RTC",
    "choice_d": "Emulated RTC",
    "correct_answer": "D",
    "explanation": "Normally a dedicated chip called the real time clock (RTC) keeps time for physical machines. However, with virtual machines their RTC is emulated and susceptible to time drift. By default, Windows 10/11 are configured for time.windows.com as an NTP. The availability of the NTP server of <code>time.windows.com</code> is not any different than physical machines. When deploying virtual machines, the physical RTC is not shared; each VM gets an emulated RTC.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      213,
      202,
      207,
      204,
      216
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 28,
    "question": "Which tool can be used to restart a failed service?",
    "choice_a": "<code>msconfig.exe</code>",
    "choice_b": "WinRE",
    "choice_c": "Computer Management MMC",
    "choice_d": "Resource Monitor",
    "correct_answer": "C",
    "explanation": "The Computer Management MMC contains the Services add-in that can be used to restart and configure failed services. Although services can be viewed with the <code>msconfig.exe</code> tool, they cannot be restarted with the tool, only enabled and disabled on startup. The Windows Recovery Environment (WinRE) is used to troubleshoot and repair problems offline. The Resource Monitor cannot be used to restart services.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      206,
      204,
      201,
      203,
      202
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 29,
    "question": "Which is a safety risk from overheating a lithium-ion battery?",
    "choice_a": "Reduced voltage",
    "choice_b": "Shock",
    "choice_c": "Explosion",
    "choice_d": "Shutdown",
    "correct_answer": "C",
    "explanation": "The risk of thermal runaway is attributed from overheating a lithium-ion battery. When thermal runaway happens, you run the risk of explosion of the battery. Overheating a li-ion battery can cause reduced voltage, but that is not a safety risk. Overheating a li-ion battery will not cause a shock. Overheating of the li-ion battery will cause a shutdown, but that is not a safety risk.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 30,
    "question": "A user is experiencing frequent shutdowns on their Windows computer. What should you check first to identify the cause?",
    "choice_a": "Event Viewer",
    "choice_b": "Device Manager",
    "choice_c": "Task Manager",
    "choice_d": "Windows Update",
    "correct_answer": "A",
    "explanation": "Event Viewer logs can help identify the cause of frequent shutdowns by showing entries related to Kernel-Boot or Kernel-General. Device Manager manages hardware devices. Task Manager monitors tasks and performance. Windows Update manages updates for the operating system.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      204,
      205,
      203,
      202,
      201
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 31,
    "question": "Which network protocol and port does RDP operate on?",
    "choice_a": "TCP port 3389",
    "choice_b": "TCP port 22",
    "choice_c": "TCP port 5900",
    "choice_d": "TCP port 443",
    "correct_answer": "A",
    "explanation": "The Remote Desktop Protocol operates on TCP port 3389. The SSH protocol operates on TCP port 22. The VNC protocol operates on TCP port 5900, and HTTPS operates on TCP port 443.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      239,
      241,
      244,
      245,
      243
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 32,
    "question": "Which line would be used to comment Windows Batch script code?",
    "choice_a": "<code>//comment</code>",
    "choice_b": "<code>'comment</code>",
    "choice_c": "<code>REM comment</code>",
    "choice_d": "<code># comment</code>",
    "correct_answer": "C",
    "explanation": "The line of <code>REM comment</code> is used to comment Windows Batch script code. The line of <code>//comment</code> is used to comment JavaScript code. The line of <code>'comment</code> is used to comment VBScript code. The line of <code># comment</code> is used to comment Bash script code and PowerShell code.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      236,
      237,
      235,
      234,
      233
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 33,
    "question": "Which command will launch the Remote Desktop Connection utility?",
    "choice_a": "<code>msra.exe</code>",
    "choice_b": "<code>mstsc.exe</code>",
    "choice_c": "<code>quickassist.exe</code>",
    "choice_d": "<code>ssh.exe</code>",
    "correct_answer": "B",
    "explanation": "The command <code>mstsc.exe</code> will launch the Windows Remote Desktop Connection utility. From this utility you can remotely connect to a server or other workstation. The command <code>msra.exe</code> will launch the Microsoft Remote Assistance utility to allow a trusted helper to remote in to help. The command <code>quickassist.exe</code> will launch the Quick Assist remote assistance utility to allow an assistant to remote in to help. The command <code>ssh.exe</code> will launch the Secure Shell client that allows you to connect to a Linux/UNIX server or networking equipment.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      239,
      241,
      243,
      245,
      244
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 34,
    "question": "A client computer connects to the main office and is configured with an IP address from the main office, on the client computer. What is being described?",
    "choice_a": "Site-to-site VPN",
    "choice_b": "Remote Desktop connection",
    "choice_c": "SSH connection",
    "choice_d": "Host-to-site VPN",
    "correct_answer": "D",
    "explanation": "The scenario being described is a host-to-site connection. A site-to-site VPN connection will be built between two sites, such as the main site and a branch site. A Remote Desktop connection or SSH connection will not configure a site IP address on the client computer.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      240,
      241,
      243,
      244,
      245
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 35,
    "question": "Zoom and Teams are classic examples of what?",
    "choice_a": "Screen-sharing software",
    "choice_b": "Videoconferencing software",
    "choice_c": "File transfer software",
    "choice_d": "Desktop management software",
    "correct_answer": "B",
    "explanation": "Zoom and Teams are classic examples of videoconferencing software, because they allow multiple attendees and have a form of attendee management. Microsoft Quick Assist is an example of screen-sharing software. Dropbox is an example of file transfer software. Splashtop and TeamViewer are examples of desktop management software.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      242,
      239,
      244,
      243,
      282
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 36,
    "question": "Which of the following is a hallmark of human intelligence that AI does not possess?",
    "choice_a": "Pattern recognition",
    "choice_b": "Emotional experience",
    "choice_c": "Data processing",
    "choice_d": "Task automation",
    "correct_answer": "B",
    "explanation": "Emotional experience is a hallmark of human intelligence that AI does not possess. AI can recognize patterns. AI is excellent at processing large volumes of data. AI can automate tasks.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      247,
      249,
      250,
      253,
      254
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 37,
    "question": "Which of the following are good measures to take to help prevent ESD? (Choose two.)",
    "choice_a": "Decrease the humidity.",
    "choice_b": "Tie long hair back.",
    "choice_c": "Take your shoes off.",
    "choice_d": "Perform self-grounding.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Long hair or neckties can very easily hold a static charge and damage computer parts. In addition, if you don\u2019t have an ESD strap or mat, you should perform self-grounding before you touch sensitive computer equipment. Lower humidity actually increases the risk of ESD. Taking your shoes off will not limit ESD.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      258,
      260,
      259,
      266,
      268
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 38,
    "question": "Which of the following screwdrivers has a splined head?",
    "choice_a": "Flat-tipped",
    "choice_b": "Phillips",
    "choice_c": "Axial",
    "choice_d": "Torx",
    "correct_answer": "D",
    "explanation": "A Torx screwdriver has a splined head used for greater gripping of the screw. A flat-tipped screwdriver as the name suggests has a flat tip. A Phillips screwdriver has a cross used for better gripping over a normal flat-tip screwdriver. An axial screwdriver is not a type of screwdriver.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      262,
      258,
      257,
      265,
      313
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 39,
    "question": "What type of software licensing agreement usually provides free trial software, with the expectation that you will pay for it if you decide to keep it?",
    "choice_a": "Freeware",
    "choice_b": "Shareware",
    "choice_c": "Open source",
    "choice_d": "Single user",
    "correct_answer": "B",
    "explanation": "Shareware often provides a free trial of a program, with the expectation that you will pay for it if you keep it. Freeware and open source applications are generally totally free, although the developers may ask for donations. Single user software is licensed for one user.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      274,
      276,
      288,
      282,
      280
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 40,
    "question": "How do antistatic mats and wrist straps drain the potential ESD?",
    "choice_a": "The use of magnets",
    "choice_b": "Through a resistor",
    "choice_c": "High-voltage probe",
    "choice_d": "Direct ground",
    "correct_answer": "B",
    "explanation": "Typically, a 1 mega-ohm resistor is used to slowly drain or discharge the potential electrostatic discharge (ESD). Magnets are used to hold screws onto screwdrivers. High-voltage probes are used to drain high voltage stored up in electrical circuits and not ESD. Direct grounds are never used because they have the potential for discharge and possible electrocution.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      259,
      258,
      260,
      268,
      256
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 41,
    "question": "When cleaning dust out of computer equipment, you should always use which of the following?",
    "choice_a": "Multimeter",
    "choice_b": "Flashlight",
    "choice_c": "Air filter mask",
    "choice_d": "Mirror",
    "correct_answer": "C",
    "explanation": "An air filter mask will protect you from inhaling dust particles. A multimeter is used to measure voltage. Although useful, a flashlight and a mirror are not needed for cleaning dust out of computer equipment.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      266,
      268,
      313,
      262,
      256
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 42,
    "question": "Which is the most likely source of interference to wireless communications?",
    "choice_a": "Magnets",
    "choice_b": "ESD",
    "choice_c": "Surges",
    "choice_d": "Microwave ovens",
    "correct_answer": "D",
    "explanation": "Microwave ovens operate in the 2.45 GHz range and can directly affect wireless communications. Magnets can generate a magnetic field, but they will not disrupt wireless communications. Electrostatic discharge (ESD) can kill components, but a discard from ESD in the same space as wireless will not cause interruptions. Electrical surges can affect the equipment running wireless, but it will not affect wireless communications.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      266,
      264,
      265,
      256,
      257
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 43,
    "question": "While working on a user\u2019s system, you discover a sticky note attached to the bottom of the keyboard that has their username and password written on it. The user is not around, and you need to verify that the network connection is working. What should you do?",
    "choice_a": "Log in, verify access, and log out.",
    "choice_b": "Log in and stay logged in when you are finished.",
    "choice_c": "Text the user.",
    "choice_d": "Log in and change the user\u2019s password.",
    "correct_answer": "C",
    "explanation": "You should text the user and let them know that you need to verify their network connection. You should not log in as another person, with their username and password. You should not log in and stay logged in when you are finished. You should definitely not log in and change the user\u2019s password.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      312,
      313,
      280,
      285,
      270
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 44,
    "question": "While installing a new network card, you accidentally broke a component off of the card. What should you do?",
    "choice_a": "Explain that the card was broken out of the box.",
    "choice_b": "Install the card anyway.",
    "choice_c": "Inform the customer of the situation.",
    "choice_d": "Leave everything as is until you can locate a new card.",
    "correct_answer": "C",
    "explanation": "You should be honest and inform the customer of the situation. Explaining the card was broken out of the box is untruthful and deceptive. Installing the card anyway will cause new problems. Leaving everything as is until you can locate a new card, does not help the customer since you\u2019ve created a new dilemma.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      310,
      304,
      307,
      311,
      312
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 45,
    "question": "What should you do when you cannot meet the timeline you proposed for resolving an issue?",
    "choice_a": "Avoid informing the customer.",
    "choice_b": "Communicate the delay and provide a new estimate.",
    "choice_c": "Blame external factors.",
    "choice_d": "Close the ticket prematurely.",
    "correct_answer": "B",
    "explanation": "Communicating the delay and providing a new estimate will help maintain transparency and manage customer expectations. Avoiding informing the customer will not meet the customer\u2019s expectations for communicating the timeline. Blaming external factors is deceitful and not professional. Closing the ticket prematurely is an unprofessional behavior because the customer will not have a status on the resolution.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      309,
      310,
      304,
      311,
      282
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 46,
    "question": "Which ticket entry method is the easiest for end users to submit their own tickets?",
    "choice_a": "Email entry",
    "choice_b": "Portal entry",
    "choice_c": "Manual entry",
    "choice_d": "Application entry",
    "correct_answer": "A",
    "explanation": "Email entry is the easiest for end users because it allows them to email the ticketing system and use a method of communication they are familiar with. Portal entry requires the end user to log into the portal, then enter fields in a form to submit a ticket. Manual ticket entry is not done by the end user; it is completed by help desk staff. Application entry is an automated ticket that submits when an application has an issue; this is independent from what the user needs solved.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      279,
      280,
      281,
      308,
      304
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 47,
    "question": "Which method is used to test a change in an isolated environment?",
    "choice_a": "Primary plan",
    "choice_b": "Backout plan",
    "choice_c": "Sandbox testing",
    "choice_d": "Technical evaluation",
    "correct_answer": "C",
    "explanation": "Sandbox testing is used to test a change before placing it into production. The process from the sandbox testing will become the primary plan used when the change in production is green-lighted. The backout, also known as the rollback plan is created in the event the primary plan fails in production. The technical evaluation is a technical evaluation of the change, along with a draft of the primary plan.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      290,
      295,
      289,
      294,
      292
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 48,
    "question": "You need to change the computer\u2019s name and join it to a domain, which tool will allow you to perform these actions?",
    "choice_a": "Device Manager",
    "choice_b": "User Accounts",
    "choice_c": "System Properties",
    "choice_d": "Credential Manager",
    "correct_answer": "C",
    "explanation": "The System Properties applet (SYSDM.CPL) allows you to change the computer name and join the system to a domain. The Device Manager is used to manage hardware resources. The User Accounts applet is used to manage user accounts. Credential Manager is used to manage stored credentials.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      288,
      295,
      279,
      280,
      262
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 49,
    "question": "Which tab in the Task Manager will allow you to see processes separated by each user on the system?",
    "choice_a": "Processes",
    "choice_b": "Performance",
    "choice_c": "App History",
    "choice_d": "Users",
    "correct_answer": "D",
    "explanation": "The Users tab in Task Manager will allow you to see processes sorted by each user. The Processes tab will show you processes sorted by forefront and background applications. The Performance tab will show you the overall performance of the system with graphical charts. The App History tab will display historical information about processes, such as CPU time.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      27,
      43,
      31,
      29,
      1
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 50,
    "question": "Which RAID system requires three or more disks to provide fault tolerance?",
    "choice_a": "Mirroring",
    "choice_b": "Striping",
    "choice_c": "RAID-1",
    "choice_d": "Striping with Parity",
    "correct_answer": "D",
    "explanation": "Striping with parity is also known as RAID-5, it requires three or more disks and provides fault tolerance. Mirroring is also known as RAID-1 and only requires two disks. Striping is also known as RAID-0 and provides no fault tolerance.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      312,
      300,
      299
    ],
    "source": "330034_Vol2_AssessmentTest"
  },
  {
    "id": 51,
    "question": "Which of the following can you type in the Start menu in Windows to open a command prompt? (Choose two.)",
    "choice_a": "<code>run</code>",
    "choice_b": "<code>cmd</code>",
    "choice_c": "<code>command</code>",
    "choice_d": "<code>open</code>",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "You can open a command prompt by typing <code>cmd</code> or <code>command</code> in the Start menu. The command prompt utility will pop up in the search results. Run is not a command; it is a dialog box. Open is not a command; it is an operating system action.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      63,
      62,
      56,
      25
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 52,
    "question": "Which part of the operating system can be described as extremely specific software written for the purpose of instructing the OS on how to access a piece of hardware?",
    "choice_a": "Source code",
    "choice_b": "Application",
    "choice_c": "Kernel",
    "choice_d": "Driver",
    "correct_answer": "D",
    "explanation": "A driver is specifically written to instruct the operating system to communicate with a piece of hardware. Source code is the original code the software is written in. An application is a program written to perform a specific purpose to interact with the user. The kernel is the core of the operating system.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      1,
      90,
      7,
      3,
      9
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 53,
    "question": "Which application will sync your files to the cloud?",
    "choice_a": "Excel",
    "choice_b": "OneDrive",
    "choice_c": "Exchange",
    "choice_d": "Outlook",
    "correct_answer": "B",
    "explanation": "OneDrive is a cloud-based file synchronization application; it is similar to Google Drive. Excel is a spreadsheet application that is part of the Microsoft 365 suite of products. Microsoft Exchange is an on-premises email server; its cloud-based counterpart is Microsoft Exchange Online, and it is similar to Google Gmail. Outlook is the email client used with Microsoft Exchange.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      49,
      16,
      11,
      14
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 54,
    "question": "Which of the following installation methods would you use if you wanted to install a program on a virtual machine? (Choose the best method.)",
    "choice_a": "ISO",
    "choice_b": "USB",
    "choice_c": "Optical disk",
    "choice_d": "ZIP files",
    "correct_answer": "A",
    "explanation": "If you wanted to install a program on a virtual machine, the preferred method would be to mount an ISO image of the application. USB and optical discs are not common installation methods for virtual machines. Although ZIP files could be used, a ZIP file is only a compression method and not a delivery method.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      54,
      12,
      46,
      44
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 55,
    "question": "The Windows File Explorer program can be used to do which of the following? (Choose two.)",
    "choice_a": "Browse the Internet",
    "choice_b": "Copy and move files",
    "choice_c": "Change file attributes",
    "choice_d": "Create backup jobs",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The Windows File Explorer program can be used to copy and move files. Windows File Explorer can also be used to change file attributes. Windows File Explorer cannot be used to browse the Internet or to create backup jobs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      7,
      57,
      35,
      30
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 56,
    "question": "What is the maximum allowable length for the name of a file in Windows?",
    "choice_a": "8 characters",
    "choice_b": "32 characters",
    "choice_c": "64 characters",
    "choice_d": "255 characters",
    "correct_answer": "D",
    "explanation": "The maximum allowable length for a filename is 255 characters.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      36,
      40,
      42,
      56,
      57
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 57,
    "question": "Which of the following is a program that runs on top of the OS and allows the user to issue commands through a set of menus or some other graphical interface?",
    "choice_a": "Taskbar",
    "choice_b": "Shell",
    "choice_c": "Desktop",
    "choice_d": "Source",
    "correct_answer": "B",
    "explanation": "The shell is a program that runs on top of the OS and allows user interaction with the operating system. The Taskbar is an element of the Desktop. The Desktop does not allow for commands to be executed. Source is not related to the graphical interface.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      1,
      63,
      98,
      5
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 58,
    "question": "If a program doesn\u2019t have a shortcut on the Desktop or in the All Apps submenu, you can start it by which of the following methods? (Choose the best answer.)",
    "choice_a": "Using the Shut Down command",
    "choice_b": "Typing the program name in the Start box",
    "choice_c": "Using the <code>run</code> command and typing in the name of the program",
    "choice_d": "Typing <code><b>cmd</b></code> in the Start box followed by the program name",
    "correct_answer": "B",
    "explanation": "Typing the program name in the Start box allows you to launch the program. The Shut Down command will shut down the operating system. Run is not a command; it is a dialog. The <code>cmd</code> command starts the command-prompt application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      63,
      7,
      1,
      14
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 59,
    "question": "Which operating system feature offers the ability for a single application to have multiple requests into the processor at one time?",
    "choice_a": "Multiuser mode",
    "choice_b": "Dystopia",
    "choice_c": "Preemption",
    "choice_d": "Multithreading",
    "correct_answer": "D",
    "explanation": "When a program is multithreaded, it is written to allow for multiple requests into the processor at one time. Multiuser mode, dystopia, and preemption are not correct answers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      1,
      7,
      4,
      8
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 60,
    "question": "In Windows, a deleted file can be retrieved using which of the following?",
    "choice_a": "My Computer icon",
    "choice_b": "Recycle Bin",
    "choice_c": "Control Panel",
    "choice_d": "Settings app",
    "correct_answer": "B",
    "explanation": "The Recycle Bin is a temporary spot that files are deleted to but from where they can be retrieved if deleted mistakenly. The My Computer icon is another older way to start the File Explorer. Control Panel and the Settings app are used to customize the operating system.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      7,
      34,
      32,
      23,
      42
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 61,
    "question": "To turn off a Windows 11 operating system gracefully, you should do which of the following?",
    "choice_a": "Run the turnoff command at a command prompt.",
    "choice_b": "Turn off the switch and unplug the machine.",
    "choice_c": "Press Ctrl+Alt+Del.",
    "choice_d": "Select Start, then click the power icon, and then choose Shut Down.",
    "correct_answer": "D",
    "explanation": "In Windows 11, when you click the Start button, a power icon is displayed on the lower left. From the power icon, you can sleep, reboot, or shut down the operating system. There is no command named turnoff. Turning the power switch off and unplugging the machine are not graceful ways to power off the operating system. Pressing Ctrl+Alt+Del alone will not power down the computer.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      23,
      7,
      5,
      1,
      3
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 62,
    "question": "Which is required for a 64-bit installation of Windows 11?",
    "choice_a": "TPM 2.0",
    "choice_b": "32 GB Storage",
    "choice_c": "Microsoft DirectX 9 graphics device",
    "choice_d": "4 GB RAM",
    "correct_answer": "A",
    "explanation": "A Trusted Platform Module (TPM) 2.0 is required for the installation of Windows 11. 64 GB or greater of storage is required for the installation of Windows 11. A Microsoft DirectX 12 graphics device is required for the installation of Windows 11. The minimum amount of memory required for the installation of the 64-bit Windows 11 operating system is 4 GB. More RAM is always recommended, but only 4 GB is required.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      8,
      44,
      19,
      45,
      55
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 63,
    "question": "What is the minimum amount of free hard drive space required for the installation of Windows 11 64-bit?",
    "choice_a": "1.5 GB",
    "choice_b": "15 GB",
    "choice_c": "32 GB",
    "choice_d": "64 GB",
    "correct_answer": "D",
    "explanation": "The minimum amount of free hard drive space required for Windows 11 64-bit is 64 GB.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      8,
      44,
      45,
      19,
      55
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 64,
    "question": "What is the minimum required memory for a 64-bit installation of Windows 11?",
    "choice_a": "512 MB",
    "choice_b": "1 GB",
    "choice_c": "2 GB",
    "choice_d": "4 GB",
    "correct_answer": "D",
    "explanation": "The minimum amount of memory required for the 64-bit installation of the Windows 11 is 4 GB.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      44,
      19,
      2,
      9
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 65,
    "question": "In Windows, a quick way to access Help is to press which keyboard key?",
    "choice_a": "F12",
    "choice_b": "The Windows key on the keyboard",
    "choice_c": "F1",
    "choice_d": "Alt",
    "correct_answer": "C",
    "explanation": "A quick method of accessing Help is to press the F1 key. The Windows key on the keyboard launches the Start menu. The F12 key and the Alt key perform various tasks, depending on the application.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      23,
      30,
      63,
      1
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 66,
    "question": "Which key(s) will open a run box?",
    "choice_a": "Windows key+R",
    "choice_b": "Ctrl+R",
    "choice_c": "Windows key",
    "choice_d": "F1",
    "correct_answer": "A",
    "explanation": "The Windows key+R will open a run box, where you can launch applications by typing in their executable name. Ctrl+R is used to reload web pages in web browsers. The Windows key alone will launch the Start menu. The F1 key will launch help in applications and on the desktop it will launch a web browser.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      62,
      63,
      34,
      43
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 67,
    "question": "Which of the following is located on the rightmost portion of the Taskbar?",
    "choice_a": "Start menu",
    "choice_b": "Pinned apps",
    "choice_c": "Notification area",
    "choice_d": "Shutdown options",
    "correct_answer": "C",
    "explanation": "The notification area is the area on the rightmost portion of the Taskbar. It is used to display the date and time and running background applications. The pinned apps and Start menus are located on the center-left portion of the Taskbar. Shutdown options are found inside the Start menu in Windows 11.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      34,
      30,
      1,
      9
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 68,
    "question": "In addition to right-clicking the Desktop, how else can you access the Display Properties settings?",
    "choice_a": "By clicking the Settings gear in the Start menu",
    "choice_b": "By clicking the System icon under Control Panel",
    "choice_c": "By pressing Ctrl+Alt+Esc",
    "choice_d": "By pressing Ctrl+Alt+Tab",
    "correct_answer": "A",
    "explanation": "Clicking the Settings gear in the Start menu will open the Settings app. From there, the System category will allow you to change the Display Properties. Clicking the System icon under Control Panel allows you to change system settings. Pressing Ctrl+Alt+Esc launches the Task Manager. Pressing Ctrl+Alt+Tab launches the Task View in Windows 11.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      23,
      27,
      43
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 69,
    "question": "Which of the following allows you to navigate file/folder structures in Windows?",
    "choice_a": "Start menu",
    "choice_b": "File Explorer",
    "choice_c": "KDE",
    "choice_d": "GNOME",
    "correct_answer": "B",
    "explanation": "The File Explorer allows you to navigate the file/folder structure in Windows 11. The Start menu allows you to launch applications. KDE and GNOME are Linux desktop shells.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      7,
      23,
      85,
      99
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 70,
    "question": "What is the minimum required processor speed for a 64-bit installation of Windows 11?",
    "choice_a": "2.2 GHz",
    "choice_b": "3.3 GHz",
    "choice_c": "1.0 GHz",
    "choice_d": "2.3 GHz",
    "correct_answer": "C",
    "explanation": "The minimum processor speed required for the 64-bit installation of the Windows 11 is 1 GHz.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      44,
      8,
      19,
      2,
      9
    ],
    "source": "330034_Vol2_Ch01"
  },
  {
    "id": 71,
    "question": "Which MMC snap-in allows you to start a program based on a condition?",
    "choice_a": "Programs and Features",
    "choice_b": "Task Scheduler",
    "choice_c": "Disk Management",
    "choice_d": "Group Policy Editor",
    "correct_answer": "B",
    "explanation": "Task Scheduler (<code>taskschd.msc</code>) will allow you to start a program based on a condition met, such as the computer starting up. The Programs and Features applet is not an MMC snap-in. The Disk Management MMC snap-in allows you to manage the disks attached to the computer. The Group Policy Editor lets you edit the local Group Policy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      60,
      21,
      12,
      35
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 72,
    "question": "You need to select a format for a flash drive that is compatible with other operating systems. Which of the following is the filesystem should you choose?",
    "choice_a": "NTFS",
    "choice_b": "EFS",
    "choice_c": "FAT32",
    "choice_d": "CDFS",
    "correct_answer": "C",
    "explanation": "FAT32 is a filesystem that was popular with Windows 9x operating systems and is also commonly used for USB flash drives for compatibility between platforms. NTFS is the native filesystem for Windows. EFS is a technology that encrypts files. The CDFS filesystem is used for CD media.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      36,
      37,
      38,
      61
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 73,
    "question": "Which utility can be used to schedule a remote shutdown?",
    "choice_a": "<code>taskmgr</code>",
    "choice_b": "<code>kill</code>",
    "choice_c": "<code>shutdown</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "The <code>shutdown</code> utility can be used to schedule a remote shutdown\u2014for example, <code>shutdown /t 60 /m \\\\computer</code>. The <code>taskmgr</code> utility is used to view tasks, <code>kill</code> is used to kill processes, and <code>netstat</code> is used to view network statistics and activity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      59,
      103,
      30,
      20
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 74,
    "question": "Which event log should be checked if you suspect that the computer has rebooted unexpectedly?",
    "choice_a": "Application",
    "choice_b": "Boot",
    "choice_c": "Security",
    "choice_d": "System",
    "correct_answer": "D",
    "explanation": "The System event log would contain an entry when the operating system reboots. The Application log is used to log applications installed on the system. The boot log is not a valid log. The Security log contains log information pertaining to the security of objects and files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      1,
      7,
      62
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 75,
    "question": "Which of the following filesystems is a proprietary filesystem created by Microsoft for use with large flash drives?",
    "choice_a": "GPT",
    "choice_b": "NFS",
    "choice_c": "ext3",
    "choice_d": "exFAT",
    "correct_answer": "D",
    "explanation": "The exFAT filesystem is a Microsoft proprietary filesystem created for large flash drives. GPT is a partition table type, NFS is a network filesystem used with Linux/Unix, and ext3 is a filesystem used with Linux.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      39,
      37,
      36,
      40,
      61
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 76,
    "question": "Which section in the Settings app lets you configure backups?",
    "choice_a": "System",
    "choice_b": "Devices",
    "choice_c": "Apps",
    "choice_d": "Accounts",
    "correct_answer": "D",
    "explanation": "The Accounts settings screen allows you to access the Backup screen, where you can configure backups for the user under the Windows Backup menu item. The System section allows you to configure a multitude of options for Windows itself. The Devices section lets you configure devices, and the Apps section allows you to uninstall and configure applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      92,
      91,
      94
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 77,
    "question": "Which of the following filesystems is a proprietary filesystem created by Apple that offers SSD support?",
    "choice_a": "HFS",
    "choice_b": "ext4",
    "choice_c": "APFS",
    "choice_d": "exFAT",
    "correct_answer": "C",
    "explanation": "The Apple File System (APFS) is a proprietary filesystem created for SSD support; it can be found on macOS Sierra 10.12.4, iOS 10.3, and tvOS 10.2 and later operating systems. Hierarchical File System (HFS) is a proprietary filesystem that was developed by Apple for the Mac OS back in 1985, ext4 (Fourth Extended File System) is used with Android and other Linux-based operating systems, and exFAT is a Microsoft proprietary filesystem created for large flash drives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      37,
      36,
      5
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 78,
    "question": "Which Control Panel applet would you use to join the operating system to a domain?",
    "choice_a": "System",
    "choice_b": "User Accounts",
    "choice_c": "Windows Tools",
    "choice_d": "Programs And Features",
    "correct_answer": "A",
    "explanation": "The System Control Panel applet is used to change the operating system computer name and change its membership from a workgroup to a domain, or domain to workgroup. The User Accounts applet is used to make changes to your user account or others on the operating system. The Windows Tools option in Control Panel opens up a menu of tools, none of which join the operating system to a domain. The Programs And Features applet is used to uninstall and repair installed programs, as well as manage Windows features.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      20,
      72,
      65,
      48
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 79,
    "question": "What can you do if a program is not responding to any commands and appears to be locked up?",
    "choice_a": "Open the System Control Panel applet and choose Performance to see what process is causing the problem.",
    "choice_b": "Add more memory.",
    "choice_c": "Press Ctrl+Alt+Delete to reboot the computer.",
    "choice_d": "Open Task Manager, select the appropriate task, and then click End Task.",
    "correct_answer": "D",
    "explanation": "When a program is not responding to any commands, the process must be terminated via the Task Manager. You can end the process by opening the Task Manager, right-clicking the application, and selecting End Task. Viewing the performance will not make the process respond. Adding more memory is not possible without shutting down the computer. Pressing Ctrl+Alt+Delete without any further action will not reboot the computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      31,
      3,
      1
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 80,
    "question": "Which command will start the Event Viewer snap-in?",
    "choice_a": "<code>eventviewer.exe</code>",
    "choice_b": "<code>eventvwr.msc</code>",
    "choice_c": "<code>lusrmgr.msc</code>",
    "choice_d": "<code>devmgmt.msc</code>",
    "correct_answer": "B",
    "explanation": "The command <code>eventvwr.msc</code> will start the Event Viewer snap-in. The command <code>eventviewer.exe</code> is not a valid command. The command <code>lusrmgr.msc</code> will start the Local Users and Group snap-in. The command <code>devmgmt.msc</code> will start the Device Manager snap-in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      62,
      63,
      35,
      61
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 81,
    "question": "You need to configure an iSCSI connection; where will you find iSCSI settings?",
    "choice_a": "Storage Spaces applet",
    "choice_b": "Disk Management snap-in",
    "choice_c": "Windows Tools",
    "choice_d": "Device Manager snap-in",
    "correct_answer": "C",
    "explanation": "The iSCSI Initiator utility can be found in Control Panel, in Windows Tools. The Storage Spaces applet is used to configure storage spaces of already connected storage. The Disk Management snap-in is used to configure disks already connected to the operating system. Device Manager is used to configure hardware attached to the computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      40,
      29,
      41,
      1
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 82,
    "question": "Which type of resources do you configure in Device Manager?",
    "choice_a": "Hardware",
    "choice_b": "Files and folders",
    "choice_c": "Applications",
    "choice_d": "Memory",
    "correct_answer": "A",
    "explanation": "Hardware resources are configured in the Device Manager console. Files and folders and applications are configured in the operating system GUI. Memory is configured in System Properties.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      28,
      29,
      1,
      27,
      31
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 83,
    "question": "What should be periodically done with mechanical hard drives to speed up performance when launching and saving files?",
    "choice_a": "Free up space",
    "choice_b": "Empty Recycle Bin",
    "choice_c": "Defragment",
    "choice_d": "Trim",
    "correct_answer": "C",
    "explanation": "The mechanical hard drive should be periodically defragmented to arrange concurrent blocks of storage of files so that the hard drive arm does not need to move much when reading and writing files. Solid-state drives (SSDs) do not suffer poor performance from fragmentation, because they have no moving parts. Freeing up space and emptying the Recycle Bin are good ideas but do not contribute to the hard drive\u2019s performance as much as defragmenting. Trim is a feature used with SSD drives, where the operating system notifies the SSD device that data blocks have been freed up.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      97,
      31,
      43,
      27
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 84,
    "question": "You have a number of files with a <code>.des</code> extension and you want to be able to search each file\u2019s metadata; which applet should this be configured in?",
    "choice_a": "Indexing Options applet",
    "choice_b": "File Explorer Options applet",
    "choice_c": "Windows Tools applet",
    "choice_d": "Ease of Access Center applet",
    "correct_answer": "A",
    "explanation": "The Indexing Options applet allows you to configure custom extensions so that metadata can be searched. The File Explorer Options applet is used to view and configure the File Explorer. The Windows Tools option in Control Panel is not really an applet; it opens up a menu of tools. The Ease of Access Center applet is used to configure options related to user disabilities to make the operating system easier to use.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      32,
      25,
      42,
      22,
      7
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 85,
    "question": "Which of the following partitions is specifically the partition from which the operating system boots?",
    "choice_a": "Primary partition",
    "choice_b": "Extended partition",
    "choice_c": "Dynamic partition",
    "choice_d": "Logical partition",
    "correct_answer": "A",
    "explanation": "The operating system must boot from an active primary partition if MBR style partitioning is used. Extended partitions are used to contain logical partitions. There is no such thing as a dynamic partition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      45,
      54,
      36,
      61
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 86,
    "question": "Which of the following Registry hives contains information about the computer\u2019s hardware?",
    "choice_a": "<code>HKEY_CURRENT_MACHINE</code>",
    "choice_b": "<code>HKEY_LOCAL_MACHINE</code>",
    "choice_c": "<code>HKEY_MACHINE</code>",
    "choice_d": "<code>HKEY_RESOURCES</code>",
    "correct_answer": "B",
    "explanation": "The <code>HKEY_LOCAL_MACHINE</code> Registry hive contains information about the computer\u2019s hardware. It is also known as <code>HKLM</code>. <code>HKEY_CURRENT_MACHINE</code> and <code>HKEY_MACHINE</code> are not valid Registry hives. <code>HKEY_RESOURCES</code> was used with Windows 9 <i>x</i> operating systems but is no longer used.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      1,
      44,
      62,
      5
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 87,
    "question": "Which of the following replaces the MBR in 64-bit versions of the Windows operating system?",
    "choice_a": "LILO",
    "choice_b": "NFS",
    "choice_c": "GPT",
    "choice_d": "GRUB",
    "correct_answer": "C",
    "explanation": "GUID [globally unique identifier] Partition Table (GPT) allocates a 64-bit logical block addressing entry to partition tables to accommodate larger drives. GPT has rapidly replaced the MBR-style partition tables. LILO and GRUB are boot managers for Linux. NFS is a network filesystem used with Linux/Unix operating systems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      45,
      39,
      2,
      54
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 88,
    "question": "Which of the following utilities will rearrange the files on your hard disk to occupy contiguous chunks of space?",
    "choice_a": "Disk Defragmenter",
    "choice_b": "Windows File Explorer",
    "choice_c": "Scandisk",
    "choice_d": "Windows Backup",
    "correct_answer": "A",
    "explanation": "Disk Defragmenter will rearrange blocks of files on a hard drive to create contiguous files and space. Windows File Explorer is used to navigate the filesystem. Scandisk is not a command. Windows Backup allows for file backups.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      42,
      97,
      36,
      28,
      40
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 89,
    "question": "Which power mode will write the contents of the RAM to the disk?",
    "choice_a": "Hibernate",
    "choice_b": "Standby",
    "choice_c": "Sleep",
    "choice_d": "Suspend",
    "correct_answer": "A",
    "explanation": "The hibernate power mode will write the contents of the RAM to the disk so that the computer can enter a low power state. The standby power mode will turn off the monitor and lower power consumption by the computer. The sleep and suspend power mode will lower power consumption, but it will not write the contents of the RAM to the disk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      30,
      8,
      42,
      97
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 90,
    "question": "Which partition style allows up to 2,000 volumes to be partitioned on a physical disk?",
    "choice_a": "GPT",
    "choice_b": "MBR",
    "choice_c": "Dynamic Disk",
    "choice_d": "Basic Disk",
    "correct_answer": "C",
    "explanation": "The Dynamic Disk partition style allows up to 2,000 volumes to be created on a physical disk. GUID [globally unique identifier] Partition Table (GPT) allow up to 128 volumes to be created on a physical disk. The Master Boot Record (MBR) and Basic Disk partitioning scheme are one and the same and allow up to 26 partitions to be created on a physical disk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      36,
      41,
      28,
      45
    ],
    "source": "330034_Vol2_Ch02"
  },
  {
    "id": 91,
    "question": "You are tasked with installing Windows 11 on a new computer. The computer has a 1 GHz processor, 2 GB of RAM, and 32 GB of storage. What should you do?",
    "choice_a": "Proceed with the installation.",
    "choice_b": "Upgrade the RAM to at least 4 GB.",
    "choice_c": "Increase the storage to 64 GB.",
    "choice_d": "Both B and C.",
    "correct_answer": "D",
    "explanation": "Windows 11 requires a minimum of 4 GB of RAM and 64 GB of storage. Therefore, to meet these requirements, you need to upgrade both the RAM and the storage. Simply proceeding with the installation would not work because the current specifications do not meet the minimum requirements. Upgrading only the RAM or only the storage would still leave one of the requirements unmet, making both upgrades necessary.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      44,
      8,
      19,
      55,
      45
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 92,
    "question": "What is the name of the pass that detects hardware and installs drivers?",
    "choice_a": "Generalize",
    "choice_b": "OOBE",
    "choice_c": "Specialization",
    "choice_d": "WinPE",
    "correct_answer": "A",
    "explanation": "The Generalize pass is where the operating system detects hardware and installs the appropriate drivers. The Out-Of-Box Experience (OOBE) is the pass that is responsible for configuring and creating the user environment during the setup process. The Specialization pass is where the operating system is configured during setup. The WinPE pass starts the procedure of installing the operating system.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      47,
      48,
      1,
      9,
      5
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 93,
    "question": "Which partition contains the recovery utility in the event of a problem?",
    "choice_a": "BCD",
    "choice_b": "System",
    "choice_c": "ESP",
    "choice_d": "WinRE",
    "correct_answer": "D",
    "explanation": "The WinRE partition is where the Windows Recovery Environment is located. The BCD is a term used with the boot configuration data to direct the operating system how to boot. The system partition contains the kernel of the operating system. The EFI system partition (ESP) contains the boot configuration data (BCD) that is used to boot the rest of the operating system on a UEFI system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      45,
      46,
      40,
      54
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 94,
    "question": "Which tool is used to create an operating system image for deployment?",
    "choice_a": "WDS",
    "choice_b": "MAP toolkit",
    "choice_c": "USMT",
    "choice_d": "<code>sysprep</code>",
    "correct_answer": "A",
    "explanation": "The Windows Deployment Services (WDS) is a server role that is used to create a Windows image for mass deployment. The Microsoft Assessment and Planning (MAP) toolkit is used to create reports on system hardware for image deployment. The User State Migration Toolkit (USMT) is used in a corporate environment to migrate user data. The <code>sysprep</code> utility is used to prepare an operating system for imaging.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      13,
      52,
      28,
      36,
      19
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 95,
    "question": "Which command will allow copying of all data to include NTFS permissions?",
    "choice_a": "<code>xcopy</code>",
    "choice_b": "<code>copy</code>",
    "choice_c": "<code>chkdsk</code>",
    "choice_d": "<code>robocopy</code>",
    "correct_answer": "D",
    "explanation": "The <code>robocopy</code> command will copy all data and will include NTFS permission to remain intact. The <code>xcopy</code> and <code>copy</code> commands will copy files from a source folder to a destination folder but will not copy NTFS permissions. The <code>chkdsk</code> command is used to check the integrity of the NTFS filesystem.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      61,
      39,
      56,
      36
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 96,
    "question": "Which Windows Update branch for Windows will install features as they are released to the general public?",
    "choice_a": "Semi-Annual Channel",
    "choice_b": "General Availability",
    "choice_c": "Long-Term Servicing Channel",
    "choice_d": "Insider Program",
    "correct_answer": "B",
    "explanation": "The General Availability branch will install updates as they are released to the general public. The Semi-Annual Channel is no longer a channel supported by Windows 11. The Long-Term Servicing Channel never installs new features during the life of the version of Windows. The Insider Program allows for the installation of brand-new features before they are publicly released.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      93,
      52,
      46,
      54
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 97,
    "question": "Which edition of Windows 11 will not allow for Insider Program branch releases?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Education",
    "choice_d": "Enterprise",
    "correct_answer": "A",
    "explanation": "Windows 11 Home only allows for the General Availability branch releases. Windows 11 Pro allows for the use of the Insider Program branch releases. Windows 11 Education allows for the use of the Insider Program branch releases. Windows 11 Enterprise allows for the use of Insider Program branch releases.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      53,
      19,
      26,
      5
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 98,
    "question": "You are configuring a new Windows 11 installation and need to ensure it supports Secure Boot. What type of firmware must the computer have?",
    "choice_a": "BIOS",
    "choice_b": "UEFI",
    "choice_c": "Legacy BIOS",
    "choice_d": "EFI",
    "correct_answer": "B",
    "explanation": "Unified Extensible Firmware Interface (UEFI) firmware is required for Secure Boot, which enhances security by ensuring that only trusted software is loaded during the boot process. Basic Input/Output System (BIOS) and Legacy BIOS do not support Secure Boot. Extensible Firmware Interface (EFI) is an older term; UEFI is the correct modern term.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      45,
      44,
      19,
      46,
      55
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 99,
    "question": "Which command is used to measure packet loss as a packet travels to a destination address?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>nslookup</code>",
    "choice_c": "<code>pathping</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "C",
    "explanation": "The <code>pathping</code> command will measure the packet loss at each router as the packet travels to the destination address; it combines the <code>ping</code> and <code>tracert</code> commands. The <code>ping</code> command will return a single destination\u2019s response time. The <code>nslookup</code> command is used to resolve DNS addresses. The <code>tracert</code> command allows you to see how a packet travels to its destination.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      59,
      62,
      63,
      98
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 100,
    "question": "Which tool allows you to report a remote computer\u2019s inventory of hardware?",
    "choice_a": "<code>regedit.exe</code>",
    "choice_b": "<code>msinfo32.exe</code>",
    "choice_c": "<code>msconfig.exe</code>",
    "choice_d": "<code>dxdiag.exe</code>",
    "correct_answer": "B",
    "explanation": "The <code>msinfo32.exe</code> tool allows for the remote reporting of a computer\u2019s hardware. <code>regedit.exe</code> is used to edit the Registry. <code>msconfig.exe</code> is used to change the startup of services and change the boot process. <code>dxdiag.exe</code> is used to diagnose DirectX problems.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      35,
      1,
      43,
      40
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 101,
    "question": "Which command will allow you to check a volume for corruption?",
    "choice_a": "<code>diskpart</code>",
    "choice_b": "<code>format</code>",
    "choice_c": "<code>chkdsk</code>",
    "choice_d": "<code>sfc</code>",
    "correct_answer": "C",
    "explanation": "The <code>chkdsk</code> command is used to check a volume for corruption, as well as attempt to repair the corruption. The <code>diskpart</code> command allows you to create, modify, and view volumes on a disk. The <code>format</code> command allows you to format a filesystem on a volume. The <code>sfc</code> command is used to fix corrupted files but not volume corruption.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      61,
      36,
      40,
      42,
      97
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 102,
    "question": "Which restriction will be imposed on Windows users until they activate the operating system?",
    "choice_a": "They won\u2019t be able to launch applications.",
    "choice_b": "They won\u2019t be able to run Windows Updates.",
    "choice_c": "They won\u2019t be able to change the wallpaper.",
    "choice_d": "They won\u2019t be able to browse the Internet.",
    "correct_answer": "C",
    "explanation": "Users will not be able to change the wallpaper or personalize the operating system until it is active. Applications will still launch fine. Windows Updates will continue to function to keep Windows up-to-date. Browsing the Internet will not be affected.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      18,
      5,
      23
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 103,
    "question": "What is the name of the pass that configures and creates the user environment during the setup process?",
    "choice_a": "Generalization",
    "choice_b": "OOBE",
    "choice_c": "Specialization",
    "choice_d": "WinPE",
    "correct_answer": "B",
    "explanation": "The Out-Of-Box Experience (OOBE) is the pass that is responsible for configuring and creating the user environment during the setup process. The Generalization pass is where the operating system detects hardware. The Specialization pass is where the operating system is configured during setup. The WinPE pass starts the process of installing the operating system.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      48,
      47,
      54,
      35,
      36
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 104,
    "question": "When installing Windows, you can control telemetry data. In which step during setup is this configured?",
    "choice_a": "Privacy settings",
    "choice_b": "Locale options",
    "choice_c": "Partitioning options",
    "choice_d": "Account creation",
    "correct_answer": "A",
    "explanation": "When installing Windows, you can control telemetry data in the Privacy Settings dialog box. The Locale options allow you to control how the language and local notations of money, weight, date, and several other measurements for a particular region of the world. Disk partitioning is configured during the initial installation in order to direct Windows where to install. Account creation is performed to create the first user on the operating system.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      48,
      46,
      34,
      36,
      40
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 105,
    "question": "You are troubleshooting a network issue and need to verify the path packets take to a destination. Which command should you use?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>nslookup</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "B",
    "explanation": "The <code>tracert</code> command shows the path packets take to a destination, helping to identify where delays or failures occur. The <code>ping</code> command checks connectivity but not the path. <code>nslookup</code> resolves DNS names but does not trace the path. <code>netstat</code> shows network connections and ports but not the path.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      106,
      59,
      62,
      33
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 106,
    "question": "You want to upgrade from 32-bit Windows 10 Professional to a 64-bit version of Windows 11. What are your options?",
    "choice_a": "Upgrade directly to Windows 11 Pro 64-bit.",
    "choice_b": "Upgrade first to Windows 11 Pro 32-bit, and then upgrade to 64-bit.",
    "choice_c": "Upgrade to Windows 10 64-bit, and then upgrade to Windows 11 64-bit.",
    "choice_d": "You must perform a clean installation of Windows 11 Pro 64-bit.",
    "correct_answer": "D",
    "explanation": "There is no way to directly convert a 32-bit installation of Windows to 64-bit Windows without performing a clean installation. Upgrading directly to Windows 11 Pro 64-bit is not possible. Upgrading to Windows 11 Pro 32-bit is possible, but you cannot upgrade to a 64-bit edition. Upgrading to Windows 11 64-bit is not possible.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      18,
      2,
      45,
      46
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 107,
    "question": "Where is the boot configuration data stored on a Windows installation using EFI?",
    "choice_a": "EFI System Partition",
    "choice_b": "WinRE partition",
    "choice_c": "Secure Boot partition",
    "choice_d": "<code>C:\\WINDOWS</code>",
    "correct_answer": "A",
    "explanation": "The BCD is stored in the EFI System Partition on an EFI installation of Windows. The WinRE partition is used for the Windows Recovery Environment. Secure Boot is a feature of an EFI installation and does not contain its own partition. The <code>C:\\WINDOWS</code> folder is where the installation of Windows exists.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      40,
      19,
      54
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 108,
    "question": "Which command is used to identify ports in use by applications and the operating system?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>pathping</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "A",
    "explanation": "The <code>netstat</code> command can be used to view ports in use by the operating system and network applications communicating with the network. The <code>ipconfig</code> command allows you to see the current IP address and DNS information for the operating system. <code>pathping</code> allows you to view packet loss along the path to a destination IP address. The <code>nslookup</code> command is used to resolve DNS records.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      59,
      106,
      62,
      63,
      1
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 109,
    "question": "Which type of connection is configured in the Cellular screen in the Settings app?",
    "choice_a": "Wired",
    "choice_b": "Wireless",
    "choice_c": "WWAN",
    "choice_d": "VPN",
    "correct_answer": "C",
    "explanation": "The Wireless Wide Area Network (WWAN) connection is a cellular connection and is configured on the Cellular screen in the Settings app. A wired connection is configured on the Ethernet screen in the Settings app. A wireless connection is configured on the Wi-Fi screen in the Settings app. A virtual private network (VPN) connection is configured on the VPN screen in the Settings app.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      80,
      34,
      67,
      58
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 110,
    "question": "What is the maximum number of concurrent connections that can be made to a Windows workstation?",
    "choice_a": "30 connections",
    "choice_b": "40 connections",
    "choice_c": "20 connections",
    "choice_d": "25 connections",
    "correct_answer": "C",
    "explanation": "The maximum number of connections that can simultaneously be made to a Windows workstation is 20. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      59,
      66,
      18,
      4
    ],
    "source": "330034_Vol2_Ch03"
  },
  {
    "id": 111,
    "question": "Within a Linux terminal, you want to see all the files on your system in long format (using the <code>\u2013l</code> option), including any hidden files (which requires the <code>\u2013a</code> option). Which command should you use?",
    "choice_a": "<code>ls \u2013a | ls -l</code>",
    "choice_b": "<code>ls \u2013s; ls -l</code>",
    "choice_c": "<code>ls -la</code>",
    "choice_d": "<code>ls \u2013a\\ls -l</code>",
    "correct_answer": "C",
    "explanation": "The command <code>ls -la</code> will list all the files in a long format. The command <code>ls -a | ls-l</code> will not work. <code>ls -s; ls -a</code> will show two listings: one with the size and the other with all the files. The <code>ls -a\\ls -l</code> command will show two listings\u2014one with all the files and the other in a long format\u2014but it will not show all the files in a long format.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      107,
      98,
      105,
      104,
      99
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 112,
    "question": "Which of the following allows you to see all running programs in macOS?",
    "choice_a": "Keychain",
    "choice_b": "Mission Control",
    "choice_c": "Finder",
    "choice_d": "Force Quit",
    "correct_answer": "B",
    "explanation": "Mission Control is a quick way on macOS to view what is currently running. Keychain or keychain access is a tool that saves credentials so that the user does not need to be prompted. The Finder is the macOS equivalent to the Windows File Explorer. Force Quit is a function of the macOS for killing a process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      83,
      85,
      86,
      87
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 113,
    "question": "As part of your training program, you\u2019re trying to convince users to make backups on a regular basis. Which Apple app can be used to make backups of various types on a regular basis?",
    "choice_a": "Time Machine",
    "choice_b": "Finder",
    "choice_c": "VSS",
    "choice_d": "Keychain",
    "correct_answer": "A",
    "explanation": "Time Machine is the Apple application that can be used to create backups on a regular basis. The Finder is the macOS equivalent to Windows File Explorer. VSS is a Windows technology that is used to create snapshots of a volume. Keychain is a tool that saves credentials so that the user does not need to be prompted.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      92,
      86,
      85,
      94
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 114,
    "question": "Which of the following Linux commands/utilities can be used to edit a file?",
    "choice_a": "<code>ps</code>",
    "choice_b": "<code>nano</code>",
    "choice_c": "<code>rm</code>",
    "choice_d": "<code>ls</code>",
    "correct_answer": "B",
    "explanation": "The <code>nano</code> command is used to edit files. The <code>ps</code> command lists processes running. The <code>rm</code> command removes files or directories. The <code>ls</code> command lists files and folders in the filesystem.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      105,
      98,
      104,
      103,
      107
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 115,
    "question": "Which of the following Linux commands/utilities can be used to edit an Ethernet connection\u2019s configuration settings?",
    "choice_a": "<code>dd</code>",
    "choice_b": "<code>apt </code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>pwd</code>",
    "correct_answer": "C",
    "explanation": "The <code>ip</code> command can be used to edit an Ethernet connection\u2019s configuration settings. The <code>dd</code> command is used to duplicate disks. The <code>apt</code> command is used with the APT package management system for downloading packages. The <code>pwd</code> command will show the current working directory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      98,
      104,
      105,
      99
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 116,
    "question": "Which of the following is a macOS feature for password management in the latest version macOS 15.2 (Sequoia)?",
    "choice_a": "Passwords",
    "choice_b": "Keychain",
    "choice_c": "Dock",
    "choice_d": "Spotlight",
    "correct_answer": "A",
    "explanation": "The Passwords feature has replaced the Keychain tool in the latest version of macOS 15.2 (Sequoia). The Passwords feature saves credentials so that the user does not need to be prompted. Spotlight is a utility in macOS that allows a search of the operating system and Internet for search terms. The Dock is the macOS application menu that is located on the bottom of the screen.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      85,
      88,
      89,
      1
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 117,
    "question": "The interpreter in Linux between the operating system and the user is known as the _______.",
    "choice_a": "Shell",
    "choice_b": "Translator",
    "choice_c": "Login",
    "choice_d": "GUI",
    "correct_answer": "A",
    "explanation": "The shell is the interpreter in Linux between the operating system and the user. The translator is a wrong answer. Login is something you perform to access the shell. The graphical user interface (GUI) does not interpret commands and therefore is not considered an interpreter.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      7,
      98,
      82,
      1,
      63
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 118,
    "question": "What type of backup is kept on-site at the computer center for immediate recovery purposes?",
    "choice_a": "On-path attack",
    "choice_b": "Cloud copies",
    "choice_c": "Journal copies",
    "choice_d": "Working copies",
    "correct_answer": "D",
    "explanation": "Working copies are backups that are kept on-site at the computer center for immediate recovery purposes. An on-path attack is an attack where an eavesdropper listens between two people or devices. Cloud copies are backups that are sent to cloud storage and cannot be immediately recovered. Journal copies is a wrong answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      92,
      79,
      93,
      55
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 119,
    "question": "Which of the following utilities can be used in Linux to download patches for installation on a workstation?",
    "choice_a": "<code>update</code>",
    "choice_b": "Shell/terminal",
    "choice_c": "<code>apt</code>",
    "choice_d": "<code>patch</code>",
    "correct_answer": "C",
    "explanation": "The <code>apt</code> utility can be used to download and apply patches to a Linux installation. The <code>update</code> command is not a utility. Shell/terminal is an interface for interacting with the operating system with the command line. The <code>patch</code> command is not a utility.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      93,
      98,
      7,
      99
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 120,
    "question": "Which of the following commands can be used to change the owner of a file to a new owner in Linux?",
    "choice_a": "<code>cd</code>",
    "choice_b": "<code>chmod</code>",
    "choice_c": "<code>chown</code>",
    "choice_d": "<code>pwd</code>",
    "correct_answer": "C",
    "explanation": "The <code>chown</code> command is used to change ownership of a file. The <code>cd</code> command changes the working directory. The <code>chmod</code> command changes permissions on files. The <code>pwd</code> command displays the current working directory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      98,
      99,
      107
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 121,
    "question": "Which Linux utility can be used to check and repair disks?",
    "choice_a": "<code>fsck</code>",
    "choice_b": "<code>chkdsk</code>",
    "choice_c": "<code>du</code>",
    "choice_d": "<code>dumgr</code>",
    "correct_answer": "A",
    "explanation": "The <code>fsck</code> Linux utility is used to check and repair disks. The <code>chkdsk</code> utility is a Windows utility used to check and repair disks. The <code>du</code> utility is used to show the current disk usage. <code>dumgr</code> is not a utility and is a wrong answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      77,
      98,
      37,
      36
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 122,
    "question": "Your iPad has an application that will not stop running. What feature/tool can you use to stop it?",
    "choice_a": "<code>kill</code>",
    "choice_b": "Force Quit",
    "choice_c": "Task Manager",
    "choice_d": "Close Quit",
    "correct_answer": "B",
    "explanation": "By pressing the Home button twice on an iPad, you can Force Quit an application that will not stop running. The <code>kill</code> utility can be used only at the command line of Linux/macOS. The Task Manager is a Windows utility. Close Quit is not a feature and therefore a wrong answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      27,
      103,
      98,
      9
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 123,
    "question": "Which of the following is the most common shell used with Linux?",
    "choice_a": "Tcl/Tk",
    "choice_b": "Terminal",
    "choice_c": "Bash",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "Bash is the most common command-line shell used with Linux. Tcl/Tk is a shell used with Linux, but it is very uncommon. Terminal is a utility used to access the command-line shell. SSH, or Secure Shell, is a secure protocol used to access the shell over a network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      7,
      5,
      63,
      82
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 124,
    "question": "What is the name of the area at the bottom of a macOS screen where, by default, a bar of crucial icons appears?",
    "choice_a": "Footer",
    "choice_b": "Mission Control",
    "choice_c": "Taskbar",
    "choice_d": "Dock",
    "correct_answer": "D",
    "explanation": "The Dock is the area at the bottom of the macOS screen that is used to launch applications. The footer is not a valid answer. Mission Control is a macOS feature that allows you to see all the applications running. The Taskbar is a Windows Desktop element that is used to track running applications and quickly launch them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      76,
      23,
      84,
      5
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 125,
    "question": "Which key combination can you use to bring up Spotlight from within an app?",
    "choice_a": "Control+Shift",
    "choice_b": "Option+Tab",
    "choice_c": "Command+spacebar",
    "choice_d": "Alt+Home",
    "correct_answer": "C",
    "explanation": "The Command+spacebar key combination will bring up the Spotlight utility. Control+Shift, Option+Tab, and Alt+Home are wrong answers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      83,
      73,
      89,
      76
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 126,
    "question": "Which Linux command can be used to let you run a single command as another user?",
    "choice_a": "<code>sudo</code>",
    "choice_b": "<code>su</code>",
    "choice_c": "<code>passwd</code>",
    "choice_d": "<code>ifconfig</code>",
    "correct_answer": "A",
    "explanation": "The <code>sudo</code> command can be used to run a single command as another user. The <code>su</code> command allows you to change user logins at the command line. The <code>passwd</code> command changes the user\u2019s password. The <code>ifconfig</code> command allows you to view and modify the wired network interface.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      98,
      100,
      104,
      106
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 127,
    "question": "Which of the following Linux commands will show you a list of running processes?",
    "choice_a": "<code>ls</code>",
    "choice_b": "<code>cat</code>",
    "choice_c": "<code>ps</code>",
    "choice_d": "<code>su</code>",
    "correct_answer": "C",
    "explanation": "The <code>ps</code> command will display a snapshot of the current running processes on a Linux operating system. The <code>ls</code> command will display a listing of files from the working directory. The <code>cat</code> command will display the contents of a file. The <code>su</code> command allows you to change user logins at the command line.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      105,
      98,
      104,
      99
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 128,
    "question": "You are currently in a Linux terminal session and in the <code>/home/testuser/documents/mail</code> directory. Which command will take you to <code>/home/testuser/documents</code>?",
    "choice_a": "<code>cd .</code>",
    "choice_b": "<code>cd ..</code>",
    "choice_c": "<code>cd \u2026</code>",
    "choice_d": "<code>cd</code> \u223c",
    "correct_answer": "B",
    "explanation": "The command <code>cd ..</code> will take you one level back from the current working directory. The command <code>cd .</code> will do nothing, because the period signifies the current working directory. The command <code>cd . . .</code> is not a valid command. The command <code>cd ~</code> will change directories to the home directory of the user.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      104,
      98,
      99,
      105,
      107
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 129,
    "question": "If the permissions for a file are <code>rwxrw-r\u2013\u2013</code>, what permissions apply for a user who is a member of the group to which the owner belongs?",
    "choice_a": "Read, write, and execute",
    "choice_b": "Read and write",
    "choice_c": "Read only",
    "choice_d": "No access",
    "correct_answer": "B",
    "explanation": "The effective permissions are read and write. From left to right, the permissions are <code>rwx</code> for the user, <code>rw-</code> for the group, and <code>r--</code> for everyone else. Since the user is only a member of the group applied to the file, they will have read and write permissions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      100,
      99,
      98,
      36
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 130,
    "question": "What does the <code>\u2013p</code> option with <code>mkdir</code> do?",
    "choice_a": "Prompts the user before creating files",
    "choice_b": "Prompts the user before creating subfolders",
    "choice_c": "Creates subfolders as well as folders",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "The <code>-p</code> option on the <code>mkdir</code> command allows subfolders to be created as well as the target folder. All other answers are incorrect.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      98,
      104,
      101,
      99,
      7
    ],
    "source": "330034_Vol2_Ch04"
  },
  {
    "id": 131,
    "question": "As part of your training program, you're trying to educate users on the importance of security. You explain to them that not every attack depends on implementing advanced technological methods. Some attacks, you explain, take advantage of human shortcomings to gain access that should otherwise be denied. Which term do you use to describe attacks of this type?",
    "choice_a": "Social engineering",
    "choice_b": "IDS",
    "choice_c": "Perimeter security",
    "choice_d": "Biometrics",
    "correct_answer": "A",
    "explanation": "Social engineering uses the inherent trust in the human species, as opposed to technology, to gain access to your environment. IDSs are network-based systems that detect intrusions. Perimeter security describes physical security. Biometrics describes an authentication method based on human physical traits.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      139,
      143,
      211,
      210
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 132,
    "question": "You\u2019re in the process of securing the IT infrastructure by adding fingerprint scanners to your existing authentication methods. This type of security is an example of which of the following?",
    "choice_a": "Access control",
    "choice_b": "Physical barriers",
    "choice_c": "Biometrics",
    "choice_d": "Softening",
    "correct_answer": "C",
    "explanation": "A fingerprint scanner, or any device that identifies a person by a physical trait, is considered a biometric security control. Access control is the system that controls access for users. Physical barriers are structures that limit physical access. Softening refers to weakening of security.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      115,
      120,
      108,
      113,
      191
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 133,
    "question": "Which type of attack denies authorized users access to network resources?",
    "choice_a": "DoS",
    "choice_b": "Worm",
    "choice_c": "Trojan",
    "choice_d": "Social engineering",
    "correct_answer": "A",
    "explanation": "Although the end result of any of these attacks may be denying authorized users access to network resources, a denial-of-service (DoS) attack is specifically intended to prevent access to network resources by overwhelming or flooding a service or network. Worms reproduce and move throughout the network to infect other systems. Trojans are programs that enter a system or network under the guise of another program. Social engineering is a process in which an attacker attempts to acquire information about your network and system by social means, such as talking to people in the organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      141,
      128,
      133,
      142
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 134,
    "question": "As the security administrator for your organization, you must be aware of all types of attacks that can occur and plan for them. Which type of attack uses more than one computer to attack the victim?",
    "choice_a": "DoS",
    "choice_b": "DDoS",
    "choice_c": "Worm",
    "choice_d": "Rootkit",
    "correct_answer": "B",
    "explanation": "A distributed denial-of-service (DDoS) attack uses multiple computer systems to attack a server or host in the network. A denial-of-service (DoS) is a one-on-one attack to disrupt service. Worms reproduce and move throughout the network to infect other systems and therefore do not attack one victim. Rootkits are software programs that have the ability to hide themselves from the operating system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      128,
      127,
      142,
      152
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 135,
    "question": "A vice president of your company calls a meeting with the IT department after a recent trip to competitors\u2019 sites. She reports that many of the companies she visited granted access to the operating system or applications after an employee presented a number that rotated. Of the following, which technology relies on a rotating number for users for authentication?",
    "choice_a": "Smartcard",
    "choice_b": "Biometrics",
    "choice_c": "Geofencing",
    "choice_d": "Token",
    "correct_answer": "D",
    "explanation": "Tokens are rotating numerical keys that you must physically have with you to gain access to the operating system or applications. Biometrics relies on a physical characteristic of the user to verify identity. Biometric devices typically use either a hand pattern or a retinal scan to accomplish this. Smartcards contain a private certificate key and are protected with a password. Geofencing uses your GPS coordinates to ensure that the authentication happens when you are in a defined geographic area.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      113,
      115,
      170,
      168
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 136,
    "question": "You've discovered that credentials to a specific application have been stolen. The application is accessed from only one computer on the network. Which type of attack is this most likely to be?",
    "choice_a": "On-path attack",
    "choice_b": "Zero-day",
    "choice_c": "Denial-of-service (DoS)",
    "choice_d": "Smurf",
    "correct_answer": "A",
    "explanation": "An on-path attack intercepts data and then sends the information to the server as if nothing were wrong, while collecting the information. Zero-day attacks are attacks in which a developer has not properly patched a hole yet and is unaware of the hole. A denial-of-service (DoS) attack is used to disrupt legitimate requests from being answered. A Smurf attack is a type of distributed denial-of-service (DDoS).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      148,
      145,
      147,
      139
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 137,
    "question": "A junior administrator comes to you in a panic. After looking at the log files, he has become convinced that an attacker is attempting to use a legitimate IP address to disrupt access elsewhere on the network. Which type of attack is this?",
    "choice_a": "Spoofing",
    "choice_b": "Social engineering",
    "choice_c": "Worm",
    "choice_d": "Password",
    "correct_answer": "A",
    "explanation": "A spoofing attack is an attempt by someone or something to masquerade as someone else (IP address) and is often used to disrupt access. Social engineering is a process in which an attacker attempts to acquire information about your network and system by social means, such as talking to people in the organization. Worms reproduce and move throughout the network to infect other systems. Password attacks are used in an attempt to guess passwords.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      147,
      141,
      144,
      148,
      149
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 138,
    "question": "Which of the following is different from a virus in that it can reproduce itself, is self-contained, and doesn\u2019t need a host application to be transported?",
    "choice_a": "Worm",
    "choice_b": "Smurf",
    "choice_c": "Phish",
    "choice_d": "Trojan",
    "correct_answer": "A",
    "explanation": "A worm is different from a virus in that it can reproduce itself, is self-contained, and doesn\u2019t need a host application to be transported. A smurf attack is a type of distributed denial-of-service (DDoS). A phishing attack is an attempt to gain a user\u2019s credentials to a network resource. Trojan horses are programs that enter a system or network under the guise of another program.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      133,
      130,
      127,
      131,
      128
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 139,
    "question": "A reflective attack attempts to use a broadcast ping on a network. The return address of the ping may be that of a valid system in your network. Which protocol does the reflective attack use to conduct the attack?",
    "choice_a": "TCP",
    "choice_b": "IP",
    "choice_c": "UDP",
    "choice_d": "ICMP",
    "correct_answer": "D",
    "explanation": "The reflective attack is using a broadcast ping (ICMP) on a network. The return address of the ping may be that of a valid system in your network. The Transmission Control Protocol (TCP) is not typically used with a reflective attack. The Internet Protocol (IP) is a suite of protocols and solely used with a reflective attack. The User Datagram Protocol (UDP) is not described in this reflective attack.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      144,
      147,
      209,
      146,
      128
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 140,
    "question": "Which type of attack involves passing a database query with a web request?",
    "choice_a": "Insider threat",
    "choice_b": "Evil twin",
    "choice_c": "SQL injection",
    "choice_d": "Tailgating",
    "correct_answer": "C",
    "explanation": "A SQL injection attack is a method of passing a SQL query with a web request by using an escape code sequence. An insider threat is a threat from within your organization, such as a disgruntled employee. An evil twin attack involves a rogue access point with the same SSID as your organization. Tailgating is the act of walking behind someone who has swiped to get into an area so the attacker can gain entry.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      149,
      151,
      142,
      152
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 141,
    "question": "Which is an example of an authentication method in which you have something?",
    "choice_a": "Password",
    "choice_b": "Key fob",
    "choice_c": "Fingerprint",
    "choice_d": "Place",
    "correct_answer": "B",
    "explanation": "A key fob is an example of authentication for something you have. A password is something you know. A fingerprint is something you are. A place is a geographical place in which you are.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      113,
      121,
      169,
      115
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 142,
    "question": "You need to protect your users from potentially being phished via email. Which of the following should you use to protect them?",
    "choice_a": "Antivirus software",
    "choice_b": "End-user education",
    "choice_c": "SecureDNS",
    "choice_d": "The principle of least privilege",
    "correct_answer": "B",
    "explanation": "End-user education is the best way to protect your users from the threat of phishing via email. Antivirus software is used to prevent viruses, not phishing attempts. SecureDNS can be useful in protecting your users, but not from phishing emails. The principle of least privilege assigns only the permissions that users need to do their work, and no more.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      137,
      142,
      135,
      210
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 143,
    "question": "Your help desk has informed you that they received an urgent call from the vice president last night requesting his login ID and password. When you talk with the VP today, he says he never made that call. What type of attack is this?",
    "choice_a": "Spoofing",
    "choice_b": "Replay",
    "choice_c": "Social engineering",
    "choice_d": "Trojan horse",
    "correct_answer": "C",
    "explanation": "Spear phishing is a type of social engineering, where someone is trying to con your organization into revealing account and password information by pretending to be a high-level person. A spoofing attack is an attempt by someone or something to masquerade as someone else, with the intent of disrupting access. A replay attack is a form of an on-path attack, where packets are replayed at a critical time. Trojan horses are programs that enter a system or network under the guise of another program.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      141,
      147,
      128,
      139
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 144,
    "question": "Internal users suspect there have been repeated attempts to infect their systems, as reported to them by pop-up messages from their antivirus software. According to the messages, the virus seems to be the same in every case. What is the most likely culprit?",
    "choice_a": "A server is acting as a carrier for a virus.",
    "choice_b": "A password attack is being carried out.",
    "choice_c": "Your antivirus software has malfunctioned.",
    "choice_d": "A DoS attack is under way.",
    "correct_answer": "A",
    "explanation": "Some viruses won\u2019t damage a system in an attempt to spread into all the other systems in a network. These viruses use that system as the carrier of the virus. A password attack would not prompt your antivirus software to notify you. Your antivirus software could be malfunctioning, but it would not suggest the same virus is infecting you over and over again. A denial-of-service (DoS) attack would not prompt your antivirus to notify you.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      130,
      133,
      211,
      135,
      209
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 145,
    "question": "You're working late one night and notice that the hard drive on your new computer is very active even though you aren't doing anything on the computer and it isn\u2019t connected to the Internet. What is the most likely suspect?",
    "choice_a": "A spear phishing attack is being performed.",
    "choice_b": "A virus is spreading in your system.",
    "choice_c": "Your system is under a DoS attack.",
    "choice_d": "TCP/IP hijacking is being attempted.",
    "correct_answer": "B",
    "explanation": "A symptom of many viruses is unusual activity on the system disk. The virus spreading to other files on your system causes this. A disk failure will not create high disk activity. A spear phishing attack is a social engineering attack and will not create high disk activity; neither denial-of-service attacks nor TCP/IP hijacking attacks will create high disk activity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      134,
      127,
      128,
      141
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 146,
    "question": "You\u2019re the administrator for a large bottling company. At the end of each month, you routinely view all logs and look for discrepancies. This month, your email system error log reports a large number of unsuccessful attempts to log in. It\u2019s apparent that the email server is being targeted. Which type of attack is most likely occurring?",
    "choice_a": "Brute-force",
    "choice_b": "Backdoor",
    "choice_c": "Worm",
    "choice_d": "TCP/IP hijacking",
    "correct_answer": "A",
    "explanation": "A brute-force attack is a type of password attack in which a password is guessed over and over, until the right password is guessed. A backdoor attack is an embedded account that allows unauthorized access through an unpatched coding hole. A worm is different from a virus in that it can reproduce itself, is self-contained, and doesn\u2019t need a host application to be transported. A TCP/IP hijacking attempt is an attack that attempts to redirect the TCP/IP conversation to the threat agent.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      148,
      157,
      133,
      128,
      209
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 147,
    "question": "Your boss needs you to present to upper management the need for a firewall for the network. What is the thesis of your presentation?",
    "choice_a": "The isolation of one network from another",
    "choice_b": "The scanning of all packets for viruses",
    "choice_c": "Preventing password attacks",
    "choice_d": "The hardening of physical security",
    "correct_answer": "A",
    "explanation": "The thesis of your presentation should outline the need of a firewall to isolate the external network from the internal network. Firewalls will not scan packets for viruses. Firewalls will not prevent password attacks or harden physical security.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      188,
      173,
      134,
      139,
      154
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 148,
    "question": "Which Active Directory component maps printers and drives during login?",
    "choice_a": "Home folders",
    "choice_b": "Organizational unit",
    "choice_c": "Login script",
    "choice_d": "Microsoft Management Console (MMC)",
    "correct_answer": "C",
    "explanation": "A login script is used by Active Directory during login to map drives and printers. A home folder is a private network location in which the user can store their personal files. Organizational units (OUs) are used to group computers and users so that Group Policy can be applied. The MMC is used to manage various aspects of Active Directory and the local operating system.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      126,
      125,
      170,
      160,
      200
    ],
    "source": "330034_Vol2_Ch05"
  },
  {
    "id": 149,
    "question": "Which policy would you create to define the minimum specification if an employee wanted to use their own device for email?",
    "choice_a": "MDM",
    "choice_b": "AUP",
    "choice_c": "BYOD",
    "choice_d": "NDA",
    "correct_answer": "C",
    "explanation": "A bring your own device (BYOD) policy defines the minimum specifications for an employee\u2019s device used for work-related access. The mobile device management (MDM) software would usually police these specifications, but it would not define them. The acceptable use policy (AUP) is a code of conduct when dealing with organization resources. The nondisclosure agreement (NDA) is an agreement used when dealing with intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      155,
      124,
      139,
      232
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 150,
    "question": "Which term refers to copying data between a mobile device and a computer system in order to mirror such things as contacts, programs, pictures, and music?",
    "choice_a": "Calibration",
    "choice_b": "Remote wipe",
    "choice_c": "Pairing",
    "choice_d": "Synchronization",
    "correct_answer": "D",
    "explanation": "Synchronizing a mobile device with a computer system allows you to mirror personal data between the devices, regardless of which one contains the most current data. Calibration refers to matching the device\u2019s and the user\u2019s perceptions of where the user is touching the screen. Remote wipes allow you to remove personal data from a lost or stolen device. Pairing is what must be done in Bluetooth for two Bluetooth devices to connect and communicate.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      197,
      198,
      196,
      195,
      124
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 151,
    "question": "You want to follow the rules of good security administration as set by CompTIA and vendors. To do so, which account should be disabled on most Windows operating systems for security reasons?",
    "choice_a": "Guest",
    "choice_b": "Print Operators",
    "choice_c": "Power Users",
    "choice_d": "Userone",
    "correct_answer": "A",
    "explanation": "The Guest account should be disabled on the operating system, unless there is good reason to leave the account enabled. Print Operators is a group found on Windows servers. Power Users is a group found on both Windows workstations and servers. Userone is obviously a user account. Unless the user has left the organization, there should be no reason to disable the account.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      167,
      160,
      117,
      126,
      158
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 152,
    "question": "What kind of mobile app is being used when the owner\u2019s phone displays a message on the screen and emits an extremely loud tone?",
    "choice_a": "Failed login restriction",
    "choice_b": "Antivirus",
    "choice_c": "Locator",
    "choice_d": "Remote wipe",
    "correct_answer": "C",
    "explanation": "Locator apps can find the phone and then display a message that can be read even while the phone is locked. Locator apps also often give the user the option to make the phone blare a noise to aid in finding the device. Failed login restrictions will wipe a device if a specific number of wrong passwords are entered. Antivirus apps make sure that your phone does not get a virus, but they offer no way to message or locate the device. Remotely wiping a mobile device is a feature of locator apps, but it is not itself an app that displays messages and produces noises.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      196,
      193,
      134,
      124,
      232
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 153,
    "question": "As a best practice, after a set period of inactivity on a Windows workstation, what should happen?",
    "choice_a": "The system should shut down.",
    "choice_b": "The system should restart.",
    "choice_c": "A password-enabled screensaver should automatically start.",
    "choice_d": "The system should log out the user.",
    "correct_answer": "C",
    "explanation": "A screensaver should automatically start after a short period of idle time, and that screensaver should require a password before the user can begin the session again. The system should neither shut down nor restart, since work could still be open. For the same reason, the system should not log out the user.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      158,
      117,
      170,
      139
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 154,
    "question": "Which Windows feature helps protect against unauthorized changes to system files?",
    "choice_a": "BitLocker",
    "choice_b": "EFS",
    "choice_c": "UAC",
    "choice_d": "Windows Defender",
    "correct_answer": "C",
    "explanation": "User Account Control (UAC) helps protect against unauthorized changes to system files by prompting for administrative approval. BitLocker and EFS provide encryption. Windows Defender offers antivirus protection.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      170,
      167,
      117,
      160,
      172
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 155,
    "question": "Which of the following has the goal of allowing a username/password combination to be entered once and then allowing claims to be used for consecutive logins? (Choose the best answer.)",
    "choice_a": "Tokens",
    "choice_b": "Kerberos",
    "choice_c": "Single sign-on",
    "choice_d": "Multifactor authentication",
    "correct_answer": "C",
    "explanation": "The goal of single sign-on (SSO) is to allow a username/password combination. Once the combination is entered, claims are used to access additional resources. Tokens are given to the operating system after a user successfully logs in; they allow a user to access rights on the operating system. Kerberos is used (along with Active Directory) to authenticate a user on the Windows operating system. Multifactor authentication is the use of two or more factors to authenticate a user.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      169,
      122,
      121,
      168,
      125
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 156,
    "question": "Which of these is a password manager?",
    "choice_a": "Edge",
    "choice_b": "Credential Manager",
    "choice_c": "Internet Explorer 11",
    "choice_d": "Active Directory",
    "correct_answer": "B",
    "explanation": "The Windows Credential Manager is a password manager that is built into the operating system of Windows. Edge and Internet Explorer 11 work in conjunction with the Credential Manager, but they are not password managers. Active Directory is used to authenticate domain users, but it does not manage passwords for end users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      158,
      157,
      120,
      159
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 157,
    "question": "You have a very small network in a home-based office, and you want to limit network access to only those hosts that you physically own. What should you utilize to make this possible?",
    "choice_a": "Static IP addresses",
    "choice_b": "Disabled DNS",
    "choice_c": "Default subnet mask",
    "choice_d": "Empty default gateway",
    "correct_answer": "A",
    "explanation": "The advantage to assigning the IP addresses statically is that you can make certain which host is associated with which IP address, and then use filtering to limit network access to only those hosts. Disabling DNS will limit all hosts on a network from getting to the Internet and will not limit network access. A default subnet mask will not limit network access and will cause other problems. An empty default gateway will not limit network access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      182,
      187,
      189,
      119,
      147
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 158,
    "question": "Which wireless encryption protocol provides Advanced Encryption Standard (AES) encryption?",
    "choice_a": "Wired Equivalent Privacy (WEP)",
    "choice_b": "Wi-Fi Protected Access (WPA)",
    "choice_c": "Wi-Fi Protected Access 2 (WPA2)",
    "choice_d": "Temporal Key Integrity Protocol (TKIP)",
    "correct_answer": "C",
    "explanation": "Wi-Fi Protected Access 2 (WPA2) offers the Advanced Encryption Standard (AES) for encrypting wireless communications. Wired Equivalent Privacy (WEP) offers weak 64- or 128-bit encryption. Wi-Fi Protected Access (WPA) uses the RC4 encryption algorithm. Temporal Key Integrity Protocol (TKIP) is a part of the WPA encryption protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      180,
      183,
      181,
      182,
      184
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 159,
    "question": "Which type of add-on will extend the functionality of the web browser in a way it wasn\u2019t originally designed?",
    "choice_a": "Pop-up blocker",
    "choice_b": "Extensions",
    "choice_c": "Plug-in",
    "choice_d": "Ad blocker",
    "correct_answer": "B",
    "explanation": "An extension is a type of add-on that will extend the functionality of the web browser in a way it was never originally designed. A pop-up blocker changed the way a web page is rendered. A plug-in changes the way a web page is rendered. An ad blocker also changes the way a web page is rendered.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      179,
      176,
      178,
      177,
      175
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 160,
    "question": "What is normally performed when an employee is offboarded?",
    "choice_a": "Their user account is deleted.",
    "choice_b": "Their user account is unlocked.",
    "choice_c": "Their user account is created.",
    "choice_d": "Their user account\u2019s password is reset.",
    "correct_answer": "A",
    "explanation": "When an employee is offboarded, their user account is deleted or disabled. A user account is not created, nor is its password reset, during the offboarding process. A user account normally is created during the onboarding process.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      160,
      126,
      167,
      166,
      168
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 161,
    "question": "By default, when setting up an Android device, why do you need a Google account?",
    "choice_a": "The device requires email setup.",
    "choice_b": "The account is used for cloud synchronizations.",
    "choice_c": "The account is used for desktop backups.",
    "choice_d": "The device requires registration.",
    "correct_answer": "B",
    "explanation": "By default, a Google account is required on Android devices; it is used to synchronize data and app purchases to the cloud. The device does not require email to be set up, but the account can be used for the setup. The account is not used for desktop backups. The device does not require registration.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      197,
      196,
      124,
      232,
      195
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 162,
    "question": "You need to secure your mobile device\u2019s lock screen with the highest level of protection. Which of the following should you use? (Choose the best answer.)",
    "choice_a": "Fingerprint lock",
    "choice_b": "Face lock",
    "choice_c": "Passcode lock",
    "choice_d": "Swipe lock",
    "correct_answer": "A",
    "explanation": "Fingerprint locks are the most secure of all the lock methods, since fingerprints are hard to duplicate. Face locks have a high number of false positives, which can be used to gain access to the phone. Passcode locks can be cracked or shoulder surfed. Swipe locks are not really locks; they just allow the screen to be opened with a swipe.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      115,
      159,
      120,
      148
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 163,
    "question": "You need to encrypt a single file on a Windows desktop. Which technology should you use?",
    "choice_a": "EFS",
    "choice_b": "BitLocker",
    "choice_c": "NTFS",
    "choice_d": "BitLocker to Go",
    "correct_answer": "A",
    "explanation": "The Encrypted File System (EFS) is a functionality of the Windows NTFS filesystem. EFS can encrypt individual files and folders. BitLocker is a full-device encryption technology. NTFS is a filesystem that supports encryption and security, among other functionality. BitLocker to Go is used for full-device encryption of removable drives.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      174,
      172,
      156,
      171,
      200
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 164,
    "question": "A user is in both the Sales group and the Marketing group. The Sales group has full permission at the share level, and the Marketing group has Read-only permission. The files on NTFS are secured with the Modify permission for the Sales group and the Read & Execute permission for the Marketing group. Which permissions will the user have?",
    "choice_a": "Full",
    "choice_b": "Modify",
    "choice_c": "Read-only",
    "choice_d": "Read & Execute",
    "correct_answer": "B",
    "explanation": "Because the user is in both groups and the Sales group has full share permissions and the Sales group has modify NTFS permissions, the most restrictive of the two is Modify, so that will be the effective permission for the user. All of the other answers are incorrect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      126,
      160,
      117
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 165,
    "question": "James just moved a folder on the same partition. What will happen with the permissions for the folder?",
    "choice_a": "The permissions will be the same as they were before the move.",
    "choice_b": "The permissions will be inherited from the new parent folder.",
    "choice_c": "The permissions will be configured as the root folder for the drive letter.",
    "choice_d": "The permissions will be blank until configured.",
    "correct_answer": "A",
    "explanation": "The permissions will be the same as before the move, since you are just moving the files and not creating a new entity. The permissions will not be inherited from the parent folder. The permissions will not be configured the same as the root folder. The permissions will not be blank.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      172,
      119,
      167
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 166,
    "question": "A user is in the Sales group. The Sales group has no permissions at the share level. The files on NTFS are secured with the Modify permission for the Sales group. What permissions will the user have?",
    "choice_a": "The user will have the Modify permission when connecting from the network.",
    "choice_b": "The user will have the Modify permission when logged in locally to the computer.",
    "choice_c": "The user will have no access when logged in locally to the computer.",
    "choice_d": "The user will have Read-only permissions when connecting from the network.",
    "correct_answer": "B",
    "explanation": "The user will have only the Modify permission when logged in locally to the computer, since the filesystem is not shared with the appropriate permissions. The user will not have the Modify permission when connecting from the network. The user will still have the Modify permission when logged in locally, because of the NTFS permissions. The user will not have read-only permissions when connecting from the network.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      171,
      200,
      172,
      168,
      126
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 167,
    "question": "You are trying to delete a file on the local filesystem, but the operating system will not let you. What could be the problem? (Choose the best answer.)",
    "choice_a": "The NTFS Modify permission is applied to the file.",
    "choice_b": "The share permissions are not set to Full Control.",
    "choice_c": "The file attributes are set to Read-only.",
    "choice_d": "The file attributes are set to System.",
    "correct_answer": "C",
    "explanation": "The file attributes are most likely set to Read-only, and thus you are not permitted to delete the file. The Modify permission would not hinder the file from being deleted. The share permissions would not have any bearing on the problem, since the local filesystem is being accessed. The file attributes being set to System would not restrict a file from being deleted.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      172,
      171,
      170,
      200,
      167
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 168,
    "question": "You need to enforce profile security requirements on mobile devices. Which should you use to achieve this goal?",
    "choice_a": "AUP",
    "choice_b": "NDA",
    "choice_c": "BYOD",
    "choice_d": "MDM",
    "correct_answer": "D",
    "explanation": "Mobile device management (MDM) software enables you to enforce profile security requirements on mobile devices. The acceptable use policy (AUP) is a code of ethics your users should follow when dealing with organizational resources. A nondisclosure agreement (NDA) is an agreement between an employee and the organization to protect intellectual property. A bring your own device (BYOD) policy explains how devices should be secured but provides no enforcement.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      195,
      198,
      124,
      232,
      155
    ],
    "source": "330034_Vol2_Ch06"
  },
  {
    "id": 169,
    "question": "In Windows, which utility is responsible for finding, downloading, and installing Windows patches?",
    "choice_a": "Device Manager",
    "choice_b": "Microsoft Management Console",
    "choice_c": "Download Manager",
    "choice_d": "Windows Update",
    "correct_answer": "D",
    "explanation": "Windows Update is responsible for downloading and installing Windows service packs, patches, and security updates. Device Manager is used to view devices installed on the operating system. The Microsoft Management Console is a console that allows snap-ins to be added for management. Download Manager is a component of Edge.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      153,
      175,
      146,
      138,
      134
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 170,
    "question": "Which Startup Setting option allows you to boot with basic drivers?",
    "choice_a": "Enable Debugging",
    "choice_b": "Enable Safe Boot",
    "choice_c": "Disable Driver Signature Enforcement",
    "choice_d": "Enable Low-Resolution Video",
    "correct_answer": "B",
    "explanation": "Enable Safe Boot with the <code>msconfig</code> utility allows you to boot with basic drivers and minimal startup of nonessential services. Enable Debugging is used by kernel developers. Disable Driver Signature Enforcement is used to allow an unsigned driver to load during boot. Enable Low-Resolution Video will boot the operating system into a VGA mode.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      203,
      202,
      201,
      204
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 171,
    "question": "Which <code>bootrec</code> option can be used in Windows to rebuild the boot configuration file?",
    "choice_a": "<code>/fixboot</code>",
    "choice_b": "<code>/rebuildbcd</code>",
    "choice_c": "<code>/scanos</code>",
    "choice_d": "<code>/fixmbr</code>",
    "correct_answer": "B",
    "explanation": "The <code>/REBUILDBCD</code> option can be used with the <code>bootrec</code> tool to rebuild the boot configuration data (BCD). The <code>/FIXBOOT</code> option writes a new boot sector to the system partition. The /<code>SCANOS</code> option scans all other partitions that are found to have Windows installations. The <code>/FIXMBR</code> writes a new master boot record (MBR) to the partition.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      202,
      203,
      216,
      219,
      218
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 172,
    "question": "What is the first step in malware removal?",
    "choice_a": "Quarantine the infected system.",
    "choice_b": "Identify and verify the malware symptoms.",
    "choice_c": "Remediate the infected system.",
    "choice_d": "Educate the end user.",
    "correct_answer": "B",
    "explanation": "The most important first step is to identify and verify the malware symptoms. You should quarantine the infected system once you have verified it is infected. Remediating the infected system happens after you disable System Restore. Education of the end user is the last step to malware removal.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      217,
      209,
      211,
      220,
      134
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 173,
    "question": "Which tool will allow you to troubleshoot a slow-loading profile?",
    "choice_a": "Profile tab of the Advanced System Properties",
    "choice_b": "Regedit",
    "choice_c": "Windows Recovery Environment",
    "choice_d": "Windows Preinstallation Environment",
    "correct_answer": "A",
    "explanation": "The Profile tab of the Advanced Systems Properties dialog box allows you to view the total size of a local or remote profile. Regedit and the Windows Recovery Environment will not aid in troubleshooting a slow-loading profile. Windows Preinstallation Environment is the mini-Windows version used for installation of Windows.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      202,
      203,
      201,
      204,
      206
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 174,
    "question": "Which of the following components are only used to restore Windows from a suspended state?",
    "choice_a": "BCD",
    "choice_b": "<code>ntoskrnl.exe</code>",
    "choice_c": "<code>winload.efi</code>",
    "choice_d": "<code>winresume.exe</code>",
    "correct_answer": "D",
    "explanation": "<code>winresume.exe</code> is used to load Windows from a suspended state. The Boot Configuration Data (BCD) is used to direct Windows to boot the proper installation. <code>ntoskrnl.exe</code> is the Windows kernel. <code>winload.efi</code> is used for the normal booting of the Windows operating system.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      202,
      203,
      216,
      208,
      205
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 175,
    "question": "One of the users you support has a Windows 11 laptop that will not boot up. The user just installed brand-new drivers for a graphics card. They need to access a tax application and their data files. What should you try first?",
    "choice_a": "Use System Restore.",
    "choice_b": "Use Reset This PC.",
    "choice_c": "Reimage the laptop.",
    "choice_d": "Manually reinstall Windows 10.",
    "correct_answer": "A",
    "explanation": "The System Restore option should be used first to restore the operating system to an earlier point before the problem. This will restore the device back to a previous state before the installation of the drivers. System Restore will not affect user data files. Reset This PC will reset the PC back to factory default before the tax application was installed. Reimaging the laptop will erase all programs and data files. Manually reinstalling Windows 10 will erase all programs and data files.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      205,
      203,
      208,
      216,
      218
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 176,
    "question": "Which partitioning type is required when you have UEFI firmware?",
    "choice_a": "GPT",
    "choice_b": "MBR",
    "choice_c": "POST",
    "choice_d": "Boot Sector",
    "correct_answer": "A",
    "explanation": "When you have UEFI firmware, you must have the disk set up with a GUID Partition Table (GPT) partitioning type. The standard master boot record (MBR) partitioning type can be used with BIOS. Power-on self-test (POST) is a routine the BIOS or firmware performs to test hardware before boot. The Boot Sector is contained on both MBR and GPT partitioning types.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      202,
      203,
      216,
      208,
      219
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 177,
    "question": "Which of the following are used to prevent pop-unders from appearing?",
    "choice_a": "Antimalware utilities",
    "choice_b": "Pop-up blockers",
    "choice_c": "Phishing sites",
    "choice_d": "Antivirus software",
    "correct_answer": "B",
    "explanation": "Pop-up blockers are used to prevent pop-ups and pop-unders from appearing. Antimalware utilities will remove and prevent malware. Phishing sites are used to collect users credentials\u2019 by tricking users. Antivirus software is used to protect the operating system from viruses.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      135,
      132,
      211,
      139
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 178,
    "question": "In general, how often should you update your antivirus definitions?",
    "choice_a": "Weekly.",
    "choice_b": "Monthly.",
    "choice_c": "Daily.",
    "choice_d": "Antivirus definitions do not need to be updated.",
    "correct_answer": "C",
    "explanation": "Antivirus definitions should be updated daily, because new viruses are identified by the minute. Updating antivirus definitions weekly or monthly will open you up to the possibility of infection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      173,
      220,
      135,
      153
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 179,
    "question": "Which tool can be used to diagnose why Windows 11 is slow and sluggish?",
    "choice_a": "Resource Monitor",
    "choice_b": "<code>msconfig.exe</code>",
    "choice_c": "Device Manager",
    "choice_d": "Reliability Monitor",
    "correct_answer": "A",
    "explanation": "Resource Monitor can be used to identify slow and sluggish performance, as well as identify the source of the problem. The <code>msconfig.exe</code> tool can be used to enable or disable services on startup and launch tools, but it cannot be used to diagnose performance issues. The Device Manager MMC can be used to view and modify devices, but it will not help diagnose performance problems. Reliability Monitor will display the reliability of the operating system, but it will not help diagnose problems with performance.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      201,
      204,
      207,
      216,
      219
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 180,
    "question": "Which tool will allow you to diagnose why Windows Update keeps failing?",
    "choice_a": "<code>ntbtlog.txt</code>",
    "choice_b": "Windows Update Troubleshooter",
    "choice_c": "Windows Recovery Environment",
    "choice_d": "Safe mode",
    "correct_answer": "B",
    "explanation": "Windows Update Troubleshooter can assist in diagnosing problems with Windows Update. The <code>ntbtlog.txt</code> file is used to diagnose problems with bootup. Windows Recovery Environment is used to solve problems with Windows and is not typically used for problems with Windows Updates. Safe mode is a boot mode that loads minimal drivers and services.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      216,
      208,
      204,
      203,
      206
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 181,
    "question": "Which of the following programs could be considered antimalware?",
    "choice_a": "Windows Defender Security",
    "choice_b": "MDM",
    "choice_c": "Windows Action Center",
    "choice_d": "VirusTotal",
    "correct_answer": "A",
    "explanation": "Windows Defender Security is considered antimalware and antivirus protection for the Windows operating system. Mobile device management (MDM) software is used to manage mobile devices. Windows Action Center is a notification center for action to be taken in the operating system. VirusTotal is a third-party site that analyzes virus signatures, but it does not protect you from them.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      135,
      134,
      217,
      211
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 182,
    "question": "Which of the following tools allows you to manually fix maliciously modified system files?",
    "choice_a": "<code>regedit</code>",
    "choice_b": "SFC",
    "choice_c": "<code>bootrec</code>",
    "choice_d": "UAC",
    "correct_answer": "B",
    "explanation": "The System File Checker (SFC) allows you to manually scan for modified operating system files and repair them. <code>regedit</code> is used to modify the Registry. <code>bootrec</code> is used to repair the boot records on an operating system installation. User Account Control (UAC) is used to control access to administrative credentials.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      154,
      153,
      209,
      172
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 183,
    "question": "Which of the following can you do to help eliminate security problems? (Choose the best answer.)",
    "choice_a": "Establish security policies and procedures.",
    "choice_b": "Optimize drives.",
    "choice_c": "Prevent booting into Safe Mode.",
    "choice_d": "Prevent booting into Windows Recovery Environment.",
    "correct_answer": "A",
    "explanation": "Establishing security policies and procedures will help eliminate security problems and guide employees on what to do if they arise. Optimizing drives will defragment drives and has no effect on security. Preventing booting into safe mode will only hinder diagnostics. Preventing booting into Windows Recovery Environment will also hinder diagnostics.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      141,
      117,
      153,
      158
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 184,
    "question": "A mobile device is running out of RAM. What could be the most likely problem?",
    "choice_a": "The device is not charged to capacity.",
    "choice_b": "The digitizer is not functioning properly.",
    "choice_c": "The device is in DND mode.",
    "choice_d": "The device has background applications open.",
    "correct_answer": "D",
    "explanation": "The device most likely has too many background applications open that are using RAM. That the device is not charged to capacity would not affect RAM. A digitizer not functioning properly would resemble inaccurate touchscreen responses. If the device were in Do Not Disturb (DND) mode, the speakers would not work.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      223,
      221,
      230,
      207,
      225
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 185,
    "question": "What is a risk of using the auto-reconnect feature on a mobile device?",
    "choice_a": "The device will reconnect to any SSID.",
    "choice_b": "The device could be exploited by an evil twin attack.",
    "choice_c": "The device\u2019s battery life could be shortened.",
    "choice_d": "You may exceed your cellular data plan\u2019s limits.",
    "correct_answer": "B",
    "explanation": "If auto-reconnect is configured on an SSID, the device could be susceptible to an evil twin attack, in which the device connects to any device with the same SSID. The device will not reconnect to any SSID but only to the SSID configured as auto-reconnect. Battery life will remain unaffected with auto-reconnect. Exceeding limits can be avoided with auto-reconnect, because the wireless network is used for data usage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      182,
      184,
      139,
      195
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 186,
    "question": "You notice that the reliability of the operating system has diminished in Reliability Monitor. Where can you find more details on why applications are failing?",
    "choice_a": "Device Manager",
    "choice_b": "Event Viewer",
    "choice_c": "Windows Recovery Environment",
    "choice_d": "<code>msconfig.exe</code>",
    "correct_answer": "B",
    "explanation": "Event Viewer will allow you to see more detailed information on why programs have crashed. The Event Viewer logs may not give the exact reason, but they will aid in understanding the root cause. Device Manager is used to view and manage devices connected to the operating system. The Windows Recovery Environment is used to repair the Windows operating system. The <code>msconfig.exe</code> tool is used to modify startup programs and launch other diagnostic tools.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      204,
      206,
      208,
      203,
      205
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 187,
    "question": "Why would the operating system write out large amounts of RAM to the page file?",
    "choice_a": "The CPU is running high on utilization.",
    "choice_b": "This is a normal process of the operating system.",
    "choice_c": "The amount of physical RAM is low.",
    "choice_d": "The page file is faster than conventional RAM.",
    "correct_answer": "C",
    "explanation": "The reason that the operating system would write out large amounts of RAM to the page file is that the system is running low on physical RAM and is attempting to free up physical RAM. The CPU might run high when paging occurs, but it will not trigger excessive paging. Although it is normal for the operating system to write out RAM to the page file, it is not normal for large amounts to be written out. The page file is not faster than conventional RAM.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      207,
      201,
      223,
      204,
      216
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 188,
    "question": "What is one consequence of an overheating mobile device?",
    "choice_a": "Higher RAM usage",
    "choice_b": "Degraded battery life",
    "choice_c": "Inaccurate touchscreen response",
    "choice_d": "Inability to decrypt emails",
    "correct_answer": "B",
    "explanation": "Degraded battery life can be expected from an overheating mobile device if the\u00a0problem persists for a long time. Higher RAM usage will not occur with overheating, but it could be a cause of overheating. Inaccurate touchscreen responses are not a symptom or a consequence of overheating. The inability to decrypt emails depends on having the proper certificate installed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      197,
      232,
      195,
      124,
      228
    ],
    "source": "330034_Vol2_Ch07"
  },
  {
    "id": 189,
    "question": "Which statement about scripting languages is true?",
    "choice_a": "Scripting languages require a compiler.",
    "choice_b": "Scripting languages are strongly typed.",
    "choice_c": "Scripting languages are interpreted.",
    "choice_d": "Scripting languages have good memory management.",
    "correct_answer": "C",
    "explanation": "Scripting languages are interpreted languages that run on top of a runtime environment. Programming languages, not scripting languages, require a compiler. Scripting languages are not strongly typed; programming languages are strongly typed. Scripting languages have bad memory management because of loosely typed variables.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      233,
      234,
      235,
      236,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 190,
    "question": "What level are scripting languages considered?",
    "choice_a": "High",
    "choice_b": "Mid",
    "choice_c": "Intermediate",
    "choice_d": "Low",
    "correct_answer": "A",
    "explanation": "Scripting languages are considered high-level languages because they do not directly access hardware and use an intermediary called the interpreter. Mid-level languages are Java and C/C++, not scripting languages. There is no such thing as an intermediate-level language. Low-level languages are machine language and assembly language, which are not scripting languages.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      237,
      236,
      234,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 191,
    "question": "Which type of variable will allow decimal math?",
    "choice_a": "Boolean",
    "choice_b": "Integer",
    "choice_c": "Floating-point",
    "choice_d": "String",
    "correct_answer": "C",
    "explanation": "Floating-point variables allow for precision math, also known as decimal math. Boolean variables allow for true or false values. Integer variables allow for whole numbers values. String variables allow for text values.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      235,
      236,
      237,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 192,
    "question": "Which environment variable is not inherited?",
    "choice_a": "System variable",
    "choice_b": "User variable",
    "choice_c": "Program variable",
    "choice_d": "String variable",
    "correct_answer": "C",
    "explanation": "A program variable is the least significant and it is not inherited. A system variable is defined for the entire system and is the most significant because it is inherited by all users and programs. A user variable is significant as well, since all applications will inherit the variable. A string variable is not inherited, but it is not an environment variable.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      255,
      236,
      238,
      242
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 193,
    "question": "Which statement will load a PowerShell variable <code>xvar</code> with a value of 2?",
    "choice_a": "<code>xvar = 2</code>",
    "choice_b": "<code>$xvar = 2</code>",
    "choice_c": "<code>xvar = 2;</code>",
    "choice_d": "<code>set /a xvar=2</code>",
    "correct_answer": "B",
    "explanation": "The statement <code>$xvar = 2</code> is a PowerShell statement that will load the variable <code>xvar</code> with a value of <code>2</code>. The statement <code>xvar = 2</code> is Bash syntax. The statement <code>xvar = 2</code>; is JavaScript syntax. The statement <code>set /a xvar=2</code> is Windows batch script syntax.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      236,
      237,
      235,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 194,
    "question": "Which type of loop has a defined beginning and end, and steps from beginning to end?",
    "choice_a": "<code>do while</code> loop",
    "choice_b": "<code>while</code> loop",
    "choice_c": "<code>if</code> statement",
    "choice_d": "<code>for</code> loop",
    "correct_answer": "D",
    "explanation": "A <code>for</code> loop has a defined beginning and end, and steps from the beginning to the end. A <code>do while</code> loop is a type of <code>while</code> loop and has only a defined end. A <code>while</code> loop has only a defined end. An <code>if</code> statement is branch logic, not a loop.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      235,
      234,
      246,
      250,
      251
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 195,
    "question": "Which extension is used with the Windows batch scripting language?",
    "choice_a": "<code>.vbs</code>",
    "choice_b": "<code>.js</code>",
    "choice_c": ".<code>bat</code>",
    "choice_d": ".<code>py</code>",
    "correct_answer": "C",
    "explanation": "The <code>.bat</code> extension is used with the Windows batch scripting language. The <code>.vbs</code> extension is used with VBScript language. The <code>.js</code> extension is used with the JavaScript scripting language. The <code>.py</code> extension is used with the Python scripting language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      236,
      234,
      233,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 196,
    "question": "Which scripting language allows for the use of the Component Object Model (COM)?",
    "choice_a": "PowerShell",
    "choice_b": "VBScript",
    "choice_c": "Windows batch script",
    "choice_d": "JavaScript",
    "correct_answer": "B",
    "explanation": "The VBScript language allows for the use of the Component Object Model (COM). The PowerShell scripting language allows for the use of the .NET Framework. Windows batch scripts use existing applications. JavaScript is primarily web browser\u2013based and does not allow for the use of external objects.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      237,
      236,
      233,
      234,
      255
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 197,
    "question": "Which extension is used with the Python scripting language?",
    "choice_a": "<code>.vbs</code>",
    "choice_b": "<code>.js</code>",
    "choice_c": "<code>.bat</code>",
    "choice_d": "<code>.py</code>",
    "correct_answer": "D",
    "explanation": "The <code>.py</code> extension is used with the Python scripting language. The <code>.vbs</code> extension is used with the VBScript language. The <code>.js</code> extension is used with the JavaScript scripting language. The <code>.bat</code> extension is used with the Windows batch scripting language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      234,
      236,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 198,
    "question": "Which scripting language is used with Microsoft Azure and Microsoft 365?",
    "choice_a": "PowerShell",
    "choice_b": "VBScript",
    "choice_c": "Windows batch script",
    "choice_d": "JavaScript",
    "correct_answer": "A",
    "explanation": "The PowerShell scripting language allows for the use of the .NET Framework and is commonly used with Microsoft Azure and Microsoft 365. The VBScript language allows for the use of the Component Object Model (COM) and is not used for cloud services. A Windows batch script uses existing applications and is not used for cloud services. JavaScript is primarily web browser\u2013based, does not allow for the use of external objects, and is not used for cloud services.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      236,
      237,
      255,
      233,
      235
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 199,
    "question": "Which scripting language is used within web pages to allow for interactive content?",
    "choice_a": "PowerShell",
    "choice_b": "Bash",
    "choice_c": "Windows batch script",
    "choice_d": "JavaScript",
    "correct_answer": "D",
    "explanation": "JavaScript is primarily web browser\u2013based and allows for interactive content. The PowerShell scripting language is used to manage the operating system. The Bash scripting language is primarily used with Linux and Unix systems. Windows batch scripts use existing applications and are used to manage the operating system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      234,
      235,
      233,
      236
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 200,
    "question": "Which extension is used with the Bash scripting language?",
    "choice_a": "<code>.vbs</code>",
    "choice_b": "<code>.sh</code>",
    "choice_c": "<code>.bat</code>",
    "choice_d": "<code>.py</code>",
    "correct_answer": "B",
    "explanation": "The <code>.sh</code> extension is used with the Bash scripting language. The <code>.vbs</code> extension is used with the VBScript language. The <code>.bat</code> extension is used with the Windows batch scripting language. The <code>.py</code> extension is used with the Python scripting language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      234,
      238,
      236
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 201,
    "question": "What must be done before a Bash script can be executed?",
    "choice_a": "<code>chown</code> permissions must be set.",
    "choice_b": "The <code>execute</code> attribute must be set.",
    "choice_c": "<code>chmod</code> permissions must be set.",
    "choice_d": "An <code>.sh</code> must be added to the end of the script.",
    "correct_answer": "C",
    "explanation": "Before a Bash script can be executed, you must use the <code>chmod</code> command to grant execute permissions. The <code>chown</code> command changes ownership. There is no such thing as an <code>execute</code> attribute. Adding <code>.sh</code> to the end of the script doesn\u2019t serve any purpose.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      235,
      238,
      290,
      292
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 202,
    "question": "Which statement will load a JavaScript variable <code>mvar</code> with a value of 8?",
    "choice_a": "<code>$mvar = 8</code>",
    "choice_b": "<code>mvar = 8</code>",
    "choice_c": "<code>mvar = 8;</code>",
    "choice_d": "<code>set /a mvar=8</code>",
    "correct_answer": "C",
    "explanation": "The statement <code>mvar = 8</code>; is JavaScript syntax to load a variable of <code>mvar</code> with a value of <code>8</code>. The statement <code>$mvar = 8</code> is PowerShell syntax. The statement <code>mvar = 8</code> is Bash syntax. The statement <code>set /a mvar=8</code> is Windows batch script syntax.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      234,
      236,
      255,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 203,
    "question": "Which scripting language has its own preinstalled Integrated Scripting Environment (ISE)?",
    "choice_a": "VBScript",
    "choice_b": "Bash",
    "choice_c": "Python",
    "choice_d": "PowerShell",
    "correct_answer": "D",
    "explanation": "PowerShell is the only scripting language that has a preinstalled Integrated Scripting Environment (ISE), called the PowerShell ISE. The VBScript language requires the installation of Microsoft Visual Studio Code. The Bash scripting language requires a text editor or other package to be installed. The Python scripting language requires a third-party integrated development environment (IDE), also known as an ISE.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      236,
      237,
      255,
      233,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 204,
    "question": "Which line would be used to comment JavaScript code?",
    "choice_a": "<code>//comment</code>",
    "choice_b": "<code>'comment</code>",
    "choice_c": "<code>REM comment</code>",
    "choice_d": "<code># comment</code>",
    "correct_answer": "A",
    "explanation": "The line <code>//comment</code> is used to comment JavaScript code. The line '<code>comment</code> is used to comment VBScript code. The line <code>REM comment</code> is used to comment Windows batch script code. The line <code># comment</code> is used to comment Bash script code and PowerShell code.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      237,
      233,
      235,
      236,
      238
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 205,
    "question": "Which extension is used with the JavaScript scripting language?",
    "choice_a": "<code>.js</code>",
    "choice_b": "<code>.sh</code>",
    "choice_c": "<code>.bat</code>",
    "choice_d": "<code>.py</code>",
    "correct_answer": "A",
    "explanation": "The <code>.js</code> extension is used with the JavaScript scripting language. The <code>.sh</code> extension is used with the Bash scripting language. The <code>.bat</code> extension is used with the Windows batch scripting language. The <code>.py</code> extension is used with the Python scripting language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      234,
      238,
      236
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 206,
    "question": "What is the primary goal of artificial intelligence (AI)?",
    "choice_a": "To replace human intelligence",
    "choice_b": "To simulate or imitate human intelligence",
    "choice_c": "To create emotional experiences",
    "choice_d": "To enhance human physical abilities",
    "correct_answer": "B",
    "explanation": "The primary goal of AI is to simulate or imitate human intelligence. This involves processes like learning, thinking, and problem-solving. AI is not intended to replace human intelligence but to complement it. Creating emotional experiences is not the main goal of AI. AI focuses on cognitive processes, not physical abilities.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      247,
      246,
      249,
      250,
      248
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 207,
    "question": "What is the primary function of convolutional neural networks (CNNs)?",
    "choice_a": "Language translation",
    "choice_b": "Image and video analysis",
    "choice_c": "Speech recognition",
    "choice_d": "Game playing",
    "correct_answer": "B",
    "explanation": "Convolutional neural networks (CNNs) are specialized for image and video analysis. Language translation is typically handled by recurrent neural networks (RNNs). Speech recognition is also handled by RNNs. Game playing can be handled by various types of neural networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      247,
      246,
      249,
      250,
      251
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 208,
    "question": "What is tokenization in the context of AI?",
    "choice_a": "Dividing text into smaller parts known as tokens",
    "choice_b": "Converting images into text",
    "choice_c": "Translating text into another language",
    "choice_d": "Analyzing audio data",
    "correct_answer": "A",
    "explanation": "Tokenization is the method of dividing text into smaller parts known as tokens. Tokenization does not involve converting images into text. Tokenization is not about translating text. Tokenization deals with text, not audio data. Translating text into another language is the function of transformers.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      248,
      250,
      246,
      249,
      251
    ],
    "source": "330034_Vol2_Ch08"
  },
  {
    "id": 209,
    "question": "You have dropped a screw into a tight location of a computer. How should you retrieve it?",
    "choice_a": "Use a magnetic-tipped screwdriver.",
    "choice_b": "Use a magnetic grabber.",
    "choice_c": "Use a three-pronged grabber.",
    "choice_d": "Shake the computer until it falls out.",
    "correct_answer": "C",
    "explanation": "A three-pronged grabber should be used to retrieve the screw from the computer. Using a magnetic-tipped screwdriver is not advisable, because many components are sensitive to magnets. Using a magnetic grabber is not advisable, because many components are sensitive to magnets. Shaking the computer until it falls out can be dangerous and make the screw harder to get out.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      258,
      259,
      266,
      261
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 210,
    "question": "Your company\u2019s AUP states that employees must not use company resources for personal gain. You have a side business and want to use your work computer to manage it. What should you do?",
    "choice_a": "Use your work computer to manage your side business.",
    "choice_b": "Use your personal computer to manage your side business.",
    "choice_c": "Ask your manager for permission to use your work computer.",
    "choice_d": "Ignore the AUP and use your work computer anyway.",
    "correct_answer": "B",
    "explanation": "Using your personal computer to manage your side business adheres to the AUP and prevents misuse of company resources. Using your work computer violates the AUP. Asking for permission is unnecessary as the AUP clearly prohibits such use.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      287,
      254,
      286,
      275
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 211,
    "question": "One of your coworkers just spilled a chemical solvent in a warehouse, and you have been asked to help clean it up. Which of the following must contain information about a chemical solvent\u2019s emergency cleanup procedures?",
    "choice_a": "OSHA",
    "choice_b": "MSDS",
    "choice_c": "Product label",
    "choice_d": "CRT",
    "correct_answer": "B",
    "explanation": "The material safety data sheet (MSDS) will have the necessary information about the cleanup procedures. The Occupational Safety and Health Administration (OSHA) is an organization that oversees safety in the workplace. The product label may or may not have this information. A cathode-ray tube (CRT) is a type of monitor that uses a glass tube.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      268,
      266,
      269,
      278,
      263
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 212,
    "question": "You are purchasing an inkjet printer cartridge for home use that you know has an MSDS. How do you obtain the MSDS for this product?",
    "choice_a": "The store is required to give you one at the time of purchase.",
    "choice_b": "It\u2019s contained in the packaging of the printer cartridge.",
    "choice_c": "You are not legally allowed to have an MSDS for this product.",
    "choice_d": "You should visit the printer cartridge manufacturer\u2019s website.",
    "correct_answer": "D",
    "explanation": "You can download the MSDS by visiting the printer cartridge manufacturer\u2019s website. The store is not required to furnish an MSDS at the time of purchase. The manufacturer is not required to furnish an MSDS with the packaging of the product. You are legally allowed to have an MSDS for products, as per OSHA. You should have them on hand in case of an emergency.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      268,
      267,
      269,
      261,
      287
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 213,
    "question": "In the interest of a safe work environment, which of the following should you report? (Choose two.)",
    "choice_a": "An accident",
    "choice_b": "A near-accident",
    "choice_c": "Spills on the floor inside a building",
    "choice_d": "Rain forecasted for a workday",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "An accident should always be reported so that if there is a hazardous condition, it can be fixed. Report hazardous conditions, such a spill on the floor, to the employer before they are a problem. A near-accident does not need to be reported unless it is caused by a hazardous condition, like spills. Rain forecasted for a workday is not a hazardous condition.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      278,
      268,
      269,
      266,
      286
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 214,
    "question": "What is the approximate minimum level of static charge for humans to feel a shock?",
    "choice_a": "300 volts",
    "choice_b": "3,000 volts",
    "choice_c": "30,000 volts",
    "choice_d": "300,000 volts",
    "correct_answer": "B",
    "explanation": "You can feel an ESD shock of 3,000 volts or more. 300 volts is too low for a human to feel. A minimum of 30,000 volts can be felt by a human. 300,000 volts can be felt by humans and could be painful.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      260,
      259,
      257,
      256
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 215,
    "question": "Your work environment has been unusually dry lately, and several components have been damaged by ESD. Your team has been asked to be extra careful about ESD damage. Which of the following measures can be implemented to reduce the risk of ESD? (Choose two.)",
    "choice_a": "Use an antistatic wrist strap.",
    "choice_b": "Use an antistatic bag.",
    "choice_c": "Spray disinfectant spray.",
    "choice_d": "Shuffle your feet.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Using an antistatic wrist strap allows you to ground yourself to dissipate a static charge. Using antistatic bags allows for a uniform charge around a component. Spraying disinfectant spray will only kill germs, not reduce static. Shuffling your feet will build a charge of static.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      259,
      260,
      266,
      268
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 216,
    "question": "Which of the following are OSHA requirements for a safe work environment that must be followed by employers? (Choose two.)",
    "choice_a": "Attend yearly OSHA safe work environment seminars.",
    "choice_b": "Provide properly maintained tools and equipment.",
    "choice_c": "Have an OSHA employee stationed within 5 miles of the facility.",
    "choice_d": "Display an OSHA poster in a prominent location.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Providing properly maintained tools and equipment is a requirement for an OSHA-compliant workplace. Displaying an OSHA poster in a prominent location is also a requirement for an OSHA-compliant workplace. Attending yearly OSHA safe work environment seminars is not a requirement. Having an OSHA employee stationed within five miles of the facility is also not a requirement.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      268,
      262,
      263,
      266,
      256
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 217,
    "question": "Your office just added 20 new workstations, and your manager has put you in charge of configuring them. The users need to have Microsoft Office installed. What should you do to install Microsoft Office properly on these computers?",
    "choice_a": "Ensure that the company has the proper licenses to install 20 additional copies.",
    "choice_b": "Agree with the open source license agreement during installation.",
    "choice_c": "Use the personal license key from an existing system to install Office on the new computers.",
    "choice_d": "Follow normal installation procedures; nothing else needs to be done.",
    "correct_answer": "A",
    "explanation": "You should ensure that the company has the proper licenses to install 20 additional copies to be compliant with licensing. Microsoft Office is not an open source licensed product. Using the personal license key from an existing system violates the license agreement. Following normal installation procedures will not ensure compliance of licensing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      284,
      286,
      275,
      277
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 218,
    "question": "Your office is moving from one floor of a building to another, and you are part of the moving crew. When moving computer equipment, which of the following are good procedures to follow? (Choose two.)",
    "choice_a": "Lift by bending over at the waist.",
    "choice_b": "Carry CRT monitors with the glass face away from your body.",
    "choice_c": "Use a cart for heavy objects.",
    "choice_d": "Ensure that there are no safety hazards in your path.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "You should use a cart to move heavy objects. You should also ensure that no safety hazards are in your path. Lifting by bending over at the waist can hurt your back. Carrying CRT monitors with the glass facing outward is not safe, as the weight will be farthest from your body.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      278,
      257,
      266,
      268
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 219,
    "question": "You just removed four AA alkaline batteries from a remote-control device. What is the recommended way to dispose of these batteries?",
    "choice_a": "Throw them in the trash.",
    "choice_b": "Incinerate them.",
    "choice_c": "Take them to a recycling center.",
    "choice_d": "Flush them down the toilet.",
    "correct_answer": "C",
    "explanation": "Alkaline batteries should be taken to a recycling center. Throwing batteries in the trash is not environmentally responsible. Incinerating batteries is not advisable, since they can explode and will create pollution. Flushing batteries down the toilet is not an acceptable disposal method.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      267,
      269,
      268,
      266,
      264
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 220,
    "question": "When replacing a hard drive, you discover prohibited material on a user\u2019s laptop. What should you do first? (Choose two.)",
    "choice_a": "Destroy the prohibited material.",
    "choice_b": "Confiscate and preserve the prohibited material.",
    "choice_c": "Confront the user about the material.",
    "choice_d": "Report the prohibited material through the proper channels.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The first step is to confiscate and preserve the prohibited materials on the drive. The next step is to report the prohibited materials through the proper channels. Destroying the prohibited material will not remedy the situation. Confronting the user about the material is not suggested, as they could become hostile.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      270,
      272,
      273,
      312,
      310
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 221,
    "question": "You need to investigate how to protect credit card data on your network. Which information should you research?",
    "choice_a": "PCI DSS",
    "choice_b": "GDPR",
    "choice_c": "PHI",
    "choice_d": "PII",
    "correct_answer": "A",
    "explanation": "You should research information on the Payment Card Industry Data Security Standard (PCI DSS) standard. The General Data Protection Regulation (GDPR) is used for protecting EU citizens. Protected health information (PHI) is any data that defines a patient or an ailment of a patient. Personally identifiable information (PII) is any information that can be used to identify a person.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      275,
      277,
      312,
      273,
      272
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 222,
    "question": "Which class of fire extinguisher is recommended for use in a wood and paper fire?",
    "choice_a": "A",
    "choice_b": "B",
    "choice_c": "C",
    "choice_d": "D",
    "correct_answer": "A",
    "explanation": "Wood and paper fires can be put out by a Class A fire extinguisher. Class B fire extinguishers are used for flammable liquids. Class C fire extinguishers are used for electrical files. Class D fire extinguishers are used for flammable metals.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 223,
    "question": "Which of the following are common types of screwdrivers? (Choose two.)",
    "choice_a": "Circular",
    "choice_b": "Phillips",
    "choice_c": "Torx",
    "choice_d": "Helix",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Phillips and Torx are two common types of screwdrivers. Neither circular nor helix is a type of screwdriver.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 224,
    "question": "Which of the following are elements of a good workplace safety plan? (Choose two.)",
    "choice_a": "Periodic workplace inspections",
    "choice_b": "A safety and health training program",
    "choice_c": "Retribution for employees who report violations",
    "choice_d": "An independent third-party auditor of the safety plan",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Good safety plans protect the interests of the workers and also help to keep company costs down. Periodic workplace inspections and a training program are good components to implement. Employees cannot be punished in any way for reporting safety violations. Third-party audits of safety programs are not necessary but can complement periodic inspections and safety and health training programs.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      268,
      263,
      278,
      285,
      282
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 225,
    "question": "What is the recommended use policy on magnetic-tipped screwdrivers inside computers?",
    "choice_a": "Do not use them.",
    "choice_b": "It\u2019s okay to use them, but keep them away from the processor.",
    "choice_c": "It\u2019s okay to use them, but keep them away from the RAM.",
    "choice_d": "It\u2019s okay to use them, but only if they\u2019re of the powered variety.",
    "correct_answer": "A",
    "explanation": "A good rule of thumb when it comes to magnetic-tipped screwdrivers is to avoid using them inside a computer case. Magnetic tools can damage data on disks that use a magnetic storage scheme. Magnetic-tipped screwdrivers should not be used inside a computer even if they are kept away from the processor and the RAM. Regardless of whether they are powered or not, magnetic-tipped screwdrivers should not be used inside computers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      262,
      258,
      259,
      266,
      268
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 226,
    "question": "Which of the following are usually contained on an MSDS? (Choose two.)",
    "choice_a": "Freezing point",
    "choice_b": "Handling and storage instructions",
    "choice_c": "Personal protection instructions",
    "choice_d": "Weight",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Material safety data sheets (MSDSs) contain handling and storage instructions as well as personal protection instructions. MSDSs do not contain freezing point specifications or weight.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      268,
      269,
      257,
      261,
      256
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 227,
    "question": "Which of the following are OSHA requirements for a safe work environment that must be followed by employees? (Choose two.)",
    "choice_a": "Immediately report all accidents to OSHA.",
    "choice_b": "Use protective gear and equipment.",
    "choice_c": "Attend safety training.",
    "choice_d": "Follow all employer-implemented health and safety rules.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "To maintain a safe work environment, all employees must follow certain protocols. These include using protective gear and equipment and following all health and safety rules. Accidents must be reported to the employer, not OSHA (unless action is not properly taken by the employer). There are no rules requiring safety training, although it is a good idea to have these sessions and for employees to attend them.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      268,
      278,
      258,
      259,
      261
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 228,
    "question": "Which of the following types of batteries are not considered environmental hazards?",
    "choice_a": "Alkaline",
    "choice_b": "Nickel-metal hydride (NiMH)",
    "choice_c": "Nickel-cadmium (NiCd)",
    "choice_d": "Button cell",
    "correct_answer": "B",
    "explanation": "Nickel-metal hydride (NiMH) batteries are not considered environmental hazards. Alkaline batteries used to contain mercury, which is an environmental hazard, so they are assumed to be environmental hazards. Nickel-cadmium (NiCd) batteries and button cell batteries are considered environmental hazards.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      267,
      269,
      256,
      257,
      265
    ],
    "source": "330034_Vol2_Ch09"
  },
  {
    "id": 229,
    "question": "What is the first step to consider when entering a ticket manually?",
    "choice_a": "Determine the urgency of the issue.",
    "choice_b": "Collect user information.",
    "choice_c": "Identify recent changes.",
    "choice_d": "Verify the issue description.",
    "correct_answer": "B",
    "explanation": "Collecting user information is correct because it is essential to know who is reporting the issue and how to contact them. Determining the urgency of the issue is important, but communication to the customer is of higher importance. Identifying recent changes would happen after you enter the ticket. Verifying the issue description is an important, but secondary, step.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      280,
      304,
      279,
      306,
      312
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 230,
    "question": "You are executing the primary plan in the change management documentation and realize that you cannot proceed. Which section details the original configuration?",
    "choice_a": "Purpose",
    "choice_b": "Risk analysis",
    "choice_c": "Rollback",
    "choice_d": "Plan for change",
    "correct_answer": "C",
    "explanation": "The rollback section contains the original configuration that can be used to revert the changes. The purpose section contains the reason for the proposed change. The risk analysis section explains the risks involved with the proposed changes. The plan for change section contains the primary change configuration and the alternate change configuration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      289,
      288,
      291,
      292,
      294
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 231,
    "question": "Which section of the change management documentation contains whom the change will affect?",
    "choice_a": "Business processes",
    "choice_b": "Scope of change",
    "choice_c": "User acceptance",
    "choice_d": "Plan for change",
    "correct_answer": "B",
    "explanation": "The scope of change section details whom the change will affect. The business processes section details the current business processes the change will affect. The end-user acceptance section details how the changes were tested and accepted by the users. The plan for change contains the primary and alternate plans for the proposed change.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      292,
      288,
      291,
      295,
      296
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 232,
    "question": "You just had an outage of Internet connectivity. Which document should you complete so that stakeholders understand the reason for the outage?",
    "choice_a": "Change management documentation",
    "choice_b": "Knowledge base article",
    "choice_c": "Acceptable use policy",
    "choice_d": "Incident documentation",
    "correct_answer": "D",
    "explanation": "Incident documentation should be completed so that key stakeholders can understand the reason for the outage. Change management documentation is used for proposed changes to the network. Knowledge base articles are used to document symptoms and solutions. An acceptable use policy (AUP) is used to protect an organization\u2019s resources from user abuse.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      285,
      288,
      291,
      273,
      272
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 233,
    "question": "Which type of backup allows users to restore their own files without IT intervention?",
    "choice_a": "Image-based backup",
    "choice_b": "Volume Shadow Copy",
    "choice_c": "Incremental backup",
    "choice_d": "Differential backup",
    "correct_answer": "B",
    "explanation": "Volume Shadow Copy allows users to restore previous versions of their files themselves. Image-based restoration typically requires a desktop administrator. Incremental and differential backup and restores also require IT intervention for restoration.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      297,
      301,
      299,
      298,
      302
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 234,
    "question": "Why is it important to document the root cause in an incident document?",
    "choice_a": "To satisfy legal requirements",
    "choice_b": "To ensure accurate billing",
    "choice_c": "To prevent the recurrence of the incident",
    "choice_d": "To train new employees",
    "correct_answer": "C",
    "explanation": "Documenting the root cause helps in preventing the incident from recurring. There are typically no legal requirements around the documentation of the root cause, unless there is something specifically in a contract. Billing is also not related to documenting root cause, unless there is something specifically in a contract. Training new employees is important but is not a primary reason for documenting the root cause.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      285,
      282,
      286,
      310,
      277
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 235,
    "question": "End users are abusing the email system by selling personal items. Which policy would detail the proper use of the email system for business purposes?",
    "choice_a": "MDM",
    "choice_b": "Password policy",
    "choice_c": "AUP",
    "choice_d": "Incident management",
    "correct_answer": "C",
    "explanation": "The acceptable use policy (AUP) details the acceptable use of the email system for business purposes. Mobile device management (MDM) is software that allows you to manage mobile devices in the workplace. A password policy details the appropriate handling and management of passwords. Incident management is how a network or security incident is handled.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      270,
      254,
      286,
      277
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 236,
    "question": "Which backup media is the fastest from which to recover?",
    "choice_a": "Disk-to-tape",
    "choice_b": "Disk-to-disk",
    "choice_c": "Disk-to-flash",
    "choice_d": "Disk-to-cloud",
    "correct_answer": "B",
    "explanation": "Disk-to-disk is the fastest recovery method and backup method as well, because you are backing up from a disk to another disk attached via the network. Disk-to-tape is slower because you must re-tension the tape and then locate the data on the tape to recover it. Disk-to-flash is not a backup method, because of the price of flash. Disk-to-cloud is the slowest recovery method because you must recover from the cloud over a network connection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      302,
      303,
      299,
      301
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 237,
    "question": "You need to upgrade a server and want to make a backup of the data before you begin. Which backup method should you choose so that your normal backups are not affected?",
    "choice_a": "Full",
    "choice_b": "Copy",
    "choice_c": "Incremental",
    "choice_d": "Differential",
    "correct_answer": "B",
    "explanation": "You should use the copy backup method, since it will perform a full backup of the files without resetting the archive bits. A full backup makes a full backup and resets all the archive bits affecting the normal backups. An incremental backup copies only the files that have changed since the last backup and leaves the archive bits unchanged. A differential backup backs up only the files that have changed since the last backup and then resets all the archive bits.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      301,
      289,
      302,
      303,
      300
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 238,
    "question": "What is the primary benefit of having a knowledge base in an IT environment?",
    "choice_a": "Reduces the number of help desk staff needed",
    "choice_b": "Ensures compliance with company policies",
    "choice_c": "Provides a quick reference for resolving common issues",
    "choice_d": "Improves employee morale",
    "correct_answer": "C",
    "explanation": "Providing a quick reference for resolving common issues helps both users and technicians solve problems more efficiently. Creating a knowledge base rarely ever reduces help desk staff. Knowledge bases do not ensure compliance. Although knowledge bases are great tools, they do not improve morale.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      304,
      310,
      283,
      288
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 239,
    "question": "You promised a customer that you would be out to service their problem before the end of the day but have been tied up at another site. As it now becomes apparent that you will not be able to make it, what should you do? (Choose the best answer.)",
    "choice_a": "Arrive first thing in the morning.",
    "choice_b": "Wait until after hours and then leave a message that you were there.",
    "choice_c": "Call the customer and inform them of the situation.",
    "choice_d": "Email the customer to let them know that you will be late.",
    "correct_answer": "C",
    "explanation": "Calling the customer and informing them of the situation is the best action that can be performed, since you are having direct communications. Arriving first thing in the morning should be done, but communication is the first action. Waiting until after hours and then leaving a message is not an appropriate action. Sending an email letting the customer know that you will be late is lying, since you will not make it to their site.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      304,
      309,
      310,
      308,
      311
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 240,
    "question": "A user reports that a workstation has two significant problems that do not seem related. How should you approach these problems?",
    "choice_a": "Look for what the two problems would have in common.",
    "choice_b": "Assume that a virus is involved.",
    "choice_c": "Deal with each issue separately.",
    "choice_d": "Order a new machine.",
    "correct_answer": "C",
    "explanation": "If the problems do not appear to be related, then deal with them separately. Looking for commonalities between the problems would just waste valuable time. No assumptions should be made, such as that a virus is causing the problem, unless there is proof. Ordering a new machine is disruptive to the customer, unless the problem dictates that this action be performed.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      306,
      280,
      290,
      293,
      288
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 241,
    "question": "A customer is trying to explain a problem with their system. Unfortunately, the customer has such a thick accent that you are unable to understand their problem. What should you do? (Choose the best answer.)",
    "choice_a": "Just start working on the system and look for obvious errors.",
    "choice_b": "Call your supervisor.",
    "choice_c": "Ask that another technician be sent in your place.",
    "choice_d": "Apologize and find another user or manager who can help you translate.",
    "correct_answer": "D",
    "explanation": "If you do not understand the customer, you should apologize, treat the customer with respect, and seek a manager to help translate. Ignoring the customer and starting to work on the system is not an appropriate response. Calling your supervisor will not solve the problem, since your supervisor will have the same issue. Asking that another technician be sent in your place is being insensitive to the customer and \u201cpassing the buck.\u201d.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      313,
      304,
      311,
      307,
      310
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 242,
    "question": "You have been trying to troubleshoot a user\u2019s system all day when it suddenly becomes clear that the data is irretrievably lost. When you inform the customer, they become so angry that they shove you against a wall. What should you do?",
    "choice_a": "Shove the user back, only a little harder than they shoved you.",
    "choice_b": "Shove the user back, only a little easier than they shoved you.",
    "choice_c": "Try to calm the user down.",
    "choice_d": "Yell for everyone in the area to come quickly.",
    "correct_answer": "C",
    "explanation": "You should avoid confrontations with the user by attempting to calm them down. You should never shove the user back. Yelling for everyone in the area to come quickly will escalate the situation, which is the opposite of what you want to do.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      311,
      281,
      312,
      288,
      279
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 243,
    "question": "A customer tells you that a technician from your company spent three hours on the phone making personal calls. What should you do with this information?",
    "choice_a": "Nothing.",
    "choice_b": "Inform your manager.",
    "choice_c": "Talk to the technician personally.",
    "choice_d": "Ask the customer to prove it.",
    "correct_answer": "B",
    "explanation": "You should take appropriate action and inform your manager, as well as notify the customer that you\u2019ve done so. Doing nothing is not an appropriate response to this situation. Talking to the technician personally will create a confrontation and should be avoided. Asking the customer to prove it is an inappropriate action to this problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      310,
      311,
      304,
      313,
      309
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 244,
    "question": "You arrive at the site of a failed server to find the vice president nervously pacing and worrying about lost data. What should you do?",
    "choice_a": "Offer a joke to lighten things up.",
    "choice_b": "Downplay the situation and tell him that customers lose data every day.",
    "choice_c": "Keep your head down and keep looking at manuals to let him know that you are serious.",
    "choice_d": "Inform him that you\u2019ve dealt with similar situations and will let him know what needs to be done as soon as possible.",
    "correct_answer": "D",
    "explanation": "You should assure the vice president that you are optimistic and skilled to deal with these problems. Offering a joke is an inappropriate action. Downplaying the situation does not show respect to the customer\u2019s problem. Keeping your head down and ignoring the customer does not display appropriate communications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      311,
      310,
      313,
      309,
      306
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 245,
    "question": "You are temporarily filling in on phone support when a caller tells you that they are sick and tired of being bounced from one hold queue to another. They want their problem fixed, and they want it fixed now. What should you do?",
    "choice_a": "Inform them up front that you are only filling in temporarily and won\u2019t be of much help.",
    "choice_b": "Transfer them to another technician who handles phone calls more often.",
    "choice_c": "Try to solve their problem without putting them on hold or transferring them elsewhere.",
    "choice_d": "Suggest that they call back at another time when you are not there.",
    "correct_answer": "C",
    "explanation": "You should try to solve the customer\u2019s problem without further escalating the frustration by putting them on hold or transferring them. Informing them that you won\u2019t be able to help is only going to anger the caller, further validating their frustration. Transferring them to another technician is not the appropriate action, because it will add to their frustration. Suggesting that they call back will create more frustration and is poor customer service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      308,
      304,
      310,
      306,
      313
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 246,
    "question": "At the end of the day, you finish a job only to find that the user you were doing it for had to leave. What should you do? (Choose two.)",
    "choice_a": "Clean up and leave no evidence that you were there.",
    "choice_b": "Leave a note for the user detailing what was done and how to contact you.",
    "choice_c": "Notify the user\u2019s manager and your own manager that you have finished.",
    "choice_d": "Put the system back to its original state.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Leaving a note for the user detailing what was done and how to contact you displays appropriate communications. Notifying the user\u2019s manager and your own manager that the problem is resolved is also appropriate communications. Cleaning up and leaving no evidence that you were there is an inappropriate action, as it is deceiving to the user. Putting the system back to its original state is an inappropriate action because it does not solve the problem.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      304,
      282,
      288,
      307,
      312
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 247,
    "question": "A user on the phone does not seem to be able to explain their problem to you without using profanity. That profanity is making you unable to understand their problem. What should you do? (Choose the best answer.)",
    "choice_a": "Ask the user to refrain from the offensive language.",
    "choice_b": "Overlook the profanity.",
    "choice_c": "Hang up.",
    "choice_d": "Show them that you know just as many expletives as they do.",
    "correct_answer": "A",
    "explanation": "While the user\u2019s profanity is likely linked to frustration, it hinders the communication and should be eliminated. You should ask the user to refrain from the offensive language. There may be circumstances where it is necessary to overlook the profanity, if your request is likely to make the already upset customer even angrier, as long as you can understand what is being said. Hanging up is not an appropriate action and will further the user\u2019s frustration. Firing back with profanity is not an appropriate response, as it will escalate the situation further.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      308,
      304,
      311,
      313,
      310
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 248,
    "question": "Which of the following is not a benefit of implementing asset tags for inventory management?",
    "choice_a": "Tracking of the equipment",
    "choice_b": "Scheduling the depreciation of the equipment",
    "choice_c": "Identifying assets",
    "choice_d": "Providing ownership of the equipment",
    "correct_answer": "B",
    "explanation": "Scheduling of the depreciation of the equipment is performed in accounting software. Tracking of the equipment is a benefit to an asset tag. Identifying assets is a direct benefit of asset tags. An asset tag provides a proof of ownership.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      291,
      285,
      282
    ],
    "source": "330034_Vol2_Ch10"
  },
  {
    "id": 249,
    "question": "Which term is used to describe an operating system that is preinstalled on a computer?",
    "choice_a": "Retail",
    "choice_b": "OEM",
    "choice_c": "Market",
    "choice_d": "Desktop",
    "correct_answer": "B",
    "explanation": "Original equipment manufacturer (OEM) is the term used to describe the operating system that comes preinstalled on a computer. Retail operating systems are operating systems that are purchased through a retailer. Market is not a term used describe operating systems. Desktop is a type of operating system, but not a term to describe how it is packaged.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      5,
      18,
      1,
      6,
      26
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 250,
    "question": "What is the purpose of the TPM in Windows 11?",
    "choice_a": "To enhance graphics performance",
    "choice_b": "To provide additional storage",
    "choice_c": "To ensure security and encryption",
    "choice_d": "To manage network settings",
    "correct_answer": "C",
    "explanation": "The Trusted Platform Module (TPM) is used for security and encryption purposes. The TPM does not enhance graphics performance. The TPM does not provide additional storage. The TPM does not manage network settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      44,
      19,
      21,
      8,
      96
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 251,
    "question": "Which editions of Windows 11 include BitLocker feature?",
    "choice_a": "Pro edition only",
    "choice_b": "All, except Home edition",
    "choice_c": "Home, Pro, and Enterprise editions",
    "choice_d": "Pro for Workstations only",
    "correct_answer": "B",
    "explanation": "The BitLocker feature is available on all editions, except for Home edition. Although Pro edition supports the BitLocker feature, it is not the only edition. Home does not support the BitLocker feature, therefore the answers of Home, Pro and Enterprise editions are wrong. The BitLocker feature is supported in the Pro for Workstations, as well as all other editions except for Home edition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      21,
      19,
      5,
      55
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 252,
    "question": "You need to install 4 physical CPUs; which Windows 10 edition should you plan to install?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": "C",
    "explanation": "The Windows Pro for Workstations edition supports up to 6 TBs of RAM and up to 4 CPUs. Home edition supports only 128 GB of RAM and 2 CPUs. Pro edition supports 2 TB of RAM and 2 CPUs. Enterprise edition supports 6 TB of RAM and 2 CPUs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      8,
      2,
      9,
      44
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 253,
    "question": "Your organization wants to implement a cloud-based email system that integrates with other productivity tools. Which tool would be most suitable?",
    "choice_a": "OneDrive",
    "choice_b": "Exchange Online",
    "choice_c": "iCloud",
    "choice_d": "Outlook",
    "correct_answer": "B",
    "explanation": "Exchange Online is a Microsoft 365 cloud-based email system that allows the creation, delivery, and sending of email. OneDrive is a cloud-based file synchronization tool that copies your files to the cloud. iCloud is Apple\u2019s version of OneDrive used exclusively with iOS and macOS. Outlook is the client that connects to the Exchange email service, or any email service that supports standard protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      16,
      49,
      17,
      12
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 254,
    "question": "You need to schedule a virtual meeting with your team members. Which cloud-based tool would you use to conduct the meeting?",
    "choice_a": "Outlook",
    "choice_b": "Exchange Online",
    "choice_c": "Google Slides",
    "choice_d": "Teams",
    "correct_answer": "D",
    "explanation": "Microsoft Teams is an instant messaging and cloud-based virtual meeting tool. Outlook is the client that connects to the Exchange email service, or any email service that supports standard protocols. Exchange Online is a Microsoft 365 cloud-based email system that allows the creation, delivery, and sending of email. Google Slides allows multiple users to collaborate on a presentation in real time, making it ideal for remote collaboration.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      16,
      15,
      83,
      84,
      20
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 255,
    "question": "You need to verify network connectivity for a host. Which tool should you use?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>net use</code>",
    "choice_c": "<code>sfc</code>",
    "choice_d": "<code>gpupdate</code>",
    "correct_answer": "A",
    "explanation": "The <code>ping</code> command is used to verify basic network connectivity to hosts, by sending a packet to the destination host in which it responds. The <code>net use</code> command is used to map network drives. The <code>sfc</code> command is used to scan the filesystem for corrupted system files. The <code>gpupdate</code> utility is used to update Group Policy settings.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      58,
      59,
      106,
      62,
      69
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 256,
    "question": "You believe that there are corrupted clusters on your disk. Which tool should you use?",
    "choice_a": "Disk Management",
    "choice_b": "<code>sfc</code>",
    "choice_c": "<code>chkdsk</code>",
    "choice_d": "<code>diskpart</code>",
    "correct_answer": "C",
    "explanation": "The <code>chkdsk</code> tool is used to check the disk and repair any bad clusters, if possible. The Disk Management console is used to manage disks. The System File Checker (<code>sfc</code>) is used to scan for corrupt operating system files. <code>diskpart</code> is a command-line version of the Disk Management console.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      28,
      40,
      42,
      60
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 257,
    "question": "You believe that your system files are corrupted in Windows. You run the System File Checker. Which command should you run in order to make the System File Checker automatically repair your system files?",
    "choice_a": "<code>sfc /recover</code>",
    "choice_b": "<code>sfc /repair</code>",
    "choice_c": "<code>sfc /verifyfile</code>",
    "choice_d": "<code>sfc /scannow</code>",
    "correct_answer": "D",
    "explanation": "The System File Checker (<code>sfc</code>) will scan for and fix missing or corrupted operating systems files. The command used to initiate an immediate scan is <code>sfc /scannow</code>. <code>SFC /recover</code> and <code>sfc /repair</code> are not valid options. <code>sfc /verifyfile</code> will check a single file, but the path must be specified.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      60,
      62,
      51,
      1,
      56
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 258,
    "question": "Which of the following switches can be used with <code>robocopy</code> to mirror a complete directory tree?",
    "choice_a": "<code>/s</code>",
    "choice_b": "<code>/mir</code>",
    "choice_c": "<code>/cdt</code>",
    "choice_d": "<code>/ah</code>",
    "correct_answer": "B",
    "explanation": "The <code>robocopy</code> command used with the <code>/mir</code> switch will mirror a directory tree file structure. The <code>/s</code> switch can be used to copy subdirectories, but not empty ones. The <code>/cdt</code> switch and the <code>/ah</code> switch are not valid for <code>robocopy</code>.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      57,
      56,
      25,
      63,
      105
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 259,
    "question": "A user needs to access a shared printer on the network. Which command can you use to connect to the printer?",
    "choice_a": "<code>net use</code>",
    "choice_b": "<code>net user</code>",
    "choice_c": "<code>netstat</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "A",
    "explanation": "The <code>net use</code> command maps network resources, including printers, to local ports. The <code>net user</code> command manages user accounts. The <code>netstat</code> command shows network connections. The <code>nslookup</code> command resolves DNS names.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      68,
      58,
      66,
      62
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 260,
    "question": "A user needs to check if their computer\u2019s hardware is compatible with Windows 11. Which tool should they use to provide comprehensive list?",
    "choice_a": "System Information (<code>msinfo32</code>)",
    "choice_b": "Device Manager",
    "choice_c": "Task Manager",
    "choice_d": "Windows Update",
    "correct_answer": "A",
    "explanation": "The System Information tool (<code>msinfo32</code>) provides detailed information about the computer\u2019s hardware, which can be used to check compatibility with Windows 11 requirements. Device Manager manages hardware devices but does not provide a comprehensive compatibility check. Task Manager monitors system performance and processes but does not provide hardware compatibility information. Windows Update manages updates but does not check hardware compatibility.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      44,
      62,
      8,
      19,
      28
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 261,
    "question": "You are logged on as root to a Linux workstation, how can you check to see if an account exists on the workstation?",
    "choice_a": "<code>ls ~</code>",
    "choice_b": "<code>cat /etc/passwd</code>",
    "choice_c": "<code>pwd</code>",
    "choice_d": "<code>dd</code>",
    "correct_answer": "B",
    "explanation": "The <code>/etc/passwd</code> file contains all of the user information for accounts on a Linux workstation. You can view it by using the cat command. The <code>ls ~</code> command will list all of the files in the current user\u2019s home directory. <code>pwd</code> will display the current working directory. <code>dd</code> is used for copying block-level data and is also used to copy data from devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      98,
      105,
      99,
      62
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 262,
    "question": "You need to copy all of the files from the parent directory into the current directory on a Linux workstation; which command will achieve this?",
    "choice_a": "<code>dd *.*</code>",
    "choice_b": "<code>copy ..\\* .</code>",
    "choice_c": "<code>cp . ..\\*</code>",
    "choice_d": "<code>cp ..\\* .</code>",
    "correct_answer": "D",
    "explanation": "The command of <code>cp ..\\* .</code> will copy all files from the parent directory to the current directory. The <code>dd</code> command is used for copying block level data and not files. The <code>copy</code> command is a Windows utility. The command <code>cp . ..\\*</code> will not copy anything.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      104,
      98,
      57,
      63
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 263,
    "question": "Which file type on macOS can perform an automated install, in which the user is asked questions?",
    "choice_a": "DMG",
    "choice_b": "ZIP",
    "choice_c": "PKG",
    "choice_d": "ISO",
    "correct_answer": "C",
    "explanation": "The PKG file type is typically used by macOS to provide a guided installation for the end user. The DMG file type is similar to ZIP and ISO. The file types will mount to the Desktop and the user will copy the application into the Applications folder.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      75,
      76,
      87,
      11,
      12
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 264,
    "question": "You are tasked with creating a backup of your macOS system. Which tool should you use?",
    "choice_a": "Disk Utility",
    "choice_b": "Keychain",
    "choice_c": "Time Machine",
    "choice_d": "Finder",
    "correct_answer": "C",
    "explanation": "Time Machine is the macOS feature specifically designed for creating backups. Disk Utility is used for managing disks. Keychain is for password management. Finder is for file management on macOS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      91,
      92,
      77,
      85
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 265,
    "question": "A user reports that their macOS application is unresponsive. What feature should you use to close the application?",
    "choice_a": "Spotlight",
    "choice_b": "Mission Control",
    "choice_c": "Force Quit",
    "choice_d": "System Settings",
    "correct_answer": "C",
    "explanation": "Force Quit is the feature used to close unresponsive applications on macOS. Spotlight is for searching on macOS. Mission Control is for managing desktops and seeing all the running apps. System Settings is used for adjusting the system preferences.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      84,
      87,
      76,
      7
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 266,
    "question": "You need to change the permissions of a file in Linux to make it readable and writable by the owner, but only readable by others. Which command should you use?",
    "choice_a": "<code>chmod 644 filename</code>",
    "choice_b": "<code>chmod 755 filename</code>",
    "choice_c": "<code>chmod 600 filename</code>",
    "choice_d": "<code>chmod 777 filename</code>",
    "correct_answer": "A",
    "explanation": "The command <code>chmod 644</code> sets the file permissions to readable and writable by the owner with the 6, and readable by the group and others with the 4. The other options set different permissions that do not match the requirement.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      104,
      98,
      107,
      105,
      99
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 267,
    "question": "Your company provides medical data to doctors from a worldwide database. Because of the sensitive nature of the data you work with, it's imperative that authentication be established on each session and be valid only for that session. Which of the following authentication methods provides credentials that are valid only during a specific period of time?",
    "choice_a": "Token",
    "choice_b": "Certificate",
    "choice_c": "Smartcard",
    "choice_d": "License",
    "correct_answer": "A",
    "explanation": "A hardware or software token creates a numeric password that is only valid for a specific amount of time, before a new one is displayed. Certificate authentication is not time limited for a session. Smartcard authentication is not time limited for a session. A license is a term used with the licensing of software and therefore an incorrect answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      183,
      169,
      125
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 268,
    "question": "A user has brought an email to your attention that is not from his bank, but looks like his bank when he clicks on the link. What is this most likely?",
    "choice_a": "Spam",
    "choice_b": "Password cracking",
    "choice_c": "Phishing",
    "choice_d": "Worm",
    "correct_answer": "C",
    "explanation": "This is most likely a phishing attack aimed at the user. Spam would not have links to a bank website for login. Password cracking is the act of trying several different passwords in an attempt to gain access. A worm is malware that replicates itself and infects other system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      139,
      141,
      137,
      147
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 269,
    "question": "Which media can store viruses and infect other systems?",
    "choice_a": "Tape",
    "choice_b": "USB thumb drive",
    "choice_c": "Optical media",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "All of these devices can store and pass viruses to uninfected systems. Backups of a system with a virus can store a virus, if the tape is restored the virus will be active again. A USB thumb drive is the most common method of transmitting a virus from one system to another. Optical media can store viruses for long periods of time and if introduced to a system, an infection can occur.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      130,
      127,
      128,
      162
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 270,
    "question": "You are setting up a new office building and need to ensure physical security. Which component should you install to prevent unauthorized vehicle access?",
    "choice_a": "Bollards",
    "choice_b": "Badge readers",
    "choice_c": "Motion sensors",
    "choice_d": "Alarm systems",
    "correct_answer": "A",
    "explanation": "Bollards are architectural structures that act as visual indicators for a perimeter and protect the area from unauthorized vehicle access. Badge readers are used to scan security ID badges, Motion sensors detect unauthorized access. Alarm systems alert security personnel in the event of unauthorized access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      108,
      109,
      116,
      111
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 271,
    "question": "During a security audit, you notice that employees are frequently leaving their workstations without locking their screens. What policy should you implement to mitigate this risk?",
    "choice_a": "Password expiration",
    "choice_b": "Screen saver lock",
    "choice_c": "Multifactor authentication",
    "choice_d": "Data encryption",
    "correct_answer": "B",
    "explanation": "Implementing a screen saver lock policy ensures that workstations automatically lock after a period of inactivity, reducing the risk of unauthorized access. Password expiration ensures passwords are changed regularly. Multifactor authentication adds an extra layer of security. Data encryption protects sensitive information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      126,
      160,
      121,
      220
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 272,
    "question": "When implementing a BYOD policy for users, what is a risk?",
    "choice_a": "Higher risk of malware attacks",
    "choice_b": "Higher risk of phishing attacks",
    "choice_c": "Lower risk of phishing attacks",
    "choice_d": "Higher risk of password attacks",
    "correct_answer": "A",
    "explanation": "When implementing a BYOD policy there is an inherit risk of malware attacks, because outside devices are entering your network. A higher risk of phishing attacks will not be seen with a BYOD implementation. A lower risk of phishing attacks is not affected with a BYOD implementation. A higher risk of password attacks is not affected by implementing a BYOD strategy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      155,
      198,
      124,
      127,
      134
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 273,
    "question": "Ian wants to manage folder access on a shared resource by using NTFS permissions exclusively. To accomplish this, which permission should he set for the Everyone group?",
    "choice_a": "Read",
    "choice_b": "Write",
    "choice_c": "Change",
    "choice_d": "Full Control",
    "correct_answer": "D",
    "explanation": "To manage the resource exclusively with NTFS permissions, he should set the share permissions on Everyone to Full Control. Setting the share permissions to read will not allow the goal of controlling the folder with NTFS permissions. Setting the share permissions to write will not allow the goal of controlling the folder with NTFS permissions. Setting the share permissions to change will not allow the goal of controlling the folder with NTFS permissions.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      171,
      200,
      119,
      126,
      167
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 274,
    "question": "Which protocol is use with Active Directory to authenticate a user and provide the network access token?",
    "choice_a": "SSO",
    "choice_b": "Kerberos",
    "choice_c": "LDAP",
    "choice_d": "EFS",
    "correct_answer": "B",
    "explanation": "Kerberos is the protocol used to authenticate a user with Active Directory and provide the network access token. Single Sign-On (SSO) is used in conjunction with Active Directory for claims-based authentication. Lightweight Directory Access Protocol (LDAP) is used to look up objects in Active Directory. Encrypted File System (EFS) is used to encrypt files on NTFS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      168,
      125,
      169,
      122,
      120
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 275,
    "question": "A user is in the Sales and Marketing group; the Sales group has full permission at the share level and the Marketing group is denied full control permissions. The files on NTFS are security with modify for the Sales group and read and execute for the Marketing group. What permissions will the user have accessing it remotely?",
    "choice_a": "Full control",
    "choice_b": "Read-only",
    "choice_c": "Modify",
    "choice_d": "Access denied",
    "correct_answer": "D",
    "explanation": "The user will be denied access, because the marketing group is denied full control permission on the share permission level. The user will not have full control, because they are denied full control permission. The user will not have read-only access because read-only is part of full control and the user is denied. The user will not have modify access because modify is part of full control and the user is denied.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      171,
      200,
      126,
      168,
      119
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 276,
    "question": "What should be installed on a mobile device to control data being uploaded from applications?",
    "choice_a": "Antivirus",
    "choice_b": "Antimalware",
    "choice_c": "Firewall",
    "choice_d": "Phishing protection",
    "correct_answer": "C",
    "explanation": "A firewall can be installed on a mobile device to control data being uploaded from applications and communications directed to the device. Antivirus will not normally protect network traffic leaving a device. Antimalware will not normally protect network traffic leaving a device. Phishing protection will not prevent and control data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      195,
      232,
      124,
      173,
      194
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 277,
    "question": "You want to harden your operating system and follow best practices. Which account should be disabled on Windows operating systems for security reasons?",
    "choice_a": "Guest",
    "choice_b": "Print Operators",
    "choice_c": "Power Users",
    "choice_d": "Userone",
    "correct_answer": "A",
    "explanation": "The Guest account should be disabled on the operating system, unless there is good reason to leave the account enabled. Print Operators is a group found on Windows servers that allows management of print jobs. Power Users is a group found on both Windows workstations and servers and it has the permissions of a standard user. Userone is obviously a user account. Unless the user has left the organization, there should be no reason to disable the account.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      167,
      160,
      117,
      170,
      126
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 278,
    "question": "What kind of mobile app is being used when the owner's phone displays a message on the screen and emits an extremely loud tone?",
    "choice_a": "Failed login restriction",
    "choice_b": "Antivirus",
    "choice_c": "Locator",
    "choice_d": "Remote wipe",
    "correct_answer": "C",
    "explanation": "Locator apps can find the phone and then display a message that can be read even while the phone is locked. Locator apps also often give the user the option to make the phone blare a noise to aid in finding the device. Failed login restrictions will wipe a device if a specific number of wrong passwords are entered. Antivirus apps make sure that your phone does not get a virus, but they offer no way to message or locate the device. Remotely wiping a mobile device is a feature of locator apps, but it is not itself an app that displays messages and produces noises.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      196,
      193,
      124,
      134,
      229
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 279,
    "question": "Which critical system can be affected directly if there is high RAM usage?",
    "choice_a": "Network",
    "choice_b": "CPU",
    "choice_c": "Disk",
    "choice_d": "Graphics",
    "correct_answer": "C",
    "explanation": "Disk can be affected by high RAM usage because the operating system will try to free pages in memory by swapping pages (paging) to disk. This can cause a high utilization on the disk system in the computer. The network will not be impacted by RAM usage. The CPU will not be directly affected from high RAM usage. The graphics adapter will not be impacted by high RAM usage.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      201,
      207,
      223,
      204,
      216
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 280,
    "question": "You have just identified a piece of malware on an operating system. What is the next step?",
    "choice_a": "Remediate the infected system.",
    "choice_b": "Quarantine the infected system.",
    "choice_c": "Schedule a scan of the infected system.",
    "choice_d": "Educate the end user.",
    "correct_answer": "B",
    "explanation": "As soon as malware is identified, it should be quarantined and isolated from the production network. Remediating the infected system happens after you disable System Protection (System Restore). Scheduling a scan happens after you remediate the infected system. Education of the end user is the last step.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      138,
      209,
      134,
      211
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 281,
    "question": "A user has reported that their Excel spreadsheet is hung, what is the most appropriate action?",
    "choice_a": "Reboot the operating system.",
    "choice_b": "Press Windows key+Shift+Ctrl+B.",
    "choice_c": "Use Task Manager to kill the process.",
    "choice_d": "Use System Protection to view activity.",
    "correct_answer": "C",
    "explanation": "Using the Task Manager to kill the process is the most appropriate action if the application is not responding. Rebooting the operating system is a bit aggressive as the user will need to save all their work. Pressing Windows key+Shift+Ctrl+B will send a wake signal to the display. System Protection is used to manage System Restore points.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      201,
      204,
      208,
      221,
      223
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 282,
    "question": "Which of the following components is the last step in the boot process, where the control is handed over to the operating system?",
    "choice_a": "BCD",
    "choice_b": "<code>NTOSKRNL.EXE</code>",
    "choice_c": "<code>WINLOAD.EFI</code>",
    "choice_d": "<code>WINRESUME.EXE</code>",
    "correct_answer": "B",
    "explanation": "<code>NTOSKRNL.EXE</code> is the Windows kernel, when it is loaded the boot process is handed over to the operating system. The Boot Configuration Data (BCD) is used to direct Windows to boot the proper installation. The <code>WINLOAD.EFI</code> component is used for the normal booting of the Windows operating system and it loads the <code>NTOSKRNL.EXE</code>. The component of <code>WINRESUME.EXE</code> is used to load Windows from a suspended state.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      202,
      203,
      201,
      204,
      216
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 283,
    "question": "High RAM usage will mimic the symptoms of which other critical system?",
    "choice_a": "CPU",
    "choice_b": "Disk",
    "choice_c": "Network",
    "choice_d": "Graphics",
    "correct_answer": "A",
    "explanation": "High RAM usage will mimic the symptoms of high CPU usage because applications will be slow in responsiveness. High RAM usage will not mimic the symptoms of disk problem, background tasks will still be responsive. High RAM usage will not mimic the symptoms of network problems. High RAM usage will not mimic the symptoms graphics problems.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      201,
      207,
      223,
      204,
      208
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 284,
    "question": "You want to ensure that your computer receives automatic updates to Windows and other Microsoft products. Which tool will take care of this for you?",
    "choice_a": "Windows Update",
    "choice_b": "System Configuration",
    "choice_c": "System Protection",
    "choice_d": "Task Manager",
    "correct_answer": "A",
    "explanation": "The Windows Update tool inside of the Settings app will allow you to ensure you receive automatic updates. System Configuration is used to selectively start processes and services at boot time. System Protection is responsible for management of System Restore points. Task Manager is used to manage tasks (processes) on the operating system.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      153,
      154,
      220,
      138,
      173
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 285,
    "question": "Users are reporting that when the click a link, they are sent to a website that sells sunglasses and is not relevant to their search. What is this an example of? (Choose the best answer.)",
    "choice_a": "Pop-ups",
    "choice_b": "Browser redirection",
    "choice_c": "Security alerts",
    "choice_d": "Compromised account",
    "correct_answer": "B",
    "explanation": "Browser redirection is a threat agent\u2019s method of redirecting a user to a malicious website or shopping site from a web browser. Pop-ups happen inside a browser to spam advertisements foreground of the page you are viewing. Security alerts are phony alerts that people forward and propagate false warnings. A compromised account is an account that has been taken over by a threat agent.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      214,
      211,
      209,
      176,
      139
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 286,
    "question": "You are trying to remove malware in Windows 11, but Windows Defender Antivirus will not remove the stubborn malware. What can be done to remove the malware? (Choose the best answer.)",
    "choice_a": "Use Computer Management to start the Windows Defender Antivirus service.",
    "choice_b": "Run Windows Defender Antivirus in an offline scan.",
    "choice_c": "Reboot into the Windows Recovery Environment.",
    "choice_d": "Reboot into the Windows Preinstallation Environment.",
    "correct_answer": "B",
    "explanation": "You should run Windows Defender Antivirus in an offline scan. This type of scan will start Windows in a Preinstallation Environment and start a scan with Windows Defender Antivirus. The Services and Applications snap-in inside of Computer Management will not allow tampering with Windows Defender Antivirus. Rebooting into the Windows Recovery Environment will not allow you to perform an antivirus scan. Rebooting into the Windows Preinstallation Environment will not allow you to perform an antivirus scan.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      217,
      220,
      134,
      138
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 287,
    "question": "If a device is not responding, what is the first thing you should try?",
    "choice_a": "Soft reset",
    "choice_b": "Hard reset",
    "choice_c": "Factory reset",
    "choice_d": "USB debugging",
    "correct_answer": "B",
    "explanation": "If a device is not responding and is frozen, then a hard reset should be performed. A soft reset will not work if the device is not responding and is frozen. A factory reset will remove all of your data. USB debugging in not turned on by default and will not help you with a nonresponsive device.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      223,
      221,
      222,
      224,
      225
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 288,
    "question": "Which of these would not typically cause an intermittent wireless issue?",
    "choice_a": "Bluetooth devices",
    "choice_b": "Microwaves ovens",
    "choice_c": "WAPs",
    "choice_d": "Radar",
    "correct_answer": "C",
    "explanation": "Wireless access points (WAPs) would not typically cause an intermittent wireless issue. By adding more WAPs it generally reduces connectivity problems. Microwave ovens and Bluetooth devices operate in the 2.4 GHz band and can affect 2.4 GHz wireless. Radar operates in the 5 GHz band and can affect the 5 GHz wireless devices.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      181,
      185,
      209,
      144,
      182
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 289,
    "question": "A user reports that their mobile device is not connecting to the Internet via mobile data. What should you check first?",
    "choice_a": "Mobile data settings",
    "choice_b": "Screen resolution settings",
    "choice_c": "Bluetooth settings",
    "choice_d": "Battery level",
    "correct_answer": "A",
    "explanation": "Checking the mobile data settings is the first step because incorrect settings can prevent Internet connectivity via mobile data. Screen resolution settings would not affect Internet connectivity. Bluetooth settings would affect devices connected to the mobile device. Battery level is unrelated to mobile data connectivity.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      226,
      231,
      221,
      223,
      225
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 290,
    "question": "A user reports that their mobile device screen does not autorotate. What should you check first?",
    "choice_a": "Screen resolution",
    "choice_b": "Display driver",
    "choice_c": "Autorotate lock",
    "choice_d": "Bluetooth settings",
    "correct_answer": "C",
    "explanation": "Checking the autorotate lock is the first step because it is a common cause of this issue. Screen resolution settings are typically not a setting for a mobile device. Display drivers are less likely to be the cause because they are specific to the mobile operating system. Mobile devices don\u2019t typically have BIOS settings that can be manipulated.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      227,
      221,
      223,
      226,
      225
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 291,
    "question": "Which statement will load a Windows Batch script variable of <code>yvar</code> with a value of <code>4</code>?",
    "choice_a": "<code>$yvar = 4</code>",
    "choice_b": "<code>yvar = 4</code>",
    "choice_c": "<code>yvar = 4;</code>",
    "choice_d": "<code>set /a yvar=4</code>",
    "correct_answer": "D",
    "explanation": "The statement <code>set /a yvar=4</code> is Windows Batch script syntax and will load a variable of <code>yvar</code> with <code>4</code>. The statement <code>$yvar = 4</code> is a PowerShell syntax. The statement <code>yvar = 4</code> is Bash syntax. The statement <code>yvar = 4;</code> is JavaScript syntax to load a variable <code>yvar</code> with a value of <code>4</code>.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      234,
      237,
      238,
      235
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 292,
    "question": "Which command will allow a PowerShell scripts to be run?",
    "choice_a": "<code>set-executionpolicy default</code>",
    "choice_b": "<code>set-executionpolicy unrestricted</code>",
    "choice_c": "<code>get-executionpolicy unrestricted</code>",
    "choice_d": "<code>get-executionpolicy default</code>",
    "correct_answer": "B",
    "explanation": "The command <code>set-executionpolicyunrestricted</code> will allow PowerShell commands to be unrestricted from running. The command <code>set-executionpolicy default</code> will set the restriction policy back to default and PowerShell scripts will be restricted from running. Both <code>get-executionpolicy unrestricted </code>and <code>get-executionpolicy default </code>are not valid commands because they get information from the operating system as to the current execution policy.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      236,
      235,
      238,
      234,
      237
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 293,
    "question": "Which key sequence will stop a Windows Batch script from processing?",
    "choice_a": "Ctrl+C",
    "choice_b": "Ctrl+X",
    "choice_c": "SysRq key",
    "choice_d": "Ctrl+V",
    "correct_answer": "A",
    "explanation": "The Ctrl+C key sequence will send a break to the execution of the Batch script. The Ctrl+X command is used to cut to the Clipboard. The SysRq key is a legacy key intended for the Linux operating system. The Ctrl+V key is used to paste from the Clipboard.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      236,
      235,
      238,
      234,
      243
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 294,
    "question": "What level is assembly language considered?",
    "choice_a": "High-level",
    "choice_b": "Mid-level",
    "choice_c": "Intermediate level",
    "choice_d": "Low-level",
    "correct_answer": "D",
    "explanation": "Low-level languages are machine language and assembly language, which are not scripting languages. Scripting languages are considered high-level languages because they do not directly access hardware and use an intermediary called the interpreter. Mid-level languages are Java and C/C++, not scripting languages. There is no such thing as intermediate-level languages.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      233,
      237,
      236,
      234,
      238
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 295,
    "question": "Which network protocol and port does SSH operate on?",
    "choice_a": "TCP port 3389",
    "choice_b": "TCP port 22",
    "choice_c": "TCP port 5900",
    "choice_d": "TCP port 443",
    "correct_answer": "B",
    "explanation": "The SSH protocol operates on TCP port 22. The Remote Desktop Protocol operates on TCP port 3389. The VNC protocol operates on TCP port 5900 and HTTPS operates on TCP port 443.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      239,
      244,
      245,
      240
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 296,
    "question": "Which is not a feature of Quick Assist?",
    "choice_a": "Works behind routers and firewalls",
    "choice_b": "Chat tool",
    "choice_c": "Annotations",
    "choice_d": "File transfer tool",
    "correct_answer": "D",
    "explanation": "The Quick Assist utility does not contain a method to transfer files between the assistant and the end user. The Quick Assist utility will work from behind a router or firewall. The Quick Assist utility also includes and annotation tool and chat tool, so you can communicate with the end-user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      243,
      298,
      288,
      282,
      276
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 297,
    "question": "Which remote access technology is used for encrypted console-based access?",
    "choice_a": "Quick Assist",
    "choice_b": "RDP",
    "choice_c": "VNC",
    "choice_d": "SSH",
    "correct_answer": "D",
    "explanation": "The Secure Shell utility is used for secure console-based remote access. The Microsoft Quick Assist tool is used for screen sharing. The Remote Desktop Protocol is a protocol used for Remote Desktop connections. Virtual Network Computing (VNC) is a remote-control tool for the sharing of desktops.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      239,
      244,
      243,
      245
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 298,
    "question": "Which type of learning model is based on a sequence of decisions to achieve a desirable outcome?",
    "choice_a": "Supervised learning",
    "choice_b": "Unsupervised learning",
    "choice_c": "Reinforcement learning",
    "choice_d": "Deep learning",
    "correct_answer": "C",
    "explanation": "Reinforcement learning is based on a sequence of decisions to achieve a desirable outcome. Supervised learning involves training on labeled data. Unsupervised learning involves finding hidden patterns in data. Deep learning is a subset of machine learning that uses neural networks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      246,
      249,
      250,
      247,
      253
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 299,
    "question": "You need to investigate how to protect health information on your network; what should you search?",
    "choice_a": "PCI DSS",
    "choice_b": "GDPR",
    "choice_c": "PHI",
    "choice_d": "PII",
    "correct_answer": "C",
    "explanation": "Protected health information (PHI) is any data that defines a patient or aliment of a patient. Payment Card Industry Data Security Standard (PCI DSS) standards define how payment card data should be secured. The General Data Protection Regulation (GDPR) is used for protecting EU citizens. Personally identifiable information (PII) is any information that can be used to identify a person.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      275,
      312,
      277,
      273,
      303
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 300,
    "question": "What is the single best thing that you can do to protect your company from prohibited content?",
    "choice_a": "Disable the Internet connection.",
    "choice_b": "Utilize the computer manufacturer\u2019s MSDS.",
    "choice_c": "Create an NDA policy.",
    "choice_d": "Install security cameras to monitor employee computer usage.",
    "correct_answer": "C",
    "explanation": "The most important thing that you can do is to create a nondisclosure policy. The policy should clearly define what is and what is not allowed, and it should stipulate the penalties for violating the policy. If you disabled the Internet connection, users could still bring prohibited content in on flash drives or discs. The MSDS sheets will not protect you from prohibited content. Installing security cameras to monitor employee computer usage, will not protect you from prohibited content because the content could be audible.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      270,
      276,
      287,
      254,
      273
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 301,
    "question": "Which class of fire extinguisher is recommended for use with flammable liquids?",
    "choice_a": "A",
    "choice_b": "B",
    "choice_c": "C",
    "choice_d": "D",
    "correct_answer": "B",
    "explanation": "Class B fire extinguishers are used for flammable liquids. Wood and paper fires can be put out by a class A fire extinguisher. Class C fire extinguishers are used for electrical files. Class D fire extinguishers are used for flammable metals.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      265,
      264,
      257,
      267
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 302,
    "question": "Which component inside of a power supply can hold a lethal charge well after it is powered off?",
    "choice_a": "Resistor",
    "choice_b": "Capacitor",
    "choice_c": "Conductors",
    "choice_d": "Transformer",
    "correct_answer": "B",
    "explanation": "The capacitor inside of the power supply can hold a lethal charge well after it is powered off and unplugged. Resistors do not hold charges; they are used to resist current. Conductors do not store a charge, but they do conduct electricity. Transformers also do not store charges, but they can amplify a charge.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      267,
      258,
      259,
      278
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 303,
    "question": "Which tool is used when making a block-level copy of evidence?",
    "choice_a": "Memory dump",
    "choice_b": "Swap file/paging file",
    "choice_c": "Write-blocker",
    "choice_d": "Removable media",
    "correct_answer": "C",
    "explanation": "A write-blocker is a tool used to make block-level copies of evidence; it prohibits writing back to the original source copy. A memory dump is valuable for forensic investigations, but it is not a block level copy. A swap file/paging file contains the partial RAM contents that have been written out and it may be block-level copied from the original media, but it is not a tool. Removable media is media that can be temporally mounted to the operating system compromised to save data, but it is not normally used to block-level copy evidence.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      262,
      300,
      303
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 304,
    "question": "Which type of license permits the end user to see the code of the application?",
    "choice_a": "Shareware",
    "choice_b": "Freeware",
    "choice_c": "Perpetual",
    "choice_d": "Open source",
    "correct_answer": "D",
    "explanation": "An open source license allows the end user to see the code of the application, because the source code is open to all. Shareware is a license that allows for a free trial of the software, but it does not imply you can see the source code. Freeware allows for free use of the applications, but it does not imply you can see the source code. A perpetual license is simply a license that does not expire.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      244,
      276,
      284,
      279
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 305,
    "question": "What should you do before opening a computer to inspect or replace parts?",
    "choice_a": "Leave it plugged in and powered on.",
    "choice_b": "Turn it off and unplug it.",
    "choice_c": "Wear safety goggles.",
    "choice_d": "Use a grounding pen.",
    "correct_answer": "B",
    "explanation": "Turning off and unplugging the computer ensures that you do not get electrocuted while working on it. Leaving it plugged in and powered on is dangerous as it can cause electric shock. Wearing safety goggles is important but not the first step. Using a grounding pen is for discharging capacitors, not for general inspection.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      258,
      257,
      262,
      278
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 306,
    "question": "What is the primary purpose of an ESD strap?",
    "choice_a": "To protect your eyes from dust",
    "choice_b": "To ground your body and prevent electrostatic discharge",
    "choice_c": "To keep your tools organized",
    "choice_d": "To measure electrical current",
    "correct_answer": "B",
    "explanation": "An ESD strap grounds your body and prevents electrostatic discharge, which can damage computer components. Protecting your eyes from dust is not its purpose. Keeping tools organized is unrelated. Measuring electrical current is done with a multimeter, not an ESD strap.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      260,
      259,
      262,
      256
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 307,
    "question": "Which backup media is the slowest for the recovery?",
    "choice_a": "Disk-to-tape",
    "choice_b": "Disk-to-disk",
    "choice_c": "Disk-to-flash",
    "choice_d": "Disk-to-cloud",
    "correct_answer": "D",
    "explanation": "Disk-to-cloud is the slowest recovery because you must recovery from the cloud over a network connection. Disk-to-disk is the fastest recovery method and backup method as well, because you are backing up from disk to another disk attached via the network. Disk-to-tape is slower because you must retention the tape and then locate the data on the tape to recovery it. Disk-to-flash is not a backup method, because of the price of flash.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      302,
      301,
      303,
      299
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 308,
    "question": "Which backup method can create a new current full backup from the files already contained on the backup media?",
    "choice_a": "Synthetic",
    "choice_b": "Copy",
    "choice_c": "Incremental",
    "choice_d": "Differential",
    "correct_answer": "A",
    "explanation": "A synthetic backup uses the latest full backup and applies each of the daily backups to create a new full backup. The backup software performs this function by using the backup media already obtained. A copy backup is similar to a full backup, except it will not rest the archive bits and requires back up from the servers. An incremental will copy only those files that have changed since the last backup and it will leave the archive bits unchanged. A differential backup will back up only the files that have changed since the last backup.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      301,
      302,
      300,
      298,
      303
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 309,
    "question": "You have a copy of the change management documentation and you are trying to locate the possible undesirable consequences of the proposed change. In which section would you find this information?",
    "choice_a": "Scope of change",
    "choice_b": "Purpose of change",
    "choice_c": "Plan for change",
    "choice_d": "Risk analysis",
    "correct_answer": "D",
    "explanation": "The risk analysis section is where you will find the possible undesirable consequences of a proposed change. The scope of change section details who will be affected. The purpose of change details why the proposed change needs to be implemented. The plan for change details how the changes will be implemented.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      294,
      292,
      295,
      289,
      291
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 310,
    "question": "You are upgrading a computer that probably needs replaced, but the customer wants the upgrade. They are now accusing you of not upgrading the computer. What is the best course of action? (Choose the best answer.)",
    "choice_a": "Remove the upgrade to prove it needs replaced.",
    "choice_b": "Leave because the customer is being disrespectful.",
    "choice_c": "State that the computer needs to be replaced and not upgraded.",
    "choice_d": "Assure the customer that the upgrade was performed and direct them to your manager.",
    "correct_answer": "D",
    "explanation": "The customer is always right in most cases and because you performed the upgrade you should assure them it has been upgraded and direct them to your manager. Removing the upgrade to confront the user is not an appropriate action. Leaving will make matters worse, because communications will end at that point. Stating the computer needs to be replaced will confront the customer and should be avoided.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      311,
      304,
      310,
      307,
      306
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 311,
    "question": "Which change management concept is typically used by developers, when they propose a significant change to a user interface?",
    "choice_a": "End-user acceptance",
    "choice_b": "Risk analysis",
    "choice_c": "Change board",
    "choice_d": "Scope of change",
    "correct_answer": "A",
    "explanation": "End-user acceptance is a process that developers use to beta-test a change that impacts the user interface of an application. The testing can be done either, self-paced or in person. Risk analysis is a process to gauge how risky the change is to existing processes. The change board is a group of people that evaluate the changes proposed. The scope of change defines who, what will be affected by the change, along with when the change will take place.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      296,
      295,
      294,
      292,
      291
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 312,
    "question": "Which information is not commonly found in the initial form for a change request?",
    "choice_a": "Reason",
    "choice_b": "Priority",
    "choice_c": "Risk analysis",
    "choice_d": "Change rollback plan",
    "correct_answer": "C",
    "explanation": "The risk analysis is typically not included in the initial request form for change submitted to the change advisory board. Any risk included in this initial form will be a narrow view from the requestor. The function of the change advisory board is to perform the risk analysis organizational wide. Reason, priority, and change rollback plan are all commonly found in the initial form for a change request.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      291,
      295,
      289,
      292,
      294
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 313,
    "question": "What is the main purpose of a rollback plan in change management?",
    "choice_a": "To document the changes made",
    "choice_b": "To provide an alternative plan",
    "choice_c": "To revert to the original state if needed",
    "choice_d": "To ensure all stakeholders are informed",
    "correct_answer": "C",
    "explanation": "Reverting to the original state if needed with a rollback plan ensures that changes can be undone if they fail. A rollback plan on documents changes required to roll back in the event of a failure during implementation. The alternate plan will provide an alternative plan. The rollback plan is not used for informing stakeholders.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      289,
      295,
      288,
      292,
      294
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 314,
    "question": "How should you handle confidential information encountered during your work?",
    "choice_a": "Share with your colleagues for advice.",
    "choice_b": "Keep it private and secure.",
    "choice_c": "Post about it on social media.",
    "choice_d": "Discuss it with the customer openly.",
    "correct_answer": "B",
    "explanation": "Keeping confidential information private and secure is correct because it ensures data protection and maintains trust. Sharing confidential information with colleagues is unprofessional. Posting confidential information on social media can get your fired, and possibly have legal ramifications. Discussing confidential information openly is a breach of confidentiality.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      312,
      275,
      252,
      254,
      287
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 315,
    "question": "Why is documenting the severity of an issue important in a ticket system?",
    "choice_a": "To prioritize resolution efforts",
    "choice_b": "To allocate resources efficiently",
    "choice_c": "To provide accurate billing",
    "choice_d": "To track employee performance",
    "correct_answer": "A",
    "explanation": "Prioritizing resolution efforts is a result of the severity level, and it helps in addressing the most critical issues first. Although the severity of an issue is important, it will not usually allocate resources. Unless your organization supports other organization and charges for priority of issues, the severity will not provide accurate billing. The severity level does not help in tracking employee performance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      280,
      281,
      285,
      291,
      310
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 316,
    "question": "You need to create a 3 TB volume on an existing disk, what must be done first to accommodate the creation of the volume?",
    "choice_a": "Initialize the disk",
    "choice_b": "Mount the disk",
    "choice_c": "Convert the disk to MBR",
    "choice_d": "Convert the disk to GPT",
    "correct_answer": "D",
    "explanation": "Since you are trying to create the volume on an existing disk, the disk in initialized already. Mounting the disk will not affect creation of a volume. The disk must be converted to a <i>GUID [globally unique identifier] Partition Table (GPT)</i> disk before you can create the volume. MBR disks cannot handle a volume over 2 TBs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      28,
      61,
      42
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 317,
    "question": "You need to implement full disk encryption for a workstation, which feature should you implement?",
    "choice_a": "Disk Management",
    "choice_b": "Device Manager",
    "choice_c": "BitLocker",
    "choice_d": "Computer Management",
    "correct_answer": "C",
    "explanation": "BitLocker is a low-level full disk encryption technology used to protect data. The Disk Management MMC allows you to manage volumes on the disk. Device Manager MMC is used to manage devices on the operating system. The Computer Management MMC is used to manage user, group, devices, disks, and many other components, but not encryption.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      21,
      28,
      78,
      40,
      29
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 318,
    "question": "Which command line tool will allow you to view the volume size?",
    "choice_a": "gpedit.msc",
    "choice_b": "perfmon.msc",
    "choice_c": "taskmgr",
    "choice_d": "diskpart",
    "correct_answer": "D",
    "explanation": "The diskpart utility will allow you to view the volume size via the command line. The Group Policy Editor (gpedit.msc) tool allows you to edit the local Group Policy for the operating system. Performance Monitor (perfmon.msc) displays performance counters. It will collect counter information and then send that information to a console or event log. The taskmgr tool is used to view processed running on the operating system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      40,
      31,
      56,
      63
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 319,
    "question": "You need to schedule a program to run every Monday at 8 AM. Which MMC snap-in would you use?",
    "choice_a": "Programs and Features",
    "choice_b": "Task Scheduler",
    "choice_c": "Disk Management",
    "choice_d": "Group Policy Editor",
    "correct_answer": "B",
    "explanation": "Task Scheduler allows you to start a program based on a condition met, such as a specific time. Programs and Features is used to manage installed programs. Disk Management is for managing disks. Group Policy Editor is for editing local Group Policy.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      40,
      43,
      27,
      12
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 320,
    "question": "Your computer has rebooted unexpectedly. Which event log should you check?",
    "choice_a": "Application",
    "choice_b": "Boot",
    "choice_c": "Security",
    "choice_d": "System",
    "correct_answer": "D",
    "explanation": "The System event log contains entries related to system events, including unexpected reboots. The Application log is for application events. The Boot log is not a valid log. The Security log contains security-related information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      51,
      93,
      1
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 321,
    "question": "You need to configure a proxy server for your network. Which section in the Settings app would you use?",
    "choice_a": "System",
    "choice_b": "Devices",
    "choice_c": "Network & Internet",
    "choice_d": "Accounts",
    "correct_answer": "C",
    "explanation": "The Network & Internet section allows you to configure network settings, including proxy servers. The System section is for system settings. Devices is for managing connected devices. Accounts is for modifying user accounts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      34,
      66,
      33,
      70
    ],
    "source": "330034_Vol2_PT1"
  },
  {
    "id": 322,
    "question": "Which edition of Windows receives normal Windows Updates for security, but not feature upgrades?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise LTSC",
    "correct_answer": "D",
    "explanation": "The Enterprise LTSC (Long-Term Servicing Channel) edition of Windows will receive normal Windows Updates for security, but it will not receive feature upgrades. Enterprise LTSC is typically supported for 10 years. All of the other editions include feature updates along with the typical Windows Updates.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      18,
      53,
      19,
      21,
      50
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 323,
    "question": "Which operating system changed the Start menu to the Start screen?",
    "choice_a": "Windows 7",
    "choice_b": "Windows 8",
    "choice_c": "Windows 10",
    "choice_d": "Linux",
    "correct_answer": "B",
    "explanation": "Windows 8 changed the Start menu to the Start screen to accommodate mobile environments. The Start screen displays the Start menu on the entire screen. The Start menu has returned in Windows 10. Windows 7 has a conventional Start menu similar to prior Windows operating system. Linux desktop Start menus differ depending on the graphical manager, but normally follow the style of Windows 7 and prior Windows operating systems.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      23,
      7,
      18,
      4
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 324,
    "question": "Which key will launch the Help and Support application?",
    "choice_a": "F1",
    "choice_b": "F2",
    "choice_c": "F10",
    "choice_d": "Ctrl+H",
    "correct_answer": "A",
    "explanation": "The F1 key is the universal help key in Microsoft operating systems and applications. When it is pressed on the desktop, it will launch the Help and Support application. The F2 key is used to rename files and folders. The F10 key activates the menu bar. Ctrl+H does nothing in the operating system.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      62,
      7,
      63,
      1,
      4
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 325,
    "question": "Which operating system do Apple laptops currently use?",
    "choice_a": "iOS",
    "choice_b": "macOS",
    "choice_c": "UNIX",
    "choice_d": "Mac OS X",
    "correct_answer": "B",
    "explanation": "Apple laptops currently use the macOS operating system. The iOS operating system is a tile-based operating system originally release for iPhone and iPads. Although the Apple operating system was originally based off of BSD/UNIX, it is considered its own operating system of macOS. Mac OS X is the prior version of macOS and it is currently not named Mac OS X anymore.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      73,
      4,
      90,
      38
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 326,
    "question": "You are working on a project from home and need to access your files stored on your office computer. Which cloud-based tool would allow you to access these files remotely?",
    "choice_a": "Exchange Online",
    "choice_b": "OneDrive",
    "choice_c": "Teams",
    "choice_d": "Outlook",
    "correct_answer": "B",
    "explanation": "Microsoft OneDrive allows you to synchronize files across multiple computers. So, your office computer will upload the documents to the cloud and then your personal computer can retrieve the file and allow for remote editing. Exchange Online is a Microsoft 365 cloud-based email system that allows the creation, delivery, and sending of email. Microsoft Teams is an instant messaging and cloud-based virtual meeting tool. Outlook is the client that connects to the Exchange email service, or any email service that supports standard protocols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      16,
      49,
      14,
      91
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 327,
    "question": "Which of the following is <i>not</i> a feature to upgrading to Windows 11 Pro edition?",
    "choice_a": "BitLocker",
    "choice_b": "Remote Desktop Protocol (RDP)",
    "choice_c": "Joining a domain",
    "choice_d": "Microsoft Defender",
    "correct_answer": "D",
    "explanation": "Microsoft Defender is a standard feature built into all Windows editions. Microsoft Home edition contains Microsoft Defender. BitLocker is a feature of upgrading to Windows 11 Pro; it is used for drive level encryption. Remote Desktop Protocol (RDP) is a feature of upgrading to Windows 11 Pro edition; it allows an administrator or privileged user to remotely connect to the operating system. Joining a domain is a feature of upgrading to Windows 11 Pro; this feature allows the ability to join a Windows Active Directory domain.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      21,
      20,
      72,
      96
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 328,
    "question": "Which of the following utilities allows you to display network statistics?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>xcopy </code>",
    "choice_d": "<code>tracert /?</code>",
    "correct_answer": "A",
    "explanation": "The <code>netstat</code> displays network statistics. The <code>ping</code> utility allows you to test basic network connectivity by sending a small message to the destination address, and the destination will respond. The <code>xcopy</code> command is basically an extension of <code>copy</code> with one notable exception\u2014it\u2019s designed to copy folders as well as files. The <code>tracert /?</code> command will display information about the <code>tracert</code> command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      59,
      63,
      56,
      57
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 329,
    "question": "Which of the following command-line utilities starts a command prompt in Windows? (Choose the best answer.)",
    "choice_a": "<code>command.com</code>",
    "choice_b": "<code>command32.com</code>",
    "choice_c": "<code>cmd.exe</code>",
    "choice_d": "<code>cmd32.exe</code>",
    "correct_answer": "C",
    "explanation": "In Windows, <code>cmd.exe</code> starts a command prompt. This can be achieved by pressing the Windows key and the R key to open a run box and then typing <code>cmd.exe</code>. <code>cmd32.exe</code> and <code>command32.com</code> are not Windows commands. <code>command.com</code> is the command interpreter for MS-DOS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      63,
      62,
      30,
      35,
      61
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 330,
    "question": "You are having trouble connecting to a server and want to make sure you are receiving the correct IP address from DNS. Which tool should you use?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>nslookup</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>ping</code>",
    "correct_answer": "B",
    "explanation": "The <code>nslookup</code> tool will allows you to verify DNS. The <code>netstat</code> tool will show you network statistics and network connections. The <code>tracert</code> tool will show you the path network traffic will take. The <code>ping</code> command will allow you to view the current IP address configured on the computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      58,
      106,
      33,
      67
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 331,
    "question": "You need to learn which application is listening on port 455 on your computer; which command should you use?",
    "choice_a": "<code>net use</code>",
    "choice_b": "<code>nslookup</code>",
    "choice_c": "<code>netstat</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "C",
    "explanation": "The <code>netstat</code> command used with the <code>-a -b</code> switches will show all listening ports and the applications listening. The <code>net use</code> command is used to map drives. The <code>nslookup</code> is used to lookup DNS entries and <code>tracert</code> is used to determine the path a packet will take though the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      58,
      63,
      62,
      106
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 332,
    "question": "You need to create a new partition on a hard drive using the command line. Which command should you use?",
    "choice_a": "<code>format</code>",
    "choice_b": "<code>chkdsk</code>",
    "choice_c": "<code>diskpart</code>",
    "choice_d": "<code>sfc</code>",
    "correct_answer": "C",
    "explanation": "The <code>diskpart</code> command is used to create, delete, and manage partitions on a hard drive from the command line. The <code>format</code> command is used to format a partition but not create one. The <code>chkdsk</code> command checks and repairs file systems but does not manage partitions. The <code>sfc</code> command checks and repairs system files but does not manage partitions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      61,
      40,
      36,
      42,
      56
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 333,
    "question": "You need to diagnose network connectivity issues by checking IP configuration details on a user\u2019s computer. Which command should you use?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "B",
    "explanation": "The <code>ipconfig</code> command displays IP configuration details, including IP address, subnet mask, default gateway, and DNS servers, which are essential for diagnosing network connectivity issues. The <code>ping</code> command checks connectivity to other devices but does not provide configuration details. The <code>tracert</code> command shows the path packets take to a destination but does not provide configuration details. The <code>netstat</code> command shows active network connections but not IP configuration details.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      59,
      62,
      106,
      66
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 334,
    "question": "Which Linux command can be used to change the password at the command-line?",
    "choice_a": "<code>pwd</code>",
    "choice_b": "<code>passwd</code>",
    "choice_c": "<code>password</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "B",
    "explanation": "The <code>passwd</code> command is used at the command line to change the password. The <code>pwd</code> command is used to display the current working directory. <code>password</code> is not a valid command. The <code>ps</code> command will show the current processes running on the operating system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      98,
      103,
      104
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 335,
    "question": "You need to quickly see all of the running applications in macOS; which key sequence should you use?",
    "choice_a": "The Mission Control key",
    "choice_b": "Command+spacebar",
    "choice_c": "Command+A",
    "choice_d": "Command+T",
    "correct_answer": "A",
    "explanation": "The Mission Control key will allow you to see all of the running applications on the macOS. Command+spacebar will launch the Spotlight utility. Command+A is the equivalent of Ctrl+A on a Windows PC; it selects all items. Command+T opens a new tab in the web browser.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      83,
      87,
      76,
      1
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 336,
    "question": "You need to check which applications on macOS have rights to see your photos. Which System setting will show you the information?",
    "choice_a": "Security & Privacy",
    "choice_b": "Networks",
    "choice_c": "Displays",
    "choice_d": "Accessibility",
    "correct_answer": "A",
    "explanation": "The Security & Privacy applet in System settings will allow you to see all the applications with right to see your photos. The Networks applet will allow you to configure network settings for macOS. The Displays applet will allow you to configure display settings. The Accessibility applet will allow you to configure custom controls for vision, hearing, and motor skills needs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      80,
      34,
      76,
      85
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 337,
    "question": "A user needs to install a package on a Debian-based Linux system. Which command should they use?",
    "choice_a": "<code>yum install package</code>",
    "choice_b": "<code>dnf install package</code>",
    "choice_c": "<code>apt install package</code>",
    "choice_d": "<code>rpm install package</code>",
    "correct_answer": "C",
    "explanation": "The <code>apt</code> command is used for package management on Debian-based systems. The <code>yum</code> and <code>dnf</code> commands are used with Red Hat\u2013based systems. The <code>rpm</code> command is used for RPM packages.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      93,
      99,
      105,
      98
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 338,
    "question": "You need to check the disk usage of the <code>/var</code> directory in a human-readable format. Which command should you use?",
    "choice_a": "<code>df -h /var</code>",
    "choice_b": "<code>du -sh /var</code>",
    "choice_c": "<code>ls -lh /var</code>",
    "choice_d": "<code>find /var -size</code>",
    "correct_answer": "B",
    "explanation": "The <code>du -sh</code> command provides a summary of disk usage in a human-readable format. The <code>df -h</code> command shows disk space usage for filesystems. The <code>ls -lh</code> command lists files with sizes. The <code>find</code> command is used for searching files.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      98,
      104,
      77,
      97,
      103
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 339,
    "question": "A user wants to change the owner of a file to a new user named barney. Which command should they use?",
    "choice_a": "<code>chmod barney <i>filename</i></code>",
    "choice_b": "<code>chown barney <i>filename</i></code>",
    "choice_c": "<code>chgown barney <i>filename</i></code>",
    "choice_d": "<code>usermod barney <i>filename</i></code>",
    "correct_answer": "B",
    "explanation": "The <code>chown</code> command changes the owner of a file. The <code>chmod</code> command changes permissions. The command <code>chgown</code> is not a real command. The <code>usermod</code> command modifies user accounts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      99,
      98,
      100
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 340,
    "question": "Which Active Directory component can enforce settings on a group of users or computers?",
    "choice_a": "Login scripts",
    "choice_b": "Folder redirection",
    "choice_c": "Kerberos",
    "choice_d": "Group Policy",
    "correct_answer": "D",
    "explanation": "Group policy is applied to organization units to enforce settings on groups of user and computer objects. Login scripts can set setting, but cannot enforce the settings. Folder redirection redirects common folders for a user, such as the <code>Desktop</code>, <code>Documents</code>, and <code>AppData</code>. Kerberos is an authentication protocol used with Active Directory.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      125,
      117,
      160,
      171
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 341,
    "question": "What type of filters can be placed over a monitor to prevent the data on the screen from being readable when viewed from the side?",
    "choice_a": "Security",
    "choice_b": "Privacy",
    "choice_c": "Degauss",
    "choice_d": "Tempered",
    "correct_answer": "B",
    "explanation": "Privacy filters are either film or glass add-ons that are placed over a monitor, and they prevent the data on the screen from being readable when viewed from the sides. Security is the overall goal and not the correct answer. Degauss is associated with magnetic media erasure. Tempered is a type of glass and does not prevent side viewing.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      143,
      176,
      191,
      161
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 342,
    "question": "Using a smartcard is an example what type of authentication?",
    "choice_a": "Single-factor authentication",
    "choice_b": "RADIUS authentication",
    "choice_c": "Multifactor authentication",
    "choice_d": "Active Directory authentication",
    "correct_answer": "C",
    "explanation": "Smartcards are an example of multifactor authentication, because you must have the smart card and know the passphrase that secures the credentials stored on the card. Single-factor authentication would only require having something or knowing something, but not both in this instance. RADIUS authentication requires an authentication server for validating usernames and passwords. Active Directory authentication requires a username and password.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      113,
      121,
      120,
      183,
      125
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 343,
    "question": "You receive a report of unauthorized access to a restricted area. Which security measure could help prevent this in the future?",
    "choice_a": "Fingerprint reader",
    "choice_b": "Badge reader",
    "choice_c": "Cypher lock",
    "choice_d": "Alarm system",
    "correct_answer": "A",
    "explanation": "A fingerprint reader authenticates a user based on something they are and therefore credentials cannot be shared. Badge readers only control access. A cypher lock authenticates a person based upon something they know, and this combination can be shared. An alarm systems alert security personnel and, just like motion sensor, it detect unauthorized access but does not prevent it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      115,
      108,
      110,
      111
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 344,
    "question": "During a routine check, you find that several employees are using weak passwords. What policy should you enforce to improve password security?",
    "choice_a": "Password complexity",
    "choice_b": "Screensaver lock",
    "choice_c": "Multifactor authentication",
    "choice_d": "Data encryption",
    "correct_answer": "A",
    "explanation": "Enforcing a password complexity policy ensures that passwords include a mix of uppercase, lowercase, numbers, and symbols, making them more secure. Screensaver locks prevent unauthorized access by locking the screen after a period of inactivity. Multifactor authentication adds an extra layer of security, requiring multiple factors of authentication. Data encryption protects sensitive information by using encryption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      158,
      159,
      121,
      148
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 345,
    "question": "Which type of malware is designed to hide its presence from the operating system?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Rootkit",
    "choice_d": "Trojan",
    "correct_answer": "C",
    "explanation": "A rootkit is designed to hide its presence from the operating system, by tricking the operating system to hide it. A virus is a type of malware that replicates itself. A worm is a type of malware that spreads across networks. A Trojan is a type of malware that disguises itself as legitimate software.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      129,
      133,
      128,
      131,
      217
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 346,
    "question": "Which attribute will notify your backup software that a file should be backed up?",
    "choice_a": "<code>hidden</code>",
    "choice_b": "<code>system</code>",
    "choice_c": "<code>backup</code>",
    "choice_d": "<code>archive</code>",
    "correct_answer": "D",
    "explanation": "The <code>archive</code> attribute is used to notify backup software that a file should be backed up. The <code>hidden</code> attribute hides files from the user. The <code>system</code> attribute is for backward compatibility with older operating systems and is no longer used. There is no such attribute called the <code>backup</code> attribute.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      172,
      162,
      197,
      154,
      135
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 347,
    "question": "Employees are leaving their computers unattended with sensitive information on their screen. What can be implemented to mitigate this risk? (Choose the best answer.)",
    "choice_a": "Complex passwords",
    "choice_b": "Password expiration",
    "choice_c": "Screensaver requiring passwords",
    "choice_d": "Privacy screens",
    "correct_answer": "C",
    "explanation": "Implementing screensavers requiring passwords will mitigate the risk of the screens left unattended. Complex passwords will not mitigate the risk sensitive information being seen by unauthorized persons. Password expiration will not mitigate the risk of risk sensitive information being seen by unauthorized persons. Privacy screens will only mitigate the risk of someone walking by and looking at the screen from an angle and will not mitigate the risk in this case.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      158,
      160,
      157,
      139
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 348,
    "question": "Which of the following is not a share permission?",
    "choice_a": "Read",
    "choice_b": "Full Control",
    "choice_c": "Modify",
    "choice_d": "Change",
    "correct_answer": "C",
    "explanation": "Modify in not a share permission. Read is a share permission. Full control is a share permission. Change is a share permission.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      200,
      171,
      119,
      126,
      167
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 349,
    "question": "By default, which of the following are connection methods that allow the connection of an iPhone to a computer for synchronization? (Choose two.)",
    "choice_a": "Wi-Fi",
    "choice_b": "USB",
    "choice_c": "Bluetooth",
    "choice_d": "Ethernet",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Synchronization of an iOS device can occur over wired USB connections or over Wi-Fi connections. Bluetooth is not an option for synchronization. Ethernet is not an option for synchronization.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      197,
      196,
      193,
      192,
      155
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 350,
    "question": "Permissions on remote folders are governed by which of the following?",
    "choice_a": "Share permissions only",
    "choice_b": "NTFS only",
    "choice_c": "NTFS and share permissions",
    "choice_d": "NTFS permissions unless share permissions are set",
    "correct_answer": "C",
    "explanation": "Permissions on remote folders are governed by NTFS and share permissions.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      171,
      200,
      119,
      126,
      172
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 351,
    "question": "Which of these stores credentials and is considered a password manager?",
    "choice_a": "Edge",
    "choice_b": "Credential Manager",
    "choice_c": "Chrome",
    "choice_d": "Active Directory",
    "correct_answer": "B",
    "explanation": "The Windows Credential Manager is a password manager that is built into the operating system of Windows. Edge and Chrome store credentials inside their own built-in password managers, but they are not password managers. Active Directory is used to authenticate domain users, but it does not manage passwords for end users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      168,
      125,
      166,
      175
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 352,
    "question": "You need to boot to the Windows Recovery Environment in Windows 11. How can you perform this task?",
    "choice_a": "During bootup, press the Shift key.",
    "choice_b": "During bootup, press the F8 key.",
    "choice_c": "Reboot from the operating system while holding the Shift key.",
    "choice_d": "Reboot from the operating system while holding the Ctrl key.",
    "correct_answer": "C",
    "explanation": "You must know, boot the operating system first then reboot holding the Shift key, to enter into the Windows Recovery Environment. Just pressing the Shift key during boot will not do anything. Windows 11 removed the ability to press the F8 key during bootup. Rebooting from the operating system while holding the Ctrl key will not do anything.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      203,
      202,
      205,
      219,
      216
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 353,
    "question": "When an application is not loading on a mobile device, what is the first troubleshooting step?",
    "choice_a": "Force-quit the application.",
    "choice_b": "Clear the applications cache.",
    "choice_c": "Reinstall the application.",
    "choice_d": "Factory reset the phone.",
    "correct_answer": "A",
    "explanation": "Performing a force quit on the application is the first diagnostic step that should be performed on an application that is not loading. Clearing the application cache would be a secondary step to diagnosing the problem. Reinstalling the application will most of the time be disruptive to the user, because data is often deleted. A factory reset is an aggressive diagnostic step and should not be performed.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      221,
      222,
      223,
      208,
      204
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 354,
    "question": "Your users report when they attempt to visit a banking site, they receive a page that looks like the site, but it isn\u2019t right site. What is this an example of?",
    "choice_a": "Pop-ups",
    "choice_b": "Pop-unders",
    "choice_c": "Pharming",
    "choice_d": "JavaScript errors",
    "correct_answer": "C",
    "explanation": "This is most likely pharming, which is a tactic used with browser redirection to phish credentials. Pop-ups are advertisements that pop-up when you visit a web site. Pop-unders are advertisements that spawn under a web page. JavaScript is a language and the primary method of creating pop-ups and pop-unders.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      214,
      139,
      211,
      176,
      209
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 355,
    "question": "You need to kill a process on an operating system in which the application seems to be frozen. Which should you do to minimize disruption?",
    "choice_a": "Reboot the operating system.",
    "choice_b": "Use Resource Monitor.",
    "choice_c": "Log the user off.",
    "choice_d": "Use System Protection to view activity.",
    "correct_answer": "B",
    "explanation": "Using the Resource Monitor to kill the process is the most appropriate action if the application is not responding. Rebooting the operating system is a bit aggressive as the user will need to save all their work. Logging the user off will kill the process, but it will also cause disruption. System Protection is used to manage System Restore points.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      201,
      204,
      208,
      221,
      223
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 356,
    "question": "Which utility is can be used to boot into Safe Boot on the next reboot?",
    "choice_a": "<code>REGEDIT</code>",
    "choice_b": "<code>BOOTREC</code>",
    "choice_c": "<code>MSCONFIG</code>",
    "choice_d": "Event Viewer",
    "correct_answer": "C",
    "explanation": "<code>MSCONFIG</code>, otherwise known as System Configuration, can be used to boot into Safe Bode. <code>REGEDIT</code> is used to view and modify the Registry. <code>BOOTREC</code> is used to repair the boot up procedure. Event Viewer is used to see system, application, and security problems.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      205,
      202,
      203,
      204,
      216
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 357,
    "question": "When a user visits a specific web page an advertisement appears over the page they were intending to visit. What is this an example of? (Choose the best answer.)",
    "choice_a": "Pop-ups",
    "choice_b": "Browser redirection",
    "choice_c": "Security alerts",
    "choice_d": "Compromised account",
    "correct_answer": "A",
    "explanation": "Pop-ups happen inside a browser to spam advertisements foreground of the page you are viewing. Browser redirection is the method of redirecting a user to a malicious website from a web browser. Security alerts are phony alerts that people forward and propagate false warnings. A compromised account is any account that is being used by an unauthorized user.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      176,
      210,
      211,
      178,
      132
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 358,
    "question": "You have just disabled System Protection after identifying and quarantining a system with malware. What should be done next?",
    "choice_a": "Run antivirus software to remove the malware.",
    "choice_b": "Schedule scans of antivirus software.",
    "choice_c": "Enable System Protection.",
    "choice_d": "Educate the end user.",
    "correct_answer": "A",
    "explanation": "The next step is to run antivirus software to remove the malware infection. Scheduling scans of antivirus software should be done after you have remediated the infected system. Enabling System Protection (System Restore) should be done after you have scheduled scans and updated definitions. Educating the end user should be done last.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      220,
      134,
      217,
      173,
      135
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 359,
    "question": "You find out that your cellular plan has overages. When you investigate your device, you find that there is malware installed. What can prevent these overages in the future? (Choose the best answer.)",
    "choice_a": "Only use wireless.",
    "choice_b": "Install a mobile firewall.",
    "choice_c": "Turn off cellular when it is not needed.",
    "choice_d": "Use MDM software.",
    "correct_answer": "B",
    "explanation": "Installing a mobile firewall on the device can prevent this in the future, because traffic will be disabled from leaving the device unless it is authorized. Only using wireless will not stop the device from sending large amounts of malicious traffic. Turning off cellular when it is not needed is not a realistic option. Using mobile device management (MDM) software will not prevent this in the future.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      195,
      134,
      232,
      217,
      127
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 360,
    "question": "Which utility should you use to restart failed services in Windows 11?",
    "choice_a": "Computer Management",
    "choice_b": "Device Manager",
    "choice_c": "Recovery",
    "choice_d": "Startup Settings",
    "correct_answer": "A",
    "explanation": "You can restart failed services under Services and Application inside of the Computer Management console utility. Device Manager is used to install drivers and hardware. Recovery is an option in the Windows Recovery Environment. Startup Settings is an advanced option Windows Recovery Environment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      206,
      204,
      203,
      202,
      201
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 361,
    "question": "What is the purpose of the Windows Boot Manager (<code>BOOTMGR</code>)?",
    "choice_a": "To manage device drivers",
    "choice_b": "To start the loading of an operating system",
    "choice_c": "To monitor system performance",
    "choice_d": "To manage user accounts",
    "correct_answer": "B",
    "explanation": "The Windows Boot Manager (<code>BOOTMGR</code>) bootstraps the system and starts the loading of an operating system. Device drivers are managed in the Device Manager MMC. Monitoring of system performance can be done through the Performance Monitor MMC. Management of user account is performed through the Computer Management MMC.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      202,
      203,
      201,
      204,
      216
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 362,
    "question": "A user reports that their mobile device is not connecting to their headset. What should you check first?",
    "choice_a": "Bluetooth settings",
    "choice_b": "Screen brightness",
    "choice_c": "Battery level",
    "choice_d": "Available storage space",
    "correct_answer": "A",
    "explanation": "Checking the Bluetooth settings is the first step because incorrect settings can prevent Bluetooth connections such as the headset. Screen brightness would not affect the headset. Battery level would not prevent the headset from connecting. Available storage space is unrelated to Bluetooth connectivity.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      226,
      221,
      223,
      225,
      224
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 363,
    "question": "A user reports that their computer is displaying certificate warnings when accessing websites. What is the most likely cause?",
    "choice_a": "Incorrect system time",
    "choice_b": "Faulty network card",
    "choice_c": "Outdated browser",
    "choice_d": "Insufficient RAM",
    "correct_answer": "A",
    "explanation": "Incorrect system time is a common cause of certificate warnings because certificates rely on accurate time settings. A faulty network card would not create a certificate warning. An outdated browser could cause issues, but a certificate would most likely not be an issue. Insufficient RAM is unrelated to this issue.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      213,
      201,
      204,
      215,
      231
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 364,
    "question": "Which variable is defined inside of a script?",
    "choice_a": "System variable",
    "choice_b": "User variable",
    "choice_c": "Assembly register",
    "choice_d": "String variable",
    "correct_answer": "D",
    "explanation": "A string variable is a type of variable that is defined inside of a script. A system variable is defined for the entire system and is not normally defined for an individual script. A user variable is defined for all of the applications and scripts run as the user and not normally defined in a script. An Assembly register is not something that is found in a script.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      234,
      255,
      236,
      237,
      238
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 365,
    "question": "You are creating a Windows Batch script; what extension will launch the command interpreter when it is double-clicked?",
    "choice_a": "<code>.VBS</code>",
    "choice_b": "<code>.JS</code>",
    "choice_c": "<code>.BAT</code>",
    "choice_d": "<code>.PY</code>",
    "correct_answer": "C",
    "explanation": "The <code>.BAT</code> extension is associated with the Windows command interpreter for batch scripting. The <code>.VBS</code> extension is associated with the VBScript interpreter. The .<code>JS</code> extension is used with the JavaScript scripting language. The <code>.PY</code> extension is used with the Python scripting language.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      236,
      233,
      234,
      238
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 366,
    "question": "Which type of variable will only allow whole numbers for mathematic purposes?",
    "choice_a": "Boolean",
    "choice_b": "Integer",
    "choice_c": "Floating-point",
    "choice_d": "String",
    "correct_answer": "B",
    "explanation": "Integer variables allow for whole numbers values. Boolean variables allow for true or false values. Floating-point variables allow for precision math also known as decimal math. String variables allow for text values.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      235,
      236,
      237,
      238
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 367,
    "question": "In the PowerShell example following this question, what is this an example of?<br>While ( $count < 5 ) {<br>#do something <br>}",
    "choice_a": "A <code>for</code> loop",
    "choice_b": "A <code>branch</code> loop",
    "choice_c": "A <code>while</code> loop",
    "choice_d": "Branch logic",
    "correct_answer": "C",
    "explanation": "The example in the question is a <code>while</code> loop. A <code>for</code> loop contains a defined beginning, end, and step that will allow the for loop to complete. There is no such thing as a branch loop; however, a branch can be used to exit a loop. Branch logic is used to branch a script based on a true or false condition.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      235,
      236,
      238,
      244,
      255
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 368,
    "question": "Which remote technology can connect multiple sites over the Internet?",
    "choice_a": "Quick Assist",
    "choice_b": "SSH",
    "choice_c": "Host-to-site VPN",
    "choice_d": "Site-to-site VPN",
    "correct_answer": "D",
    "explanation": "A site-to-site virtual private network (VPN) will allow two or more sites to connect securely over the Internet. The Microsoft Quick Assist tool is used to allow a trusted helper to connect to an end-user for help. The Secure Shell (SSH) protocol is used to provide secure text-based console access for a client to server communications. Host-to-site VPN allows a user to connect to a site and obtain an IP address from the site and tunnel communications, as is they were at the site.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      240,
      241,
      243,
      244,
      239
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 369,
    "question": "Which scripting language is native to Linux and UNIX environments?",
    "choice_a": "Python",
    "choice_b": "Bash script",
    "choice_c": "PowerShell",
    "choice_d": "Windows Batch script",
    "correct_answer": "B",
    "explanation": "A Bash script is native to Linux/UNIX environments. Python requires an interpreter to be installed to execute a Python script. PowerShell and Windows batch scripts are native to the Windows platform.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      237,
      233,
      234,
      235,
      238
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 370,
    "question": "What is the main advantage of deep learning?",
    "choice_a": "It requires explicit programming.",
    "choice_b": "It can learn from experience and improve.",
    "choice_c": "It only works with small datasets.",
    "choice_d": "It is limited to text-based tasks.",
    "correct_answer": "B",
    "explanation": "The main advantage of deep learning is its capacity to learn from experience and get better without explicit programming. Deep learning does not require explicit programming. Deep learning works with large datasets. Deep learning is used in various applications, not just text-based tasks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      247,
      246,
      250,
      251,
      253
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 371,
    "question": "Which AI model is known for generating coherent and contextual information?",
    "choice_a": "CNNs",
    "choice_b": "RNNs",
    "choice_c": "GPT",
    "choice_d": "BPE",
    "correct_answer": "C",
    "explanation": "Generative Pre-trained Transformer (GPT) is known for generating coherent and contextual information. Convolutional Neural Networks (CNNs) are specialized for image and video analysis. Recurrent Neural Networks (RNNs) are good at processing sequential data. Byte-Pair Encoding (BPE) is a tokenization technique.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      250,
      249,
      247,
      253,
      246
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 372,
    "question": "Which class of fire extinguisher is recommended for electrical fires?",
    "choice_a": "A",
    "choice_b": "B",
    "choice_c": "D",
    "choice_d": "ABC",
    "correct_answer": "D",
    "explanation": "Class ABC fire extinguishers are used for wood and paper, flammable liquids, and electrical fires. Wood and paper fires can be put out by a class A fire extinguisher. Class B fire extinguishers are used for flammable liquids. Class D fire extinguishers are used for flammable metals.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 373,
    "question": "Which is considered a carcinogen?",
    "choice_a": "Laser printer toner",
    "choice_b": "Computer screws",
    "choice_c": "Internals of a power supply",
    "choice_d": "Ink-jet fluid",
    "correct_answer": "A",
    "explanation": "Laser printer toner is considered to consist of carcinogens, which is sometimes in the form of heavy metals. Computer screws do not contain carcinogens. The internals of a power supply are high voltage hazards and not carcinogens. Ink-jet fluid is messy, but not considered a carcinogen.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      261,
      269,
      266,
      267,
      262
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 374,
    "question": "You were routinely looking at logs and found a security incident occurred. What type of incident of detection is described?",
    "choice_a": "Passive",
    "choice_b": "Active",
    "choice_c": "Proactive",
    "choice_d": "Auditing",
    "correct_answer": "A",
    "explanation": "Routinely looking at a log file and discovering a security incident occurred is an example of passive detection. Active detection would be the case if you were actively notified when the incident occurred. Proactive detection would be where you would find the security incident before it occurred. Auditing is the act of reading through a log file and not detection of an incident.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      271,
      285,
      273,
      280,
      282
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 375,
    "question": "Which is a reason you should recycle button cell batteries?",
    "choice_a": "Button cell batteries contain mercury metals.",
    "choice_b": "Button cell batteries contain lithium metals.",
    "choice_c": "Button cell batteries pose a fire hazard.",
    "choice_d": "Button cell batteries contain cadmium.",
    "correct_answer": "A",
    "explanation": "Button batteries often contain silver and mercury and they are considered toxic substances for the environment. Button cells generally do not contain lithium and lithium is not considered a hazardous waste. Lithium-ion batteries are susceptible to thermal take off, which can cause fires, but button cell batteries are not. Cadmium is not typically used in the formulation of button cell batteries.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      267,
      269,
      268,
      266,
      272
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 376,
    "question": "The use of an IDS is an example of which type of incidence detection?",
    "choice_a": "Passive",
    "choice_b": "Active",
    "choice_c": "Proactive",
    "choice_d": "Pen testing",
    "correct_answer": "B",
    "explanation": "The use of intrusion detection system (IDS) is an example of active incidence detection. Passive detection is the act of reviewing log files, content, or events to discover the incident. Penetration testing, also known as pen testing is the act of proactively finding holes in security and patching them.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      271,
      285,
      273,
      272,
      276
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 377,
    "question": "Which organization mandates that material safety data sheets are kept with materials that can cause injury?",
    "choice_a": "OSHA",
    "choice_b": "EPA",
    "choice_c": "ISO",
    "choice_d": "WEEE",
    "correct_answer": "A",
    "explanation": "The U.S. Occupational Safety and Health Administration (OSHA) mandates material safety data sheets (MSDSs) are kept for materials that can cause injury. The Environmental Protection Agency (EPA) regulates computer waste for the United States. The International Organization for Standardization (ISO) certifies organizations that standardization their processes according to the published ISO standards. The United Kingdom introduced the Waste Electrical and Electronic Equipment (WEEE) Regulations for the disposal of e-waste.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      268,
      269,
      267,
      261,
      256
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 378,
    "question": "Why should you avoid using magnetic-tipped screwdrivers when working on computers?",
    "choice_a": "They can cause short circuits.",
    "choice_b": "They can erase data on magnetic storage devices.",
    "choice_c": "They are not strong enough.",
    "choice_d": "They are too expensive.",
    "correct_answer": "B",
    "explanation": "Magnetic-tipped screwdrivers can erase data on magnetic storage devices like hard drives. They do not cause short circuits. Their strength is not a problem when repairing electronics. Their cost is not an issue for most screw drivers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      257,
      261,
      266,
      269
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 379,
    "question": "What should you do if you spill liquid on a keyboard?",
    "choice_a": "Use a hairdryer to dry it.",
    "choice_b": "Soak it in distilled, demineralized water.",
    "choice_c": "Shake it vigorously.",
    "choice_d": "Leave it to air-dry.",
    "correct_answer": "B",
    "explanation": "Soaking the keyboard in distilled, demineralized water removes impurities and prevents residue. Using a hairdryer can cause further damage. Shaking it vigorously is ineffective. Leaving it to air-dry may not remove all contaminants.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      266,
      256,
      265,
      285,
      286
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 380,
    "question": "Which level of support will a person typically receive calling a help desk?",
    "choice_a": "Level 1",
    "choice_b": "Level 2",
    "choice_c": "Level 3",
    "choice_d": "Developer",
    "correct_answer": "A",
    "explanation": "Typically, someone calling into the help desk will receive level 1 support, in which the person will have basic knowledge of IT systems. Level 2 support is typically a buffer between the end-user and Level 3 support personnel. Level 3 support is typically expert level support for an IT system. Developer support is typically a level 3 support level.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      281,
      308,
      280,
      306,
      304
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 381,
    "question": "Which traditional type of backup media can be physically taken offsite for safe storage?",
    "choice_a": "Disk-to-tape",
    "choice_b": "Disk-to-disk",
    "choice_c": "Disk-to-cloud",
    "choice_d": "Disk-to-Blu-ray",
    "correct_answer": "A",
    "explanation": "Disk-to-tape is a traditional backup media that can be taken offsite for safe storage. Disk-to-disk storage is normally a rack mounted unit that can be hosted at a remote site, but is not transferable easily. Disk-to-cloud is not a traditional backup method and cannot be physically taken offsite. Disk-to-Blu-ray is not a traditional method of backup media and is not normally used.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      300,
      303,
      301,
      302,
      289
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 382,
    "question": "You need to recover an Active Directory user that was accidentally deleted, so the user can log in. You are going to restore the user from last night\u2019s nightly backup. What should you restore?",
    "choice_a": "System State",
    "choice_b": "User files",
    "choice_c": "SQL database",
    "choice_d": "Exchange database",
    "correct_answer": "A",
    "explanation": "The System State should be restored from backup and an authoritative restore should be performed on the user object. User files might need restored as well, but currently the user needs to log in. An SQL database restore will not restore the user\u2019s account for Active Directory. An Exchange database restore will not restore the user\u2019s account for Active Directory.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      299,
      289,
      303
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 383,
    "question": "Which type of backup will allow a bare-metal restore of a new server?",
    "choice_a": "File based restore",
    "choice_b": "Volume Shadow Copy",
    "choice_c": "Image restore",
    "choice_d": "Cloud restore",
    "correct_answer": "C",
    "explanation": "An image restore can be used to restore an existing server to brand new server hardware. A file based restore requires a file server be installed already. Volume Shadow Copy is a process on the backend of a file server to allow user restores of data. Cloud restore is a type of backup media and therefore an incorrect answer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      299,
      298,
      303,
      301,
      289
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 384,
    "question": "Which should not be worn if the dress code is formal?",
    "choice_a": "Long sleeve dress shirt",
    "choice_b": "Suit and tie",
    "choice_c": "Khakis",
    "choice_d": "Stripped pants",
    "correct_answer": "C",
    "explanation": "Khakis are typically worn if the dress code is business casual. Wearing a long sleeve dress shirt, a suit and tie, or stripped pants are all acceptable if the dress code is formal.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      305,
      287,
      286,
      309,
      282
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 385,
    "question": "Which advantage does a Configuration Management Database (CMDB) provide?",
    "choice_a": "Reduces the need for documentation",
    "choice_b": "Enhances visibility and control over IT environment",
    "choice_c": "Automates all IT tasks",
    "choice_d": "Increases hardware lifespan",
    "correct_answer": "B",
    "explanation": "Enhancing visibility and control over the IT environment is an advantage of a CMDB. It provides a clear picture of configuration items and their relationships. The CMDB does not directly reducing documentation. Although the CMDB can in some instances automatically configure equipment, it does not automate tasks. A CMDB does not increase hardware lifespan.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      286,
      288,
      282,
      310
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 386,
    "question": "When should a follow-up be conducted after resolving an issue?",
    "choice_a": "Immediately after closing the ticket",
    "choice_b": "Before the ticket is closed",
    "choice_c": "Only if the customer requests it",
    "choice_d": "During the next scheduled maintenance",
    "correct_answer": "B",
    "explanation": "Conducting a follow-up before closing the ticket ensures the issue is fully resolved to the customer's satisfaction. Immediately after closing the ticket, might be presumptuous and the problem might not be fixed. If a follow-up is requested, it typically means the problem is not fixed. Scheduled maintenance is not related to follow-ups, it is related to the issue reported.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      310,
      307,
      308,
      304
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 387,
    "question": "What should be included in a standard operating procedure (SOP)?",
    "choice_a": "Detailed steps for each task",
    "choice_b": "Employee performance reviews",
    "choice_c": "Company financial statements",
    "choice_d": "Personal opinions of the author",
    "correct_answer": "A",
    "explanation": "Including detailed steps for each task provides clear guidance on how to perform the process. Performance reviews is not related to an SOP, it is typically related to an employee\u2019s work record. Company financial statements are not disclosed inside SOPs. The handling of financial records might be in an SOP, but the SOP will not contain the financial statement itself. Personal opinions are not relevant to SOPs and should not be in an SOP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      286,
      288,
      292,
      295,
      310
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 388,
    "question": "What is the primary function of a ticketing system in IT?",
    "choice_a": "To schedule employee shifts",
    "choice_b": "To manage and resolve user issues",
    "choice_c": "To track company assets",
    "choice_d": "To forecast IT budget",
    "correct_answer": "B",
    "explanation": "Managing and resolving user issues is what a ticketing system is designed to do in tracking and addressing user issues. Ticketing systems do not schedule shifts. Tracking assets is typically a function of asset management and not a ticketing system. Forecasting budgets is also an unrelated function of ticketing systems.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      279,
      280,
      281,
      282,
      309
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 389,
    "question": "Which command will start the Device Manager?",
    "choice_a": "<code>mmsys.cpl</code>",
    "choice_b": "<code>hdwwiz.cpl</code>",
    "choice_c": "<code>powercfg.cpl</code>",
    "choice_d": "<code>sysdm.cpl</code>",
    "correct_answer": "B",
    "explanation": "The <code>hdwwiz.cpl</code> or the <code>devmgmt.msc</code> will start the Device Manager applet. The <code>mmsys.cpl</code> command will start the Sound applet. The <code>powercfg.cpl</code> command will start the Power Options applet. The <code>sysdm.cpl</code> command with start the System Properties applet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      28,
      30,
      62,
      63
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 390,
    "question": "You\u2019re having problems with a connection to a database, which tool will assist you in troubleshooting the problem?",
    "choice_a": "ODBC Data Sources",
    "choice_b": "Task Manager",
    "choice_c": "Component Services",
    "choice_d": "Local Security Policy",
    "correct_answer": "A",
    "explanation": "The ODBC Data Sources tool will allow you to verify and test connections to the database. Task Manager is used to view processes running on the operating system. Component Services is used to manage running Components on the operating system. The Local Security Policy tool is used to view password policies and security related policies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      59,
      58,
      66
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 391,
    "question": "When you create a partition on a disk that will be booted, what must you configure?",
    "choice_a": "Boot flag",
    "choice_b": "Mount the disk",
    "choice_c": "Mark it active",
    "choice_d": "Convert it to MBR",
    "correct_answer": "C",
    "explanation": "When you create a partition on a disk that is to be booted it must be marked as active. The first active primary partition is the partition that is booted. There is no such thing as a boot flag. The disk should be mounted, but it is not required. Both MBR and <i>GUID [globally unique identifier] Partition Table (GPT)</i> disks will boot with a primary partition.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      40,
      46,
      54,
      28,
      36
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 392,
    "question": "You want to configure the operating system to automatically download updates over metered connections. Which section in the Settings app would you use?",
    "choice_a": "System",
    "choice_b": "Devices",
    "choice_c": "Windows Update",
    "choice_d": "Windows Security",
    "correct_answer": "C",
    "explanation": "The Windows Update section allows you to configure update settings, including downloading updates over metered connections. System is for system settings. Devices is for managing connected devices. Windows Security contains settings for virus protections and other security settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      53,
      93,
      66,
      30
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 393,
    "question": "You want to view detailed memory usage of processes running on the operating system. Which tool would you use?",
    "choice_a": "Task Manager",
    "choice_b": "Resource Monitor",
    "choice_c": "Disk Management",
    "choice_d": "System Configuration",
    "correct_answer": "B",
    "explanation": "Resource Monitor (resmon.exe) provides detailed memory usage information. Task Manager shows basic memory usage. Disk Management is for managing disks. System Configuration is for configuring startup settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      43,
      27,
      28,
      40
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 394,
    "question": "You need to configure a certificate for the Internet Information Services (IIS) web server. Which account type should you manage certificates for?",
    "choice_a": "User account",
    "choice_b": "Service account",
    "choice_c": "Computer account",
    "choice_d": "Administrator account",
    "correct_answer": "C",
    "explanation": "Managing certificates for the computer account is relevant for the operating system, including IIS. User account certificates are for individual users. Service account certificates are for specific services. Administrator account is not a certificate type.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      32,
      35,
      65,
      72
    ],
    "source": "330034_Vol2_PT2"
  },
  {
    "id": 395,
    "question": "Which key sequence will allow you to individually select multiple files at one time for copying?",
    "choice_a": "Shift",
    "choice_b": "Alt",
    "choice_c": "Ctrl",
    "choice_d": "Windows",
    "correct_answer": "C",
    "explanation": "By holding the Ctrl key and clicking individual files, you can select multiple files for copying. Holding the Shift key will allow you to select a large group of files, but not individual files. Holding Alt and double clicking will open the properties of the file or folder. The Windows key will open the Start menu.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      23,
      1,
      57,
      32,
      49
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 396,
    "question": "Which editions of Windows 11 allows for joining a corporate domain?",
    "choice_a": "Enterprise only",
    "choice_b": "Enterprise and Pro only",
    "choice_c": "Pro, Education, and Enterprise only",
    "choice_d": "Home, Pro, Education, and Enterprise only",
    "correct_answer": "C",
    "explanation": "All editions of Windows 11 allow for joining a corporate domain, except for Windows 11 Home.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      20,
      65,
      19,
      72
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 397,
    "question": "Which operating system life cycle term is used to describe an OS that is almost ready to be sold to customers?",
    "choice_a": "Alpha",
    "choice_b": "Beta",
    "choice_c": "Release candidate",
    "choice_d": "Mainstream",
    "correct_answer": "C",
    "explanation": "A release candidate is a pre-release of an operating system, before it is released to market (RTM). It often has features that may or may not be in the final version. Alpha versions of software are highly unstable. Beta versions are more stable with bugs, but not ready for retail. Mainstream is a term used to describe the current release operation system.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      6,
      5,
      50,
      26,
      18
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 398,
    "question": "You realize that your hard drive is out of space, but after deleting a number of files the hard drive remains out of space. What needs to be done?",
    "choice_a": "Reboot the operating system.",
    "choice_b": "Defragment the disk.",
    "choice_c": "Log off and back on.",
    "choice_d": "Empty the Recycle Bin.",
    "correct_answer": "D",
    "explanation": "When you delete files and folders, they will be sent to the Recycle Bin and not completely deleted. Therefore, you must empty the Recycle Bin to completely delete the files and folders and free up space. Rebooting the operating system and logging off and back on will not accomplish freeing up space. Although defragmenting the disk may consolidate space and free a very small amount up, if your disk is out of space then you will not be able to defragment the disk.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      97,
      42,
      7,
      92,
      1
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 399,
    "question": "Which of the following is <i>not</i> a category of operating systems?",
    "choice_a": "Server",
    "choice_b": "Workstation",
    "choice_c": "Mobile",
    "choice_d": "Firmware",
    "correct_answer": "D",
    "explanation": "Firmware is not a category of operating systems; it is a type of software that provides low-level control for a device\u2019s specific hardware. Server is a category of operating system that serves data or resources. Workstation is a category of operating system that allows connecting to servers. Mobile is a category of operating system that is found on mobile devices.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      4,
      1,
      5,
      94,
      6
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 400,
    "question": "What is the primary purpose of a shell in an operating system?",
    "choice_a": "To manage hardware resources",
    "choice_b": "To provide a user interface",
    "choice_c": "To execute applications",
    "choice_d": "To store data",
    "correct_answer": "B",
    "explanation": "A shell is a program that runs on top of the operating system and allows the user to issue commands through a set of menus or another interface. The operating system kernel manages hardware resources. The execution is a function of the operating system, but it is not specifically the primary purpose of the shell. The filesystem on the operating system is used to store data.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      7,
      98,
      82,
      1,
      5
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 401,
    "question": "You have a Windows 11 Home laptop, and your organization has a Windows Server 2025 domain controller. You cannot find the option to join the domain. What could be the problem?",
    "choice_a": "The domain controller needs to be at least Windows 2025.",
    "choice_b": "The edition of the Windows 11 operating system needs to be upgraded.",
    "choice_c": "Windows 11 does not support joining to a domain.",
    "choice_d": "The operating system must be installed on a desktop in order to join a domain.",
    "correct_answer": "B",
    "explanation": "The edition of Windows 11 needs to be Pro, Enterprise, or Education in order to join a domain. The domain version has no effect on the joining of operating systems. Windows 11 supports joining to a domain, provided that it is not Windows 11 Home edition. There is no restriction for joining a domain for a laptop.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      18,
      20,
      72,
      64,
      19
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 402,
    "question": "A user needs to check the integrity of system files on their Windows 11 computer. Which command should they use?",
    "choice_a": "<code>chkdsk</code>",
    "choice_b": "<code>sfc</code>",
    "choice_c": "<code>diskpart</code>",
    "choice_d": "<code>format</code>",
    "correct_answer": "B",
    "explanation": "The <code>sfc</code> (System File Checker) command checks and repairs the integrity of system files, ensuring they are not corrupted or altered. The <code>chkdsk</code> command checks and repairs the file system on a disk but does not specifically check system files. The <code>diskpart</code> command manages disk partitions but does not check system files. The <code>format</code> command erases and formats a disk, which is not suitable for checking system file integrity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      56,
      62,
      36
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 403,
    "question": "You have a laptop that has no CD-ROM drive; how could you install Windows 11? (Choose two.)",
    "choice_a": "USB",
    "choice_b": "CD-ROM",
    "choice_c": "eSATA",
    "choice_d": "PXE",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Universal Serial Bus (USB) flash devices can install Windows 11 and it is the most popular way to install Windows 11 on a laptop with no optical drive. Windows 11 requires a DVD-ROM because of the size of the installation media; a CD-ROM will not work. eSATA is not a media type that can install Windows 11, and although Windows 11 can be installed to eSATA, it is not an option to install from. Preboot Execution Environment (PXE) is a way of booting over a network so that an installation of Windows 11 can be performed.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      54,
      46,
      11,
      44,
      45
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 404,
    "question": "When joining Windows 11 to an Active Directory domain, what is required?",
    "choice_a": "Windows 11 Enterprise",
    "choice_b": "The BitLocker feature installed",
    "choice_c": "An administrative account on the domain",
    "choice_d": "UEFI",
    "correct_answer": "C",
    "explanation": "When joining a Windows 11 operating system to a domain, an administrative account on the domain is required. As long as the operating system is not Windows 11 Home, it can be joined to an Active Directory domain. BitLocker is a volume-level encryption tool for Windows. Windows 11 requires Unified Extensible Firmware Interface (UEFI) for operation.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      72,
      18,
      64,
      19,
      44
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 405,
    "question": "You need to configure a Windows 11 computer to use a specific DNS server. Which tool should you use?",
    "choice_a": "Network & Internet settings",
    "choice_b": "Device Manager",
    "choice_c": "Task Manager",
    "choice_d": "Windows Firewall",
    "correct_answer": "A",
    "explanation": "DNS server settings are configured in Network & Internet settings, where you can specify the preferred and alternate DNS servers. Device Manager manages hardware devices but does not configure network settings. Task Manager monitors system performance and processes but does not configure network settings. Windows Firewall manages firewall settings but does not configure DNS servers.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      34,
      66,
      70,
      58,
      28
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 406,
    "question": "A user needs to create a new user account on their Windows 11 computer using the command line. Which command should they use?",
    "choice_a": "<code>net user</code>",
    "choice_b": "<code>net use</code>",
    "choice_c": "<code>netstat</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "A",
    "explanation": "The <code>net user</code> command is used to create and manage user accounts on a Windows computer. The <code>net use</code> command maps network resources but does not manage user accounts. The <code>netstat</code> command shows network connections but does not manage user accounts. The <code>nslookup</code> command resolves DNS names but does not manage user accounts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      65,
      32,
      63,
      56
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 407,
    "question": "Which Linux command can be used to download software packages at the command line?",
    "choice_a": "<code>sudo</code>",
    "choice_b": "<code>dd</code>",
    "choice_c": "<code>apt</code>",
    "choice_d": "<code>pm</code>",
    "correct_answer": "C",
    "explanation": "The <code>apt</code> command can be used at the Linux shell to download software packages. The <code>sudo</code> command will execute a single command with root privileges. The <code>dd</code> command is used to duplicate block-level data. There is no <code>pm</code> command in Linux.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      98,
      100,
      102
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 408,
    "question": "Which Linux command can be used to rename a file at the command line?",
    "choice_a": "<code>rd</code>",
    "choice_b": "<code>mv</code>",
    "choice_c": "<code>cp</code>",
    "choice_d": "<code>chown</code>",
    "correct_answer": "B",
    "explanation": "The <code>mv</code> command is used at the Linux shell to change the name of a file to a new name. The <code>rd</code> command is a DOS command to remove a directory. The <code>cp</code> command will copy a file or directory. The <code>chown</code> command will change the ownership of a file or directory.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      98,
      56,
      104,
      62
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 409,
    "question": "Which macOS application is similar to Microsoft File Explorer?",
    "choice_a": "Mission Control",
    "choice_b": "Dock",
    "choice_c": "Finder",
    "choice_d": "Time Machine",
    "correct_answer": "C",
    "explanation": "The Finder application is the macOS equivalent to Microsoft File Explorer. Mission Control is a macOS feature that allows you to see all the applications running. The Dock is the area at the bottom of the macOS screen that is used to launch applications. Time Machine is a backup utility on macOS that allows the operating system to create backups on a USB drive.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      85,
      76,
      84,
      87,
      77
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 410,
    "question": "You need to check the IP address configuration of a network interface in Linux. Which command should you use?",
    "choice_a": "<code>ipconfig</code>",
    "choice_b": "<code>ip addr</code>",
    "choice_c": "<code>netstat</code>",
    "choice_d": "<code>ping</code>",
    "correct_answer": "B",
    "explanation": "The <code>ip addr</code> command shows IP address configuration. The <code>ipconfig</code> command is a Windows utility for viewing the IP configuration. The <code>netstat</code> command shows network connections. The <code>ping</code> command tests network connectivity from end-to-end.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      106,
      58,
      98,
      107,
      103
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 411,
    "question": "You need to mount a USB drive to the <code>/mnt/usb</code> directory. Which command should you use?",
    "choice_a": "<code>mount /dev/sdb1 /mnt/usb</code>",
    "choice_b": "<code>umount /dev/sdb1 /mnt/usb</code>",
    "choice_c": "<code>df /mnt/usb</code>",
    "choice_d": "<code>du /mnt/usb</code>",
    "correct_answer": "A",
    "explanation": "The mount <code>/dev/sdb1 /mnt/usb</code> command attaches the USB drive of <code>/dev/sdb1</code> to the <code>/mnt/usb</code> directory. The <code>umount</code> command detaches it a mounted directory. The <code>df</code> command shows disk space usage. The <code>du</code> command shows directory usage.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      102,
      104,
      61,
      98,
      105
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 412,
    "question": "A user wants to create a new directory and its parent directories in one command. Which command should they use?",
    "choice_a": "<code>mkdir -p /home/user/folder/files</code>",
    "choice_b": "<code>mkdir -r /home/user/folder/files</code>",
    "choice_c": "<code>mkdir -m /home/user/folder/files</code>",
    "choice_d": "<code>mkdir -d /home/user/folder/files</code>",
    "correct_answer": "A",
    "explanation": "The <code>mkdir -p /home/user/folder/files</code> command creates parent directories as needed. The <code>mkdir -r /home/user/folder/files</code> command is a wrong answer. The <code>mkdir -m /home/user/folder/files</code> command sets permissions. The <code>mkdir -d /home/user/folder/files</code> command is not a valid option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      104,
      105,
      56,
      57
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 413,
    "question": "Which form of social engineering is nothing more than looking over someone\u2019s shoulder while they enter or view sensitive information?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Phishing",
    "choice_c": "Tailgating",
    "choice_d": "Whaling",
    "correct_answer": "A",
    "explanation": "Shoulder surfing involves looking over someone\u2019s shoulder as they enter information. Phishing is the act of attempting to steal credentials by sending an email that takes you to a fraudulent login. Tailgating is the act of following a person through an access control point, using their credentials. Whaling is a form of phishing that targets high profile individuals.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      141,
      142,
      108,
      139
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 414,
    "question": "You have several office-level users who have administrative privileges on the network. What is the easiest to implement that will immediately add security to the network?",
    "choice_a": "Biometric authentication",
    "choice_b": "Hardware tokens",
    "choice_c": "Active Directory",
    "choice_d": "Least privilege",
    "correct_answer": "D",
    "explanation": "By implementing least privileges and removing the administrative privileges from the office workers, you can easily secure the network. Biometric authentication will secure the network, but it not easily implemented. Hardware tokens will secure the network, but are not easily implemented. Active Directory will not secure the network anymore so, as it is only a centralized authentication system.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      117,
      167,
      170,
      123,
      126
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 415,
    "question": "You need to protect your users from trojans, viruses and phishing emails. What should you implement?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Software firewalls",
    "choice_c": "Antimalware",
    "choice_d": "Antivirus",
    "correct_answer": "C",
    "explanation": "Antimalware covers a wide array or security threats to users, including trojans, viruses, and phishing emails. Multifactor authentication combines two or more single-factor authentication methods to create a very secure authentication for users. Software firewalls will not prevent threats such as trojans, viruses and phishing emails. Antivirus software will only protect you from viruses and trojans, but not phishing emails.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      135,
      134,
      137,
      139,
      128
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 416,
    "question": "Which type of malware encrypts a victim\u2019s files and demands payment for decryption?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Ransomware",
    "choice_d": "Spyware",
    "correct_answer": "C",
    "explanation": "Ransomware encrypts a victim\u2019s files and demands payment for decryption, as a ransom for your files. A virus is malicious malware that replicates itself and effects your operating system in a negative way. A worm is a type of malware that spreads across networks. Spyware collects information about a user without their knowledge.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      127,
      133,
      128,
      130,
      211
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 417,
    "question": "Which type of attack involves intercepting and altering communication between two parties?",
    "choice_a": "Phishing",
    "choice_b": "Spoofing",
    "choice_c": "On-path attack",
    "choice_d": "Tailgating",
    "correct_answer": "C",
    "explanation": "An on-path attack involves intercepting and altering communication between two parties. Phishing involves tricking someone into providing sensitive information. Spoofing involves pretending to be someone else though network communications. Tailgating involves following someone into a restricted area without authorization.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      149,
      147,
      142,
      145,
      150
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 418,
    "question": "Which type of attack involves using a fake wireless access point to intercept communication?",
    "choice_a": "Phishing",
    "choice_b": "Evil twin",
    "choice_c": "Spoofing",
    "choice_d": "Tailgating",
    "correct_answer": "B",
    "explanation": "An evil twin attack involves using a fake wireless access point to intercept communication, by duping a user to connect to the malicious SSID. Phishing involves tricking someone into providing sensitive information. Spoofing involves pretending to be someone else though network communications. Tailgating involves following someone into a restricted area without authorization.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      145,
      149,
      147,
      142,
      144
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 419,
    "question": "An attacker uses a malicious script embedded in a legitimate web page to steal information. What type of attack is this?",
    "choice_a": "Phishing",
    "choice_b": "On-path",
    "choice_c": "Cross-site scripting (XSS)",
    "choice_d": "SQL injection",
    "correct_answer": "C",
    "explanation": "Cross-site scripting (XSS) involves using a malicious script embedded in a legitimate web page to steal information. Phishing attempts to steal sensitive information through deceptive emails. On-path attacks intercept and alters communication between two parties. SQL injection inserts malicious SQL queries into input fields in an attempt to execute the query.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      150,
      142,
      149,
      135,
      139
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 420,
    "question": "Which protocol is use with claims-based authentication of users?",
    "choice_a": "SSO",
    "choice_b": "Kerberos",
    "choice_c": "LDAP",
    "choice_d": "EFS",
    "correct_answer": "A",
    "explanation": "Single Sign-On (SSO) is used in conjunction with Active Directory for claims-based authentication. Kerberos is the protocol used to authenticate a user with Active Directory and provide the network access token. Lightweight Directory Access Protocol (LDAP) is used to lookup objects in Active Directory. Encrypted File System (EFS) is used to encrypt files on NTFS.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      169,
      122,
      183,
      168
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 421,
    "question": "Which attribute is used by the operating system to protect files?",
    "choice_a": "<code>hidden</code>",
    "choice_b": "<code>system</code>",
    "choice_c": "<code>protect</code>",
    "choice_d": "<code>archive</code>",
    "correct_answer": "A",
    "explanation": "The <code>hidden</code> attribute is used by the operating system to protect files by hiding them from the users. The <code>system</code> attribute will not protect files in the operating system. There is no such attribute called the <code>protect</code> attribute. The <code>archive</code> attribute works to notify backup software that a file should be backed up.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      158,
      168,
      167,
      170,
      117
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 422,
    "question": "You need to install an update to your iPhone, but you want to make sure you have the latest backup. What is the quickest way to synchronize your iPhone?",
    "choice_a": "Wi-Fi",
    "choice_b": "USB",
    "choice_c": "Bluetooth",
    "choice_d": "MicroSD card",
    "correct_answer": "B",
    "explanation": "Synchronizing via USB to iTunes is the fastest way to back up your iPhone. Wi-Fi would also work as an option, but it is not the quickest way to synchronize. Bluetooth is not an option to synchronize your iPhone. MicroSD card is not an option to synchronize your iPhone.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      153,
      198,
      155,
      156,
      162
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 423,
    "question": "Which of the following contains the login information for a user, including their groups and privileges? (Choose the best answer.)",
    "choice_a": "Access tokens",
    "choice_b": "Kerberos",
    "choice_c": "Single sign-on",
    "choice_d": "Multifactor authentication",
    "correct_answer": "A",
    "explanation": "The access token, in Windows, contains the login information for a user, including their groups and privileges. Kerberos is the authentication protocol used with Active Directory. Single Sign-on (SSO) is a claims-based authentication method. Multifactor authentication requires two or more factors for authentication.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      168,
      170,
      167,
      121,
      122
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 424,
    "question": "Which of the following is not a recommended security best practice to secure a workstation?",
    "choice_a": "Require passwords",
    "choice_b": "Change default usernames",
    "choice_c": "Degauss drives",
    "choice_d": "Require a password-protected screensaver",
    "correct_answer": "C",
    "explanation": "Degaussing drives destroy the drive with a large magnetic field which is not a best practice to secure a workstation. Requiring passwords is a best practice to secure a workstation. Changing default usernames is a best practice to secure a workstation. Requiring password-protected screensavers is a best practice to secure a workstation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      164,
      162,
      163,
      158,
      160
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 425,
    "question": "Which will extend the functionality of the web browser in a way it wasn't originally designed?",
    "choice_a": "Pop-up blocker",
    "choice_b": "Extensions",
    "choice_c": "Proxy",
    "choice_d": "Ad blocker",
    "correct_answer": "B",
    "explanation": "An extension is a type of add-on that will extend the functionality of the web browser in a way it was never originally designed. A pop-up blocker changed the way a web page is rendered. A proxy will fetch the web page in behalf of the user. An ad blocker also changes the way a web page is rendered.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      179,
      178,
      176,
      177,
      175
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 426,
    "question": "Which utility is can be used to view logs on the Windows operating systems?",
    "choice_a": "<code>REGEDIT</code>",
    "choice_b": "<code>BOOTREC</code>",
    "choice_c": "<code>MSCONFIG</code>",
    "choice_d": "<code>EVENTVWR</code>",
    "correct_answer": "D",
    "explanation": "The <code>EVENTVWR</code> utility is used to view Event Logs on the Windows operating system. <code>REGEDIT</code> is used to view and modify the Registry. <code>BOOTREC</code> is used to repair the bootup procedure. <code>MSCONFIG</code> otherwise known as System Configuration can be used to boot into Safe Mode.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      206,
      203,
      205,
      202
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 427,
    "question": "Donna needs to heal missing or modified system files. Which of the following utilities can be used at the command line to do this?",
    "choice_a": "<code>MSCONFIG</code>",
    "choice_b": "<code>REGEDIT</code>",
    "choice_c": "<code>WINRESUME.EXE</code>",
    "choice_d": "SFC",
    "correct_answer": "D",
    "explanation": "The SFC utility can be used to heal missing or modified system files. <code>MSCONFIG</code>, otherwise known as System Configuration, can be used to boot into Safe Mode and change startup services. <code>REGEDIT</code> is used to view and modify the Registry. <code>WINRESUME.EXE</code> is used during boot up to resume after a system has been suspended.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      212,
      203,
      219,
      205,
      206
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 428,
    "question": "You need to enforce the use of encryption on mobile devices. Which method will be the most effective?",
    "choice_a": "BYOD policy",
    "choice_b": "MDM",
    "choice_c": "Group Policy",
    "choice_d": "NDA",
    "correct_answer": "B",
    "explanation": "The use of mobile device management (MDM) software is the most effective way of enforcing the policy of encryption. A bring your own device (BYOD) policy is only as effective as you make it because it is a written policy. Group Policy is used to apply policies to users and computers in Active Directory domains. A nondisclosure agreement (NDA) is an agreement between an employee and an organization to not divulge intellectual property.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      124,
      232,
      155,
      193
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 429,
    "question": "Users are reporting that in the middle of the day their wireless intermittently gets disconnected. Which is most likely not causing the problem?",
    "choice_a": "Microwave oven",
    "choice_b": "The wrong SSID",
    "choice_c": "Too many devices",
    "choice_d": "Bluetooth devices",
    "correct_answer": "B",
    "explanation": "The wrong SSID is most likely not the problem, since they are reporting intermittent connection problems. A microwave oven can cause intermittent connection problems because they operate on 2.4 GHz. Too many devices connected to an access point can cause congestion issues and signal drops. Bluetooth devices can create interface on 2.4 GHz wireless, although unlikely, they can cause intermittent drops if the airspace is congested.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      181,
      185,
      182,
      110,
      144
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 430,
    "question": "Your mobile device has no wireless, or cellular connectivity, what should be checked first?",
    "choice_a": "Time and date",
    "choice_b": "Frozen applications",
    "choice_c": "Nonresponsive touchscreen",
    "choice_d": "Airplane mode",
    "correct_answer": "D",
    "explanation": "Airplane mode is a function on mobile devices that turns off all radio communications, so therefore it is the most likely problem. Time and date will have no effect on radio communications. A frozen application will not turn off radio communications. A nonresponsive touchscreen will not turn off radio communications.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      223,
      221,
      222,
      224
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 431,
    "question": "You installed a driver for a new drawing tablet, but quickly find that the new driver breaks the functionality of the tablet. Which tool can be used to roll back the driver?",
    "choice_a": "System Startup",
    "choice_b": "Task Manager",
    "choice_c": "Windows Recovery Environment",
    "choice_d": "Device Manager",
    "correct_answer": "D",
    "explanation": "The Drivers tab in Device Manager will allow you to roll back a driver to the originally detected driver. System Startup allows you to boot into Safe Mode and change the startup behavior of Windows, but will not rollback drivers. Task Manager is used to view running processes. Windows Recovery Environment will allow you to perform a system restore, but this will affect the entire system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      203,
      205,
      208,
      204,
      206
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 432,
    "question": "Under which circumstance will Windows 11 boot into the Windows Recovery Environment?",
    "choice_a": "Pressing F8 during bootup",
    "choice_b": "If a BSOD occurs",
    "choice_c": "After two failed attempts to boot",
    "choice_d": "Pressing F12 during POST",
    "correct_answer": "C",
    "explanation": "Windows 11 will boot into the Windows Recovery Environment automatically if the boot process fails twice within two minutes. Windows 7 and prior operating system will prompt with a boot menu if the F8 key is pressed during bootup. When a blue screen of death (BSOD) occurs the system will reboot, but it will not boot into the Windows Recovery Environment. Pressing F12 during the power on self-test (POST) will allow you to enter into BIOS or alter the boot process, depending on the BIOS type.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      203,
      202,
      204,
      205,
      216
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 433,
    "question": "Which utility will allow you to see how often applications crash and the overall health of the operating system?",
    "choice_a": "Reliability Monitor",
    "choice_b": "Resource Monitor",
    "choice_c": "Services and Applications",
    "choice_d": "Dr. Watson",
    "correct_answer": "A",
    "explanation": "The Reliability Monitor is used to view how often applications crash and the overall health of the operating system. Resource Monitor allows you to see a more detailed view of processes and the resources they are using. Services and Applications is used to view services. Dr. Watson is no longer used and was the original application crash notification system in Windows XP and prior operating systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      204,
      201,
      205,
      208,
      216
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 434,
    "question": "You have just successfully remediated the system from malware and want to make sure that Windows Defender Antivirus is up to date on definitions. Which utility should you use to manually update it?",
    "choice_a": "System Configuration",
    "choice_b": "Windows Defender Security apps",
    "choice_c": "Task Scheduler",
    "choice_d": "System Startup",
    "correct_answer": "B",
    "explanation": "The Windows Defender Security app can be used to manually update Microsoft Defender Antivirus. System Configuration is used to change startup behavior of Window. Task Scheduler is used to schedule tasks on the operating system, such as malware scanning. System Startup is used to change the behavior of startup of the operating system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      134,
      220,
      217,
      153
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 435,
    "question": "Which tool can be used to view the total size of a local or remote profile in Windows?",
    "choice_a": "Task Manager",
    "choice_b": "Resource Monitor",
    "choice_c": "Advanced System Properties",
    "choice_d": "Device Manager",
    "correct_answer": "C",
    "explanation": "The Profile tab of the Advanced System Properties dialog box allows you to view the total size of a local or remote profile. Task Manager allows you to see the running tasks and their resource usage. Resource Monitor is used for performance monitoring. Device Manager manages hardware devices.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 436,
    "question": "A user reports that their mobile device is overheating frequently. What is the most likely cause?",
    "choice_a": "Insufficient storage",
    "choice_b": "High CPU usage",
    "choice_c": "Low battery level",
    "choice_d": "Outdated operating system",
    "correct_answer": "B",
    "explanation": "High CPU usage can cause the device to overheat due to excessive processing. Insufficient storage would not make the device overheat. Low battery level is unrelated to overheating. An outdated operating system can contribute to performance issues, but is less likely to be the primary cause of overheating.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      225,
      223,
      201,
      230,
      224
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 437,
    "question": "You are troubleshooting a computer that displays a Low Memory warning. What should you do first?",
    "choice_a": "Add more RAM.",
    "choice_b": "Increase the page file size.",
    "choice_c": "Close unnecessary applications.",
    "choice_d": "Reinstall the operating system.",
    "correct_answer": "C",
    "explanation": "Closing unnecessary applications is the first step because it frees up RAM and can resolve the issue immediately. Adding more RAM and increasing the page file size are more permanent solutions but should be considered after initial troubleshooting. Reinstalling the operating system is unnecessary for this issue.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      207,
      201,
      223,
      208,
      204
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 438,
    "question": "Which remote access protocol will connect local drives and plug and play (PnP) devices?",
    "choice_a": "SSH",
    "choice_b": "Telnet",
    "choice_c": "RDP",
    "choice_d": "VNC",
    "correct_answer": "C",
    "explanation": "The Windows Remote Desktop Protocol has the ability to transport several resources such as remote audio, printers, the clipboard, local disks and video capture devices, as well as any other Plug and Play (PnP) devices. SSH is a text console based remote access method and will not connect devices. Telnet is a text console based remote access method and will not connect devices. VNC is a remote screen sharing application, but it will not connect remote devices.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      241,
      244,
      245,
      242
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 439,
    "question": "Which type of variable will contain characters or text-based values?",
    "choice_a": "Boolean",
    "choice_b": "Integer",
    "choice_c": "Floating-point",
    "choice_d": "String",
    "correct_answer": "D",
    "explanation": "String variables allow for text values and characters. Integer variables allow for whole number values. Floating-point variables allow for precision math also known as decimal math. Boolean variables allow for true or false values.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      235,
      236,
      237,
      238
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 440,
    "question": "You need to create a script that will run on both Windows and Linux operating systems the same. Which scripting language will you choose? (Choose the best answer.)",
    "choice_a": "Python",
    "choice_b": "Bash script",
    "choice_c": "PowerShell",
    "choice_d": "Windows Batch script",
    "correct_answer": "A",
    "explanation": "A Python script will work the same on a Windows or Linux operating system, since they are both executed in the same interpreter. A Bash script will run uniquely on Linux only. A PowerShell script will run uniquely on Windows. Windows Batch scripts can only be executed on Windows.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      238,
      235,
      234
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 441,
    "question": "Which line would be used to comment VBScript code?",
    "choice_a": "<code>//comment</code>",
    "choice_b": "<code>'comment</code>",
    "choice_c": "<code>REM comment</code>",
    "choice_d": "<code># comment</code>",
    "correct_answer": "B",
    "explanation": "The line <code>'comment</code> is used to comment VBScript code. The line <code>//comment</code> is used to comment JavaScript code. The line <code>REM comment</code> is used to comment Windows Batch script code. The line <code># comment</code> is used to comment Bash script code and PowerShell code.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      235,
      236,
      238
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 442,
    "question": "Which script language uses commands with a verb and noun separated by a dash?",
    "choice_a": "Windows batch script",
    "choice_b": "Visual Basic",
    "choice_c": "PowerShell",
    "choice_d": "Python",
    "correct_answer": "C",
    "explanation": "The PowerShell scripting language uses verb and noun combinations separated with a dash, also known as a cmdlet. Windows batch scripts commands vary and usually just have one verb, such as <code>mkdir</code> and <code>rmdir</code>, just to name a few. Python and Visual Basic commands will also vary and do not follow the verb and noun convention.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      236,
      237,
      234,
      235,
      233
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 443,
    "question": "Which remote technology uses TCP port 5900 to communicate?",
    "choice_a": "RDP",
    "choice_b": "SSH",
    "choice_c": "Telnet",
    "choice_d": "VNC",
    "correct_answer": "D",
    "explanation": "The Virtual Network Computing (VNC) protocol uses TCP port 5900 to communicate. The Remote Desktop Protocol operates on TCP port 3389. The SSH protocol operates on TCP port 22. The Telnet service operates on TCP port 23.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      244,
      239,
      241,
      245,
      243
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 444,
    "question": "What is the purpose of NLP?",
    "choice_a": "To process and analyze large volumes of natural language data",
    "choice_b": "To create visual representations of data",
    "choice_c": "To translate audio into text",
    "choice_d": "To generate synthetic images",
    "correct_answer": "A",
    "explanation": "The purpose of natural language processing (NLP) is to process and analyze large volumes of natural language data. NLP does not create visual representations of data. NLP is not limited to translating audio into text. NLP does not generate synthetic images.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      249,
      248,
      246,
      251,
      253
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 445,
    "question": "What is the role of large language models (LLMs)?",
    "choice_a": "To handle audio-related tasks",
    "choice_b": "To understand written words and generate human-like responses",
    "choice_c": "To analyze video data",
    "choice_d": "To create neural networks",
    "correct_answer": "B",
    "explanation": "The role of large language models (LLMs) is to understand written words and generate human-like responses. Audio transformers handle audio-related tasks. Video transformers analyze video data. LLMs do not create neural networks.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      250,
      249,
      248,
      247,
      253
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 446,
    "question": "You are the first responder for to ransomware security incident. What should you collect first?",
    "choice_a": "Picture of a message on the screen",
    "choice_b": "Filesystem information",
    "choice_c": "Raw disk copy",
    "choice_d": "Network activity",
    "correct_answer": "A",
    "explanation": "The order of volatility prescribes you should get memory contents first; this would include a message on the screen that could go away. Filesystem information is after network processes are collected. Raw disk copy is the last thing you should collect. Network activity is after memory and swap files/paging files.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      271,
      285,
      275
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 447,
    "question": "Lately several of your electronics have been damaged after what you believe is a brownout. What should you use to protect your equipment?",
    "choice_a": "Power strip",
    "choice_b": "UPS",
    "choice_c": "Surge protector",
    "choice_d": "Power monitor",
    "correct_answer": "B",
    "explanation": "Uninterruptable power supplies (UPSs) can be used to prevent damage to electronics when a brownout occurs. Power strips offer no protection from power problems. Surge protectors offer protection from surges in electrical voltage. Power monitors only monitor power and do not protect equipment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      264,
      265,
      263,
      268,
      307
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 448,
    "question": "Which component is not considered a high-voltage hazard?",
    "choice_a": "Laser printer",
    "choice_b": "LCD inverter",
    "choice_c": "Power supply",
    "choice_d": "Computer case",
    "correct_answer": "D",
    "explanation": "The computer case is not considered a high voltage hazard, if left plugged in during service with the power off it will be grounded. Laser printers have high-voltage power that drives the corona wire and laser. LCD inverters contain high-voltage circuitry to drive the LCD panel. The power supply contains high voltage even when it is unplugged.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      257,
      261,
      256,
      266,
      278
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 449,
    "question": "Which should be used when cleaning computer contacts?",
    "choice_a": "Demineralized water",
    "choice_b": "Denatured isopropyl alcohol",
    "choice_c": "Compressed air",
    "choice_d": "Computer vacuums",
    "correct_answer": "B",
    "explanation": "Denatured isopropyl alcohol should be used to clean computer contacts, as it will remove and residual grease and oxidation. Demineralized water is typically used on keyboards and other devices that do not contain metal. Compressed air is used to blow out dust particles from hard-to-reach areas. Computer vacuums are used to suck up dust and small particles, but are never used on computer contacts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      268,
      259,
      258,
      262
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 450,
    "question": "Which type of license permits the end user to freely try the software with the intention of buying the application?",
    "choice_a": "Shareware",
    "choice_b": "Freeware",
    "choice_c": "Perpetual",
    "choice_d": "Open source",
    "correct_answer": "A",
    "explanation": "Shareware is a license that allows for a free trial of the software with the intention of purchasing the software after the trial period. Freeware allows for free use of the applications. A perpetual license is simply a license that does not expire. An open source license allows the end user to see the code of the application, because the source code is open to all.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      282,
      280,
      284
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 451,
    "question": "Which type of data is information that can be used to identify a person?",
    "choice_a": "PCI DSS",
    "choice_b": "GDPR",
    "choice_c": "PHI",
    "choice_d": "PII",
    "correct_answer": "Unknown",
    "explanation": "AnswerD <br>Personally identifiable information (PII) is any information that can be used to identify a person. Payment Card Industry Data Security Standard (PCI DSS) is related to credit card information. The General Data Protection Regulation (GDPR) is used for protecting EU citizens. Protected health information (PHI) is any data that defines a patient or an ailment of a patient.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      275,
      312,
      276,
      277,
      273
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 452,
    "question": "What is the purpose of an MSDS?",
    "choice_a": "To provide technical specifications of a product",
    "choice_b": "To offer safety information about hazardous chemicals",
    "choice_c": "To list the components of a computer",
    "choice_d": "To guide software installation",
    "correct_answer": "B",
    "explanation": "A Material Safety Data Sheet (MSDS) provides safety information about hazardous chemicals. An MSDS does not offer technical specifications. An MSDS does not list computer components. An MSDS does not guide software installation.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      268,
      269,
      267,
      261,
      256
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 453,
    "question": "What should you do if you find prohibited content on a work computer?",
    "choice_a": "Delete the content immediately.",
    "choice_b": "Report it through proper channels.",
    "choice_c": "Ignore it.",
    "choice_d": "Confront the user directly.",
    "correct_answer": "B",
    "explanation": "Reporting through proper channels ensures that the situation is handled according to company policy. Deleting the content can destroy evidence. Ignoring it is irresponsible. Confronting the user directly can escalate the situation.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      270,
      285,
      280,
      310,
      287
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 454,
    "question": "You need to shorten your nightly backup windows. Which backup method should you choose to minimize backup time?",
    "choice_a": "Full",
    "choice_b": "Copy",
    "choice_c": "Incremental",
    "choice_d": "Differential",
    "correct_answer": "C",
    "explanation": "An incremental will copy only those files that have changed since the last backup and it will leave the archive bits unchanged, this method will shorten the backup window. A full backup will make a full backup of the data set and will take the longest. Performing a copy backup will take the longest as well and should only be used in specific circumstances. A differential backup will back up only the files that have changed since the last backup; therefore, it will become increasing large until the next full backup.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      298,
      300,
      302,
      303
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 455,
    "question": "Which is defines a media rotation scheme for monthly, weekly, and daily backups?",
    "choice_a": "GFS",
    "choice_b": "RPO",
    "choice_c": "FIFO",
    "choice_d": "RTO",
    "correct_answer": "A",
    "explanation": "The grandfather, father, son (GFS) rotation defines that backups will be aged from daily to weekly and weekly to monthly. The term recovery point objective (RPO) defines the point in time that you can restore to in the event of a disaster. The term first-in first-out (FIFO) defines the order in which backup media is aged. The term recovery time objective (RTO) defines how fast you can restore the data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      301,
      303,
      289,
      302
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 456,
    "question": "You were working at a customer site and an employee told you that a new product was going to be launched next week that would be in high demand. A coworker is now discussing they would like to invest in the same company. What should you do?",
    "choice_a": "Invest in the company with your coworker.",
    "choice_b": "Direct your fellow coworker to the employee that you were speaking to.",
    "choice_c": "Direct your coworker to invest and disclose why.",
    "choice_d": "Do nothing.",
    "correct_answer": "D",
    "explanation": "Doing nothing is the most appropriate answer, because you were privileged to sensitive information that should not be disclosed. Investing in the company with your coworker, could be considered insider trading because you are using privileged information. Directing your fellow coworker to the employee is inappropriate. Directing your coworker to invest and disclosing the information is illegal and inappropriate.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      312,
      277,
      310,
      313
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 457,
    "question": "Which is not typically an element of a knowledge base article?",
    "choice_a": "Symptom",
    "choice_b": "Solution",
    "choice_c": "Date",
    "choice_d": "Contact info",
    "correct_answer": "D",
    "explanation": "Contact info is not typically an element of a knowledge base article. The symptom of the problem, solution for the problem, and the date the article is published are all common elements found in a knowledge base article.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      282,
      280,
      285,
      291,
      292
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 458,
    "question": "What is the procedure of removing access for an employee when they leave an organization?",
    "choice_a": "Onboarding",
    "choice_b": "Offboarding",
    "choice_c": "Termination",
    "choice_d": "Exit process",
    "correct_answer": "B",
    "explanation": "Access is removed for an employee when they leave the organization through the offboarding procedure. The onboarding procedure is used when an employee enters the organization. Termination or the exit process are human resource (HR) terms that signifies when an employee exits the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      287,
      283,
      280,
      282,
      313
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 459,
    "question": "Why should you create documentation during IT projects?",
    "choice_a": "To delay the project completion",
    "choice_b": "To avoid redoing discovery steps in the future",
    "choice_c": "To impress management",
    "choice_d": "To increase project costs",
    "correct_answer": "B",
    "explanation": "Avoiding redoing discovery steps in the future is how documentation provides a reference for solving similar problems later. Although it might seem like documentation could delay completion, if it is performed during IT projects it will speed up completion. Documenting during IT projects is not done to impress management. Documenting does not typically increase costs for an IT project.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      286,
      285,
      288,
      291
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 460,
    "question": "Which method of ticket entry is most suitable for external customers?",
    "choice_a": "Portal entry",
    "choice_b": "Manual entry",
    "choice_c": "Email entry",
    "choice_d": "IVR automation",
    "correct_answer": "C",
    "explanation": "Email entry is a very suitable method because it allows external customers to easily submit issues without needing specific access. Portal entry typically requires logins to the portal, which is not an easy as email. Manual entry is typically performed by an IT person and not the customer. An IVR automation requires the customer to call in and record their issue, this method is very uncommon for external customers.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      279,
      280,
      281,
      304,
      310
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 461,
    "question": "What is the significance of a knowledge base article\u2019s title?",
    "choice_a": "To attract more readers",
    "choice_b": "To represent the key symptom of the issue",
    "choice_c": "To provide detailed solutions",
    "choice_d": "To list all resources used",
    "correct_answer": "B",
    "explanation": "Representing the key symptom of the issue is how the title helps users quickly identify relevant articles. The article title is not used to attracting readers, if you are in the knowledge base, it is because you have an issue. The knowledge base title does not provide solutions. The knowledge base title also does not list resources used.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      280,
      281,
      286,
      291
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 462,
    "question": "How can a CMDB assist in incident management?",
    "choice_a": "By increasing hardware capacity",
    "choice_b": "By identifying affected configuration items",
    "choice_c": "By reducing the workload of IT staff",
    "choice_d": "By automating software updates",
    "correct_answer": "B",
    "explanation": "Identifying affected configuration items is how a CMDB provides detailed information that aids in root cause analysis and resolution. A CMDB will not increase hardware capacity. A CMDB will not reduce workload related to incident management. A CMDB is not used to automate updates for software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      285,
      292,
      288,
      280
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 463,
    "question": "Which tool is used to update a print driver on the operating system?",
    "choice_a": "Device Manager",
    "choice_b": "Devices and Printers applet",
    "choice_c": "System Configuration",
    "choice_d": "msconfig.exe",
    "correct_answer": "B",
    "explanation": "Although the Device Manager can be used to update most drivers, the Devices and Printers applet is the only place to update print drivers. The system configuration tool (msconfig.exe) is used to manage boot up and service settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      94,
      30,
      1
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 464,
    "question": "You have a dual-boot computer and need to change the boot order. Which tool will allow you to change the boot order?",
    "choice_a": "Task Scheduler",
    "choice_b": "System Properties",
    "choice_c": "MSINFO32",
    "choice_d": "BOOTREC",
    "correct_answer": "B",
    "explanation": "The System Properties (SYSDM.CPL) is used to change the boot order. System Properties \u00d8Advanced tab \u00d8Startup & Recovery Settings will display the boot order. Task Scheduler is used for scheduling tasks. MSINFO32 is used to view the operating system environment and hardware. BOOTREC is used to fix the MBR.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      30,
      28,
      34,
      35
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 465,
    "question": "You supervisor asks you to plan for a fault tolerant disk design on a sensitive Windows workstation, which partition scheme should you use?",
    "choice_a": "GPT",
    "choice_b": "MBR",
    "choice_c": "Dynamic",
    "choice_d": "Basic",
    "correct_answer": "C",
    "explanation": "In the Windows operating system if you are going to use RAID, the partitions scheme must be dynamic. MBR, <i>GUID [globally unique identifier] Partition Table (GPT)</i> and Basic (MBR) will not allow for RAID.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      41,
      28,
      45,
      36
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 466,
    "question": "You need to view and manage the active firewall settings. Which section in the Settings app would you use?",
    "choice_a": "System",
    "choice_b": "Devices",
    "choice_c": "Windows Security",
    "choice_d": "Network & Internet",
    "correct_answer": "C",
    "explanation": "The Windows Security section allows you to view and manage firewall settings. System is for system settings. Devices is for managing connected devices. The Network & Internet section will only allow you to view the active status.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      34,
      33,
      69,
      32,
      96
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 467,
    "question": "You want to configure the operating system to use a specific keyboard layout. Which section in the Settings app would you use?",
    "choice_a": "System",
    "choice_b": "Devices",
    "choice_c": "Time & Language",
    "choice_d": "Accessibility",
    "correct_answer": "C",
    "explanation": "The Time & Language section allows you to configure keyboard layouts. System is for system settings. Devices is for managing connected devices. Accessibility is for accessibility settings, comparable with Ease of Access Settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      80,
      7,
      5,
      1
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 468,
    "question": "You need to configure a storage pool using external USB hard drives. Which feature would you use?",
    "choice_a": "Disk Management",
    "choice_b": "Storage Spaces",
    "choice_c": "Device Manager",
    "choice_d": "Task Scheduler",
    "correct_answer": "B",
    "explanation": "Storage Spaces allows you to create storage pools using external USB hard drives. Disk Management is for managing disks. Device Manager is for managing hardware devices. Task Scheduler is for scheduling tasks.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      41,
      28,
      61,
      36,
      31
    ],
    "source": "330034_Vol2_PT3"
  },
  {
    "id": 469,
    "question": "What should be done before upgrading from Windows 10 to Windows 11?",
    "choice_a": "Upgrade the graphic card.",
    "choice_b": "Upgrade the RAM.",
    "choice_c": "Check that applications are supported.",
    "choice_d": "Upgrade the processor.",
    "correct_answer": "C",
    "explanation": "You should always make sure that your applications are supported on Windows 11 before upgrading. The hardware requirements for Windows 10 are identical to Windows 11, so upgrading the graphics card, RAM and processor is not required.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      50,
      19,
      44,
      9
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 470,
    "question": "Which desktop element contains volume adjustment for the computer?",
    "choice_a": "Notification area",
    "choice_b": "Task tray",
    "choice_c": "Start menu",
    "choice_d": "Start screen",
    "correct_answer": "A",
    "explanation": "The Notification area contains the volume adjustment that can be used to adjust the sound for the computer. In addition to the volume icon, the Notification area holds other icons, such as eject, network and date and time. The task tray is not an element of the desktop. The Start menu is used to start applications and applets. The Start screen is similar to the Start menu and is found in Windows 8.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      30,
      43,
      1,
      54
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 471,
    "question": "Which desktop element can restore recently deleted files for Microsoft operating systems?",
    "choice_a": "Recently Deleted",
    "choice_b": "Trash Can",
    "choice_c": "Recycler",
    "choice_d": "Recycle Bin",
    "correct_answer": "D",
    "explanation": "The Recycle Bin is the icon on the desktop that can be used to recover recently deleted file. Recently Deleted and Recycler folders are not used in any mainstream operating system for restoring deleted files. The Trash Can is used the restore deleted items in the macOS operating system.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      7,
      22,
      5,
      1,
      87
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 472,
    "question": "Currently you have a 32-bit installation of Windows 10 and you need to install a 64-bit program. How can you easily accomplish this task?",
    "choice_a": "Preform an in-place upgrade of the operating system to 64-bit.",
    "choice_b": "Reinstall the operating system with 64-bit Windows 10.",
    "choice_c": "Install at least 2 GB of RAM.",
    "choice_d": "Install the 64-bit drivers for the CPU.",
    "correct_answer": "B",
    "explanation": "In order to use a 64-bit program, it will require a 64-bit operating system. However, you cannot perform an in-place upgrade from a 32-bit operating system to a 64-bit operating system; you must reinstall the operating system. When you install a 64-bit Windows 10, it will require at least 2 GB of RAM, but simply having 2 GB of RAM will not allow a 64-bit program to run on a 32-bit operating system. Generally, you will not have drivers for the CPU and installing them will not enable a 32-bit operating system to run as a 64-bit operating system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      9,
      8,
      19,
      46
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 473,
    "question": "Which of the following is a feature of Windows 11 Enterprise edition but not available in Windows 11 Home?",
    "choice_a": "Microsoft Defender",
    "choice_b": "Remote Desktop Protocol (RDP)",
    "choice_c": "AppLocker",
    "choice_d": "BitLocker",
    "correct_answer": "C",
    "explanation": "AppLocker is a feature available in Windows 11 Enterprise that allows administrators to control which applications can run on the system. Microsoft Defender is a standard feature built into all Windows editions. Microsoft Home edition contains Microsoft Defender. Remote Desktop Protocol (RDP) is a feature of upgrading to Windows 11 Pro edition; it allows an administrator or privileged user to remotely connect to the operating system. BitLocker is a feature of upgrading to Windows 11 Pro; it is used for drive-level encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      21,
      20,
      19,
      96
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 474,
    "question": "What is the primary benefit of using cloud-based productivity tools?",
    "choice_a": "They require no Internet connection.",
    "choice_b": "They are always free to use.",
    "choice_c": "They allow access to files from any device with an Internet connection.",
    "choice_d": "They do not require any updates.",
    "correct_answer": "C",
    "explanation": "Cloud-based productivity tools enable users to access their files and applications from any device with an Internet connection, providing flexibility and convenience. Cloud-based tools typically require an Internet connection to access files and applications. Many cloud-based tools have associated costs. Cloud-based tools are often updated automatically by the service provider.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      15,
      16,
      14,
      92,
      96
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 475,
    "question": "Which command can be used to map a network drive to a volume letter?",
    "choice_a": "<code>net use</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>nslookup</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "A",
    "explanation": "The <code>net use</code> command can be used to map a volume letter to a network drive, as an example <code>net use z: \\\\server\\share</code> will map the Z drive letter to the network share of <code>\\\\server\\share</code>. The <code>netstat</code> tool will show you network statistics and network connections. The <code>nslookup</code> tool will allows you to verify DNS. The <code>tracert</code> tool will show you the path network traffic will take.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      59,
      58,
      67,
      71
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 476,
    "question": "Which command will place the computer into hibernate power mode?",
    "choice_a": "<code>sleep</code>",
    "choice_b": "<code>shutdown /h</code>",
    "choice_c": "<code>sfc</code>",
    "choice_d": "<code>winver</code>",
    "correct_answer": "B",
    "explanation": "The command <code>shutdown /h</code> will place the computer into hibernate power mode. The <code>sleep</code> command will pause the command line for a number of specified seconds and is often used with command scripts. The <code>sfc</code> command is a system file checker to repair the operating system. The <code>winver</code> command will display the version of the operating system in a GUI window.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      32,
      63,
      61,
      28
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 477,
    "question": "Which network model is best used with a SOHO environment?",
    "choice_a": "Domain",
    "choice_b": "Active Directory",
    "choice_c": "Workgroup",
    "choice_d": "SSO",
    "correct_answer": "C",
    "explanation": "A workgroup model is best to be used with a small office/home office (SOHO) environment, since it doesn\u2019t require any special servers to function. A domain model is used to centralize authentication and is often used with large scale enterprises. Microsoft Active Directory is the main authentication technology used with Microsoft Windows Server domain controllers in a domain networking model. Single Sign On (SSO) is an authentication method that uses claims to authenticate users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      20,
      12,
      17
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 478,
    "question": "Which will remove a filesystem folder?",
    "choice_a": "<code>dir</code>",
    "choice_b": "<code>rd</code>",
    "choice_c": "<code>md</code>",
    "choice_d": "<code>cd</code>",
    "correct_answer": "B",
    "explanation": "The <code>rd</code> command or the <code>rmdir</code> command will remove a filesystem folder. The command <code>dir</code> will show the files within a folder. The command <code>md</code> will make a directory. The command <code>cd</code> will change the folder in focus.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      56,
      57,
      61,
      62,
      105
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 479,
    "question": "You need to check the boot configuration data on a Windows 11 computer. Which command should you use?",
    "choice_a": "<code>bcdedit</code>",
    "choice_b": "<code>msconfig</code>",
    "choice_c": "<code>diskpart</code>",
    "choice_d": "<code>sfc</code>",
    "correct_answer": "A",
    "explanation": "The <code>bcdedit</code> command is used to view and manage the boot configuration data (BCD) on a Windows computer. The <code>msconfig</code> command is used to configure system startup options but does not directly manage BCD. The <code>diskpart</code> command manages disk partitions but does not manage BCD. The <code>sfc</code> command checks and repairs system files but does not manage BCD.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      30,
      51,
      45,
      46,
      62
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 480,
    "question": "A user needs to resolve a DNS name to an IP address for troubleshooting purposes. Which command should they use?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>nslookup</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "The <code>nslookup</code> command resolves DNS names to IP addresses, which is useful for troubleshooting DNS-related issues. The <code>ping</code> command checks connectivity but does not resolve DNS names directly to IP addresses in detail like <code>nslookup</code> does. The <code>tracert</code> command shows the path packets take to a destination but does not resolve DNS names specifically for troubleshooting purposes like <code>nslookup</code> does.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      58,
      106,
      62,
      98
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 481,
    "question": "You believe that the disk on your Linux operating system is full. Which command will allow you to verify this assumption?",
    "choice_a": "<code>df</code>",
    "choice_b": "<code>su</code>",
    "choice_c": "<code>pwd</code>",
    "choice_d": "<code>ls</code>",
    "correct_answer": "A",
    "explanation": "The <code>df</code> command will allow you to see how much of the disk is free. The <code>su</code> command will allow you to log in as a different user. The <code>pwd</code> command will show the current working directory. The <code>ls</code> command will list all of the files in the current working directory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      104,
      103,
      99,
      105
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 482,
    "question": "Which Linux command can be used at the command line to see in which directory you are currently working?",
    "choice_a": "<code>pwd</code>",
    "choice_b": "<code>cd</code>",
    "choice_c": "<code>ls</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "A",
    "explanation": "The <code>pwd</code> command is used at the Linux shell to see the present working directory. The <code>cd</code> command allows you to change the current directory. The <code>ls</code> command displays the files in the current directory. The <code>ps</code> command will display the current process running on the operating system.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      104,
      98,
      103,
      107,
      99
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 483,
    "question": "Which Linux command will allow you to interactively see all running processes similar to the Windows Task Manager?",
    "choice_a": "<code>ps</code>",
    "choice_b": "<code>su</code>",
    "choice_c": "<code>top</code>",
    "choice_d": "<code>df</code>",
    "correct_answer": "C",
    "explanation": "The <code>top</code> command-line utility will show you all running processes on Linux in an interactive window, similar to Windows Task Manager. The <code>ps</code> command will only show you a snapshot of what is running. The <code>su</code> command will allow you to change to another user\u2019s context, such as root. The <code>df</code> command will display free space on the disk.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      103,
      98,
      27,
      99,
      43
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 484,
    "question": "A user needs to change the password for their account in Linux. Which command should they use?",
    "choice_a": "<code>passwd</code>",
    "choice_b": "<code>usermod</code>",
    "choice_c": "<code>chown</code>",
    "choice_d": "<code>chmod</code>",
    "correct_answer": "A",
    "explanation": "The <code>passwd</code> command will allow the user to change their password. The <code>usermod</code> command modifies user accounts. The <code>chown</code> command changes ownership of files and folders. The <code>chmod</code> command changes permissions of files and folders.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      99,
      100,
      98,
      104,
      105
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 485,
    "question": "You need to uninstall an application on macOS. What is the correct method to do this?",
    "choice_a": "Drag the application to the Trash.",
    "choice_b": "Use the Disk Utility to remove the application.",
    "choice_c": "Open the Terminal and type the <code>uninstall</code> command.",
    "choice_d": "Delete the application from the App Store.",
    "correct_answer": "A",
    "explanation": "The correct method to uninstall an application on macOS is to drag the application to the Trash. Using Disk Utility is for managing disks. Typing an <code>uninstall</code> command in Terminal is not the standard method. Deleting from the App Store is not a correct answer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      87,
      75,
      85,
      77
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 486,
    "question": "A user needs to encrypt their entire disk on macOS. Which feature should they use?",
    "choice_a": "Time Machine",
    "choice_b": "FileVault",
    "choice_c": "Keychain",
    "choice_d": "Disk Utility",
    "correct_answer": "B",
    "explanation": "FileVault is the feature that provides full-disk encryption to prevent unauthorized access to the information contained on the device during startup. Time Machine is a feature that allows for backups. Keychain and Passwords are features for password management. The Disk Utility is a feature for managing disks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      79,
      77,
      86,
      74
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 487,
    "question": "Which of the following is a hard drive sanitation method? (Choose the best answer.)",
    "choice_a": "Format",
    "choice_b": "Overwrite",
    "choice_c": "Drill",
    "choice_d": "Degauss",
    "correct_answer": "B",
    "explanation": "Overwriting and drive wiping are the two methods of hard drive sanitation. Formatting is not considered a hard drive sanitation method. Drilling is a physical destruction method. Degaussing magnetic media is another type of physical destruction method.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      163,
      162,
      164,
      165,
      156
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 488,
    "question": "Chelsea is worried about the threat of malware on the network. She wants every workstation to have installed software that will detect worms and Trojan horses. What type software should she install?",
    "choice_a": "Malware",
    "choice_b": "Antivirus/antimalware",
    "choice_c": "Software firewalls",
    "choice_d": "Spyware",
    "correct_answer": "B",
    "explanation": "Antivirus/antimalware software is an application that is installed on a system to protect it and to scan for viruses as well as worms and Trojan horses. Malware is malicious software that once install on system causes malicious activity. Software firewalls will not detect trojan horses and worms. Spyware is malicious software that monitors user activity and offers unsolicited pop-up advertisements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      128,
      133,
      217
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 489,
    "question": "What is a method for stopping tailgating?",
    "choice_a": "User authentication",
    "choice_b": "Access control vestibule",
    "choice_c": "Strong passwords",
    "choice_d": "Change SSIDs",
    "correct_answer": "B",
    "explanation": "Using access control vestibule, which are devices such as small rooms that limit access to one or a few individuals, is a great way to stop tailgating. User authentication will not stop tailgating, it is present even when tailgating is happening. Strong passwords will not prevent tailgating, as tailgating is a physical security problem. Changing SSIDs will not stop tailgating from happening, as tailgating does not pertain to wireless.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      143,
      113,
      115,
      116
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 490,
    "question": "Which type of malware is designed to collect information about a user without their knowledge?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Ransomware",
    "choice_d": "Spyware",
    "correct_answer": "D",
    "explanation": "Spyware is malicious malware that spies on a user without their knowledge and collects information. A virus is malicious malware that replicates itself and effects your operating system in a negative way. A worm is a type of malware that spreads across networks. Spyware collects information about a user without their knowledge. Ransomware encrypts a victim\u2019s files and demands payment for decryption, as a ransom for your files.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      132,
      133,
      128,
      129,
      134
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 491,
    "question": "Which type of attack involves using a fake website to trick users into providing sensitive information?",
    "choice_a": "Phishing",
    "choice_b": "Spoofing",
    "choice_c": "On-path attack",
    "choice_d": "Tailgating",
    "correct_answer": "A",
    "explanation": "Phishing involves using a fake website to trick users into providing sensitive information. Spoofing involves pretending to be someone else though network communications. An on-path attack involves intercepting and altering communication between two parties. Tailgating involves following someone into a restricted area without authorization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      147,
      149,
      145,
      210
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 492,
    "question": "To enhance security, your company decides to implement a system that requires employees to use both a password and a code sent to their phone. What is this security measure called?",
    "choice_a": "SAML",
    "choice_b": "MFA",
    "choice_c": "SQL",
    "choice_d": "XSS",
    "correct_answer": "B",
    "explanation": "Multifactor authentication (MFA) providing multiple layers of security by requiring multiple forms of verification to enhance security. Security Assertion Markup Language (SAML) is an XML type message used with Single Sign-On (SSO). Structured Query Language (SQL) is used with queries to databases. Cross-Site Scripting (XSS) is a technique of embedding scripts into a web page.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      122,
      183,
      158,
      157
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 493,
    "question": "What is the primary function of a firewall in network security?",
    "choice_a": "Encrypting data",
    "choice_b": "Scanning for viruses",
    "choice_c": "Isolation",
    "choice_d": "Authenticating users",
    "correct_answer": "C",
    "explanation": "Firewalls control traffic between networks to prevent unauthorized access, by isolating one network from another. Encrypting data, which is the function of encryption tools, not firewalls. Scanning for viruses, which is the function of antivirus software. Authenticating users, which is the function of authentication systems such as Active Directory.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      188,
      140,
      119,
      144,
      118
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 494,
    "question": "Which of the following is not an NTFS permission? (Choose the best answer.)",
    "choice_a": "Full Control",
    "choice_b": "Write",
    "choice_c": "Read & Execute",
    "choice_d": "Change",
    "correct_answer": "D",
    "explanation": "Change is a share permission; the similar permission in NTFS is Modify. Full control is an NTFS permission. Write is an NTFS permission. Read & Execute is an NTFS permission.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      172,
      167,
      166
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 495,
    "question": "Which mobile device screen lock uses the factor of biometrics to secure your device?",
    "choice_a": "Passcode lock",
    "choice_b": "Swipe Lock",
    "choice_c": "Face Lock",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "Face lock is a type of biometric used on mobile devices that uses your face to unlock the device. Passcode lock is a factor of something you know. Swipe lock is not really a screen lock and just protects the phone from accidental dialing. Face lock is the only correct answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      120,
      115,
      159,
      192
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 496,
    "question": "What can you implement to protect files from accidental deletion on the local operating system? (Choose the best answer.)",
    "choice_a": "Share permissions",
    "choice_b": "Modify NTFS permissions",
    "choice_c": "<code>read-only</code> attribute",
    "choice_d": "<code>hidden</code> attribute",
    "correct_answer": "C",
    "explanation": "The <code>read-only</code> attribute will protect the files from accidental deletion. Share permissions are not effective if the users are local to the operating system. Modify NTFS permissions will allow the user to modify the files and possibly delete them. The <code>hidden</code> attribute only hides file from the user and should not be considered the only level of protection.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      172,
      171,
      170,
      117,
      162
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 497,
    "question": "Jimmy just copied a folder on the same partition; what will happen with the permissions for the folder?",
    "choice_a": "The permissions will be the same as they were before the move.",
    "choice_b": "The permissions will be inherited from the new parent folder.",
    "choice_c": "The permissions will be configured as the root folder for the drive letter.",
    "choice_d": "The permissions will be blank until configured.",
    "correct_answer": "B",
    "explanation": "The permissions will be inherited from the new parent folder, because the copy is considered a new entity. The permission will not be the same as before the move. The permissions will not be configured the same as the root folder. The permissions will not be blank.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      172,
      167,
      170
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 498,
    "question": "What can you use to ensure the authenticity of an installation?",
    "choice_a": "Windows Defender",
    "choice_b": "File Hashes",
    "choice_c": "NTFS",
    "choice_d": "Attributes",
    "correct_answer": "B",
    "explanation": "File hashes can be used to ensure the authenticity of an installation, it is a numerical hash of the entire file. Windows Defender, now known as Windows security, can only scan a file to check if it is infected. NTFS is a filesystem and offers no controls for authenticity. Attributes are an element of the filesystem and offer no controls for authenticity.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      173,
      134,
      171,
      174,
      156
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 499,
    "question": "You need to secure your mobile device\u2019s lock screen with the highest level of protection. Which of the following should you use?",
    "choice_a": "Fingerprint lock",
    "choice_b": "Face lock",
    "choice_c": "Passcode lock",
    "choice_d": "Swipe lock",
    "correct_answer": "A",
    "explanation": "Fingerprint locks are the most secure of all the lock methods, since fingerprints are hard to duplicate. Face locks have a high number of false positives, which can be used to gain access to the phone. Passcode locks can be cracked or shoulder surfed. Swipe locks are not really locks; they just allow the screen to be opened with a swipe.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      115,
      159,
      120,
      155
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 500,
    "question": "You have a physical Windows computer that continually has a time drift problem. What should be checked?",
    "choice_a": "That the NTP server is reachable",
    "choice_b": "That the correct time zone is set",
    "choice_c": "That the correct locale is set",
    "choice_d": "That you have the latest Windows Updates",
    "correct_answer": "A",
    "explanation": "If you are experiencing time drift, you should check that the Network Time Protocol (NTP) server is reachable. The NTP server can be blocked by a firewall or some other network issue. Having the correct time zone configured is important, but will not attribute to time drift. Having the wrong locale might display the time different than expected, but will not attribute to time drift. Having the latest Windows Updates will not affect time drift at all.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      213,
      216,
      204,
      206,
      202
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 501,
    "question": "When you have an invalid certificate error on a web page, what is the first and easiest thing to check?",
    "choice_a": "Date and time of your computer",
    "choice_b": "That you are using SSL",
    "choice_c": "SSL version of the destination site",
    "choice_d": "That the remote server is signing with your private certificate",
    "correct_answer": "A",
    "explanation": "The first and easiest thing to check is your data and time, this is to include your time zone. If your date and time are off, it can cause an invalid certificate error. If you are receiving an invalid certificate error you\u2019re already running SSL/TLS. SSL/TLS version of the destination site will have no bearing on an invalid certificate. Remote servers will not sign with your private certification, only you have access to the private certificate.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      213,
      216,
      208,
      204,
      219
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 502,
    "question": "If you have extremely short battery life on your mobile device, what should you suspect? (Choose the best answer.)",
    "choice_a": "Location-based services are off",
    "choice_b": "An application is frozen",
    "choice_c": "High RAM usage",
    "choice_d": "Your display is too dim",
    "correct_answer": "C",
    "explanation": "The first suspect of extremely short battery life is high RAM usage. When RAM usage is high, swapping will occur and drain battery life. Location-based service off will not affect battery life. An application being frozen means it will not respond and generally is not processing to use battery life. If the display is too dim it will not generally affect battery life.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      223,
      225,
      201,
      207,
      230
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 503,
    "question": "What should you do if you encounter a No OS Found error during boot?",
    "choice_a": "Remove any non-bootable media.",
    "choice_b": "Reinstall Windows.",
    "choice_c": "Update the BIOS.",
    "choice_d": "Replace the hard drive.",
    "correct_answer": "A",
    "explanation": "Removing any non-bootable media is the first step to take if you encounter a No OS Found error during boot. Reinstalling Windows will not solve the issue if there is non-bootable media present. Updating the BIOS will not fix the issue. Replacing the hard drive is a drastic measures that should be considered later.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      202,
      203,
      216,
      219,
      218
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 504,
    "question": "When you choose to boot to Safe Mode, which of the following is not loaded?",
    "choice_a": "Keyboard drivers",
    "choice_b": "Storage system services",
    "choice_c": "Networking",
    "choice_d": "Standard VGA drivers",
    "correct_answer": "C",
    "explanation": "Safe Mode does not load networking drivers. Safe Mode loads the standard keyboard driver. Safe Mode loads the storage system services. Safe Mode loads the standard VGA driver.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      202,
      203,
      219,
      218
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 505,
    "question": "What is the motivation of a threat agent, when they engage in affiliate redirection?",
    "choice_a": "DDoS",
    "choice_b": "Commission on sales",
    "choice_c": "Pharming",
    "choice_d": "Installation of malware",
    "correct_answer": "B",
    "explanation": "Affiliate redirection is the form of redirecting an end-user to an affiliate link on a retail site, so the threat agent receives a commission on sales. A distributed denial-of-service (DDoS) attack does not use affiliate redirection. Pharming is an attack where one host is sent to another and does not use affiliate redirection. The installation of malware is also not performed with affiliate redirection.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      214,
      209,
      210,
      211,
      139
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 506,
    "question": "You manage the IT department for an organization and want to enforce restrictions so that company owned devices do not record via the camera and microphone. What can you implement?",
    "choice_a": "Antivirus software",
    "choice_b": "MDM software",
    "choice_c": "Firewall software",
    "choice_d": "BYOD policy",
    "correct_answer": "B",
    "explanation": "Implementing mobile device management (MDM) software can help you enforce restrictions of mobile device recordings. Antivirus software does not restrict camera and microphone usage. Firewall software does not restrict camera and microphone usage. A BYOD policy will not enforce restrictions of camera and microphone usage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      124,
      232,
      195,
      194
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 507,
    "question": "A mobile device has a nonresponsive touchscreen; what is the first thing you should try?",
    "choice_a": "Soft reset",
    "choice_b": "Hard reset",
    "choice_c": "Factory reset",
    "choice_d": "USB debugging",
    "correct_answer": "B",
    "explanation": "If a device has a nonresponsive touchscreen, then a hard reset should be performed. A soft reset will not work if the device has a nonresponding touchscreen. A factory reset will remove all of your data. USB debugging in not turned on by default and will not help you with a nonresponsive touchscreen.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      221,
      223,
      224,
      222,
      225
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 508,
    "question": "You have a number of organization owned mobile devices and want to mitigate the risk of leaked personal data, what can be implemented? (Choose the best answer.)",
    "choice_a": "Antivirus",
    "choice_b": "Mobile firewall",
    "choice_c": "Encrypted wireless",
    "choice_d": "Limited cellular plans",
    "correct_answer": "A",
    "explanation": "Antivirus software can mitigate the risk of leaked personal data on a mobile device. Mobile firewalls will not mitigate the risk of leaked personal data, if the device is physically lost or stolen. Encrypted wireless will not mitigate the risk of leaked personal data in the event of a virus or physical loss or theft of the device. Limited cellular plans will not mitigate the risk of leaked personal data, since many plans allow for normal usage and will transmit the personal data before an over limit occurs.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      124,
      232,
      228,
      195
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 509,
    "question": "A user is unable to access the network on their computer. What could be a potential cause related to security?",
    "choice_a": "Malfunctioning network interface card (NIC)",
    "choice_b": "Improperly installed network software",
    "choice_c": "Malware acting as a proxy",
    "choice_d": "Outdated drivers",
    "correct_answer": "C",
    "explanation": "Malware acting as a proxy can cause network connectivity issues by intercepting and redirecting traffic. Malfunctioning NICs would not be related to a security concern. Improperly installed network software is not realistic since the operating system is responsible for network software. Outdated drivers are also potential causes but are not specifically related to security.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      209,
      133,
      149,
      211,
      134
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 510,
    "question": "A user reports that their computer is displaying random pop-ups even when no browser is open. What is the most likely cause?",
    "choice_a": "Malware infection",
    "choice_b": "Outdated operating system",
    "choice_c": "Faulty network card",
    "choice_d": "Insufficient RAM",
    "correct_answer": "A",
    "explanation": "Random pop-ups are a common symptom of a malware infection. An outdated operating system can contribute to security vulnerabilities but is not the direct cause of pop-ups. A faulty network card would not create random pop-ups. Insufficient RAM is unrelated to this issue.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      209,
      211,
      134,
      131,
      132
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 511,
    "question": "Why should you disable System Restore when dealing with a malware infection?",
    "choice_a": "To free up system resources",
    "choice_b": "To prevent the creation of infected restore points",
    "choice_c": "To speed up the malware removal process",
    "choice_d": "To allow the operating system to update",
    "correct_answer": "B",
    "explanation": "Disabling System Restore prevents the system from creating restore points that may contain the malware, ensuring that the infection does not persist through system restores. Freeing up system resources is not something of concern with a malware infection. Disabling System Restore will not speed up the malware removal process. It is also not necessary for allowing the operating system to update.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      217,
      134,
      209,
      139
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 512,
    "question": "You need to assist an end  user with Windows 11; during the assistance you will need to transfer some files to the user. Which remote access technology should you use?",
    "choice_a": "SSH",
    "choice_b": "Quick Assist",
    "choice_c": "WinRM",
    "choice_d": "Third-party remote assistance",
    "correct_answer": "D",
    "explanation": "During the end-user assistance session you will need to transfer files which Quick Assist does not support, so third-party tools will be required. SSH does not transfer files or screen share. Windows Remote Management (WinRM) is a Microsoft tool for remote management and the automation of tasks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      243,
      244,
      239,
      245,
      242
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 513,
    "question": "Which remote access protocol provides TLS security?",
    "choice_a": "SSH",
    "choice_b": "Telnet",
    "choice_c": "RDP",
    "choice_d": "VNC",
    "correct_answer": "C",
    "explanation": "The Remote Desktop Protocol encrypts with 128 bit TLS security. SSH is a text console based remote access method and uses public key cryptography. Telnet is a text console\u2013based remote access method and does not offer any encryption. VNC is a remote screen sharing application and does not offer any encryption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      239,
      241,
      244,
      245,
      240
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 514,
    "question": "In the PowerShell example following this question, what is this an example of?<br>if ( $count < 5 ) { #do something }",
    "choice_a": "A <code>for</code> loop",
    "choice_b": "A <code>branch</code> loop",
    "choice_c": "A <code>while</code> loop",
    "choice_d": "Branch logic",
    "correct_answer": "D",
    "explanation": "This is an example of branch logic, which is used to branch execution based upon a true or false condition. A <code>for</code> loop is a loop that has a defined beginning, end, and step that will allow the for loop to complete. There is no such thing as a branch loop; however, a branch can be used to exit a loop. A <code>while</code> loop is a loop that requires a condition to be satisfied to exit.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      235,
      236,
      255,
      244,
      246
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 515,
    "question": "You need to provide a text-based console to a server with a high-level of encryption; which remote access technology should you choose?",
    "choice_a": "RDP",
    "choice_b": "WinRM",
    "choice_c": "SSH",
    "choice_d": "VNC",
    "correct_answer": "C",
    "explanation": "The SSH protocol is a text-based console remote access protocol that allows for a high-level of encryption. The Remote Desktop Connection utility is a Graphical User Interface (GUI) based tool that uses the Remote Desktop Protocol (RDP). WinRM is a tool for remote management and automation of tasks, it does not provide text-based console access. VNC is a remote desktop tool and is GUI based.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      244,
      243,
      245,
      239
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 516,
    "question": "Which PowerShell cmdlet will map a network drive?",
    "choice_a": "<code>net use</code>",
    "choice_b": "<code>Install-Module</code>",
    "choice_c": "<code>New-PSDrive</code>",
    "choice_d": "<code>net user</code>",
    "correct_answer": "C",
    "explanation": "The <code>New-PSDrive</code> cmdlet will map a network drive in PowerShell. The <code>net use</code> command is used with Windows batch scripting to map network drives. The <code>Install-Module</code> command allows you to install PowerShell modules. The <code>net user</code> command is used to administer users.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      238,
      234,
      235,
      233
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 517,
    "question": "Which statement will load a PowerShell variable of <code>xvar</code> with a value of <code>11</code>?",
    "choice_a": "<code>$xvar = 11</code>",
    "choice_b": "<code>xvar = 11</code>",
    "choice_c": "<code>xvar = 11;</code>",
    "choice_d": "<code>set /a xvar=11</code>",
    "correct_answer": "A",
    "explanation": "The statement <code>$xvar = 11</code> will load <code>11</code> into the <code>xvar</code> variable in PowerShell. The statement <code>xvar = 11</code> is Bash syntax. The statement <code>xvar = 11;</code> is JavaScript syntax to load a variable of <code>xvar</code> with a value of <code>11</code>. The statement <code>set /a xvar=11</code> is Windows Batch script syntax and will load a variable of <code>xvar</code> with <code>11</code>.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      234,
      237,
      236,
      235,
      238
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 518,
    "question": "Which Microsoft remote protocol allows for local drives to be presented to the remote system?",
    "choice_a": "VCN",
    "choice_b": "RDP",
    "choice_c": "SSH",
    "choice_d": "WinRM",
    "correct_answer": "B",
    "explanation": "Remote Desktop Protocol (RDP) allows for local drives to be available to the remote machine when an RDP session is initiated. Virtual Network Computing (VNC), Secure Shell (SSH), and Windows Remote Management (WinRM) are not capable of redirecting drives.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      239,
      244,
      241,
      245,
      243
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 519,
    "question": "Which type of data is highly organized and easily searchable?",
    "choice_a": "Unstructured data",
    "choice_b": "Semi-structured data",
    "choice_c": "Structured data",
    "choice_d": "Real-time data",
    "correct_answer": "C",
    "explanation": "Structured data is highly organized and easily searchable. Unstructured data lacks a predefined format. Semi-structured data has elements of both structured and unstructured data. Real-time data is generated continuously by various sources.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      251,
      246,
      247,
      250,
      253
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 520,
    "question": "You need to ship an electronic component that is potentially susceptible to ESD; what should you use?",
    "choice_a": "Antistatic mat",
    "choice_b": "Antistatic bag",
    "choice_c": "Antistatic wrist strap",
    "choice_d": "Antistatic spray",
    "correct_answer": "B",
    "explanation": "You should use an antistatic bag to ship an electronic component that is susceptible to ESD. An antistatic mat is used when working with an electronic component. An antistatic wrist strap is used when handling electronic components. Antistatic spray is used in an area to eliminate a static charge.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      258,
      260,
      268,
      269
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 521,
    "question": "You are responding to an incident where a fellow employee has been exposed to battery acid. How should you treat the injury?",
    "choice_a": "Dial the OSHA hotline.",
    "choice_b": "The procedure in the MSDS.",
    "choice_c": "Baking soda and water.",
    "choice_d": "Dial the poison control center.",
    "correct_answer": "B",
    "explanation": "The procedure in the material safety data sheet (MSDS) for the batteries will outline how to care for the injury. OSHA does not have an injury hotline. Baking soda and water may cause further injuries. A poison control center will most likely have you check the MSDS sheet for the battery, since the employee is not poisoned.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      268,
      266,
      285,
      308,
      312
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 522,
    "question": "You work for an organization that works with information identifying citizens in the United States and Europe. Which regulations should you adhere to?",
    "choice_a": "PCI DSS",
    "choice_b": "PII",
    "choice_c": "GDPR",
    "choice_d": "PHI",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "You should adhere to regulation based on personally identifiable information (PII) and General Data Protection Regulation (GDPR) for EU citizens. Payment Card Industry Data Security Standard (PCI DSS) is a standard of processes and procedure used to handle data related to transactions using payment cards. Protected health information (PHI) refers to any information used in the health care industry to describe a patient or aliment.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      275,
      277,
      312,
      270,
      254
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 523,
    "question": "Which power issue describes when power abruptly increases momentarily and then drop back to normal?",
    "choice_a": "Power sag",
    "choice_b": "Brownout",
    "choice_c": "Blackout",
    "choice_d": "Power surge",
    "correct_answer": "D",
    "explanation": "A power surge happens when the voltage spikes up severely for a split second then it drops back to normal. Power sags and brownouts happens when voltage sags down past its normal operating range. A blackout happens when the electrical supply ceases for a period of time.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      265,
      264,
      256,
      257,
      261
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 524,
    "question": "Which license model allows you to install the software on more computers than you are licensed for?",
    "choice_a": "Perpetual",
    "choice_b": "Concurrent",
    "choice_c": "Shareware",
    "choice_d": "Open source",
    "correct_answer": "B",
    "explanation": "A concurrent license allows you to install the software on many computers, but you can only use the software concurrently for the number of licensed users. A perpetual license is a license that does not expire. A shareware license allows you to trial the software before you purchase the software. An open source license allows you to view the source code for the application.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      274,
      283,
      288,
      301,
      276
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 525,
    "question": "Which is a risk of high humidity around computer equipment?",
    "choice_a": "ESD",
    "choice_b": "Overheating",
    "choice_c": "Short circuits",
    "choice_d": "Discharging",
    "correct_answer": "C",
    "explanation": "When the humidity levels are too high, water combines with dust can short circuit computer components. Electrostatic discharge (ESD) happens when humidity is too low. Overheating happens when the ambient air is not cool enough. Discharging is related to ESD and only happens when the humidity is too low.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      260,
      259,
      266,
      265,
      264
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 526,
    "question": "What is the first step in responding to an incident involving prohibited content?",
    "choice_a": "Collect evidence.",
    "choice_b": "Report to management.",
    "choice_c": "Confront the user.",
    "choice_d": "Ignore the incident.",
    "correct_answer": "A",
    "explanation": "Collecting evidence is crucial to ensure that the incident is documented properly. Reporting to management comes after evidence collection. Confronting the user is not the first step. Ignoring the incident is not an option.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      285,
      270,
      280
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 527,
    "question": "What should you do if you suspect a computer has been compromised by malware?",
    "choice_a": "Continue using the computer.",
    "choice_b": "Disconnect it from the network.",
    "choice_c": "Reboot the computer.",
    "choice_d": "Delete suspicious files.",
    "correct_answer": "B",
    "explanation": "Disconnecting the computer from the network prevents the malware from spreading. Continuing to use the computer is risky. Rebooting may not remove the malware. Deleting suspicious files can cause data loss and may not remove the malware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      285,
      289,
      276,
      252,
      288
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 528,
    "question": "What is the definition of the recovery point objective?",
    "choice_a": "How long it will take to back up the dataset",
    "choice_b": "How current the data is on backup media",
    "choice_c": "How long it will take to restore the dataset",
    "choice_d": "How big the current dataset is",
    "correct_answer": "B",
    "explanation": "The recovery point objective (RPO) is how current the data is on the backup media and to what point you can recover to. How long it takes to back up the data set is the backup window. How long it will take to restore the data set is the recovery time objective (RTO). Determining the size of the current dataset is an incorrect answer.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      302,
      301,
      303,
      298,
      299
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 529,
    "question": "You been called to fix an application issue, but after arrival you test it and find it is in working order. What should you do?",
    "choice_a": "Leave, since it is fixed.",
    "choice_b": "Call your manager for guidance.",
    "choice_c": "Reinstall the application for good measure.",
    "choice_d": "Ask the user to reproduce the problem.",
    "correct_answer": "D",
    "explanation": "You should ask the user to reproduce the problem, since you have not been able to reproduce the problem or the problem is not how it was originally reported. Leaving is not an appropriate action since it will probably still be a problem for the user. Calling your manager for guidance will is not going to help the situation. Reinstalling the application could introduce new problems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      306,
      307,
      304,
      310,
      308
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 530,
    "question": "Which routine backup method requires the longest backup window?",
    "choice_a": "Full",
    "choice_b": "Copy",
    "choice_c": "Incremental",
    "choice_d": "Differential",
    "correct_answer": "A",
    "explanation": "A full backup will make a full backup of the dataset and will take the longest during a routine backup. Performing a copy backup will take the longest as well and should only be used in specific circumstances. An incremental will copy only those files that have changed since the last backup and it will leave the archive bits unchanged; this method will shorten the backup window. A differential backup will back up only the files that have changed since the last backup; therefore, it will become increasingly large until the next full backup.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      300,
      303,
      299
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 531,
    "question": "Which element is external of the organization and ultimately defines processes?",
    "choice_a": "Regulations",
    "choice_b": "Audits",
    "choice_c": "Policies",
    "choice_d": "Procedures",
    "correct_answer": "A",
    "explanation": "Regulations are external restrictions placed on the organization. Audits can be performed internally or externally of the organization and monitor compliance of the regulation. Policies are internally created to adhere to the external regulations. Procedures are a component of a process and they are typically internal to the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      277,
      276,
      270,
      286,
      291
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 532,
    "question": "You are the network administrator for your organization. Backup windows are starting to extend into work shifts. You have been asked to recommend a better strategy; what will speed up backups to shorten the window?",
    "choice_a": "Disk-to-tape backups",
    "choice_b": "Disk-to-disk backups",
    "choice_c": "Full backups",
    "choice_d": "GFS rotations",
    "correct_answer": "B",
    "explanation": "Disk-to-disk backups will speed up any backup since the backup is coming off disks and being backed up to disks. A disk-to-tape backup is the traditional method to back up networks and is considered slower than disk-to-disk. A full backup is generally done once a week and consists of a full backup of the network servers. Although GFS rotations may speed up end-of-week and end-of-month backups, it is considered a rotation strategy rather than a backup method.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      301,
      302,
      303,
      298
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 533,
    "question": "What is the purpose of the remediation section in an incident document?",
    "choice_a": "To list temporary actions taken",
    "choice_b": "To provide the ultimate fix for the issue",
    "choice_c": "To summarize the incident",
    "choice_d": "To detail the services impacted",
    "correct_answer": "B",
    "explanation": "Providing the ultimate fix for the issue is how the remediation addresses the root cause. Listing temporary actions is not what is contained in the remediation section of the incident document. The executive brief is the summary of the incident. The remediation section does not detail impacted services.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      285,
      281,
      282,
      273,
      291
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 534,
    "question": "What should you do first when a user reports an issue with their computer?",
    "choice_a": "Restart the computer.",
    "choice_b": "Check the network connection.",
    "choice_c": "Ask the user to describe the issue.",
    "choice_d": "Run a virus scan.",
    "correct_answer": "C",
    "explanation": "Asking the user to describe the issue helps you understand the problem from their perspective and gather important details. Restarting the computer might fix the issue, but it is not the first thing you should do. Checking the network connection is also a valid diagnostic step, but it is not the first thing you should do. Running a virus scan is not a bad idea if the user thinks they have been compromised, but asking the user to describe the issue should always come first.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      280,
      281,
      282,
      285,
      312
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 535,
    "question": "What is the benefit of using Volume Shadow Copy for backups?",
    "choice_a": "It is the cheapest backup solution,",
    "choice_b": "It allows users to restore their own files,",
    "choice_c": "It requires no configuration,",
    "choice_d": "It provides unlimited storage,",
    "correct_answer": "B",
    "explanation": "Volume Shadow Copy empowers users to restore their own files, reducing the burden on IT support. Volume Shadow Copy is not necessarily the cheapest as it uses storage. The Volume Shadow Copy does require configuration by the IT administrator. Volume Shadow Copy also does not provide unlimited storage.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      297,
      314,
      303,
      302,
      281
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 536,
    "question": "What is the main advantage of using a cloud-based ticketing system?",
    "choice_a": "It is always cheaper than on-premises systems.",
    "choice_b": "It requires no maintenance.",
    "choice_c": "It offers better availability and scalability.",
    "choice_d": "It eliminates the need for IT support.",
    "correct_answer": "C",
    "explanation": "Cloud-based ticketing systems provide better availability and scalability, making them suitable for growing organizations. Cloud-based ticketing systems are not always cheaper because they are hosted on the providers equipment. Cloud-based ticketing systems still require some maintenance. Cloud-based ticketing systems do not eliminate the need for IT support, they assist staff to resolve issues.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      279,
      282,
      242,
      286,
      288
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 537,
    "question": "You just installed a hard drive from an Apple computer into the Windows computer. You cannot view the files, why?",
    "choice_a": "The drive needs to be initialized.",
    "choice_b": "The drive needs to be mounted.",
    "choice_c": "The drive needs to be converted to GPT.",
    "choice_d": "The drive contains an APFS filesystem.",
    "correct_answer": "D",
    "explanation": "Apple computers use a file system called Apple File System (APFS) that is incompatible with Windows operating systems. None of the other options are valid, the files will need to be copied on an Apple PC to a disk containing FAT, FAT32, or NTFS.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      38,
      39,
      36,
      57,
      25
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 538,
    "question": "Your computer suddenly rebooted and you need to learn why it abruptly rebooted. Which tool will assist you in learning this?",
    "choice_a": "Event Viewer",
    "choice_b": "Task Scheduler",
    "choice_c": "SHUTDOWN",
    "choice_d": "Performance Monitor",
    "correct_answer": "A",
    "explanation": "The Event Viewer records system errors that could explain why the computer abruptly rebooted. Task Scheduler is used for scheduling tasks. The SHUTDOWN command shuts a computer down or reboots it. The Performance Monitor will only show performance related statistics.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      28,
      30,
      27,
      43,
      31
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 539,
    "question": "Which Microsoft Management Console allows you to configure services?",
    "choice_a": "Device Manager",
    "choice_b": "Computer Management",
    "choice_c": "Local Users and Groups",
    "choice_d": "Event Viewer",
    "correct_answer": "B",
    "explanation": "The Computer Management MMC has a number of other snap-ins, one being the Services snap-in where you can configure services on the operating system. The Device Manager will allow you to configure and view devices connected to the computer. The Local User and Groups snap-in allows you to view all of the local user accounts and group configured on the operating system. The Event Viewer snap-in is used to view logs of the operating system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      1,
      3,
      25
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 540,
    "question": "You need to configure the operating system to automatically lock when a paired Bluetooth device moves out of range. Which feature would you use?",
    "choice_a": "Windows Hello",
    "choice_b": "Dynamic Lock",
    "choice_c": "BitLocker",
    "choice_d": "Credential Manager",
    "correct_answer": "B",
    "explanation": "Dynamic Lock automatically locks the computer when a paired Bluetooth device moves out of range. Windows Hello is for biometric authentication, BitLocker is for drive encryption, and Credential Manager is for managing stored credentials. Dynamic Lock is specifically designed for this purpose.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      18,
      49,
      21,
      78,
      1
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 541,
    "question": "You need to configure the operating system to automatically unlock when you come into view of the webcam. Which feature would you use?",
    "choice_a": "Windows Hello",
    "choice_b": "Dynamic Lock",
    "choice_c": "BitLocker",
    "choice_d": "Credential Manager",
    "correct_answer": "A",
    "explanation": "Windows Hello is for biometric authentication, such as finger prints and facial recognition. You can configure Windows Hello to unlock the computer when you come into view of the camera. Dynamic Lock automatically locks the computer when a paired Bluetooth device moves out of range. BitLocker is for drive encryption. Credential Manager is for managing stored credentials.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      65,
      34,
      21,
      35,
      18
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 542,
    "question": "You want to data on the CPU usage for a period of time. Which tool would you use?",
    "choice_a": "Task Manager",
    "choice_b": "Performance Monitor",
    "choice_c": "Resource Monitor",
    "choice_d": "Event Viewer",
    "correct_answer": "B",
    "explanation": "Performance Monitor (perfmon.msc) can record, store, and displays performance counters for the CPU, among other components in the computer. Task Manager shows basic CPU usage. Resource Monitor provides detailed resource usage. Event Viewer is for viewing event logs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      31,
      30,
      27,
      103
    ],
    "source": "330034_Vol2_PT4"
  },
  {
    "id": 543,
    "question": "You want to transfer files from your computer to a remote server. To do this, you want to connect to a shared directory on the server and copy the files. Which command-line utility will allow you to do this?",
    "choice_a": "<code>netstat</code>",
    "choice_b": "<code>net use</code>",
    "choice_c": "<code>netshare</code>",
    "choice_d": "<code>netdom</code>",
    "correct_answer": "B",
    "explanation": "The <code>net use</code> command enables you to connect to a shared resource. Depending on the version of Windows you are using, <code>net</code> can be one of the most powerful commands at your disposal. While all Windows versions include a <code>net</code> command, its capabilities <code>differ</code> based on whether it is used on a server or workstation and the version of the operating system. Commonly, <code>net share</code> is used to create shared folders, and <code>net use</code> is used to connect to shared resources. The <code>net user</code> command allows administrators to create and manage user accounts. <code>netstat</code> shows what sockets (IP address plus port) are being used and by which protocols. <code>Net Share</code> is a valid command for managing shared resources, but <code>netshare</code> and <code>netdom</code> are not valid commands.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      62,
      58,
      56,
      20
    ],
    "source": "9781394330348"
  },
  {
    "id": 544,
    "question": "A technician is troubleshooting a computer that occasionally will not read data from the hard drive. What should they try first?",
    "choice_a": "Run Defragment and Optimize Drives.",
    "choice_b": "Run <code>chkdsk /f</code> at a command prompt.",
    "choice_c": "Format the hard drive and reinstall the OS.",
    "choice_d": "Replace the hard drive.",
    "correct_answer": "B",
    "explanation": "It\u2019s possible that the hard drive has some bad sectors, so run <code>chkdsk /f</code> to scan the drive and attempt to repair them. If that doesn\u2019t work, formatting is the second option, and replacing the drive is the third. If your drive is getting read/write errors, having an extra hard drive on hand would be wise.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      36,
      42,
      28,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 545,
    "question": "You have replaced a failed hard drive and need to prepare the new drive for data storage. Which of the following utilities will you use first?",
    "choice_a": "<code>format</code>",
    "choice_b": "<code>chkdsk</code>",
    "choice_c": "<code>diskpart</code>",
    "choice_d": "<code>gpupdate</code>",
    "correct_answer": "C",
    "explanation": "The <code>diskpart</code> utility lets the user see and manage partitions on the computer\u2019s hard drives. Because of the enormous power it holds, the user must have administrator status to run <code>diskpart</code>. Once a partition is created, the <code>format</code> command will set up the file system on the new volume. The <code>chkdsk</code> command verifies the disk integrity and <code>gpupdate</code> forces group policy changes to take effect immediately.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      40,
      36,
      42,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 546,
    "question": "Which of the following file system types available in Windows Pro for Workstations will detect when data on a mirrored drive has been corrupted and will use a healthy copy of the data on other drives to attempt to correct corrupted data and protect data?",
    "choice_a": "NTFS",
    "choice_b": "ReFS",
    "choice_c": "ext4",
    "choice_d": "FAT32",
    "correct_answer": "B",
    "explanation": "Resilient File System (ReFS) is a feature available on Windows Pro for Workstations and Windows Enterprise editions. ReFS will detect when data on a mirrored drive has been corrupted and will use a healthy copy of the data on other drives to attempt to correct corrupted data and protect data. New Technology File System (NTFS) has been available on Windows operating systems (OSs) since 1993 and provides file encryption and the ability to use NTFS permissions for security. The fourth extended filesystem (ext4) is a Linux filesystem, and File Allocation Table 32 (FAT32) is a legacy filesystem sometimes used for compatibility between different OSs, and used on external storage devices like memory cards, Universal Serial Bus (USB) drives, and hard drives.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      39,
      36,
      18,
      91,
      42
    ],
    "source": "9781394330348"
  },
  {
    "id": 547,
    "question": "You want to use BitLocker to encrypt the company president\u2019s laptop drive, but when you go into the Control Panel to find it, it isn\u2019t there. What Windows 10 edition does this computer have?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": "A",
    "explanation": "Windows 10 Home edition does not offer BitLocker as an option. BitLocker is available in the Pro, Pro for Workstations, and Enterprise editions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      21,
      32,
      20,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 548,
    "question": "Which of the following Windows editions support ReFS? (Choose two.)",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Resilient File System (ReFS) is a feature available on Windows Pro for Workstations and Windows Enterprise editions. ReFS will detect when data on a mirrored drive has been corrupted and will use a healthy copy of the data on other drives to attempt to correct corrupted data and protect data. As of the fall 2023 update, ReFS use on Pro editions of Windows became limited. To use the full-featured ReFS, you need Pro for Workstations or Enterprise editions.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      39,
      18,
      36,
      21,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 549,
    "question": "You just purchased a new computer that has four CPUs. What edition of Windows will you need, at a minimum, to take advantage of the computer\u2019s processing capability?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": "C",
    "explanation": "Windows Pro for Workstations is designed so that users can take advantage of the capabilities of high-end workstations. Windows Home edition can support up to two physical Central Processing Units (CPUs), while Windows Pro for Workstations can support up to four physical processors. Remember that each physical processor has multiple cores.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      8,
      43,
      19,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 550,
    "question": "An employee wants to bring their Windows device to use at work. At work, they will need to log in to a domain. Which reason listed will prohibit the employee from using their device on the domain?",
    "choice_a": "Their device has only one processor.",
    "choice_b": "Their device OS is Windows Home.",
    "choice_c": "Their device has only 8 GB of RAM.",
    "choice_d": "Their device must be Windows Enterprise edition.",
    "correct_answer": "B",
    "explanation": "Windows Home does not have the capability of joining a domain, so the employee will not be able to use their personal device. Windows Pro, Pro for Workstations, and Enterprise editions are all able to log in to a domain. The number of processors and amount of RAM are irrelevant to the ability to log in to a domain.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      20,
      72,
      21,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 551,
    "question": "One of your technicians needs to use the Task Manager utility. What are two ways they can open Task Manager? (Choose two.)",
    "choice_a": "Press Ctrl+Alt+Delete and then click Task Manager",
    "choice_b": "Press Ctrl+Shift+T",
    "choice_c": "Press Ctrl+Alt+T",
    "choice_d": "Press Ctrl+Shift+Esc",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Task Manager is a powerful tool that works in all versions of Windows, although it has different capabilities in different versions. In Windows 10 and 11, it allows you to shut down nonresponsive applications and view the performance of the Central Processing Unit (CPU), memory, disks, Wi-Fi, and Graphics Processing Units (GPUs); as well as to show application usage history, services, and programs launched at startup, users attached to the system, and other useful information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      31,
      29,
      34
    ],
    "source": "9781394330348"
  },
  {
    "id": 552,
    "question": "You need to configure Internet connections on a Windows workstation. Which tabs of the Internet Options utility in the Control Panel would you use to set the Home page and enable the pop-up blocker?",
    "choice_a": "Connections, Security",
    "choice_b": "General, Security",
    "choice_c": "General, Privacy",
    "choice_d": "Connections, Privacy",
    "correct_answer": "C",
    "explanation": "The Internet Options utility in the Windows Control Panel has six tabs that allow you to configure how your browser interacts with the Internet. The six tabs are General, Security, Privacy, Content, Connections, Programs, and Advanced. (Note, not all versions of Windows have the Content tab.) The General tab allows you to change the Home page, while the Privacy tab has a Turn on Pop-up Blocker option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      67,
      66,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 553,
    "question": "A network connection doesn\u2019t seem to be working as it should. You\u2019ve verified that the cables are good from end to end. Where can you quickly look in the OS to see if there is a problem with the onboard NIC driver?",
    "choice_a": "Device Manager",
    "choice_b": "Programs and Features",
    "choice_c": "File Explorer Options",
    "choice_d": "Ease of Access",
    "correct_answer": "A",
    "explanation": "A quick look at Device Manager (<code>devmgmt.msc</code>) is often all you need to troubleshoot a problem with an onboard device. In Device Manager, if the device drivers aren\u2019t installed for the device, you\u2019ll see a yellow exclamation point next to the device name in the list, which signifies that the device is not working properly. Programs and Features enables the user to add, remove, or troubleshoot installed programs (the options will change by program) and add Windows features that are not yet installed. The File Explorer Options utility changes how File Explorer works, such as showing hidden files or extensions and other view options. Ease of Access provides alternative ways to interact with the computer for differently-abled users.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      28,
      29,
      32,
      30,
      66
    ],
    "source": "9781394330348"
  },
  {
    "id": 554,
    "question": "A salesperson in your company travels regularly to foreign countries through different time zones. They have asked you if there is a way to set their Windows 11 PC so that it will always show the time and date for their location. How can this be done?",
    "choice_a": "In Windows Settings, choose Time & language, then choose Date And Time, and select Set Time Automatically.",
    "choice_b": "In the Control Panel, choose Date and Time, and then select Set Time Zone Automatically.",
    "choice_c": "In Windows Settings, choose Date And Time, and then select Synchronize Your Clock.",
    "choice_d": "In Windows Settings, choose Time & language, then choose Date And Time, and select Set Time Zone Automatically and Set Time Automatically.",
    "correct_answer": "D",
    "explanation": "To always show the time and date correctly for the salesperson\u2019s location, you would need to enable both Set time zone automatically and Set time automatically, as shown in the graphic. Sync now, which synchronizes your clock, would work in the moment but will not automatically change the time and time zone as the salesperson travels.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      49,
      26,
      47,
      7,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 555,
    "question": "One of your Windows 10 users has limited eyesight and has asked you to enable voice activation for as many applications as possible. Where can this be done?",
    "choice_a": "In the Control Panel, Default Programs",
    "choice_b": "In Windows Settings, under Privacy, Notifications",
    "choice_c": "In Windows Settings, under Privacy, Voice Activation",
    "choice_d": "In the Control Panel, Indexing Options",
    "correct_answer": "C",
    "explanation": "The Voice activation window of Privacy settings in Windows Settings will allow the user to turn on microphone access and choose which apps are allowed to use voice activation, even when the device is locked. The choices are slightly different in Windows 11. In Windows Settings, choose Privacy & security, then Speech. The setting is on by default. The Default Programs app of the Control Panel allows you to manage default applications for opening types of files, such as photos or mail by opening those settings in Windows Settings. By choosing Privacy, then Notifications in the Windows Setting, you can allow or deny applications to access your notifications. The Control Panel\u2019s Indexing Options look at words in and metadata of files to provide faster file searches.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      81,
      48,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 556,
    "question": "You are working with a customer that has a small workgroup (peer-to-peer) network. The employee computers have a program that requires using the <code>X</code> drive. Several computer users need to be able to access this drive, which is actually a shared folder located on the manager\u2019s PC. What can you do to make this drive available for other computers to access as Drive <code>X:\\</code>? (Choose two.)",
    "choice_a": "On each client computer, open File Explorer, right-click on This PC (or the name of the PC), and then click Map Network Drive. Next to Drive:, choose <code>X:</code>, and then navigate to the shared resource.",
    "choice_b": "On the manager\u2019s PC, navigate to the shared folder, and then right-click on it and choose Map Network Drive.",
    "choice_c": "On the manager\u2019s PC, ensure that each user who will connect to the manager\u2019s PC has a user account.",
    "choice_d": "On the client computer, create a folder called <code>Drive X</code>, and then, on the manager\u2019s PC, map drive <code>X:</code> to that folder.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "In a workgroup (peer-to-peer) network, you would first need to ensure that each person who will be using the shared resource has a username and password on the manager\u2019s computer. The resource would then be shared on the manager\u2019s PC, and on each employee\u2019s computer, go into File Explorer, click on This PC, then Map Network Drive and follow the onscreen prompts to map drive <code>X:\\</code> to that shared resource.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      64,
      59,
      72,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 557,
    "question": "You are setting up a network for a very small company. It has a total of 10 computers running a mix of Windows 11 Home and Windows 11 Pro computers, and it has a network-attached printer. What will you use to allow the company to share files and its printer?",
    "choice_a": "Domain",
    "choice_b": "Workgroup",
    "choice_c": "Homegroup",
    "choice_d": "Crossover cables",
    "correct_answer": "B",
    "explanation": "To have a domain, you would need a Domain Controller (DC), for which the company would need Windows Server software installed on a network-connected computer. They only have Windows 10 workstations. Homegroups were a networking scheme that shared a computer\u2019s libraries with other people on the same Homegroup, but Homegroups are no longer an option. Crossover cables are not a practical way to share anything among 10 computers. By default, the computers would belong to the workgroup named workgroup. Each computer that is sharing a resource would need to have the user they are sharing with listed on that computer, then the person sharing information could right-click a folder and choose Give access to, then Specific people, and choose with whom they want to share that particular resource. Workgroups are great for small groups of people, but if there are more than 20 or 30 people in the group, you\u2019ll likely want to move up to a Domain Controller and centralized security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      68,
      20,
      18,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 558,
    "question": "A user\u2019s Windows workstation seems to be using an excessive amount of memory. Which management tool could you use to identify the application that is causing the problem?",
    "choice_a": "Performance Monitor",
    "choice_b": "Computer Management",
    "choice_c": "Windows Memory Diagnostics",
    "choice_d": "Processes tab of Task Manager",
    "correct_answer": "D",
    "explanation": "One of Task Manager\u2019s many capabilities is allowing you to see what resources (e.g., memory, Central Processing Unit [CPU], Graphics Processing Unit [GPU], network, and disk) are being used by application, and it allows you to end the process or the entire process tree to free up those resources. Performance Monitor will show resources used but not by application. Computer Management gives access to several other resources but not Task Manager, while Windows Memory Diagnostics is used to test the health of Random Access Memory (RAM) modules.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      27,
      43,
      31,
      28,
      3
    ],
    "source": "9781394330348"
  },
  {
    "id": 559,
    "question": "The CEO will be attending several meetings whose discussions must remain confidential. They want to ensure that the microphone on their Windows 11 PC is not available while they are using certain apps. Where can these settings be configured?",
    "choice_a": "In Windows Settings, choose Privacy & Security and then Microphone.",
    "choice_b": "Device Manager",
    "choice_c": "Computer Management",
    "choice_d": "In Windows Settings, choose Personalization.",
    "correct_answer": "A",
    "explanation": "In Windows 11 Settings, choosing Privacy & security, then Microphone opens a window that provides granular settings for microphone use, including which apps can use the microphone. Device Manager could be used to disable the microphone, but it would be for all purposes. Computer Management provides access to several tools, but not granular microphone settings. In Windows Settings, Personalization options allow the user to change settings, such as background, colors, and lock screen. In Windows 10, the only difference is that you would choose Privacy, not Privacy & security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      48,
      28,
      32,
      22
    ],
    "source": "9781394330348"
  },
  {
    "id": 560,
    "question": "You are manually configuring IPv4 addresses on a computer. The IP address is <code>200.100.1.10</code>, and the network number is <code>200.100.0.0.</code> What is the appropriate subnet mask for this computer?",
    "choice_a": "<code>200.100.0.0</code>",
    "choice_b": "<code>255.255.0.0</code>",
    "choice_c": "<code>0.0.255.255</code>",
    "choice_d": "<code>192.168.0.0</code>",
    "correct_answer": "B",
    "explanation": "The best way to understand IPv4 addressing is to convert the IP address and subnet mask to binary numbers. This is essentially what the operating system is looking at when determining the network and host portion of an IP address. What we see as dotted decimal notation is seen by the computer as four sets of eight binary bits (either a 1 or a 0). In the subnet mask, a binary 1 indicates that the position of that bit is part of the network number, and a 0 indicates that it is part of the host number. Network numbers always go consecutively from left to right with no breaks between. Eight binary bits that are all ones (11111111) equates to 255 in decimal, so the maximum value of a subnet mask\u2019s octet is 255. Choices A and D are invalid subnet masks because for a number to exist in the second octet from the left, the first octet would need to be all ones, or 255. Choice C is an invalid subnet mask because the ones indicating the network number would be in the first octets reading from left to right, not the last. If you compare the IP address of <code>200.100.1.10</code> to the subnet mask in choice B, <code>255.255.0.0</code>, you can see that the first two octets are network number and the last two are host numbers, making the network number <code>200.100.0.0</code> for that IP address and subnet mask combination. The host computer is then <code>0.0.1.10</code>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      66,
      70,
      106,
      59
    ],
    "source": "9781394330348"
  },
  {
    "id": 561,
    "question": "You are configuring a Windows client computer on a network that has a DHCP server and a DNS server attached. From where will the computer get a dynamic IP address and subnet mask?",
    "choice_a": "You will manually configure them in Windows Settings by choosing Personalization.",
    "choice_b": "You will manually configure them in Windows Settings by choosing Network & Internet.",
    "choice_c": "It will automatically get them from the DHCP server.",
    "choice_d": "It will automatically get them from the DNS server.",
    "correct_answer": "C",
    "explanation": "The default setting for obtaining an IP address is automatic, which means that the computer will look for a Dynamic Host Configuration Protocol (DHCP) server to assign it an IP address and subnet mask automatically. No manual configuration is required, but in Windows 11 if you open Windows Settings and click on Network & Internet, then click on Properties of the network connection you want to change, and then click Edit next to IP assignment, you can change the default settings to manual. The process is the same for IPv6, except that you would choose IPv6 instead of IPv4 once you\u2019re on the Edit screen. This can also be done through the Control Panel, by clicking on Network and Sharing Center instead of Network & Internet, then clicking on Change adapter settings and right-clicking on the network connection you want to change. Choose properties, then click on IPv4 and click on configure. Your screen should be similar to the following figure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      71,
      66,
      58,
      34
    ],
    "source": "9781394330348"
  },
  {
    "id": 562,
    "question": "You have been told to configure a static IP of <code>110.110.1.5</code> for a server. This server will need to be able to access the Internet. Which of the following is not a required setting to configure?",
    "choice_a": "Default gateway",
    "choice_b": "IP address",
    "choice_c": "Proxy server",
    "choice_d": "Subnet mask",
    "correct_answer": "C",
    "explanation": "An IP address on a device can either be dynamic or static. In a static IP address, the minimum amount of information that needs to be configured is the IP address, subnet mask, and, if the computer will access the Internet or other networks, a default gateway. A proxy server is an added security measure between a device and the Internet. It is used to translate between protocols and filter out certain types of traffic, such as keeping inappropriate websites out and confidential data in the network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      67,
      106,
      1,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 563,
    "question": "Considering the graphic, what is most likely the IP address of a router?<img src=\"/question_assets/220-1202/c06f003.png\" alt=\"Screenshot of a Windows Command Prompt depicts output for a wireless LAN adapter Wi-Fi.\"/>\n\n<figcaption>Screenshot of a Windows Command Prompt depicts output for a wireless LAN adapter Wi-Fi.</figcaption>",
    "choice_a": "<code>192.168.1.242</code>",
    "choice_b": "<code>192.168.1.1</code>",
    "choice_c": "<code>CC-15-2A-CC-3B-31</code>",
    "choice_d": "<code>255.255.255.0</code>",
    "correct_answer": "B",
    "explanation": "Often on a network, especially a smaller one, the router will serve multiple purposes. In this scenario, it is the default gateway, the Dynamic Host Configuration Protocol (DHCP) server, and the Domain Name System (DNS) server. <code>192.168.1.1</code> is the address of the router, gateway, DHCP server, and DNS server. <code>192.168.1.242</code> is the local computer\u2019s IP address. CC-15-2A-CC-3B-31 is the Media Access Control (MAC) address, which is embedded in the computer\u2019s network interface card (NIC). <code>255.255.255.0</code> is the subnet mask.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      67,
      65,
      70,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 564,
    "question": "What security feature, common to iOS and iPad OS 16.4.1 or greater and macOS 13.3.1 or greater, automatically provides security updates that are installed on startup before the OS is even active?",
    "choice_a": "Sandbox",
    "choice_b": "File Quarantine",
    "choice_c": "RSR",
    "choice_d": "Antivirus",
    "correct_answer": "C",
    "explanation": "Rapid Security Response (RSR) is a feature of new iOS, iPad OS, and macOS systems. It automatically sends targeted fixes for security issues between software updates. For example, if there\u2019s a security update to Safari, it is loaded before the operating system (OS) on startup, or it may be deployed when the system is on, and sometimes will ask the user to restart Safari (but not always). Each RSR will update the OS number with a letter after, such as 16.4.1 (b). RSR is on by default but can be turned off in System Settings, General, Software updates, and Automatic updates (although that\u2019s not advisable!). Sandbox and File Quarantine are part of macOS\u2019s built-in antivirus protection that only requires you keep the system updated, which it will do automatically.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      93,
      6,
      5,
      78
    ],
    "source": "9781394330348"
  },
  {
    "id": 565,
    "question": "What is the purpose of a subnet mask?",
    "choice_a": "Identifies the network portion of an IPv4 address",
    "choice_b": "Identifies the network portion of an IPv6 address",
    "choice_c": "Masks (hides) part of the IP address from a hacker",
    "choice_d": "Masks (hides) the host number from a hacker",
    "correct_answer": "A",
    "explanation": "In IPv4 networking, a computer system will compare the subnet mask to the IP address to identify the network and host number of the IP address. IPv6 addresses don\u2019t use a subnet mask. IPv6 addresses consist of eight segments. The first three are a site prefix, the fourth is the subnet ID, and the last four segments are the interface ID, which is essentially the host address. The subnet mask doesn\u2019t hide anything.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      71,
      106,
      2,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 566,
    "question": "You\u2019ve been asked to help with a network for a company that has 50 computers. The company has been using workgroups, but they are getting too difficult to manage. There are an assortment of Windows 11 editions on the computers, including Home, Pro, and Enterprise. What will you do to set up the new network? (Choose two.)",
    "choice_a": "Upgrade all the Windows Home PCs to Windows Pro.",
    "choice_b": "Install a server with Active Directory.",
    "choice_c": "Downgrade all the Windows 11 Enterprise workstations to Windows 11 Pro.",
    "choice_d": "Upgrade all the workstations to Windows 11 Enterprise.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A network with that many computers (typically more than 10) needs a domain for security management. The Windows 11 Home edition PCs can\u2019t log in to a domain, so they would need to be upgraded to at least the Pro edition. It\u2019s not necessary to downgrade the Windows 11 Enterprise workstations to Windows 11 Pro or upgrade the workstations to Windows 11 Enterprise.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      64,
      20,
      72,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 567,
    "question": "You work for a multinational corporation. All the company laptops are configured to use United States English; however, a worker who speaks Bajan (Barbados English) would prefer to see apps and websites in their native language. Is this possible?",
    "choice_a": "No, this is not possible.",
    "choice_b": "Yes. Add English (Barbados) in the Control Panel, Programs and Features utility.",
    "choice_c": "Yes. Add English (Barbados) in Windows Settings, Time & language, Language section.",
    "choice_d": "Yes. but it will require reinstalling the OS in Bajan.",
    "correct_answer": "C",
    "explanation": "It is possible to view apps and websites in many languages and dialects. In Windows Settings, choose Time & language, then Language & region (see the following graphic). Click Add a language to choose the appropriate language to install if it isn\u2019t already installed, then click Next and install to install it and select the desired language as the preferred language. The language may require downloading a language pack. Icons beside the installed language are used to indicate what is available in that language.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      34,
      46,
      6,
      29,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 568,
    "question": "A Windows workstation has an application that appears to be locked up, but the keyboard is responsive in other applications. What system tool can you use to terminate the nonresponsive application?",
    "choice_a": "Event Viewer",
    "choice_b": "Task Manager",
    "choice_c": "Computer Management",
    "choice_d": "<code>msconfig.exe</code>",
    "correct_answer": "B",
    "explanation": "The Processes tab of Task Manager (<code>taskmgr</code>) will allow you to terminate the non-responsive application. Event Viewer (<code>eventvwr.msc</code>) keeps a log of security, application, and system events. Computer Management (<code>compmgmt.msc</code>) gives access to several other resources, but not one that lets you end wayward applications. The <code>msconfig.exe</code> application launches System Configuration, which gives you access to boot configuration settings, running services, and links to other Windows tools.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      28,
      30,
      83
    ],
    "source": "9781394330348"
  },
  {
    "id": 569,
    "question": "Which of the following Control Panel utilities enables configuration of a proxy server?",
    "choice_a": "Internet Options",
    "choice_b": "File Explorer Options",
    "choice_c": "Device Manager",
    "choice_d": "Security and Maintenance",
    "correct_answer": "A",
    "explanation": "In the Control Panel, choose Internet Options and select the Connections tab, then LAN. LAN settings will take you to a window that enables configuration of a proxy server. Proxy server settings can also be configured through Windows Settings, by choosing Network & Internet, then Proxy. The File Explorer Options utility is used to configure how files and folders are viewed and how searches are conducted. Device Manager is a great utility to use when troubleshooting hardware issues, and the Security and Maintenance utility provides a quick way to see if security is configured on the PC and any recent messages.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      67,
      34,
      33,
      66
    ],
    "source": "9781394330348"
  },
  {
    "id": 570,
    "question": "Considering the following graphic, what do you know about the network configuration of this computer? (Choose two.)<img src=\"/question_assets/220-1202/c06f004.png\" alt=\"Screenshot of a Windows Command Prompt depicts output for a wireless LAN adapter Wi-Fi.\"/>\n\n<figcaption>Screenshot of a Windows Command Prompt depicts output for a wireless LAN adapter Wi-Fi.</figcaption>",
    "choice_a": "The PC is configured to obtain an address dynamically.",
    "choice_b": "This computer is getting its address from a DHCP server.",
    "choice_c": "The IPv4 address is a routable address.",
    "choice_d": "The internal network number is <code>192.168.1.0</code>.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The computer is configured to obtain the address dynamically because the graphic says \u201cYes\u201d next to Dynamic Host Control Protocol (DHCP) enabled. If it was set to obtain an address dynamically but not able to reach the DHCP server, the operating system would have obtained an address using Automatic Private IP Addressing (APIPA) and would have been in the range that begins with <code>169.254.0.0</code>, so this PC is not being assigned an APIPA address. You don\u2019t know for sure that it is getting its address from the DHCP server because someone could have manually configured it to the IP address shown. Addresses in the <code>192.168.<i>x.x</i></code> range are non-routable addresses, meaning that they can only be used internally. To reach the Internet, they would go through a gateway (router) that has Network Address Translation (NAT) enabled. (Essentially all modern routers use NAT.) You know the network number is <code>192.168.1.0</code> and the host address is <code>0.0.0.242</code> by comparing the IP address to the subnet mask.<img src=\"/question_assets/220-1202/cappa001.png\" alt=\"Computer settings screenshot depicts Language and region options for Windows display language and preferred languages.\"/>\n\n<figcaption>Computer settings screenshot depicts Language and region options for Windows display language and preferred languages.</figcaption>",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      58,
      66,
      71,
      70,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 571,
    "question": "Given the IP address of <code>fe80::308c:fee2:2abc:8337</code>, what do you know about this address? (Choose two.)",
    "choice_a": "It is an IPv4 address.",
    "choice_b": "It is an IPv6 address.",
    "choice_c": "The subnet mask is 0.",
    "choice_d": "It is not routable.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "IPv4 addresses are 32-bits long and consist of four octets, which is a group of eight bits each, separated by a period (.). They are normally presented in dotted decimal notation meaning each group of eight bits is shown as a decimal number less than 256, with a period (.) between each number such as <code>192.168.1.1</code>. IPv6 addresses are a 128-bit IP address presented as eight segments of four hexadecimal numbers each, separated by a colon (:). Where the hexadecimal number is 0 in any segment, it can be omitted and replaced simply by double colons (::). If consecutive segments are 0, they can all be replaced by a single set of double colons, but only one set of double colons can exist in any given address, otherwise you wouldn\u2019t be able to tell how many sets of 0 are in each part of the IP address. In the example <code>fe80::308c:fee2:dabc:8337</code>, the expanded address would be <code>fe80:0:0:0:308c:fee2:dabc:8337</code>. The first three segments (48 bits) are the site prefix, and the fourth segment (16 bits) is the subnet ID, also known as private topology or site topology. The site prefix and subnet number together constitute the subnet prefix. The last four segments (64 bits) are the interface ID, also sometimes called a token. The subnet ID in this case would be <code>0</code>. IPv6 addresses do not have a subnet mask. The value of the first octet, <code>fe80</code>, tells you that this number is a link-local address, an internal number only, not routable.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      5,
      1,
      7,
      20,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 572,
    "question": "You see an IP address with <code>/48</code> after it. What does the <code>/48</code> tell you? (Choose two.)",
    "choice_a": "There are 48 PCs on this network.",
    "choice_b": "The prefix length is 48 bits.",
    "choice_c": "This network uses the IPv6 addressing scheme.",
    "choice_d": "This network uses the IPv4 addressing scheme.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The IP address in question must be IPv6 because IPv4 addresses are only 32-bits long. The <code>/</code> indicates that the number behind it is the number of bits for the network address in IPv4 or the prefix length in IPv6, both of which identify the network number of an IP address. In IPv4, this is called Classless Inter-domain Routing (CIDR) notation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      59,
      70,
      106,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 573,
    "question": "Which of the following IPv6 address types are routable?",
    "choice_a": "Global unicast",
    "choice_b": "Link-local",
    "choice_c": "Loopback",
    "choice_d": "Unique local",
    "correct_answer": "A",
    "explanation": "Global unicast addresses are routable, like IPv4 public addresses. Meaning that a global unicast address can be reached by any other PC on the Internet, unless you put security measures in place like a firewall. You would likely want a global unicast address on a web server but not on your workstation. Link-local addresses can only be used to communicate with devices that are on the same local link. They will start with <code>fe80</code> and are assigned in a manner similar to IPv4 APIPA addresses. The IPv6 loopback address is <code>::1</code> and is used for testing just like the loopback address in IPv4 (127.0.0.1). A unique local address is akin to an IPv4 private address. Unique local addresses are non-routable, so a computer with only a unique local address and a link-local address (but no global unicast address) would need a router with IPv6 NAT to access the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 574,
    "question": "You are on a Windows computer that is joined to a workgroup. You\u2019re going home and ready to shut your computer down but want to be certain that no one is using the shared files on the computer first. Where would you go to check?",
    "choice_a": "Task Manager, Users tab",
    "choice_b": "Users and Groups",
    "choice_c": "Performance Monitor",
    "choice_d": "Control Panel, Networking",
    "correct_answer": "A",
    "explanation": "The Task Manager\u2019s Users tab provides information about any users connected to the local machine. The Users tab shows the user\u2019s identification and the resources they are using. Right-click and choose Expand to see what they are using on your computer. You can also disconnect them from here, but it might be nicer to message them first.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      7,
      28,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 575,
    "question": "You have a workstation with a 64-bit processor and no operating system. When you install an operating system on the workstation, which of the following is true?",
    "choice_a": "You can only install a 64-bit operating system.",
    "choice_b": "You can only install a 32-bit operating system.",
    "choice_c": "You can install either a 64-bit or 32-bit operating system.",
    "choice_d": "You can install a 64-bit operating system or a 32-bit operating system running in compatibility mode.",
    "correct_answer": "C",
    "explanation": "With a 64-bit processor, you can install either a 32-bit or 64-bit operating system (OS). A 32-bit system will not be able to take advantage of the full processing power of the 64-bit processor though. Windows 11 requires a 64-bit processor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      8,
      5,
      45,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 576,
    "question": "A customer has an older PC on which they would like to install Windows 11 Pro. What is the minimum processor speed they must have to install Windows 11?",
    "choice_a": "1 GHz, 32-bit",
    "choice_b": "1 GHz, 64-bit",
    "choice_c": "2 GHz",
    "choice_d": "4 GHz",
    "correct_answer": "B",
    "explanation": "Windows 11 minimum requirements are a 1 GHz or faster 64-bit processor that is on the approved list and has at least two cores, and 4 GB of RAM. Available storage must be at least 64 GB. Firmware must be the newer Unified Extensible Firmware Interface (UEFI) not the older Basic Input/Output System (BIOS) interface, and it must be Secure Boot capable. The system must support Trusted Platform Module 2.0. Graphics compatible with Direct X 12, WDDM 2.0 driver and 720p display, and a Home version requires Internet access and a Microsoft account for setup. These are the minimums, and in reality, it won\u2019t run well unless there is a faster processor and much more Random Access Memory (RAM).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      44,
      19,
      45,
      8,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 577,
    "question": "Which of the following is not a Windows edition?",
    "choice_a": "Home",
    "choice_b": "Enterprise",
    "choice_c": "Pro Artist",
    "choice_d": "Pro Workstation",
    "correct_answer": "C",
    "explanation": "Pro Artist is not a valid Windows edition. Windows is available in many different editions. The editions on the CompTIA A+ exam are Home, Pro, Pro for Workstations, and Enterprise. Other Windows editions (not on the CompTIA A+ exam) include Education, Windows in S mode, and Windows for IoT.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      18,
      5,
      8,
      34,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 578,
    "question": "Which of the following Windows editions doesn\u2019t include media-related technologies?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Enterprise",
    "choice_d": "Pro N",
    "correct_answer": "D",
    "explanation": "Windows N editions do not include media related technologies, like Windows media player. You can add them by downloading a media feature pack from the Microsoft website.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      5,
      46,
      48,
      49
    ],
    "source": "9781394330348"
  },
  {
    "id": 579,
    "question": "You\u2019re troubleshooting a PC and want to see which ports TCP is connected on and the IP addresses of those connections. What command-line utility can you use to see statistics on network interfaces?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>nbtstat</code>",
    "choice_c": "<code>nslookup</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "D",
    "explanation": "The <code>netstat</code> command-line utility presents statistics related to the installed network interfaces. By default, on a Windows machine, running the command will display a list of connections and the associated protocol, the source and target address, and the current state of the connection. <code>ping</code> is used to test connectivity between two computers, <code>nbtstat</code> is used for troubleshooting Network Basic Input/Output System (NetBIOS) over Transmission Control Protocol/Internet Protocol (TCP/IP), and <code>nslookup</code> is used to query a Domain Name System (DNS) server.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      59,
      58,
      106,
      68,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 580,
    "question": "A new technician asked you how to use a Windows command. In the spirit of sharing knowledge with others, you show them how to get help on many commands instead of just one. Which one of the following does not work with any commands?",
    "choice_a": "<code>help [<i>command name</i>]</code>",
    "choice_b": "<code>[<i>command name</i>] help</code>",
    "choice_c": "<code>[<i>command name</i>] /?</code>",
    "choice_d": "<code>/? [<i>command name</i>]</code>",
    "correct_answer": "D",
    "explanation": "The <code>/? [<i>command name</i>]</code> syntax simply does not work. The CompTIA A+ objectives list <code>[<i>command name</i>] /?</code>, but there are other ways to get help in the Command Prompt. Typing simply <code>help</code> and pressing <b>Enter</b> at a command prompt will provide a list of commands that <code>help</code> can help you with. Armed with that information, you can type <code>help [<i>command name</i>]</code>, for example, <code>help xcopy</code>, and you will see the syntax, switches, and explanations for how the command works. Some commands, for example, <code>sfc</code>, will not work with that help syntax. To find help with <code>sfc</code>, you would type <code>sfc /?, sfc /help,</code> or <code>sfc help</code>, but none of those options work with all commands. For example, <code>gpresult /?</code> works, but <code>gpresult /help</code> will tell you that <code>/help</code> is an invalid option. Remember that the option CompTIA wants you to know is <code>[<i>command name</i>] /?</code>. There are upwards of 200 commands supported by Windows 10 and Windows 11. CompTIA\u2019s A+ objectives list just a few, so focus on those.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      56,
      63,
      57,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 581,
    "question": "Which Windows utility allows you to view error messages generated by system events, applications, or login failures?",
    "choice_a": "System Information",
    "choice_b": "Windows Defender",
    "choice_c": "Event Viewer",
    "choice_d": "Disk Management",
    "correct_answer": "C",
    "explanation": "Event Viewer (<code>eventvwr.msc</code>) is a Windows tool available in most versions, and it allows you to view application error logs, security audit records, and system errors. System Information (<code>msinfo32.exe</code>) shows a plethora of information about the hardware and software of a system, but it doesn\u2019t keep a log of changes. It provides static information available at the time you launch the program. Windows Defender is a Windows 10 Control Panel utility that provides a software firewall for the local computer. Disk Management (<code>diskmgmt.msc</code>) is a graphic utility for creating and formatting volumes on any physical drives attached to the system. Worth noting is that Disk Management shows you the physical disks attached to the system and their volumes, while opening File Explorer and choosing This PC shows only the logical volumes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      62,
      32,
      30,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 582,
    "question": "You want to know how much RAM is in this system. Which of the following commands should you type in the search bar and launch to quickly bring up the window shown in the graphic?<img src=\"/question_assets/220-1202/c06f005.png\" alt=\"Screenshot of Windows System Information depicts a detailed system summary of a laptop's hardware and software specifications.\"/>\n\n<figcaption>Screenshot of Windows System Information depicts a detailed system summary of a laptop's hardware and software specifications.</figcaption>",
    "choice_a": "<code>msinfo32.exe</code>",
    "choice_b": "<code>resmon.exe</code>",
    "choice_c": "<code>msconfig.exe</code>",
    "choice_d": "<code>devmgmt.msc</code>",
    "correct_answer": "A",
    "explanation": "The screen shown is System Information. It quickly provides a snapshot of the system\u2019s hardware and software including the operating system (OS) version, Random Access Memory (RAM), processor, motherboard and much more. The program to launch it is <code>msinfo32.exe.</code> Resource Monitor\u2019s program name is <code>resmon.exe.</code> Unlike System Monitor, Resource Monitor is changing every moment, alerting you to resources that are overused or experiencing difficulty. System Configuration (<code>msconfig.exe</code>) has been appearing in Windows OSs for many years, but its features have changed over time. In Windows 10 and Windows 11, this utility is used to control how Windows boots up and to provide quick access to other Windows tools. Finally, <code>devmgmt.msc</code> is Device Manager, which should be your go-to app when resolving hardware issues. From there, you can update or install drivers, see what isn\u2019t working, and disable hardware if need be.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      31,
      29,
      30,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 583,
    "question": "In Windows 11, preconfigured power plans can be found in Settings, System, Power and Battery, and Power Mode. Which of the following isn\u2019t a default power mode?",
    "choice_a": "Best Power Efficiency",
    "choice_b": "Balanced",
    "choice_c": "Fast",
    "choice_d": "Best Performance",
    "correct_answer": "C",
    "explanation": "The CompTIA A+ objectives don\u2019t specifically list the power modes in Windows 11 settings. They do, however, mention power plans, which have default power settings, just like power modes. If a user needs a custom power plan, they can be created in the Power Options utility of the Control Panel. Different options, such as Hibernate or Standby, can be configured for when the laptop is on battery power versus when it\u2019s plugged in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      5,
      1,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 584,
    "question": "Your manager has a laptop running Windows. They want to configure the laptop so that when it is on battery power, the display shuts off after five minutes of inactivity. When the laptop is plugged in, the display needs to stay active for up to 45 minutes of inactivity. Which Control Panel utility is used to configure these settings?",
    "choice_a": "Power Options",
    "choice_b": "Computer Management",
    "choice_c": "Performance Monitor",
    "choice_d": "System Configuration",
    "correct_answer": "A",
    "explanation": "A power plan needs to be created with the user\u2019s desired settings. This is done in the Power Options utility of the Control Panel. Different options, such as Hibernate or Standby, can be configured for when the laptop is on battery power versus when it\u2019s plugged in. There are also power settings in Windows Settings, but they are not listed in the CompTIA A+ objectives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      30,
      1,
      7,
      9
    ],
    "source": "9781394330348"
  },
  {
    "id": 585,
    "question": "You need to work in the Command Prompt on a Windows PC. When you open the utility, you are at <code>C:\\window\\system32</code>. You need to work on the second partition, which is listed as <code>D:</code>. How do you navigate to the <code>D:</code> drive? Assume that you press Enter after the command.",
    "choice_a": "<code>root D:</code>",
    "choice_b": "<code>D:</code>",
    "choice_c": "<code>cd D:</code>",
    "choice_d": "<code>cd D:\\</code>",
    "correct_answer": "Unknown",
    "explanation": "",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      56,
      63,
      40,
      54,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 586,
    "question": "Which Windows Editions support up to four CPU sockets? (Choose two.)",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Windows Pro for Workstations and Enterprise editions support up to four physical Central Processing Unit (CPU) sockets and 6 TB of Random Access Memory (RAM). The Home edition supports one CPU socket and 128 GB of RAM, while the Pro edition supports a maximum of two CPU sockets and 2 TB of RAM.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      18,
      8,
      9,
      4,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 587,
    "question": "You have a workstation with a 32-bit processor and no operating system installed. When you install an operating system on the workstation, which of the following is true?",
    "choice_a": "You can only install a 32-bit operating system.",
    "choice_b": "You can install a 64-bit operating system, but it will run in compatibility mode.",
    "choice_c": "You can install either a 32-bit or 64-bit operating system, and either will run fine.",
    "choice_d": "You can install a 64-bit operating system, but it will only run half as fast.",
    "correct_answer": "A",
    "explanation": "A 32-bit processor doesn\u2019t have the capability to run a 64-bit operating system (OS) in any mode. It also won\u2019t be able to run a 64-bit program. It simply doesn\u2019t have a wide enough data path.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      2,
      8,
      5,
      1,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 588,
    "question": "You are reinstalling the Windows 10 Home 64-bit operating system on a friend\u2019s computer. What is the minimum storage space that must be available for the OS installation?",
    "choice_a": "1 GHz",
    "choice_b": "2 GHz",
    "choice_c": "20 GB",
    "choice_d": "64 GB",
    "correct_answer": "C",
    "explanation": "The minimum Windows 10 storage is 20 GB. Windows 11 has a minimum storage requirement of 64GB. Windows 10 questions are included to meet the CompTIA objectives. The two options measured in GHz are incorrect because GHz is a measure of speed, not storage. Windows 10\u2019s minimum requirements are a 1 GHz or faster processor or System on a Chip (SoC), DirectX 9 or later with Windows Display Driver Model (WDDM) 1.0 driver, and a minimum 800 \u00d7 600 display. For storage, the 32-bit version requires 16 GB, and the 64-bit version requires 20 GB available for the operating system (OS). Random Access Memory (RAM) requirements are 1 GB for the 32-bit OS, and 2 GB for the 64-bit OS. Keep in mind that these are the absolute minimum requirements, and that the OS will run but not as well as you have come to expect. In reality, a faster processor, more RAM, and more storage would be expected.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      8,
      2,
      9,
      44,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 589,
    "question": "You are in the Windows Command Prompt, using Run as Administrator. There is a directory named <code>d:\\files</code> that you want to delete. It currently has six subdirectories and dozens of files in it. Which command should you use to delete <code>d:\\files</code>?",
    "choice_a": "<code>del d:\\files /s</code>",
    "choice_b": "<code>del d:\\files /q</code>",
    "choice_c": "<code>rmdir d:\\files /s</code>",
    "choice_d": "<code>rmdir d:\\files /q</code>",
    "correct_answer": "C",
    "explanation": "The <code>cd</code>, <code>md</code>, and <code>rd</code> commands are used to change, make, and remove directories, respectively. They\u2019re shorthand versions of the <code>chdir</code>, <code>mkdir</code>, and <code>rmdir</code> commands. The <code>rd</code> or <code>rmdir</code> command will only delete empty directories by default. With that command, the <code>/s</code> switch will remove all subdirectories and files. The <code>/q</code> switch is quiet mode, and when used with the <code>/s</code> switch, it will not ask if it\u2019s okay to remove all the files and subdirectories; it will remove them without warning. The <code>del</code> command is for deleting files.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      56,
      57,
      62,
      63,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 590,
    "question": "You\u2019ve installed several identical new PCs and want to capture a baseline of their performance for future troubleshooting. What tool would be best suited for that purpose?",
    "choice_a": "Event Viewer",
    "choice_b": "Performance Monitor",
    "choice_c": "System Information",
    "choice_d": "System Configuration",
    "correct_answer": "B",
    "explanation": "Performance Monitor (<code>perfmon.msc</code>) offers a graphic display of a wide range of counters to track how well hardware, such as Random Access Memory (RAM), drives and Central Processing Units (CPUs), are performing over time. Those reports can be printed and filed as a baseline to compare to future performance and used to identify bottlenecks in a system. Event Viewer (<code>eventvwr.msc</code>) keeps logs of system, application, and security events that can be used for activities such as detecting attempted unauthorized access to resources. System Information provides a snapshot of the system\u2019s hardware and software, including the operating system (OS) version, RAM, processor, motherboard, and much more. The program to launch it is <code>msinfo32.exe.</code> System Configuration (<code>msconfig.exe</code>) has been appearing in Windows OSs for many versions now, but its features have changed over time. In Windows 10 and Windows 11, this utility is used to control how Windows boots up and to provide quick access to other Windows tools.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      28,
      27,
      44,
      30,
      42
    ],
    "source": "9781394330348"
  },
  {
    "id": 591,
    "question": "A user has called the Help Desk saying that the Internet is down on their Windows computer. After asking a few questions, you want to examine their network configuration to determine the cause of their computer\u2019s connectivity problem. You\u2019ve talked them through accessing the Windows Command Prompt. What command will you have them type so they can read the computer configuration to you?",
    "choice_a": "<code>ipconfig /all</code>",
    "choice_b": "<code>ipconfig /renew</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "A",
    "explanation": "The <code>ipconfig</code> command is used to display information about the computer\u2019s current network configurations. The <code>/all</code> switch will show more detailed information than <code>ipconfig</code> alone will, such as whether Dynamic Host Configuration Protocol (DHCP) is enabled and what the Domain Name System (DNS) settings are. Typing <code>ipconfig /renew</code> will request a new Internet Protocol (IP) address from a DHCP server, if one is available to the host PC. The macOS/Linux equivalent of <code>ipconfig</code> is <code>ip</code> (replacing the old <code>ifconfig</code> command) and <code>tracert</code> shows the path a packet takes to get from one computer to another.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      63,
      62,
      56,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 592,
    "question": "A Windows 11 computer user that you support is having difficulty reading the words on the screen, because they have a visual impairment making distinguishing colors difficult for them. What can you change in Windows Settings to make their screen more readable?",
    "choice_a": "In Windows Settings, go to Personalization and then Fonts.",
    "choice_b": "In Windows Settings, go to Personalization and then Background, and choose High Contrast Settings.",
    "choice_c": "In Windows Settings, select System, then Display, and then Nightlight.",
    "choice_d": "In Windows Settings, select Accessibility, and click on Contrast Themes to select a theme that will work better for them.",
    "correct_answer": "D",
    "explanation": "In Windows 11 Settings, Contrast themes is found under Accessibility. In Windows 10, the High contrast settings option makes the colors more distinct and easier for visually impaired users to distinguish between them. It might make it easier for the user to read the words on the screen. The setting is also available in Windows Settings, Personalization, Colors, then scroll down and choose Contrast Themes. In Windows 10, these were under Settings, Personalization, Themes and Settings, and Ease of Access.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      22,
      34,
      48,
      18,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 593,
    "question": "You need to work at a command prompt on a Windows PC. When you open the utility, you are at <code>C:\\window\\system32</code>. You need to be at the root of the C drive for what you\u2019ll be doing. How do you get to <code>C:\\</code>? Assume you would press Enter after the command.",
    "choice_a": "<code>cd c:</code>",
    "choice_b": "<code>cd\\</code>",
    "choice_c": "<code>C:\\</code>",
    "choice_d": "<code>cd root</code>",
    "correct_answer": "B",
    "explanation": "<code>cd\\</code> will take you to the root of whatever drive you are on. You could also type <code>cd</code> and press Enter to go back one directory at a time. For example, to go from <code>C:\\windows\\system32</code> to <code>C:\\</code>, you would need to type <code>cd..[enter]</code>, <code>cd..[enter]</code>. The other options will not get you to the root of the C drive.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      63,
      59,
      57,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 594,
    "question": "A laptop user has traveled to visit a client and forgot their power adapter. They are heading to lunch with the client and want to conserve their battery power but enable the fastest possible startup when they get back, with the applications already open. Which power mode will conserve battery life but enable the fastest startup?",
    "choice_a": "Shut down",
    "choice_b": "Sleep/suspend",
    "choice_c": "Hibernate",
    "choice_d": "Resting",
    "correct_answer": "B",
    "explanation": "Sleep stores everything that\u2019s open in Random Access Memory (RAM) and enters a low power state. The display and drives aren\u2019t using power, but power is needed to continually refresh memory so it can retain the information. It uses very little power, but \u201cwakes up\u201d very quickly with everything open as it was. Sleep in some computer systems and other electronic devices may be called Standby or Suspend. Shutting the computer down would cause the laptop to use no power but starting up would take longer. Hibernate stores open programs and data to the hard drive and once hibernated would use no power, but it will not resume its state as quickly as Sleep would. There is no resting power state.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      4,
      1,
      6,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 595,
    "question": "Which of the following operating systems is open-source, allowing its users to customize it as they wish to suit their individual needs?",
    "choice_a": "Windows",
    "choice_b": "Linux",
    "choice_c": "macOS",
    "choice_d": "Chrome OS",
    "correct_answer": "B",
    "explanation": "Linux is free and open-source, so a user can modify the operating system\u2019s source code to behave and appear however they choose. The downside is that there might not be as much support if something goes wrong, as there would be with a commercial package. Windows and macOS are closed-source commercial operating systems (OSs), meaning that you pay for them and can use their utilities to configure the OS, but you don\u2019t have access to the OS\u2019s source code. Chrome OS is a commercial, proprietary OS found only on Chromebooks, but there is an open-source version called Chromium OS.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      73,
      1,
      6,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 596,
    "question": "What does Keychain provide for the user in macOS?",
    "choice_a": "Password management",
    "choice_b": "Local file sharing",
    "choice_c": "Certificate management",
    "choice_d": "Screen protection",
    "correct_answer": "A",
    "explanation": "Remembering the passwords for various websites is easily managed in macOS with Keychain. It does not provide the other three options.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      85,
      78,
      34,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 597,
    "question": "You\u2019re installing Windows 11 on a workstation. Which of the following do not meet the minimum system requirements? (Choose two.)",
    "choice_a": "20 GB storage",
    "choice_b": "2 GB RAM",
    "choice_c": "UEFI",
    "choice_d": "TPM 2.0",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Windows 11 minimum requirements are:<ul><li>1 GHz processor</li><li>4 GB Random Access Memory (RAM)</li><li>64 GB or larger storage</li><li>Unified Extensible Firmware Interface (UEFI), not the older Basic Input/Output (BIOS) interface</li><li>Trusted Platform Module (TPM) version 2.0</li><li>Graphics card compatible with DirectX 12 or later with WDDM 2.0 driver</li><li>720p high-definition display at least 9 inches diagonally</li></ul><p>Other specialized editions and advanced features may have additional requirements.</p>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      44,
      8,
      19,
      45,
      46
    ],
    "source": "9781394330348"
  },
  {
    "id": 598,
    "question": "Which Windows edition supports up to 2 TB of RAM?",
    "choice_a": "Home",
    "choice_b": "Pro",
    "choice_c": "Pro for Workstations",
    "choice_d": "Enterprise",
    "correct_answer": "B",
    "explanation": "Windows Pro editions (64-bit, Windows 10 or Windows 11) support up to 2 TB of Random Access Memory (RAM) and a maximum of two Central Processing Unit (CPU) sockets. The Home editions support only 128 GB of RAM and one CPU. Windows Pro for Workstations and Enterprise editions support up to four physical CPU sockets and 6 TB of RAM. Windows 10 has a 32-bit edition. Any operating system (OS) or CPU that is 32-bit only supports a maximum of 4 GB of RAM.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      2,
      18,
      19,
      44
    ],
    "source": "9781394330348"
  },
  {
    "id": 599,
    "question": "You work at home with a computer that has Windows Home edition installed. You\u2019re trying to run <code>gpedit.msc</code> to establish group policies on the computer that will limit what your children can do on it. For some reason, <code>gpedit.msc</code> won\u2019t launch. What should you do?",
    "choice_a": "Reboot the computer, and then run <code>gpedit.msc</code>.",
    "choice_b": "Upgrade to Windows Pro edition.",
    "choice_c": "Install Windows Active Directory.",
    "choice_d": "Launch it from the Administrative tools.",
    "correct_answer": "B",
    "explanation": "The Local Group Policy Editor (<code>gpedit.msc</code>) is not available in the Home editions of Windows. It is available in the Pro, Pro for Workstation, and Pro for Enterprise editions. You don\u2019t need have Active Directory (AD) installed on a server to use the Local Group Policy Editor, although it is available there as well. Going to Administrative tools won\u2019t help because the Group Policy Editor is not available anywhere on Windows Home editions.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      21,
      28,
      20,
      64
    ],
    "source": "9781394330348"
  },
  {
    "id": 600,
    "question": "You are on a Windows computer at the command prompt, on the C drive. You need to create a directory named <code>files</code> on the <code>D:</code> drive. What is the proper command and syntax to do this?",
    "choice_a": "<code>cd d:\\files</code>",
    "choice_b": "<code>cd files d:\\</code>",
    "choice_c": "<code>md d:\\files</code>",
    "choice_d": "<code>md files d:\\</code>",
    "correct_answer": "C",
    "explanation": "The <code>cd</code>, <code>md</code>, and <code>rd</code> commands are used to change, make, and remove directories, respectively. They\u2019re shorthand versions of the <code>chdir</code>, <code>mkdir</code>, and <code>rmdir</code> commands. The syntax of the command is <code>md [<i>drive</i>:]<i>path</i></code>, so the directory would appear after the drive letter when typing the command. The drive letter must be included because it is not the drive that you are on.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      63,
      57,
      62,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 601,
    "question": "You will be installing several new resource-intensive applications on a Windows workstation, and the user has concerns over system performance. You want to monitor memory and CPU performance and set up the workstation so that it logs performance over time. Which utility should you use to set this up?",
    "choice_a": "Resource Monitor",
    "choice_b": "Performance Monitor",
    "choice_c": "Task Viewer",
    "choice_d": "Event Viewer",
    "correct_answer": "B",
    "explanation": "There are three tools that quickly show you Central Processing Unit (CPU) and memory usage in Windows. They are Resource Monitor, Performance Monitor, and Task Manager. The only one that lets you set up logs is Performance Monitor. It will collect counter information and then send that information to a console or event log. Event Viewer logs system, application, and security events but not performance.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      43,
      31,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 602,
    "question": "You don\u2019t like the pictures that are on your desktop that automatically change from time to time. Where will you go in Windows Settings to change this setting?",
    "choice_a": "Accounts",
    "choice_b": "Apps",
    "choice_c": "Personalization",
    "choice_d": "System",
    "correct_answer": "C",
    "explanation": "From the Personalization menu of Windows Settings, you can change the desktop theme and background colors. Accounts enables the user to manage what accounts have access to this computer and at what level. The Apps settings deal with application-specific parameters and not operating system (OS) settings. Finally, the System settings in Windows Settings has a multitude of settings that relate to the system but not the image that appears on the desktop.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      22,
      34,
      48,
      32,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 603,
    "question": "What operating system developed by Google is used on tablets or laptops used mainly for online and Android applications?",
    "choice_a": "Ubuntu",
    "choice_b": "iOS",
    "choice_c": "Windows 11 Pro",
    "choice_d": "Chrome OS",
    "correct_answer": "D",
    "explanation": "The Google Chrome OS was developed by Google. It comes preinstalled on laptops and tablets called Chromebooks. A freeware version, Chromium OS, can be installed on tablets, smartphones, laptops, and desktops. Ubuntu is based on the open-source Linux OS kernel. iOS is Apple\u2019s proprietary operating system (OS) and Windows 11 Pro was developed by Microsoft.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      4,
      1,
      6,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 604,
    "question": "On your laptop running macOS, what is the name of the utility used to browse through files and folders?",
    "choice_a": "Spotlight",
    "choice_b": "Remote Disc",
    "choice_c": "iCloud",
    "choice_d": "Finder",
    "correct_answer": "D",
    "explanation": "Finder in the macOS is very similar to File Explorer in Windows. Both allow you to browse through folders and find files, disks, and applications. Both can be used to change the view so entries can be seen as images, a list, a column, and so on. Spotlight is the tool for searching within macOS, and iCloud is similar to Microsoft\u2019s OneDrive for storage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      76,
      84,
      87,
      25
    ],
    "source": "9781394330348"
  },
  {
    "id": 605,
    "question": "You\u2019re troubleshooting a network connectivity issue and want to see if the local computer can reach a particular server on the Web. What command do you use?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>tracert</code>",
    "choice_c": "<code>ipconfig</code>",
    "choice_d": "<code>pathping</code>",
    "correct_answer": "A",
    "explanation": "The <code>ping</code> (i.e., packet Internet groper) command sends a series of four packets to a remote computer and waits for a reply. If the reply is received, you know that the local computer is able to reach the remote host. It also displays how long the transaction took. <code>ping</code> can be used with domain names like <u><code>Wiley.com</code></u>, or the IP address (if known). When <code>ping localhost</code> or <code>ping 127.0.0.1</code> or <code>ping::1</code> is run, the command verifies that Transmission Control Protocol/Internet Protocol (TCP/IP) is working on the local computer. <code>tracert</code> shows the routers that a packet traverses to reach its destination. <code>ipconfig</code> is used to view network configuration, and <code>pathping</code> is a combination of the abilities of <code>ping</code> and <code>tracert</code>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      58,
      106,
      63,
      98,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 606,
    "question": "Which command in a Linux environment is used to display the full path to the current directory?",
    "choice_a": "<code>ls</code>",
    "choice_b": "<code>pwd</code>",
    "choice_c": "<code>cp</code>",
    "choice_d": "<code>yum</code>",
    "correct_answer": "B",
    "explanation": "All of the answer choices are Linux commands. The <code>pwd</code> (print working directory) command writes the full path to the current (working) directory from the root on whatever the default output device is (usually the display). The path might be, for example, <code>/home/audrey/documents</code>. The <code>ls</code> command provides a list of all the files and folders found in the current directory, while the <code>cp</code> command is used to copy files and directories, and <code>yum</code> (Yellowdog Updater Modified) is used to install, update, remove, and search for software packages.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      103,
      98,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 607,
    "question": "One of the users you support has a MacBook. They\u2019re finding that their desktop is too cluttered. What can they use to have quick access to what they want and help them organize their desktop?",
    "choice_a": "Finder",
    "choice_b": "Time Machine",
    "choice_c": "Notes",
    "choice_d": "Multiple desktops",
    "correct_answer": "D",
    "explanation": "If a user finds their desktop getting out of hand, they can create multiple desktops, which macOS calls Spaces, to organize their desktop objects, or simply to make more space. Multiple desktops are created using Mission Control. Once multiple desktops are created, apps can be moved from one desktop to another by dragging, similar to using a smartphone. Finder is used to drill down through the file structure to find what you\u2019re looking for, and Time Machine is used to make backups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      85,
      76,
      79,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 608,
    "question": "What is the name of the bar on the bottom of the screenshot shown in the graphic, where shortcuts to commonly used programs and utilities are kept in macOS?<img src=\"/question_assets/220-1202/c06f006.png\" alt=\"Screenshot of a mac O S desktop with a downward arrow pointing to the bottom bar.\"/>\n\n<figcaption>Screenshot of a mac O S desktop with a downward arrow pointing to the bottom bar.</figcaption>",
    "choice_a": "Taskbar",
    "choice_b": "Dock",
    "choice_c": "File Explorer",
    "choice_d": "Finder",
    "correct_answer": "B",
    "explanation": "The macOS Dock provides quick access to the programs you\u2019ll likely use most often. Taskbar provides a similar function in the Windows operating system (OS). File Explorer and Finder are both used to drill down through the filesystem to find what you\u2019re looking for, with File Explorer being the Windows utility, and Finder being the macOS utility.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      76,
      7,
      25,
      87
    ],
    "source": "9781394330348"
  },
  {
    "id": 609,
    "question": "What Windows feature best describes Event Viewer (<code>eventvwr.msc</code>), Disk Management (<code>diskmgmt.msc</code>), and Certificate Manager (<code>certmgr.msc</code>)?",
    "choice_a": "Services",
    "choice_b": "Processes",
    "choice_c": "Policies",
    "choice_d": "Snap-ins",
    "correct_answer": "D",
    "explanation": "Event Viewer, Disk Management, and Certificate Manager are all Microsoft Management Console (MMC) snap-ins. An MMC provides an interface where a user can configure and easily access their own tool list that they use most often. These tools are called snap-ins, and many of them are available. A console contains shortcuts to the tools, and when the console is saved, it can be identified by a toolbox icon. Services are programs that run in the background on a Windows system, such as Print Spooler and Wireless Local Area (WLAN) AutoConfig. Processes are parts of a program that are running, usually consisting of multiple threads. Threads are the section of code being worked on by the processor. Policies are rules for granting access, such as the ability to log on locally or settings for passwords requiring complexity. Policies are configured through the Group Policy Editor (<code>gpedit.msc</code>) and are not available in Windows Home editions. There are literally hundreds of policies that can be set in a Windows system. The Group Policy Editor is also an MMC snap-in.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      60,
      21,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 610,
    "question": "Your laptop battery is getting older and won\u2019t hold a charge as long as it once did, so you want to ensure that when you walk away from it for a period of time and it isn\u2019t plugged in, it will not use any power but save everything and let you pick up where you left off working. What power state will work for this scenario?",
    "choice_a": "Always On",
    "choice_b": "Sleep",
    "choice_c": "Hibernate",
    "choice_d": "Hyper-V",
    "correct_answer": "C",
    "explanation": "The Hibernate power setting, once it has saved everything from Random Access Memory (RAM) to a system file (<code>hiberfil.sys</code>) on the hard drive, will turn the system off and use no power. Hibernate takes considerably longer to get back to a running state than Sleep does, but Hibernate won\u2019t use any power after it has stored the data. When the system is resumed, the contents of the system file are copied back into RAM and the user can continue where they left off. Sleep needs a small amount of power to keep the data in RAM refreshed. Always On will obviously use power continuously, and Hyper-V is Microsoft\u2019s virtualization product, not a power setting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      1,
      7,
      43,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 611,
    "question": "You are at a command prompt on a Windows PC, at <code>C:\\></code>, and you need to get to <code>C:\\Windows\\system32</code>. Which commands listed will get you there? Assume you press Enter after the line. (Choose two.)",
    "choice_a": "<code>c:\\windows cd system32</code>",
    "choice_b": "<code>cd C:\\windows\\system32</code>",
    "choice_c": "<code>cd windows\\system32</code>",
    "choice_d": "<code>cd system32 windows</code>",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Because you are already on the C drive, you would not need to specify the drive letter to change to a directory on that drive. If you did specify the drive, it\u2019s not a problem, because if you were going to a directory on a different drive, you would need to specify the drive letter. You could go to that directory with two commands, changing one directory at a time, by typing <code>cd windows [enter]</code> and then <code>cd system32 [enter]</code>, but that would be inefficient and is not one of the options given. You can also type <code>cd.. [enter]</code> to go back one directory.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      63,
      58,
      98,
      57
    ],
    "source": "9781394330348"
  },
  {
    "id": 612,
    "question": "Your system is running sluggishly, and you want to know why. Which application, as shown in the graphic, shows CPU usage by core and allows you to end problematic processes and stop running services?<img src=\"/question_assets/220-1202/c06f007.png\" alt=\"Screenshot of Windows Resource Monitor depicts C P U usage, processes, and services, with graphs for overall and per-C P U core usage.\"/>\n\n<figcaption>Screenshot of Windows Resource Monitor depicts C P U usage, processes, and services, with graphs for overall and per-C P U core usage.</figcaption>",
    "choice_a": "<code>eventvwr.msc</code>",
    "choice_b": "<code>lusrmgr.msc</code>",
    "choice_c": "<code>perfmon.msc</code>",
    "choice_d": "<code>resmon.exe</code>",
    "correct_answer": "D",
    "explanation": "The <code>resmon.exe</code> program launches the Resource Monitor, which is shown in the graphic. Resource Monitor is a powerful performance monitoring tool. It provides more granular information than Task Manager or Performance Monitor but doesn\u2019t have the ability to save a log of performance. The Event Viewer can be launched with <code>eventvwr.msc</code>. The Local Users and Groups application can be launched with <code>lusrmgr.msc</code>, and the Performance Monitor can be launched with <code>perfmon.msc</code>.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      31,
      27,
      30,
      28,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 613,
    "question": "You have Windows 10 32-bit on a desktop computer that has a 32-bit processor. It seems to be working fine, but when you install more RAM, bringing the total up to 12 GB, the operating system doesn\u2019t recognize anything above 4 GB. What is the problem?",
    "choice_a": "You need to tell the BIOS that the extra RAM is there.",
    "choice_b": "A 32-bit OS can support a maximum of 4 GB of RAM.",
    "choice_c": "You need to go to Device Manager to add the RAM.",
    "choice_d": "You need to replace the motherboard.",
    "correct_answer": "B",
    "explanation": "Any 32-bit operating system has a limit of 4 GB of Random Access Memory (RAM). The limitation is caused by the bus width. There simply aren\u2019t enough numbers available to identify memory locations above 4 GB.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      2,
      5,
      10,
      3,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 614,
    "question": "You\u2019re at a friend\u2019s house when a manager at your company calls to say they are having a problem with their Windows Pro PC while working at home. You listen and tell them you can easily fix it using Remote Desktop to take over their computer for a minute or two. Which of the following would not be an option to use Remote Desktop from where you are?",
    "choice_a": "Use your friend\u2019s Windows Home PC.",
    "choice_b": "Use your friend\u2019s Windows Pro PC.",
    "choice_c": "Use Microsoft Remote Desktop on your iOS device.",
    "choice_d": "Use Microsoft Remote Desktop on your Android device.",
    "correct_answer": "A",
    "explanation": "Remote Desktop can only be enabled on a Windows Pro or better operating system (OS). Windows Home edition does not have this capability. However, using a PC with Windows Pro, Pro for Workstations, or Enterprise edition is not the only way to access the manager\u2019s computer. The Remote Desktop Mobile app (called the Microsoft Remote Desktop) is available for iOS and Android devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      18,
      19,
      5,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 615,
    "question": "You are at a Windows workstation and have the Command Prompt open. Which of the following commands is used to refresh Group Policy settings and force their changes to take effect?",
    "choice_a": "<code>gpedit</code>",
    "choice_b": "<code>gpresult</code>",
    "choice_c": "<code>gprefresh</code>",
    "choice_d": "<code>gpupdate</code>",
    "correct_answer": "D",
    "explanation": "The <code>gpupdate</code> tool is used to update Group Policy settings immediately. It refreshes, or changes, both local and Active Directory (AD)\u2013based policies. The <code>gpedit</code> command allows the user to edit group policies, while the <code>gpresult</code> command will show the Resultant Set of Policy (RSoP) for a user or computer. RSoP is the culmination of all policies that affect the target user or computer. It is particularly helpful in troubleshooting conflicting policies. <code>gprefresh</code> is not a valid command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      64,
      12,
      62,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 616,
    "question": "You\u2019ve been having trouble with network communications to one of your company\u2019s offices. You want to determine the source of latency on the connection. What command will you use in the Windows Command Prompt to see where the latency is?",
    "choice_a": "<code>grep</code>",
    "choice_b": "<code>pathping</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>mv</code>",
    "correct_answer": "B",
    "explanation": "The <code>pathping</code> command works like <code>ping</code> and <code>tracert</code> combined. It shows the path a packet takes from point A to point B, then will show the time at each hop. (A hop is the number of routers a packet passes through to get to its destination after it leaves the initial router.) <code>grep</code> and <code>mv</code> are Linux Terminal commands, which are used to search for text from a file, and move files and folders, respectively. The <code>tracert</code> command shows the path a packet takes to its destination.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      63,
      56,
      105,
      68
    ],
    "source": "9781394330348"
  },
  {
    "id": 617,
    "question": "Your spouse is trying to work at home but has started to complain about the constant notifications appearing on the computer and interrupting their work. What category can you access in Windows Settings to turn them off?",
    "choice_a": "System",
    "choice_b": "Gaming",
    "choice_c": "Update & Security",
    "choice_d": "Apps",
    "correct_answer": "A",
    "explanation": "To turn off all notifications, or to choose how to manage if and how individual notification senders can interact with you, In Windows 11 Settings, choose System, then Notifications and choose Notifications again. From here, you can turn off all notifications or some and choose whether or not a sound is played when they arrive. The Gaming option enables configuring the system to be optimized for gameplay and recording. The Update & Security option is only available in Windows 10, and doesn\u2019t address notifications. The Apps option lets you manage where apps can be installed from, default apps for opening files, and other application configuration settings.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      34,
      23,
      30,
      53,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 618,
    "question": "Your grandparent just bought a computer with macOS Ventura on it. They can\u2019t find the Security & Privacy settings. What will you tell them? (Choose two.)",
    "choice_a": "They can no longer change preferences.",
    "choice_b": "Preferences is renamed System Settings in Ventura and newer versions.",
    "choice_c": "Security & Privacy has been renamed Privacy & Security in Ventura and newer editions.",
    "choice_d": "Preferences has moved to the Dock.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "In October of 2022, the Ventura release of the macOS changed System Preferences to System Settings, to make the desktop operating system (OS) more in line with iOS and iPadOS. Preferences for each app can still be found within the app. At that time, they renamed some apps and moved them around, so troubleshooting will depend on whether the macOS involved is newer or older than Ventura.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      81,
      5,
      7,
      6,
      85
    ],
    "source": "9781394330348"
  },
  {
    "id": 619,
    "question": "A macOS user is complaining that their MacBook has been acting strangely lately, and it\u2019s very slow to start. What utility will you use to repair any potential disk errors?",
    "choice_a": "FileVault",
    "choice_b": "Terminal",
    "choice_c": "Disk Utility",
    "choice_d": "Force Quit",
    "correct_answer": "C",
    "explanation": "The macOS Disk Utility can be used to find and fix errors in the directory structure of a Mac disk. If the Mac won\u2019t boot into the operating system (OS), the utility can be accessed through macOS Recovery. Depending on the hardware your Mac is using, you would either hold the power button until startup options appear or press and hold Command+R while the computer is starting to bring up macOS Recovery. From there, choose Utilities and Disk Utility. FileVault provides encryption; Terminal is the macOS and Linux command-line user interface, as well as the new Windows 11 command-line interface; and Force Quit can be used when a single app is causing problems and refuses to close. In Windows, Terminal opens the PowerShell interface, but the Command Prompt is still available. The Windows Terminal enables the user to run multiple shells at the same time, including the Command Prompt, Linux bash, and PowerShell.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      83,
      82,
      51,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 620,
    "question": "You\u2019ve created a batch file that needs to run every day before the employees arrive. What can you use to ensure that this batch file is run every weekday at 6 A.M.?",
    "choice_a": "Task Scheduler",
    "choice_b": "Event Viewer",
    "choice_c": "Device Manager",
    "choice_d": "Local Users and Groups",
    "correct_answer": "A",
    "explanation": "Task Scheduler is a Microsoft Management Console (MMC) snap-in, and as its name implies, a tool for running programs and performing tasks based on a trigger, such as date or time or events such as logon, idle, or locking the workstation. Event Viewer keeps logs of system, security, and application events. Device Manager is a tool for working with hardware, such as updating drivers and scanning for newly attached devices. Local Users and Groups is a MMC snap-in for creating and managing users and groups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      27,
      43,
      29
    ],
    "source": "9781394330348"
  },
  {
    "id": 621,
    "question": "A smartphone user recently found their phone on the End-of-Support list when looking up the product life-cycle. They asked you what this means. Why will you recommend they purchase a new phone?",
    "choice_a": "They can\u2019t download any more apps.",
    "choice_b": "Their phone will stop working by the date on the list.",
    "choice_c": "Their phone may not receive any more feature or security updates.",
    "choice_d": "Their phone will no longer connect to cellular service.",
    "correct_answer": "C",
    "explanation": "When an operating system (OS), smartphone, PC, or any electronic device is at end-of-life (EOL) or end-of-support, it generally is no longer sold or supported, meaning that replacement parts and product and security updates are no longer available. While you might be able to scavenge parts, not getting security updates should be a great concern. At an electronics end-of-support, the best course of action is to recycle the device and procure a newer one. The other options are generally not true.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      6,
      93,
      95,
      94,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 622,
    "question": "You are on a Windows computer working at a command prompt, and you need to see a list of files in the directory in which you are working. What command will you type?",
    "choice_a": "<code>dir</code>",
    "choice_b": "<code>ls</code>",
    "choice_c": "<code>pwd</code>",
    "choice_d": "<code>grep</code>",
    "correct_answer": "A",
    "explanation": "The <code>dir</code> command will show you a list of all the files and folders that are in the directory you are working in, along with the date created. Using the switches that work with <code>dir</code>, you can view much more information. The <code>ls</code> Linux command lists information about files in the working directory. The <code>pwd</code> Linux command prints the complete path to the working directory, and the <code>grep</code> Linux command searches for files with a pattern that you specify.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      63,
      62,
      104,
      98
    ],
    "source": "9781394330348"
  },
  {
    "id": 623,
    "question": "A user with a Windows workstation recently received a second hard drive. Another administrator created a partition on the hard drive, and it\u2019s ready for use. The user will store the raw video files they create on that drive and insist that it be called the <code>R:</code> drive. Which of the following statements is true?",
    "choice_a": "You can use Disk Management to change the drive letter to <code>R:</code>.",
    "choice_b": "You can use Disk Management to change the drive letter to <code>R:</code>, but only if it\u2019s a dynamic disk.",
    "choice_c": "You can use Disk Management to change the drive letter to <code>R:</code>, but only if it\u2019s in an extended partition.",
    "choice_d": "You will need to use Disk Management to delete the partition first and then re-create it as <code>R:</code>.",
    "correct_answer": "A",
    "explanation": "Disk Management is a Windows tool that has been available for many Windows versions. With it, you can reassign or change a drive letter, create and format volumes, shrink or expand volumes, change basic drives to dynamic drives, import foreign drives, and even establish software Redundant Array of Independent Disks (RAID). In Windows 10, it can be launched through the Control Panel by choosing Administrative Tools, then Computer Management or by typing <code>diskmgmt.msc</code> in the Search box. In Windows 11, Administrative tools has been replaced with Windows Tools, which is not as robust and doesn\u2019t provide a link to Disk Management; however, the easiest way to access Disk Management in Windows 10 or 11 is to press the Windows Key plus the X key to bring up the Quick Link menu, which is a list of commonly used tools, then simply click Disk Management on the list.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      40,
      28,
      41,
      32,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 624,
    "question": "A salesperson at your company travels with their macOS laptop every week. You want to encrypt the data on their startup disk to ensure data security. What macOS utility will you use?",
    "choice_a": "Finder",
    "choice_b": "Time Machine",
    "choice_c": "FileVault",
    "choice_d": "BitLocker",
    "correct_answer": "C",
    "explanation": "FileVault is the macOS utility for encrypting data. Finder is the macOS utility for drilling down through folders to find objects. Time Machine is used to create and restore backups of data on a Mac, and BitLocker is the Windows drive encryption utility.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      79,
      21,
      81,
      77
    ],
    "source": "9781394330348"
  },
  {
    "id": 625,
    "question": "A user wants to perform a backup on their MacBook. Which software utility should be used to make backups?",
    "choice_a": "Image Recovery",
    "choice_b": "Time Machine",
    "choice_c": "iBackup",
    "choice_d": "Accessibility",
    "correct_answer": "B",
    "explanation": "Time Machine is the macOS backup utility. It can be accessed through System Preferences, and once it\u2019s set up, it will run on schedule much like any other backup software. Image Recovery and iBackup are not macOS tools. Accessibility options can be found in System Preferences and are used to adjust settings for different vision, hearing, and mobility needs.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      79,
      81,
      80,
      91,
      92
    ],
    "source": "9781394330348"
  },
  {
    "id": 626,
    "question": "One of your network users has a MacBook Pro. Where should this user go to see whether there are any OS updates available?",
    "choice_a": "Software Updates in Settings",
    "choice_b": "In the App Store",
    "choice_c": "Click Updates on the dock",
    "choice_d": "Open Finder and click Updates on the menu bar",
    "correct_answer": "A",
    "explanation": "Updates to macOS can be found under Software updates in Settings. Individual applications can be updated through the App Store. Open it and click Updates in the toolbar to see which updates are available.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      95,
      34,
      6,
      5
    ],
    "source": "9781394330348"
  },
  {
    "id": 627,
    "question": "What command will bring up the screen shown in the following graphic?<img src=\"/question_assets/220-1202/c06f008.png\" alt=\"Screenshot of the About Windows dialog box depicts Windows 11, Version 24 H 2, and O S Build 26100 point 3194.\"/>\n\n<figcaption>Screenshot of the About Windows dialog box depicts Windows 11, Version 24 H 2, and O S Build 26100 point 3194.</figcaption>",
    "choice_a": "<code>winver</code>",
    "choice_b": "<code>version</code>",
    "choice_c": "<code>osver</code>",
    "choice_d": "<code>build</code>",
    "correct_answer": "A",
    "explanation": "If you need to know the Windows version of the PC you\u2019re working on, press Windows+R to bring up the Run dialog box and type <code>winver</code>, then click the OK box or press Enter. This command works in both Windows 10 and Windows 11. You\u2019ll see a screen similar to the one shown in the graphic. The other options are not valid commands.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      30,
      34,
      53,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 628,
    "question": "Which of the following commands was used to display the screen snippet shown in the graphic?<img src=\"/question_assets/220-1202/c06f009.png\" alt=\"Screenshot of a Command Prompt window depicts R S O P data for a user with O S configuration, Group Policy details, and security groups.\"/>\n\n<figcaption>Screenshot of a Command Prompt window depicts R S O P data for a user with O S configuration, Group Policy details, and security groups.</figcaption>",
    "choice_a": "<code>gpedit</code>",
    "choice_b": "<code>gpresult</code>",
    "choice_c": "<code>gprefresh</code>",
    "choice_d": "<code>gpupdate</code>",
    "correct_answer": "B",
    "explanation": "The <code>gpresult</code> command will show the Resultant Set of Policy (RSoP) for a user or computer. RSoP is the culmination of all policies that affect the target user or computer. It is particularly helpful in troubleshooting conflicting policies. The screen shown used the <code>/r</code> switch, which shows the RSoP summary for the currently logged-in user on the local computer. The <code>gpedit</code> command allows the user to edit Group Policy settings. The <code>gpupdate</code> tool is used to update Group Policy settings. It refreshes, or changes, both local and Active Directory (AD)\u2013based policies. <code>gprefresh</code> is not an existing command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      64,
      72,
      62,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 629,
    "question": "Which Linux command is used to copy files, groups of files, or whole directories from one place to another?",
    "choice_a": "<code>mv</code>",
    "choice_b": "<code>cp</code>",
    "choice_c": "<code>find</code>",
    "choice_d": "<code>cat</code>",
    "correct_answer": "B",
    "explanation": "All the commands listed are Linux commands. The <code>cp</code> command is used to copy files. There are three syntax for the <code>cp</code> command, as follows:<ol><li><code>cp [option] <i>source destination</i></code></li><li><code>cp [option] <i>source directory</i></code></li><li><code>cp [option] <i>source-1 source-2 source-n directory</i></code></li></ol><p>For example, if the copy command has two filenames, it will create a copy of the first filename and save it as the second. The command would be <code>cp <i>file1 file2</i></code>. The <code>mv</code> command is used to move files, and the <code>find</code> command is used to find files and directories and perform operations on them. The <code>cat</code> command is a powerful tool that can be used to view contents of a file, create new files, and concatenate (i.e., put together) files.</p>",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      105,
      98,
      104,
      106,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 630,
    "question": "Despite your great objections, someone you know is still running a Windows OS that predates Windows 10 and has reached its EOL. The software they regularly use on it still works, and they have an antivirus installed. Why should they update to a newer OS? (Choose two.)",
    "choice_a": "They will not receive security updates.",
    "choice_b": "They will not receive feature updates.",
    "choice_c": "Their apps will stop working.",
    "choice_d": "Their OS will stop working at end-of-life.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Operating systems (OSs) and electronics have a lifecycle just as all living things do. They are introduced, grow, reach maturity (receive mainstream support), decline (receive extended support), and reach their end-of-life (EOL, receive no support). The end of mainstream support means that there are no updates other than security. The end of extended support means there is no support, including security updates and patches. Essentially, if (when) a vulnerability is discovered by a hacker, the user of an EOL OS is at risk for being attacked. Applications may continue to work just fine, but updates might not work with the OS. The OS will not magically stop working, but if a problem occurs there will be no official support available.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      6,
      93,
      96,
      53,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 631,
    "question": "A smartphone user has come to you for help. They would like a laptop so they can use a bigger screen, but they don\u2019t know what to choose. They\u2019re accustomed to doing their work online with Google Docs and their smartphone and saving it to the cloud. They would like to be able to use some of the same apps that they have available on their Android phone. Cost is a factor. What type of laptop would you recommend for this user?",
    "choice_a": "Windows Home",
    "choice_b": "Linux",
    "choice_c": "macOS",
    "choice_d": "Chromebook (Chrome OS)",
    "correct_answer": "D",
    "explanation": "The Chromebook, which has the Chrome OS preinstalled, is the best option for this user. Its main user interface is the Google Chrome browser, and it can run apps designed for Android smartphones. Chromebooks are also known for being less expensive laptop options. Windows Home and macOS would be fine for accessing the Internet, but they would not support the applications that the user is accustomed to using, and the user would experience a learning curve. Linux might be able to run their Android apps using third-party software, but again the user would have a learning curve.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      16,
      15,
      1,
      87
    ],
    "source": "9781394330348"
  },
  {
    "id": 632,
    "question": "A user called the Help Desk because they were denied access to a secure server and received a message that they have an invalid certificate. Their computer was recently updated. Where can you go in Windows to manage their certificates?",
    "choice_a": "Device Manager",
    "choice_b": "Local Users and Groups",
    "choice_c": "Certificate Manager",
    "choice_d": "Group Policy Editor",
    "correct_answer": "C",
    "explanation": "Certificates are a way of proving who someone or a website is by means of a digital signature. A user\u2019s certificates hold the private key of a key pair for encryption. If certificates are outdated or otherwise no longer valid, then encryption doesn\u2019t happen and the transmission can be intercepted by someone with malicious intent. Normally you wouldn\u2019t need to worry about certificates, but if a problem occurs, the certificate may need to be deleted and a new one requested. Certificate Manager (<code>certmgr.msc</code>) allows you to view and manage certificates by user or computer. Device Manager is a hardware management tool. Local Users and Groups allows for organizing users by access need and assigning permissions and access to the group rather than the user, simplifying access management. Group Policy Editor allows administrators to further control what users and computers are allowed to do on the network.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      32,
      60,
      65,
      29
    ],
    "source": "9781394330348"
  },
  {
    "id": 633,
    "question": "Which desktop operating system is a proprietary product of Apple?",
    "choice_a": "Apache",
    "choice_b": "Red Hat Linux",
    "choice_c": "macOS",
    "choice_d": "FreeBSD",
    "correct_answer": "C",
    "explanation": "macOS is Apple\u2019s proprietary desktop operating system (OS). Apache is a popular web server OS, not a desktop OS. Red Hat Linux is a distribution of the open-source Linux OS, and FreeBSD is a freeware, open-source OS based on UNIX.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      73,
      4,
      90,
      74
    ],
    "source": "9781394330348"
  },
  {
    "id": 634,
    "question": "A user on your network complains that they are unable to type a human-friendly name likeSybex.cominto their browser to reach a website, but typing in an IP address in the browser works. What client network configuration setting do you suspect is the problem?",
    "choice_a": "Authentication Server",
    "choice_b": "DNS server",
    "choice_c": "DHCP server",
    "choice_d": "Proxy server",
    "correct_answer": "B",
    "explanation": "The Domain Name System (DNS) has one function on the network, and that is to resolve hostnames to Internet Protocol (IP) addresses. For a computer or phone to open a website, it needs to know the IP address of that website. Each DNS server has a database called a zone file, which maintains records of hostname to IP address mappings. If the network settings for a DNS server on a client computer are improperly configured and the client can\u2019t reach the DNS server, then human-friendly names are not resolved to IP addresses, causing the problem this user is having. Authentication servers are used to verify whether a user has the proper credentials to gain access to resources on a network. A Domain Controller (DC) is created when Microsoft\u2019s Active Directory (AD) is installed on a server. A DC is a type of authentication server. A Dynamic Host Configuration Protocol (DHCP) server is used to automatically provide an IP address to a client based on a list (scope) of IP addresses made available on the DHCP server. A proxy server sits between the client and the outside world and is used to filter incoming or outgoing content.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      59,
      58,
      32,
      67,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 635,
    "question": "You need to start a new shell on a Linux workstation, with <code>root</code> permissions. Which command should you use to do this?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>sudo</code>",
    "choice_c": "<code>apt-get</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "A",
    "explanation": "The <code>su</code> command (switch user, substitute user, or super user) is used to start another shell on a Linux computer. Without specifying the username, it\u2019s assumed you are trying to start a shell with a super user (or <code>root</code>) authority. This can be dangerous because as the <code>root</code>, the user can do anything on the system, including delete parts of the operating system (OS), and there is no undo or warning message. You must know the <code>root</code> password to run <code>su</code>. It\u2019s far safer to run the <code>sudo</code> command. The <code>sudo</code> command stands for superuser do, or substitute user do, and it will run a single command as the alternate user. The <code>apt-get</code> command is used to download or remove software packages, and it has largely been replaced by the <code>apt</code> command, which is newer and more user friendly. The <code>ps</code> command lists the processes that are currently running along with their Process IDs (PIDs).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      99,
      98,
      103,
      101,
      104
    ],
    "source": "9781394330348"
  },
  {
    "id": 636,
    "question": "A user wants to change the resolution on their MacBook. Which System Preferences pane would they use to do that?",
    "choice_a": "Printers & Scanners",
    "choice_b": "Desktop & Screen Saver",
    "choice_c": "Accessibility",
    "choice_d": "Displays",
    "correct_answer": "D",
    "explanation": "The Displays pane in System Preferences is used to set resolution and brightness (turn Night Shift on and off), and possibly other settings depending on whether there is a display connected. The Printers & Scanners pane is where you would add or manage a printer and its print jobs. Accessibility preferences include settings for hearing, mobility, and vision. The Desktop & Screen Saver options allow you to configure the desktop and screen saver.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      80,
      81,
      32,
      7,
      75
    ],
    "source": "9781394330348"
  },
  {
    "id": 637,
    "question": "How do you get access to collaboration tools like spreadsheets, video conferencing, and presentation tools? (Choose three.)",
    "choice_a": "When you log in to your account on Google or Microsoft 365",
    "choice_b": "When you install the software and purchase a license",
    "choice_c": "They come preinstalled on many devices.",
    "choice_d": "You must purchase each separately and then install it on your device.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "For some services like Microsoft 365, you\u2019ll need a license and pay a fee monthly or annually (or your employer will) to have access to collaboration tools. For Google collaboration tools, you need to create a Google account. Most smartphones come with some collaboration tools preinstalled and ready to use. It is unlikely that you would need to purchase each separately and install them on your device, as they often are packaged together.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      15,
      74,
      87,
      49
    ],
    "source": "9781394330348"
  },
  {
    "id": 638,
    "question": "You are in the Command Prompt in Windows. You believe that some of the Windows system files are corrupt. Which command should you use to scan and repair problematic system files?",
    "choice_a": "<code>sfc /scanfile</code>",
    "choice_b": "<code>sfc /scannow</code>",
    "choice_c": "<code>sfc /verifyfile</code>",
    "choice_d": "<code>sfc /verifyonly</code>",
    "correct_answer": "B",
    "explanation": "The System File Checker (SFC) is a command-line utility that checks and verifies the versions of system files on your computer. If system files are corrupted, the SFC will replace the corrupted files with correct versions. The <code>/scannow</code> option will scan and repair files, whereas <code>/scanfile</code> will just check one specified file. The <code>/verifyonly</code> option will scan the integrity of protected system files but not attempt to repair them. The <code>/verifyfile</code> option will verify the integrity of a specific file.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      63,
      56,
      30,
      93
    ],
    "source": "9781394330348"
  },
  {
    "id": 639,
    "question": "You are at a command prompt in Windows. Which command enables you to copy files and directories, copy NTFS permissions, and mirror a directory tree?",
    "choice_a": "<code>copy</code>",
    "choice_b": "<code>xcopy</code>",
    "choice_c": "<code>robocopy</code>",
    "choice_d": "<code>copyall</code>",
    "correct_answer": "C",
    "explanation": "The <code>robocopy</code> utility (Robust File Copy for Windows) has the big advantage of being able to accept a plethora of specifications and keep New Technology File System (NTFS) permissions intact in its operations. For example, the <code>/mir</code> switch can be used to mirror a complete directory tree. Both <code>copy</code> and <code>xcopy</code> are valid commands but have nowhere near the power that <code>robocopy</code> does. <code>copyall</code> is not a valid command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      61,
      25,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 640,
    "question": "The HDD performance on your Windows workstation has deteriorated over time. To attempt to improve performance, you want to ensure that files on the drive are written in contiguous blocks. Which Windows tool should you use to make this happen?",
    "choice_a": "<code>diskmgmt.msc</code>",
    "choice_b": "<code>dfrgui.exe</code>",
    "choice_c": "<code>perfmon.msc</code>",
    "choice_d": "<code>devmgmt.msc</code>",
    "correct_answer": "B",
    "explanation": "When files are written to a hard disk drive (HDD), they\u2019re not always written contiguously, that is, with all the data in a single location. Defragmenting a disk involves analyzing the disk and then consolidating fragmented files and folders so that they occupy a contiguous space (i.e., consecutive blocks), thus increasing performance during file retrieval. The executable for Disk Defragment is <code>dfrgui.exe</code>, which brings up the Optimize Drives window. By default, drives are automatically scheduled to be optimized, but it can be done here on command, or the schedule settings can be changed. The Disk Management (<code>diskmgmt.msc</code>) utility is used to create and format volumes and other tasks related to managing drives. Performance Monitor (<code>perfmon.msc</code>) shows real-time or logged performance indicators and Device Manager (<code>devmgmt.msc</code>) is useful in examining and troubleshooting issues with hardware.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      42,
      97,
      28,
      40,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 641,
    "question": "Your client is taking over a business and wants to upgrade the computer systems, which are currently all legacy Windows machines. They will be using Microsoft 365 along with accounting and manufacturing software that is part of the business. They are concerned about compatibility of other files with their customers, vendors, and historical company data. What operating system would you recommend for their workstations?",
    "choice_a": "Chrome OS",
    "choice_b": "Linux",
    "choice_c": "macOS",
    "choice_d": "Windows",
    "correct_answer": "D",
    "explanation": "Because the majority of business users are still using Microsoft products and there may be compatibility concerns with data from older systems, a Windows operating system (OS) would be the correct choice. Chrome OS is most appropriate where users would be working in the cloud. Linux and macOS may have compatibility issues with data from other sources. Microsoft 365 does come in a version for macOS; however, the company specific software must also be considered.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      18,
      15,
      55,
      5,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 642,
    "question": "In macOS, where can the menus Displays, Printers, and Privacy be found, and settings changed?",
    "choice_a": "System Preferences",
    "choice_b": "Accessibility",
    "choice_c": "Settings",
    "choice_d": "App Store",
    "correct_answer": "A",
    "explanation": "System Preferences is where settings can be viewed and modified. System Preferences are divided into various panes, including Displays, Networks, Printers & Scanners, Privacy, Accessibility, Time Machine, Power, and many other selections for changing settings. Windows Settings is a part of the Microsoft Windows operating system (OS). App Store is where you would go on a macOS to find new applications to download and update the OS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      81,
      5,
      73,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 643,
    "question": "Your friend has a Windows 10 PC and has never created a backup. You provide them with an external drive to use. What category will you choose in Windows Settings to turn on automatic backups for your friend every hour?",
    "choice_a": "System",
    "choice_b": "Apps",
    "choice_c": "Update & Security",
    "choice_d": "Network & Internet",
    "correct_answer": "C",
    "explanation": "The Update & Security category of the Settings app in Windows 10 contains more than the name would suggest. In Update & Security, there is, of course, Windows Update and Windows Security, but users can also find Backup, Troubleshoot, Recovery, Activation, Find my device, For developers, and Windows Insider Program selections. To perform a backup using File History, an additional drive is needed (you can\u2019t back up to the drive Windows is installed on), and under More options, you\u2019ll find settings for how often to automatically back up your computer and be able to choose which folders to back up. (In Windows 11, use File History to backup files. File History can be found in the Settings app or in the Control Panel. Backup and Restore, from Windows 7, can be found in the Control Panel.) The Systems category contains Display, Sound, Power, and other system-related settings. The Apps category is where you can uninstall apps, set default apps, and change what apps load upon startup. The Network & Internet category has Wi-Fi settings and a network troubleshooter, among other common network-related settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      32,
      18,
      48,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 644,
    "question": "Your company has a DHCP server to dynamically assign IP addresses to any nodes that connect to it. Which of the following would you want to assign a static IP address to? (Choose two.)",
    "choice_a": "Workstation",
    "choice_b": "File server",
    "choice_c": "Printer/MFD",
    "choice_d": "Local printer",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Typically, on a network, static Internet Protocol (IP) addresses, rather than dynamic ones, would be assigned to shared resources such as file servers and printers/Multifunction Devices (MFDs) to avoid problems connecting to those resources that might occur if their IP addresses were acquired dynamically. A user\u2019s workstation normally does not need a static IP address and allowing it to obtain one automatically makes workstation configuration easier and avoids accidental duplication of IP addresses. A local printer, by definition, is attached to a local computer and not directly to the network, so it wouldn\u2019t have its own IP address.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      71,
      32,
      28,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 645,
    "question": "You\u2019re installing an application that requires 4 GB of RAM on a Windows 11 Home workstation. The workstation has 4 GB of RAM. Will you need to make any configuration changes to the system to install this application?",
    "choice_a": "No, because the system already has 4 GB of RAM.",
    "choice_b": "No, because the OS and the application won\u2019t be running at the same time.",
    "choice_c": "Yes. You\u2019ll need at least 4 additional GB of RAM.",
    "choice_d": "Yes. You\u2019ll need at least 2 additional GB of RAM.",
    "correct_answer": "C",
    "explanation": "When the application is running, the operating system will also be running, so you need to add their respective Random Access Memory (RAM) requirements together to determine the minimum total amount of system RAM needed. The minimum amount of RAM for a Windows 11 installation is 4 GB, and because the application\u2019s RAM requirement is 4 GB, you\u2019ll need a total of at least 8 GB. Because you only have 4 GB, an additional 4 GB will need to be installed. While that will run the program on this system, having only 4 GB for the operating system (OS) will not allow it to run as fast as the user is accustomed to, so in reality you\u2019ll likely want to add more.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      9,
      44,
      43,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 646,
    "question": "Which of the filesystem types offered is the best to use when running a Linux database server?",
    "choice_a": "FAT32",
    "choice_b": "NTFS",
    "choice_c": "XSF",
    "choice_d": "ext4",
    "correct_answer": "C",
    "explanation": "Although the Extended Filesystem (XSF) and Fourth Extended File System (ext4) are both filesystems used with Linux, the XSF file system, which uses parallel execution, is more robust and designed to handle the large file sizes of database servers. File Allocation Table 32 (FAT32) is the filesystem that was used when only 32-bit processors were available and can still be used for compatibility issues with legacy devices or compatibility between different platforms, such as Windows, Linux, and macOS. However, Windows 10 installations default to New Technology File System (NTFS) as the filesystem used for installation, and Windows 11 requires it. FAT32 only supports 4GB of RAM due to the word size limitation of a 32-bit data path, and Windows 11 supports terabytes (TB) of RAM. NTFS has been available for decades and offers security features that FAT32 doesn\u2019t have.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      2,
      36,
      39,
      97
    ],
    "source": "9781394330348"
  },
  {
    "id": 647,
    "question": "You are going to install Windows on a workstation from an image located across the network on a server. What does the workstation need to support to enable it to install Windows this way?",
    "choice_a": "Netboot",
    "choice_b": "Unattended installation",
    "choice_c": "PXE boot",
    "choice_d": "USB boot",
    "correct_answer": "C",
    "explanation": "An installation can be started many ways\u2014with a USB drive, a DVD, and so on\u2014and an image and setup files can also be located on and installed from a network. Often called a PXE-initiated boot (for Pre-boot Execution Environment), it allows the workstation involved in the installation to retrieve the files from the network as needed and then configure variables accordingly. Netboot refers to booting a computer from a network drive, not installing an operating system (OS). Unattended installation is an installation type that uses an answer file and little or no interaction from a human. While it\u2019s possible to install Windows from a USB, if you\u2019re using a USB to boot and install an image from a server, the bare metal machine still needs PXE support.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      52,
      13,
      45,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 648,
    "question": "You\u2019re in a secure environment where the workstations are not allowed to have USB ports or DVD drives. You\u2019ve just received 10 new bare-metal workstations, with PXE support, that need to have Windows installed. How will you install the Windows OS on these 10 PCs?",
    "choice_a": "Optical Media",
    "choice_b": "External drive",
    "choice_c": "Internet-based",
    "choice_d": "Network",
    "correct_answer": "D",
    "explanation": "Because the workstations don\u2019t have DVD drives, you can\u2019t use optical media to install Windows 10, and because there are no USB ports, it\u2019s unlikely that you will be able to use an external drive. Internet-based installation requires that you can boot and get to the Internet, so you would need an operating system (OS) already installed, and the question states that these are bare metal machines. You\u2019re left with a network installation using the Pre-boot Execution Environment (PXE) boot as the only option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      45,
      47,
      8,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 649,
    "question": "You need to run just one command as <code>root</code>. What will you use?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>sudo</code>",
    "choice_c": "<code>apt</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "B",
    "explanation": "The <code>sudo</code> command stands for superuser do, or substitute user do, and will run a single command as the alternate user. The user can authenticate with their own password instead of the <code>root</code> password, which is a security feature. Another command, <code>visudo</code>, is used to configure exactly what each user can do when they run <code>sudo</code>. The <code>visudo</code> command is not on the CompTIA A+ objectives, but it answers the question of how you would control the access of users who are not <code>root</code>. The <code>su</code> command (i.e., switch user, substitute user, or super user) is used to start another shell on a Linux computer. Without specifying the username, it\u2019s assumed you are trying to start a shell with super user (or <code>root</code>) authority, and you need the root password to run it. Note the difference between <code>su</code> and <code>sudo</code>, starting a whole new shell vs. running a command. The <code>apt</code> command, which has largely replaced <code>apt-get</code>, is used to download or remove software packages, and the <code>ps</code> command will list the processes that are currently running along with their Process IDs (PIDs).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      99,
      98,
      103,
      100,
      104
    ],
    "source": "9781394330348"
  },
  {
    "id": 650,
    "question": "You\u2019re working in a school district in a computer lab full of Windows workstations, setting up an application that uses the computer\u2019s name to identify it on the application. What command can you use at a workstation to determine its name? (Choose two.)",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>clientname</code>",
    "choice_c": "<code>hostname</code>",
    "choice_d": "<code>ping localhost</code>",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The <code>hostname</code> command returns the name of the computer that it is entered on and, while not its primary purpose, <code>ping localhost</code> will also return the computer\u2019s name. <code>Nslookup</code> will show the default DNS server and its IP address. <code>clientname</code> is not a valid command.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      63,
      58,
      59,
      56,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 651,
    "question": "You\u2019re at a Windows workstation, troubleshooting a connectivity problem with a computer in another office on your campus-area network. You need to determine where packets between the two are being dropped. Which command will tell you the last router the packet traversed?",
    "choice_a": "<code>ipconfig /all</code>",
    "choice_b": "<code>ping</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "D",
    "explanation": "The <code>tracert</code> command will show the routers that a packet went through and how long each hop took, which can narrow down your search for the problem by showing how far it got. The Linux equivalent to <code>tracert</code> is <code>traceroute</code>. Typing <code>ipconfig /all</code> will show the current Transmission Control Protocol/Internet Protocol (TCP/IP) configuration of the local machine, such as its IP address, Media Access Control (MAC) address, and default gateway. The macOS/Linux equivalent of <code>ipconfig</code> is <code>ip</code>. The <code>ping</code> command will only show that the packet is not making the trip there and back by timing out.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      63,
      56,
      98,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 652,
    "question": "You\u2019re setting up a computer for a user with limited vision, who would like to have the contents of the screen read to them. What Control Panel utility will you use to accomplish this?",
    "choice_a": "Devices and Printers",
    "choice_b": "Programs and Features",
    "choice_c": "Ease of Access Center",
    "choice_d": "Sound",
    "correct_answer": "C",
    "explanation": "Ease of Access Center has settings to help users who have limited sight, mobility, or hearing. Devices and Printers is for managing and troubleshooting printers, print jobs, and other devices like connected smartphones or keypads. Programs and Features lets you uninstall or change installed programs, and Sound is used to configure recording and playback devices or choose a sound scheme.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      81,
      7,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 653,
    "question": "The Linux workstation you are using seems slow. You want to see what processes are running on the computer. Which command should you use?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>sudo</code>",
    "choice_c": "<code>apt</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "D",
    "explanation": "The <code>ps</code> command (i.e., process status command) will list the currently running processes along with their Process IDs (PIDs), the controlling terminal for the process, the time the Central Processing Unit (CPU) has been used by the process and the name of the command that started the process. The <code>su</code> command (i.e., switch user, substitute user, or super user command) is used to start another shell on a Linux computer. The <code>sudo</code> command stands for superuser do or substitute user do and will run a single command as the alternate user. The <code>apt</code> command, which has largely replaced the older <code>apt-get</code> command, is used to download or remove software packages.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      103,
      99,
      43,
      98,
      27
    ],
    "source": "9781394330348"
  },
  {
    "id": 654,
    "question": "Which of the following is not an advantage that the ext4 filesystem has over the ext3 filesystem?",
    "choice_a": "Supports larger volumes and files",
    "choice_b": "Compatible with macOS and Windows",
    "choice_c": "Unlimited number of subdirectories",
    "choice_d": "Faster filesystem checks",
    "correct_answer": "B",
    "explanation": "Extended File System, version 4 (Ext4) is not compatible with macOS and Windows. Neither is ext3. For compatibility between Linux, macOS, and Windows, format an external drive with Extensible File Allocation Table (exFAT) or File Allocation Table 32 (FAT32), so it can be read by any of the three. ext3 only supports file sizes up to 2 TB and volumes up to 16 TB, while ext4 supports files up to 16 TB and volumes up to 1 EB. ext3 is limited to about 32,000 subdirectories, while ext4 has no limit. ext4 also provides superior resistance to fragmentation and faster filesystem checking.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      39,
      97,
      36,
      38
    ],
    "source": "9781394330348"
  },
  {
    "id": 655,
    "question": "A user installed a new headset, but the audio is still playing through the speakers. Where can you go to change that configuration? (Choose two.)",
    "choice_a": "Control Panel, Security and Maintenance",
    "choice_b": "The System window of Windows Settings, and then choose Sound",
    "choice_c": "Control Panel, Sound",
    "choice_d": "Windows Settings, Apps",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Going to the Control Panel and choosing the Sound utility will enable you to change the default playback device for sound, so will opening the Windows Settings app and clicking on System, then Sound. Opening Windows Settings, then System and Sound will as well, but that is not one of the answer choices. The Security and Maintenance utility in the Control Panel has settings for the firewall, malware protection, and other features. The Apps group in Windows Settings is where you would uninstall or choose default apps.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      34,
      32,
      7,
      30,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 656,
    "question": "A user wants to know if it\u2019s possible to change what happens when they close the lid on their Windows 11 laptop. Currently, closing the lid does nothing, but they would like the laptop to hibernate when the lid is closed. Where can this setting be changed?",
    "choice_a": "Control Panel, Power Options utility",
    "choice_b": "Control Panel, Devices and Printers utility",
    "choice_c": "Windows Settings, System group, Power & Battery",
    "choice_d": "Windows Settings, Devices group, Power options",
    "correct_answer": "A",
    "explanation": "The Power Options utility in the Control Panel is where you can find the setting for changing what happens when you close the lid, and other Sleep and Hibernate options. Windows 10 has an option in the Windows Settings app, System group, under Power options that says Additional power settings, which takes you into the Control Panel utility. Windows Settings in Windows 11 is missing this link, but in both versions of Windows, the other power settings (i.e., when to sleep, when to hibernate) are available in Windows Settings. Devices and Printers is where you would manage printers and print jobs, and other devices like connected cell phones. The System group in Settings controls Display, Sound, Notifications & Actions, and several other areas related to the system as a whole. The Devices group in Windows 10, Windows Settings allows you to configure Bluetooth, printers, and mouse settings. In Windows 11, this group is called Bluetooth & Devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      30,
      33,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 657,
    "question": "A friend wants to upgrade from Windows 8 to Windows 11. What will you tell them? (Choose two.)",
    "choice_a": "There isn\u2019t a direct upgrade.",
    "choice_b": "Sure! It\u2019s free and easy to upgrade.",
    "choice_c": "They must install 8.1 first and then 11.",
    "choice_d": "Their hardware probably won\u2019t work, but they can check system requirements.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "No, you can\u2019t upgrade directly from Windows 8 or 8.1 to Windows 11. Upgrading from Windows 10 to Windows 11 might be free based on the situation, but to upgrade from Windows 8, you would need to buy a Windows 10 or 11 license and perform a clean install. A PC can be upgraded from Windows 10 Professional to Windows 11 Professional directly from the desktop of the PC, but not to a different edition; for example, going from Windows 10 Home to Windows 11 Pro would require purchasing a Windows 11 Pro license. The other consideration is that hardware that ran a Windows 8 PC probably won\u2019t meet the hardware requirements for Windows 11.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      18,
      8,
      44,
      46
    ],
    "source": "9781394330348"
  },
  {
    "id": 658,
    "question": "You need to uninstall an app that is on your Linux computer. What command will you use?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>sudo</code>",
    "choice_c": "<code>apt-remove</code>",
    "choice_d": "<code>ps</code>",
    "correct_answer": "C",
    "explanation": "In many Linux distributions, the <code>apt</code> or <code>apt-get</code> command is used to download or remove software packages. The syntax for this command is <code>apt-remove [<i>options</i>] <i>command</i></code>. There are too many options to explain them all here, but in the question we are uninstalling an app, so the command could be <code>apt-get purge [<i>package name</i>]</code>, but remember that you would want to precede the <code>apt-get</code> command with <code>sudo</code>. If the package name were <code>milou</code>, then the command would be <code>sudo apt-get purge milou</code>. Using <code>purge</code> deletes all configuration files as well as the package. The <code>sudo</code> command stands for superuser do, or substitute user do, and will run a single command as the alternate user. The <code>su</code> command (i.e., switch user, substitute user, or super user) is used to start another shell on a Linux computer. Without specifying the username, it\u2019s assumed you are trying to start a shell with super user (or <code>root</code>) authority. The <code>ps</code> command will list the processes that are currently running along with their Process IDs (PIDs).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      101,
      99,
      98,
      103,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 659,
    "question": "You want to upgrade all the computers in your SOHO from Window 11 Home to Windows 11 Pro so your computers can join a domain. You don\u2019t want to lose user information and settings in the process. Which type of installation will you perform?",
    "choice_a": "Clean installation",
    "choice_b": "In-place upgrade",
    "choice_c": "Program-only upgrade",
    "choice_d": "Multiboot",
    "correct_answer": "B",
    "explanation": "An in-place upgrade enables you to keep user settings, apps, and data while upgrading a system. You can also use an in-place upgrade to refresh an operating system\u2019s files if you\u2019re having difficulties and are unable to resolve them. Make sure you log in with an administrator account. Sometimes, the in-place upgrade doesn\u2019t work perfectly and changes something you didn\u2019t want it to change, so be certain that you have a backup before executing the upgrade, preferably as a system image. A clean installation wipes out everything on the hard drive and replaces it with a new operating system (OS). A program-only upgrade isn\u2019t a real term. A multiboot is having two OSs on a computer and choosing which one you want to use at startup. This is cumbersome at best, and the new OS wouldn\u2019t automatically have all your files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      18,
      50,
      55,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 660,
    "question": "You\u2019re having trouble with a new digitizing pad that the operating system doesn\u2019t seem to be recognizing. Which tool would you use to troubleshoot the problem?",
    "choice_a": "Event Viewer",
    "choice_b": "Performance Monitor",
    "choice_c": "Device Manager",
    "choice_d": "Disk Management",
    "correct_answer": "C",
    "explanation": "Device Manager is the first place to go when troubleshooting hardware. A yellow exclamation point will let you know that there is a problem that needs to be addressed. Event Viewer keeps logs of system, security, and application events. Performance Monitor helps locate bottlenecks in a system by showing resources being used in real-time, and Disk Management allows formatting, partitioning, and managing storage drives.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      29,
      28,
      27,
      40,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 661,
    "question": "You suspect that one of your running services is causing problems with the operating system. What is the tool, shown in the graphic, that lets you choose a diagnostic startup on the next restart?<img src=\"/question_assets/220-1202/c06f010.png\" alt=\"Screenshot of the Windows System Configuration depicts the General tab with Selective startup selected.\"/>\n\n<figcaption>Screenshot of the Windows System Configuration depicts the General tab with Selective startup selected.</figcaption>",
    "choice_a": "Event Viewer",
    "choice_b": "Performance Monitor",
    "choice_c": "System Information",
    "choice_d": "System Configuration",
    "correct_answer": "D",
    "explanation": "System Configuration (<code>msconfig.exe</code>) has been appearing in Windows operating system (OSs) since 2006, but its features have changed over time. The General tab lets you choose a Diagnostic startup that will load just basic devices and services, which can sometimes aid in troubleshooting. The Boot tab lets you choose other boot options. Timeout, on the right of the Boot tab, can be set if you have more than one OS on the hard drive and want time to choose between them. However, a more common option now is to use Virtual Machines (VMs) when more than one OS is needed. The Services tab is where you can stop and start many services, although that can also be done through the services console (<code>services.msc</code>), which has all of the services. The Startup tab only has a link to Task Manager, and the Tools tab is used to provide quick access to other Windows tools. Event Viewer (<code>eventvwr.msc</code>) keeps logs of system, application, and security events that can be used for activities, such as detecting attempted unauthorized access to resources. Performance Monitor (<code>perfmon.msc</code>) offers a graphic display of a wide range of counters to track how well hardware, such as Random Access Memory (RAM) drives and Central Processing Units (CPUs), are performing over time. System Information provides a snapshot of the system\u2019s hardware and software, including the OS version, RAM, processor, motherboard, and much more. The program to launch it is <code>msinfo32.exe.</code>",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      43,
      34,
      1,
      5
    ],
    "source": "9781394330348"
  },
  {
    "id": 662,
    "question": "You need to check the integrity of key Windows system files on the <code>C:</code> drive, which are hidden from view by default. Which Control Panel utility can you use to view hidden files?",
    "choice_a": "Programs and Features",
    "choice_b": "File Explorer Options",
    "choice_c": "Indexing Options",
    "choice_d": "System",
    "correct_answer": "B",
    "explanation": "Some of the more important files that you will need to work on are hidden by default as a security precaution. To make certain folders or files visible, you need to change the display properties of File Explorer. This can be done by going to the View tab of File Explorer Options in the Control Panel and deselecting Hide Protected Operating System Files (Recommended). Programs and Features is for uninstalling or changing programs and turning Windows features on and off. Indexing makes a log of the metadata of files and helps search work faster. The System utility of the Control Panel opens System in Windows Settings.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      25,
      32,
      30,
      107,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 663,
    "question": "What is the name of the macOS command-line user interface?",
    "choice_a": "Terminal",
    "choice_b": "Finder",
    "choice_c": "Command Prompt",
    "choice_d": "File Explorer",
    "correct_answer": "A",
    "explanation": "Terminal has long been the name of the command-line user interface in both macOS and Linux. In Windows 11, Microsoft added Terminal to their operating system (OS), which launches a PowerShell command-line interface and enables the user to include tabs for other command-line interfaces such as the original Command Prompt. In any command-line interface, a user can type commands to perform actions and launch programs. Often, for experienced users, using a command-line interface is faster than navigating menus. Finder is the macOS utility for drilling down through folders to find objects. Command Prompt is the name of the older Windows command-line user interface, and File Explorer is the Windows rendition of Finder.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      82,
      7,
      63,
      85,
      5
    ],
    "source": "9781394330348"
  },
  {
    "id": 664,
    "question": "You\u2019re setting up an online storage system for backing up your data, but the remote storage company said that you need to open your software firewall to allow the online storage solution to communicate with your computer. Where in the Windows Control Panel can you do this?",
    "choice_a": "Programs and Features",
    "choice_b": "Internet Options",
    "choice_c": "Windows Defender Firewall",
    "choice_d": "Network and Sharing Center",
    "correct_answer": "C",
    "explanation": "Windows Defender Firewall is a software firewall residing on the local system that provides features designed to protect your system from malware. Unfortunately, sometimes those settings interfere with other applications and need to be changed. Turning the firewall off is not advisable, but you can open it up to applications by clicking on Allow an app or feature through Windows Defender Firewall. Programs and Features is used to uninstall or change applications and turn Windows features on and off. Internet Options affect how browsers work and can be used to connect to a virtual private network (VPN). The Network and Sharing Center is the Windows Control Panel tool for viewing and configuring network connections and changing adapter settings.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      33,
      69,
      32,
      34,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 665,
    "question": "You\u2019re troubleshooting a file problem and need to see the file extensions, but they are not visible. Which Control Panel utility can you use to show hidden file extensions?",
    "choice_a": "Programs and Features",
    "choice_b": "File Explorer Options",
    "choice_c": "Indexing Options",
    "choice_d": "File Explorer",
    "correct_answer": "B",
    "explanation": "Most computer users don\u2019t need to look at file extensions, but sometimes as technicians, those extensions are very important! The option to hide or show file extensions is found on the View tab of File Explorer Options in the Control Panel. You can also hide them in File Explorer, which is not a Control Panel utility, by clicking on View, then Show, and unchecking the box that says File name extensions. Programs and Features is for uninstalling or changing programs and turning Windows features on and off. Indexing makes a log of the files\u2019 metadata and helps search work faster. File Explorer is incorrect because the question asks for a Control Panel utility, and it isn\u2019t one. File Explorer is opened through the folder icon on the task bar.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      32,
      7,
      42,
      60
    ],
    "source": "9781394330348"
  },
  {
    "id": 666,
    "question": "You need to make some changes to group membership for an employee who was just promoted. Which of the following will you type in the Run dialog box?",
    "choice_a": "<code>eventvwr.msc</code>",
    "choice_b": "<code>lusrmgr.msc</code>",
    "choice_c": "<code>perfmon.msc</code>",
    "choice_d": "<code>groups.exe</code>",
    "correct_answer": "B",
    "explanation": "The Local Users and Groups application can be launched with the <code>lusrmgr.msc</code> command and provides quick access to modify users and the groups to which they belong. The Event Viewer can be launched with <code>eventvwr.msc</code> and tracks actions involving security, applications, and the system, and will audit failed or successful logins. Performance Monitor can be launched with <code>perfmon.msc</code>, and <code>groups.exe</code> isn\u2019t a real application in Windows 11.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      34,
      63,
      7,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 667,
    "question": "You are working on a Linux file server. Which command would you use to see the amount of free disk space on a volume?",
    "choice_a": "<code>grep</code>",
    "choice_b": "<code>df</code>",
    "choice_c": "<code>ps</code>",
    "choice_d": "<code>dig</code>",
    "correct_answer": "B",
    "explanation": "The <code>df</code> command (i.e., disk free command) is used to show free and used disk space on a volume. The syntax of this command is <code>df [<i>option</i>] [<i>file</i>]</code>. If you type <code>df</code> and press Enter, it will show the space available on all filesystems that are mounted. If you specify a particular file, it will provide information on that file. The <code>grep</code> Linux command will search for files with a pattern that you specify. The <code>ps</code> command will list the processes that are currently running along with their Process IDs (PIDs). The <code>dig</code> command (i.e., Domain Information Grouper command) works in Linux and macOS to find information about Domain Name System (DNS) name servers, mail exchanges, and hosts.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      106,
      103,
      104,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 668,
    "question": "You are working on a Windows 11 workstation and want to change the Account Lockout policy. You are working at a command prompt. Which of the following commands can you enter to open a graphical utility that enables you to change all local policy settings?",
    "choice_a": "<code>gpedit</code>",
    "choice_b": "<code>gpresult</code>",
    "choice_c": "<code>gprefresh</code>",
    "choice_d": "<code>gpupdate</code>",
    "correct_answer": "A",
    "explanation": "The <code>gpedit</code> command allows the user to edit group policies, while the <code>gpresult</code> command will show the Resultant Set of Policy (RSoP) for a user or computer. RSoP is the culmination of all policies that affect the target user or computer. It is particularly helpful in troubleshooting conflicting policies. <code>gprefresh</code> is not a valid command. The <code>gpupdate</code> tool is used to update Group Policy settings immediately after policy changes have been made. It refreshes, or changes, both local and Active Directory(AD)\u2013based policies.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      60,
      64,
      30,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 669,
    "question": "You\u2019re setting up security for a company that is expanding rapidly. Part of your plan is to create groups to manage permissions to folders and then add users to those groups to grant them the permissions they need. What utility will enable you to add users to groups?",
    "choice_a": "Device Manager",
    "choice_b": "Local Users and Groups",
    "choice_c": "Certificate Manager",
    "choice_d": "Group Policy Editor",
    "correct_answer": "B",
    "explanation": "Local Users and Groups allows you to organize users by access need and assign permissions and access to the group rather than the user, thus simplifying access management. Incidentally, assigning New Technology File System (NTFS) permissions to groups rather than individuals is considered a best practice. Suppose your accounting manager suddenly quits and you hire a new one. Rather than setting up permissions for the new manager, you would merely add their username to the appropriate groups. (And, of course, disable the former manager\u2019s account.) Group Policy Editor allows administrators to further control what users and computers are allowed to do on the network, such as enforcing password complexity, disabling USB drives, and limiting what users can do in the Control Panel. Device Manager is a hardware management tool, and Certificate Manager allows you to view and manage certificates by user or computer. Certificates hold the private key of a key pair used in encryption.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      32,
      60,
      65,
      72
    ],
    "source": "9781394330348"
  },
  {
    "id": 670,
    "question": "One of your users has a MacBook Air, and an application appears to have crashed. What can they use to compel the app to close?",
    "choice_a": "Task Manager",
    "choice_b": "Force Quit",
    "choice_c": "Terminal",
    "choice_d": "Time Machine",
    "correct_answer": "B",
    "explanation": "When an app hangs inside macOS, you can use Force Quit to force it to close. Most devices, whether running macOS or iOS, offer similar options. You get to Force Quit by looking at the Apple menu or by pressing Command+Option+Esc, which is analogous to pressing Ctrl+Alt+Del on a Windows PC. Task Manager is a Windows utility, Terminal is the macOS and Linux command-line user interface, and Time Machine is used for backups. Windows 11 includes Terminal, which opens a PowerShell command-line interface and enables users to open multiple tabs for different command-line interfaces.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      82,
      27,
      5,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 671,
    "question": "You would like to monitor CPU, memory, and Wi-Fi usage in real time on a Windows computer. Which of the following options will provide you with that information? (Choose two.)",
    "choice_a": "The Task Manager Performance tab",
    "choice_b": "In Administrative Tools, choose System Information.",
    "choice_c": "Event Viewer",
    "choice_d": "Resource Monitor",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Although the graphs look different in each application, both the Performance tab of Task Manager and the Resource Monitor utility will show Central Processing Unit (CPU), memory, and Wi-Fi statistics in real-time. In Performance Monitor, a Wi-Fi connection could be found on the Network tab. Event Viewer logs system, software, and security events. The System Information utility, which can be found in Administrative Tools, shows a snapshot of a system\u2019s configuration, but not real-time information. Note: Administrative Tools is a utility in Windows 10 but is not a part of Windows 11. Instead, Windows 11 has the Windows Tools application, which has many but not all of the same utilities available in the Administrative Tools utility. Note that Windows Tools is not on the CompTIA A+ objectives, but Administrative Tools is.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      31,
      43,
      34,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 672,
    "question": "You are on a Linux computer working in Terminal and need to see a list of files in the directory that you are working in. What command will you type?",
    "choice_a": "<code>dir</code>",
    "choice_b": "<code>ls</code>",
    "choice_c": "<code>pwd</code>",
    "choice_d": "<code>grep</code>",
    "correct_answer": "B",
    "explanation": "The Linux <code>ls</code> command lists information about files in the working directory. The <code>dir</code> command in Windows does the same. The <code>pwd</code> Linux command prints the complete path to the working directory, and the <code>grep</code> Linux command will search for files with a pattern that you specify.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      107,
      98,
      104,
      105,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 673,
    "question": "What Linux utility is like the Windows Command Prompt?",
    "choice_a": "Time Machine",
    "choice_b": "Mission Control",
    "choice_c": "Terminal",
    "choice_d": "Shell",
    "correct_answer": "C",
    "explanation": "The Linux Terminal is a command-driven user interface that allows the user to interact with the shell by typing commands at a prompt, much like the Windows Command Prompt in Windows 10 and previous versions, or the Terminal in Windows 11. The command-driven user interface in macOS is also called Terminal. The shell is the part of the operating system (OS) that sits between the user and the rest of the OS, allowing the user to interact with the OS. Time Machine and Mission Control are features of macOS used for backups and viewing all open applications, respectively.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      98,
      82,
      63,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 674,
    "question": "A system has been doing some quirky things, and you think it might have something to do with a temporary file. A best practice to avoid malware is to remove files and programs that aren\u2019t being used. Which tool, shown in the graphic, will you use to delete temporary and unused files from a computer system?<img src=\"/question_assets/220-1202/c06f011.png\" alt=\"Screenshot of Windows Disk Cleanup options with checkboxes for various file types to delete and potential disk space gain.\"/>\n\n<figcaption>Screenshot of Windows Disk Cleanup options with checkboxes for various file types to delete and potential disk space gain.</figcaption>",
    "choice_a": "<code>resmon.exe</code>",
    "choice_b": "<code>diskmgmt.msc</code>",
    "choice_c": "<code>regedit.exe</code>",
    "choice_d": "<code>cleanmgr.exe</code>",
    "correct_answer": "D",
    "explanation": "Disk Cleanup (<code>cleanmgr.exe</code>) will look through your hard drive and show how much space unused files are taking up. You then have the option to choose which files you would like to delete. Clicking on a file type will provide a description of what is being deleted. On modern, large hard drives, the space saved is usually negligible. Resource Monitor (<code>resmon.exe</code>) shows resources being used by process in real-time. Disk Management (<code>diskmgmt.msc</code>) is a graphic utility for creating, formatting, and managing volumes on any physical drives attached to the system. You can even use it to configure software Redundant Array of Independent Disks (RAID). The Registry is a huge database that contains information about all the users, hardware, software, and configuration information in a computer. Typically changing the registry by using the Registry Editor (<code>regedit.exe</code>) is a last resort, because changes are immediate and there is no undo button. The Control Panel and Windows Settings can do much of the registry management for you, and they\u2019re much safer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      31,
      28,
      35,
      42,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 675,
    "question": "You\u2019re using the Event Viewer tool to see a list of failed login attempts. What command will you launch to access it?",
    "choice_a": "<code>eventvwr.msc</code>",
    "choice_b": "<code>lusrmgr.msc</code>",
    "choice_c": "<code>perfmon.msc</code>",
    "choice_d": "<code>groups.exe</code>",
    "correct_answer": "A",
    "explanation": "The Event Viewer can be launched with <code>eventvwr.msc</code>. Event Viewer tracks actions involving security, applications, and the system, and it will audit failed or successful logins. The Local Users and Groups application can be launched with the <code>lusrmgr.msc</code> command and provides quick access to modify users and the groups to which they belong. Performance Monitor can be launched with <code>perfmon.msc</code>, and <code>groups.exe</code> isn\u2019t a real application in Windows 11.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      28,
      30,
      31,
      34,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 676,
    "question": "You have recently deployed a custom application to several Windows workstations on your network. The application appears to have a bug, and the developer suggests you edit the Registry to fix it. Which administrative tool would you use to do this?",
    "choice_a": "<code>msinfo32.exe</code>",
    "choice_b": "<code>compmgmt.msc</code>",
    "choice_c": "<code>regedit.exe</code>",
    "choice_d": "<code>notepad.exe</code>",
    "correct_answer": "C",
    "explanation": "Windows configuration information is stored in a special configuration database known as the Registry. This centralized database also contains environmental settings for various Windows programs. To edit the Registry, use the <code>regedit.exe</code> program. Be careful, though, because an incorrect Registry change can render a system inoperable. Changes are immediate and there is no undo. the System Information utility, <code>msinfo32.exe</code>, provides a snapshot of the hardware, software, and some configuration information for the system. Entering <code>compmgmt.msc</code> opens computer management, and <code>notepad.exe</code> launches the Notepad program, which is a simple text editor. Commands like these can be run using the Command Prompt, the Windows Terminal, or the run command, which can be accessed by pressing the Windows Logo Key+R.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      35,
      28,
      30,
      62,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 677,
    "question": "A couple of applications that run at startup are causing problems with a computer. Where can you change settings, so those programs won\u2019t automatically start when the computer does?",
    "choice_a": "Task Manager, Services tab",
    "choice_b": "Task Manager, Startup apps",
    "choice_c": "Services Console",
    "choice_d": "Task Scheduler",
    "correct_answer": "B",
    "explanation": "To stop (disable) programs from running on startup, use the Startup apps list in Task Manager, which is found by clicking its icon on the left of the Task Manager screen. The System Configuration utility was the place to go in older versions of Windows, but now it merely has a link to Task Manager. Services are programs that run in the background and are part of the operating system, not applications that have been added. A limited subset of them can be configured on the Services tab of Task Manager, or all services can be accessed through the Services Console (<code>services.msc</code>). Task Scheduler is used to automatically perform some action(s) when a trigger, such as a date, time, or other event, is reached.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      30,
      43,
      28,
      34
    ],
    "source": "9781394330348"
  },
  {
    "id": 678,
    "question": "You are working on a computer with macOS, with about a dozen applications open. Which feature allows you to easily see all of them and switch to your desired application?",
    "choice_a": "Spotlight",
    "choice_b": "Keychain",
    "choice_c": "Mission Control",
    "choice_d": "Finder",
    "correct_answer": "C",
    "explanation": "On a Mac, it\u2019s possible to run numerous things at one time, whether those things in question are apps or Windows Desktops. Apple\u2019s Mission Control is an easy way to see what is open and switch between applications. To access Mission Control, you can press the Mission Control key (identified by an image of three different size rectangles) on an Apple keyboard, click the Mission Control icon in Dock (or Launchpad), or swipe up with three or four fingers on a trackpad. Spotlight is used to search for files, folders, images, and such. Keychain is the macOS password-management feature, and Finder enables the user to drill down through directories to find what they\u2019re looking for, much like File Explorer in Windows.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      85,
      83,
      76,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 679,
    "question": "You have a Windows 11 Pro computer with multiple printers installed. Which Control Panel utility allows you to manage multiple print servers and printers from a single interface?",
    "choice_a": "Devices and Printers",
    "choice_b": "Programs and Features",
    "choice_c": "Network and Sharing Center",
    "choice_d": "Device Manager",
    "correct_answer": "A",
    "explanation": "Clicking Devices and Printers in Windows 11 will take you to Settings, Bluetooth & Devices, where you can click on Printers and Scanners. From there, you can manage multiple printers and perform tasks, such as choosing a default printer, installing new printers, and changing printer settings. Programs and Features allows the user to add, remove, or troubleshoot installed programs (the options will change by program) and add or remove Windows features. The Network and Sharing Center is the Windows Control Panel tool for viewing and configuring network connections and changing adapter settings. Device Manager should be your go-to app when resolving hardware issues. From there, you can update or install drivers, see what isn\u2019t working, and disable hardware if need be.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      68,
      29,
      33,
      69
    ],
    "source": "9781394330348"
  },
  {
    "id": 680,
    "question": "Which power state will close applications and files, log off users like a full shutdown would, save the kernel state and system session to a hibernation file before shutdown, and then, when the computer restarts, quickly restore that file, saving some time involved in a normal boot?",
    "choice_a": "Hibernate",
    "choice_b": "Sleep",
    "choice_c": "Selective Suspend",
    "choice_d": "Fast Startup",
    "correct_answer": "D",
    "explanation": "Fast Startup is similar to Hibernate in how it works, but instead of saving all of your applications and data as you had them so you\u2019re instantly back at work, it saves the system state. As described in the question, Fast Startup will close running apps and log off any users, then save the contents of Random Access Memory (RAM) to a hibernation file. When the computer starts back up, it reads the hibernation file and loads drivers, system state, and kernel much more quickly than it would if the system had to read all of that information individually back into RAM, like it would in a normal cold boot. Sleep stores everything that\u2019s open in RAM and enters a low-power state. The display and drives aren\u2019t using power, but power is needed to continually refresh memory so it can retain information. It uses very little power, but \u201cwakes up\u201d very quickly with everything open as it was. Hibernate stores open programs and data to the hard drive then shuts down the computer so it uses no power, but it does not resume its state as quickly as Sleep does.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      32,
      27,
      43,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 681,
    "question": "You\u2019re troubleshooting a Windows computer that is unable to resolve domain names to IP addresses. What command-line utility can help identify what DNS server the computer relies on?",
    "choice_a": "<code>nslookup</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>ping</code>",
    "choice_d": "<code>tracert</code>",
    "correct_answer": "A",
    "explanation": "The <code>nslookup</code> utility will query the Domain Name System (DNS) server the computer is currently configured to use. The utility can be used to perform a variety of DNS queries. The <code>netstat</code> command shows what Transmission Control Protocol (TCP) connections exist on a computer and the port number they are using. The <code>ping</code> command is used to determine whether there is connectivity with a remote computer. When entered as <code>ping localhost</code>, it is used to determine if TCP/IP is running on the local computer, and <code>tracert</code> displays the path (i.e., routers) that a packet took to get to a remote computer. Traceroute is used in Linux for similar purposes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      59,
      58,
      106,
      62,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 682,
    "question": "A user recently left the company, and you need to change ownership of their files on the Linux server to a new user. Which command should you use to do this?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>chmod</code>",
    "choice_c": "<code>cat</code>",
    "choice_d": "<code>cp</code>",
    "correct_answer": "A",
    "explanation": "The <code>chown</code> command (i.e., change owner command) is used to change ownership of files in Linux. The syntax to change the owner of a file is <code>chown <i>owner-name filename</i></code>. The <code>chmod</code> command (i.e., change mode command) is used to modify the mode of the file, meaning who has what access to the file. The <code>cat</code> command is a powerful tool that can be used to view contents of a file, create new files, and concatenate (i.e., put together) files. The <code>cp</code> command is used to copy files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      98,
      99,
      100
    ],
    "source": "9781394330348"
  },
  {
    "id": 683,
    "question": "You need to configure a VPN for an employee working remotely on a Windows Pro computer. What category group in Windows Settings provides options for establishing dial-up or VPN connections?",
    "choice_a": "Network and Sharing Center",
    "choice_b": "Network & Internet",
    "choice_c": "System",
    "choice_d": "Accounts",
    "correct_answer": "B",
    "explanation": "Network & internet is the Settings category that provides options for setting up virtual private network (VPN) or dial-up connections. Network and Sharing Center is a Control Panel utility. The System category of Settings deals with display, sound, power, notification, and other settings. The Accounts category is useful for managing users and syncing settings. In Windows 11 (but not Windows 10), Windows backup is included in the Accounts category.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      66,
      32,
      20,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 684,
    "question": "You\u2019re installing Windows 11 on a computer that uses BIOS, not UEFI, and has only one storage drive. You\u2019ll be booting from this drive. Which of the following are true? (Choose two.)",
    "choice_a": "The partition scheme must be MBR.",
    "choice_b": "The partition scheme must be GPT.",
    "choice_c": "The partition must be less than 2 TB.",
    "choice_d": "You won\u2019t be able to boot from this drive.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When a motherboard uses basic input/output system (BIOS) rather than Unified Extensible Firmware Interface (UEFI) to manage firmware, it must use the Master Boot Record (MBR) partition type, or the drive will not be bootable. A Globally Unique Identifier (GUID) Partition Table (GPT) partition will be able to be read but not booted to. MBR\u2019s partition size limit is 2 TB, but the newer GPT partition scheme can, in theory, support drives with up to 128 partitions of 18 EB each, but is limited by operating system capabilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      44,
      46,
      54,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 685,
    "question": "A print queue has stalled, so you\u2019re going to stop and restart the Print Spooler service. Where can you do this?",
    "choice_a": "Device Manager",
    "choice_b": "Task Manager, Services",
    "choice_c": "Disk Management, Services",
    "choice_d": "Task Scheduler",
    "correct_answer": "B",
    "explanation": "The Services console (<code>services.msc</code>) enables you to manage all the computer\u2019s services. The Services option in Task Manager is a subset of those services. There are several utilities where you can find out what services are running, with the option to enable and disable services. They include the Services console, Computer Management, and Task Manager. In Windows 10 but not Windows 11, they include the Control Panel\u2019s Administrative Tools utility. In Windows 11 only, services can be found in the Windows Tools utility. Note: Administrative Tools is on the CompTIA A+ exam, but Windows Tools is not. Disk Management does not have a link to the Services console, and Task Scheduler is designed to perform tasks when a trigger happens, such as a date, time, or event.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      30,
      40,
      43
    ],
    "source": "9781394330348"
  },
  {
    "id": 686,
    "question": "A user types their username and password into a workstation, which is a member of a domain instead of a workgroup. What examines their information and determines whether they are allowed access to network resources?",
    "choice_a": "Local operating system",
    "choice_b": "File server",
    "choice_c": "AAA server",
    "choice_d": "DHCP server",
    "correct_answer": "C",
    "explanation": "A domain uses an Authentication, Authorization, and Accounting (AAA) server to determine whether a user is granted access to shared resources. In Windows, an Authentication server is also known as a Domain Controller. Domains are not available with Windows Home editions. Windows Home editions can only use a workgroup, and in that case the operating system (OS) on the device with the shared resource would allow or deny access. A file server is a computer that provides access to shared files. A Dynamic Host Configuration Protocol (DHCP) server is used to automatically assign Internet Protocol (IP) addresses and configure network settings. A DHCP server is often included in the software on a Small Office/Home Office (SOHO) router.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      20,
      72,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 687,
    "question": "Your spouse takes gaming seriously and has complained that restart notifications sometimes pop up on the screen at crucial moments, disrupting their game. What settings group can you use to stop restart notifications from appearing and stop unnecessary programs from running in the background?",
    "choice_a": "System",
    "choice_b": "Gaming",
    "choice_c": "Windows Update",
    "choice_d": "Apps",
    "correct_answer": "B",
    "explanation": "Although you can turn off all notifications or manage if and how individual notification senders can interact with you in Windows Settings, the System group, then Notifications & Actions, this is not the correct answer because it doesn\u2019t stop the background activity, it only stops the notifications. Game mode, found in the Gaming options group, enables configuring the system to be optimized for gameplay and recording, including stopping unnecessary programs from running in the background. In addition to preventing driver update installations and stopping restart notifications, it changes some settings affecting the video frame rate. Windows Update settings don\u2019t address notifications. The Apps option lets you manage where apps can be installed from, default apps for opening files, and other application configuration settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      30,
      43,
      33,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 688,
    "question": "What type of operating system is found on an Apple iPhone?",
    "choice_a": "iPhone OS",
    "choice_b": "iOS",
    "choice_c": "Android",
    "choice_d": "Windows for iPhone",
    "correct_answer": "B",
    "explanation": "iOS is the proprietary operating system for iPhones. iPhone OS and Windows for iPhone don\u2019t exist. The Android OS was developed by Google and is used on smartphones, tablets, and other touchscreen devices. Other operating systems include iPadOS for use on iPads; Windows, Linux, and macOS found on desktop and laptop PCs; and Chrome OS, which is proprietary and found on Chromebooks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      4,
      2,
      1,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 689,
    "question": "You want to find and download a new application to use for network monitoring on your MacBook. Where can you do this in macOS?",
    "choice_a": "Finder",
    "choice_b": "App Store",
    "choice_c": "Mission Control",
    "choice_d": "FileVault",
    "correct_answer": "B",
    "explanation": "The App Store is where you would go to locate and download new programs. Finder enables a user to drill down through folders to find what they are looking for. Mission Control is an easy way to see what is open and switch between applications, and FileVault provides encryption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      74,
      84,
      76,
      75,
      85
    ],
    "source": "9781394330348"
  },
  {
    "id": 690,
    "question": "You work as the IT manager of a telephone call center. Your company just purchased 100 computers in anticipation of a large wave of hiring, and you need to configure them all with the OS, applications, and settings that your company uses. What type of installation will you do?",
    "choice_a": "Upgrade",
    "choice_b": "Recovery partition",
    "choice_c": "Repair installation",
    "choice_d": "Image deployment",
    "correct_answer": "D",
    "explanation": "Image deployments are usually done in a large volume setting where you have many computers configured identically. One machine will have the operating system (OS) and applications installed, with the settings configured. An image is then created. This image can be stored on a network drive, a Universal Serial Bus (USB) drive, or other media. When it is installed, it will include the OS, software, and settings that were configured on the original machine. An upgrade installation will keep all your files and settings but install a different OS version on your computer. A recovery partition is often created on a laptop that is purchased from a major supplier. There will be a key (or multiple keys) to press while the computer is booting. The exact key(s) will depend on the laptop\u2019s manufacturer. Using a recovery partition will erase everything on the drive and restore the computer to the state it was in when it was received from the manufacturer. (This is sometimes called a factory reset.) A repair installation will use the same OS and attempt to leave all your files and settings while fixing any of the operating system files.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      52,
      45,
      46,
      14,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 691,
    "question": "A MacBook user has a program that they no longer use. What are their options for removing it from their computer? (Choose two.)",
    "choice_a": "Use Finder and then Applications to locate the app, and then right-click and choose Delete.",
    "choice_b": "Use Finder and then Applications to locate the app\u2019s folder, and then drag the app to Trash, or on your keyboard press Command+Delete.",
    "choice_c": "Use Launchpad, hold the Option key until the apps wiggle, then click the <code>X</code> next to the app to delete it, and then click Applications to find the app and drag the app from the Applications folder to Trash.",
    "choice_d": "Click on Apple and then Uninstall, and then choose the app.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "An app can be deleted simply by dragging it to Trash, but if it has its own folder, you must look for an uninstall program. Right-clicking and deleting is how you might remove a file in a Windows operating system (OS). There is no uninstall option from the Apple menu.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      76,
      75,
      85,
      7,
      4
    ],
    "source": "9781394330348"
  },
  {
    "id": 692,
    "question": "You\u2019re on a Linux system and need to change a user\u2019s access to a file. Which command will you use to do this?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>chmod</code>",
    "choice_c": "<code>cat</code>",
    "choice_d": "<code>cp</code>",
    "correct_answer": "B",
    "explanation": "The <code>chmod</code> command (i.e., change mode command) is used to modify the file\u2019s mode, meaning who has what type of access to the file. The who is divided into the file owner, group members, and others (i.e., everyone else). The permissions that can be assigned are read, write, and execute. The command can be quite complicated, but in its basic form, it is <code>chmod [<i>reference</i>][<i>operator</i>][<i>mode</i>] <i>file</i></code>. As an example, if I want to restrict a user (i.e., the owner) of a file named <code>bogus</code> from writing to that file, the command would be <code>chmod u=r bogus</code>. In the command, <code>u</code> is the reference to the user, <code>=</code> is the operator, and <code>r</code> is the mode. Then, to see the result, type <code>ls -l</code>,as shown in the following figure. Before changing the permission on the file named <code>bogus</code>, running the <code>ls -l</code> command may have shown <code>-rw-rw-r</code>. The first <code>-</code> means it\u2019s a file, not a folder. After that, the three sets of characters (<i><code>rwx</code></i>) are as follows: first set for owner, second set for group, and third set for others. As shown in the graphic, after the <code>chmod u=r bogus</code> command runs, the permissions shown for the bogus file when <code>ls -l</code> is run should be <code>-r--rw-r--</code>, showing that the write permission for the owner was removed. The <code>chown</code> command (i.e., change owner command) is used to change ownership of files in Linux. The <code>cat</code> command is powerful and can be used to view contents of a file, create new files, and concatenate (i.e., put together) files. The <code>cp</code> command is used to copy files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      105,
      98,
      99,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 693,
    "question": "You just got a new MacBook for a child, but they said the text on the screen is too hard to read. What system preference would you use to help them?",
    "choice_a": "Accessibility options",
    "choice_b": "Displays",
    "choice_c": "Privacy",
    "choice_d": "Time Machine",
    "correct_answer": "A",
    "explanation": "Click Apple, then Preferences, and choose Accessibility options to find several features that make interacting easier for people with different abilities. Zoom can enlarge text on the screen. VoiceOver will read screen contents. Sticky Keys lets the user press key combinations one key at a time. There are several other accessibility options as well. Displays is obviously where you would configure display settings. Privacy is for privacy settings, and Time Machine is for backing up the system.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      81,
      85,
      34,
      79,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 694,
    "question": "An application on a user\u2019s Windows Pro workstation has become corrupted. Where can you go in the Control Panel to attempt to repair, or reinstall, the application?",
    "choice_a": "Devices and Printers",
    "choice_b": "Programs and Features",
    "choice_c": "Network and Sharing Center",
    "choice_d": "Device Manager",
    "correct_answer": "B",
    "explanation": "Programs and Features allows the user to add, remove (i.e., uninstall), or troubleshoot (i.e., repair) installed programs (the options will change by program), and add/remove Windows features. From Devices and Printers, you can manage multiple printers and perform tasks, such as choosing a default printer, installing new printers, and changing printer settings. The Network and Sharing Center is the Windows tool for viewing and configuring network connections and changing adapter settings. Device Manager should be your go-to app when resolving hardware issues. From there, you can update or install drivers, see what isn\u2019t working, and disable hardware if need be.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      29,
      30,
      14,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 695,
    "question": "A Wi-Fi user at your company said that their MacBook isn\u2019t connecting to the network. What option will you choose from Preferences in the Apple menu to turn Wi-Fi on and select Automatically Join This Network?",
    "choice_a": "Ethernet",
    "choice_b": "Wi-Fi",
    "choice_c": "Network",
    "choice_d": "Accessibility",
    "correct_answer": "C",
    "explanation": "The correct choice is Network, where you can see all the network connections of the MacBook. Ethernet and Wi-Fi are not choices in Preferences. Accessibility provides access to features that make working with a Mac easier for differently-abled people.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      85,
      66,
      7,
      38
    ],
    "source": "9781394330348"
  },
  {
    "id": 696,
    "question": "You are at a Linux workstation and need to search for text within several files. Which command should you use?",
    "choice_a": "<code>sudo</code>",
    "choice_b": "<code>grep</code>",
    "choice_c": "<code>cp</code>",
    "choice_d": "<code>ls</code>",
    "correct_answer": "B",
    "explanation": "The <code>grep</code> command (i.e., short for the impossibly long Globally Search a Regular Expression and Print) does just what it says it does: It searches for a string of text and then displays the results of what it found. The syntax is <code>grep [<i>options</i>] <i>pattern</i> [<i>files</i>]</code>. The <code>sudo</code> command stands for superuser do, or substitute user do, and will run a single command as the alternate user. The <code>cp</code> command copies files, and <code>ls</code> provides a list of the working directory\u2019s contents.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      98,
      105,
      99,
      103,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 697,
    "question": "You need to install Windows on a new machine. Which of the following is not an installation option?",
    "choice_a": "USB",
    "choice_b": "Network",
    "choice_c": "External drive",
    "choice_d": "CD",
    "correct_answer": "D",
    "explanation": "Compact Disks (CDs) don\u2019t hold enough information to be used for installation media for Windows. Windows media can be installed from a Universal Serial Bus (USB) or external drive, or via a network connection, provided there is a way to boot to the network such as Pre-boot Execution Environment (PXE) support.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      46,
      45,
      44,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 698,
    "question": "Which of the following is not a best practice for hardening your macOS against attack?",
    "choice_a": "Use Time Machine to back up your Mac.",
    "choice_b": "Use BitLocker to encrypt your drive.",
    "choice_c": "Install updates and patches as soon as they are available.",
    "choice_d": "Turn on the firewall in the System Settings, Network, and then click to enable the Firewall.",
    "correct_answer": "B",
    "explanation": "The program used to encrypt a drive on a Mac is FileVault. BitLocker does the same in the Windows operating system (OS), so BitLocker is the one thing listed that you would not do on a Mac computer. Best practices for hardening a Mac system against malware include backing up the data using Time Machine, encrypting the drive, installing patches and updates as soon as they are available, disabling remote access, turning on the software firewall, using a password manager, using a non-admin account whenever possible, and setting a password-protected screen saver.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      78,
      21,
      79,
      93,
      86
    ],
    "source": "9781394330348"
  },
  {
    "id": 699,
    "question": "Which of the following file types is a drive image that can be mounted in macOS and treated like a drive?",
    "choice_a": "<code>.pkg</code>",
    "choice_b": "<code>.bat</code>",
    "choice_c": "<code>.dmg</code>",
    "choice_d": "<code>.app</code>",
    "correct_answer": "C",
    "explanation": "A file with a <code>.dmg</code> extension is a disk image and treated like a drive in the macOS. It can be \u201cmounted\u201d like a physical hard drive, the contents read, and files opened or applications installed. A file with a <code>.pkg</code> extensions on a Mac is a compressed package file. You might be able to view the file\u2019s contents in Finder. But if not, it would need to be extracted first. Files with a <code>.bat</code> extension are batch files used in Windows to run a string of commands that have been entered into a text file, and files with an <code>.app</code> extension are applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      11,
      76,
      88,
      97
    ],
    "source": "9781394330348"
  },
  {
    "id": 700,
    "question": "Your company\u2019s graphics department just purchased a new printer, and now you need to install it. What System Preference pane can you use to install new printers in macOS?",
    "choice_a": "Printers",
    "choice_b": "Printers & Scanners",
    "choice_c": "Devices",
    "choice_d": "Sharing",
    "correct_answer": "B",
    "explanation": "The Printers & Scanners pane is where you would go to install a new printer or configure a printer in the macOS System Preferences folder. Printers and Devices are not options there; however, sharing is, and from there you can share your screen or files and choose from several other options.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      80,
      81,
      34,
      87,
      74
    ],
    "source": "9781394330348"
  },
  {
    "id": 701,
    "question": "You\u2019re setting up a new PC with Windows 11 and using a GPT partition scheme for the boot partition. Which of the following are true? (Choose two.)",
    "choice_a": "Your system must have UEFI.",
    "choice_b": "You can only have four partitions.",
    "choice_c": "Your partition size is realistically unlimited.",
    "choice_d": "You won\u2019t be able to boot from this drive.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A Globally Unique Identifier (GUI) Partition Table (GPT) partition scheme is required with Windows 11. To create a GPT partition, your system must be using the Unified Extensible Firmware Interface (UEFI) instead of a Basic Input/Output System (BIOS) interface. The theoretical maximum partition size for a GPT partition is around 18 Exabytes, and because an 18-Exabyte drive isn\u2019t available commercially yet, your partition size is virtually unlimited. You can create it as large as your storage media is. Any partition table, whether GPT or the older Master Boot Record (MBR), keeps track of the partitions on your storage drive. GPT can address 128 partitions. MBR can only address four partitions. GPT also is more secure than MBR because it has a backup of the partition table and uses a cyclic redundancy check (CRC) to ensure that the partition table is accurate. GPT partitions can be located in the same computer with drives that have an MBR to maintain backward compatibility.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      45,
      46,
      19,
      54
    ],
    "source": "9781394330348"
  },
  {
    "id": 702,
    "question": "Your friend just bought a new iPad. What type of operating system will it have?",
    "choice_a": "iPhone OS",
    "choice_b": "iOS",
    "choice_c": "iPadOS",
    "choice_d": "Android",
    "correct_answer": "C",
    "explanation": "Unlike iOS for iPhones, the iPadOS has features such as Split View that allow it to use multiple applications at the same time. It also boasts support for external drives and displays. iOS is the operating system (OS) of iPhones, and the Android OS developed by Google is used on smartphones, tablets, and other touchscreen devices. iPhone OS is not a real thing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      4,
      1,
      2,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 703,
    "question": "You would like to see the contents of a file named <code>bogus.txt</code>. What command do you use to view the file\u2019s contents?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>chmod</code>",
    "choice_c": "<code>cat</code>",
    "choice_d": "<code>cp</code>",
    "correct_answer": "C",
    "explanation": "The <code>cat</code> command is powerful and can be used to view file contents, create new files, and concatenate (i.e., put together) files. For example, to view the line-by-line contents of the <code>bogus.txt</code> file, you would simply enter <code>cat bogus.txt</code>. To add line numbers to the output, the command would be <code>cat -n bogus.txt</code>. The <code>chown</code> command (i.e., change owner command) is used to change ownership of files in Linux. The <code>chmod</code> command (i.e., change mode command) is used to modify the file\u2019s mode, meaning who has what access to the file. The <code>cp</code> command is used to copy files.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      98,
      104,
      99,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 704,
    "question": "You\u2019ve noticed that a USB device consistently won\u2019t work after a time of inactivity. When you move it to another USB port, it works, but after a time that port stops working too. What can you do to resolve this problem? (Choose two.)",
    "choice_a": "Enable USB selective suspend.",
    "choice_b": "Disable USB selective suspend.",
    "choice_c": "Replace the device.",
    "choice_d": "Replace the motherboard.",
    "correct_answer": "B",
    "explanation": "The Windows 11 feature USB selective suspend will suspend a Universal Serial Bus (USB) port when it isn\u2019t being used, placing it into a low-power state. The port should resume normal power when the attached device is used again, such as when a mouse is moved. Some devices don\u2019t work well with the USB selective suspend feature, and to remedy the situation, you\u2019ll need to disable it. The Power Options utility in the Control Panel has a setting to enable/disable USB selective suspend. To get there, choose Power Options, Change plan settings, and Change advanced power settings. Then click on USB settings in the Settings list and choose USB Selective Suspend; click to Disable the option. The other options are more drastic and might not fix the problem.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      30,
      49,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 705,
    "question": "Your company just purchased five new MacBook computers for employee use. You will be providing tech support for them. What filesystem will they have?",
    "choice_a": "ReFS",
    "choice_b": "APFS",
    "choice_c": "ext4",
    "choice_d": "NTFS",
    "correct_answer": "B",
    "explanation": "The Apple File System (APFS) has been the filesystem used by macOS-based computers since 2017. It supports up to 9 quintillion files and folders, full disk encryption, and space sharing, so that a drive\u2019s free space is available to all volumes of that drive. Resilient File System (ReFS) is a feature available on Windows Pro for Workstations and Windows Enterprise editions. ReFS will detect when data on a mirrored drive has been corrupted and will use a healthy data copy on other drives to attempt to correct corrupted data and protect data. The ext4 filesystem is used in the Linux world, and New Technology File System (NTFS) is the Windows filesystem that supports file encryption and NTFS permissions for file sharing.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      39,
      37,
      40,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 706,
    "question": "Your friend decided to buy a used Microsoft Duo 2 folding phone. What operating system will likely be on their new phone?",
    "choice_a": "iPadOS",
    "choice_b": "iOS",
    "choice_c": "Android",
    "choice_d": "Windows",
    "correct_answer": "C",
    "explanation": "Although the Duo products are made by Microsoft, they run an Android operating system (OS), not Windows. While Microsoft briefly developed an OS for smartphones, their last venture into that market was in 2017 and met its end-of-life (EOL) in 2020. There is currently no Windows version for smartphones. iPadOS and iOS are Apple\u2019s proprietary OSs.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      4,
      6,
      2,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 707,
    "question": "On a Mac using macOS 10.6 or later, what is the best way to protect the system against viruses and other malware, given the following choices? (Choose two.)",
    "choice_a": "Install an antivirus from a vendor you trust.",
    "choice_b": "Ensure that the system\u2019s data files and security updates are set to run automatically.",
    "choice_c": "Only install software from the App Store or reliable sources.",
    "choice_d": "Use Finder to find and delete viruses and malware.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Since Snow Leopard (macOS 10.6), Apple has included malware detection, called File Quarantine, in its software. File Quarantine will not allow a known malware file to be opened. To protect your system from the most recent malware, you need to ensure that updates will run automatically. This is done by going to the Apple menu, choosing System Preferences, then App Store, and checking Automatically check for updates and the box to Install system data files and security updates. It\u2019s also good advice to only download programs and files from reputable sources, like the App Store. You could install an antivirus or anti-malware product, but it probably isn\u2019t necessary. Finder is used to find folders and files in the directory structure, much like Windows File Explorer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      93,
      74,
      96,
      85
    ],
    "source": "9781394330348"
  },
  {
    "id": 708,
    "question": "A user calls your hotline saying that they can\u2019t get directions and Siri can\u2019t give them the weather. What System Preferences pane do they need to use to remedy the situation?",
    "choice_a": "Privacy",
    "choice_b": "Mission Control",
    "choice_c": "Accessibility",
    "choice_d": "Networks",
    "correct_answer": "A",
    "explanation": "In the macOS System Preferences, the Security & Privacy pane, Privacy tab is where you would enable location services, which is how Siri knows where you are to tell you about the weather, provide maps, and give you directions. The window for each type of privacy concern will show what applications have requested Location Services. Also on the Privacy tab are Contacts, Calendars, Reminders, Photos, Accessibility, and Analytics. Mission Control will show all the open apps for quick access. Accessibility allows you to configure settings for differently-abled people, and the Networks pane will show all of the computer\u2019s network settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      84,
      32,
      7,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 709,
    "question": "A salesperson will be working remotely, and you need to set up a virtual private network (VPN) for them. What Control Panel utility will you use to do this?",
    "choice_a": "Devices and Printers",
    "choice_b": "Programs and Features",
    "choice_c": "Network and Sharing Center",
    "choice_d": "User Accounts",
    "correct_answer": "C",
    "explanation": "The Network and Sharing Center is the Windows Control Panel tool for viewing and configuring network connections and changing adapter settings. From here, you can also manually set up a new connection or network such as dial-up, virtual private network (VPN) connections, or even a wireless access point (WAP). From Devices and Printers, you can manage multiple printers and perform tasks, such as choosing a default printer, installing new printers, and changing printer settings. Programs and Features allows the user to add, remove, or troubleshoot installed programs (the options will change by program), and add/remove Windows features. User Accounts is the utility for adding new user accounts, changing their passwords, or managing profiles as well as other user-related configurations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      32,
      67,
      33,
      58
    ],
    "source": "9781394330348"
  },
  {
    "id": 710,
    "question": "A user brought you their laptop that wouldn\u2019t boot into the OS. After trying some troubleshooting techniques, you inform them that you will need to reinstall their operating system. After ensuring that they have a backup of their files, you restart the computer and press F10, and the OS installation begins. What type of installation are you doing?",
    "choice_a": "Upgrade",
    "choice_b": "Recovery partition",
    "choice_c": "Repair installation",
    "choice_d": "Image deployment",
    "correct_answer": "B",
    "explanation": "This is a recovery partition installation. A recovery partition is often created on a laptop that is purchased from a major supplier. There will be a key (or multiple keys) to press while the computer is booting. The exact key(s) depends on the laptop manufacturer. Using a recovery partition will erase everything that is on the drive and restore the computer to the state it was in when it was received from the manufacturer. This is sometimes called a factory reset. An upgrade installation will keep all of your files and settings but install a different version of an operating system (OS) on your computer. A repair installation will use the same OS and attempt to leave all of your files and settings while fixing any of the OS files. Image deployments are usually done in a large volume setting where you have many computers configured identically. One computer will have the OS and applications installed and settings configured. Then an image of that computer is created. This image can be stored on a network drive, a Universal Serial Bus (USB) drive, or other media. When it is installed, it will include the OS, software, and settings that were configured on the original computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      45,
      46,
      52,
      54
    ],
    "source": "9781394330348"
  },
  {
    "id": 711,
    "question": "A second person is going to be using the Windows computer at your desk when you\u2019re not there. What would you choose in Windows Settings to create their user account?",
    "choice_a": "Accounts",
    "choice_b": "User Accounts",
    "choice_c": "Personalization",
    "choice_d": "System",
    "correct_answer": "A",
    "explanation": "Accounts is the group in Windows Settings that will enable you to add a new user. From there, click on Family & other users, then, in Windows 10, click Add someone else to this PC. In Windows 11, click Add other user. User Accounts is the Control Panel utility for managing users. From the Personalization menu of Windows Settings, you can change the desktop theme and background colors. The System group in Windows Settings has a multitude of settings including Display, Sound, Notifications & Actions, and Power, to name a few.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      34,
      32,
      48,
      22,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 712,
    "question": "You\u2019re working in the Linux Terminal and need to locate a file. Which command lets you locate and perform actions on a file?",
    "choice_a": "<code>find</code>",
    "choice_b": "<code>ps</code>",
    "choice_c": "<code>man</code>",
    "choice_d": "<code>nano</code>",
    "correct_answer": "A",
    "explanation": "The <code>find</code> command is used to find files and directories and perform operations on them. The syntax of the command is <code><i>find</i> [<i>where to look</i>] [<i>-options</i>][<i>what to find</i>]</code>. For example, <code>find Documents -name *.jpg</code> will find all the files in <code>Documents</code> and its subfolders that have <code>.txt</code> at the end. Find can also search by folder, name, creation date, modification date, owner, and permissions. The <code>ps</code> command will list the processes that are currently running along with their Process IDs (PIDs), and the <code>man</code> command displays a user manual for any Linux command, much like the Microsoft Windows <code>/?</code> command. Nano is a Linux text editor.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      105,
      98,
      103,
      104,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 713,
    "question": "A user wants to install an application that requires a 2 GHz processor on a Windows 11 installation. What is the minimum speed processor that their computer must have?",
    "choice_a": "1 GHz",
    "choice_b": "2 GHz",
    "choice_c": "3 GHz",
    "choice_d": "4 GHz",
    "correct_answer": "B",
    "explanation": "Windows 11 requires at least a dual core, 1 GHz or faster processor. However, the application requires a 2 GHz processor, so to use the software, you must install a 2 GHz processor. (In reality, you\u2019ll probably already have a faster one.) Unlike Random Access Memory (RAM), where you must add the requirements together, choose a processor that is at least the fastest requirement of all the running software. In this case, the 2 GHz processor is needed for the application. You would not need to buy a 3 GHz processor to accommodate the new software.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      8,
      44,
      14,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 714,
    "question": "Which of the filesystems listed is compatible with more operating systems than the others?",
    "choice_a": "FAT32",
    "choice_b": "exFAT",
    "choice_c": "NTFS",
    "choice_d": "ext4",
    "correct_answer": "A",
    "explanation": "File Allocation Table 32 (FAT32) is more compatible than the other operating systems (OSs). It can be read by Windows, Linux, macOS, and many game consoles. Extensible File Allocation Table (exFAT) partitions require third-party software to be read by Linux, and New Technology File System (NTFS) doesn\u2019t play well with any OS other than Microsoft Windows. Fourth extended filesystem (ext4) partitions are used in Linux. Microsoft systems can\u2019t even recognize ext4 partitions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      37,
      36,
      5,
      73
    ],
    "source": "9781394330348"
  },
  {
    "id": 715,
    "question": "Which of the following operating systems can be found on a smartphone? (Choose two.)",
    "choice_a": "iOS",
    "choice_b": "macOS",
    "choice_c": "Android",
    "choice_d": "Windows 11",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Once upon a time, Microsoft had a Windows version for smartphones, but they no longer do. On modern smartphones, you\u2019ll most likely find either iOS or Android, although there is also Tizen, which is a Linux, open-source mobile operating system developed by Samsung. macOS and Windows 11 are for laptop and desktop computers. BlackBerry once had a smartphone operating system (OS) but now relies on Android and is known for and focused on their security software for smartphones. Bada and Symbian are other discontinued smartphone OSs. Tip: Remember to focus on the mobile OSs that are listed on the CompTIA A+ objectives. Those are iPadOS, iOS, and Android.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      4,
      1,
      2,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 716,
    "question": "Before you upgrade your Windows 10 OS to Windows 11, you want to create a backup of your Windows 10 system configuration so you can restore it if something goes wrong. What should you create?",
    "choice_a": "Restore point",
    "choice_b": "System restore",
    "choice_c": "Windows backup",
    "choice_d": "Shadow copy",
    "correct_answer": "A",
    "explanation": "A restore point is a copy of your system configuration at a given point in time. Restore points are useful for when Windows fails to boot but the computer appears to be fine otherwise, or when Windows doesn\u2019t seem to be acting right, and you think it was because of a recent configuration change. In Windows 10, restore points are created in the System Protection tab of System Properties.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      51,
      50,
      19,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 717,
    "question": "A friend has a game that they love to play on their macOS desktop computer, and they want to place it on the Windows laptop with which they travel. What will you tell them?",
    "choice_a": "Sure, it\u2019s no problem to install it.",
    "choice_b": "They can only install it if both are 64-bit systems.",
    "choice_c": "They can install macOS software on a Windows machine, but not Windows software on a Mac.",
    "choice_d": "They will need to find a Windows-compatible version of the software to install it on their Windows laptop.",
    "correct_answer": "D",
    "explanation": "Software intended for macOS and Windows are not interchangeable; however, some software packages come in a macOS version and a Windows version, so it\u2019s important to ensure you purchase the correct one. Windows can be run on a Mac, but not at the same time. You would need to run a program called Boot Camp to create a Windows partition on the Mac\u2019s hard drive, then install the Windows operating system (OS) on that partition. At boot, you can choose either Windows or macOS, but you can\u2019t run Windows applications on macOS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      5,
      1,
      75,
      45,
      54
    ],
    "source": "9781394330348"
  },
  {
    "id": 718,
    "question": "You\u2019re looking at the specifications for a new computer and notice that it says, \u201cGraphics type: Intel Arc, Integrated.\u201d What is true about this graphics card? (Choose two.)",
    "choice_a": "The GPU is on an expansion card.",
    "choice_b": "The GPU is located on the processor.",
    "choice_c": "It uses part of the system\u2019s RAM.",
    "choice_d": "It has its own VRAM.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "A video card can either be dedicated or integrated. If it is integrated, then the Graphics Processing Unit (GPU) resides on the processor, and the GPU will share Random Access Memory (RAM) with the system. A dedicated video card will contain a GPU and Video RAM (VRAM) and be installed in an expansion slot.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      9,
      8,
      1,
      2
    ],
    "source": "9781394330348"
  },
  {
    "id": 719,
    "question": "You want to uninstall an app on a Windows computer. Where will you go in Windows Settings to uninstall it?",
    "choice_a": "System",
    "choice_b": "Apps",
    "choice_c": "Update & Security",
    "choice_d": "Gaming",
    "correct_answer": "B",
    "explanation": "The Apps group of Windows Settings lets you delete or update apps, choose apps to start when you log in, choose default apps for opening files, and other application configuration settings. The System group has settings for display, power, sound and notifications, and several other options. Update & Security (Windows 10 only) has a plethora of tools, including Windows Update, troubleshooting, Activation, Recovery, and Windows Security. (The similar Settings group in Windows 11 is Windows Update, but it is only for updates and recovery options. Troubleshoot and Activation are found in the System group, and Windows Security settings are found in the Privacy & security group of Windows 11 Settings.) The Gaming option enables configuring the system to be optimized for gameplay and recording.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      49,
      23,
      18,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 720,
    "question": "You just built your first computer from components. What type of operating system install will you perform?",
    "choice_a": "Upgrade installation",
    "choice_b": "Recovery partition",
    "choice_c": "Clean installation",
    "choice_d": "Image deployment",
    "correct_answer": "C",
    "explanation": "You will be performing a clean installation. Clean installations happen on a new machine that doesn\u2019t have an operating system (OS) at all (i.e., bare metal), but can also happen when you want to completely wipe out the drive and begin fresh. An upgrade installation can only happen when there is an existing OS. An upgrade will keep all of your files and settings but install a different OS version on your computer. A recovery partition is often found on laptops, and sometimes on desktop PCs, that are purchased from a major supplier. There will be a key (or multiple keys) to press while the computer is booting. The exact key(s) will depend on the laptop manufacturer. Using a recovery partition will erase everything that is on the drive and restore the computer to the state it was in when it was received from the manufacturer. This is sometimes called a factory reset. Image deployments are usually done in a large volume setting, where you have many computers configured identically. One computer will have the OS and applications installed and settings configured. Then an image of that computer is created. That image can be stored on a network drive, a Universal Serial Bus (USB) drive, or other media. When it is installed, it will include the OS, software, and settings that were configured on the original computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      45,
      52,
      51,
      13
    ],
    "source": "9781394330348"
  },
  {
    "id": 721,
    "question": "You need to be able to boot into two different operating systems on the same hardware, and it doesn\u2019t support using a VM. What other option can you use?",
    "choice_a": "Clean installation",
    "choice_b": "In-place upgrade",
    "choice_c": "Network installation",
    "choice_d": "Multiboot",
    "correct_answer": "D",
    "explanation": "A multiboot is having two operating systems (OSs) on a computer and choosing which one you want to use as the computer is booting, before any OS files are loaded. This is cumbersome at best but necessary if you only have one set of hardware and it doesn\u2019t support using a virtual machine (VM). The other three options are methods of installing an OS, not a method of booting into one.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      54,
      51,
      30,
      44,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 722,
    "question": "You\u2019re buying a new graphics-intensive program that says it must have a GPU with 256 MB of dedicated VRAM. Your existing graphics adapter\u2019s properties are shown in the graphic. What is your best option?<img src=\"/question_assets/220-1202/c06f013.png\" alt=\"Screenshot of the Intel H D Graphics 520 Properties window depicts adapter information and memory details.\"/>\n\n<figcaption>Screenshot of the Intel H D Graphics 520 Properties window depicts adapter information and memory details.</figcaption>",
    "choice_a": "Purchase a new graphics card that meets the requirements.",
    "choice_b": "Replace the CPU with one that has an integrated GPU.",
    "choice_c": "Add VRAM to your graphics card.",
    "choice_d": "Add RAM to your system.",
    "correct_answer": "A",
    "explanation": "Video Random Access Memory (VRAM) is memory dedicated solely to be used by the Graphics Processing Unit (GPU). The GPU takes the work of processing graphics away from the Central Processing Unit (CPU). GPUs can either be integrated (on the CPU) or dedicated (on a discrete graphics card). A graphics card will have its own cooler and VRAM. VRAM on a video card can\u2019t usually be upgraded. To increase it, you would need to buy a different video card. In this scenario, you might be able to replace the CPU for one with integrated graphics, if the system supported the new processor, but it isn\u2019t the best option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      9,
      14,
      1,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 723,
    "question": "You\u2019re working in the Linux Terminal and aren\u2019t sure how to use the <code>ps</code> command. Which of the following will show you detailed information about the command?",
    "choice_a": "<code>find ps</code>",
    "choice_b": "<code>ps man</code>",
    "choice_c": "<code>man ps</code>",
    "choice_d": "<code>nano ps</code>",
    "correct_answer": "C",
    "explanation": "Linux has a built-in manual that can be accessed using the <code>man</code> command, similar to using Windows <code>help [<i>command</i>]</code> or <code>[<i>command</i>] /?</code> at a command prompt. The syntax is <code>man [<i>command</i>]</code>. The <code>find</code> command is used to find files and directories and perform operations on them. The <code>ps</code> command will list the processes currently running, along with their Process IDs (PIDs), and Nano is a Linux text editor. The <code>[<i>command</i>] --help</code> command can also be used at a Linux terminal prompt to get help on a specific command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      98,
      103,
      62,
      104,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 724,
    "question": "You\u2019re moving your Windows 10 computer to Windows 11. What type of installation are you doing?",
    "choice_a": "Upgrade installation",
    "choice_b": "Recovery partition",
    "choice_c": "Clean installation",
    "choice_d": "Image deployment",
    "correct_answer": "A",
    "explanation": "You will be performing an upgrade installation. An upgrade installation can only happen when there is an existing operating system (OS). It will keep all your files and settings but install a different OS version on your computer. A recovery partition is often found on a laptop purchased from a major supplier. There will be a key (or multiple keys) to press while the computer is booting. The exact key(s) depends on the laptop manufacturer. Using a recovery partition will erase everything that is on the drive and restore the computer to the state it was in when it was received from the manufacturer. This is sometimes called a factory reset. A clean installation happens on a new machine that doesn\u2019t have an OS at all (i.e., bare metal), but can also happen when you want to completely wipe out the drive and begin fresh. Image deployments are usually done in a large volume setting, where you have many computers configured identically. One computer will have the OS and applications installed and settings configured. Then an image of that computer is created. The image can be stored on a network drive, a Universal Serial Bus (USB) drive, or other media. When it is installed, it will include the OS, software, and settings that were configured on the original computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      50,
      45,
      46,
      52,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 725,
    "question": "You\u2019re considering upgrading your Windows 10 PC to Windows 11. Which of the following does not need to be done before upgrading?",
    "choice_a": "Backups of user files and preferences",
    "choice_b": "Operating system refresh",
    "choice_c": "Check application and driver compatibility",
    "choice_d": "Check hardware compatibility",
    "correct_answer": "B",
    "explanation": "You won\u2019t need to refresh the operating system (OS). Refreshing an OS reinstalls the same version over the existing one to correct issues with OS files. You don\u2019t need to do that when you are upgrading a system to a new OS. Whenever you\u2019re doing an upgrade, it is important to consider several things. Backups must be made in case something goes wrong. Before you start the upgrade, you\u2019ll want to ensure that the applications you run are compatible with the new OS and compatible drivers are available for your hardware. You\u2019ll also want to ensure that the hardware you have will work with the new OS.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      50,
      44,
      8,
      1,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 726,
    "question": "You\u2019re purchasing software that says it uses 32-bit processing. Your computer has a 64-bit processor. Can you use this software on your computer?",
    "choice_a": "Yes, a 32-bit software program can run on a 64-bit processor.",
    "choice_b": "No, a 32-bit software program must have a 32-bit processor.",
    "choice_c": "Yes, if you replace the processor with a 32-bit one.",
    "choice_d": "Yes, it will just need more RAM.",
    "correct_answer": "A",
    "explanation": "You can run a 32-bit software program on a 64-bit processor; it just doesn\u2019t take advantage of the 64-bit processor\u2019s full capabilities. However, you cannot run a 64-bit software program on a 32-bit processor. More RAM has nothing to do with the question at hand. It\u2019s a processor issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      9,
      8,
      1,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 727,
    "question": "Which of the following commands, when entered into a Linux Terminal, will open a text editor?",
    "choice_a": "<code>find</code>",
    "choice_b": "<code>ps</code>",
    "choice_c": "<code>man</code>",
    "choice_d": "<code>nano</code>",
    "correct_answer": "D",
    "explanation": "Nano is a user-friendly text editor available in many Linux distributions. Other text editors, such as vim and emacs, may also be available, but nano is easier to use. The <code>find</code> command is used to find files and directories and perform operations on them. Find can also search by folder, name, creation date, modification date, owner, and permissions. The <code>ps</code> command will list the processes that are currently running along with their Process IDs (PIDs), and the <code>man</code> command displays a user manual for any Linux command, much like the Microsoft Windows <code>[command-name] /?</code> command, where <code>[command-name]</code> is replaced with the name of the command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      98,
      106,
      104,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 728,
    "question": "You would like to know the IP address of a website. What Linux tool will you use?",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>dig</code>",
    "choice_c": "<code>top</code>",
    "choice_d": "<code>ip</code>",
    "correct_answer": "B",
    "explanation": "The <code>dig</code> command can be used to retrieve the IP address of a website, for example, <code>dig Sybex.com +short</code> will return the IP address of Sybex.com. The <code>chown</code> command (i.e., change owner command) is used to change ownership of files in Linux. The <code>top</code> command displays dynamic information about the running processes, and the <code>ip</code> command is used in Linux or macOS to display configuration information for network interfaces.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      98,
      103,
      107,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 729,
    "question": "Which of the following is not true regarding managed Apple IDs?",
    "choice_a": "They are created by a company for its employees.",
    "choice_b": "They can\u2019t make purchases.",
    "choice_c": "An IT administrator can remove or update your account.",
    "choice_d": "You can reset your own password.",
    "correct_answer": "D",
    "explanation": "With managed Apple IDs, your company, not you, can reset your password. Your company owns a managed Apple ID, so there are restrictions set in place. A managed ID is created by a company for use in company business. Because it\u2019s linked to your company, your managed Apple ID can\u2019t be used to make purchases, and your company\u2019s IT administrator can restrict access to your account, remove it, or update it.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      74,
      17,
      64,
      20,
      83
    ],
    "source": "9781394330348"
  },
  {
    "id": 730,
    "question": "Which of the following are methods of booting an OS? (Choose two.)",
    "choice_a": "Solid-state/flash drives",
    "choice_b": "Internal drives",
    "choice_c": "In-place upgrade",
    "choice_d": "Formatting",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Booting an operating system (OS) can happen in many ways, including solid-state and flash drives, internal drives, external or hot-swappable drives, Internet-based, and multiboot. In-place is a type of upgrade, not a type of boot, and formatting prepares a drive to be booted.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      46,
      52,
      30,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 731,
    "question": "Which of the following filesystems is optimized for flash drives?",
    "choice_a": "FAT32",
    "choice_b": "NTFS",
    "choice_c": "ext4",
    "choice_d": "exFAT",
    "correct_answer": "D",
    "explanation": "Extensible File Allocation Table (exFAT) is optimized for flash drives because it has low overhead like the File Allocation Table 32-bit (FAT32) filesystem (as opposed to New Technology File System [NTFS]). However, like NTFS, it will support much larger file sizes than FAT32, which is limited to 4 GB. exFAT is less compatible with non-Microsoft operating systems (OSs) than FAT32 is, but more compatible than NTFS. For example, macOS can only read NTFS partitions, yet it can read and write to exFAT partitions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      37,
      36,
      38,
      97
    ],
    "source": "9781394330348"
  },
  {
    "id": 732,
    "question": "You are working on a Linux workstation. A file named <code>docs</code> needs to be renamed to <code>newdocs</code>. What is the right command to execute this?",
    "choice_a": "<code>ren docs newdocs</code>",
    "choice_b": "<code>mv docs newdocs</code>",
    "choice_c": "<code>cp docs newdocs</code>",
    "choice_d": "<code>rm docs newdocs</code>",
    "correct_answer": "B",
    "explanation": "In Linux, the <code>mv</code> (move) command is used to rename files. As shown in the answer, the syntax is <code>mv [<i>old-file-name</i>] [<i>new-file-name</i>]</code>. The <code>cp</code> command copies a file, but that is a different process than moving it. The <code>rm</code> command is short for remove, and it deletes files. The <code>ren</code> command is a Windows command to rename files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      98,
      104,
      99,
      107
    ],
    "source": "9781394330348"
  },
  {
    "id": 733,
    "question": "Which method of booting a computer requires having a PXE and a bootable image on the Internet?",
    "choice_a": "Solid-state/flash drives",
    "choice_b": "Internal drives",
    "choice_c": "Internet-based",
    "choice_d": "Network-based",
    "correct_answer": "C",
    "explanation": "To enable Internet-based computer booting, you need a network interface card (NIC) and Unified Extensible Firmware Interface (UEFI) or Basic Input/Output System (BIOS) that support loading a pre-execution environment (PXE). The PXE instructions exist on the NIC and must be preconfigured to request an IP address from a Dynamic Host Configuration Protocol (DHCP) server. It then requests information from a server holding the bootable image. It is possible to boot from the Internet, most likely using a Linux distribution. A network-based boot also requires PXE, but it gets its operating system (OS) from the local network, not the Internet. Be aware that some people use Internet-based and network-based interchangeably; they are not the same. Solid-state/flash drives or internal drives (e.g., SATA, M.2) hold the OS from which you boot. They don\u2019t need PXE.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      54,
      52,
      71,
      30,
      10
    ],
    "source": "9781394330348"
  },
  {
    "id": 734,
    "question": "You have the Control Panel open and want to quickly check how much RAM is installed in the system and what processor it has. Which Control Panel utility will you use to view this information?",
    "choice_a": "System utility",
    "choice_b": "Device Manager",
    "choice_c": "Devices and Printers",
    "choice_d": "Programs and Features",
    "correct_answer": "A",
    "explanation": "The System utility of the Control Panel provides a link to the System, About option in Windows Settings. The screen that pops up by default shows information about the PC, such as its name, its specific processor, how much physical Random Access Memory (RAM) is installed, the Windows version and edition, and so on. The Device Manager utility is used for troubleshooting hardware and installing device drivers. Devices and Printers is used for managing printers, multifunction devices, and other devices that are connected to the computer. Programs and Features helps in uninstalling, changing, and repairing applications and adding or removing Windows features.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      29,
      43,
      8
    ],
    "source": "9781394330348"
  },
  {
    "id": 735,
    "question": "You downloaded a new application that you want to install on your Windows PC and noticed that it has only one file, and that file has an <code>.iso</code> extension. Which of the following is true regarding this file?",
    "choice_a": "Double-click it and let it run to install the application.",
    "choice_b": "Right-click the file and choose Mount. Windows will then see and treat the file as a disk in an optical drive.",
    "choice_c": "You will need a third-party utility to open this file.",
    "choice_d": "Right-click and choose Extract to install the software.",
    "correct_answer": "B",
    "explanation": "Files with an <code>.iso</code> extension are disk image files. To install the software they contain, you need to first mount the image. You might be able to double-click it, if not, right-click and choose Mount, or locate the file in File Explorer. Select the file, then click Mount under Disk Image Tools. Once the file is mounted, the operating system (OS) will treat it as a disk in an optical drive. You\u2019ll look for an installer or autorun file to start the software installation. When you\u2019re done using the image, right-click it and choose Eject. Extract is a command for zipped files, not <code>.iso</code> files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      75,
      25,
      13,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 736,
    "question": "You\u2019re considering installing new software for monitoring network traffic. You know that it will generate additional network traffic of its own. Which of the following should be considered before purchasing the software? (Choose three.)",
    "choice_a": "Impact on the network",
    "choice_b": "Impact on operations",
    "choice_c": "Impact on the software company",
    "choice_d": "Impact on the business",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Whenever you\u2019re considering a new software purchase, there are many things to consider. The technical aspects such as operating system (OS) and application compatibility and hardware concerns are only a part of it. You must also consider what impact this will have on any devices, the network, how internal systems work, and the operation of the business, in addition to the business as a whole\u2014how will it affect the company\u2019s bottom line. In the case of the network-monitoring software presented in the question, consider whether the additional network overhead will cause a significant enough impact on the network to cause adverse effects on production, whether it will decrease company profits by slowing production, or whether is it a wise investment because it can help protect against malware. Will it work well with routers, switches, and other network hardware? Do the positive impacts outweigh the negative ones?",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      9,
      31,
      55,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 737,
    "question": "An application that you\u2019re installing requires 20 GB of space plus storage for data files of 400 GB. What is the absolute minimum size your hard drive must be if you\u2019re running Windows 10 64-bit, which requires 20 GB of storage?",
    "choice_a": "20 GB",
    "choice_b": "400 GB",
    "choice_c": "420 GB",
    "choice_d": "440 GB",
    "correct_answer": "D",
    "explanation": "With today\u2019s hard drives measured in terabytes (TBs), storage is seldom a problem, but in an industrial setting, it might be. When determining how big a hard drive needs to be, add the storage requirements of everything that will be on that drive, including the operating system (OS), the applications that will be installed, and all the data that will be generated by those applications. With Random Access Memory (RAM), you need to consider what will be running at the same time. But with storage, you must consider all the applications and all the data, whether or not they are all working at the same time. It\u2019s also important to consider what type of data files will be stored. Word documents take up much less space than video files do.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      9,
      8,
      14,
      36,
      42
    ],
    "source": "9781394330348"
  },
  {
    "id": 738,
    "question": "You\u2019re working at a Linux command prompt (i.e., you\u2019re in the Linux Terminal) and need to delete a file called <code>oldstuff.txt</code>. Which of the following commands will work?",
    "choice_a": "<code>rm oldstuff.txt</code>",
    "choice_b": "<code>del oldstuff.txt</code>",
    "choice_c": "<code>er oldstuff.txt</code>",
    "choice_d": "<code>rd oldstuff.txt</code>",
    "correct_answer": "A",
    "explanation": "In Linux, <code>rm</code> (remove) is the command for deleting files and directories. As shown, the syntax is simply <code>rm [<i>option</i>] [<i>what-to-remove</i>]</code>. If you\u2019re removing more than one file at a time, simply list the files after the remove command, such as <code>rm <i>file1.ext file2.ext</i></code>. With its options, the <code>rm</code> command can also remove directories and work in verbose mode, meaning that it will tell you what it\u2019s doing. The <code>del</code> command is used to delete one or more files at a Windows Command Prompt. <code>er</code> is not a known command in either Linux or Windows, and <code>rd</code> is a Windows command to remove directories.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      105,
      98,
      56,
      63,
      104
    ],
    "source": "9781394330348"
  },
  {
    "id": 739,
    "question": "Which of the following is a file that can be extracted, or opened, with an installer app to install an application?",
    "choice_a": "<code>.pkg</code>",
    "choice_b": "<code>.bat</code>",
    "choice_c": "<code>.dmg</code>",
    "choice_d": "<code>.app</code>",
    "correct_answer": "A",
    "explanation": "A file with a <code>.pkg</code> extension in macOS is a compressed package file. You might be able to view the contents of the file in Finder, but if not, it would need to be extracted first. It can be installed by double-clicking it, or opening it with an installer. A file with a <code>.dmg</code> extension is a disk image and treated like a drive in the macOS. It does not need to be extracted. It can be \u201cmounted\u201d like a physical hard drive, the contents read, and files opened or applications installed. Files with an <code>.app</code> extension are applications, and files with a <code>.bat</code> extension are batch files used in Windows to run a string of commands that have been entered into a text file.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      85,
      50,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 740,
    "question": "Which of the following is not an advantage of a downloadable software distribution over using physical media to distribute software?",
    "choice_a": "It\u2019s always current.",
    "choice_b": "It costs the distributor less.",
    "choice_c": "It works on a system without a DVD drive.",
    "choice_d": "It works on all bare-metal systems.",
    "correct_answer": "D",
    "explanation": "A bare metal system is one that doesn\u2019t have any software yet including the operating system (OS). It would not be able to download software to install. It could be used for a network installation of an OS if it supported Pre-boot Execution Environment (PXE) booting to the network; however, that would be using a local area network (LAN) to distribute software as opposed to downloadable distribution, which by definition, uses the Internet. Distributing software via download means that it could be the most up-to-date version of the software. It costs less because no one must pay for the Universal Serial Bus (USB) or DVD to distribute it, and it only requires an Internet connection, not a DVD drive. Many new PCs don\u2019t have optical drives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      54,
      46,
      55,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 741,
    "question": "You\u2019re working on a Windows computer that is having some trouble booting. After trying System File Checker (SFC) and other troubleshooting techniques, you decide that you need to reinstall the operating system files. What type of installation will you be doing?",
    "choice_a": "Upgrade",
    "choice_b": "Repair",
    "choice_c": "Clean",
    "choice_d": "Remote",
    "correct_answer": "B",
    "explanation": "A repair installation (or repair upgrade, as Microsoft calls it) means that you\u2019re installing the same version of the same operating system (OS) over top of the existing OS. A repair installation can be done from within the existing OS or from other media. It will go through a licensing screen and some others, eventually showing a screen where you will choose to Keep Windows Settings, personal files, and apps. An upgrade installation will also keep your files, apps, and settings, but you will be using a newer version of the OS. A clean installation wipes out everything on the hard drive. A remote installation is done across a network and could be any of the other three types.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      45,
      46,
      50,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 742,
    "question": "You need to quickly view the network configuration on a Linux computer. What command do you use?",
    "choice_a": "<code>ipconfig</code>",
    "choice_b": "<code>ipconfig /all</code>",
    "choice_c": "<code>ip</code>",
    "choice_d": "<code>cfg</code>",
    "correct_answer": "C",
    "explanation": "The <code>ip</code> command is used to configure and view network settings in modern Linux and macOS distributions, replacing the former <code>ifconfig</code> command. Like most Linux commands, there is a multitude of objects and options that can be used. Likely the most frequently used one is <code>ip addr show</code>, which will show all of the network interfaces and their respective IP addresses. The <code>ipconfig</code> and <code>ipconfig /all</code> Windows commands are for viewing IP configuration. <code>cfg</code> isn\u2019t an actual command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      58,
      80,
      98,
      99
    ],
    "source": "9781394330348"
  },
  {
    "id": 743,
    "question": "You purchased a Windows laptop and notice that it immediately resumes when you open the lid. What allows it to do that?",
    "choice_a": "Hibernate",
    "choice_b": "Idle mode",
    "choice_c": "Standby",
    "choice_d": "Auto Off",
    "correct_answer": "C",
    "explanation": "Windows supports a feature called Modern Standby. Modern Standby must also be supported by the hardware. With Modern Standby, the system will wake from the lowest power to allow short bursts (i.e., milliseconds) of software execution as the system needs them. The system uses just enough power to process background tasks but still preserve battery life. The result is that when in Sleep mode, a computer can stay connected to a local area network (LAN) and reacts much like a smartphone with instant on/instant off ability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      30,
      1,
      7,
      27
    ],
    "source": "9781394330348"
  },
  {
    "id": 744,
    "question": "You\u2019re at a command prompt in Windows and need to quickly add a user named <code>student</code>. What command will you use?",
    "choice_a": "<code>net user student * /add</code>",
    "choice_b": "<code>net use /add student *</code>",
    "choice_c": "<code>net user student *</code>",
    "choice_d": "<code>user /add student</code>",
    "correct_answer": "A",
    "explanation": "The <code>net user</code> command can be used at a command prompt to add a user on-the-fly. The syntax is <code>net user <i>username</i> [<i>password</i> | *] /add [<i>options</i>] [</code><i>/</i><code><i>domain</i>]</code>. In this example, you are adding a user named <code>student</code>, and the * replacing <code><i>password</i></code> tells the system to prompt you for a password. If no domain is specified, the command assumes the user is added to the local computer. As soon as this command is executed, the named user will appear in the Users utility of the Control Panel.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      59,
      32,
      65,
      56,
      63
    ],
    "source": "9781394330348"
  },
  {
    "id": 745,
    "question": "What shortcut keys open the Quick Link menu, on which you can quickly access many of the technician tools used in Windows operating systems?",
    "choice_a": "Press Windows Logo Key+D key.",
    "choice_b": "Press Windows Logo Key+L key.",
    "choice_c": "Press Windows Logo Key+I key.",
    "choice_d": "Press Windows Logo Key+X key.",
    "correct_answer": "D",
    "explanation": "Pressing the Windows Logo Key plus the X key simultaneously will open the Quick Link menu. On it in Windows 11, you will find shortcuts to Installed Apps, Mobility Center, Power Options, Event Viewer, System, Device Manager, Network Connections, Disk Management, Computer Management, Terminal, and Terminal Admin, which opens the PowerShell utility, Task Manager, Settings, File Explorer, Search, and Run. You can also click Shut Down or Sign Out from the Quick Link menu, or click Desktop, which will display or hide all open applications on the desktop. Pressing the Windows Logo Key+D will also hide or display all open applications. Pressing the Windows Logo Key+L is a quick way to lock the computer, and Windows Logo Key+I brings you to Windows Settings.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      23,
      30,
      34,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 746,
    "question": "A friend just installed Windows on their bare-metal machine. They called you because everything works except their network. What do they most likely need to do?",
    "choice_a": "Reinstall the operating system.",
    "choice_b": "Install third-party drivers.",
    "choice_c": "Remove and reinstall the network card.",
    "choice_d": "Replace the faulty network card.",
    "correct_answer": "B",
    "explanation": "The Windows operating system (OS) contains many drivers that will help make setting up a new OS easy. However, it would be impossible for the installation media to have all the drivers for all the devices available. When you have a device whose driver, or a compatible one, doesn\u2019t automatically install, you\u2019ll have to install the driver from a third party, such as the motherboard manufacturer. Often, these drivers can be downloaded from an online source, such as the manufacturer\u2019s website.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1,
      47,
      55,
      94,
      29
    ],
    "source": "9781394330348"
  },
  {
    "id": 747,
    "question": "What Linux command is used to display the partial dynamic table shown in the graphic?<img src=\"/question_assets/220-1202/c06f014.png\" alt=\"Screenshot of a Linux terminal running the top command depicts system processes, C P U, and memory usage statistics.\"/>\n\n<figcaption>Screenshot of a Linux terminal running the top command depicts system processes, C P U, and memory usage statistics.</figcaption>",
    "choice_a": "<code>chown</code>",
    "choice_b": "<code>dig</code>",
    "choice_c": "<code>top</code>",
    "choice_d": "<code>ip</code>",
    "correct_answer": "C",
    "explanation": "The <code>top</code> command provides a dynamic chart of the running processes, with the details shown in the graphic. The top section of the screen shows resources used and process statistics. The bottom shows the processes currently running. The <code>dig</code> command can be used to retrieve the Internet Protocol (IP) address of a website. The <code>chown</code> command (i.e., change owner command) is used to change ownership of files in Linux, and the <code>ip</code> command is used to display configuration information for network interfaces.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      106,
      105,
      98,
      27
    ],
    "source": "9781394330348"
  },
  {
    "id": 748,
    "question": "A Mac user has accidentally deleted an app and wants to reinstall it. They believe that the file to install the software again is still on their computer. What file extensions will you be looking for? (Choose two.)",
    "choice_a": "<code>.pkg</code>",
    "choice_b": "<code>.bat</code>",
    "choice_c": "<code>.dmg</code>",
    "choice_d": "<code>.app</code>",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "A file with a <code>.pkg</code> extensions on a Mac is a compressed package file. You might be able to view the file\u2019s contents in Finder, but if not, it would need to be extracted first. It can be installed by double-clicking it or opening it with an installer. A file with a <code>.dmg</code> extension is a disk image and treated like a drive in the macOS. It can be \u201cmounted\u201d like a physical hard drive, the contents read, and files opened, or applications installed from it. Files with an <code>.app</code> extension are applications, and files with a <code>.bat</code> extension are batch files used in Windows to run a string of commands that have been entered into a text file.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      75,
      87,
      1,
      7,
      25
    ],
    "source": "9781394330348"
  },
  {
    "id": 749,
    "question": "What feature, known more for mobile devices than desktops, is available for the desktop macOS by using a trackpad or Magic Mouse?",
    "choice_a": "SDK",
    "choice_b": "Power options",
    "choice_c": "Gestures",
    "choice_d": "Emergency notifications",
    "correct_answer": "C",
    "explanation": "Modern touchpads/trackpads and touchscreens can accept multiple finger gestures that function similarly to gestures on a smartphone or tablet, such as swipe left or right to move between pages. To see what gestures are available, click the Apple menu, then System Preferences, and Trackpad. Software Development Kit (SDK) is more of a programming term. Emergency notifications and power options have little to do with a trackpad or Magic Mouse. Incidentally, gestures are also available in Windows. To view or modify multi-finger gestures on your Windows 10 PC from Windows Settings, choose Devices, and then Touchpad. In Windows 11, from Windows Settings, choose Bluetooth & Devices, and then Touchpad.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      73,
      5,
      22,
      34
    ],
    "source": "9781394330348"
  },
  {
    "id": 750,
    "question": "You have a workgroup with all Windows Home PCs. One of the computers is sharing a folder with two users who don\u2019t have an account on this PC. What Control Panel utility do you use to add the users and their passwords to this computer?",
    "choice_a": "Administrative Tools",
    "choice_b": "User Accounts",
    "choice_c": "Local Users and Groups",
    "choice_d": "Mail",
    "correct_answer": "B",
    "explanation": "You would use the User Accounts Control Panel utility to add new accounts for the users. If you were on a Windows Pro or better computer, you could use the Local Users and Groups app, but that is not available in Windows Home editions. It also isn\u2019t listed as a separate Control Panel utility, but in Windows 10 Pro and higher editions (not Windows 11), it can be accessed through Administrative Tools, then choose Computer Management, then Local Users and Groups. On Windows 11, you can access Computer Management through the Control Panel, Computer Management, but it\u2019s faster to right-click the Windows icon in the taskbar and choose Computer Management. Or click Windows+R and in the Run box, type <code>lusrmgr.msc</code> to go directly to Local Users and Groups. The Administrative Tools utility doesn\u2019t have a link to the Control Panel User Accounts utility, which is not as versatile as Local Users and Groups. The Mail utility is where you would configure user profiles for use with Microsoft Outlook.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      18,
      28,
      65,
      59
    ],
    "source": "9781394330348"
  },
  {
    "id": 751,
    "question": "Your company has employees working in a remote location. A new employee has been hired to work there. You send them a desktop computer that doesn\u2019t have an OS on it. When it arrives, the employee plugs it in and turns it on. It then uses PXE to install the company\u2019s desktop image from the corporate server. Finally, an administrator logs in remotely using RDP and configures the computer. What has just happened?",
    "choice_a": "Unattended installation",
    "choice_b": "Zero-touch installation",
    "choice_c": "Internet-based installation",
    "choice_d": "Remote network installation",
    "correct_answer": "D",
    "explanation": "The scenario in the question describes a remote network installation. This differs from an Internet-based installation because an Internet-based installation generally refers to only the operating system (OS) install, while a remote network installation includes remote configuration of the device. An unattended installation is completed with a file that provides answers to the questions asked during installation, while a zero-touch installation includes the OS and configuration of the computer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      52,
      54,
      20,
      12,
      47
    ],
    "source": "9781394330348"
  },
  {
    "id": 752,
    "question": "On your PC, it seems that searching through files has gotten slower and slower. What utility will organize data so searches run faster?",
    "choice_a": "Control Panel, choose the Indexing Options utility",
    "choice_b": "Windows Settings, choose the System group",
    "choice_c": "Windows Settings, choose the Apps group",
    "choice_d": "Control Panel, choose the Default Programs utility",
    "correct_answer": "A",
    "explanation": "The Control Panel\u2019s Indexing Options looks at words in files and metadata of files to provide faster file searches. The System group of Windows Settings enables you to configure notifications, power, and many other settings, but not Indexing. The Apps group of Systems is where you can choose default programs and remove applications that you no longer need. The Default Programs app of the Control Panel allows you to manage default applications for opening file types such as photos or mail by opening those settings in Windows Settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      34,
      43,
      97,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 753,
    "question": "You are on a Domain Controller and need to share a folder of data files for some users and not others. Where do you configure access to the folder? (Choose two.)",
    "choice_a": "On the Domain Controller",
    "choice_b": "In Windows Active Directory",
    "choice_c": "Configure sharing on individual workstations.",
    "choice_d": "Run a batch file to copy the files to each user computer that needs access.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When a computer logs in to a domain, access to resources is controlled through Active Directory (AD). The server that Active Directory resides on is called a Domain Controller (DC). In a workgroup, sharing would be configured on the computer providing access to the files. Running a batch file to copy the files to each user would result in multiple copies of the files, likely with all different information after a time, and not a single file repository where the files are shared among users.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      20,
      65,
      21,
      57
    ],
    "source": "9781394330348"
  },
  {
    "id": 754,
    "question": "Your company has employees working in a remote location, and a new employee has been hired to work there. The company\u2019s PC supplier sends a computer to the new hire and the computer\u2019s serial number and other information to you. The supplier has preconfigured the computer to install software and connect to your network when the computer is turned on. You then use MDM to finish the configuration automatically. What has just happened?",
    "choice_a": "Unattended installation",
    "choice_b": "Zero-touch installation",
    "choice_c": "Internet-based installation",
    "choice_d": "Remote network installation",
    "correct_answer": "B",
    "explanation": "The scenario in the question describes a zero-touch installation. This differs from an unattended installation, because it\u2019s more than simply an answer file for installing the operating system (OS). As the IT administrator, you literally never touch the computer. Mobile Device Management (MDM) software is used to apply policies, profiles, and other security and compliance settings using pre-established configuration profiles. Internet and remote network installations use the Pre-boot Execution Environment (PXE) to install an OS, which then needs to be configured.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      54,
      28,
      34,
      14,
      93
    ],
    "source": "9781394330348"
  },
  {
    "id": 755,
    "question": "You\u2019re installing Windows 11 Enterprise in a bare-metal system. What is the maximum amount of RAM you can put into this system?",
    "choice_a": "128 GB",
    "choice_b": "2 TB",
    "choice_c": "6 TB",
    "choice_d": "256 TB",
    "correct_answer": "C",
    "explanation": "Windows 11 maximum Random Access Memory (RAM) limits are 128 GB for the Home edition, 2 TB for the Pro edition, and 6 TB for the Pro for Workstations and Enterprise editions. They are the same limits for Windows 10 64-bit, but the maximum RAM for any 32-bit Windows operating system (OS) is only 4 GB.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      2,
      18,
      44,
      19
    ],
    "source": "9781394330348"
  },
  {
    "id": 756,
    "question": "You are creating a network for a small office with Windows Pro computers. They do not want centralized security, but they want it to be easy to share printers and files, including libraries. What type of network setup should you recommend?",
    "choice_a": "Workgroup",
    "choice_b": "Homegroup",
    "choice_c": "Personal Area Network",
    "choice_d": "Domain",
    "correct_answer": "A",
    "explanation": "You would want a workgroup. By default, Windows 10 computers will join a workgroup called <code>workgroup</code>, making it easy to share files, printers, and other resources. Windows 11 computers don\u2019t, by default, join a workgroup called workgroup, but you can set it up as a member of a workgroup during the operating system (OS) installation process. Access to resources is configured on each workstation that is sharing a resource. The drawbacks of a workgroup are that security is configured on each PC, and it\u2019s only appropriate for very small networks. Homegroup was a networking scheme in prior versions of Windows that shared libraries. A personal area network (PAN) consists of a PC and its wireless devices, usually paired Bluetooth devices such as printers, headphones, and input devices. A domain is a network where access to resources is configured on a central server that all resource users must log in to. Home versions of Windows can\u2019t join a domain, but Pro, Pro for Workstations, and Enterprise editions can.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      65,
      68,
      18,
      20
    ],
    "source": "9781394330348"
  },
  {
    "id": 757,
    "question": "Your accounting department uses an application requiring them to insert a fob into a USB port on the computer before they can use the application, to ensure that they have a valid license to use it. What are they using?",
    "choice_a": "A remote certificate",
    "choice_b": "An external software token",
    "choice_c": "An external hardware token",
    "choice_d": "A biometric device",
    "correct_answer": "C",
    "explanation": "When a Universal Serial Bus (USB) or other hardware device is required to ensure that the user has a valid license, the device is a hardware token. A remote certificate is a bit of software ensuring that the connection is valid and the certificate holder is who they say they are. Biometric devices use a reader and part of someone\u2019s body to identify them, such as a fingerprint, facial recognition, or retina scan.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      14,
      9,
      1,
      96,
      28
    ],
    "source": "9781394330348"
  },
  {
    "id": 758,
    "question": "Which of the following is not a best practice for updating/patching a Linux distribution?",
    "choice_a": "Keep installed software updates current.",
    "choice_b": "Verify that installed packages have a valid signature.",
    "choice_c": "Update packages quarterly.",
    "choice_d": "Download packages only from trusted sources.",
    "correct_answer": "C",
    "explanation": "Updating packages only quarterly would be disastrous for the security of your systems. It\u2019s important to plan for updates and follow that plan. If your system has many Linux installations, test package updates in a sandbox before installing them on all systems. Managing patches can be time consuming, which is why companies providing patch management services exist for both Linux and Windows installations. Checking for patches can be scripted using the <code>yum</code> command. Updates should only be downloaded from reliable sources, and if you\u2019re using Red Hat Linux, verify that the packages are signed by Red Hat.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      93,
      101,
      14,
      53,
      9
    ],
    "source": "9781394330348"
  },
  {
    "id": 759,
    "question": "Your company\u2019s sales department wants to install a new customer management system, but they first need your approval. Which of the following impacts do you and the company need to consider when deciding whether to install this software? (Choose three.)",
    "choice_a": "Device",
    "choice_b": "Network",
    "choice_c": "Installation time",
    "choice_d": "Business",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The four main factors for a company to consider before adopting new software, according to the CompTIA objectives, are how it will impact the device, the network, the operation, and the business. Installation time is not a factor on its own, but could be part of how the software installation impacts the business.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      14,
      9,
      1,
      4,
      93
    ],
    "source": "9781394330348"
  },
  {
    "id": 760,
    "question": "You\u2019re configuring a new user\u2019s computer so that their Microsoft Outlook mail will automatically be downloaded onto their Windows computer. What pieces of information will you need to set up their profile? (Choose two.)",
    "choice_a": "The protocol the server uses",
    "choice_b": "The user\u2019s email address",
    "choice_c": "The user\u2019s password",
    "choice_d": "The server port number",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To enable a user to retrieve their email from Microsoft Outlook, you would only need the user\u2019s email address and password. If the server is other than a Microsoft Outlook server, then you might need more information, such as the protocol the server uses and the server address. You don\u2019t need to know the port number. Email accounts may be configured in Settings by searching for mail and choosing the appropriate option, or by using the Mail applet in the Control Panel.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      34,
      32,
      48,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 761,
    "question": "You have a MacBook Pro and want to share files with a small group of Mac users. Because your team edits the files frequently, you want to make sure everyone has access to the same version of the files online. What storage solution should you use?",
    "choice_a": "iCloud",
    "choice_b": "Finder",
    "choice_c": "Remote Disc",
    "choice_d": "Spotlight",
    "correct_answer": "A",
    "explanation": "One of the best ways to always have the latest version of files, regardless of the device that you are using to access them, is to have them stored and accessed in the cloud. iCloud is Apple\u2019s answer to remote storage, and you can configure your Apple devices to place files there automatically or use it for backup. Finder enables a user to drill down through folders to find what they are seeking. Remote Disc is for using a shared optical drive, and Spotlight is used to search for objects in a macOS. It uses the familiar spyglass icon.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      86,
      92,
      85,
      15
    ],
    "source": "9781394330348"
  },
  {
    "id": 762,
    "question": "Which of the following is not a best practice for backing up Linux (or any) desktop systems?",
    "choice_a": "Follow the 3-2-1 rule.",
    "choice_b": "Carefully document backups.",
    "choice_c": "Make only monthly backups.",
    "choice_d": "Periodically verify that backups are not corrupt and can be restored.",
    "correct_answer": "C",
    "explanation": "Making only monthly backups would likely not be often enough for anyone. In a business setting, it\u2019s important to have a backup plan, taking into consideration how much data you\u2019re willing to lose and how long it would take to restore said data, if restoring from a backup were needed. The 3-2-1 rule states that you need to have three backups on two different media, and one needs to be offsite. It\u2019s also important to consider having backups that are separate from your main system, so that an infection of the main system won\u2019t infect the backup. Your backup plan should include regularly verifying that the backups are able to be restored, meaning that the backups complete properly, are not corrupted, and your restore plan works. Even emergency medical services have practice runs from time to time to ensure that when a major event happens, they will be ready. You should too. Finally, document, document, document. If an event occurs, you need to ensure that you\u2019re restoring from the correct backups, and if the person in charge of backups is not available for any reason, a thoroughly documented backup system will make it easier for someone else to continue the process in their place and/or restore backups if needed.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      92,
      93,
      55,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 763,
    "question": "You\u2019re working at a Windows command prompt and need to prepare a hard drive to receive data using the NTFS filesystem. The hard drive should be designated as drive <code>X</code>. Which command would you use at a Command Prompt to do this?",
    "choice_a": "<code>format x: /fs:ntfs</code>",
    "choice_b": "<code>initialize x: /fs:ntfs</code>",
    "choice_c": "<code>format x: /ntfs</code>",
    "choice_d": "<code>initialize x: /ntfs</code>",
    "correct_answer": "A",
    "explanation": "The <code>format</code> command is used to format hard drives. Before you format any drive, be sure that you have it backed up or are prepared to lose whatever is on it. The <code>/fs:[<i>filesystem</i>]</code> switch specifies the filesystem with which to prepare the disk. <code>initialize</code> is not a command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      36,
      39,
      56,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 764,
    "question": "You\u2019re running a computer with macOS. Which of the following will protect your data against accidental deletion?",
    "choice_a": "Mirrored drives",
    "choice_b": "An online utility",
    "choice_c": "Time Machine",
    "choice_d": "Nothing",
    "correct_answer": "C",
    "explanation": "Time Machine is a part of the macOS, and it makes backups hourly daily and weekly that can be used to restore a single file from months ago if it was accidentally deleted. Mirrored drives provide redundancy if the hard drive fails, but not against human error. Online utilities are often set up to do the same. Backups should be a priority if retaining the data is important. The only drawback with Time Machine is that if the external drive being used by it becomes full, it will start deleting the first backups to make room for new ones.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      91,
      92,
      94,
      93
    ],
    "source": "9781394330348"
  },
  {
    "id": 765,
    "question": "You are a junior IT administrator, and the senior IT administrator has just set up a proxy server, so you need to add settings for it to every workstation. What information do you need to properly set up the proxy server in the Network & Internet group of Windows Settings? (Choose two.)",
    "choice_a": "The proxy server\u2019s IP address",
    "choice_b": "The router\u2019s IP address",
    "choice_c": "The DHCP server\u2019s IP address",
    "choice_d": "The port number to use for the proxy server",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A proxy server provides a connection to networks outside the current network, hiding the internal network Internet Protocol (IP) addresses from outside, and filtering traffic entering and exiting a network. To set up a proxy server in Windows Settings, you only need the server\u2019s IP address and port number to use. You likely should also check the box that says Don\u2019t use the proxy server for local (intranet) addresses. You would not need the router\u2019s IP address or the Dynamic Host Configuration Protocol (DHCP) server\u2019s IP address unless it is also functioning as the proxy server. A router decides if a packet belongs on the local area network (LAN) or another network, and a DHCP server\u2019s job is to provide IP addresses and other settings to devices that log in to a network.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      67,
      34,
      66,
      33,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 766,
    "question": "You are working on a MacBook Pro and need to search it for a document you wrote a few months ago. Which feature should you use to search the computer\u2019s hard drive?",
    "choice_a": "Keychain",
    "choice_b": "Spotlight",
    "choice_c": "Finder",
    "choice_d": "Siri",
    "correct_answer": "B",
    "explanation": "The search feature within macOS is Spotlight, and a magnifying glass icon in the upper-right corner of the Menu bar represents it (or you can press the Command key+spacebar from any app). Spotlight can search for documents, images, apps, and so on. Keychain is Apple\u2019s password management system. Finder enables a user to drill down through folders to find what they are seeking. Siri is Apple\u2019s voice-activated virtual assistant.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      85,
      76,
      86,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 767,
    "question": "Which of the following is not a best practice for avoiding viruses/malware in a Linux system?",
    "choice_a": "Create a different user and disable the root user.",
    "choice_b": "Install an antivirus/anti-malware program and update it regularly.",
    "choice_c": "Only use eight-character alphanumeric passwords.",
    "choice_d": "Use <code>sudo</code> instead of <code>su</code>.",
    "correct_answer": "C",
    "explanation": "Eight-character alphanumeric passwords are simply too easy to hack. Whether a Windows or Linux system, longer or more complex passwords should always be required. There are other ways to keep malware and viruses out as well. Linux has a few advantages on that front. First and foremost, there are numerous people looking at Linux code, which means many people to catch and rectify a vulnerability that could be taken advantage of by viruses and hackers. In Linux, the user and system are more compartmentalized. If malware attacks a user, it will only have access to what that user account has access to, not system files and folders. This means if you must run commands as root, it\u2019s extremely important to, whenever possible, do so using <code>sudo</code> instead of <code>su</code>. The <code>sudo</code> command will run just that command as root, but <code>su</code> opens up an entire new shell as root and a greater vulnerability to attack. If you\u2019re logged in as <code>root</code>, the whole system is vulnerable. Also, hackers know that <code>root</code> is the default name for the system administrator, so you should create another user and disable <code>root</code> so a hacker not only has to guess the password, but the username as well. It\u2019s always good advice to install an antivirus/anti-malware program and update it regularly (preferably automatically). Other Linux security actions are to configure a firewall to filter traffic on unused ports, keep the Linux packages and Kernel updated, remove any software that is no longer being used, and change the <code>/boot</code> directory to \u201cread only\u201d so it can\u2019t be changed. You\u2019ll also want to monitor failed login attempts and lock accounts after a reasonable number of failed logins. Email can be encrypted, and of course, train users about the dangers of opening email from unfamiliar sources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      96,
      93,
      101,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 768,
    "question": "You are installing a new network for a small office. They are concerned about security and want a single place where access to files, printers, and other shared resources is established. You\u2019re installing Windows computers, so what type of network setup will you choose?",
    "choice_a": "Workgroup",
    "choice_b": "Homegroup",
    "choice_c": "Personal Area Network",
    "choice_d": "Domain",
    "correct_answer": "D",
    "explanation": "A domain is a group of computers that are tightly connected (or associated) and share a common domain name. It has a single authority (called a Domain Controller) that manages security and access to resources for all computers. All users will log in to the Windows domain using their centrally created user account. If no domain is used, then by default Windows computers will join a workgroup called <code>workgroup</code>, making it easy to share files, printers, and other resources. Access to resources is configured on each workstation sharing a resource. A workgroup\u2019s drawbacks are that security is configured on each PC, and it\u2019s only appropriate for very small networks. Homegroup was a networking scheme in prior Windows versions that shared Libraries. A personal area network (PAN) consists of a PC and its wireless devices, usually paired Bluetooth devices such as printers, headphones, and input devices. A domain is a network where access to resources is configured on a central server that all resource users must log in to.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      20,
      72,
      68,
      65
    ],
    "source": "9781394330348"
  },
  {
    "id": 769,
    "question": "You are viewing the screen shown in the following graphic. Which of the following is not true about the network connection from this screen?<img src=\"/question_assets/220-1202/c06f015.png\" alt=\"Screenshot of the Windows Network and Sharing Center depicts active network information and options to change network settings.\"/>\n\n<figcaption>Screenshot of the Windows Network and Sharing Center depicts active network information and options to change network settings.</figcaption>",
    "choice_a": "It is likely a network you or your company controls.",
    "choice_b": "File and Printer Sharing is likely enabled.",
    "choice_c": "It is a public network.",
    "choice_d": "Network Discovery is likely enabled.",
    "correct_answer": "C",
    "explanation": "In the View Your Active Networks pane, you can see that this network profile is set to Private network (i.e., not public). A private network is one that is trusted like where you work, or that you control like your home network. By default, this computer will be discoverable on the network, and File and Printer Sharing is enabled. To change these settings, you would click on Change advanced sharing settings. The other two types of network profiles are public and domain. To change the network type, go to Settings, choose Network and Internet, then Status. Click on Properties of the network connection that you want to change and choose the profile type. The domain profile type is detected automatically when the local computer logs in to an Active Directory (AD) domain.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      33,
      66,
      67,
      20
    ],
    "source": "9781394330348"
  },
  {
    "id": 770,
    "question": "A user has shared a folder with you. Working in File Explorer, how can you configure access to this shared network location each time you log in without reentering the path? (Choose two.)",
    "choice_a": "Left-click on This PC and choose the network share.",
    "choice_b": "Select This PC on the left and then click the Map Network Drive icon in the File Explorer ribbon and follow the onscreen prompts, ensuring that you choose Reconnect At Sign-in.",
    "choice_c": "Use File Explorer to drill down to the shared network resource. Right-click on the shared resource and then choose Map Network Drive and follow the onscreen prompts, ensuring that you choose Reconnect At Sign-in.",
    "choice_d": "Click on Quick Access and choose the network share.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Mapping a network drive to a share makes it easy to access that share every time you log in to your computer, provided you\u2019re on the same network. Left-clicking on This PC will show the mapped drive in the right pane after it has been set up as a mapped drive, so you can easily choose it from there. The network share will appear on Quick Access after you\u2019ve used it.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      68,
      59,
      66,
      31,
      58
    ],
    "source": "9781394330348"
  },
  {
    "id": 771,
    "question": "You\u2019re on your private wired network at home and notice that your mouse pointer is moving across the screen, but you aren\u2019t moving it. Also, your computer seems to be running slowly, so you suspect someone with malicious intent has hacked into it. You want to immediately block access through the local machine\u2019s firewall. Where can you quickly do this?",
    "choice_a": "Search for Firewall. Choose Firewall & Network Protection, click Private, and then click the box next to Block All Incoming Connections, including those in the list of allowed apps.",
    "choice_b": "Start typing <code>Windows</code> in the search box, choose Windows Defender Firewall, and then click Private Networks and Disable.",
    "choice_c": "Search for <code>air,</code> click on Turn Airplane Mode On Or Off, and then turn Airplane Mode on.",
    "choice_d": "Search for Windows Defender Firewall and choose it, and then turn the firewall off.",
    "correct_answer": "A",
    "explanation": "Choosing to Block all incoming connections, including those in the list of allowed apps would certainly stop all incoming connections quickly. There is no Disable option under Private networks in the Windows Defender Firewall window. Turning Airplane mode on would stop the computer from communicating on wireless networks, but it wouldn\u2019t stop communication on a wired network, and turning off the firewall is the opposite of what you would want to do.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      69,
      33,
      96,
      28,
      66
    ],
    "source": "9781394330348"
  },
  {
    "id": 772,
    "question": "You have a Windows Pro computer set up in a workgroup, and you need to perform some routine management tasks on it. Before you do, you need to see what shares already exist on the local computer. How can you do this?",
    "choice_a": "In Windows Settings, choose Network & internet.",
    "choice_b": "In Windows Settings, choose Ease Of Access.",
    "choice_c": "In Computer Management, choose Shared Folders, and then double-click Shares.",
    "choice_d": "In the Network and Sharing Center utility of the Control Panel, click on Change Advanced Sharing.",
    "correct_answer": "C",
    "explanation": "Choosing Computer Management, then Shared Folders, and Shares will show all of the resources that are shared on the local computer. Some are created by default. Hidden shares will have a <code>$</code> at the end of the name and can only be accessed if you know the share name. Network & internet deals with configuring network connections, not network shares. Ease of Access is a Windows 10 utility that enables alternate configurations that work better for differently-abled people. Network and Sharing Center is used to configure networks, and it has settings to turn sharing on and off, but not a way to show all of the current network shares.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      68,
      59,
      33,
      20
    ],
    "source": "9781394330348"
  },
  {
    "id": 773,
    "question": "Your laptop is equipped with a WWAN card, and you\u2019ve arranged for service with a cellular provider. Where in Windows 11 can you connect to the network? (Choose two.)",
    "choice_a": "Click on the wireless network icon on the taskbar, and then click Network And Internet Settings, Cellular.",
    "choice_b": "In the Network & Internet group of Windows Settings, click on Mobile Hotspot.",
    "choice_c": "In the Network & Internet group of Windows Settings, click on Wi-Fi.",
    "choice_d": "Open the Control Panel, click on Network And Sharing Center, and then click Set Up A New Connection Or Network.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Before you can use the WWAN, you need to configure it, which can either be done through Network and Internet Settings in the Settings app, or through the Network and Sharing Center in the Control Panel. WWAN is a cellular connection, not a mobile hotspot or Wi-Fi.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      66,
      34,
      32,
      58,
      67
    ],
    "source": "9781394330348"
  },
  {
    "id": 774,
    "question": "You want to block an application from communicating through your Windows Defender Firewall. What will you set up for this application?",
    "choice_a": "An exception",
    "choice_b": "A restriction",
    "choice_c": "A mapped drive",
    "choice_d": "A network share",
    "correct_answer": "B",
    "explanation": "A restriction means that you will not allow an application to communicate through a firewall, while an exception means that you will allow that application to communicate through the firewall. To configure a restriction in Windows Defender Firewall, open it from the Control Panel and click on Advanced Settings, then click on Outbound Rules and New Rule. Ensure that Program is selected and click Next. Click on Browse to locate the program file, click to select it, then click Open. The program path should appear in the New Outbound Rule Wizard dialog box. Click Next, then choose Block the connection. Click Next twice, then give your rule a name and click Finish. A mapped drive means that you have assigned a drive letter on a local computer to a folder that is shared on a remote computer. A network share would take place on a computer with folders to which you want to allow others on your network to have access.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      69,
      14,
      68,
      11
    ],
    "source": "9781394330348"
  },
  {
    "id": 775,
    "question": "You need to connect to the Internet, but you regularly work in remote areas, and your only option is to use a cellular network. What type of network are you establishing when you connect to the Internet?",
    "choice_a": "PAN",
    "choice_b": "CAN",
    "choice_c": "WWAN",
    "choice_d": "LAN",
    "correct_answer": "C",
    "explanation": "Most of us are familiar with the local area network (LAN) in our home or office, and the personal area network (PAN) that we use to connect Bluetooth devices, such as wireless keyboards, mice, and headsets to our computers. A campus area network (CAN) could exist on a property owned by a single entity but housed in discrete buildings. The network might even cross government-owned streets. You might be less familiar with a wireless wide area network (WWAN). However, they are used more and more frequently. Unlike Wireless LANs, which use radio, microwave, or infrared signals, WWANs take advantage of the cellular network. You can purchase a WWAN device, often called a mobile hotspot, from a cellular service provider. They generally require a contract, but some don\u2019t. The great advantage of a WWAN is that they work almost anywhere\u2014the cellular network is virtually worldwide. The biggest disadvantage is likely the cost.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      58,
      59,
      68,
      33
    ],
    "source": "9781394330348"
  },
  {
    "id": 776,
    "question": "You\u2019re working on your laptop at a friend\u2019s house. You click on your browser to research something, but a window pops up saying No Internet. How do you resolve this? (Choose two.)",
    "choice_a": "Right-click the browser shortcut and choose New Window.",
    "choice_b": "Open Settings, choose Network & Internet, click on Wi-Fi, and then click on Show Available Networks. Choose your friend\u2019s network, and ask for the password.",
    "choice_c": "Click the taskbar icon that looks like a globe, and then choose your friend\u2019s network and ask for the password.",
    "choice_d": "Type <code>firewall</code> in the search box and choose Firewall & Network Protection, and then click on Private Network.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The fastest way to join your friend\u2019s network is to click on the globe icon (or Wi-Fi icon) and choose their network; however, going through Settings, Network & Internet, Wi-Fi, and Show available networks also works. Right-clicking a browser shortcut will show websites that you\u2019ve recently been to and a few other options, including New window. Firewall & network protection, then choosing Private network, will enable you to configure firewall settings for use with a private network.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      34,
      33,
      58,
      59
    ],
    "source": "9781394330348"
  },
  {
    "id": 777,
    "question": "You need to create an exception to allow Open Office to communicate through the local Windows computer\u2019s firewall. How do you configure this? (Choose two.)",
    "choice_a": "In the Search box, type <code>Firewall & network protection</code>, and then choose it and click Allow An App Through Firewall.",
    "choice_b": "In Windows Settings, choose the Apps group.",
    "choice_c": "In the Control Panel, choose Windows Defender Firewall, and then select Allow An App Or Feature Through Windows Defender Firewall.",
    "choice_d": "In the Control Panel, open the Programs and Features utility.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "You can drill down through Windows Settings to find Firewall & Network Protection Settings, but it\u2019s far easier to search for it, then choose Allow an app through firewall. Once there, if the app is in the list, check the Change Settings button, then check the box next to the application you want to allow access for under the listing for Private or Public network, depending on your needs. If it isn\u2019t in the list, click Allow another app. Drilling down through the Control Panel, choose Windows Defender Firewall, then Allow an app or feature through Windows Defender Firewall will take you to the same setup screen. The other two options in the question enable you to uninstall applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      33,
      69,
      34,
      32,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 778,
    "question": "A user has a laptop that they think has WWAN capabilities. Where can you quickly check?",
    "choice_a": "Disk Management",
    "choice_b": "Device Manager",
    "choice_c": "Apps & Features",
    "choice_d": "Programs and Features",
    "correct_answer": "B",
    "explanation": "A quick check of Device Manager and clicking on Network Adapters should show you what you have for network devices. Most likely you\u2019ll see a Bluetooth Device (personal area network) entry, possibly an Ethernet local area network (LAN) adapter, a wireless area network (WAN) adapter and, if you have one, a wireless wide area network (WWAN) adapter. If it doesn\u2019t show there, it either isn\u2019t being detected by the system, or one does not exist in your system. Disk Management is for configuring and managing drives. Apps & Features and Programs and Features both have the same job\u2014that is providing a way to install or repair applications and add or remove Windows features. The former is in Settings, and the latter is in the Control Panel.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      66,
      34,
      31
    ],
    "source": "9781394330348"
  },
  {
    "id": 779,
    "question": "A user wants to use a WWAN connection to the Internet because they travel, and Ethernet and Wi-Fi networks aren\u2019t always available for connection. What will this user need? (Choose two.)",
    "choice_a": "A wireless NIC",
    "choice_b": "A WWAN card or device",
    "choice_c": "A cellular service provider",
    "choice_d": "An RJ-45 connector",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Wireless wide area networks (WWANs) use the cellular system to connect to the Internet. To make a connection, you would need either a WWAN card in your laptop, or a WWAN device, sometimes called a mobile hotspot device, and a cellular service connection. Some cellular companies require a contract for this type of cellular service, but not all do. The WWAN card or WWAN device needs to be compatible with your cellular provider. Wireless network interface cards (NICs) are used for Wi-Fi connections, and an RJ-45 connector is used for wired Ethernet connections.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      66,
      32,
      33,
      14,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 780,
    "question": "A user at your company just signed up for WWAN service through their cellular provider. Their data is capped at 10 GB per month. It\u2019s very costly if they go over, so they\u2019ve asked you if there is a way for them to avoid going over their data limit. What will you do for them?",
    "choice_a": "Set up their cellular WWAN as a metered service.",
    "choice_b": "Use Performance Monitor to track their WWAN use.",
    "choice_c": "Switch them to a VPN so it won\u2019t cost anything.",
    "choice_d": "Use a proxy server so their data downloads won\u2019t count.",
    "correct_answer": "A",
    "explanation": "Metered network settings can be configured for wired, Wi-Fi, or a wireless wide area network (WWAN) connection. For example, to configure a Wi-Fi network as a metered connection, go to Settings, then choose the Network & Internet group, click on Wi-Fi, then Manage known networks, and select the Network. In Windows 10, you need to click Properties, but in Windows 11 you\u2019re already on the Properties screen. Locate the metered connection setting and turn it on. You can then set a data limit to control data usage. Performance Monitor won\u2019t show data usage. A WWAN can connect to a virtual private network (VPN), but it will still use data. Your connection might go through a proxy server when connecting to a network, but a proxy server\u2019s job is to filter network traffic. Anytime you\u2019re connecting to the Internet or a VPN via your WWAN connection, you\u2019ll be using data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      32,
      31,
      67,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 781,
    "question": "A junior network administrator wants to know what the fastest way is to access File Explorer, because they use it often. What do you tell them?",
    "choice_a": "Press Windows Logo Key+F key.",
    "choice_b": "Press Windows Logo Key+M key.",
    "choice_c": "Press Windows Logo Key+E key.",
    "choice_d": "Press Windows Logo Key+X key, and then choose File Explorer from the menu.",
    "correct_answer": "C",
    "explanation": "File Explorer should be showing on the Windows taskbar, but if it isn\u2019t, pressing the Windows Logo Key plus the E key simultaneously will open the File Explorer window. Pressing the Windows Logo Key+X key, then selecting File Explorer from the menu will also work, but it\u2019s not the fastest or most direct way. Windows Logo Key+F will bring up a feedback window, and Windows Logo Key+M will minimize all the open windows, leaving you at the desktop.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      23,
      7,
      25,
      30,
      35
    ],
    "source": "9781394330348"
  },
  {
    "id": 782,
    "question": "You need to establish a wired connection between a newly installed Windows Pro computer and an Ethernet home network. The router is located next to the desk and provides DHCP services. What will you need to connect a desktop computer to this network? (Choose two.)",
    "choice_a": "Patch cable",
    "choice_b": "Wireless NIC",
    "choice_c": "NIC with RJ-45 port",
    "choice_d": "IP address and subnet mask",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "For a new Windows installation, the default network setting is to configure IP addresses dynamically, so the computer should get its IP address and subnet mask from the Dynamic Host Configuration Protocol (DHCP) server. All you need is a patch cable to connect to the router and a compatible network interface card (NIC) installed (with its drivers, of course) with a registered jack 45 (RJ-45) port. You would not use a wireless NIC for an Ethernet network. A wireless NIC is for a Wi-Fi network. You don\u2019t need to know the IP address and subnet mask because the DHCP server will assign them automatically.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      66,
      58,
      28,
      1,
      94
    ],
    "source": "9781394330348"
  },
  {
    "id": 783,
    "question": "You need to know the path to a network resource. How can you locate it? (Choose two.)",
    "choice_a": "In File Explorer, look at the path in the title bar.",
    "choice_b": "In File Explorer, right-click the resource, choose Properties, and then click the Sharing tab and look under Network Path.",
    "choice_c": "Type <code>mynetworkdrives</code> in a browser.",
    "choice_d": "In Computer Management, choose Shared Folders and then Shares.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "There are multiple ways to view the path to a resource. In File Explorer, you can right-click the resource, then choose Properties and the Sharing tab. The screen will say Network Path and list the path just below it. You can also see it at the top of File Explorer when you\u2019re in the resource. If it isn\u2019t there, click on the ellipsis (\u2026), choose Options, then the View tab, and ensure that Show full path in address bar is checked. Shares in Computer Management shows what you are sharing, not what is being shared with you. Typing <code>mynetworkdrives</code> in a browser is invalid.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      68,
      25,
      59,
      66,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 784,
    "question": "When installing a new application, which of the following is not an advantage of using a mountable file over physical media?",
    "choice_a": "Ease of installation",
    "choice_b": "Lower cost to distribute",
    "choice_c": "Easier to change",
    "choice_d": "Easier to locate",
    "correct_answer": "A",
    "explanation": "Software on a mountable file or physical media should be equally easy (or difficult) to install, because it\u2019s the same software; only the method of delivery is different. Mountable media has a lower cost to distribute because there is no physical media to purchase and nothing to mail to someone else; mountable files can be distributed over a network. It\u2019s easier to change because changes can be made to the file and uploaded instead of retrieving existing media and making multiple copies of the new file. It\u2019s also easier to locate because there is no need to find a Universal Serial Bus (USB) drive among the several that someone has. Files with an <code>.iso</code> extension are disk image files. To install the software they contain, you first need to mount the image. You might be able to double-click it. If not, right-click and choose Mount or locate the file in File Explorer. Select the file, then click Mount under Disk Image Tools. Once the file is mounted, the operating system (OS) will treat it as a disk in an optical drive. You\u2019ll look for an installer or autorun file to start the software installation. When you\u2019re done using the image, right-click it and choose Eject.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      75,
      46,
      54,
      14
    ],
    "source": "9781394330348"
  },
  {
    "id": 785,
    "question": "You\u2019ve installed a new hard drive in a Windows PC and need to partition the drive and format the volumes. What tools can you use to format it? (Choose two.)",
    "choice_a": "<code>diskmgmt.msc</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "<code>perfmon.msc</code>",
    "choice_d": "<code>services.msc</code>",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Once a hard drive is installed, partitions must be created (even if there is only one), and the volumes must then be formatted before they will show in File Explorer and be ready for the user to store information on them. Disk Management (<code>diskmgmt.msc</code>) and <code>diskpart</code> are two excellent and powerful tools for doing just that. Disk Management is a utility with a user-friendly graphical user interface (GUI), while <code>diskpart</code> is run from the command line and is the more powerful of the two and worth spending some time exploring. Performance Monitor (<code>perfmon.msc</code>) shows resource usage in real-time, and the Services console (<code>services.msc</code>) shows all the services available in the system and their current status.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      61,
      40,
      36,
      56,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 786,
    "question": "You\u2019re troubleshooting problems with an application on a Mac computer. You\u2019ve uninstalled the application, but it won\u2019t reinstall because it says the application is already installed. You\u2019re going to manually delete the application file so you can then reinstall it. What file extension will you look for?",
    "choice_a": "<code>.pkg</code>",
    "choice_b": "<code>.bat</code>",
    "choice_c": "<code>.dmg</code>",
    "choice_d": "<code>.app</code>",
    "correct_answer": "D",
    "explanation": "Files with an <code>.app</code> extension are applications. A file with a <code>.pkg</code> extension in a Mac is a compressed package file. A file with a <code>.dmg</code> extension is a disk image and treated like a drive in the macOS. It can be \u201cmounted\u201d like a physical hard drive, the contents read, and files opened, or applications installed from it. Files with a <code>.bat</code> extension are batch files used in Windows to run a string of commands that have been entered into a text file.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      75,
      87,
      11,
      14,
      96
    ],
    "source": "9781394330348"
  },
  {
    "id": 787,
    "question": "Your company has Windows on its workstations and wants to use file encryption and advanced permissions at the file level. What filesystem will the company be using?",
    "choice_a": "ReFS",
    "choice_b": "FAT32",
    "choice_c": "ext4",
    "choice_d": "NTFS",
    "correct_answer": "D",
    "explanation": "New Technology File System (NTFS) is the Windows filesystem that supports file encryption and NTFS permissions for file sharing. Resilient File System (ReFS) is a feature available on Windows Pro for Workstations and Windows Enterprise editions. ReFS will detect when data on a mirrored drive has been corrupted and will use a healthy copy of the data on other drives to attempt to correct corrupted data and protect data. The File Allocation Table 32 (FAT32) filesystem is most compatible between operating systems (OSs) but doesn\u2019t support NTFS permissions and file-level encryption. The Fourth Extended File System (ext4) filesystem is used in the Linux world.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      39,
      36,
      21,
      61,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 788,
    "question": "Which of the following filesystem types are you most likely to find on a Linux workstation?",
    "choice_a": "FAT32",
    "choice_b": "NTFS",
    "choice_c": "XSF",
    "choice_d": "ext4",
    "correct_answer": "D",
    "explanation": "Although the XSF filesystem and Fourth Extended File System (ext4) are both filesystems used with Linux, the ext4 filesystem is most likely to be found on a Linux workstation. The XSF filesystem uses parallel execution and is designed to handle the large file sizes of database servers. File Allocation Table 32 (FAT32) is commonly used for memory cards, Universal Serial Bus (USB) drives, and external hard drives. It is the filesystem that was used when only 32-bit processors were available. It can still be used for compatibility issues with legacy devices; however, Windows 10 and Windows 11 require the New Technology File System (NTFS). NTFS has been available for decades and offers security features that FAT32 doesn\u2019t have.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      36,
      39,
      2,
      5
    ],
    "source": "9781394330348"
  },
  {
    "id": 789,
    "question": "Which of the following filesystem types is required on Windows 11?",
    "choice_a": "FAT32",
    "choice_b": "NTFS",
    "choice_c": "XSF",
    "choice_d": "ext4",
    "correct_answer": "B",
    "explanation": "Windows 10 and Windows 11 require the New Technology File System (NTFS). NTFS has been available for decades and offers security features that File Allocation Table 32-bit (FAT32) doesn\u2019t have. FAT32 is the filesystem that was used when only 32-bit processors were available and can still be used for compatibility issues with legacy devices. It is commonly used when compatibility between different operating system (OS) platforms is required, and for memory cards, Universal Serial Bus (USB) drives, and external hard drives. The XSF filesystem and Fourth Extended File System (ext4) are both used with Linux.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      36,
      19,
      44,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 790,
    "question": "You want to automate a repetitive process. You press the Windows Logo Key+R Key simultaneously. What do you type in the Run dialog box?",
    "choice_a": "<code>automate</code>",
    "choice_b": "<code>tasksched.msc</code>",
    "choice_c": "<code>diskmgmt.msc</code>",
    "choice_d": "<code>dfrgui.exe</code>",
    "correct_answer": "B",
    "explanation": "The Task Scheduler (<code>tasksched.msc</code>) enables users to set times and dates for programs to run, whether they run one time or repetitively. <code>automate</code> isn\u2019t a valid command. Disk Management (<code>diskmgmt.msc</code>) provides a quick graphical user interface (GUI) for managing volumes on storage drives, and Disk Defragment (<code>dfrgui.exe</code>) is a GUI where a user can defragment a hard disk drive (HDD).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      31,
      32,
      43,
      27
    ],
    "source": "9781394330348"
  },
  {
    "id": 791,
    "question": "You want to know who is currently logged in to a workstation. What command works in both the Linux terminal and Windows Command Prompt and Terminal and will show information about the current user?",
    "choice_a": "<code>whoami</code>",
    "choice_b": "<code>users</code>",
    "choice_c": "<code>idme</code>",
    "choice_d": "<code>net use</code>",
    "correct_answer": "A",
    "explanation": "The <code>whoami</code> command returns information about the currently logged on user. It works in both Windows and Linux, but CompTIA only has it listed under Windows. Exactly what it displays depends on what computer you\u2019re using when you run it. On a workstation, it will display the computer name/username. On a Windows server, it will return the users along with their groups and privileges. Users is a folder that contains information about all the users of the computer. It isn\u2019t a command. The option of <code>idme</code> isn\u2019t a real command, and the <code>net use</code> command enables a person to use shared resources on a network.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      62,
      98,
      99,
      63,
      56
    ],
    "source": "9781394330348"
  },
  {
    "id": 792,
    "question": "You find that you are often using System Configuration, Disk Cleanup, and Event Viewer. What Windows 10 Control Panel utility gives you quick access to these and more tools?",
    "choice_a": "Computer Management",
    "choice_b": "Resource Monitor",
    "choice_c": "Administrative Tools",
    "choice_d": "Task Scheduler",
    "correct_answer": "C",
    "explanation": "Administrative Tools, which can be found in the Windows 10 Control Panel, has many of the computer-management tools that are used to maintain and troubleshoot computer systems, not just the ones listed in this question. In Windows 11, Administrative Tools has been renamed to Windows Tools and is not identical to Administrative Tools. Computer Management is a Microsoft Management Console (MMC) that contains other tools as well. In it, you can find Task Scheduler, Event Viewer, Shared Folders, Performance, Device Manager, and Disk Management, as well as Services and Windows Management Instrumentation (WMI) Control. In Windows Pro and above editions, Computer Management also contains Local Users and Groups. Resource Monitor shows resources being used by process in real-time, and Task Scheduler is just as the name sounds\u2014it can be used to schedule other applications, even batch files, to run based on time or other predetermined events.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      32,
      31,
      27
    ],
    "source": "9781394330348"
  },
  {
    "id": 793,
    "question": "You just upgraded a computer from Windows 10 to Windows 11 and can\u2019t find Administrative Tools. What Windows 11 utility is most similar to Windows 10 Administrative Tools?",
    "choice_a": "Computer Management",
    "choice_b": "Resource Monitor",
    "choice_c": "Windows Tools",
    "choice_d": "Task Scheduler",
    "correct_answer": "C",
    "explanation": "Administrative Tools, which can be found in the Windows 10 Control Panel, has many of the computer management tools that are used to maintain and troubleshoot computer systems. In Windows 11, Administrative Tools has been renamed to Windows Tools. Computer Management is a Microsoft Management Console (MMC) that contains other tools as well. In it, you can find Task Scheduler, Event Viewer, Shared Folders, Performance, Device Manager, and Disk Management, as well as Services and Windows Management Instrumentation (WMI) Control. In Windows Pro and above editions, Computer Management also contains Local Users and Groups. Resource Monitor shows resources being used by process in real-time, and Task Scheduler is just as the name sounds\u2014it can be used to schedule other applications, even batch files, to run based on time or other predetermined events.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      30,
      31,
      27,
      26
    ],
    "source": "9781394330348"
  },
  {
    "id": 794,
    "question": "You\u2019ve been called to troubleshoot a customer\u2019s computer. You first observe that the desktop has the taskbar icons slid to the left of the taskbar instead of in the center, and when you click on the Windows button at bottom-left, a start screen with tiles appears. What version of Windows does this user have?",
    "choice_a": "Windows 8",
    "choice_b": "Windows 9",
    "choice_c": "Windows 10",
    "choice_d": "Windows 11",
    "correct_answer": "C",
    "explanation": "One of the notable differences between Windows 11 and Windows 10 is the user interface. In Windows 10, the taskbar icons are all the way to the left, and clicking the Windows icon brings up a Start menu with live tiles. Windows 11 has centered taskbar icons, and clicking the Windows icon launches a Start menu with pinned icons and a search bar. Windows 8 didn\u2019t have a Start button. There is no Windows 9.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      18,
      22,
      8,
      50
    ],
    "source": "9781394330348"
  },
  {
    "id": 795,
    "question": "Which of the following is not an available tab in the File Explorer Options applet found in the Control Panel?",
    "choice_a": "General tab",
    "choice_b": "View tab",
    "choice_c": "Search tab",
    "choice_d": "Options tab",
    "correct_answer": "D",
    "explanation": "File Explorer Options in the Control Panel has three tabs: General, View, and Search. In the General tab, under Browse folders, there is only one option, which is to choose whether to open each folder in the same window or its own window. The other two sections of the General tab control whether you single or double-click to open a file, and whether the list of previously accessed files and folders is shown. The View tab has many advanced settings in the checklist shown in the graphic. The Search tab enables you to change how searches are conducted. There is no Options tab.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      34,
      32,
      30,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 796,
    "question": "In macOS, which of the following folders holds universal fonts, settings, and other information used by everyone who uses the system?",
    "choice_a": "<code>/Library</code>",
    "choice_b": "<code>/Users~/Library</code>",
    "choice_c": "<code>/System</code>",
    "choice_d": "<code>/Applications</code>",
    "correct_answer": "A",
    "explanation": "In macOS, the <code>/Library</code> folder holds information that all users need for the system to function. <code>/Users~/Library</code> holds data and software for the particular named user. The <code>/System</code> folder holds files needed to run the operating system (OS). <code>/Applications</code> holds the files of applications that have been installed on the Mac, like the <code>\\Program Files</code> folder in a Windows system does.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      89,
      88,
      87,
      90,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 797,
    "question": "In macOS, which of the following folders holds information about everyone who uses the computer?",
    "choice_a": "<code>/Library</code>",
    "choice_b": "<code>/Users</code>",
    "choice_c": "<code>/System</code>",
    "choice_d": "<code>/User</code>",
    "correct_answer": "B",
    "explanation": "In macOS, the <code>/Users</code> folder contains a folder named for each user in the system. The <code>/Library</code> folder holds information that is shared among all users, like system-wide fonts. <code>/System</code> holds the Mac operating system (OS) files. Don\u2019t rename or delete it! <code>/User</code> isn\u2019t valid in the macOS world. <code>\\User</code> in a Windows system contains a list of all users who have logged in to the system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      88,
      89,
      90,
      5,
      73
    ],
    "source": "9781394330348"
  },
  {
    "id": 798,
    "question": "What two iCloud applications enable audio, video, and text messages to be shared between Mac systems? (Choose two.)",
    "choice_a": "iPhone",
    "choice_b": "iMessage",
    "choice_c": "FaceTime",
    "choice_d": "Teams",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "iMessage is the Short Message Service (SMS) software used by Mac devices, and FaceTime enables users to see the other person to which they\u2019re talking. iPhone is a platform, not an application, and Teams is Microsoft\u2019s sharing platform for Windows users.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      84,
      16,
      87,
      74,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 799,
    "question": "Your mom has an Apple Watch that enables her to answer and make phone calls, check her email, and read and respond to messages, even if her iPhone is not near her. What\u2019s the name of the feature of Apple devices that enables these devices to synchronize?",
    "choice_a": "Continuity",
    "choice_b": "Individuality",
    "choice_c": "Integration",
    "choice_d": "iCloud",
    "correct_answer": "A",
    "explanation": "Continuity is an Apple feature that enables synchronization of information between Apple devices. iCloud plays a role in this synchronization but isn\u2019t the name of the feature. Individuality and Integration are not Apple features, and iCloud is Apple\u2019s online storage space.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      84,
      86,
      15,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 800,
    "question": "Which of the following are involved in filesystem management in a Linux system? (Choose two.)",
    "choice_a": "<code>du</code>",
    "choice_b": "<code>fsck</code>",
    "choice_c": "<code>mount</code>",
    "choice_d": "<code>kernel</code>",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "In a Linux system, <code>fsck</code> and <code>mount</code> are used for filesystem management. The filesystem consistency check (<code>fsck</code>) looks for and repairs errors in the filesystem. The <code>mount</code> command enables the user to add files from an external source to their directory tree so they can easily use them. <code>du</code> calculates and reports disk space usage, and the kernel files are the main part of the operating system (OS). The kernel accepts commands.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      37,
      77,
      61,
      97
    ],
    "source": "9781394330348"
  },
  {
    "id": 801,
    "question": "Which of these Linux networking commands enables a user to communicate with a client computer through the Linux Terminal?",
    "choice_a": "<code>ping</code>",
    "choice_b": "<code>traceroute</code>",
    "choice_c": "<code>curl</code>",
    "choice_d": "<code>dig</code>",
    "correct_answer": "C",
    "explanation": "In a Linux distribution, the <code>curl</code> command is used in the Terminal (Linux\u2019s command-line interface) to communicate with a specific client URL (<code>cURL</code>). <code>ping</code> tests connectivity. <code>traceroute</code> shows the routers a packet traverses to get from sender to destination, and <code>dig</code>, which is also used in macOS, provides several functions related to the Domain Name System (DNS) and provides DNS lookups.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      98,
      82,
      59,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 802,
    "question": "Which of these is a Linux command that is used to install, update, and remove packages?",
    "choice_a": "<code>man</code>",
    "choice_b": "<code>cat</code>",
    "choice_c": "<code>curl</code>",
    "choice_d": "<code>dnf</code>",
    "correct_answer": "D",
    "explanation": "In a Linux distribution, the <code>dnf</code> command is used to install, update, and remove packages. <code>man</code> displays the manual (help) for the specified command. <code>cat</code>, short for concatenate, can read, display, and combine files. The <code>curl</code> command is used at a Terminal (Linux\u2019s command-line interface) to communicate with a specific client URL (<code>cURL</code>).",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      101,
      99,
      98,
      105,
      106
    ],
    "source": "9781394330348"
  },
  {
    "id": 803,
    "question": "Which of these is a Linux OS component that runs the initialization programs in many Linux distributions and manages services and systems?",
    "choice_a": "<code>systemd</code>",
    "choice_b": "<code>kernel</code>",
    "choice_c": "<code>bootloader</code>",
    "choice_d": "<code>traceroute</code>",
    "correct_answer": "A",
    "explanation": "In many (but not all) Linux distributions, the kernel loads <code>systemd</code>, which then initializes all the other processes needed to run the operating system (OS). The <code>bootloader</code> in Linux is akin to the <code>bootloader</code> in a Windows system; it is part of the master boot record (MBR) and is the file that finds and loads the OS files, in this case, the kernel. <code>traceroute</code> is a networking command used to see the path a packet takes to get from one point to another.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      103,
      1,
      73,
      101
    ],
    "source": "9781394330348"
  },
  {
    "id": 804,
    "question": "Windows has administrator accounts that can control everything in a Windows computer. What is the username with similar power in a Linux system?",
    "choice_a": "<code>admin</code>",
    "choice_b": "<code>boss</code>",
    "choice_c": "<code>root</code>",
    "choice_d": "<code>systemd</code>",
    "correct_answer": "C",
    "explanation": "The Linux <code>root</code> account has ultimate power in a Linux system. <code>systemd</code> is a part of the operating system (OS) that is loaded by the bootloader. It initializes the system and loads the kernel. <code>admin</code> is a common administrator username on some routers, and <code>boss</code> is not a real computing term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      5,
      1,
      73
    ],
    "source": "9781394330348"
  },
  {
    "id": 805,
    "question": "Which of these Linux OS folders holds a hashed version of username passwords?",
    "choice_a": "<code>/ect/passwd</code>",
    "choice_b": "<code>/ect/shadow</code>",
    "choice_c": "<code>/ect/hosts</code>",
    "choice_d": "<code>/ect/resolve.conf</code>",
    "correct_answer": "B",
    "explanation": "A hashed list of user passwords is held in the <code>/ect/shadow</code> folder. <code>/ect/passwd</code> holds other information about users, such as their username, ID, home directory and group, and a marker that points to their entry in the <code>/ect/shadow file</code>. The option of <code>/ect/hosts</code> is used to resolve hostnames to Internet Protocol (IP) addresses on the local network, and <code>/ect/resolve.conf</code> is used to specify Domain Name System (DNS) server IP addresses to be used in resolving domain names to IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      65,
      1,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 806,
    "question": "Which of these Linux OS folders is used to resolve hostnames on a local network to IP addresses?",
    "choice_a": "<code>/ect/passwd</code>",
    "choice_b": "<code>/ect/fstab</code>",
    "choice_c": "<code>/ect/hosts</code>",
    "choice_d": "<code>/ect/resolve.conf</code>",
    "correct_answer": "C",
    "explanation": "The <code>/ect/hosts</code> folder contains a table resolving local hostnames to their IP addresses. <code>/ect/passwd</code> holds information about users, such as their username, ID, home directory and group, and a marker that points to their entry in the <code>/ect/shadow file</code>, which contains a hashed version of their password. <code>/ect/fstab</code> contains a configuration table for mounting and unmounting filesystems. It makes using devices like Universal Serial Bus (USB) drives easier because using it means the user doesn\u2019t have to manually mount and unmount drives. <code>/ect/resolve.conf</code> is used to specify Domain Name System (DNS) server Internet Protocol (IP) addresses to be used in resolving domain names to IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      102,
      106,
      99,
      73
    ],
    "source": "9781394330348"
  },
  {
    "id": 807,
    "question": "Which of these Linux OS folders automatically mounts and unmounts external devices?",
    "choice_a": "<code>/ect/passwd</code>",
    "choice_b": "<code>/ect/fstab</code>",
    "choice_c": "<code>/ect/hosts</code>",
    "choice_d": "<code>/ect/resolve.conf</code>",
    "correct_answer": "B",
    "explanation": "The <code>/ect/fstab</code> folder contains a configuration table for mounting and unmounting filesystems. It makes using devices like Universal Serial Bus (USB) drives easier because using it means the user doesn\u2019t have to manually mount and unmount drives. <code>/ect/passwd</code> holds information about users, such as their username, ID, home directory and group, and a marker that points to their entry in the <code>/ect/shadow file</code>, which contains a hashed version of their password. The <code>/ect/hosts</code> folder contains a table resolving local hostnames to their Internet Protocol (IP) address. <code>/ect/resolve.conf</code> is used to specify Domain Name System (DNS) server IP addresses to be used in resolving domain names to IP addresses.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      100,
      37,
      99,
      73
    ],
    "source": "9781394330348"
  },
  {
    "id": 808,
    "question": "What two pieces of information are usually all that are required to configure a user\u2019s cloud-based email system? (Choose two.)",
    "choice_a": "Email address",
    "choice_b": "DNS server",
    "choice_c": "Password",
    "choice_d": "Mail server IP address",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Usually when creating or configuring an online email service, all that is needed is the user\u2019s email address and a password.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      16,
      9,
      62,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 809,
    "question": "Which of these is not a cloud storage system/service?",
    "choice_a": "Google Drive",
    "choice_b": "OneDrive",
    "choice_c": "Dropbox",
    "choice_d": "Linux drive",
    "correct_answer": "D",
    "explanation": "Linux doesn\u2019t have a specific online storage named Linux drive, but there are several online spaces that Linux users can use to collaborate, like Slack and Google Drive. Google Drive is a Google tool that provides not only storage but also the ability to share documents and collaborate. Microsoft\u2019s online storage solution, OneDrive, works with Office 365 Copilot. Dropbox is a third-party application for storing and backing up files.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      16,
      37,
      41,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 810,
    "question": "A family member has a new iPhone and wants to know how to synchronize their photos so they can be viewed with their iPad. What do you tell them? (Choose two.)",
    "choice_a": "It can\u2019t be done.",
    "choice_b": "On the phone, go to Settings, their name, and then iCloud, tap iCloud Drive, and click the button next to Sync This iPhone. Do the same on the iPad.",
    "choice_c": "On the phone, go to Settings, their name, and then iCloud, tap iCloud Drive, and click the button next to Sync This iPhone. On the iPad, navigate to <code>icloud.com</code>, and then sign in with their Apple account.",
    "choice_d": "On the phone, go to Settings and then their name, click Synchronize, and then enter their username and password. Click Synchronize Now to Google Drive. Access their Google Drive from the iPad.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Synchronizing between an iPhone and an iPad is easy. Go to Settings, click on your name, then iCloud, tap iCloud drive, and click the button next to Sync this iPhone. Then on the iPad, the user can either perform the same synchronization setup or access the data from <u><code>icloud.com</code></u>.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      86,
      75,
      4,
      88
    ],
    "source": "9781394330348"
  },
  {
    "id": 811,
    "question": "You\u2019re a network admin and need to give employees access to Microsoft 365 apps for business. You\u2019ve already purchased licenses, so you go to <code>https://admin.cloud.microsoft</code>. Which of the following isn\u2019t required?",
    "choice_a": "Downloading Office 365",
    "choice_b": "Adding the user\u2019s email address",
    "choice_c": "Assigning a license to the user",
    "choice_d": "Sending the user their credentials",
    "correct_answer": "A",
    "explanation": "When giving new users access to Microsoft 365 apps for business, you will go to your admin account and choose Go to setup, which starts a wizard. You don\u2019t need to download and install Microsoft 365 at this time. Instead, go to the next screen and add users. They will automatically be assigned one of your licenses. Then you have an option to print, email, or download the user\u2019s credentials. The user can then download and install Microsoft 365 on as many as five devices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      15,
      16,
      12,
      34
    ],
    "source": "9781394330348"
  },
  {
    "id": 812,
    "question": "A client has a Windows 11 Home computer with a virus on it. They have quarantined the system from the rest of their network. To follow malware removal best practices, what should be done next?",
    "choice_a": "Investigate and verify malware symptoms.",
    "choice_b": "Disable System Restore in Windows Home.",
    "choice_c": "Enable System Restore and create a restore point in Windows.",
    "choice_d": "Update anti-malware software.",
    "correct_answer": "B",
    "explanation": "CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      217,
      220,
      173,
      138,
      153
    ],
    "source": "9781394330348"
  },
  {
    "id": 813,
    "question": "Someone has configured an external server with an IP address that should belong to one of your sister company\u2019s servers. With this new computer, they are attempting to establish a connection to your internal network. What type of attack is this?",
    "choice_a": "Spoofing",
    "choice_b": "On-path attack",
    "choice_c": "Zombie/botnet",
    "choice_d": "Non-compliant system",
    "correct_answer": "A",
    "explanation": "A spoofing attack is an attempt by someone to make something masquerade as something else. This type of attack is usually considered an access attack. The most popular spoofing attacks today are Internet Protocol (IP) spoofing, Address Resolution Protocol (ARP) spoofing, and Domain Name System (DNS) spoofing. This is an example of IP spoofing, where the goal is to make the data look as if it came from a trusted host when it didn\u2019t (thus spoofing the IP address of the sending host). On-path attacks occur when your data transmissions are intercepted enroute, then forwarded on to their destination, sometimes with changes, sometimes without. Zombie and botnet are attacks when the user of the computer doesn\u2019t know there is malware on their computer. Their computer is a zombie, and when many zombies are used to attack a system, it\u2019s known as a botnet attack. A non-compliant system is one that is not following best practices such as keeping the operating system (OS) and anti-malware updated and firewall enabled.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      147,
      149,
      151,
      131,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 814,
    "question": "Which of the following options best describes the type of security device that often incorporates RFID technology to grant personnel access to secure areas or resources?",
    "choice_a": "Smart card",
    "choice_b": "Security token",
    "choice_c": "Access control vestibule",
    "choice_d": "Key fob",
    "correct_answer": "A",
    "explanation": "A smart card is a type of badge or card that gives the holder access to resources, including buildings, parking lots, and computers. It contains information about your identity and access privileges. Each area or computer has either a card scanner that uses Radio Frequency Identification (RFID), or a reader in which you insert your card. A security token is something you have that is used to verify your identity; it can be a software or hardware token. A smart card is a type of hardware security token. An access control vestibule is used to prevent tailgating. It is an area between two doors, often with a security camera and possibly a security guard, where people are held until their identity is verified and access is granted. The second door grants access to a secure area. A key fob is a small device used in multifactor identification. It can generate a number or have software on it that is read to gain access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      108,
      121,
      120,
      115
    ],
    "source": "9781394330348"
  },
  {
    "id": 815,
    "question": "You are configuring a wireless network for a small office. What should you enable for the best encryption possible for network transmissions?",
    "choice_a": "WPS",
    "choice_b": "WEP",
    "choice_c": "WPA",
    "choice_d": "WPA3",
    "correct_answer": "D",
    "explanation": "There are four wireless encryption methods available for Wi-Fi networks. From least to most secure, they are Wired Equivalent Privacy (WEP), Wi-Fi Protected Access (WPA), and two newer versions of WPA called WPA2 and WPA3. WPA3 is the latest and the most secure and should be used unless strange circumstances prevent you from doing so. Wi-Fi Protected Setup (WPS) is an easy way to configure Wi-Fi for devices like printers, where a number would be generated on a printer, for example, and the number would need to be entered on the access point, or vice versa. WPS has security flaws and is not listed in the CompTIA A+ exam objectives.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      180,
      182,
      186,
      183,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 816,
    "question": "You are working in a company with a domain. An employee received a new position in the company and will be relocating from the Miami, Florida, office to the Paris, France, office. What will be the result when you move them from the Miami OU to the Paris OU?",
    "choice_a": "Their rights will stay the same, but permissions will change.",
    "choice_b": "Their group policies and security settings will remain the same as at the Miami OU.",
    "choice_c": "They will inherit group policies and security settings from the Paris OU.",
    "choice_d": "You will need to create a new OU for moved employees.",
    "correct_answer": "C",
    "explanation": "When an object is moved from one Organizational Unit (OU) to another, the object inherits the group policies and security settings of the new OU. Their rights, permissions, and group policies probably won\u2019t remain the same, unless the two OUs have the same settings. There is no need to create a new OU for moved employees.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      126,
      168,
      170,
      117,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 817,
    "question": "Which types of security threats involve the attacker attempting to directly contact a potential victim? (Choose two.)",
    "choice_a": "Spoofing",
    "choice_b": "Phishing",
    "choice_c": "Social engineering",
    "choice_d": "Brute-force attacking",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Social engineering is a process in which an attacker attempts to acquire information about your network and system by social means, such as talking to people in the organization, shoulder surfing, tailgating, or other methods. When this is done via email or instant messaging, it\u2019s called phishing or smishing. Spoofing involves pretending to be a trusted resource, for example, by using a trusted resource\u2019s Internet Protocol (IP) address to gain access to something else. A brute-force attack usually involves software that keeps trying passwords or codes until it hits upon the right one to gain access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      142,
      147,
      143,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 818,
    "question": "An employee uses their security badge to enter the building through a secured door. Another person tries to enter the building behind them before the door closes, without swiping a badge. What type of behavior is the second person demonstrating?",
    "choice_a": "Shoulder surfing",
    "choice_b": "On-path attack",
    "choice_c": "Brute-force",
    "choice_d": "Tailgating",
    "correct_answer": "D",
    "explanation": "Tailgating refers to being so close to someone when they enter a building that you can come in right behind them, without needing to use a key, a card, or any other security device. Using an access control vestibule, which is a small room that limits access to one or a few individuals, is a great way to stop tailgating. Revolving doors can also help prevent tailgating. Shoulder surfing is walking behind someone hoping to see passwords or other security information they may be entering. Privacy screens and physical barriers can help prevent shoulder surfing. On-path attacks occur when data transmissions are intercepted by someone enroute, then forwarded on to their destination, sometimes with changes, sometimes without. A brute-force attack involves software that keeps trying passwords or codes until it hits upon the right one to gain access.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      143,
      108,
      141,
      120,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 819,
    "question": "You have a Windows domain network and want to ensure that users are forced to meet password complexity requirements. What is the best way to implement this on the network?",
    "choice_a": "Use a firewall.",
    "choice_b": "Use a VPN.",
    "choice_c": "Use a GPO.",
    "choice_d": "Use DLP processes.",
    "correct_answer": "C",
    "explanation": "In a Windows Active Directory (i.e., domain), password policies can be configured at the domain level using Group Policy Objects (GPOs). There are hundreds of variables that can be configured. Variables that can be configured relating to passwords include password complexity and length and the time between allowed changes to passwords. A firewall can be configured to block certain types of traffic based on things like IP address, protocol, or a Media Access Control (MAC) address. A virtual private network (VPN) is a secure path between a local and remote device. Data Loss Prevention (DLP) is the process of monitoring and identifying sensitive data to make sure it is only accessed by authorized persons.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      125,
      158,
      157,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 820,
    "question": "You are planning security protocols for your company\u2019s new server room. What is the simplest way to keep potential attackers physically away from your servers?",
    "choice_a": "Lock the door.",
    "choice_b": "Use cable locks.",
    "choice_c": "Install an access control vestibule.",
    "choice_d": "Implement biometrics.",
    "correct_answer": "A",
    "explanation": "Sometimes, the obvious solutions are the best ones! A key aspect of access control involves physical barriers. One of the easiest ways to prevent those intent on creating problems from physically entering your environment is to lock your doors and keep them out. Cable locks are used to secure mobile devices like laptops to a table or fixed device so they can\u2019t be carried away. An access control vestibule is a small room between two doors, where the secure access area is beyond the second door, and biometrics uses a part of the body to identify a person.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      111,
      108,
      113,
      115,
      114
    ],
    "source": "9781394330348"
  },
  {
    "id": 821,
    "question": "A user on your network reported that their screen went blank and a message popped up. It\u2019s telling them that their files are no longer accessible, and if they want them back, they need to enter a credit card number and pay a $2,000 fee. Which type of malware has infected this system?",
    "choice_a": "Rootkit",
    "choice_b": "Ransomware",
    "choice_c": "Trojan",
    "choice_d": "Spyware",
    "correct_answer": "B",
    "explanation": "Ransomware is software, often delivered through a Trojan, that takes control of a system and demands that a third party be paid. The \u201ccontrol\u201d can be accomplished by encrypting the hard drive, by changing user password information, or via any of several other creative ways. Users are usually assured that by paying the extortion amount (i.e., the ransom), they will be given the code needed to revert their systems to normal operations. Even among malware, ransomware is particularly nasty. A rootkit is software that gains access to a system as administrator, giving it full control over a system. Rootkits are adept at hiding their presence and are difficult to eradicate. A Trojan is named after the Trojan horse of Greek mythology. Trojans are malicious software that hide in that fun game or screensaver that you just downloaded, and it installs when you install the innocent-looking files. Trojans often install a backdoor that a malicious actor can use later to access the infected system. Spyware is designed to watch what you do and where you go, hoping to gain information such as logins, passwords, and bank account numbers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      129,
      128,
      132,
      135
    ],
    "source": "9781394330348"
  },
  {
    "id": 822,
    "question": "You are setting up a new wireless SOHO router. Which of the following should you change immediately when initially configuring the network? (Choose two.)",
    "choice_a": "The router\u2019s default administrator username and password",
    "choice_b": "The default SSID",
    "choice_c": "The radio power level",
    "choice_d": "The guest account password",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When configuring a new small office/home office (SOHO) or any other wireless router, always change the default administrator username and password first. This prevents would-be hackers from having easy access to the router. Then change the default service set identifier (SSID). These default values can easily be found online and not changing them immediately makes your router vulnerable to attack. The radio power level might be changed later if you discover the signal is too weak or too strong. There is no actual guest account on a router.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      186,
      182,
      184,
      158,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 823,
    "question": "You are configuring a router for a small office network. The network users should be able to access regular and secure websites and send and receive email. Those are the only connections allowed to the Internet. Which security feature should you configure to prevent additional traffic from coming through the router?",
    "choice_a": "MAC filtering",
    "choice_b": "Content filtering",
    "choice_c": "Port forwarding/mapping",
    "choice_d": "Port security/disabling unused ports",
    "correct_answer": "D",
    "explanation": "Port security involves disabling all unneeded protocols and ports. In this case, ports 80 and 443 are needed for Hypertext Transfer Protocol (HTTP) and HTTP Secure (HTTPS) access, and ports 25, 110, 143, 465, or 587 may be needed for email. That\u2019s it. If you don\u2019t need them, remove the additional protocols, software, or services, or prevent them (i.e., disable them, or block them, as the setting is typically called on a router) from loading. Ports left open but not in use present an open door for an attacker to enter. Media Access Control (MAC) filtering is an option on most routers that will only allow devices with specific MAC addresses to access the router. Content filtering blocks undesirable traffic, such as social media or hate sites on a corporate network. Port forwarding/mapping will send all traffic that comes in on a specified port number to a specific node on the network.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      187,
      119,
      117,
      128,
      140
    ],
    "source": "9781394330348"
  },
  {
    "id": 824,
    "question": "On a Windows workstation, there are two NTFS volumes. The Managers group has Modify access to the <code>D:\\mgmt</code> directory. You move the folder to the <code>D:\\keyfiles</code> folder, to which the Managers group has Read access. What level of permissions will the Managers group have to the new <code>D:\\keyfiles\\mgmt</code> directory?",
    "choice_a": "Full Control",
    "choice_b": "Modify",
    "choice_c": "Read & Execute",
    "choice_d": "Read",
    "correct_answer": "B",
    "explanation": "When you move a file or folder on the same New Technology File System (NTFS) volume, in this case the <code>D:\\</code> drive, it will keep its original permissions. If you copy it or move it to a different volume, it will inherit permissions from its new parent directory.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      171,
      200,
      160,
      117,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 825,
    "question": "For users to log on to your network from a remote location, they are required to supply a username and password as well as a code from an RSA token. What type of security is being used?",
    "choice_a": "Firewall",
    "choice_b": "Multifactor authentication",
    "choice_c": "Access control list",
    "choice_d": "Principle of least privilege",
    "correct_answer": "B",
    "explanation": "When users log on to a computer or network, they are generally required to provide credentials such as a username and password. In multifactor authentication (MFA), the user is required to provide two or more factors proving who they are. These items are generally from two of four categories: Something they know, such as a password, something they have, such as a code from a security token, something they are, such as a fingerprint or palmprint scan), or somewhere they are based on global positioning system (GPS) location or Wi-Fi and cell tower triangulation. A firewall is a software or hardware device that will block traffic into or out of a network based on parameters that the administrator specifies. An access control list (ACL) exists for each resource. It defines who has what level of access to that resource. The principle of least privilege states that you give a user only enough access to do what they need to do their job and nothing more.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      121,
      120,
      119,
      117,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 826,
    "question": "You want to recycle some hard drives that your company no longer uses, but you need to ensure that other people will not be able to access the data. Which methods of removing the data are acceptable for your purposes? (Choose two.)",
    "choice_a": "Formatting the drive.",
    "choice_b": "Using an overwrite utility.",
    "choice_c": "Using a drive erasing\\wiping utility.",
    "choice_d": "Using electromagnetic fields.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The best methods for destroying sensitive data without destroying the drive are using either overwrite or drive wipe programs. Overwriting the drive entails copying over the data with new data. A common practice is to replace the data with 0s. Drive wipes do a similar thing. Formatting the drive does not guarantee that others can\u2019t read the data. Using electromagnetic fields (or degaussing) isn\u2019t reliable and can damage the hard drive, and it won\u2019t work at all on solid-state drives (SSDs).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      164,
      174,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 827,
    "question": "Your department is taking steps to create a system that will monitor computers, smartphones, servers, and any other company devices that interact with the outside world for potential malware attacks. When an attack is discovered, the system will automatically launch countermeasures to protect company data and endpoints, and monitor, report on, and mitigate the spread of potential problems.What type of system are you deploying?",
    "choice_a": "MDR",
    "choice_b": "EDR",
    "choice_c": "DDoS",
    "choice_d": "PUP",
    "correct_answer": "B",
    "explanation": "Endpoint detection and response (EDR) monitors network endpoints continuously in an attempt to recognize, remediate, and prevent spread of any malware or data loss in a system. They also provide reporting capabilities. Managed EDR (MDR) is EDR managed by a third party. Distributed denial-of-service (DDoS) is an attack performed by many computers to keep legitimate traffic from reaching a server. A potentially unwanted program (PUP) is often installed with other legitimate software and although it can launch any malware, it generally is used for browser redirection and adware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      194,
      132,
      144,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 828,
    "question": "You have installed Windows 11 Pro on a workstation. For better security, which user account should you ensure is disabled?",
    "choice_a": "Administrator",
    "choice_b": "DefaultAccount",
    "choice_c": "Power User",
    "choice_d": "Guest",
    "correct_answer": "D",
    "explanation": "When Windows is installed, one of the default accounts it creates in local users and groups is Guest, and this represents a weakness that can be exploited by an attacker. While the account cannot do much, it can provide initial access to a system, and the attacker can use that to find another account or acquire sensitive information about the system. To secure the system, disable all accounts that are not needed, especially the Guest account, which is disabled by default, although verifying this should be a part of your security plan. The Administrator account should be renamed. If a hacker knows a valid username, then they are halfway into your system. The DefaultAccount is an account that is managed by the system and is disabled by default. Power User is not an account that is installed with Windows 11, however, there is a Power Users group that is kept for backward compatibility.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      160,
      167,
      117,
      152,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 829,
    "question": "Which type of network attack involves an intermediary hardware device intercepting data and altering it, or transmitting it to an unauthorized user?",
    "choice_a": "On-path attack",
    "choice_b": "Non-compliant system",
    "choice_c": "Zombie/botnet",
    "choice_d": "Spoofing",
    "correct_answer": "A",
    "explanation": "On-path attacks clandestinely place something (such as a piece of software or a rogue router) between a server and the user, and neither the server\u2019s administrator nor the user is aware of it. The on-path attack intercepts data, then sends the information to the server as if nothing is wrong. The on-path attack software may be recording information for someone to view later, altering it, or in some other way compromising the security of your system and session. A non-compliant system is one that is not in line with acceptable security policies and procedures. Zombie and botnet are attacks where the user of the computer doesn\u2019t know there is malware on their computer. Their computer is a zombie, and when many zombies are used to attack a system, it\u2019s known as a botnet attack. Spoofing occurs when another system pretends or appears to be a trusted system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      149,
      147,
      145,
      131,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 830,
    "question": "You are implementing new password policies for your network, and you want to follow guidelines for password best practices. Which of the following will best help improve the security of your network? (Choose two.)",
    "choice_a": "Force passwords to expire every 180 days.",
    "choice_b": "Require passwords to be a minimum of eight characters.",
    "choice_c": "Encourage users to use passphrases.",
    "choice_d": "Restrict passwords to be no more than 10 characters long.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Setting strong passwords is critical to network security. They should be as long as possible, with a maximum of 64 characters. Eight characters is the minimum for standard users, but in secure environments or for privileged user accounts the minimum required should be 15 characters. Passphrases, such as a line from a favorite poem, are longer than the eight character minimum, but easier for the user to remember. Password complexity means using a combination of uppercase and lowercase letters, a number, and a special character such as #, @, &, or others. It\u2019s important to note that just before release of the exam, the National Institute of Standards and Technology (NIST), which makes recommendations for computer security in the United States of America, had dropped the recommendation for enforcing password complexity and password expiration. They are mentioned here because they are included in the CompTIA objectives for the 220\u20131202 exam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      158,
      148,
      161,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 831,
    "question": "What does NTFS use to track users and groups and their level of access to resources?",
    "choice_a": "ACLs",
    "choice_b": "Tokens",
    "choice_c": "Badges",
    "choice_d": "Control rosters",
    "correct_answer": "A",
    "explanation": "With New Technology File System (NTFS), each file, directory, and volume can have its own security. NTFS tracks security in access control lists (ACLs) for each resource. The ACL will contain the user or group name and the level of access they have been granted. The basic permissions to choose from are Full Control, Modify, Read & execute, List Folder Contents, Read, and Write. There are also special permissions and settings that can be applied. A token is software or hardware that is used in multifactor authentication (MFA) and falls under the category of something that a user has. Badges may use radio frequency identification (RFID) or other technology that is read to allow physical entry to a secure area. Control rosters are used in areas that have security guards and contain a list of people who are allowed to enter.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      171,
      200,
      126,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 832,
    "question": "You have created a user account for a contract employee on a Windows 11 PC. The contractor will be with the company for one month. Which user group should this user\u2019s account be placed in?",
    "choice_a": "Power Users",
    "choice_b": "Administrators",
    "choice_c": "Standard Users",
    "choice_d": "Guest",
    "correct_answer": "D",
    "explanation": "The Guest account is created and disabled by default (and should remain disabled) and is a member of the Guests group. For the most part, members of Guests have the same rights as Users, except they can\u2019t get to log files. The best reason to make users members of the Guests group is to access the system only for a limited time. Although there is a Standard User account type, there is no group named Standard Users by default. There are groups created automatically called Users, Administrators, Power Users, Guests, and a few others. The Power Users group is kept for backward compatibility, but they are the same as someone in the Users group. Administrators have complete control over the systems that they are an administrator on.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      117,
      160,
      126,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 833,
    "question": "On your network, there are multiple systems that users need to access, such as domain resources, a cloud site for storage, and order processing software. You want to configure the network such that users do not need to remember separate usernames or passwords for each site; their login credentials will be good for different systems. Which technology should you use?",
    "choice_a": "EFS",
    "choice_b": "MDM",
    "choice_c": "SSO",
    "choice_d": "UAC",
    "correct_answer": "C",
    "explanation": "One of the big problems larger networks must deal with is the need for users to access multiple systems or applications. This may require a user to remember multiple accounts and passwords. The purpose of single sign-on (SSO) is to give users access to all the applications and systems that they need when they log on. Some systems may require users to enter their credentials again, but the username and password will be consistent between systems. SSO is often configured as a part of the network\u2019s directory services. Encrypting file system (EFS) is used to encrypt volumes, files, and folders in Windows OSs. Mobile device management (MDM) enables an IT department to retain some control, even though an organization may allow users to bring your own devices (BYOD) to the workplace. User account control (UAC) requires entering an administrator password to verify that the person has the authority to change a Windows system before allowing them to make any changes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      169,
      168,
      126,
      170,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 834,
    "question": "A user discovers a strange text file at the root of their user directory. It contains everything they have typed over the past few days, including their credentials. What is the likely cause of the text file?",
    "choice_a": "System auditing enabled",
    "choice_b": "Keylogger installed",
    "choice_c": "Email application in debug mode",
    "choice_d": "Backup file",
    "correct_answer": "B",
    "explanation": "A keylogger seems to be running on the system, monitoring and copying all that is typed on the keyboard. Obviously, this malware needs to be removed and incident response steps taken. The other three options would not cause the symptoms stated.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      209,
      217,
      128,
      134,
      220
    ],
    "source": "9781394330348"
  },
  {
    "id": 835,
    "question": "What security solution would protect a user from unwanted network traffic probing their workstation?",
    "choice_a": "Software firewall",
    "choice_b": "Anti-phishing training",
    "choice_c": "Anti-malware",
    "choice_d": "Antivirus",
    "correct_answer": "A",
    "explanation": "A software-based firewall on the workstation would be able to stop unwanted network traffic, including port scans and probes. Anti-phishing training teaches users to avoid malicious emails. Anti-malware and antivirus are software designed to recognize and quarantine or eradicate malicious code. Viruses are a subset of malware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      173,
      128,
      187,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 836,
    "question": "The user wants to use MFA on their PC but does not want to carry a key fob and is strongly against biometrics. What method can you suggest?",
    "choice_a": "Second password",
    "choice_b": "Hardware token",
    "choice_c": "Software token",
    "choice_d": "Fingerprint reader",
    "correct_answer": "C",
    "explanation": "The software token is stored on a general-purpose device, such as a PC or smartphone. The hardware token option would involve carrying an added key fob or device. A fingerprint reader would be unacceptable as it involves biometrics. A second password defeats the benefit of using multifactor authentication (MFA).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      121,
      113,
      115,
      169,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 837,
    "question": "What wireless protocol used in WPA compensated for the weak encryption of WEP?",
    "choice_a": "VLAN",
    "choice_b": "TKIP",
    "choice_c": "VPN",
    "choice_d": "AES",
    "correct_answer": "B",
    "explanation": "Temporal key integrity protocol (TKIP) is an encryption protocol, used in Wi-Fi protected access (WPA) for wireless connections. It was intended to replace the weak encryption of wired equivalent privacy (WEP) by creating a unique key for each data frame. It has since been subject to wireless attacks and is deprecated. A virtual LAN (VLAN) occurs when devices from multiple local area networks (LANs) are joined together virtually and can act as if on the same physical network even though they are not, while a virtual private network (VPN) is similar because it creates a private tunnel through a public network using encryption protocols. A VPN might be used by someone working remotely to access a corporate server. Advanced encryption standard (AES) is the successor to TKIP and is used in WPA2 along with TKIP for backward compatibility; however, AES is also vulnerable to certain attacks. WPA3 uses the simultaneous authentication of equals (SAE) protocol on networks, and the opportunistic wireless encryption (OWE) protocol on open networks. Although WPA3 is most secure, its adoption has been slow due to compatibility issues and vulnerabilities (leaked passwords) that have been discovered. Most routers offer WPA2/WPA3 mixed mode, which can be used until all devices are updated to WPA3. Despite its vulnerabilities, WPA3 is the most secure of these standards.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      180,
      183,
      145,
      184,
      182
    ],
    "source": "9781394330348"
  },
  {
    "id": 838,
    "question": "Which of the following Active Directory concepts can help enforce security settings? (Choose two.)",
    "choice_a": "EFS",
    "choice_b": "Group policy/updates",
    "choice_c": "Disabling unused ports",
    "choice_d": "Assigning login scripts",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Group policy/updates and assigning login scripts are common ways to push and enforce security settings on Active Directory objects. Encrypting file system (EFS) is used to encrypt volumes, files, and folders. Disabling unused ports is an important part of device/network hardening and is performed on a firewall, which may be a service of a router or a separate firewall device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      125,
      158,
      170,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 839,
    "question": "What 128-bit block encryption that uses an encryption key of 128, 192, or 256 bits is used in WPA2 and is more secure than TKIP?",
    "choice_a": "AES",
    "choice_b": "VPN",
    "choice_c": "RADIUS",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "Advanced encryption standard (AES) is used in Wi-Fi protected access, version 2 (WPA2). A virtual private network (VPN) is a connection that transmits data across a public network using encryption. Remote authentication dial-in user service (RADIUS) and Kerberos are both authentication protocols.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      180,
      183,
      184,
      156,
      193
    ],
    "source": "9781394330348"
  },
  {
    "id": 840,
    "question": "What protocol was originally designed to authenticate remote users to a dial-in access server?",
    "choice_a": "TKIP",
    "choice_b": "TACACS+",
    "choice_c": "VPN",
    "choice_d": "RADIUS",
    "correct_answer": "D",
    "explanation": "Remote authentication dial-in user service (RADIUS) was originally designed to authenticate remote users to a dial-in access server but is now used in several authentication situations. Temporal key integrity protocol (TKIP) is a wireless encryption protocol used in Wi-Fi protected access (WPA), which made WPA more robust/secure than wired equivalent privacy (WEP). Terminal access controller access-control system (TACACS+) is an authentication protocol for centralized authentication, and a virtual private network (VPN) uses encryption to create a private connection using a public network.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      183,
      180,
      118,
      122,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 841,
    "question": "A user is complaining that they can no longer sign in to their account because of too many bad login attempts. What basic directory services security function is at work here?",
    "choice_a": "Failed login attempts restrictions",
    "choice_b": "Antivirus/anti-malware",
    "choice_c": "A bollard",
    "choice_d": "A rootkit",
    "correct_answer": "A",
    "explanation": "By using directory services, like Active Directory settings or the Local Group Policy Editor, you can restrict the number of failed log-in attempts before the user is locked out of their account. This is important to help prevent a brute-force attack, which attempts to guess passwords until it hits upon the right one. Antivirus/anti-malware is important to have installed and identifies malicious software based on its signature code but is not at work here. A bollard is a physical post intended to block vehicular traffic, and a rootkit is a particularly difficult malware to eradicate, because it is working with administrator rights and it\u2019s good at hiding in a system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      126,
      125,
      148,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 842,
    "question": "What concept in Active Directory creates a directory subdivision within which may be placed users, groups, computers, and other objects to which the same group policies will be applied?",
    "choice_a": "User",
    "choice_b": "Domain",
    "choice_c": "Organizational unit",
    "choice_d": "Home folder",
    "correct_answer": "C",
    "explanation": "The organizational unit (OU) is a subdivision within which users, groups, more OUs, and other objects can be placed. The OU exists on a domain, which is a group of users and resources under a single administrative control. Windows domains are managed by software called an Active Directory, which is organized into organizational units, usually for security purposes. A home directory is where an individual user stores their documents and such, and in a Windows domain, that location is usually on the Domain Controller or another server.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      126,
      117,
      171,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 843,
    "question": "A technician is troubleshooting a Windows 10 computer that is acting strangely, and they suspect that it is infected with a virus. They have followed the best practices for malware removal and remediated the computer. What should they do next?",
    "choice_a": "Schedule scans and run updates.",
    "choice_b": "Educate the end user.",
    "choice_c": "Enable System Restore and create a restore point.",
    "choice_d": "Disable System Restore in Windows.",
    "correct_answer": "A",
    "explanation": "CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      220,
      217,
      138,
      139,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 844,
    "question": "Your data center recently experienced the theft of a server from its rack. Which security mechanisms would protect servers from future theft? (Choose two.)",
    "choice_a": "Equipment lock",
    "choice_b": "Security token",
    "choice_c": "Door lock",
    "choice_d": "External hardware token",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "An equipment lock and door lock would slow down a would-be thief. A security token is involved in multifactor authentication (MFA) and an external hardware token is one of two types of security tokens, the other being a software token.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      111,
      190,
      121,
      112,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 845,
    "question": "What other security devices are often employed in an access control vestibule? (Choose two.)",
    "choice_a": "Bollard",
    "choice_b": "Motion sensors",
    "choice_c": "Security guards",
    "choice_d": "Video surveillance",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Often an access control vestibule will have either a security guard, or video surveillance, or both. Once in the vestibule, the second door could be opened remotely by someone watching through the surveillance camera, or by a guard who personally clears the person trying to gain access. A bollard is a post used to block vehicular traffic. A motion sensor detects movement and is often used to trigger an alarm, turn on a light, turn on a camera, or a combination of those.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      113,
      111,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 846,
    "question": "Normally, your company places users\u2019 profiles and folders on the local machine. Now, the organization would like users to be able to log in from other computers. What concept in Active Directory allows a user\u2019s profile folders to be placed in storage somewhere else on the network?",
    "choice_a": "Home folder",
    "choice_b": "Folder redirection",
    "choice_c": "Organizational unit",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "Folder redirection allows users\u2019 profile folders to be stored in a more centralized location on the network, instead of on the local machine. A profile stored this way is called a roaming profile. The home folder is the specific location where a user\u2019s documents and such are stored. An organization unit (OU) is a management tool that can be used to organize Active Directory (AD) resources and can contain users, computers, and other resources. A virtual private network (VPN) is created across a public network by using strong encryption protocols.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      126,
      125,
      124,
      171,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 847,
    "question": "What wireless encryption protocol uses both TKIP for backward compatibility and AES, and replaced WPA?",
    "choice_a": "WEP",
    "choice_b": "WPA2",
    "choice_c": "WPA3",
    "choice_d": "RADIUS",
    "correct_answer": "B",
    "explanation": "Wi-Fi protected access, version 2 (WPA2) replaced Wi-Fi protected access (WPA), which had replaced wired equivalency protocol (WEP). WEP was the first wireless security protocol. WPA was developed next and used temporal key integrity protocol (TKIP) for encryption. WPA2 uses TKIP for backward compatibility and the more secure advanced encryption standard (AES). Wi-Fi protected access, version 3 (WPA3) was released in 2018 to replace WPA2, whose security had been broken. WPA3 also includes better security for the proliferation of Internet of Things (IoT) devices. WPA, WPA2, and WPA3 all have personal and enterprise options, and all have been proven to have vulnerabilities, but WPA3 is the most secure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      180,
      181,
      182,
      186,
      199
    ],
    "source": "9781394330348"
  },
  {
    "id": 848,
    "question": "When should OS and application patches be applied to a system to avoid an unpatched system vulnerability?",
    "choice_a": "Every 6 months",
    "choice_b": "Every 3 months",
    "choice_c": "Once a month",
    "choice_d": "As soon as they are available",
    "correct_answer": "D",
    "explanation": "Operating system (OS) and application patches may fix vulnerabilities in the software and should be applied as soon as possible after they are released. In a corporate environment, it would be best to test them in a sandbox first to avoid any problems. In a Windows PC\u2019s settings, Windows Updates manages the process for you.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      153,
      152,
      154,
      220,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 849,
    "question": "What do security groups manage in a Windows Active Directory environment? (Choose two.)",
    "choice_a": "Permissions to access file servers",
    "choice_b": "Applying group policies",
    "choice_c": "Access to resources",
    "choice_d": "Updating OS on client computers",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Security groups in Windows Active Directory (AD) are similar to groups in a workstation; they are used to group objects (i.e., users, computers, etc.) together that need the same permissions (i.e., the same access to resources). For example, if I belong to the accounting clerk group, I will have access to the accounting folders but not the production folders. Conversely, organizational units (OUs) are used mainly for applying group policies. You would likely use an OU to apply updates to client computers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      125,
      171,
      117,
      200
    ],
    "source": "9781394330348"
  },
  {
    "id": 850,
    "question": "You need to join a new Windows 11 workstation to your company\u2019s domain. What utility will you access to do this?",
    "choice_a": "Administrative Tools",
    "choice_b": "System",
    "choice_c": "Computer Management",
    "choice_d": "System Information",
    "correct_answer": "B",
    "explanation": "To log in to a domain instead of a workgroup, you can either right-click the Windows icon on the taskbar and choose System or go into the Control Panel and choose System. Both take you to the System screen in Settings. From there, choose Domain or Workgroup, and click on change. Windows 10 Administrative tools has been renamed Windows tools in Windows 11, and it won\u2019t take you to the screen you need. Computer management is for managing drives and volumes. System information tells you about the hardware, software, and users in a system, but it doesn\u2019t provide a way to change anything.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      125,
      168,
      166,
      126,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 851,
    "question": "Which of the following are examples of physical security methods? (Choose two.)",
    "choice_a": "Access control vestibule",
    "choice_b": "Multifactor authentication",
    "choice_c": "Keys",
    "choice_d": "Firewalls",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "An access control vestibule is a holding area between two doors that often uses video surveillance and has a security guard that will grant or deny physical access to an area. They may employ other means of authentication as well and are considered physical security, as are simple door keys. Multifactor authentication (MFA) is security that requires identification and two or more methods of authentication, such as a password and key fob. Authentication can be verified by something you know (e.g., passwords), something you have (e.g., key fob, smart card, etc.), something you are (e.g., fingerprint, palmprint, retina scan), or somewhere you are (e.g., using Global Positioning System [GPS] position or Wi-Fi network and cell tower triangulation). Firewalls are logical security devices that filter incoming and outgoing packets to allow or reject them based on criteria you choose.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      108,
      113,
      111,
      109,
      115
    ],
    "source": "9781394330348"
  },
  {
    "id": 852,
    "question": "A user on your network reported that they received a phone call from someone in the IT department saying the user needed to reset their password. The caller offered to do it for them if the user could provide the IT worker with their current password. What is this most likely an example of?",
    "choice_a": "The IT department helping the user to reset their password",
    "choice_b": "A spoofing attack",
    "choice_c": "A social engineering attack",
    "choice_d": "A brute-force attack",
    "correct_answer": "C",
    "explanation": "A person in the IT department is not likely to ask for your password. If they want you to reset it, they can use software to reset it, which will make you choose a new password on next login. This is a social engineering attack. Social engineering means using kindness, coercion, or fear to get you to give up privileged information like your password. Spoofing is when a website or server, for example, is made to look like a trusted one, but in reality, there is an attacker lurking there. A brute-force attack uses software to repeatedly try different passwords to break into a system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      139,
      142,
      143,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 853,
    "question": "Your corporate IT department has decided that, to enhance security, they will draft an MDM policy to require both a password and a fingerprint scan to unlock a mobile device for use. Which of the following is this not an example of?",
    "choice_a": "An authenticator application",
    "choice_b": "Biometric authentication",
    "choice_c": "Device hardening",
    "choice_d": "Multifactor authentication",
    "correct_answer": "A",
    "explanation": "Authenticator apps run on devices like smartphones or PCs and provide a unique key that changes every few seconds. An authenticator app can be a part of multifactor authentication (MFA) and device hardening but is not described in the question. A fingerprint scan is a type of biometric authentication. Device hardening means taking steps to protect devices and the data on them from attack. Anytime there is more than one authentication method required, it\u2019s MFA. In this case, it does involve using biometrics, but the password is not a biometric factor. MFA requires two or more of the following four types of inputs: something you know (e.g., password), something you have (e.g., token), something you are (e.g., biometrics), or somewhere you are (i.e., Global Positioning System [GPS] or other location services).",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      121,
      120,
      115,
      124,
      198
    ],
    "source": "9781394330348"
  },
  {
    "id": 854,
    "question": "Several employees at your company have been tailgating to gain access to secure areas. Which of the following security methods is the best choice for stopping this practice?",
    "choice_a": "Door lock",
    "choice_b": "Entry control roster",
    "choice_c": "Access control vestibule",
    "choice_d": "ID badges",
    "correct_answer": "C",
    "explanation": "Tailgating refers to being so close to someone when they enter a building that you can come in right behind them without needing to use a key, a card, or any other security device. Using an access control vestibule, which is a device such as a small room that limits access to one or a few individuals, is a great way to stop tailgating. With a door lock or ID badge, the tailgaters could still follow the other employee in. An entry control roster is merely a list of people who are allowed access to an area and isn\u2019t much use without a guard to check it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      143,
      113,
      112,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 855,
    "question": "A user has joined your company as a network administrator. Assume their user account name is <code>AOShea</code>. What is the recommended way to give <code>AOShea</code> the administrative privileges they need?",
    "choice_a": "Add the <code>AOShea</code> user account to the Administrators group.",
    "choice_b": "Create an account called <code>AdminAOShea</code>. Add that account to the Administrators group. Have the new administrator use the <code>AOShea</code> account unless they need administrative rights, in which case they should use the <code>AdminAOShea</code> account.",
    "choice_c": "Copy the Administrator account and rename it <code>AOShea</code>.",
    "choice_d": "Add the <code>AOShea</code> user account to the Power Users group.",
    "correct_answer": "B",
    "explanation": "Adding <code>AOShea</code> to the Administrators group will certainly work, but it\u2019s not the recommended approach. Because members of the Administrators group have such power, they can inadvertently do harm, for example, accidentally deleting a file that a standard user could not. To protect against this, the practice of logging in with an Administrators group account for daily interaction is strongly discouraged. Instead, system administrators should log in with a user account with lesser privileges and change to the Administrators group account with elevated privileges only when necessary. The original Administrator account shouldn\u2019t be renamed to this user, because there is usually more than one administrator. The Power User\u2019s group is only kept for backward compatibility.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      170,
      167,
      123,
      117,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 856,
    "question": "You are designing a security policy for laptops on your network. Which of the following is a common method of biometric authentication used with laptops and other mobile devices?",
    "choice_a": "Fingerprint scan",
    "choice_b": "Retina scan",
    "choice_c": "Swipe lock",
    "choice_d": "DNA lock",
    "correct_answer": "A",
    "explanation": "Biometric authentication requires identification of a physical feature of the user, such as a fingerprint or palmprint. Laptops and other mobile devices commonly use your fingerprint to prove who you are. Most modern laptops can also use a facial scan to identify you. DNA and retina scanners are considered a form of biometric authentication, but they are not commonly used today with mobile devices. (Imagine your phone needing to collect blood or saliva to authenticate you\u2014no thanks!) DNA isn\u2019t on the CompTIA A+ objectives yet, but facial recognition, retina scanners, and fingerprint and palm print scanners are. A swipe lock is not a type of biometrics. It\u2019s also not secure!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      115,
      169,
      120,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 857,
    "question": "An administrator is transferring confidential files from one Windows Pro workstation to another using a flash drive. Policy dictates that the files on the flash drive must be encrypted. Which technology should be used?",
    "choice_a": "BitLocker",
    "choice_b": "BitLocker-To-Go",
    "choice_c": "EFS",
    "choice_d": "AES",
    "correct_answer": "B",
    "explanation": "BitLocker allows you to use drive encryption to protect files\u2014including those needed for startup and log-on. For removable drives, BitLocker-To-Go provides the same encryption technology to help prevent unauthorized access to the files stored on them. Encrypting file system (EFS) is used to encrypt volumes, files, and folders on a drive. Advanced encryption standard (AES) is an encrypting protocol for Wi-Fi.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      174,
      156,
      172,
      161,
      162
    ],
    "source": "9781394330348"
  },
  {
    "id": 858,
    "question": "Which type of security system uses physical characteristics to allow or deny access to locations or resources?",
    "choice_a": "ID badges",
    "choice_b": "Bollards",
    "choice_c": "Biometrics",
    "choice_d": "Tokens",
    "correct_answer": "C",
    "explanation": "Biometric devices use physical characteristics to identify the user. Biometric systems include fingerprint/palm/hand scanners, retinal scanners, face scanners, and soon, possibly, DNA scanners. To gain access to resources, you must pass a physical screening process. ID badges often use radio frequency identification (RFID) to communicate with a reader and verify your identity. Bollards are vertical posts used to block vehicular traffic. Tokens can be either hard (e.g., key fob) or soft (e.g., software on a system) and are often used in multifactor authentication (MFA).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      120,
      121,
      113,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 859,
    "question": "Your company\u2019s president has been contacted and threatened by someone who seems to know everything they\u2019ve been doing on their computer system. What type of malware has their system been attacked by?",
    "choice_a": "Keylogger",
    "choice_b": "Stalkerware",
    "choice_c": "SQL injection",
    "choice_d": "Trojan",
    "correct_answer": "B",
    "explanation": "Stalkerware is any software whether a commercial app or a malware that is used to perform surveillance on a person or business for malicious intent, which is stalking. A keylogger records keyboard input for a malicious actor to use later. A Structured Query Language (SQL) injection happens when a poorly written website doesn\u2019t specify limits on what an input field can contain, and that field is used by a malicious actor to insert code into the website. SQL is used to interact with databases, and most websites have databases running on the backend to take orders or capture visitor data for newsletters and such. A Trojan is malware that appears to be a useful program and is unwittingly downloaded by the victim, then often installs a backdoor for a malicious actor to use later for accessing the system.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      132,
      129,
      128,
      211,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 860,
    "question": "A security consultant for your company recommended that you begin shredding or burning classified documents before disposing of them. What security risk is the consultant trying to protect the company from?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Dumpster diving",
    "choice_c": "Social engineering",
    "choice_d": "Brute-force attack",
    "correct_answer": "B",
    "explanation": "Companies normally generate a huge amount of paper, most of which eventually winds up in dumpsters or recycle bins. Dumpsters may contain information that is highly sensitive in nature, and attackers may seek it out by practicing dumpster diving. In high-security and government environments, sensitive papers should be either shredded or burned. Shoulder surfing is literally looking over someone\u2019s shoulder to see passwords or other sensitive information. Social engineering happens anytime someone tries to coerce, threaten, or cajole someone into giving up privileged security information. A brute-force attack is repeatedly trying passwords in an effort to guess the correct one.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      165,
      141,
      139,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 861,
    "question": "Several workstations on your network have operating systems and antivirus software that are outdated. The workstations don\u2019t have the most recent security policies applied. They do not have the standard operating environment configured. What type of vulnerability does this represent?",
    "choice_a": "Non-compliant systems",
    "choice_b": "Zombie/botnet",
    "choice_c": "Brute-force attack",
    "choice_d": "Zero-day attack",
    "correct_answer": "A",
    "explanation": "The systems are not up-to-date and therefore are more vulnerable to attacks. These systems are considered non-compliant systems. It\u2019s a violation of security best practices to fail to keep all software on your network up to date. Zombie and botnet are attacks where the computer\u2019s user doesn\u2019t know there is malware on their computer. Their computer is a zombie, controlled by a bad actor, and when many zombies are used to attack a system, it is known as a botnet attack. A brute-force attack usually involves software that keeps trying passwords or codes until it hits upon the right one to gain access. A zero-day attack happens when a hole is found in a web browser or other software and attackers begin exploiting it before the software developer or anti-malware vendors have time to plug the hole.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      154,
      152,
      131,
      146,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 862,
    "question": "On the Internet, you get a news flash that the developer of one of your core applications found a security flaw. They will issue a patch for it in two days. Before you can install the patch, it\u2019s clear that the flaw has been exploited and someone has illegally accessed your network. What type of attack is this?",
    "choice_a": "Zombie/botnet",
    "choice_b": "Non-compliant system",
    "choice_c": "Zero-day attack",
    "choice_d": "Brute-force attack",
    "correct_answer": "C",
    "explanation": "When a hole is found in a web browser or other software and attackers begin exploiting it the very day it is discovered by the developer (i.e., bypassing the one- to two-day response time that many software providers need to put out a patch once the hole has been found), it is known as a zero-day attack (or exploit). Zombie and botnet are attacks where the computer\u2019s user doesn\u2019t know there is malware on their computer. Their computer is a zombie, controlled by a bad actor, and when many zombies are used to attack a system, it\u2019s known as a botnet attack. Non-compliant systems are those whose software is not up to date or they are not following best practices or corporate restrictions and rules. A brute-force attack usually involves software that keeps trying passwords or codes until it hits upon the right one to gain access.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      146,
      152,
      131,
      148,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 863,
    "question": "UserA is a member of the Dev group and the HR group. They are trying to access a local resource on an NTFS volume. The HR group has Allow Full Control permission for the <code>payroll</code> folder, and the Dev group has Deny Read permission for the same folder. What is UserA\u2019s effective access to the <code>payroll</code> folder?",
    "choice_a": "Full Control",
    "choice_b": "Read",
    "choice_c": "Write",
    "choice_d": "Deny",
    "correct_answer": "D",
    "explanation": "When there are conflicting New Technology File System (NTFS) permissions, generally they are combined, and the most liberal is granted. The exception to that is when there is an explicit Deny. As in this case, Deny overrides any allowed permissions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      167,
      126,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 864,
    "question": "Which default Windows group was designed to have more power than normal users but not as much power as administrators, and is now kept for backward compatibility only?",
    "choice_a": "Superuser",
    "choice_b": "Standard Users",
    "choice_c": "Power Users",
    "choice_d": "Advanced Users",
    "correct_answer": "C",
    "explanation": "Microsoft wanted to create a group in Windows that was not as powerful as the Administrators group, which is how the Power Users group came into being. The idea was that membership in this group would be given Read/Write permission to the system, allowing members to install most software but keeping them from changing key OS files or accessing other user\u2019s data. However, for many Windows versions now, the Power Users group now assigns permissions equivalent to the Standard user, a member of the Users group. There is no group called Superuser, or Standard Users, or Advanced Users.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      167,
      117,
      160,
      170,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 865,
    "question": "You have installed a Window workstation on your LAN. Which of the following are recommended best practices for maximizing security regarding the Administrator account? (Choose two.)",
    "choice_a": "Disable the Administrator account.",
    "choice_b": "Rename the Administrator account.",
    "choice_c": "Remove the Administrator account from the Administrators group.",
    "choice_d": "Create a different user with Administrator access, and only use it when necessary.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "You should disable the default Administrator account because most people are familiar with its existence, so part of the work of hacking in is already done if it isn\u2019t disabled. Renaming it isn\u2019t enough because it will still have the same Security Identifier (SID), and an attacker can use that to identify the Administrator account. Disabling it is the preferred way to keep it safe, not removing it from the group. Any users with administrative privileges should have a regular account and an admin account, and only use administrative privileges when necessary, such as when a User Account Control (UAC) window pops up, entering their admin password.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      160,
      167,
      170,
      117,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 866,
    "question": "Your friend asks you if it\u2019s necessary to clear browser history. What will you tell them the advantages of clearing history on exit are? (Choose two.)",
    "choice_a": "To maintain their privacy",
    "choice_b": "To synchronize with other devices",
    "choice_c": "Their browser will exhibit better performance.",
    "choice_d": "To clear invalid certificates",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Browser history should be cleared when you exit the browser for privacy and to maintain browser performance. Clearing it doesn\u2019t trigger synchronization unless you are logged in. To clear just the history of the computer you\u2019re on, log out of the browser. Clearing data doesn\u2019t clear invalid certificates. That\u2019s done usually under Manage Certificates or a similar setting.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      176,
      177,
      175,
      178,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 867,
    "question": "Which of the following are advantages of using NTFS permissions over using Share permissions? (Choose two.)",
    "choice_a": "NTFS permissions will override Share permissions if there is a conflict.",
    "choice_b": "NTFS permissions affect users at the local computer, but Share permissions do not.",
    "choice_c": "NTFS permissions are more restrictive in their access levels than Share permissions.",
    "choice_d": "NTFS permissions can be set at the file level, but Share permissions cannot.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "NTFS permissions affect users regardless of whether they are at the local computer or accessing the resource across the network. They can also be applied to individual files, whereas Share permissions only work across a network and can be applied only to folders. One set of permissions is not inherently more restrictive than the other, as either type can be used to deny access in a given situation (at least when accessing across the network). When New Technology File System (NTFS) and Share permissions affect the same folders, the most restrictive permission applies.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      119,
      172,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 868,
    "question": "Someone has placed an unauthorized wireless router on your network and configured it with the same SSID as your network. Users can access the network through that router, even though it\u2019s not supposed to be there. What type of security threat could this lead to?",
    "choice_a": "Zombie/botnet",
    "choice_b": "Spoofing",
    "choice_c": "Non-compliant system",
    "choice_d": "On-path attack",
    "correct_answer": "D",
    "explanation": "An unauthorized router with a seemingly legitimate configuration is specifically known as an evil twin. Those can lead to on-path attacks, which involve clandestinely placing something (such as a piece of software or a rogue router) between a server and the user, and neither the server\u2019s administrator nor the user is aware of it. The unauthorized device in the middle intercepts data and then sends the information to the server as if nothing is wrong. The unauthorized device software may be recording information for someone to view later, altering it, or in some other way compromising the security of your system and session. A zombie is a computer system that a hacker has a backdoor into and can use to perpetrate attacks, unknown to the computer system\u2019s legitimate user. A botnet is a system of zombie computers engaged in an orchestrated attack on a target. Spoofing occurs when an attacker causes a system or node to appear to be a different one. It\u2019s like impersonation but is technology-based rather than human-based. A non-compliant system is one that is not updated or not following company protocols regarding security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      145,
      149,
      131,
      147,
      180
    ],
    "source": "9781394330348"
  },
  {
    "id": 869,
    "question": "You\u2019re working in Active Directory, and you need to change an employee\u2019s security group. How do you associate an employee (user) with a selected security group? (Choose two.)",
    "choice_a": "Open Active Directory Users and Computers, right-click the user account, click on the Member Of tab, and then click on Add and search for the group.",
    "choice_b": "Move them to a new OU.",
    "choice_c": "Delete the employee in Active Directory Users and Computers, and choose the right security group when you set them up again.",
    "choice_d": "Open Active Directory Users and Computers, right-click the group, click the Members tab, and then click Add and search for the employee.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Changing security group membership can be done in Active Directory Users and Computers by right-clicking either the user or the group and clicking either the Member Of or Members tab, then clicking Add. Moving them to a new organizational unit (OU) does not change the security group membership. There is no need to delete and re-create a user, and in fact that could cause many other problems!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      171,
      200,
      117,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 870,
    "question": "You\u2019re working at a high-security server farm and must ensure that vehicles stay a certain distance away from the building. What physical security methods can be used for this purpose? (Choose two.)",
    "choice_a": "Bollards",
    "choice_b": "Motion sensors",
    "choice_c": "Fences",
    "choice_d": "Lighting",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Bollards are vertical posts that are short and sturdy, sometimes made of cement or steel. They can be placed closely enough together so that a vehicle can\u2019t go through an area, but people can. Fences can also be erected to keep vehicles and people out of an area. Motion sensors can be used to trigger alarms, but won\u2019t actually keep anyone out, and good lighting is always a deterrent, but again it won\u2019t physically keep anyone out.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      112,
      116,
      110,
      114,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 871,
    "question": "Between you and your family members, there are several mobile devices including phones, laptops, and smartwatches. Someone generally forgets where they put their phone, or it may be stolen, and it would be nice to easily find it. In addition, you want to see where other family members are when they are around town. Which type of app will allow you to do this?",
    "choice_a": "Trusted source application",
    "choice_b": "Remote control application",
    "choice_c": "Locator application",
    "choice_d": "Firewall application",
    "correct_answer": "C",
    "explanation": "A locator app is what you need. Apple supplies a free locator app called Find My, and Google has the Google Find My Device app. Together with their respective websites, these apps allow multiple mobile devices to be located if powered on and attached to the Internet (via 5G, 4G, 3G, Wi-Fi, Ethernet, and so on). For Apple devices, if not attached to the Internet, nearby devices can identify your device and tell you where it is. Both Find My and Google Find My Device allow the device to be controlled remotely so as to lock it, play a sound (even if audio is off), display a message, or even wipe it clean.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      196,
      197,
      232,
      198,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 872,
    "question": "Which security mechanism specifies permissions for users and groups as well as the type of activities the users or groups can perform?",
    "choice_a": "ACL",
    "choice_b": "EFS",
    "choice_c": "VPN",
    "choice_d": "PIN",
    "correct_answer": "A",
    "explanation": "File systems such as the New Technology File System (NTFS), and security devices such as firewalls, can track security in access control lists (ACLs). ACLs can hold permissions for local users and groups, and each entry in the ACL can also specify what type of access is given. This allows a great deal of flexibility in setting up a network. Encrypting file system (EFS) is used to encrypt volumes, files, and folders, but not entire drives. A virtual private network (VPN) is a type of network connection that uses encryption to create a private network that traverses a public one. Personal identification numbers (PINs) are used in many applications to identify a user.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      119,
      171,
      200,
      167,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 873,
    "question": "You need to know which files have been modified in a folder. Which of the following is not a way to see when files have been modified?",
    "choice_a": "Right-click each file and choose Properties and Advanced to see whether the archive bit is set.",
    "choice_b": "Open the folder in File Explorer and click on Date Modified to sort the files by the date they were last modified.",
    "choice_c": "Type <code>archive</code> at a command prompt.",
    "choice_d": "Type <code>attrib</code> at a command prompt.",
    "correct_answer": "C",
    "explanation": "On any individual file or folder, you can right-click and choose properties to see the Read-only and Hidden attributes, then click Advanced to see whether the file is ready for archiving (i.e., needs to be backed up). If it needs backing up, then it has been modified. You can also open a folder in File Explorer and click on Date Modified to sort the files by the last date modified. Simply typing <code>attrib</code> at a command prompt will show the file attributes for everything in that folder. Attributes are information such as whether the file is a system file (S), hidden (H), read only (R), or ready to be archived (A). To see the attributes for a single file, type <code>attrib <i>filename</i></code>. The <code>attrib</code> command is not specifically listed in the CompTIA A+ objectives, but file attributes are. Archive is not a valid command.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      172,
      209,
      162,
      170,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 874,
    "question": "You want to create a new policy to encrypt all company drives using BitLocker. Which operating system will need to be upgraded?",
    "choice_a": "Windows 10 Pro",
    "choice_b": "Windows 11 Home",
    "choice_c": "Windows 11 Pro",
    "choice_d": "Windows 10 for Workstations",
    "correct_answer": "B",
    "explanation": "Professional and higher operating system (OS) editions in either Windows 10 or Windows 11 will support BitLocker. Home editions will not, regardless of what version of the Windows OS they are.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      153,
      154,
      126,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 875,
    "question": "Software was installed on a laptop without the user\u2019s knowledge. The software has been tracking the user\u2019s activities and has transmitted the user\u2019s credit card information to an attacker. What type of threat is this?",
    "choice_a": "Zombie/botnet",
    "choice_b": "Spoofing",
    "choice_c": "Spyware",
    "choice_d": "Ransomware",
    "correct_answer": "C",
    "explanation": "Spyware differs from other malware in that it works\u2014often actively\u2014on behalf of a third party. Rather than self-replicating, like viruses and worms, spyware is often spread to machines by users who inadvertently ask for it. The users may have downloaded other programs that included the spyware, visited infected sites, and so on. The spyware program monitors the user\u2019s activity and gathers information about the user to pass on to marketers, or intercepts personal data such as credit card numbers. Zombies and botnets are innocent computers that are used by a hacker to perpetrate an attack on someone else without the user\u2019s knowledge. A spoofing example is using an IP address that should be someone else and pretending to be them to gain system access to a system. Ransomware locks a system in some way or encrypts data and won\u2019t allow access until the system\u2019s owner pays a ransom.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      132,
      131,
      128,
      139,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 876,
    "question": "A new user has joined your company as a network administrator. Which of the following statements is most correct regarding their network access?",
    "choice_a": "They should have just one user account, with administrator-level permissions.",
    "choice_b": "They should have just one user account, with standard user-level permissions.",
    "choice_c": "They should have two user accounts, one with standard user-level permissions and one with administrator-level permissions.",
    "choice_d": "They should have three user accounts: one with user-level permissions, one with administrator-level permissions, and one with remote access administrator permissions.",
    "correct_answer": "C",
    "explanation": "The new administrator should have a non-administrative user account to use for day-to-day tasks. They also need an account with administrative privileges to perform the administrative duties. When creating user accounts, follow the principle of least privilege: Give users only the permissions they need to do their work and no more. This is especially true with administrators. Those users should be educated on how each of the accounts should be used. A third account is not necessarily needed.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      117,
      167,
      170,
      123,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 877,
    "question": "Which types of security threats are direct attacks on user passwords? (Choose two.)",
    "choice_a": "Brute-force attack",
    "choice_b": "Zombie/botnet",
    "choice_c": "Dictionary attack",
    "choice_d": "Spoofing",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Password attacks occur when an account is attacked repeatedly with the intent of determining the password that will gain access. This is accomplished by using applications designed to break the password by sending possible passwords to log in to the account in a systematic manner. Two types of password attacks are brute-force and dictionary attacks. Zombie and botnet are attacks where the user of the computer doesn\u2019t know there is malware on their computer. Their computer is a zombie, and when many zombies are used by a bad actor to attack a system, it\u2019s known as a botnet attack. A spoofing attack is an attempt by someone or something to masquerade as someone or something else.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      148,
      157,
      131,
      147,
      141
    ],
    "source": "9781394330348"
  },
  {
    "id": 878,
    "question": "You read corporate email on your smartphone and do not want others to access the phone if you leave it somewhere. What is the first layer of security that you should implement to keep others from using your phone?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Full device encryption",
    "choice_c": "Screen lock",
    "choice_d": "Remote wipe software",
    "correct_answer": "C",
    "explanation": "All options will improve the smartphone\u2019s security. For just the basic level of security, though, enable a screen lock. A user will need to enter a personal identification number (PIN) code, fingerprint, pattern, or facial recognition to gain access to the device. Multifactor authentication (MFA) occurs whenever you need two or more ways to prove who you are (i.e., something you know, something you have, something you are, or someplace you are). Full device encryption would mean encoding the data and requiring a key to decrypt it. Remote wipe is a feature that can remove all the personal or corporate data from a phone if it is lost or stolen.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      232,
      124,
      159,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 879,
    "question": "You use your smartphone for email and extensive Internet browsing. You want to add an additional level of security to always verify your identity online when accessing various accounts. Which type of app do you need?",
    "choice_a": "Authenticator app",
    "choice_b": "Trusted source app",
    "choice_c": "Bariatric authenticator app",
    "choice_d": "Account encryption app",
    "correct_answer": "A",
    "explanation": "An authenticator app can help securely verify your identity online, regardless of the account you want to log into. Different apps work in different ways, but the general procedure is that the app will generate a random code for you to type in, along with your username and password. The random code helps identify you and tells the site you are logging into that you really are who you say you are. The other options are not actual application types.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      139,
      229,
      155
    ],
    "source": "9781394330348"
  },
  {
    "id": 880,
    "question": "You have instructed users on your network to not use common words for their passwords. What type of attack are you trying to prevent?",
    "choice_a": "Brute-force",
    "choice_b": "Dictionary",
    "choice_c": "Social engineering",
    "choice_d": "Shoulder surfing",
    "correct_answer": "B",
    "explanation": "A dictionary attack uses a dictionary of common words to attempt to find the user\u2019s password. Dictionary attacks can be automated, and several tools exist in the public domain to execute them. As an example of this type of attack, imagine guessing words and word combinations found in a standard English-language dictionary. Brute-force is trying repeatedly to guess a user\u2019s password. Social engineering is using kindness, coercion, or fear to get you to give up privileged information such as your password. Shoulder surfing is literally someone looking over your shoulder in an attempt to gain privileged information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      148,
      157,
      141,
      142,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 881,
    "question": "Which type of malware is designed to look like a different program and, when installed, creates a backdoor for an attacker to access the target system?",
    "choice_a": "Trojan",
    "choice_b": "Spyware",
    "choice_c": "Virus",
    "choice_d": "Whaling",
    "correct_answer": "A",
    "explanation": "Trojans are programs that enter a system or network under the guise of another program. A Trojan may be included as an attachment or as part of an installation program. It can create a backdoor for an attacker to use later or replace a valid program during installation. Spyware watches what you do and reports back to someone. A virus is spread from computer to computer because of some contact between the machines, often through email. Whaling is phishing for \u201cbig fish,\u201d such as very wealthy or influential people. Phishing gets its name from fishing for information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      132,
      130,
      211,
      142
    ],
    "source": "9781394330348"
  },
  {
    "id": 882,
    "question": "You have been asked to dispose of several old magnetic hard drives. What are you doing if you use a large magnet to clear the data off a hard drive?",
    "choice_a": "Overwriting",
    "choice_b": "Zero-writing",
    "choice_c": "Degaussing",
    "choice_d": "Incineration",
    "correct_answer": "C",
    "explanation": "Degaussing is using a large electromagnet to destroy any magnetic media, such as a hard drive or backup tape set. This process helps ensure that information doesn\u2019t fall into the wrong hands. Overwriting and zero-writing write random binary (or all zeros) on a magnetic hard drive using software. The process is done several times by the software to be effective. Incineration means simply burning the drive.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      164,
      162,
      163,
      174,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 883,
    "question": "If you check the Read-only or Hidden box on the graphic, what feature of the folder is being changed?<img src=\"/question_assets/220-1202/c07f001.png\" alt=\"Screenshot of myfolder properties dialog box with type, location, size, creation date, and attributes details.\"/>\n\n<figcaption>Screenshot of myfolder properties dialog box with type, location, size, creation date, and attributes details.</figcaption>",
    "choice_a": "Archive bit",
    "choice_b": "NTFS permissions",
    "choice_c": "Attributes",
    "choice_d": "Share permissions",
    "correct_answer": "C",
    "explanation": "Certain metadata pertaining to a file are called attributes. The most commonly used attributes are system (S), hidden (H), read only (R), and archive (A). There are others that can be viewed by typing <code>attrib /?</code> at a command prompt. The <code>attrib</code> command is how you add attributes, such as <code>attrib <i>myfile</i> +R</code> to make <code><i>myfile</i></code> read only. You can also remove attributes using the same command with a minus sign. In the Windows 10/11 Graphical User Interface (GUI), you can view attributes by right-clicking a file or folder and choosing properties. Windows 11 will display a screen like the one in the graphic. The <code>attrib</code> command is not specifically listed on the CompTIA A+ objectives, but file attributes are. The archive bit is set when a file has been modified and needs backing up. New Technology File System (NTFS) permissions, such as read only and full control, are part of the security measures of the NTFS file system. Share permissions are less granular than NTFS permissions and only apply when a resource is accessed across a network.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      172,
      171,
      200,
      174,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 884,
    "question": "You\u2019re setting up a Windows 11 Pro machine and want to encrypt the entire hard drive, including startup files. Which technology best meets your needs?",
    "choice_a": "Windows OSs do not allow full-drive encryption.",
    "choice_b": "BitLocker",
    "choice_c": "BitLocker-To-Go",
    "choice_d": "EFS",
    "correct_answer": "B",
    "explanation": "BitLocker drive encryption allows you to use drive encryption to protect files\u2014including those needed for startup and log-on. This is available only with Windows Pro and higher editions. For removable drives, BitLocker-To-Go provides the same encryption technology to help prevent unauthorized access to the files stored on them. Encrypting file system (EFS) is used to encrypt volumes, files, and folders but is not capable of encrypting the entire drive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      156,
      172,
      193,
      162
    ],
    "source": "9781394330348"
  },
  {
    "id": 885,
    "question": "Which type of security threat gains administrative-level access for an attacker to perform another attack, and then hides its presence from system management tools?",
    "choice_a": "Virus",
    "choice_b": "Whaling",
    "choice_c": "Rootkit",
    "choice_d": "Ransomware",
    "correct_answer": "C",
    "explanation": "Rootkits are software programs that can hide certain things from the operating system (OS); they do so by obtaining (and retaining) administrative-level access. With a rootkit, there may be several processes running on a system that don\u2019t show up in Task Manager, or connections that don\u2019t appear in a Netstat display may be established or available\u2014the rootkit masks the presence of these items. Rootkits are known for being particularly difficult to eradicate. A virus is spread from computer to computer because of some contact between the machines, often through email. Whaling is phishing for \u201cbig fish,\u201d such as very wealthy or influential people. Phishing gets its name from fishing for information. Ransomware holds a machine or network hostage, making it and its data inaccessible, until a ransom is paid.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      129,
      135,
      128,
      209,
      220
    ],
    "source": "9781394330348"
  },
  {
    "id": 886,
    "question": "A computer user wants to encrypt a few files on an NTFS volume on their Windows Pro workstation. They do not have administrative rights to the computer. Which of the following statements is correct?",
    "choice_a": "They can only use device encryption.",
    "choice_b": "They can use BitLocker.",
    "choice_c": "They can use BitLocker-To-Go.",
    "choice_d": "They can use EFS.",
    "correct_answer": "D",
    "explanation": "Encrypting file system (EFS) is available in most editions of Windows, and it allows for encryption/decryption of files stored in New Technology File System (NTFS) volumes. All users can use EFS, whereas only administrators can turn on BitLocker. It does not require any special hardware, while BitLocker benefits from having the trusted platform module (TPM). As an additional distinction, EFS can encrypt just one file, if so desired, while BitLocker encrypts the whole volume and whatever is stored on it. BitLocker is device encryption. BitLocker-To-Go is for mobile use, not on a storage drive in a desktop computer.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      174,
      172,
      170,
      117,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 887,
    "question": "Which type of digital security protects your network from malicious software programs by both preventing them from entering the system and removing them if they are found?",
    "choice_a": "Firewall",
    "choice_b": "Anti-malware",
    "choice_c": "EFS",
    "choice_d": "UAC",
    "correct_answer": "B",
    "explanation": "Anti-malware software will help protect computers from malicious programs. Typically, anti-malware does everything that antivirus software does as well as identify threats beyond just viruses. In fact, viruses are a type of malware. Often anti-malware software is marketed as antivirus software. A firewall is a hardware or software device designed to prevent certain types of traffic from entering or leaving a network. Encrypting file system (EFS) allows a user to encrypt individual volumes, files, or folders, and user account control (UAC) is designed to prevent users from making changes that they are not authorized to make.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      134,
      132,
      133,
      220
    ],
    "source": "9781394330348"
  },
  {
    "id": 888,
    "question": "Your company has hired a consultant to intentionally send emails asking for login information from your employees. What is your company engaging in?",
    "choice_a": "Phishing",
    "choice_b": "Whaling",
    "choice_c": "Zero-day attack",
    "choice_d": "Anti-phishing training",
    "correct_answer": "D",
    "explanation": "Educating users to recognize phishing is one of the most important steps in preventing hackers from acquiring login credentials. One way to do this is to hire a consulting company to send phishing emails and see which employees respond when they should not and therefore need additional training. Phishing is usually done through email and is an attempt to \u201cfish\u201d for information from an authorized network user, such as logon information. Whaling is phishing for high-profile or wealthy targets. A zero-day attack is one that happens the same day a vulnerability is discovered, so there has not been time to rectify the vulnerability.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      139,
      142,
      220,
      137,
      135
    ],
    "source": "9781394330348"
  },
  {
    "id": 889,
    "question": "On a Windows workstation, there is one volume formatted with NTFS. The Developers group has Modify access to the <code>C:\\dev</code> directory. You copy the folder to the <code>C:\\operations</code> folder, to which the Developers group has Read access. What level of permissions will the Developers group have to the new <code>C:\\operations\\dev</code> directory?",
    "choice_a": "Read & Execute",
    "choice_b": "Read",
    "choice_c": "Full Control",
    "choice_d": "Modify",
    "correct_answer": "B",
    "explanation": "When a file or folder is copied on New Technology File System (NTFS) volumes, the new file or folder will inherit its NTFS permissions from its new parent folder. The file in question was copied, so it inherits Read control and the old permission (i.e., Modify) is discarded. However, when files and folders are moved, versus copying them, the original permissions are retained at the new location.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      119,
      170,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 890,
    "question": "You are configuring NTFS and Share permissions on a Windows 11 workstation. Which of the following statements is true regarding permissions?",
    "choice_a": "Both NTFS and Share permissions can be applied only at the folder level.",
    "choice_b": "NTFS permissions can be applied at the file or folder level, and Share permissions can be applied only at the folder level.",
    "choice_c": "NTFS permissions can be applied only at the folder level, but Share permissions can be applied to files and folders.",
    "choice_d": "Both NTFS and Share permissions support inheritance.",
    "correct_answer": "B",
    "explanation": "Only New Technology File System (NTFS) permissions can be applied to individual files. Both NTFS and Share permissions can be applied to volumes and folders. Share permissions are only effective when the resource is accessed via a network. NTFS permissions are effective whether the person access the resource locally or via a network. NTFS permissions are inherited from a parent folder. Share permissions do not have inheritance.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      171,
      200,
      119,
      167,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 891,
    "question": "You are troubleshooting a Windows Home system that was infected with malware. You\u2019ve worked through all of the best-practice procedures for malware removal up to and including scheduling scans and running updates. What do you need to do next?",
    "choice_a": "Enable System Restore and create a restore point in Windows Home.",
    "choice_b": "Disable System Restore in Windows Home.",
    "choice_c": "Remediate infected systems.",
    "choice_d": "Educate the end user.",
    "correct_answer": "A",
    "explanation": "CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      138,
      217,
      153,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 892,
    "question": "You recently noticed a change on your computer. Now, when you open your web browser, no matter what you search for, you get a dozen unsolicited pop-up windows offering to sell you items you didn\u2019t ask for. What type of problem does your computer have?",
    "choice_a": "Adware",
    "choice_b": "Ransomware",
    "choice_c": "Zombie/botnet",
    "choice_d": "Trojan",
    "correct_answer": "A",
    "explanation": "Adware differs from other malware in that it works\u2014often actively\u2014on behalf of a third party. Rather than self-replicating, like viruses and worms, spyware is spread to machines by users who inadvertently ask for it. The users often don\u2019t know they have asked for it but have done so by downloading other programs, visiting infected sites, and so on. The adware program monitors the user\u2019s activity and responds by offering unsolicited pop-up advertisements, gathers information about the user to pass on to marketers, or intercepts personal data such as credit card numbers. Ransomware is software that takes over a computer and won\u2019t allow access to the data until a ransom is paid. Zombies are computers that have been taken over by another party and are used to perform malicious acts. When there are many zombies acting together, they form a botnet. The computer user is generally unaware of the presence of the attacker. A Trojan is software that is downloaded when the user downloads an innocent-looking software or digital image. Once downloaded, the Trojan loads into the computer system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      128,
      127,
      211,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 893,
    "question": "A computer user wants to encrypt the data on their Windows Home device. They have administrative rights to the computer. Which of the following statements is correct?",
    "choice_a": "They may be able to use Windows device encryption.",
    "choice_b": "They can use BitLocker.",
    "choice_c": "They can use BitLocker-To-Go.",
    "choice_d": "They can use EFS.",
    "correct_answer": "A",
    "explanation": "Encrypting File System (EFS) allows for the encryption/decryption of individual volumes, files, and folders stored in New Technology File System (NTFS) volumes, while BitLocker and BitLocker-To-Go encrypt entire drives. However, neither of them is available in Home editions of Windows. If there is supporting hardware, (trusted platform module [TPM] enabled in basic input output system/unified extensible firmware interface [BIOS/UEFI] and secure boot enabled), then device encryption can be used instead. Windows 11 requires TPM v. 2.0. With device encryption, only someone with authorization to use the device will be able to decrypt it. You must be logged in as an administrator to turn on device encryption, which can be found in Windows Settings. If device encryption isn\u2019t there, then it isn\u2019t available on the device. You can also see if the hardware supports it by launching the System Information Utility as an administrator, then scrolling down to Device Encryption Support.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      172,
      193,
      170,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 894,
    "question": "Which of the following are true about the permissions shown in the graphic? (Choose two.)<img src=\"/question_assets/220-1202/c07f002.png\" alt=\"Screenshot of Permissions dialog box depicts Everyone with read access allowed including options to add, remove, and modify permissions.\"/>\n\n<figcaption>Screenshot of Permissions dialog box depicts Everyone with read access allowed including options to add, remove, and modify permissions.</figcaption>",
    "choice_a": "They are in effect only when accessed via a network.",
    "choice_b": "They are NTFS permissions.",
    "choice_c": "This type can be used on files and folders.",
    "choice_d": "Everyone can read files in this folder.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "These are share permissions, not New Technology File System (NTFS) permissions. Share permissions have no effect when someone logs on locally; they only take effect when being accessed via a network. (NTFS permissions apply whether logging on locally or via the network.) Share permissions can only be applied to folders, not individual files. The only share permission set on this folder is that everyone can read it. No one has permission to change it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      119,
      172,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 895,
    "question": "Which of the following statements are true regarding file and folder attributes on a Windows 11 workstation? (Choose two.)",
    "choice_a": "File attributes are available only on NTFS volumes.",
    "choice_b": "Only members of the Administrators group can change file/folder attributes.",
    "choice_c": "Attributes can be accessed by right-clicking the file/folder and choosing Properties, General tab.",
    "choice_d": "Compression is an advanced file/folder attribute.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "In the graphical user interface (GUI), attributes are accessed by right-clicking the object and choosing Properties, General tab. For some attributes, such as compression and encryption, you need to click Advanced under the Attributes section of the General tab. Compression is an advanced attribute that uses algorithms to remove repeated characters and excess spaces making files take up less space. The user does not need to be an administrator to change attributes. File attributes are available in volumes other than NTFS. In addition to right-clicking the object, you can change attributes using the <code>attrib</code> command.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      172,
      171,
      174,
      170,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 896,
    "question": "Which type of digital security uses virus signatures, behavior analysis, and memory scanning to protect your network or computer?",
    "choice_a": "Antivirus",
    "choice_b": "Firewall",
    "choice_c": "Access control list",
    "choice_d": "NTFS permissions",
    "correct_answer": "A",
    "explanation": "Antivirus software needs continual updates of virus signatures as new viruses are unleashed daily. The updates are known as definition files and ensure that the antivirus engine will recognize new viruses. However, today\u2019s threat environment requires better tools, such as memory scanning and behavior analysis to catch fileless viruses that hide in memory. Firewalls can be software- or hardware-based and are designed to block or allow network traffic based on certain criteria. Once established, settings are not often changed. Access control lists (ACLs) are tied to objects in a system and are compared to an authenticated user\u2019s information to determine whether to grant access. These also are seldom changed once they are configured. New Technology File System (NTFS) permissions are part of what creates access control lists. NTFS permissions for an object are granted to a user and can include Full Control, Modify, Read & execute, List Folder Contents, Read, and Write. Share permissions also affect access to a resource, but only when a user accesses it via a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      135,
      131,
      173,
      220
    ],
    "source": "9781394330348"
  },
  {
    "id": 897,
    "question": "You are at work and receive a phone call. The caller ID indicates it\u2019s coming from your manager\u2019s desk. You can see your manager\u2019s desk, and no one is sitting there. Which of the following is likely happening?",
    "choice_a": "Zombie/botnet attack",
    "choice_b": "Impersonation attack",
    "choice_c": "Zero-day attack",
    "choice_d": "Phishing attack",
    "correct_answer": "B",
    "explanation": "Impersonation is an attempt by someone or something to masquerade as someone else. You might think of impersonation attacks as affecting network systems, but they can affect phone systems as well. A zombie is a computer system that a hacker has a backdoor into and can use to perpetrate attacks, unknown to the computer system\u2019s legitimate user. A botnet is a system of zombie computers engaged in an orchestrated attack on a target. A zero-day attack occurs when a vulnerability is used to attack a system on the very day that the vulnerability is discovered, before preventive measures to block the vulnerability can be created. In a phishing attack, the attacker uses coercion or other means to attempt to gain passwords or other privileged information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      147,
      149,
      131,
      142
    ],
    "source": "9781394330348"
  },
  {
    "id": 898,
    "question": "A user is working on a Windows workstation. Their user account is a member of the Managers group, and they are trying to access a folder named <code>reports</code>, located on a different computer. The NTFS permissions for the <code>reports</code> shared folder on that computer for the Managers group are Read and Write. The folders share permissions for the Managers group is Read permission. What are the user\u2019s effective permissions on the <code>reports</code> folder?",
    "choice_a": "Full Control",
    "choice_b": "Read and Write",
    "choice_c": "Read",
    "choice_d": "No Access",
    "correct_answer": "C",
    "explanation": "Because the user is accessing the New Technology File System (NTFS)-based resource over the network, both NTFS and Share permissions are applied. If there is a difference between the two of them, the most restrictive permissions are used. Therefore, the user has Read access only.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      119,
      126,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 899,
    "question": "Which NTFS permission overrides all the others?",
    "choice_a": "Full Control",
    "choice_b": "Deny",
    "choice_c": "List Folder Contents",
    "choice_d": "Read",
    "correct_answer": "B",
    "explanation": "Regardless of what other permissions may be granted, Deny will override all of them and the effective permission will be Deny.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      170,
      119,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 900,
    "question": "A system administrator is concerned about Windows users inadvertently installing malware from USB drives that contain malicious code. What can they do to help prevent this from happening?",
    "choice_a": "Set restrictive user permissions.",
    "choice_b": "Enable BIOS/UEFI passwords.",
    "choice_c": "Disable AutoRun/AutoPlay.",
    "choice_d": "Enable data encryption.",
    "correct_answer": "C",
    "explanation": "Disable AutoRun/AutoPlay should be selected on computers connected to the network. (It is never a good idea to put any media in a workstation if you don\u2019t know where it came from or what it is.) The simple reason is that the media (i.e., CD, DVD, USB, and SD) could contain malware. Compounding matters, the malware could be referenced in the <code>autorun.inf</code> file, causing it to be summoned when the media is inserted in the machine and requiring no other action. User permissions are not effective on external drives whose content changes all the time. A basic input/output system/unified extensible firmware interface (BIOS/UEFI) password would prevent the computer from being booted and enabling data encryption can\u2019t be done on media that is subject to change. Note that the CompTIA objectives mention AutoRun, but the feature is now known as AutoPlay. You might see either term used when working in IT.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      161,
      133,
      134,
      139,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 901,
    "question": "Someone has placed an unauthorized wireless router on your network and configured it with the same SSID as your network. Users can access the network through that router, even though it\u2019s not supposed to be there. What is this router configuration known as?",
    "choice_a": "Zombie/botnet",
    "choice_b": "Evil twin",
    "choice_c": "Non-compliant system",
    "choice_d": "DDoS",
    "correct_answer": "B",
    "explanation": "An unauthorized router with a seemingly legitimate configuration is specifically known as an evil twin. A zombie is a computer system that a hacker has a backdoor into and can use to perpetrate attacks, unknown to the computer system\u2019s legitimate user. A botnet is a system of zombie computers engaged in an orchestrated attack on a target. A non-compliant system is one that is not updated or not following company protocols regarding security. Distributed denial-of-service (DDoS) is the attack perpetrated by a botnet, which floods an unsuspecting server with so many requests that legitimate server users are unable to connect to it.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      145,
      147,
      149,
      131,
      144
    ],
    "source": "9781394330348"
  },
  {
    "id": 902,
    "question": "Which of the following are true about the information shown in the graphic? (Choose two.)<img src=\"/question_assets/220-1202/c07f003.png\" alt=\"Screenshot of security properties window for drive C in Windows with permissions settings.\"/>\n\n<figcaption>Screenshot of security properties window for drive C in Windows with permissions settings.</figcaption>",
    "choice_a": "The graphic shows Share permissions.",
    "choice_b": "The graphic shows NTFS permissions.",
    "choice_c": "These permissions will be inherited by any folder created on the C drive.",
    "choice_d": "These permissions are effective only when someone accesses them over a network.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "These are New Technology File System (NTFS) permissions, not Share permissions. They will be inherited by any folder created inside this folder, which happens to be the C drive. NTFS permissions are effective regardless of whether the user accesses them locally or over a network. (Share permissions are only effective when the resource is accessed via a network, they can only be applied to folders, and share permissions are not inherited.) Inheritance in NTFS is enabled by default but it can be disabled by clicking the Advanced button (shown in the figure in the bottom right), and selecting Disable Inheritance.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      171,
      200,
      172,
      119,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 903,
    "question": "Your office has recently experienced several laptop thefts. Which security mechanism, as pictured in the graphic, is designed to protect mobile devices from theft?<img src=\"/question_assets/220-1202/c07f004.png\" alt=\"Coiled security cable lock with a loop and cylindrical lock.\"/>\n\n<figcaption>Coiled security cable lock with a loop and cylindrical lock.</figcaption>",
    "choice_a": "Security token",
    "choice_b": "Equipment lock",
    "choice_c": "Key fob",
    "choice_d": "Magnetometer",
    "correct_answer": "B",
    "explanation": "Locks and keys are some of the simplest yet most effective physical security measures. The device shown in the figure is a laptop cable lock. The user has a key to unlock the device. The heavy cable is looped around something solid like a table leg, and the end where the key is inserted locks into a special slot in a laptop or other mobile device. Security tokens can be either soft tokens or external hardware tokens. External hardware tokens are objects a user carries, such as a key fob. Soft tokens are software installed on a system. A magnetometer measures magnetic fields and can be used in a mobile device to determine your location with respect to Earth\u2019s magnetic north and south.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      111,
      190,
      114,
      196,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 904,
    "question": "Which of the following is an open-source authentication encryption protocol that is widely used and uses a third party to verify user credentials?",
    "choice_a": "AES",
    "choice_b": "TACACS+",
    "choice_c": "Kerberos",
    "choice_d": "RADIUS",
    "correct_answer": "C",
    "explanation": "Kerberos was developed and named by computer scientists at MIT. It is an open-source authentication protocol that uses a third party to verify user credentials and symmetric key cryptography to encode transmissions between parties. Terminal access controller access-control system (TACACS+) is an authentication protocol developed by Cisco that is now an open standard. Remote authentication dial-in user service (RADIUS) is an authentication protocol that was originally used for dial-in access. It has morphed into a protocol used for authenticating remote Wi-Fi or on-premises users. Advanced encryption standard (AES), which is for wireless encryption not authentication, has been around since 2001, and it is the successor to temporal key integrity protocol (TKIP).",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      183,
      168,
      125,
      122,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 905,
    "question": "Your company allows employees to use their own devices, and as the IT director, you are naturally concerned about the security of corporate information on those devices. Which technology should you require in this situation?",
    "choice_a": "EFS",
    "choice_b": "MDM",
    "choice_c": "SSO",
    "choice_d": "UAC",
    "correct_answer": "B",
    "explanation": "Mobile device management (MDM) is a software technology that enables an IT department to retain control over corporate data while allowing users to use their personal devices. Bring your own device (BYOD) policies can save companies money on hardware but present a security risk. Using MDM, an IT administrator can restrict the type of data and applications that are used with company information. They can also wipe all corporate information off a lost or stolen device, or if an employee leaves the company. Encrypting file system (EFS) is used to encrypt files and folders in Windows operating systems (OSs), excluding Home editions. The purpose of single sign-on (SSO) is to give users access to all the applications and systems that they need when they log on. Some systems may require users to enter their credentials again, but the username and password will be consistent between systems. User account control (UAC) verifies that someone has the authority to change a system before making any changes by requiring them to enter an administrator password for certain operations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      155,
      198,
      232,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 906,
    "question": "Which of the following is not a logical security method of delivering a one-time code for multifactor authentication?",
    "choice_a": "Voice call",
    "choice_b": "Email",
    "choice_c": "Bollards",
    "choice_d": "SMS",
    "correct_answer": "C",
    "explanation": "Bollards are a method of physical security that can be used to keep vehicles out of a particular area. Voice calls, email, and short message service (SMS) can all be used to deliver a one-time code for multifactor authentication (MFA).",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      121,
      112,
      113,
      183,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 907,
    "question": "Which of the following are examples of an external hardware token? (Choose two.)",
    "choice_a": "Key fob",
    "choice_b": "Retina scanner",
    "choice_c": "Smart card",
    "choice_d": "Motion sensor",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Both key fobs and smart cards are external hardware tokens. Hardware tokens are physical security devices that can be carried about by the user. A key fob generates a random number every few seconds that can be entered into a system as part of multifactor authentication(MFA). A smart card has a chip whose data can be accessed by a reader device to enable a user access to a secure area or computer system. Retina scanners are biometric devices, because they use part of your body as authentication/identification, and while motion sensors are a part of physical security, they\u2019re generally used in conjunction with alarm systems.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      113,
      121,
      120,
      115,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 908,
    "question": "Which of the following devices, often found in smartphones and other mobile devices, is used to pinpoint a person\u2019s location on Earth and therefore can be used for multifactor authentication?",
    "choice_a": "Magnetometer",
    "choice_b": "Retina scanner",
    "choice_c": "Key fob",
    "choice_d": "External hardware token",
    "correct_answer": "A",
    "explanation": "A magnetometer measures magnetic fields and can be used to locate a person\u2019s position on Earth. As a part of multifactor authentication (MFA), that location is compared to an allow or block list, and, if the device to be accessed is in an allowed location, access may be granted. A retina scanner is a biometric device that scans a person\u2019s eye to determine if access should be granted. A key fob will generate a code that changes every few seconds. It is a type of external hardware token used for authentication.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      196,
      113,
      116
    ],
    "source": "9781394330348"
  },
  {
    "id": 909,
    "question": "Which of the following is not a physical security measure for protecting computer systems and access to them?",
    "choice_a": "Lighting",
    "choice_b": "Equipment locks",
    "choice_c": "Motion sensors",
    "choice_d": "Authenticator application",
    "correct_answer": "D",
    "explanation": "An authenticator application, a type of soft token, is a logical, rather than a physical, security measure. It is often used in multifactor authentication (MFA). An authenticator app is software, often found on your cell phone, which generates a code that when input, will grant access to a website or other resource. The other three options\u2014proper lighting, equipment and door locks, and motion sensors that trigger alarms\u2014are physical deterrents to keep would-be attackers out.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      110,
      116,
      111,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 910,
    "question": "Which of the following is not a biometric identification device?",
    "choice_a": "Fingerprint reader",
    "choice_b": "Retina scanner",
    "choice_c": "External hardware token",
    "choice_d": "Palm print scanner",
    "correct_answer": "C",
    "explanation": "An external hardware token is a security device that a computer user has in their possession, such as a key fob or smart card. External hardware tokens are often used in multifactor authentication (MFA). Fingerprint readers, retina scanners, and palm print scanners are biometric devices. Biometric devices are those that use a part of your body to identify you and either deny or allow access to a system based on your identity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      121,
      120,
      113,
      169
    ],
    "source": "9781394330348"
  },
  {
    "id": 911,
    "question": "A user is worried about others shoulder surfing. What should they use to help avoid this problem?",
    "choice_a": "Access control vestibule",
    "choice_b": "Video surveillance",
    "choice_c": "Display privacy filter",
    "choice_d": "Smart card",
    "correct_answer": "C",
    "explanation": "To prevent shoulder surfing, a user could install a display privacy filter. In shoulder surfing, a potential attacker is literally looking over someone\u2019s shoulder to try and read what is on their screen. Privacy filters are either film or glass add-ons that are placed over a monitor or laptop screen to prevent the data on the screen from being readable when viewed from the sides. Only the user sitting directly in front of the screen can read the data. An access control vestibule is an area between two doors that helps to prevent tailgating. Video surveillance occurs when there are security cameras watching a secure area and a person observing the output of those cameras. Smart cards are devices a user can carry that will authenticate them to a system as a part of multifactor authentication (MFA) login.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      108,
      159,
      139,
      109
    ],
    "source": "9781394330348"
  },
  {
    "id": 912,
    "question": "Which type of malware will often cause critical files to disappear, while sometimes displaying a taunting message, and requires user intervention (usually inadvertent) to spread from computer to computer?",
    "choice_a": "Botnet",
    "choice_b": "Virus",
    "choice_c": "Trojan",
    "choice_d": "Rootkit",
    "correct_answer": "B",
    "explanation": "Many viruses will announce that you\u2019re infected as soon as they gain system access. They may take control of your system and flash annoying messages on your screen or destroy your hard disk. When this occurs, you\u2019ll know that you\u2019re a victim. Other viruses will cause your system to slow down, cause files to disappear from your computer, or take over your disk space. Many viruses today are spread using email. The infected system attaches a file to any email that you send to another user. The recipient opens this file, thinking it\u2019s something that you legitimately sent them. When they open the file, the virus infects the target system. A botnet is a group of computers used to perpetrate an attack without the knowledge of the authorized user of that computer. The computer is called a zombie and is controlled by a third-party attacker. A Trojan is malicious software that hides in that fun game or screensaver that you just downloaded, and it installs when you install the innocent looking files. A rootkit is malware that gains access to a system as administrator, giving it full control over a system. Rootkits are adept at hiding their presence and so are difficult to eradicate.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      133,
      128,
      129,
      131,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 913,
    "question": "A computer user in the accounting department received a phone call from someone who claimed to be from the company\u2019s bank. They had a partial account number and needed the user to verify the full account number, username, and password before they could discuss the reason for their call with the user. The user said they would call back, and the caller on the other end hung up abruptly. The user contacted you in the IT department because it seemed like such a strange call. What kind of attempted attack will you tell them just happened?",
    "choice_a": "Phishing",
    "choice_b": "Vishing",
    "choice_c": "Whaling",
    "choice_d": "Evil twin",
    "correct_answer": "B",
    "explanation": "Vishing, phishing, and whaling are variations of the same type of attack\u2014social engineering. In all of these, someone attempts to gain usernames and passwords or other information by intimidation, coercion, or other means. Then they\u2019ll use that information to attack your company\u2019s systems. They\u2019re all a play on the word fishing. The attacker is casting a line and hoping you will bite on it. Vishing is using voice calls, phishing uses email, and whaling is phishing for powerful or wealthy fish (i.e., people). An evil twin attack happens when someone plugs an unauthorized wireless access point (WAP) into your network and gives it the same service set identifier (SSID) that your valid network has.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      141,
      139,
      145,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 914,
    "question": "Your company allows employees to use their personal devices for company work because it saves the company money on hardware. What is this called?",
    "choice_a": "BYOD",
    "choice_b": "MDM",
    "choice_c": "SSO",
    "choice_d": "UAC",
    "correct_answer": "A",
    "explanation": "Bring your own device (BYOD) policies can save companies money on hardware and make users happy but they present a security risk. Mobile device management (MDM) is software technology that enables an IT department to retain control over corporate data while allowing users to use their personal devices. Using MDM, an IT administrator can restrict the type of data and applications that are used with company information. They can also wipe all corporate information off a lost or stolen device, or when an employee leaves the company. The purpose of single sign-on (SSO) is to give users access to all the applications and systems that they need when they log on. Some systems may require users to enter their credentials again, but the username and password will be consistent between systems. User account control (UAC) verifies that someone has the authority to change a system before making any changes, by requiring them to enter an administrator password for certain operations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      124,
      155,
      232,
      169
    ],
    "source": "9781394330348"
  },
  {
    "id": 915,
    "question": "Why is an EOL OS a security threat?",
    "choice_a": "There will be no more security updates.",
    "choice_b": "There will be no more feature updates.",
    "choice_c": "There will be no more company support.",
    "choice_d": "The software will stop working on the EOL date.",
    "correct_answer": "A",
    "explanation": "When an operating system (OS) is at end-of-life (EOL), it means that the software company will no longer be supporting the software with feature updates or company support. That might not be a problem if you\u2019re an expert with the software and it meets your needs. The security problem arises because EOL software will no longer receive security updates, making your system and by extension, your network, vulnerable to attack. The OS won\u2019t magically stop working on the EOL date, but it becomes a threat.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      154,
      153,
      146,
      152,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 916,
    "question": "What type of malware is dangerous because it is loaded during system startup, before the antivirus software is able to load?",
    "choice_a": "Spyware",
    "choice_b": "Ransomware",
    "choice_c": "Boot sector virus",
    "choice_d": "Keylogger",
    "correct_answer": "C",
    "explanation": "When a virus infects the boot sector, the master boot record (MBR), or a partition table of a hard drive, it is called a boot sector virus. Boot sector viruses load before the operating system (OS) and security software can load. They may delete or modify files needed to boot the system, or the system may show no signs of being infected until an antivirus program is run. Removing the boot sector virus from a system may require booting to a different OS or drive. Spyware is designed to watch what you do and where you go, hoping to gain information such as logins, passwords, and bank account numbers. Ransomware locks a system in some way or encrypts data and won\u2019t allow access until the system\u2019s owner pays a ransom. A keylogger is malware that records every keystroke and reports it back to a third party. This information might include user IDs and passwords, or even bank account numbers and login information.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      130,
      134,
      128,
      129,
      132
    ],
    "source": "9781394330348"
  },
  {
    "id": 917,
    "question": "Which of the following is not a type of malware that needs to be eradicated from a computer system?",
    "choice_a": "Keylogger",
    "choice_b": "Virus",
    "choice_c": "Recovery console/WinRE",
    "choice_d": "Spyware",
    "correct_answer": "C",
    "explanation": "Keyloggers, viruses, and spyware are all types of malware, although anti-malware and antivirus are often used interchangeably. Windows Recovery Environment (WinRE), formerly known as the recovery console, is a tool used to repair problems with the operating system (OS). In addition to other tools such as startup repair and refreshing the OS, it provides access to a command prompt utility that can be used to correct problems without booting into the Windows OS.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      138,
      132,
      128,
      127,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 918,
    "question": "Which type of malware doesn\u2019t launch from a file, but rather is launched in memory, often utilizing tools like PowerShell, making it difficult to find and eradicate?",
    "choice_a": "Trojan",
    "choice_b": "Fileless",
    "choice_c": "Boot sector",
    "choice_d": "Stalkerware",
    "correct_answer": "B",
    "explanation": "Fileless malware hides in memory, so there is no digital footprint, thus making it impossible to use signature files to detect this malware. Instead, anti-malware for fileless attacks relies on memory scanning and behavior analysis, sometimes using Artificial Intelligence (AI) and Machine Learning (ML) to find and eradicate the malware. Trojans pretend to be a useful or desirable program but when the user installs them, they often open a backdoor for a user to infiltrate later. Boot sector viruses hide in the boot sector, which includes the master boot record (MBR) and partition table and launch before the operating system (OS) is loaded. Stalkerware is any software, whether a commercial app or a malware, that is used to perform surveillance on a person or business for malicious intent, which is stalking.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      131,
      128,
      130,
      134,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 919,
    "question": "You\u2019re reviewing the Event Viewer logs and notice repeated failed attempts to access the corporate bank account information. The attempts are originating from someone with a company login, and you are able to catch the person, an employee hired only a month ago, in the act. What type of attack is this?",
    "choice_a": "Insider threat",
    "choice_b": "Evil twin",
    "choice_c": "Whaling",
    "choice_d": "Social engineering",
    "correct_answer": "A",
    "explanation": "When someone who is an authorized user on your system attempts to gain access to something they should not or attempts a malicious act on your computer system, an insider threat has occurred. An evil twin is when an unauthorized wireless access point (WAP) appears on your network, using your service set identifier (SSID) and users are able to connect to the network using the unauthorized access point. Whaling is going after a big target using vishing or phishing. Social engineering is an attempt to acquire information about your network and system by social means, such as talking to people in the organization, shoulder surfing, tailgating, or other methods.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      142,
      145,
      117,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 920,
    "question": "Your web server just crashed because there was a flood of responses to a packet that looked like it was from your server, but your server didn\u2019t send it. What just happened?",
    "choice_a": "Whaling attack",
    "choice_b": "Denial-of-service attack",
    "choice_c": "Distributed denial-of-service attack",
    "choice_d": "Evil twin attack",
    "correct_answer": "B",
    "explanation": "This is a type of denial-of-service (DoS) attack. Someone spoofs your IP address (making it look like you) and sends out requests all at once to multiple hosts who respond to your IP address. Your server is flooded with those responses and crashes. It\u2019s called a denial-of-service attack, because users who want to use the server for legitimate purposes, such as placing an order, are unable to do so because of all the malicious traffic. Whaling is using phishing to go after a big target. Distributed denial-of-service (DDoS) attacks happen when many computers are used, as in a botnet. An evil twin attack happens when someone plugs an unauthorized wireless access point (WAP) into your network and gives it the same service set identifier (SSID) that your valid network has.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      144,
      147,
      142,
      145,
      149
    ],
    "source": "9781394330348"
  },
  {
    "id": 921,
    "question": "A computer user on your network is trying to access a folder named <code>Projects</code> on a local NTFS volume. Their user account is in the Developers group. The Developers group has Read & Execute permissions to the folder, and the user\u2019s user account has Full Control. What is the user\u2019s effective access to the <code>Projects</code> folder?",
    "choice_a": "Full Control",
    "choice_b": "Read & Execute",
    "choice_c": "Read",
    "choice_d": "No access",
    "correct_answer": "A",
    "explanation": "In this case, the user has Full Control. When there are conflicting New Technology File System (NTFS) permissions, generally they are combined, and the most liberal is granted. This holds true for conflicting permissions between groups or between a user\u2019s account and group memberships. The exception is Deny, which overrides all other permissions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      171,
      200,
      160,
      126,
      167
    ],
    "source": "9781394330348"
  },
  {
    "id": 922,
    "question": "You\u2019ve discovered that a system on your network has had its firewall turned off and antivirus disabled. What type of vulnerability does this present?",
    "choice_a": "Zero-day attack",
    "choice_b": "SQL injection",
    "choice_c": "Unprotected system",
    "choice_d": "Cross-site scripting",
    "correct_answer": "C",
    "explanation": "This system is vulnerable to attack because it is unprotected. The remedy is to turn on the system\u2019s software firewall and antivirus protection. Zero-day attacks happen the same day a vulnerability is discovered, and attackers are able to evade antivirus programs, because the antivirus companies have not had the time to respond to the vulnerability yet. A structured query language (SQL) injection occurs when an attacker puts code into a database instead of data, and the code is executed, giving the attacker access to the data in the database. Cross-site scripting (XSS) is similar to an SQL injection, except it uses a website and hypertext markup language (HTML) or JavaScript instead of a database. Code is injected into the website and used to gather data from legitimate website users, because their systems don\u2019t see the normally trusted website as a threat.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      134,
      154,
      152,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 923,
    "question": "What directory services security measure moves a user\u2019s data to a server and off the local drive, so that if a laptop is lost or stolen and someone gains access to it, they won\u2019t have access to information in the user\u2019s data files?",
    "choice_a": "Home folder",
    "choice_b": "Security group",
    "choice_c": "Organizational unit",
    "choice_d": "Login script",
    "correct_answer": "A",
    "explanation": "Using a home folder on an Active Directory server to store the user\u2019s files adds a level of security because the user\u2019s data is not on the local drive and is less subject to being stolen. A security group is used to grant permissions to a shared resource. Organizational units (OUs) are groupings that can include people, computers, and resources. Group policies can be applied to OUs ensuring that all computers and users in that group are given the proper access to resources. A login script is used to automate activities when a user or computer logs in to a domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      126,
      125,
      124,
      117,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 924,
    "question": "You notice that your computer seems to be working more than the normal updating it does when you\u2019re not actively using it. It also seems to be running more slowly than normal when you are using it. What type of malware uses your computing power instead of stealing your data?",
    "choice_a": "Spyware",
    "choice_b": "Ransomware",
    "choice_c": "Keyloggers",
    "choice_d": "Cryptominers",
    "correct_answer": "D",
    "explanation": "Cryptominers are malware that use your computing power rather than steal your data. You might notice that the computer is performing more slowly than usual. Spyware is designed to watch what you do and where you go, hoping to gain information such as logins, passwords, and bank account numbers. Ransomware locks a system in some way or encrypts data and won\u2019t allow access until the system\u2019s owner pays a ransom. A keylogger is malware that records every keystroke and reports it back to a third party.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      131,
      132,
      127,
      129,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 925,
    "question": "Which of the following is not important in preventing malware from damaging your computer system?",
    "choice_a": "User education regarding common threats",
    "choice_b": "Installing a keylogger",
    "choice_c": "Keeping anti-malware signatures up to date",
    "choice_d": "Keeping operating system, browser, and application patches up to date",
    "correct_answer": "B",
    "explanation": "Installing a keylogger would be installing malware, and exactly the opposite of what you need to do to keep the system safe. Educating users about malware types, including recognizing them, avoiding them, and what to do with suspicious emails, phone calls, and so on, is one of the best things you can do to protect a system. Keeping antivirus/anti-malware software updated so new malware can be detected, and keeping operating system (OSs), browsers, and applications updated to patch vulnerabilities is the key to keeping malware out.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      139,
      129,
      153,
      220,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 926,
    "question": "A user on your network wants to install an interesting browser extension they found on a download site that neither you nor they have used before. They received a warning before going to the site but clicked an option to continue. What type of website is this?",
    "choice_a": "Spoofed",
    "choice_b": "Trusted source",
    "choice_c": "Untrusted source",
    "choice_d": "Certified",
    "correct_answer": "C",
    "explanation": "This is an untrusted source. Not only have you never used it before, but there is a problem with the website\u2019s certificate that caused the warning message the user received. There is no evidence that it is a spoofed site. Clearly it does not have a valid digital certificate, and you\u2019ve never used it before, so it\u2019s not a trusted site. Digital certificates are issued by certificate authorities (CAs), who confirm that a website, person, or company is who they say they are.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      179,
      211,
      139,
      214,
      146
    ],
    "source": "9781394330348"
  },
  {
    "id": 927,
    "question": "As the IT person in a small firm using Windows OSs, you would like a window to pop up whenever apps try to make changes to a system, and when the user makes changes to the system, so that an administrator password will be required to be entered. What utility will you use to configure that setting?",
    "choice_a": "UAC",
    "choice_b": "Windows Defender Firewall",
    "choice_c": "Facial recognition",
    "choice_d": "Personalization",
    "correct_answer": "A",
    "explanation": "User account control (UAC) settings is where you can change when the operating system (OS) requests an administrator password before making changes to the system. The options range from Always Notify to Never Notify, with Notify Only if Apps Try to Make Changes between the two. UAC can be found in Windows 11 by going to the Control Panel, then choosing System and Security. Once there, select Security and Maintenance, then click Change User Account Control settings (and in Windows 10, choose Security and Maintenance in the Control Panel). Then click Change User Account Control settings. But in both versions of Windows, it\u2019s easier to simply search for UAC. Windows Defender Firewall is a software firewall included in Windows OSs. Facial recognition is a logon option, and Personalization allows you to change items such as themes, colors, and backgrounds.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      170,
      117,
      169,
      173,
      166
    ],
    "source": "9781394330348"
  },
  {
    "id": 928,
    "question": "A friend is considering purchasing an antivirus program. You let them know that there is one included with the Windows operating system. What settings should they look for in Windows settings?",
    "choice_a": "Windows Defender Firewall",
    "choice_b": "Virus & Threat Protection",
    "choice_c": "Windows Update",
    "choice_d": "Device Security",
    "correct_answer": "B",
    "explanation": "In both Windows 10 and 11, a quick search for virus & threat protection will bring you to the Windows settings for that feature. Windows Defender Firewall is a built-in firewall found in the Control Panel. Windows Update, which is in the Settings app, is for keeping the operating system (OS) files patched. Device security is also found in the Settings app, and it has settings and information for the security features of your computer, such as the trusted platform module (TPM) chip.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      134,
      140,
      153,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 929,
    "question": "Your company\u2019s website has been a victim of a botnet attack, causing your server to crash. What type of attack did the botnet attack cause?",
    "choice_a": "Brute-force",
    "choice_b": "Zero-day",
    "choice_c": "Distributed denial-of-service",
    "choice_d": "Non-compliant system",
    "correct_answer": "C",
    "explanation": "A distributed denial-of-service (DDoS) is caused by a botnet attack. It is a denial-of-service (DoS) attack because legitimate users are unable to access resources. The \u201cdistributed\u201d part of the name comes from the fact that there was traffic from many infected computers (i.e., zombies), in different locations, attacking your server at the same time, also known as a botnet. Bots, by themselves, are a form of software that runs automatically and autonomously and are not harmful. <i>Botnet</i>, however, has come to be the word used to describe malicious software running on multiple zombies and under the control of a bot-herder, the person perpetrating the attack. Both DoS and DDoS attacks can be launched by botnets, as can many forms of adware, spyware, and spam (via spambots). A brute-force attack uses software to repeatedly try to discover a password. Zero-day attacks happen the same day a vulnerability is discovered. Such attacks are able to evade antivirus/anti-malware programs because antivirus/anti-malware companies have not had time to respond to the vulnerability yet. A non-compliant system is one that is not updated or complying with corporate security policies.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      144,
      131,
      148,
      146,
      152
    ],
    "source": "9781394330348"
  },
  {
    "id": 930,
    "question": "What type of attack is like an SQL injection, except that it uses a website and HTML or JavaScript instead of a database, where malicious code is injected into the website (which is normally trusted by the user) and then used to gather data from the website user\u2019s computer because their systems don\u2019t see the normally trusted website as a threat?",
    "choice_a": "Zero-day attack",
    "choice_b": "SQL injection",
    "choice_c": "Unprotected system",
    "choice_d": "Cross-site scripting",
    "correct_answer": "D",
    "explanation": "Cross-site scripting (XSS) is similar to a structured query language (SQL) injection, except it uses a website and hypertext markup language (HTML) or JavaScript instead of a database. Code is injected into the website and used to gather data from legitimate website users, because their systems don\u2019t see the normally trusted website as a threat. Zero-day attacks happen the same day a vulnerability is discovered. Such attacks are able to evade antivirus programs because antivirus/anti-malware companies have not had time to respond to the vulnerability yet. An SQL injection occurs when an attacker places code into a database instead of data and the code is executed, giving the attacker access to the data in the database. An unprotected system is one that lacks normal measures of security such as a software firewall on the system and antivirus/anti-malware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      146,
      134,
      142,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 931,
    "question": "Your company has various locations, each with its own management needs, but wants a cohesive way to manage all the users, computers, and other resources on the network. What directory services feature will you enroll those users, computers, and resources into that will provide a way to manage each location in one place?",
    "choice_a": "Active Directory",
    "choice_b": "Organizational units",
    "choice_c": "Security groups",
    "choice_d": "Home folders",
    "correct_answer": "B",
    "explanation": "An organizational unit (OU) is a grouping of resources including people, computers, servers, printers, and so on, into a single centrally controlled unit. A domain is managed by Active Directory software. One best practice is to group the users into security groups and then establish access to resources on the group level, which will then give that access to members of the group. Home folders provide a central place on a server to store users\u2019 documents, each with their own home folder, which gets the documents off of the local computer, consolidating security for those folders into one place.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      126,
      117,
      200,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 932,
    "question": "The company\u2019s vice president just called you into the IT department because they received an email from you requesting their username and password. They didn\u2019t respond because they thought you should know them already. What kind of attack was just attempted?",
    "choice_a": "Phishing",
    "choice_b": "Vishing",
    "choice_c": "Whaling",
    "choice_d": "Evil twin",
    "correct_answer": "C",
    "explanation": "Whaling is an attack on a powerful or wealthy fish (i.e., person), phishing uses email, and vishing is using voice calls to gain information. Vishing, phishing, and whaling are variations of the same type of attack. In all of them, someone attempts to gain usernames, passwords, or other information by intimidation, coercion, or other means, collectively known as <i>social engineering</i>. Then they\u2019ll use that information to attack your company\u2019s systems. All the options are a play on the word fishing. The attacker is casting a line and hoping you will bite on it. An evil twin attack happens when someone plugs an unauthorized wireless access point (WAP) into your network and gives it the same service set identifier (SSID) that your valid network has.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      139,
      151,
      210,
      147
    ],
    "source": "9781394330348"
  },
  {
    "id": 933,
    "question": "What is the name of the software used to control access to resources in a Windows domain?",
    "choice_a": "Home folder",
    "choice_b": "Security group",
    "choice_c": "Organizational unit",
    "choice_d": "Active Directory",
    "correct_answer": "D",
    "explanation": "Active Directory is the name given to the software and large database that is used to manage resources on a Windows domain. Using a home folder on an Active Directory server to store the user\u2019s files adds a level of security because the user\u2019s data is not on the local drive and is less subject to being stolen. A security group is a group of computers or users that need the same access to resources. Permissions are granted to the security group and passed on to the group\u2019s members. Organizational units (OUs) are groupings that can include people, computers, and resources. Group policies can be applied to OUs, ensuring that all computers and users in that group are given the proper permissions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      126,
      117,
      170,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 934,
    "question": "You\u2019ve been reading about a recent malware that is causing problems for other companies and want to verify that your Windows built-in antivirus definitions are up to date. Where is this done?",
    "choice_a": "Virus and Threat Protection in the Settings app",
    "choice_b": "Virus and Threat Protection in the Control Panel",
    "choice_c": "Windows Defender Firewall in the Settings app",
    "choice_d": "Windows Defender Firewall in the Control Panel",
    "correct_answer": "A",
    "explanation": "Virus and threat protection can be found in the Settings app, in the Windows security section. There you can see when the last update was done and run a system scan, among other options. Virus and threat protection is not found in the other locations.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      173,
      134,
      153,
      217,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 935,
    "question": "You are a junior IT administrator, and your supervisor has asked you to ensure that all workstations have the built-in Windows firewall activated. Where can you go to do that? (Choose two.)",
    "choice_a": "Firewall & Network Protection in the Settings app",
    "choice_b": "Firewall & Network Protection in the Control Panel",
    "choice_c": "Windows Defender Firewall in the Settings app",
    "choice_d": "Windows Defender Firewall in the Control Panel",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "The Windows built-in firewall can be configured either in the Settings app, using Firewall & Network Protection, or in the Windows Defender Firewall, which is found in the Control Panel. It isn\u2019t found in the other two locations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      140,
      170,
      126,
      153
    ],
    "source": "9781394330348"
  },
  {
    "id": 936,
    "question": "Your company has started using new software in the cloud, but your users are finding that they can\u2019t use the software. Their computers are running Windows 11. What can you do to ensure that the software can be used remotely by the employees? (Choose two.)",
    "choice_a": "Click on Allow An App Through Firewall in the Firewall & Network Protection settings of the Settings app.",
    "choice_b": "Click on Allow An App Through Firewall in the Virus & Threat Protection settings of the Settings app.",
    "choice_c": "Click on Allow An App Through Firewall in Windows Defender Firewall, which can be found in the Control Panel.",
    "choice_d": "Add a new rule in Administrative Tools in the Control Panel.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The firewall can be configured to allow an application through (or block one) in both the Firewall & network protection settings of the Settings app or in Windows Defender Firewall in the Control Panel. Virus & threat protections are for configuring antivirus. It is not configured in the Virus & threat protection settings of the Settings app. Administrative tools is found in Windows 10, but not Windows 11 where it was replaced with Windows Tools, and it doesn\u2019t have settings for the firewall, although it does contain a shortcut to the Windows Defender Firewall.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      140,
      170,
      126,
      153
    ],
    "source": "9781394330348"
  },
  {
    "id": 937,
    "question": "Employees at your company work on very confidential projects. All employees have been instructed to lock their screens whenever they walk away from their computer, even if it\u2019s only for a minute. What key sequence will immediately lock their desktop and require a password to reenter?",
    "choice_a": "Windows Logo Key+X key",
    "choice_b": "Windows Logo Key+L key",
    "choice_c": "Windows Logo Key+Right arrow",
    "choice_d": "Windows Logo Key+D key",
    "correct_answer": "B",
    "explanation": "Use the Windows Logo key + L key simultaneously to lock the Windows desktop. Windows Logo key + X key brings up the Power Menu, which has shortcuts to many often-used tools. Windows Logo key + Right arrow will snap the active window to the right half of the screen, and Windows Logo key + the D key displays the desktop by minimizing all the other apps. These keyboard shortcuts work in both Windows 10 and Windows 11.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      170,
      167,
      169,
      190
    ],
    "source": "9781394330348"
  },
  {
    "id": 938,
    "question": "Your employees have all been trained in end-user best practices, including locking their laptop when they walk away from it. What can be done to ensure that each employee\u2019s laptop and its data will remain with the company and not fall into someone else\u2019s hands? (Choose two.)",
    "choice_a": "Use a cable equipment lock to secure the laptop to the desk.",
    "choice_b": "Use MDM software to wipe the laptop remotely if stolen.",
    "choice_c": "Place the laptop in a desk drawer when the employee walks away.",
    "choice_d": "Ask a stranger to watch the laptop when they use the restroom at a coffee shop.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "A laptop cable lock is a type of equipment lock that uses a special slot on the laptop\u2019s side and a very strong cable wrapped around something solid, like a desk, to secure the laptop to the work area. A key is used to free the laptop from the cable when you want to take it somewhere. Mobile device management (MDM) software can be used to wipe a laptop remotely if it is stolen. Placing a laptop in a desk drawer might get it out of sight, but it is still vulnerable, and you should never let a laptop out of your sight when you\u2019re in a public place.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      190,
      155,
      124,
      111,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 939,
    "question": "You\u2019re setting up authentication for new users of Windows 10 and Windows 11 desktop machines. Which of the following Windows logon methods require specific hardware? (Choose two.)",
    "choice_a": "Username and password",
    "choice_b": "PIN",
    "choice_c": "Fingerprint identification",
    "choice_d": "Facial recognition",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Fingerprint scanners and facial recognition technology are both biometric logins and require a fingerprint reader and camera, respectively, as well as special software to interpret the input. Many laptops come equipped with this hardware, but not all. Both could be added to a laptop or desktop that is missing the hardware by connecting them via a universal serial bus (USB) port. A username and password can also be used, and a personal identification number (PIN) is used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      169,
      115,
      120,
      121,
      191
    ],
    "source": "9781394330348"
  },
  {
    "id": 940,
    "question": "You\u2019re setting up new users on your network and have told them that they will need to change their user password the first time they log in, and that their password must meet complexity requirements. Which of the following is not true about password best practices?",
    "choice_a": "Passwords minimum length is eight characters.",
    "choice_b": "Longer passwords are better.",
    "choice_c": "At least one of each of these should be used: upper- and lowercase letters, numbers, and special characters.",
    "choice_d": "Passwords four characters long are okay if they are complex.",
    "correct_answer": "D",
    "explanation": "Passwords should be a bare minimum of eight characters long, and complexity should be required using at least one upper- and lowercase letter, number, and special character. If you must choose between a longer password or a more complex password, then longer is better. Four characters is definitely not long enough.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      157,
      158,
      148,
      160,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 941,
    "question": "You\u2019ve just hired a new employee who will be working at a Windows workstation on your network. You\u2019re helping the user understand what their password should be like. Which of the following are best practices for passwords? (Choose two.)",
    "choice_a": "Password complexity is enforced.",
    "choice_b": "Passwords should be easy to guess in case you forget, like your dog\u2019s name.",
    "choice_c": "Password expiration after 45 days",
    "choice_d": "Password expiration after 180 days",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Password complexity should be enforced. Passwords created by a user are better than randomly generated passwords, because the user can remember them easier without having to write them down. They should not, however, be something that is easy for someone else to guess, like their dog\u2019s name or someone\u2019s birthday. Passwords should expire after a reasonable time, making it more difficult for someone to use a compromised password. A length of 180 days (i.e., six months) is too long of a time between password expiration, but 45\u201390 days is more reasonable.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      157,
      158,
      160,
      161,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 942,
    "question": "Your company has a Windows domain managed by a Domain Controller. Following best practices, what feature of the Domain Controller is used to apply permissions to users?",
    "choice_a": "Active Directory",
    "choice_b": "User accounts",
    "choice_c": "Security groups",
    "choice_d": "Home folders",
    "correct_answer": "C",
    "explanation": "A domain is a grouping of resources, including people, computers, servers, printers, and so on, into a single centrally controlled unit. The domain is managed by Active Directory software. One best practice is to group the users into security groups and then assign permissions to the security groups. Security group members will all have the access that was assigned to the group. Home folders provide a central place for the users\u2019 documents, each with their own home folder on the server. This removes the documents from the local computer, consolidating security for those folders into one place.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      126,
      125,
      171,
      200,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 943,
    "question": "You\u2019re examining password considerations such as length, complexity, and expiration for several Windows 11 Pro workstations. What utility can you use on the workstation to configure the password requirements?",
    "choice_a": "Users Accounts in the Control Panel",
    "choice_b": "Local Users and Groups",
    "choice_c": "Administrative Tools",
    "choice_d": "Local Security Policy",
    "correct_answer": "D",
    "explanation": "Password policies such as history, password age, length, and complexity can be found by searching for and choosing Local Security Policy, then opening Password Policy. User Accounts in the Control Panel is for adding and managing users. You can set the password there, but not the password policies. Administrative Tools is available in Windows 10, but not Windows 11, where it was replaced with Windows Tools. Local Security Policy is in Pro editions of Windows 10 and 11 only, not Home editions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      158,
      157,
      126,
      167,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 944,
    "question": "Which of the following is a protocol that facilitates communication between an identification provider and a service provider, such as a web application, by passing an electronic authentication token between them, enabling single sign-on?",
    "choice_a": "SSO",
    "choice_b": "SAML",
    "choice_c": "PAM",
    "choice_d": "IAM",
    "correct_answer": "B",
    "explanation": "Security assertions markup language (SAML) is a protocol that passes an identity token between an identification provider (IdP) and a service provider (SP), enabling secure single sign-on (SSO). A one-time password (OTP) is often delivered via email or short message service (SMS) and is only valid for that session. This helps verify that the person requesting access is the person who previously entered their email or phone number into a system. Privileged access management (PAM) keeps track of any entity that has more than standard access to resources, whether the entity is human, application, or machine. Identity access management (IAM) is similar to PAM, except that it is for any entity, not just privileged entities. It provides a framework for monitoring identities and access using adaptive multifactor authentication (MFA).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      125,
      123,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 945,
    "question": "A computer user is setting up a new Windows 11 Home computer for the first time. They called you because they can\u2019t figure out how to set it up with a local account. What will you tell them?",
    "choice_a": "That option is not available. They must use a Microsoft account.",
    "choice_b": "Press F10 during bootup to create a local account.",
    "choice_c": "They must switch to the Pro edition if they want to use a local account after setup.",
    "choice_d": "Local accounts are never available in Windows 11.",
    "correct_answer": "A",
    "explanation": "When setting up a Windows 11 Home PC for the first time, you are required to use a Microsoft account. The setup will allow you to create an account during setup. Pressing F10 does not change the type of account you need to set up Windows 11 Home. A local account can be used whether they have Windows 11 Home or Pro, but when setting up the Home version, it must be set up with a Microsoft account. It is possible to add a local account later and use it to log in to either Windows 11 Home or Pro.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      166,
      160,
      153,
      170,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 946,
    "question": "When using a Microsoft account to log in to your Windows 11 computer, which of the following is not true?",
    "choice_a": "Your username is your email.",
    "choice_b": "There are more recovery options if you use a Microsoft account rather than a local account to access your computer.",
    "choice_c": "You won\u2019t be able to use your computer if your Internet access is down.",
    "choice_d": "You can access information stored on OneDrive from another computer if you log in with your Microsoft account.",
    "correct_answer": "C",
    "explanation": "You will be able to use your computer if you log in using your Microsoft account, even if the Internet is down. It will just use cached versions of files. All other options are true.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      166,
      168,
      160,
      170,
      153
    ],
    "source": "9781394330348"
  },
  {
    "id": 947,
    "question": "Your friend wants to change the password for another user who has forgotten their password and is unable to log in to the PC. When they try to access User Accounts in the Control Panel, they are unable to access it. What will you tell them?",
    "choice_a": "They need administrator access to change or create another user\u2019s account, and their user account is only a Standard account.",
    "choice_b": "They can change it in Local Users and Groups.",
    "choice_c": "They need to use the command-line utility to change the user\u2019s password.",
    "choice_d": "They can\u2019t change the password, but they can add a new username for the password and make the new user an administrator so they can access their data.",
    "correct_answer": "A",
    "explanation": "Administrators have access to everything in the system, but a Standard user account is limited in what they can do. They are not able to add or manage another user\u2019s account, for example. Nor are they able to access another user\u2019s files. Local Users and Groups is available in Pro or greater editions, but a Standard user still won\u2019t be able to manage users there or with the command line.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      170,
      117,
      168,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 948,
    "question": "You are disposing of used hard drives, and a network administrator recommends performing a low-level format. What is the difference between a low-level format and a standard format?",
    "choice_a": "Low-level formats are performed at the factory, and standard formats are performed using the <code>format</code> command.",
    "choice_b": "Standard formats are performed at the factory, and low-level formats are performed using the <code>format</code> command.",
    "choice_c": "A modern low-level format fills the entire drive with zeros, returning it to factory mode. A standard format creates the master file table (MFT) and root directory.",
    "choice_d": "A standard format records the tracks and marks the start of each sector on each track. A low-level format creates the file allocation table and root directory.",
    "correct_answer": "C",
    "explanation": "What is known as a low-level format now (also called a Zero-fill) is drastically different than it was years ago. The intent is the same though, which is to erase all data on the hard drive so it\u2019s not recoverable. Technically, the low-level format needs to happen first. Then the drive is partitioned, creating one or more sections, and a standard format is used to create the file allocation table and root directory.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      162,
      163,
      164,
      174,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 949,
    "question": "What three ways can a user sign on to a Windows system using the passwordless Windows Hello sign-on? (Choose three.)",
    "choice_a": "Single device PIN",
    "choice_b": "MFA",
    "choice_c": "Fingerprint",
    "choice_d": "Facial recognition",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Windows Hello is a passwordless way to sign on to a Windows workstation. Instead of a password, a user can enter a personal identification number (PIN) that is only valid for that one device or use biometrics\u2014a fingerprint or facial recognition\u2014to log in to their device. Multifactor authentication (MFA) is using more than one method to prove who you are.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      169,
      115,
      121,
      120,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 950,
    "question": "You work for a bank whose policy is to physically destroy, rather than recycle, hard drives that are no longer needed. Which of the following is not a physical destruction method for hard drives?",
    "choice_a": "Incinerating",
    "choice_b": "Drilling",
    "choice_c": "Zero filling",
    "choice_d": "Shredding",
    "correct_answer": "C",
    "explanation": "Zero filling a drive will make data that was once on the drive unreadable, but it is not a physical destruction method. Methods of physical destruction include drilling, shredding, degaussing, and incinerating.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      164,
      162,
      163,
      165,
      108
    ],
    "source": "9781394330348"
  },
  {
    "id": 951,
    "question": "A friend is getting overwhelmed with the number of website passwords they need to remember and has been writing them down. But the passwords aren\u2019t very complex, and your friend has used the same ones on several sites. You offer to help them. What will you do?",
    "choice_a": "Clear their browser cache.",
    "choice_b": "Clear their browsing data.",
    "choice_c": "Update their certificates.",
    "choice_d": "Show them how to use their browser\u2019s password manager.",
    "correct_answer": "D",
    "explanation": "A password manager is software that uses algorithms to generate secure passwords. The passwords are encrypted in the software manager. In a browser, the user typically only needs to remember their email or login password to gain access to the others. Most password managers will use two-factor authentication (2FA) to allow the user to log in and change any passwords. Websites that you access are stored in a cache on your computer so that the next time you visit the website, it will only download the changes and make websites load much more quickly. If a website you visit isn\u2019t updating properly, clearing the cache should resolve the issue. Certificates are issued by a certificate authority and prove that the website (or person) is who they say they are. A browser might warn you or block your access to a website whose certificate is expired or invalid.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      157,
      121,
      158,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 952,
    "question": "You work for a company that is trying to be green. The company wants to repurpose its old PCs by giving them to a charitable organization rather than destroying or recycling them. What should you do before you give them away? (Choose two.)",
    "choice_a": "Wipe all the drives.",
    "choice_b": "Low-level-format the drives.",
    "choice_c": "Standard-format the drives.",
    "choice_d": "Delete all the PCs\u2019 users and all their files and leave a generic Administrator account active.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Before you give a computer to someone else, you will certainly want to remove all of your data from it by using a drive-wiping software. But to be sure everything is gone, zero-write (also called a low-level format) the drive to restore it to its factory default condition. This can often be accomplished with a utility provided by the computer manufacturer, or in Windows, by using options in the Windows Recovery Environment (WinRE), also known as the Recovery Console. A standard format creates the master file table (MFT) and root directory.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      138,
      156,
      174
    ],
    "source": "9781394330348"
  },
  {
    "id": 953,
    "question": "You\u2019re donating a Windows PC to a charity but first want to remove all your data and restore the PC\u2019s OS to its original factory installation. You\u2019ve booted into the Windows recovery environment (WinRE). What does Microsoft call the recovery option to reinstall the OS and delete all user files and data?",
    "choice_a": "Refresh Your PC",
    "choice_b": "Reset Your PC",
    "choice_c": "Restore Your PC",
    "choice_d": "Repair Your PC",
    "correct_answer": "B",
    "explanation": "In the Windows Recovery Environment (WinRE), choose Troubleshoot, then Reset this PC. Choosing Reset this PC will give you two options. You can choose to keep your personal files but remove apps and settings or remove everything including your files and perform a fresh install. In this scenario, choose to remove everything. Refresh, restore, and repair do not have the option to reset the PC to factory default.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      162,
      153,
      220,
      173
    ],
    "source": "9781394330348"
  },
  {
    "id": 954,
    "question": "You are setting up a Windows 11 Pro computer that will house data shared by several people. How will you establish security for this group?",
    "choice_a": "Use the Local Users and Groups app to create groups such as Accounting, Office, and so on. Then set up permissions for each group on shared files. Add users to and remove them from the group as needed.",
    "choice_b": "In the Control Panel, User Accounts, make all the users Administrators so they can do what they need.",
    "choice_c": "Use the Local Users and Groups app to create groups such as Accounting, Office, and so on. Then set up permissions for each person on the shared files. Add users to the groups just for organizational purposes.",
    "choice_d": "Groups are only used on servers, so set up each person with their specific NTFS permissions on the shared data folders.",
    "correct_answer": "A",
    "explanation": "Choice A, use the Local Users and Groups app to create groups, set up permissions for each group on shared files, then add users to the group as needed, is considered a best practice. By arranging security in this way, when someone changes jobs, leaves the company, or joins the company, all you need to do is remove the user from the group and/or add them to the group with the security access that they need. This process saves on human error, as there is just one place that security is set up (for the group) instead of establishing the settings for each individual user. Local Users and Groups is available in Pro or better versions of modern Windows Operating Systems (OSs).",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      200,
      167,
      117,
      171,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 955,
    "question": "You\u2019re providing system training to new employees, and they want to know where they should keep their passwords. What will you tell them? (Choose two.)",
    "choice_a": "Passwords should be written on a sticky note and attached to the bottom of their keyboard.",
    "choice_b": "Passwords will be saved in password manager software, and multifactor authentication is used for network access.",
    "choice_c": "Passwords should be taped to the monitor where they can see them.",
    "choice_d": "They need to memorize their password and not write it down.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "One of the best practices you can do to protect a network is to train employees on how to handle IT information and events. All too often, users place their passwords where they are easy for them to find, but they are also too easy for someone with malicious intent to find. Passwords need to meet complexity requirements but be simple enough for users to remember. Other tools for securing passwords are to use password management software and multifactor authentication (MFA). Windows Credential Manager and macOS Keychain are two utilities that can manage passwords for users. Credential Manager is not on the CompTIA A+ objectives, but Keychain is, as is using password managers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      121,
      139,
      159,
      158
    ],
    "source": "9781394330348"
  },
  {
    "id": 956,
    "question": "One of your suppliers called today to tell you that its customer database and purchase order system have been compromised, and your company is one of the few whose information has been tampered with. The supplier is providing you with new authentication information and suggests that you change the passwords you\u2019re using to access its systems. What has happened here?",
    "choice_a": "QR code phishing",
    "choice_b": "Ransomware",
    "choice_c": "Whaling",
    "choice_d": "Supply chain/pipeline attack",
    "correct_answer": "D",
    "explanation": "A supply chain/pipeline attack occurs when a malicious actor attempts to infiltrate a larger company by attacking one of their suppliers. QR code phishing happens when an unsuspecting person scans a QR code and visits a site that they think is legitimate, but it\u2019s actually a phishing site intended to gather their personal information. Ransomware is software that holds your company\u2019s network or information hostage in a logical way, such as encrypting your hard drive and refusing to give you the key until you pay a ransom. Whaling is phishing for a wealthy or influential target.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      142,
      120,
      139,
      152
    ],
    "source": "9781394330348"
  },
  {
    "id": 957,
    "question": "Workers have been instructed to log off or lock their computers whenever they walk away from them, but as you walk around the company, you notice computers unlocked when no one is sitting there. Which of the following are the best ways to mitigate this problem? (Choose two.)",
    "choice_a": "Fire people who won\u2019t lock their computer.",
    "choice_b": "Enforce screensaver locks after a short time of inactivity.",
    "choice_c": "Train users on the importance of locking their PCs.",
    "choice_d": "Enforce password complexity.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Configuring all the computers to lock the screensaver after a short period of inactivity would help mitigate the problem. If a user was still at their desk but doing something else, they could easily enter their password and log in again. Training employees on network and data safety is always helpful. Firing them would be a very drastic measure, but depending on the environment, it might be the company\u2019s policy. However, it won\u2019t prevent someone from accessing a system. Enforcing password complexity should always be done, but it also won\u2019t prevent someone from accessing a system that isn\u2019t locked or logged off.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      159,
      139,
      157,
      158,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 958,
    "question": "Data encryption has been established for data that travels across the network, but you work in a secure environment and want to encrypt all the data on users\u2019 storage drives, including laptop drives, to prevent dissemination of information if the drives are compromised or stolen. Which of the following would not be a good solution to encrypt this data-at-rest?",
    "choice_a": "Use EFS and let the employee choose what to encrypt.",
    "choice_b": "Use a third-party encryption solution.",
    "choice_c": "Use MDM software.",
    "choice_d": "Use BitLocker on desktop systems.",
    "correct_answer": "A",
    "explanation": "Data-at-rest is any data that is sitting on a drive or stored somewhere. It\u2019s not moving between network locations but needs to be protected. Letting employees choose what to encrypt with encrypting file system (EFS) is not a good solution, because it opens too much possibility for human error. There are third-party companies that specialize in protecting data-at-rest. Other solutions are to use mobile device management (MDM) software. Using MDM, the IT administrator can enforce encryption on remote devices, even those owned by employees who are using their personal devices for company business. If the device is lost or stolen, company data can be wiped from it using MDM software. BitLocker is a solution for encrypting entire hard drives, but it requires Pro or higher editions of both Windows 10 and 11, and a trusted platform module (TPM) chip or module on the motherboard. BitLocker stores an encryption key in the TPM, and the TPM will only allow access to the key when the computer starts as expected.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      174,
      156,
      124,
      155,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 959,
    "question": "You have a new smartphone that can authorize a transaction by using your phone\u2019s camera while you are simply looking at it. What is this technology called?",
    "choice_a": "PIN code",
    "choice_b": "Fingerprint scanner",
    "choice_c": "Device encryption",
    "choice_d": "Facial recognition",
    "correct_answer": "D",
    "explanation": "Facial recognition and fingerprint readers are available on most smartphones and mobile devices. Facial recognition uses your cell phone\u2019s camera, sensors, and a dot projector to make a 3D map of your face. Your phone then uses that 3D map to recognize you for future transactions. Personal identification number (PIN) codes are numbers that you enter to gain access. Fingerprint scanners require that you touch a spot repeatedly to configure the scanner so it will identify you. Once the device has a map of your fingerprint, you can use your finger to log in or authorize certain transactions. Device encryption is not a method of identifying the user.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      191,
      169,
      120,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 960,
    "question": "Which method of logging in to a mobile device may make it easy for someone to guess your password based on marks left by the oils in your skin?",
    "choice_a": "Facial recognition",
    "choice_b": "Fingerprint",
    "choice_c": "Pattern",
    "choice_d": "Swipe",
    "correct_answer": "C",
    "explanation": "Some mobile devices allow the user to draw a pattern on the screen that is recognized by the device, then the user is allowed access. The problem with using this security device is that, because the pattern is repeatedly drawn on the screen, someone may see the oils left behind by your skin and be able to figure out the pattern that is drawn. Facial recognition uses the mobile device\u2019s camera to make and store a 3D map of your face. To gain access to the device, the camera reads your face again and compares it to the stored image. Fingerprint readers compare your fingerprint to one stored on the device for access. With a swipe lock, the user merely swipes across the screen to unlock it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      120,
      159,
      192,
      228
    ],
    "source": "9781394330348"
  },
  {
    "id": 961,
    "question": "Which of the following is the least secure way to access a mobile device whose screen is locked?",
    "choice_a": "Facial recognition",
    "choice_b": "PIN code",
    "choice_c": "Swipe",
    "choice_d": "Pattern",
    "correct_answer": "C",
    "explanation": "Most mobile devices will lock after a period of inactivity. For some, merely swiping across the device will unlock it. Because this can be done by anyone, it isn\u2019t secure. Facial recognition is a biometric type of identification (i.e., something that you are), so it is quite secure depending on the software used to recognize the face. Personal identification number (PIN) codes and patterns are something that a user must know and although a hacker might figure them out, they\u2019re still more secure than merely swiping across the device.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      191,
      120,
      115,
      169,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 962,
    "question": "You just installed a security camera that communicates on port 4150. The video camera is connected to your SOHO router. With the camera set up, you can view the video stream from your computer that is on the same SOHO router, but not remotely on your phone or another computer. What did you forget to do?",
    "choice_a": "Configure port forwarding on the router",
    "choice_b": "Close port 4150",
    "choice_c": "Connect the camera to the router",
    "choice_d": "Disable the firewall",
    "correct_answer": "A",
    "explanation": "Because the camera communicates over port 4150, the port would need to be open and have port forwarding configured, so your remote connection can access the camera, through the router, using that port. You know that the camera is properly connected to the router because you can access the video stream on it from a computer connected to the same router. Disabling the firewall should not be done because the firewall is a vital part of your network\u2019s security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      187,
      140,
      109,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 963,
    "question": "You are installing a SOHO router and a wired network for a small office. The manager is concerned that employees will visit websites with objectionable material. Which feature should you look for in a router to help prevent such access?",
    "choice_a": "Content filtering",
    "choice_b": "Disabling ports",
    "choice_c": "VPN access",
    "choice_d": "Port forwarding/mapping",
    "correct_answer": "A",
    "explanation": "Content filtering is the process of blocking objectionable content from either websites or email. Many routers and firewalls will provide content filtering services. In many cases, a reference service is used to block websites, and filters can be implemented to scan emails for prohibited content. Disabling ports stops traffic from entering the network; it does not filter for content. Virtual private network (VPN) access means that a user can access the network remotely just as if they were sitting in the office. Port forwarding/mapping is used when you need traffic on a particular port to go to a particular network device. It is often used for gaming and security cameras.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      187,
      194,
      189,
      182,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 964,
    "question": "Your office is in a building with several other companies. You want to configure the wireless network so that casual users in the building are not able to easily see your network name. What should you do to configure this?",
    "choice_a": "Enable WPA3.",
    "choice_b": "Enable MAC filtering.",
    "choice_c": "Disable SSID broadcasts.",
    "choice_d": "Reduce radio power levels.",
    "correct_answer": "C",
    "explanation": "One method of \u201cprotecting\u201d the network that is often recommended is to turn off the service set identifier (SSID) broadcast. The SSID is the name of your network. The access point is still there and can still be accessed by those who know of it, but it prevents those who are looking at a list of available networks from finding it. This should be considered a weak form of security because there are still ways, albeit a bit more complicated, to discover the presence of the access point besides the SSID broadcast. Wi-Fi protected access 3 (WPA3) is the most recent secure Wi-Fi encryption standard; however, it has suffered password leaks. The vulnerabilities are expected to be mitigated with future updates. Media access control (MAC) filtering allows or denies access to the network based on the MAC address associated with a network interface card (NIC). Reducing radio power levels won\u2019t send the network\u2019s signal as far, but it won\u2019t hide the network\u2019s name from anyone within range.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      182,
      184,
      180,
      185,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 965,
    "question": "You\u2019re changing some configuration settings on your SOHO router and notice that WPA3 is not available. What might you be able to do to resolve this issue?",
    "choice_a": "Configure port forwarding.",
    "choice_b": "Configure content filtering.",
    "choice_c": "Update the SSID.",
    "choice_d": "Update the router\u2019s firmware.",
    "correct_answer": "D",
    "explanation": "Just like computers, routers occasionally need their software updated to add new features or correct security holes. On a router this is called a firmware update, because it is updating software that is embedded in chips on the router\u2019s circuit board (i.e., the router\u2019s firmware). Port forwarding will send traffic for a specified port number to a specified computer. Content filtering inspects packets for specified content and rejects or allows packets to enter or leave the network based on those criteria. The service set identifier (SSID) is the name of the network.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      186,
      180,
      182,
      189,
      187
    ],
    "source": "9781394330348"
  },
  {
    "id": 966,
    "question": "Which of the following are very fast and very secure ways to access your mobile device? (Choose two.)",
    "choice_a": "PIN code",
    "choice_b": "Fingerprint",
    "choice_c": "Swipe",
    "choice_d": "Facial recognition",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Facial recognition and fingerprint readers are available on most smartphones and mobile devices, and they can identify you faster than you can enter numbers on a screen. Facial recognition uses your smartphone\u2019s camera, sensors, and a dot projector to make a 3D map of your face. The phone then uses that 3D map to recognize you for future transactions. Fingerprint readers can use capacitive, optical, or ultrasonic sensors, but regardless of the method, they make a map of your fingerprint and, like facial recognition, compare that map to your body. With either one, you can gain access to a device or authorize a transaction in about one second. PIN codes are a number that you enter to gain access. They can be entered quickly but can also be guessed, so they\u2019re not as secure as biometrics (i.e., fingerprint scanning and facial recognition). Using a swipe to unlock a mobile device is fast, but not secure.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      115,
      169,
      120,
      192
    ],
    "source": "9781394330348"
  },
  {
    "id": 967,
    "question": "In most browsers, where will you find the ability to enable or disable plug-ins/extensions and features?",
    "choice_a": "Browser history",
    "choice_b": "The browser\u2019s website",
    "choice_c": "The browser\u2019s settings",
    "choice_d": "Windows Settings",
    "correct_answer": "C",
    "explanation": "Most often enabling and disabling features can be found in the browser settings, although the exact path depends on the browser being used. For example, in the Opera browser, extensions can be found on the toolbar. Your browser history keeps track of where you\u2019ve been on the Internet. The browser\u2019s website might tell you how to enable and disable features, but isn\u2019t where you would configure them, neither is Windows Settings.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      179,
      176,
      178,
      177,
      175
    ],
    "source": "9781394330348"
  },
  {
    "id": 968,
    "question": "What method of securing a mobile device requires entering a series of numbers?",
    "choice_a": "PIN code",
    "choice_b": "Fingerprint",
    "choice_c": "Pattern",
    "choice_d": "Facial recognition",
    "correct_answer": "A",
    "explanation": "A personal identification number (PIN) code is a number that you enter to gain access to a mobile device. Fingerprint scanners and facial recognition systems are biometrics, meaning that they use a part of your body to identify you. Once a 3D map of your face or fingerprint is made, that map is compared to the new one generated when you touch the screen or look into the camera. If they match, access is granted. Drawing a pattern on the device\u2019s screen is also sometimes used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      192,
      120,
      115,
      159
    ],
    "source": "9781394330348"
  },
  {
    "id": 969,
    "question": "Your company has a policy that allows you to use your personal smartphone for company work because it will save the company money and is convenient for you. The IT manager installed some company software on it, and now you can\u2019t get into your favorite fantasy football gambling site. What has happened?",
    "choice_a": "Remote wipe",
    "choice_b": "Content filtering",
    "choice_c": "Application updates",
    "choice_d": "Malware attack",
    "correct_answer": "B",
    "explanation": "Although your first instinct might be to think you\u2019re the victim of a malware attack, it\u2019s most likely that your company made you sign a mobile device management (MDM) policy or bring your own device (BYOD) policy that says they can install content filtering software on your device. Content filtering is used to block any incoming or outgoing traffic that may be dangerous, sensitive, or inappropriate. It\u2019s likely that the policy also says that they can remotely wipe their data and applications from your device if you leave the company. Application updates are one of the many actions you should take to protect/harden a system, and a malware attack is unwanted software that invades your system and harms you in some way.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      198,
      155,
      124,
      194,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 970,
    "question": "You own a small company with a SOHO router and a web server that is used to sell your products. You don\u2019t want the IP address of your web server to change, so you\u2019ve paid the ISP for a specific IP address that is yours and will not change. What would you configure on your router for your ISP connection?",
    "choice_a": "Dynamic WAN IP",
    "choice_b": "Static WAN IP",
    "choice_c": "UPnP",
    "choice_d": "Screened subnet",
    "correct_answer": "B",
    "explanation": "On your router, you would configure a static wide area network (WAN) Internet provider (IP) address. That is the address that the Internet service provider (ISP) has assigned to you. Usually the ISP uses dynamic addressing, and your WAN setting would be Dynamic WAN IP, so having a static WAN IP generally involves higher fees paid to the ISP. Universal plug and play (UPnP) is a protocol that lets devices find and communicate with each other on your local area network (LAN), such as your laptop and printer. Unfortunately, UPnP could also be used by malware to spread to other devices on your network. A screened subnet uses one or more routers to create a separate area on a network where servers, such as a web server, can be accessed either from inside the LAN or from the Internet. It provides greater security and protects the LAN.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      189,
      188,
      182,
      187,
      140
    ],
    "source": "9781394330348"
  },
  {
    "id": 971,
    "question": "What is the protocol that allows devices on your LAN, such as your laptop and printer, to find each other?",
    "choice_a": "WPA3",
    "choice_b": "WPA2",
    "choice_c": "PIN",
    "choice_d": "UPnP",
    "correct_answer": "D",
    "explanation": "Universal plug and play (UPnP) is a protocol that lets devices find and communicate with each other on your local area network (LAN) such as your laptop and your printer. Unfortunately, UPnP could also be used by malware to spread to other devices on your network. Wi-Fi protected access version 3(WPA3) and Wi-Fi protected access version 2 (WPA2) are wireless networking encryption protocols. A personal identification number (PIN) is used to authenticate to a computer system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      189,
      180,
      183,
      184,
      145
    ],
    "source": "9781394330348"
  },
  {
    "id": 972,
    "question": "You are configuring a new SOHO router that replaced a failed one. Your network has a mixture of devices purchased several years ago and newer ones purchased in 2025. Which of the following encryption options should you choose?",
    "choice_a": "WPA3",
    "choice_b": "WPA2",
    "choice_c": "WPA2/WPA3",
    "choice_d": "WEP",
    "correct_answer": "C",
    "explanation": "Wi-Fi protected access version 3 (WPA3) is the newest and most secure wireless encryption protocol for your small office/home office (SOHO) router; however, the devices that you\u2019ve had for a few years might not be able to work with it. For the time being, until those legacy devices can be replaced, it\u2019s best to use the WPA2/WPA3 mixed mode so that all your devices can connect to the network as securely as possible. Wired equivalent privacy (WEP) and Wi-Fi protected access (WPA) should no longer be used, as they are not secure. WEP and WPA are not listed in the CompTIA A+ exam objectives, but WPA2 and WPA3 are. A better alternative than mixed mode, if possible, is to put the older devices on their own network using WPA2 until they can be replaced and the devices that support WPA3 on a network with only WPA3 to protect that part of the network at a higher level.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      180,
      182,
      184,
      145,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 973,
    "question": "You perform very confidential work as a government contractor, and you work from home. Your contract specifies that the only external computers your computer can communicate with are the government computers involved in the project. What can you configure on your router to block all other computers from communicating with your network?",
    "choice_a": "IP address filtering",
    "choice_b": "Untrusted sources",
    "choice_c": "Hashing",
    "choice_d": "Port filtering",
    "correct_answer": "A",
    "explanation": "Configuring IP filtering enables you to set which IP addresses are allowed to communicate through your router and which are not. Untrusted sources are websites that your browser has deemed suspicious or dangerous, and it warns you of such. Hashing is the act of translating a character string into code. Port filtering is a way of allowing or denying access to a network based on the port number in the packet. Filtering router traffic by port is also an excellent security practice.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      187,
      189,
      140,
      182,
      188
    ],
    "source": "9781394330348"
  },
  {
    "id": 974,
    "question": "Your company has decided to allow users to use their own devices for company business. This decision will save the company money on hardware. To use their personal devices, the company will require that employees sign an agreement. What would this agreement be called?",
    "choice_a": "BYOD policy",
    "choice_b": "MDM policy",
    "choice_c": "Cell phone policy",
    "choice_d": "Remote work policy",
    "correct_answer": "A",
    "explanation": "A company may have many policies and procedures that employees must agree to as a condition of employment. The bring your own device (BYOD) policy describes the conditions for an employee using their own device for company business. This policy likely includes that the company will use mobile device management (MDM) software to secure the company information on the user\u2019s device. Companies may have many other policies like cell phone policies and remote work policies, but those are not the name given for using your own device for work.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      124,
      155,
      232,
      195
    ],
    "source": "9781394330348"
  },
  {
    "id": 975,
    "question": "Your iPhone requires a passcode to unlock it. Because of recent phone thefts around your office, you want to set your phone so that all data is destroyed if incorrect passcodes are entered 10 times in a row. Which feature allows you to do this?",
    "choice_a": "Failed login attempts restrictions",
    "choice_b": "Screen locks",
    "choice_c": "Remote wipes",
    "choice_d": "Locator applications",
    "correct_answer": "A",
    "explanation": "Failed log-in attempt restrictions will destroy all local data on the phone if incorrect passcodes are entered ten times in a row. While this is recommended for users with phones that contain sensitive data and that are frequently taken into public venues or placed in compromising positions, the casual user should not turn on this feature unless they can be sure there will always be a recent backup available. Screen locks require authentication to access the device. Remote wipes enable a user to wipe their data when a device is lost or stolen. Locator applications can help you (or police) find your phone.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      193,
      192,
      191,
      232,
      198
    ],
    "source": "9781394330348"
  },
  {
    "id": 976,
    "question": "You own a small company with a SOHO router and a web server that is used to sell your products. You are concerned about the security of your LAN, so your IT consultant is going to set up a two-router system like the one shown in the graphic, to protect your LAN from web server traffic. What is this arrangement called?<img src=\"/question_assets/220-1202/c07f005.png\" alt=\"Network diagram depicts internet and LAN connectivity with two routers and a web server.\"/>\n\n<figcaption>Network diagram depicts internet and LAN connectivity with two routers and a web server.</figcaption>",
    "choice_a": "Dynamic WAN IP",
    "choice_b": "Static WAN IP",
    "choice_c": "UPnP",
    "choice_d": "Screened subnet",
    "correct_answer": "D",
    "explanation": "A screened subnet uses two or more routers with packet filtering to create a separate area on a network where servers, such as a web server, can be accessed from either inside the local area network (LAN) or from the Internet. This arrangement provides greater security and protects the LAN from network traffic. A static wide area network internet protocol (WAN IP) is one that doesn\u2019t change and needs to be configured on your router. Universal plug and play (UPnP) is a protocol that lets devices find and communicate with each other on your local area network (LAN), such as your laptop and your printer. Unfortunately, UPnP could also be used by malware to spread to other devices on your network. A WAN IP is the IP address a company gets from the internet service provider (ISP), and it can be dynamic (i.e., it changes) or static (i.e., it doesn\u2019t).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      187,
      189,
      140,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 977,
    "question": "You turned your back for a minute in the coffee shop, and your mobile device is now missing. Which one of the following is not a way to achieve a remote wipe on a mobile device?",
    "choice_a": "Exceeding failed login attempts restrictions",
    "choice_b": "Using Google Find My Device or the Apple Find My app",
    "choice_c": "Using MDM software",
    "choice_d": "Disabling guest access",
    "correct_answer": "D",
    "explanation": "Exactly how to wipe your device depends on the device. If you have configured failed log-in restrictions on your device, then after the prescribed number of failed attempts, the device will either lock or, in the case of an iOS device, ten failed tries will cause the device to be erased. For Android devices, you can use Google Find My Device to remotely wipe it, and for iOS devices, you can use the Find My app using a different iOS device. Mobile device management (MDM) software can also be used to wipe Apple, Android, or Windows devices. Disabling guest access is a good security practice, but it won\u2019t wipe the device\u2019s data.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      196,
      193,
      198,
      124,
      195
    ],
    "source": "9781394330348"
  },
  {
    "id": 978,
    "question": "You are setting up a router and network for a SOHO business. The router has wired and wireless connections. Which of the following is not a method for configuring secure management access or a secure location for the router?",
    "choice_a": "Place the router in the kitchen area for easy access.",
    "choice_b": "Disable any guest accounts on the network. If guests need access, set up a separate VPN for them.",
    "choice_c": "Restrict IP addresses that can manage the router.",
    "choice_d": "Place the router in an area that can be locked.",
    "correct_answer": "A",
    "explanation": "A kitchen is one of the worst places for a router to be. First, there will be electromagnetic interference (EMI) from appliances like refrigerators and microwaves, which will interfere with the wireless signal, and if they\u2019re too close to the router or wires, they could interfere with the wired signal too. Second, having easy access to the router might be good for the IT person, but it\u2019s a terrible idea for security. For physical security, place the router in a room or an enclosure that can be locked and out of reach of passersby. Any guest access or guest accounts should be disabled. If your company needs to have Wi-Fi available for visitors, place it on a separate virtual local area network (VLAN), so that your network isn\u2019t exposed to those connections. IP addresses that are able to log in to the router should be restricted. Other things you can do to secure a router are to obviously change the router\u2019s default service set identifier (SSID), username, and password, and if possible, use access control lists to limit access in addition to ensuring you keep firmware updated to protect against malware attacks. For Wi-Fi routers, take a walk around with a Wi-Fi meter and ensure that the signal doesn\u2019t extend into areas where it should not be. If it extends too far, you might need to turn the power down or possibly move the router.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      190,
      186,
      184,
      185,
      182
    ],
    "source": "9781394330348"
  },
  {
    "id": 979,
    "question": "You\u2019re setting up a new wireless router for your company. Which of the following security settings should you not do?",
    "choice_a": "Ensure that encryption is enabled (WPA2/WPA3).",
    "choice_b": "Create a VLAN for guest users.",
    "choice_c": "Turn your wireless signal power to maximum to decrease interference.",
    "choice_d": "Update the router\u2019s firmware.",
    "correct_answer": "C",
    "explanation": "Turning your signal power to maximum would likely increase interference if there were nearby Wi-Fi networks, and it won\u2019t enhance security. You do need to ensure that the appropriate encryption scheme is enabled. If you expect to have guest users, create a virtual local area network (VLAN) for them and use it to restrict access. In addition, it\u2019s important to update the router\u2019s firmware to protect against any new malware.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      180,
      184,
      186,
      185,
      145
    ],
    "source": "9781394330348"
  },
  {
    "id": 980,
    "question": "A user needs to download a new video card driver for their HP laptop. They find the driver on the HP support website and ask you if they can download it. The HP site is an example of what?",
    "choice_a": "Part of an access control list",
    "choice_b": "An authenticator website",
    "choice_c": "A trusted source",
    "choice_d": "An untrusted source",
    "correct_answer": "C",
    "explanation": "Trusted software sources are sources that you know and work with all the time (e.g., Microsoft, HP, or other manufacturers\u2019 websites), and there are untrusted sources; you should differentiate between them. Don\u2019t use or let your users use untrusted software sources. Generally, common sense can be your guide, but there are \u201csafe lists\u201d of trusted software vendors from authoritative watchdog companies like Comodo. Access control lists (ACLs) define who can have access to a resource. The question does not describe an authenticator website.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      194,
      139,
      211,
      134,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 981,
    "question": "You\u2019re explaining browser synchronization to a coworker. Which of the following are true about synchronizing browser data? (Choose three.)",
    "choice_a": "You must be logged in to devices so they will synchronize.",
    "choice_b": "You can disable or enable synchronization on individual devices.",
    "choice_c": "Synchronization happens in the background.",
    "choice_d": "You can\u2019t synchronize between Windows devices and Apple devices.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "You must be logged in to your browser for it to synchronize with other devices. You can enable or disable synchronize on one or more devices, if you don\u2019t want a certain device to synchronize. Synchronization usually happens in the background. Because we\u2019re talking about browser synchronization, you can synchronize between Windows and Apple devices. Browser synchronization depends on the browser, not the operating system (OS).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      166,
      178,
      175,
      179
    ],
    "source": "9781394330348"
  },
  {
    "id": 982,
    "question": "You receive an email from an overseas bank notifying you that a relative has left you a generous inheritance. You need to respond with your bank routing information so the bank can electronically transfer the funds directly to your account. What is this most likely an example of?",
    "choice_a": "Phishing",
    "choice_b": "Ransomware",
    "choice_c": "Spoofing",
    "choice_d": "Whaling",
    "correct_answer": "A",
    "explanation": "Social engineering is a process in which an attacker attempts to acquire information about you, your network, and your system by social means, such as talking to people in your organization. A social engineering attack can occur over the phone, by email, or in person. When an attempt is made through email or instant messaging, it is known as phishing or smishing, respectively, and is often made to look as if a message is coming from sites where users are likely to have accounts (e.g., banks, eBay, and PayPal are popular). Ransomware is software that holds your computer hostage in a logical way, such as encrypting your hard drive and refusing to give you the key until you pay a ransom. Spoofing is when someone or something pretends to be something else, such as an attacker\u2019s server using a familiar look and feel of a website, even a similar IP. Whaling is phishing for a wealthy or influential target.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      142,
      139,
      147,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 983,
    "question": "Which of the following are methods to keep your mobile device safe? (Choose three.)",
    "choice_a": "Use a swipe to unlock a mobile device.",
    "choice_b": "Accept and install OS updates as soon as possible.",
    "choice_c": "Install antivirus/anti-malware software.",
    "choice_d": "Use a remote backup application to safeguard your data in the event that you must wipe your phone.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Using a swipe to unlock a mobile device does not protect your device or your data. At the very least, using a personal identification number (PIN) is far safer than using a swipe to unlock a mobile device. Keeping operating systems (OSs) up to date to plug any vulnerabilities is especially important. All devices should have some form of antivirus, even if it is one that is built into the OS. Make sure that you are using a remote backup application to ensure that if your mobile device is lost or stolen and you must remotely wipe all the data, you will be able to download it to a new device.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      197,
      191,
      134,
      196,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 984,
    "question": "A coworker has been having some trouble with their browser being slow and some often-used web pages that won\u2019t load. You tell them to clear their browser\u2019s data. Which data should they clear? (Choose two.)",
    "choice_a": "Their browser cache",
    "choice_b": "Tracking and cookies",
    "choice_c": "History",
    "choice_d": "Passwords",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Cached files are parts of the web page that have been downloaded to make subsequent website page loading faster. Cookies store information, like your username, shopping cart, or first name, that a website uses to personalize your experience. Both cached files and cookies can cause conflicts with websites and can slow down your browser if too much is stored. Your history is a record of where you have been. Deleting it protects your privacy. Clearing passwords will not make the pages load faster, but passwords should be stored in a separate password manager for better security.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      176,
      177,
      179,
      175,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 985,
    "question": "You\u2019re visiting your mother-in-law and need to use her computer. The idea of her knowing what websites you use for work makes you uncomfortable. How can you ensure that she will not know what websites you\u2019ve visited while there?",
    "choice_a": "Enable private browsing mode.",
    "choice_b": "Update the certificates.",
    "choice_c": "Change the computer\u2019s date to a different one, and then set it back when you\u2019re done.",
    "choice_d": "Use a proxy browser.",
    "correct_answer": "A",
    "explanation": "The best solution is to enable private browsing mode. You might be thinking that you could simply clear the browser\u2019s history, but that would clear her history too, which she might not want you to do. Certificates are issued by a certificate authority and prove that the website (or person) is who they say they are. Certificates are updated by the website owners, not you. Changing the date might cause websites to give you certificate warnings and keep them from opening for you. It also won\u2019t keep the computer from recording the browsing history. Proxy browsers are similar to the network address translation (NAT) feature found in routers. A proxy browser will hide your actual IP address to protect information about your location or even personal information from being captured by someone else. A proxy browser will still store your browsing history, and you would need to have it installed on the computer to use it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      177,
      176,
      178,
      179,
      165
    ],
    "source": "9781394330348"
  },
  {
    "id": 986,
    "question": "A user is complaining that so many ads are popping up on their screen when they\u2019re doing Internet research that they can\u2019t get their work done. What can you configure in their browser to mitigate this problem?",
    "choice_a": "Private-browsing mode",
    "choice_b": "Pop-up blocker",
    "choice_c": "Password manager",
    "choice_d": "Certificates",
    "correct_answer": "B",
    "explanation": "Pop-up blockers are available in virtually every browser to stop those annoying ads from overtaking your screen. Look in the browser\u2019s settings for this option. Private-browsing mode, or incognito mode, stops the browser from saving your browsing history or cookies and keeps your activities from being seen by others on the same Wi-Fi, or later by another user of the device. Password managers provide a single login for you and are able to generate unique and complex passwords for all the websites that you browse. Certificates are digital identifications for a website. They are not involved in pop-ups.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      178,
      179,
      177,
      132
    ],
    "source": "9781394330348"
  },
  {
    "id": 987,
    "question": "You work as a contractor for a government entity that requires proof of data destruction when decommissioning old hard drives and computers. What is the best way to do this?",
    "choice_a": "Hire a third-party vendor to do the destruction and provide a certificate of destruction and recycling.",
    "choice_b": "Have the recycling center give you a receipt for the drives.",
    "choice_c": "Destroy them within your company, and show pictures of the destroyed drives to the government entity.",
    "choice_d": "Zero-write all the drives.",
    "correct_answer": "A",
    "explanation": "Data destruction contractors (who are third-party vendors) can be certified by groups such as National Association for Information Destruction (NAID) or can show that they follow government rules (e.g., Health Insurance Portability and Accountability Act [HIPAA] in the United States) for data destruction. They can provide proof of destruction, which would be difficult to do on your own. Once you drop a drive off at a recycling center, you have no idea where that drive or its data might end up. While you could destroy the data on your own either physically or logically, it would be better in this case to have a third-party vendor certify the data destruction.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      165,
      162,
      163,
      164,
      151
    ],
    "source": "9781394330348"
  },
  {
    "id": 988,
    "question": "Which of the following is a physical security measure that will trigger an alarm of some sort when it detects anything moving within its observation area?",
    "choice_a": "Lighting",
    "choice_b": "Equipment locks",
    "choice_c": "Motion sensors",
    "choice_d": "Authenticator application",
    "correct_answer": "C",
    "explanation": "Motion sensors are commonly used to trigger alarms that will turn on lights or otherwise warn of an intruder or something moving. Lighting and equipment locks are also physical security measures. An authenticator application, a type of soft token used for multifactor authentication (MFA), is a logical, rather than a physical, security measure.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      110,
      116,
      108,
      113,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 989,
    "question": "Which of the following types of physical security is used to lock, unlock, and start vehicles and lock or unlock building and room doors?",
    "choice_a": "Lighting",
    "choice_b": "Equipment locks",
    "choice_c": "Motion sensors",
    "choice_d": "Mobile digital keys",
    "correct_answer": "D",
    "explanation": "A mobile digital key is contained in a smartphone\u2019s wallet and is available on many newer vehicles to lock and unlock doors and start vehicles. They can also be used to lock and unlock buildings and rooms. Lighting can discourage access by making intruders more visible. Equipment locks are placed on servers and laptops to discourage stealing data or equipment, and motion sensors trigger lights or other alarms/deterrents.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      114,
      113,
      111,
      116,
      110
    ],
    "source": "9781394330348"
  },
  {
    "id": 990,
    "question": "You have identified sensitive information in your company that needs to be monitored, whether it\u2019s being stored, accessed, or moved. What solution will you employ?",
    "choice_a": "Firewall",
    "choice_b": "VPN",
    "choice_c": "Group policy",
    "choice_d": "DLP",
    "correct_answer": "D",
    "explanation": "Data loss prevention (DLP) is the process of identifying and monitoring sensitive data to ensure it\u2019s only accessed by authorized persons and doesn\u2019t leave the company, whether it is on a server, in the cloud, or on an endpoint device. DLP can help ensure that a company is in compliance with government regulations regarding sensitive data. A firewall can be configured to block certain types of traffic based on things like IP address, protocol, or MAC address. A virtual private network (VPN) is a secure path between a local and remote device. In a Windows domain, password policies can be configured at the domain level using group policy objects (GPOs). There are hundreds of variables that can be configured. Variables that can be configured relating to passwords include password complexity and length, and the time between allowed changes to passwords.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      124,
      155,
      126,
      158,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 991,
    "question": "Which of the following manages identities and their access to resources using adaptive MFA?",
    "choice_a": "SSO",
    "choice_b": "SAML",
    "choice_c": "PAM",
    "choice_d": "IAM",
    "correct_answer": "D",
    "explanation": "Identity access management (IAM) provides a framework for monitoring identities and access using adaptive multifactor authentication (MFA). Adaptive MFA changes the factor required based on the situation. For example, logging in from an unexpected location would require a different authentication factor than logging in from an expected location. Single sign-on (SSO) enables a user to enter their identification and authentication one time to access multiple services or applications. SSO is supported by security assertions markup language (SAML), which is a protocol that passes an identity token between an identification provider (IdP) and a service provider (SP), enabling secure SSO. Privileged access management (PAM) keeps track of any entity that has more than standard access to resources, whether human, application, or machine. Identity access management (IAM) is similar to PAM, except that it is for any entity, not just privileged entities. It provides a framework for monitoring identities and access using adaptive MFA.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      121,
      125,
      126,
      123
    ],
    "source": "9781394330348"
  },
  {
    "id": 992,
    "question": "You believe your computer has contracted a boot sector virus. Which command-line tool permits someone to make changes to the operating system without having to boot up Windows?",
    "choice_a": "WinRE (also known as the recovery console)",
    "choice_b": "RADIUS",
    "choice_c": "Administrative Tools",
    "choice_d": "Active Directory",
    "correct_answer": "A",
    "explanation": "The Windows Recovery Environment (WinRE), also known as the recovery console, in Windows 10 and 11 provides a command-line tool (among other tools) that allows the administrator to copy or remove directories, enable or disable services, write a new Master Boot Record (MBR), format volumes, and much more. If you have a virus that has infected the drive\u2019s boot sector, the only way to access the system before the boot sector virus loads is to boot to another drive, either a DVD or USB that contains either the Windows installation media or bootable antivirus. Using the installation media is one way to enter the WinRE. Typically, the system will automatically enter the WinRE if booting into Windows has failed three times in a row. You can force this to happen by turning the power off as soon as Windows starts to load and repeating that until the system boots into WinRE. From the recovery environment\u2019s main screen, choose Troubleshoot, then Advanced Options, and finally Command Prompt to get to the command prompt. Here you can enter commands or run antivirus software to remove a boot sector virus on the other hard drive. Remote authentication dial-in user service (RADIUS) is an authentication encryption protocol. Administrative tools can be found in the Control Panel of Windows 10 and is a collection of commonly used tools. Administrative tools is renamed Windows Tools in Windows 11. Active Directory is the database and software used to control and manage a Windows domain.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      130,
      134,
      173,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 993,
    "question": "Your company allows you to use your personal smartphone for company work, because it will save the company money on hardware. You gave a week\u2019s notice that you\u2019re accepting a job with a different company, and suddenly your productivity applications are missing, along with your company files. What has happened?",
    "choice_a": "Remote wipe",
    "choice_b": "Content filtering",
    "choice_c": "Application updates",
    "choice_d": "Malware attack",
    "correct_answer": "A",
    "explanation": "Although your first instinct might be to think you\u2019re the victim of a malware attack, it\u2019s most likely that your company made you sign a mobile device management (MDM) policy or bring your own device (BYOD) policy that says they will remotely wipe any company files on your device if you leave the company. Content filtering is used to block any incoming or outgoing traffic that may be dangerous, sensitive, or inappropriate. Application updates are one of the many actions you should take to protect/harden a system, and a malware attack is unwanted software that invades your system with the intent of harming you in some way.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      198,
      155,
      124,
      232,
      196
    ],
    "source": "9781394330348"
  },
  {
    "id": 994,
    "question": "Which of the following are important methods of patch management on mobile devices? (Choose two.)",
    "choice_a": "Application updates",
    "choice_b": "Content filtering",
    "choice_c": "Screen locks",
    "choice_d": "OS updates",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Each option is a part of mobile device security, but application updates and operating system (OS) updates are the necessary actions for patch management. Content filtering blocks undesirable or dangerous sites on a corporate network, and screen locks keep people from accessing your computer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      197,
      198,
      228,
      232,
      195
    ],
    "source": "9781394330348"
  },
  {
    "id": 995,
    "question": "Your friend wants to know what Secure DNS is, so you\u2019re attempting to explain it to them. Which of the following is not true?",
    "choice_a": "It\u2019s encrypted DNS information that uses HTTPS.",
    "choice_b": "It\u2019s probably on by default on their browser.",
    "choice_c": "It\u2019s only available in corporate versions of browsers.",
    "choice_d": "It protects your information in transit between you and a website.",
    "correct_answer": "C",
    "explanation": "Secure Domain Name System (DNS)\\Domain Name System (DNS) over hypertext transfer protocol secure (HTTPS) is probably enabled on your browser right now. It\u2019s not just a corporate setting. It protects your IP address and sign-in information, while DNS is translating the human-friendly website name that you type into an IP address. You might need to configure it in your browser; usually it\u2019s found in Settings. For example, in Google Chrome, click on the three stacked dots next to your user icon, scroll down and choose Settings, then Privacy and Security. Then click on Security and scroll down to find the Advanced settings, which includes DNS settings.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      178,
      214,
      156,
      177,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 996,
    "question": "What login OS option typically requires a domain and uses Kerberos?",
    "choice_a": "PIN",
    "choice_b": "SSO",
    "choice_c": "Facial recognition",
    "choice_d": "Username/password",
    "correct_answer": "B",
    "explanation": "Single sign-on (SSO) enables users to enter their username and password one time to access multiple systems. It typically requires the Kerberos authentication protocol and a domain to implement it, although there are also third-party and cloud solutions. Kerberos uses keys to keep users\u2019 passwords hidden as they traverse the network or Internet. A personal identification number (PIN) is a series of numbers known only to the person logging in. Facial recognition software compares the face presented with a stored image, using measurements like the width of the nose or the distance between eyes, to determine whether to grant access. Usernames and passwords provide identification and attempt authentication, respectively.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      122,
      169,
      168,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 997,
    "question": "You right-click a folder in Microsoft Windows, choose Properties, and click the Security tab. What are you now looking at?",
    "choice_a": "Path",
    "choice_b": "Content filtering",
    "choice_c": "ACL",
    "choice_d": "UAC",
    "correct_answer": "C",
    "explanation": "An access control list (ACL) can be viewed by right-clicking, choosing Properties, and then clicking the Security tab on a file or folder in a New Technology File System (NTFS) environment. The ACL provides a list of users or groups that have been assigned NTFS permissions for the chosen object. The path can be viewed on the shortcut tab. Content filtering allows or denies network packets based on specified criteria and is set up in a router or network security device. User account control (UAC) is the box that pops up when a user tries to access a restricted resource. It requires entering an administrator password to continue.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      119,
      171,
      170,
      200,
      172
    ],
    "source": "9781394330348"
  },
  {
    "id": 998,
    "question": "Where is folder redirection configured in Active Directory?",
    "choice_a": "Home folder",
    "choice_b": "Group policy",
    "choice_c": "OU",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "Folder redirection requires a shared folder on the server and is configured in the Active Directory group policy. The group policy is then applied to the appropriate organizational unit (OU). Folder redirection allows users\u2019 profile folders to be stored in a more centralized location on the network, rather than on the user\u2019s local device. A profile stored this way is called a roaming profile. The home folder is the specific location where a user\u2019s documents and such are stored, such as <code>\\\\%servername%\\home\\%username%</code>, then usually mapped to drive <code>H:%username%</code>, making it simple for end users. An OU is a management tool that can be used to organize Active Directory resources and can contain users, computers, and other resources. A virtual private network (VPN) is created across a public network by using strong encryption protocols.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      126,
      125,
      200,
      171,
      172
    ],
    "source": "9781394330348"
  },
  {
    "id": 999,
    "question": "You perform very confidential work as a government contractor, and you work from home. You use a browser interface to perform some of your work. What can be configured in a browser to ensure that the data you receive is not altered between a web server and you?",
    "choice_a": "IP address filtering",
    "choice_b": "Trusted sources",
    "choice_c": "Hashing",
    "choice_d": "Port filtering",
    "correct_answer": "C",
    "explanation": "Hashing is an algorithm that is computed on the sender and receiver to ensure that data is not intercepted and changed. Using trusted sources to download drivers or software, IP address filtering, and port filtering are all important security concepts, but filtering is generally done on a router or firewall.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      156,
      178,
      175,
      147,
      150
    ],
    "source": "9781394330348"
  },
  {
    "id": 1000,
    "question": "A few users have been accessing material on restricted websites via your company\u2019s network. What type of server can you install to block content from a list of prohibited websites?",
    "choice_a": "DNS server",
    "choice_b": "Authentication server",
    "choice_c": "Proxy server",
    "choice_d": "Web server",
    "correct_answer": "C",
    "explanation": "A proxy server makes requests for resources on behalf of a client. Proxy servers are known for three things. One, the proxy server can cache the information requested, speeding up subsequent searches. Two, the proxy can act as a filter, blocking content from prohibited websites and blocking sensitive data from leaving the network. Three, the proxy server can modify the requester\u2019s information when passing it to the destination, blocking the sender\u2019s identity and acting as a measure of security; the user can be made anonymous. A domain name server (DNS) server resolves IP addresses to domain names. An authentication server verifies the identity of a user and their access to resources, and a web server provides information in files that can be read by a web browser, whether internal to the company or on the Internet.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      178,
      124,
      155,
      139,
      136
    ],
    "source": "9781394330348"
  },
  {
    "id": 1001,
    "question": "A coworker is being blocked from a website that they have used in the past. A message on their browser says, \u201cYour connection is not private.\u201d What do you suspect is the problem? (Choose two.)",
    "choice_a": "Their browser cache needs clearing.",
    "choice_b": "Their browser history needs clearing.",
    "choice_c": "The website needs to update their certificates.",
    "choice_d": "The coworker\u2019s computer has the wrong date/time.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Certificates are issued by a certificate authority and prove that the website (or person) is who they say they are. When they expire, the browser gives an indicator that the certificate is expired or invalid and may block your access to the website. Websites that you access are stored in a cache on your computer, so that the next time you visit the website, it will only download the changes and make websites load much more quickly. If a website you visit isn\u2019t updating properly, clearing the cache should resolve the issue. Browser history should be cleared when you exit the browser for privacy and to maintain browser performance.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      175,
      176,
      156,
      146,
      178
    ],
    "source": "9781394330348"
  },
  {
    "id": 1002,
    "question": "A company visits your location when called to destroy old hard drives and paper copies. What are the advantages of paying someone else to do this? (Choose two.)",
    "choice_a": "They can provide a certificate of destruction and recycling.",
    "choice_b": "You can prove compliance with regulations and environmental requirements.",
    "choice_c": "You have to pay for expensive equipment.",
    "choice_d": "You must zero-write all the drives first.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Data destruction contractors (who are third-party vendors) can be certified by groups such as National Association for Information Destruction (NAID), or they can show that they follow government rules (such as the Health Insurance Portability and Accountability Act [HIPAA] in the United States) for data destruction. They can provide proof of destruction, which would be difficult to do on your own. While you could destroy the data on your own, either physically or logically, it would be better to have a third-party vendor certify the data\u2019s destruction. The data destruction company pays for the equipment, and you pay them for their services. You likely would only zero-write the drives if your company policy required you to do so.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      165,
      162,
      163,
      164,
      151
    ],
    "source": "9781394330348"
  },
  {
    "id": 1003,
    "question": "Your company allows employees to bring their own devices to work. Security is a concern, so how can your company enforce compliance with corporate policies for remote workers? (Choose two.)",
    "choice_a": "Have the employees bring in the device so you can configure it.",
    "choice_b": "Send the employees instructions on how to configure their device.",
    "choice_c": "Use MDM software.",
    "choice_d": "Require the installation of configuration profiles.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Mobile device management (MDM) software can be used to deploy configuration profiles to remote devices. For initial installation, it could be as simple as scanning a quick response (QR) code to install the required software, which enables the company to push policies and policy changes to the end users. A company can create multiple different configuration profiles for different roles, such as executive, salesperson, and so on. You can\u2019t always have an employee bring their device in, and sent instructions could be intercepted.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      198,
      195,
      124,
      155,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 1004,
    "question": "You\u2019re setting up group policies for passwords. Which of the following policies will you configure to ensure that users can\u2019t reuse old passwords until some time has passed?",
    "choice_a": "Maximum Password Age",
    "choice_b": "Enforce Password History",
    "choice_c": "Minimum Password Age",
    "choice_d": "Password Complexity Requirements",
    "correct_answer": "B",
    "explanation": "The Enforce Password History policy enables the administrator to choose a setting between 0 and 24, which represents the number of unique passwords that a user must set <i>before</i> they can reuse a password. The Maximum Password Age policy determines how long a password can exist <i>before</i> it must be changed. The Minimum Password Age policy defines how many days must pass <i>before</i> a user is allowed to reset their password. The Meeting Password Complexity Requirements policy forces the user to use at least one each of uppercase letters, lowercase letters, digits 0 through 9, and special characters like ! and $.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      126,
      160,
      158,
      157,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 1005,
    "question": "A new IT hire has asked you what they should do about services running in the background of their OS, and which ones are necessary. Because you\u2019re focused on cybersecurity, what will you tell them about background services?",
    "choice_a": "They should all be on.",
    "choice_b": "They should all be off.",
    "choice_c": "Unused/unneeded services should be disabled.",
    "choice_d": "Other services should be set to turn on only when needed.",
    "correct_answer": "C",
    "explanation": "Some services are needed all the time, so they must be constantly running. Depending on the situation, other services are likely never needed. Those services that are never needed should be disabled to reduce the computer\u2019s attack surface. Some services turn themselves on when they\u2019re needed and off when they aren\u2019t.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      117,
      170,
      167,
      123,
      140
    ],
    "source": "9781394330348"
  },
  {
    "id": 1006,
    "question": "A temporary employee called the IT department because they were unable to log in to their account. Their work contract was set to be completed yesterday, but it was extended. What will you check in Active Directory?",
    "choice_a": "Account expiration dates",
    "choice_b": "Group membership",
    "choice_c": "Signs of a malware attack",
    "choice_d": "That their computer is in the system",
    "correct_answer": "A",
    "explanation": "Like any IT expert, you\u2019ve set an account expiration date for them and now need to reset it. Account expiration dates, especially for temporary staff, are a great way to ensure that unused accounts are not left open, which a hacker could use to access a network. Also accounts of employees who\u2019ve left the company should be disabled immediately upon their exit. Group membership and their computer\u2019s inclusion shouldn\u2019t be a problem. Although a malware attack is always a possibility, it isn\u2019t likely in this situation.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      160,
      168,
      126,
      117,
      158
    ],
    "source": "9781394330348"
  },
  {
    "id": 1007,
    "question": "You want to ensure that your workstations are hardened so that unauthorized users can\u2019t load the OS, and if they do, that they won\u2019t be able to launch malware by inserting a USB drive. Which two of the following are hardening techniques to ensure that they are blocked?",
    "choice_a": "Configure a BIOS/UEFI password",
    "choice_b": "Restrict login times",
    "choice_c": "Disable guest accounts",
    "choice_d": "Disable AutoRun/AutoPlay",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A user password can be configured in the basic input output system (BIOS) interface or unified extensible firmware interface (UEFI) so that the operating system (OS) won\u2019t load without it. If an intruder does access the OS, they can\u2019t quickly load malware by inserting a universal serial bus (USB) drive if AutoPlay is disabled. Restricting login times is a hardening process, but it won\u2019t protect against someone using a USB drive during working hours. The guest account is disabled by default, but ensuring its disabled status is also a hardening policy. However, neither of these options will keep someone from loading the OS. If the AutoRun/AutoPlay feature isn\u2019t disabled, a malicious actor can use a USB to quickly load malware or run their own OS and access a network.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      161,
      167,
      120,
      154,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 1008,
    "question": "Your system is infected with malware. You have verified the symptoms, quarantined the infected system, and disabled System Restore. Which are good choices to do next? (Choose two.)",
    "choice_a": "Boot into safe mode to clean out the malware files.",
    "choice_b": "Reboot Windows as normal.",
    "choice_c": "Rebuild the Registry.",
    "choice_d": "Use updated bootable anti-malware tools to remove malicious files.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Remediating infected systems is the next step in the procedures for malware removal. While the exact steps for eradicating malware depend on the type of malware and the damage done, it\u2019s easier to get rid of the malware files if you don\u2019t boot to the drive the malware is on. You could boot into safe mode, which is a limited operating system (OS), and run anti-malware; or boot with installation media from a completely separate drive and run anti-malware on the infected drive; or boot from a bootable universal serial bus (USB) drive that was made by using tools from your favorite anti-malware company and running its antivirus/anti-malware eradication tools. In any case, you will want to ensure that you\u2019ve downloaded the most current malware definition files or other updates available to scan and remove the threat. This is not the time to boot into Windows as normal, and hopefully you won\u2019t need to rebuild the Registry before you\u2019re done troubleshooting. <p>CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:</p><ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      134,
      138,
      217,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1009,
    "question": "You are training technicians on the creation and use of restore points. Restore points can sometimes fix problems with slow, infected, or unresponsive systems. Which of the following is not a way in which restore points are created?",
    "choice_a": "Windows creates them automatically by default.",
    "choice_b": "You manually create them.",
    "choice_c": "Windows creates them before a system crashes.",
    "choice_d": "Some installation utilities will create them before installing a new program.",
    "correct_answer": "C",
    "explanation": "It\u2019s unlikely that Windows would be able to predict when a system crash is about to happen, so it isn\u2019t going to create a restore point. There are, however, common activities that can present a risk to a system, such as installing new hardware drivers or new applications. In those instances, Windows will create a restore point before the software or hardware driver is installed. A system restore point is also created by default once a week, and you can manually create them whenever you would like.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      138,
      220,
      153,
      209,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1010,
    "question": "A technician is fixing a Windows Home workstation that has contracted a virus. They are following the best practices for malware removal and have enabled System Restore and created a restore point. What is the next step that should be taken?",
    "choice_a": "Educate the end user.",
    "choice_b": "Disable System Restore.",
    "choice_c": "Quarantine the infected system.",
    "choice_d": "Remediate the infected system.",
    "correct_answer": "A",
    "explanation": "An educated end user who is aware of the signs of malware is one of the best protections against malware. <p>CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:</p><ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      217,
      134,
      153,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1011,
    "question": "A network user with an Android tablet wants to back up and synchronize their data with their phone. Which service should they use to perform these tasks?",
    "choice_a": "Google Sync",
    "choice_b": "Google Cloud",
    "choice_c": "Sync My Phone",
    "choice_d": "Bogus Cloud",
    "correct_answer": "A",
    "explanation": "Because problems tend to occur no matter how careful you are, it\u2019s important to back up devices and be able to restore your device from those backups after an incident. Google Sync is available for backups and synchronization of data between Android-based devices and PCs that have a Microsoft Exchange account. Google Cloud is their Infrastructure-as-a-Service (IaaS) platform. Sync My Phone and Bogus Cloud are not real services.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      197,
      166,
      124,
      198,
      232
    ],
    "source": "9781394330348"
  },
  {
    "id": 1012,
    "question": "A step in the malware removal best practices is to manually create a restore point in Windows. What will the restore point do?",
    "choice_a": "Create a copy of the entire hard drive.",
    "choice_b": "Create a copy of the <code>Users</code> folder and system configuration data.",
    "choice_c": "Create a copy of system configuration data.",
    "choice_d": "Create a bootable media with copies of key system files.",
    "correct_answer": "C",
    "explanation": "A restore point is a copy, or snapshot, of your system configuration at a given point in time. It\u2019s like a backup of your configuration but not your data. Snapshots are created within Windows by clicking the Search icon, typing Create a Restore Point, and selecting it from the list of results. The System Properties window opens. It should open on the System Protection tab. If not, click the System Protection tab, and near the bottom of the screen is the Create button next to Create a restore point right now for the drives that have System protection turned on. Clicking the Create button begins the process of creating a restore point. A restore point does not back up the hard driver or create a copy of the users\u2019 folder and system configuration, nor does it create bootable media.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      138,
      220,
      209,
      173,
      134
    ],
    "source": "9781394330348"
  },
  {
    "id": 1013,
    "question": "You are troubleshooting a Windows 11 workstation that might have malware on it. To follow the best practices for malware removal, what is the first step you should take?",
    "choice_a": "Quarantine the infected system.",
    "choice_b": "Update the anti-malware software.",
    "choice_c": "Enable System Restore and create a restore point.",
    "choice_d": "Investigate and verify malware symptoms.",
    "correct_answer": "D",
    "explanation": "CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      217,
      220,
      138,
      134,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 1014,
    "question": "You are troubleshooting a workstation on your network and believe it has malware. To follow the best practices for malware removal, after you investigate and verify malware symptoms, which step should you take?",
    "choice_a": "Update anti-malware software.",
    "choice_b": "Disable System Restore.",
    "choice_c": "Quarantine the infected system.",
    "choice_d": "Scan for and remove the malware.",
    "correct_answer": "C",
    "explanation": "You don\u2019t want an infected system to infect others on your network! <p>CompTIA has developed specific steps for removing malware from small office/home office (SOHO) networks. The ten steps of the malware removal process are as follows:</p><ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      217,
      220,
      209,
      211,
      138
    ],
    "source": "9781394330348"
  },
  {
    "id": 1015,
    "question": "Which type of security method allows you to bring your security device near a reader (but does not require touching) to validate access?",
    "choice_a": "PIN code",
    "choice_b": "Badge reader",
    "choice_c": "Soft token",
    "choice_d": "Biometrics",
    "correct_answer": "B",
    "explanation": "A smart card is a type of badge or card that gives you access to resources, including buildings, parking lots, and computers. It contains information about your identity and access privileges. A protected computer or area has a badge reader in which you insert your card. In the case of radio frequency identification (RFID), the reader is a wireless no-contact technology, and the user does not need to touch the card to the reader. A personal identification number (PIN) code is a number that would be entered to gain access to a device. A soft token is usually software on a cell phone or mobile device that generates a code for the user to input. Biometrics uses part of a person\u2019s body to prove identity.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      108,
      120,
      191,
      124,
      117
    ],
    "source": "9781394330348"
  },
  {
    "id": 1016,
    "question": "Which of the following authentication encryption protocols is older than the others and was developed by Cisco, but became an open protocol in the 1990s, and can be found on Linux distributions?",
    "choice_a": "AES",
    "choice_b": "TACACS+",
    "choice_c": "Kerberos",
    "choice_d": "RADIUS",
    "correct_answer": "B",
    "explanation": "Released in 1993, terminal access controller access-control system (TACACS+) is an authentication protocol developed by Cisco that is now an open standard. It separates the Authentication, Authorization, and Accounting (AAA) packets and encrypts them. Remote authentication dial-in user service (RADIUS) is an authentication protocol that was released in 1997. Kerberos is an open-source authentication protocol that has been around since the 1980s. Advanced encryption standard (AES), which is for wireless encryption not authentication, has been around since 2001, and is the successor to temporal key integrity protocol (TKIP).",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      183,
      168,
      125,
      180,
      122
    ],
    "source": "9781394330348"
  },
  {
    "id": 1017,
    "question": "Which type of security device displays a randomly generated code that a user enters for access to computer resources?",
    "choice_a": "ID badge",
    "choice_b": "RFID badge",
    "choice_c": "Smart card",
    "choice_d": "Key fob",
    "correct_answer": "D",
    "explanation": "A key fob is a small device about the size of a car key that can easily be carried in a pocket or on a keychain. It generates a random number every few seconds that can be used for multifactor authentication (MFA) to gain access to a secure system like a bank account. Key fobs are also a type of external hardware token. The other three choices\u2014an identification (ID) badge, a radio frequency identification (RFID) badge, and smart card\u2014are all something that can be carried by an employee to gain access to a specific area. Smart cards or RFID badges store electronic information that could be used to access equipment as well. Information on them is accessed by devices called readers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      113,
      121,
      120,
      108,
      115
    ],
    "source": "9781394330348"
  },
  {
    "id": 1018,
    "question": "Your company\u2019s web server has been compromised because a malicious actor placed code into a <code>name</code> input field in the company\u2019s website. What type of attack has been perpetrated?",
    "choice_a": "Keylogger",
    "choice_b": "Stalkerware",
    "choice_c": "SQL injection",
    "choice_d": "Trojan",
    "correct_answer": "C",
    "explanation": "A structured query language (SQL) injection happens when a poorly written website doesn\u2019t specify limits on what an input field can contain, and that field is used by a malicious actor to insert code into the website. SQL is used by databases, and most websites have databases running on the backend to take orders or capture visitor data for newsletters and such. A keylogger records keyboard input for a malicious actor to use later. Stalkerware is any software, whether a commercial app or a malware, which is used to perform surveillance on a person or business for malicious intent, which is stalking. A Trojan is malware that appears to be a useful program that is unwittingly downloaded by the victim, and then often installs a backdoor for a malicious actor to use later.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      150,
      128,
      129,
      132,
      135
    ],
    "source": "9781394330348"
  },
  {
    "id": 1019,
    "question": "You receive an SMS from an overseas bank notifying you that you have won a random drawing. You need to respond with your bank routing information so the bank can electronically transfer the funds directly to your account. What is this most likely an example of?",
    "choice_a": "Phishing",
    "choice_b": "Ransomware",
    "choice_c": "Whaling",
    "choice_d": "Smishing",
    "correct_answer": "D",
    "explanation": "Smishing is a type of social engineering attack that is perpetrated via short message service (SMS) messages. Social engineering is a process in which an attacker attempts to acquire information about you, your network, and your system by social means, such as talking to people in the organization. A social engineering attack may occur over the phone, by email, or in person. When the attempt is made through email, it is known as phishing and often made to look as if a message is coming from sites where users are likely to have accounts (e.g., banks, eBay, and PayPal are popular) or a relative or friend. Ransomware is software that holds your computer hostage in a logical way, such as encrypting your drive and refusing to give you the key until you pay a ransom. Whaling is phishing for a wealthy or influential target.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      141,
      139,
      211,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1020,
    "question": "You have just transformed a Windows workgroup into a small domain and are configuring user accounts. Which of the following is considered a best practice for managing user account security?",
    "choice_a": "Require every user to log on as a Guest user.",
    "choice_b": "Allow all users Read and Write access to all server files.",
    "choice_c": "Follow the principle of least privilege.",
    "choice_d": "Place all user accounts in the Administrator group.",
    "correct_answer": "C",
    "explanation": "When assigning user permissions, follow the principle of least privilege, where you give users only the bare minimum that they need to do their job and nothing more. Assign permissions to groups rather than users and make the users members of groups (or remove them from groups) as they change roles or positions. You would not let anyone log in as a Guest user or give them Read and Write access to all your server files, and placing them in the Administrator group would negate your security settings, unless the setting was an NTFS Deny setting, because Deny overrides every other setting, even for administrators. (Caution! Don\u2019t deny the Administrator group on anything!).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      117,
      167,
      126,
      160,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 1021,
    "question": "An employee scanned a QR code with their company smartphone to visit a potential supplier\u2019s website and input their contact information. Suddenly, they receive notice that their name and phone number have been spotted on the dark web. What type of attack were they a victim of?",
    "choice_a": "QR code phishing",
    "choice_b": "Ransomware",
    "choice_c": "Whaling",
    "choice_d": "Smishing",
    "correct_answer": "A",
    "explanation": "Quick response (QR) code phishing occurs when an unsuspecting person scans a QR code and visits a website that they think is legitimate, but it\u2019s actually a phishing site intended to gather their personal information. Ransomware is software that holds your computer hostage in a logical way, such as encrypting your hard drive and refusing to give you the key until you pay a ransom. Whaling is phishing for a wealthy or influential target. Smishing is a type of social engineering attach perpetrated via short message service (SMS) messages.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      142,
      141,
      139,
      211,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1022,
    "question": "A malware attack was recently thwarted by your payroll manager. The malicious actor was trying to get them to give up the company\u2019s banking information. What type of attack was attempted?",
    "choice_a": "Spear phishing",
    "choice_b": "Spyware",
    "choice_c": "Virus",
    "choice_d": "Whaling",
    "correct_answer": "A",
    "explanation": "Spear phishing is a social engineering attack aimed at a specific person for a specific purpose. In this case, the payroll manager was the \u201cfish.\u201d Spyware watches what you do and reports back to someone. A virus spreads from computer to computer through some contact between the machines, often through email. Whaling is phishing for \u201cbig fish\u201d who are very wealthy or influential people. Phishing gets its name from fishing for information.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      141,
      135,
      139,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1023,
    "question": "An employee receives an email from someone claiming to be from the IT department, asking for their network password, claiming that it needs to be reset because it\u2019s expired. If they provide the existing email, the new password then would be sent back to them via email. The employee has been to cybersecurity training, so they take a screenshot of the email and call the IT department immediately. What type of attack is it?",
    "choice_a": "Spear phishing",
    "choice_b": "Spyware",
    "choice_c": "BEC",
    "choice_d": "Whaling",
    "correct_answer": "C",
    "explanation": "A business email compromise (BEC) occurs when someone impersonates another person (or entity) in an attempt to gain sensitive information from someone. Spear phishing is a social engineering attack aimed at a specific person for a specific purpose. In this case, the payroll manager was the \u201cfish.\u201d Spyware watches what you do and reports back to someone. Whaling is phishing for a \u201cbig fish,\u201d who is very wealthy or influential. Phishing gets its name from fishing for information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      151,
      142,
      141,
      139,
      137
    ],
    "source": "9781394330348"
  },
  {
    "id": 1024,
    "question": "Which of the following practices for managing user accounts are in line with following the principle of least privilege? (Choose two.)",
    "choice_a": "Restrict user permissions.",
    "choice_b": "Restrict login times.",
    "choice_c": "Enable the Guest account.",
    "choice_d": "Give all users administrative access.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Following the principle of least privilege, users should be given only the access that they need and nothing more. If a user needs to read files but not change them, then they should be restricted to reading those files only. Sometimes, even the most careful users can make changes that they did not intend. If a user works only Monday to Friday, then they should not be able to log in on the weekend. Having their log-in available gives a hacker one more way to access your system. The guest account is disabled by default and should remain disabled. Even administrators should have a standard user account that they will use unless they are doing something requiring administrative access. Then they would only log on as an administrator while doing that activity, or enter their administrator password into a user account control (UAC) pop-up box.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      160,
      167,
      170,
      117,
      123
    ],
    "source": "9781394330348"
  },
  {
    "id": 1025,
    "question": "Your friend called you and said that they\u2019re suddenly being sent to an online store that they\u2019ve never used whenever they try to access their favorite online store. You ask if they\u2019ve installed any software recently. They confirmed that they recently installed a new game. What type of attack is your friend a victim of?",
    "choice_a": "SQL",
    "choice_b": "Smishing",
    "choice_c": "PUP",
    "choice_d": "OS",
    "correct_answer": "C",
    "explanation": "Your friend is the victim of a potentially unwanted program (PUP) attack, which occurred when they installed the game. A PUP can launch almost any type of attack, but often they are used for browser redirection or to install adware. PUPs differ from Trojans in that a Trojan makes you believe it\u2019s a harmless software, and a PUP is usually bundled with something else, and you agreed to install it. Structured query language (SQL) is used to interact with a database. Smishing is using small message service (SMS) for phishing attacks. OS merely stands for operating system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      128,
      214,
      142,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 1026,
    "question": "Your company installed a new appliance that scans email and isolates potential phishing attacks, malware, and the potential dissemination of sensitive information. What type of appliance has been installed?",
    "choice_a": "SQL",
    "choice_b": "EDR",
    "choice_c": "Proxy server",
    "choice_d": "Email security gateway",
    "correct_answer": "D",
    "explanation": "The appliance described is an email security gateway, which examines incoming and outgoing email for numerous possible problems and can quarantine emails until their intent is confirmed. Structured query language (SQL) is used to interact with a database. Endpoint detection and response (EDR) protects a network\u2019s endpoints such as servers and workstations from attacks. A proxy server hides internal nodes from the outside world and can filter traffic based on various specifications.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      137,
      136,
      142,
      124,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1027,
    "question": "You\u2019ve been working on a compromised computer to eradicate malware. You\u2019ve tried using multiple malware removal tools, but the system is still behaving erratically. The system is backed up daily, so data backups are available. What is your best option at this point?",
    "choice_a": "SQL",
    "choice_b": "EDR",
    "choice_c": "OS reinstallation",
    "choice_d": "PUP",
    "correct_answer": "C",
    "explanation": "When all else fails in your attempts to eradicate malware, you can perform an operating system (OS) reinstallation, which effectively wipes the system clean. It takes time to rebuild the settings and reinstall or restore programs and data, but sometimes it\u2019s the only way to truly clean the system. Structured query language (SQL) is used to interact with a database. Endpoint detection and response (EDR) protects a network\u2019s endpoints like servers and workstations from malware. A potentially unwanted program (PUP) is often installed with other legitimate software, and although it can launch any malware, it generally is used for browser redirection and adware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      217,
      220,
      132,
      134
    ],
    "source": "9781394330348"
  },
  {
    "id": 1028,
    "question": "Your department is interviewing vendors for a system that will monitor computers, smartphones, servers, and any other company endpoint devices for potential malware attacks. When a malware attack is discovered, the system will then automatically launch countermeasures to protect the company\u2019s data and endpoints, and monitor, report on, and mitigate the spread of potential problems.What type of system are you examining?",
    "choice_a": "MDR",
    "choice_b": "EDR",
    "choice_c": "DDoS",
    "choice_d": "PUP",
    "correct_answer": "A",
    "explanation": "Endpoint detection and response (EDR) becomes managed EDR (MDR) when EDR systems are provided by a third-party vendor that manages EDR for you. EDR monitors network endpoints continuously in an attempt to recognize, remediate, and prevent the spread of any malware or data loss in a system. They also provide reporting capabilities. Distributed denial-of-service (DDoS) is an attack performed by many computers to keep legitimate traffic from reaching a server. A potentially unwanted program (PUP) is often installed with other legitimate software, and although it can launch any malware, it generally is used for browser redirection and adware.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      194,
      132,
      144,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1029,
    "question": "You\u2019ve decided that an EDR system isn\u2019t enough. You need to monitor multiple places where endpoints exist, such as in the cloud and email. You\u2019ve decided to use software that leverages AI and automation to identify, investigate, report, and respond to threats. What type of system are you installing?",
    "choice_a": "EDR",
    "choice_b": "MDR",
    "choice_c": "XDR",
    "choice_d": "MXDR",
    "correct_answer": "C",
    "explanation": "When an endpoint detection and response (EDR) system investigates, identifies, reports, and responds to information gathered from multiple places and security levels like the cloud and email, applications, endpoints, and networks, it is considered an extended EDR (XDR) system. These systems are so complex that they need automation and artificial intelligence (AI) to sort and analyze the data in a timely manner. Managed EDR (MDR) systems are EDR services provided by a third party. Similarly, managed XDR (MXDR) systems are XDR managed by a third party. EDR, MDR, and XDR are on the CompTIA exam; however, MXDR is not.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      124,
      155,
      153,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1030,
    "question": "Which of the following is not a way to run a program as an administrator when you\u2019re logged on as a standard user?",
    "choice_a": "Right-click a program and choose Run as Administrator.",
    "choice_b": "Launch a program that requires administrator privileges, and type the administrator password in the UAC box.",
    "choice_c": "Press the Windows Key+the R key, and in the Run dialog box, type a command followed by <code>admin</code> and press Enter.",
    "choice_d": "Press the Windows Key+the R key, and in the Run dialog box, type <code><b>cmd</b></code>. Press Ctrl+Shift+Enter to open a command prompt as an administrator. Enter the password in the UAC box and press Enter.",
    "correct_answer": "C",
    "explanation": "You can\u2019t launch a program as an administrator by typing <code>%command% admin</code> in the run box. One best practice for an administrator is to log in as a standard user and only use administrator privileges when required. To run a program as an administrator, you can right-click a program and choose Run as administrator or launch the program and type an administrator password in the user account control (UAC) box, or you can open the command prompt as an administrator and then launch a program from the command prompt. Remember that administrators can do anything in a system, while a standard user can\u2019t, so only work as an administrator when it\u2019s necessary to do so.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      170,
      117,
      123,
      167,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 1031,
    "question": "Which security model requires that, rather than assuming a user is who they say they are because they\u2019re logged in to a network, they must continually authenticate who they are to access or continue accessing resources?",
    "choice_a": "Zero-trust",
    "choice_b": "Principal of least privilege",
    "choice_c": "Inheritance",
    "choice_d": "UAC",
    "correct_answer": "A",
    "explanation": "With a zero-trust model, a user is not assumed to have access to resources because they have logged in to a network as a specific user. They must provide authentication information on a recurring basis. The principle of least privilege states that you only give a user access to the resources that they need and nothing more. Inheritance means that when an object is inside a container, it takes on the access rules of the parent container. User accounts control (UAC) is a method of requiring authentication before being able to run a restricted program.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      118,
      123,
      160,
      117,
      121
    ],
    "source": "9781394330348"
  },
  {
    "id": 1032,
    "question": "Which logical security tool provides a password or code that expires in a short time period?",
    "choice_a": "SSO",
    "choice_b": "TOTP",
    "choice_c": "Zero-trust",
    "choice_d": "PAM",
    "correct_answer": "B",
    "explanation": "A time-based one-time password (TOTP) expires after a given period of time and can\u2019t be used to authenticate a user after that time. Single sign-on (SSO) assumes that a user is who they say they are, because they\u2019ve signed in to a network with their username and password. It\u2019s essentially the opposite of the zero-trust model. Privileged access management (PAM) is a system for monitoring who and what has administrative access and reporting unusual events to mitigate cybersecurity attacks.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      123,
      158,
      120,
      160
    ],
    "source": "9781394330348"
  },
  {
    "id": 1033,
    "question": "Which security feature provides a password that is often delivered via email or SMS and can only be used once to grant access to a resource?",
    "choice_a": "SSO",
    "choice_b": "JIT",
    "choice_c": "OTP",
    "choice_d": "PAM",
    "correct_answer": "C",
    "explanation": "A One-time password (OTP) is often delivered via email or short message service (SMS) and is only valid for that session. This helps verify the person requesting access is the person who previously entered their email or phone number into a system. Single sign-on (SSO) assumes that a user who has gained access to a network is that person and is not required to authenticate again, although they may be required to enter an OTP or other credential to access some resources. Just-in-time (JIT) systems grant access to resources only when needed and for a specific time period. JIT is part of privileged access management (PAM). PAM tracks, monitors, and manages access beyond a standard user, whether the user is a person, an application, or a machine.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      121,
      122,
      120,
      123,
      169
    ],
    "source": "9781394330348"
  },
  {
    "id": 1034,
    "question": "Which of the following is a feature of PAM that grants access to a system only when it is needed for a limited period of time?",
    "choice_a": "SSO",
    "choice_b": "JIT",
    "choice_c": "OTP",
    "choice_d": "IAM",
    "correct_answer": "B",
    "explanation": "Just-in-time (JIT) systems grant access to resources only when needed and for a specific period of time. JIT is part of privileged access management (PAM). PAM tracks, monitors, and manages access beyond a standard user, whether the user is a person, an application, or a machine. Single sign-on (SSO) assumes that a user who has gained access to a network is that person and is not required to authenticate again, although they might be required to enter a one-time password (OTP) or other credential to access some resources. An OTP is often delivered via email or short message service (SMS) and is only valid for that session. This helps verify that the person requesting access is the person who previously entered their email or phone number into a system. Identity access management (IAM) supports SSO but uses adaptive multifactor authentication (MFA), where the specific factor used is based on situations such as time of day, location, IP address, device, and so on.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      122,
      121,
      117,
      125
    ],
    "source": "9781394330348"
  },
  {
    "id": 1035,
    "question": "A coworker is having problems with the Bluetooth connection between a device and their laptop. Which of the following can you do to check connectivity between the laptop and the device? (Choose two.)",
    "choice_a": "Ensure that Bluetooth is turned on in Settings.",
    "choice_b": "Ensure that Airplane mode is on.",
    "choice_c": "Ensure that Airplane mode is off.",
    "choice_d": "Go to a command prompt or terminal and type <code><b>Bluetooth</b></code> to enable it.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Bluetooth must be turned on in Settings before it will work. Airplane mode must be off for Bluetooth or any other wireless connection to work. Typing <b>Bluetooth</b> at a command prompt will not enable it.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      226,
      225,
      224,
      223,
      222
    ],
    "source": "9781394330348"
  },
  {
    "id": 1036,
    "question": "You just installed a new sound card and its drivers in a Windows workstation. Now, the computer has crashed and given you a blue screen of death. You turn the computer off. What should you try to resolve the issue?",
    "choice_a": "Reinstall Windows.",
    "choice_b": "Boot to the Windows installation media and start the WinRE.",
    "choice_c": "Boot to safe mode and uninstall the sound card driver.",
    "choice_d": "Remove the sound card from the computer and reboot.",
    "correct_answer": "C",
    "explanation": "The first thing to try when you get a blue/black screen of death (BSOD) error is to reboot. (In Windows 11, the black screen of death was reverted to the familiar blue screen. A black screen of death means that the build of Windows is outdated.) If the problem goes away, it may have been a one-time glitch. Often BSOD errors are caused by hardware or drivers, and because you just installed a new sound card and drivers in Windows, that would be the likely suspect. Use the Windows Recovery Environment (WinRE) to boot into safe mode. Once in safe mode, uninstall the driver and look for an updated one on the sound card manufacturer\u2019s website.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      205,
      203,
      208,
      204,
      202
    ],
    "source": "9781394330348"
  },
  {
    "id": 1037,
    "question": "An iPad user reports that when they are in a certain part of the building, their wireless connection intermittently drops. What are the most likely causes of this? (Choose two.)",
    "choice_a": "Poor wireless buffering in the iPad",
    "choice_b": "Interference with the wireless signal",
    "choice_c": "Weak signal strength from the wireless access point",
    "choice_d": "Retracted Wi-Fi antenna on the iPad",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "There are a number of reasons intermittent wireless connections can occur, but the two most common are lack of a good signal and interference. Increasing the number of wireless access points (WAPs), or being closer to one, can address the lack of a good signal. Interference can be addressed by reducing the number of devices competing for the same channel or by moving away from walls, appliances operating on the same frequency, or obstacles. A poor wireless signal can cause video buffering, not the other way around, and Wi-Fi antennas for mobile devices are often found inside the display housing, not a retractable antenna.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      226,
      223,
      225,
      230,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1038,
    "question": "You noticed that your browser is running much more slowly than normal, even though you have a strong Wi-Fi connection. Which of the following are likely causes? (Choose three.)",
    "choice_a": "Too many tabs open",
    "choice_b": "Cache needs clearing",
    "choice_c": "Too much RAM",
    "choice_d": "Poorly written extension or add-on",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "There are a number of reasons why your browser might be running slowly (experiencing degraded performance). First, close any tabs that aren\u2019t needed. Having more than one instance of a browser open can also slow down the browser. A full cache will also slow down your browser, and if you\u2019ve added any new extensions or add-ons, try uninstalling them and see if the performance is better. Of course, malware or a browser that isn\u2019t up to date can cause degraded browser performance. Too much RAM is never a problem!",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      215,
      201,
      219,
      208,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1039,
    "question": "On your MacBook Pro, you use the Safari browser to surf the Internet. Yesterday, a friend borrowed your laptop. Today, when you try to browse the Web, no matter what site\u2019s URL you type into the address bar, you are sent to a different website. What is most likely happening to your computer?",
    "choice_a": "A practical joke by your friend",
    "choice_b": "Browser redirection",
    "choice_c": "Rogue antivirus",
    "choice_d": "Spam infection",
    "correct_answer": "B",
    "explanation": "This is a classic symptom of browser redirection, which means that you type in a specific Uniform Resource Locator (URL) and are taken to a different website. The perpetrator has one goal, which is to direct you to websites that they want you to visit, regardless of what you actually want to see. Removing the redirector might be as simple as uninstalling an application (by dragging it to the Trash and emptying it), or it might require full-scale malware mitigation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      219,
      208,
      212,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1040,
    "question": "Your company purchases a custom database software package from an outside vendor. You install the client software on a Windows workstation, and it crashes when you try to open it. You remove the software and reinstall it, but again it crashes when you open it. What should you do next?",
    "choice_a": "Run an anti-malware remediation on the workstation.",
    "choice_b": "Contact the vendor to see whether an update or patch is available.",
    "choice_c": "Delete and reinstall Windows.",
    "choice_d": "Enable Software Compatibility through the Control Panel.",
    "correct_answer": "B",
    "explanation": "When an application crashes, you want to isolate the cause of the crash. It could be a compatibility issue, hardware, or a host of other problems. Once it\u2019s isolated, you can solve the issue. One step to take early in the resolution process is to look for updates, patches, or fixes to the application released by the vendor. It\u2019s not likely to be a malware issue because you just installed this application and haven\u2019t mentioned any malware symptoms. Deleting and reinstalling Windows is a drastic measure that would be your last-ditch effort. Compatibility settings can be found in the Properties menu of a program file.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      208,
      204,
      201,
      216,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1041,
    "question": "An iPhone user reports that their phone will not connect to their wireless headset for hands-free phone calls. The headset is powered on and has worked previously. Their iPhone screen is shown in the graphic. What is most likely the problem?<img src=\"/question_assets/220-1202/c08f001.png\" alt=\"Screenshot of an I O S Control Center, with Wi-Fi enabled and all other options disabled.\"/>\n\n<figcaption>Screenshot of an I O S Control Center, with Wi-Fi enabled and all other options disabled.</figcaption>",
    "choice_a": "The headset is not paired with the iPhone.",
    "choice_b": "Bluetooth is turned off.",
    "choice_c": "Wi-Fi is turned off.",
    "choice_d": "Airplane mode is turned on.",
    "correct_answer": "B",
    "explanation": "Lack of Bluetooth connectivity is often caused when a device is not turned on and/or has an improper setting for discoverability. Make sure the device is turned on and discoverable (checking the manufacturer\u2019s documentation if necessary).",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      226,
      221,
      222,
      223,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1042,
    "question": "A user reports that their Windows Start menu looks wrong and takes too long to load. You know the environment relies on roaming profiles. What is a reliable solution to the user\u2019s problem?",
    "choice_a": "Rebuild the desktop image.",
    "choice_b": "Rebuild the Windows user profile.",
    "choice_c": "Delete the Registry on the local machine.",
    "choice_d": "Reboot the machine.",
    "correct_answer": "B",
    "explanation": "There are many reasons why a profile might load slowly. If the user hasn\u2019t logged on to this computer before, the entire profile is downloaded instead of only what needs updating. If they have and it\u2019s still slow, then it may be a very large profile. Sometimes the profile is corrupted, which can show as a screen looking strange. Rebuilding the Windows profile will fix a corrupted profile. Roaming profiles tend to experience problems, most of which can be reliably fixed by rebuilding the Windows profile.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      208,
      204,
      201,
      218,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1043,
    "question": "While working on a Windows workstation, a user receives a flashing pop-up message saying that their computer has been infected with ransomware and they need to download an anti-malware update now to fix it. What will most likely happen if they click the button to download the recommended anti-malware?",
    "choice_a": "It will download malware to their computer.",
    "choice_b": "It will download an anti-malware program to their computer and remediate it.",
    "choice_c": "The anti-malware program they download will scan their computer and find nothing because their company already uses an anti-malware program.",
    "choice_d": "It will take them to a website that will allow them to purchase an anti-malware program to remediate the system.",
    "correct_answer": "A",
    "explanation": "One of the more clever ways of spreading a virus is to disguise it so that it looks like an actual anti-malware program. When it alerts the user to a fictitious problem, the user then begins interacting with and allowing the rogue program to do all sorts of damage. One of the trickier tactics that troublemakers use is to make the program look as if it came from a trusted source\u2014such as Microsoft\u2014and mimic the user interface enough to fool an unsuspecting user. The other three options are not likely to occur.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      212,
      219,
      215,
      231,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1044,
    "question": "You have 20 Windows 11 workstations on your network. You want to create bootable media that will allow you to fix Windows boot issues. Where can you create this media?",
    "choice_a": "Use Windows Security in the Settings app.",
    "choice_b": "Back up and sync your settings in the Settings app.",
    "choice_c": "Download and use Microsoft\u2019s media creation tool.",
    "choice_d": "Copy the contents of the C drive to a USB.",
    "correct_answer": "C",
    "explanation": "If you need installation media, search for and download the Windows media creation tool, which will enable you to create a bootable universal serial bus (USB) or DVD. In addition to creating bootable media, you can download an international organization for standardization (ISO) file, which can be stored on a server and accessed over a network. Copying the contents of the C drive will not create installation media, and the drive won\u2019t be bootable. Windows Security in the Settings app will bring you to several security options, but none of them can create installation media; neither does backing up and syncing your settings.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      202,
      203,
      216,
      208,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1045,
    "question": "Your Windows system doesn\u2019t appear to be stable. It\u2019s slow to respond when you want it to open a file. You just installed a new software application yesterday. What actions can you take to fix this problem? (Choose two.)",
    "choice_a": "Reinstall Windows.",
    "choice_b": "Run an anti-malware scan.",
    "choice_c": "Use WinRE to reformat the drive.",
    "choice_d": "Restore from a recent system restore point.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Because you just installed a new application, chances are that it is the cause of all the problems you\u2019re having now. It\u2019s possible that malware was introduced into your system. If the scan finds nothing, then it might be a problem with the application. In that case, a restore point will restore any system settings that may have been changed and may uninstall the software, but your data won\u2019t be affected. Reinstalling Windows is likely not necessary. You would not want to reformat the drive unless the system could not be repaired.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      219,
      208,
      204,
      205,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1046,
    "question": "Your Windows system is running sluggishly. When you look at the storage drive, you notice that there is very little space available. Which tool should you run to attempt to free some space on the drive?",
    "choice_a": "Optimize and Defragment Drive",
    "choice_b": "Disk Cleanup",
    "choice_c": "<code>regedit</code>",
    "choice_d": "SFC",
    "correct_answer": "B",
    "explanation": "If you save many large files, and the storage drive gets to be under ten percent of free space, its performance can slow down dramatically. The Disk Cleanup utility will show how much disk space is being taken up by temporary files, log files, the Recycle Bin, and other items that can easily be deleted. This could free up some disk space. You will possibly need to delete some files as well. The Optimize and Defragment Drive utility will help with mechanical hard disk drives (HDDs), but not solid-state drives (SSDs). In fact, running it could damage an SSD. Although it could help a sluggish system perform better, it doesn\u2019t free up space. The Registry Editor is a tool that should only be used when there isn\u2019t another utility that can do the same task. Improperly changing the Registry could cause the operating system to crash. Run system file checker (SFC) if you\u2019re having problems related to system files; it won\u2019t free up space on your drive.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      201,
      207,
      204,
      216,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1047,
    "question": "A user reports that a Word document they need will not open. Other documents open as they should. They have not made a backup of this file. Which of the following statements is true?",
    "choice_a": "The file is probably corrupted, and its contents are lost.",
    "choice_b": "They can use a restore point to get the file back.",
    "choice_c": "They can use the command-line utility to open the document.",
    "choice_d": "They can use WinRE to repair the file and then open it.",
    "correct_answer": "A",
    "explanation": "Sadly, if the user hasn\u2019t backed up this file, it is likely lost. A restore point backs up system configuration, not user files. If a file won\u2019t open in the graphical user interface (GUI), it probably won\u2019t open at a command prompt either. The Windows Recovery Environment (WinRE) can fix problems with the system booting or restore the entire machine from an image, but if the files aren\u2019t on the image, then WinRE can\u2019t restore or open the file either.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      218,
      203,
      208,
      219,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1048,
    "question": "You\u2019ve been working very hard and have several Word documents open on your desktop. Luckily, you\u2019ve been saving them often, because suddenly the Word app is showing all sorts of strange characters on the screen, even in the ribbon at top. It appears to be corrupted, and it won\u2019t respond to any commands, including Close. How can you force the app to close, so you can reopen the saved files and continue your work? (Choose two.)",
    "choice_a": "Double-click the program file.",
    "choice_b": "Right-click anywhere in the program window and choose Close.",
    "choice_c": "Open Task Manager and select the Processes tab. Then right-click the program name and choose End Task.",
    "choice_d": "Reboot the computer.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Rebooting the computer should close the app and clear anything out of random access memory (RAM), but you might be able to solve the problem with less-drastic measures by ending the process using Task Manager. Double-clicking the program file and right-clicking in the window won\u2019t help because the program is corrupted and not responding.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      208,
      204,
      202,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1049,
    "question": "Your iPad is experiencing slow performance. What are the best two options to increase performance speed? (Choose two.)",
    "choice_a": "Close open apps.",
    "choice_b": "Perform a reset to the factory default.",
    "choice_c": "Increase the RAM.",
    "choice_d": "Perform a soft reset.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Slow performance is often related to random access memory (RAM). Look for any apps that are running and can be closed or perform a soft reset (i.e., cycle power off and on again) to try to free up memory. Resetting to the factory default will delete all data on the device. You can\u2019t upgrade the RAM in an iPad, because the RAM is soldered directly to the motherboard and is not designed to be user replaceable.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      223,
      221,
      222,
      224,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1050,
    "question": "You just downloaded an app to connect to your bank on your mobile device. You weren\u2019t sure which app to choose, so you picked the one that looks most like your bank. After installing the app, something didn\u2019t look right, and you noticed misspelled words on the screen where it\u2019s asking for your username and password. What should you do next?",
    "choice_a": "Enter your username and password.",
    "choice_b": "Call the bank and ask them about the app.",
    "choice_c": "Uninstall the app immediately and run an anti-malware scan.",
    "choice_d": "Run a spell checker on the app.",
    "correct_answer": "C",
    "explanation": "Most likely this is a malicious application that is trying to steal your login or other personal information (PI). Misspellings are a red flag that the application is an attempt by a malicious person to spoof your bank\u2019s app. Uninstall the offending app immediately and run a malware scan to ensure that nothing malicious was loaded on your system when you downloaded the app. Whatever you do, don\u2019t enter your username and password! You could also call the bank and let them know about the app so they can warn other bank patrons. Running spell check on the app wouldn\u2019t help you or even be possible on the app.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      219,
      218,
      231,
      230,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1051,
    "question": "You are visiting a website using your favorite browser, and without you clicking anything, a new browser window opens in front of it with an advertisement. Which of the following is the most likely explanation?",
    "choice_a": "Your computer has been infected with adware.",
    "choice_b": "Your computer has been infected with spyware.",
    "choice_c": "Your computer has been infected with a virus.",
    "choice_d": "The website is programmed to show a pop-up advertisement.",
    "correct_answer": "D",
    "explanation": "Pop-ups are annoying but not necessarily an indication that your browser or computer is infected with anything. Most likely, the website is programmed to show a pop-up advertisement. Adware pop-ups usually spam your desktop with multiple (if not dozens of) windows at the same time. Spyware generally doesn\u2019t announce its presence, and viruses generally do more damage than a simple pop-up ad does.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      215,
      231,
      219,
      212,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1052,
    "question": "You are talking to a friend about purchasing a gift, and they recommend a website to purchase it. When you put the website\u2019s secure address into your browser, you receive a message stating that there is an invalid certificate. What should you do?",
    "choice_a": "Visit the website anyway; it\u2019s probably okay.",
    "choice_b": "Do not visit the website.",
    "choice_c": "Visit the secure version of the website by changing the address to start with <code>HTTPS://</code>.",
    "choice_d": "Visit the unsecure version of the website by changing the address to start with <code>HTTP://</code>.",
    "correct_answer": "B",
    "explanation": "An invalid certificate usually means that the certificate that you have (or the one the website has) has expired. It could mean that the website is fine. But it could also mean someone has set up a Trojan that imitates the website you are seeking. Do not visit it. If it\u2019s a website you are not familiar with, the best bet is to avoid it altogether. An invalid certificate could also indicate that the time and/or date on your computer is incorrect.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      213,
      215,
      219,
      212,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1053,
    "question": "Your favorite restaurant locator app on your iPhone won\u2019t load. You closed it and tried to reopen it a few times, and it still doesn\u2019t work. What should you try next?",
    "choice_a": "Remove and reinstall the app.",
    "choice_b": "Perform a factory reset.",
    "choice_c": "Force-stop the app.",
    "choice_d": "Reboot the phone and try the app again.",
    "correct_answer": "D",
    "explanation": "Rebooting (i.e., powering off and back on) any device will clear what is in its memory and sometimes help with application problems, so try rebooting the phone and try the app again. If that doesn\u2019t work, you might want to remove and reload the app. Be sure to check the vendor\u2019s website for any known problems. You would not want to perform a factory reset for a problem with one app, because that would delete everything on your phone. Performing a force-stop on the app would close it if it were open, but in this scenario, you can\u2019t load the app.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      221,
      222,
      208,
      224,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1054,
    "question": "You\u2019re using your smartphone. When is it generally necessary to force-close running apps?",
    "choice_a": "When you receive out-of-memory errors",
    "choice_b": "When the phone is sluggish",
    "choice_c": "When an app locks up",
    "choice_d": "When you are done using them for the day",
    "correct_answer": "C",
    "explanation": "If an app on your smartphone is locked up, then you need to force-close the app, which is done on many devices by swiping the app up. Depending on the device, it may be done differently. Apps running in the smartphone\u2019s background aren\u2019t really running or using resources, unless you\u2019ve set them up to refresh in the background. (Android apps aren\u2019t as good at this as iPhone apps are.) You likely won\u2019t get an \u201cout of memory\u201d error message, but you might run out of storage space. If your phone is sluggish, it\u2019s likely that the battery is low or you\u2019re running out of storage space. You don\u2019t need to close apps when you\u2019re done with them for the day. If they\u2019re in the background, they aren\u2019t using resources.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      221,
      223,
      222,
      225,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1055,
    "question": "You receive an email warning you of a new form of ransomware. It contains a link to receive more information on how to protect yourself from this terrible threat. What should you do next?",
    "choice_a": "Click the link to receive more information.",
    "choice_b": "Check your antivirus provider\u2019s website for information on the threat.",
    "choice_c": "Check to ensure that your system has a rogue antivirus installed.",
    "choice_d": "Forward the email to everyone in your contacts list.",
    "correct_answer": "B",
    "explanation": "The email could be real, but most likely it\u2019s a fake security warning. Worse yet, it could be malware itself, and by clicking the link you will activate it on your computer. Always check a reputable source, such as a trusted anti-malware vendor for information on the latest threats. At a minimum, delete the email and don\u2019t click the link!",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      219,
      218,
      212,
      231,
      215
    ],
    "source": "9781394330348"
  },
  {
    "id": 1056,
    "question": "Mobile device users on your network are required to use a VPN app to connect to the corporate network when they are out of the office. A user reports that the app will not open for them. They\u2019re using a tablet, which they have turned off and back on again, and the app still will not open. What should be tried next?",
    "choice_a": "Cycle the power.",
    "choice_b": "Reset the device to factory defaults.",
    "choice_c": "Uninstall and reinstall the app.",
    "choice_d": "Perform a force-stop.",
    "correct_answer": "C",
    "explanation": "If an app does not load, the first thing to try is rebooting. If that does not work, attempt to uninstall and reinstall the app. Be sure to check the vendor\u2019s website for any similar problems (and solutions) encountered by others. Cycling the power is turning the device off and on again. The user has already done that. A reset to factory default wipes the device, and would be the last remedy you would try for repairing any device problem, whether the device is a phone, a tablet, or any other computing device. A force-stop, also called a force-close, is merely closing the app, which you can\u2019t do because it won\u2019t open.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      221,
      222,
      208,
      224,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1057,
    "question": "Your Windows desktop system is running sluggishly. You have a magnetic hard drive and an M.2 drive. What could you do that might improve system performance? (Choose two.)",
    "choice_a": "Run Optimize and Defragment Drive on the magnetic media drive.",
    "choice_b": "Run Disk Cleanup on both drives.",
    "choice_c": "Run Optimize and Defragment Drive on the M.2 drive.",
    "choice_d": "Run SFC.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "If you save many large files, and the hard drive gets to be under ten percent of free space, its performance can slow down dramatically. The Disk Cleanup utility will show how much disk space is being taken up by temporary files, log files, the Recycle Bin, and other items that can easily be deleted. This could free up some disk space. Optimize and Defragment Drive will help with mechanical hard disk drives (HDDs), but not solid-state drives. In fact, running it could damage a solid-state drive like your M.2. As you access and change files on a drive, the parts of the files can end up scattered in different places. With a mechanical drive, retrieving the files will be faster if the file\u2019s pieces are next to each other on the drive. This isn\u2019t as important in a solid-state drive. Defragmenting the drive rearranges it and places each file\u2019s scattered pieces together. System file checker (SFC) should be run if you\u2019re having problems related to system files. It won\u2019t free up space on your drive.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      201,
      207,
      212,
      208,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1058,
    "question": "You are visiting a website using your favorite browser. You haven\u2019t clicked anything, yet you can barely read the page because there are so many pop-ups. Which of the following is most likely causing the random, frequent pop-ups?",
    "choice_a": "Your computer has been infected with adware.",
    "choice_b": "The website is poorly written.",
    "choice_c": "The website uses pop-ups to interact with you.",
    "choice_d": "The website is programmed to show a pop-up advertisement.",
    "correct_answer": "A",
    "explanation": "Adware pop-ups usually spam your desktop with multiple (if not dozens of) windows at the same time. The website could be poorly written, but that\u2019s not the most likely issue. If a website is using pop-ups to gather information from you, they wouldn\u2019t have so many that you can\u2019t see their website. A website may have legitimate pop-up ads, but they won\u2019t have so many that it sends you to another website.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      215,
      231,
      219,
      212,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1059,
    "question": "Client computers on your network connect to the Internet through a proxy server. Recently, a Windows client was infected with adware and a browser redirector. You have removed the malware, and now the computer will not connect to the Internet. What should you do to resolve the problem?",
    "choice_a": "Disable the network card. Reboot and enable the network card.",
    "choice_b": "Perform malware remediation again.",
    "choice_c": "Disable the proxy server configuration to connect directly to the Internet.",
    "choice_d": "Check the IP configuration to ensure that it\u2019s pointing to the correct proxy server address.",
    "correct_answer": "D",
    "explanation": "Malware can change more settings than you might be aware of on a computer. For example, adware might be obvious because of the pop-ups and browser redirects, but it can also change the client-side IP settings that point to a Domain Name System (DNS) or proxy server. Check the IP configuration on the client computer and be sure it\u2019s set properly. The other options are not likely the cause or fix to this issue and may cause other problems.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      215,
      219,
      212,
      231,
      213
    ],
    "source": "9781394330348"
  },
  {
    "id": 1060,
    "question": "Your company has recently made changes to infrastructure services such as DNS. Since then, a number of users have reported that they are no longer able to connect to internal servers by name. What can be done at each affected workstation to fix the problem? (Choose two.)",
    "choice_a": "Reboot.",
    "choice_b": "Manually update network settings.",
    "choice_c": "Disable the software firewall.",
    "choice_d": "Boot to safe mode.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Updating the network settings manually or rebooting should apply the new Domain Name System (DNS) information. Disabling the firewall or booting to safe mode will not help the issue.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      226,
      206,
      202,
      204,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1061,
    "question": "Your windows computer has not been functioning properly since you installed a new application. You believe the application was poorly written and is causing the issue. You want to refresh your Windows installation but keep your personal files. Where can this be done? (Choose three.)",
    "choice_a": "System Recovery in the Settings app",
    "choice_b": "Safe mode",
    "choice_c": "Emergency repair disk",
    "choice_d": "WinRE",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "If you\u2019re able to use the operating system (OS), then go to the Settings app and search for System Recovery, which provides recovery options, including resetting the OS without touching your files. Another option on the same screen is Advanced Startup, where you can click Restart Now. This will restart the computer and bring up the Windows Recovery Environment (WinRE). In WinRE, one of the options is to boot into safe mode, which will enable you to use the options in Settings, as already explained. Alternately, hold the Shift key while restarting the computer. This will also cause the PC to boot into the WinRE. <i>Read carefully:</i> A Windows Repair Disk will enable you to boot into safe mode via WinRE, but without knowing what the \u201cemergency\u201d repair disk is, you don\u2019t know what it will do. It could be an anti-malware boot disk, or another bootable disk with troubleshooting tools.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      203,
      205,
      208,
      216,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1062,
    "question": "A Windows user\u2019s vertical market application has crashed. They reboot the computer and try to open it again, and it crashes again. What should be done next to solve the problem? (Choose two.)",
    "choice_a": "Look for a patch or update on the manufacturer\u2019s website.",
    "choice_b": "Delete the application and reinstall it.",
    "choice_c": "Remove and reinstall Windows.",
    "choice_d": "Repair the application through Programs and Features in the Control Panel.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "When an application crashes, you want to isolate the cause of the crash\u2014it could be a compatibility issue, hardware, or a host of other problems\u2014and solve it. One early step to take is to look for updates/patches/fixes to the application released by the vendor. You can also try to repair the installation through the Control Panel. If needed, you can delete and reinstall the software, but you should try patching or repairing first. You would not want to remove and reinstall Windows.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      208,
      204,
      216,
      201,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1063,
    "question": "A user reports that an application has been crashing on their mobile device. They said an error pop-up window flashes on the screen briefly, but they are unable to read it. What would be your next step?",
    "choice_a": "Wait for the next crash to read the error pop-up yourself.",
    "choice_b": "Install and run a screen recorder to capture the next pop-up.",
    "choice_c": "Reinstall the application.",
    "choice_d": "Check the application log for error messages.",
    "correct_answer": "D",
    "explanation": "Whatever message appears in the pop-up window is likely logged in the mobile application log. Steps for accessing the log will vary by device and operating system. If it was too fast for the user to read, it\u2019s probably too fast for you to read too. You would not want to install any additional software until this problem is resolved, and reinstalling the application may not be necessary.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      221,
      222,
      204,
      223,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1064,
    "question": "A user reports that the battery life on their smartphone is very short. It works for only about three hours before it needs to be recharged. What can you recommend they do to extend their phone\u2019s battery life? (Choose two.)",
    "choice_a": "Turn off unnecessary wireless connections.",
    "choice_b": "Perform a reset to factory defaults.",
    "choice_c": "Set the screen to automatically dim.",
    "choice_d": "Install an antivirus app.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Tips for increasing battery life include keeping operating system (OS) updates applied (they may include energy-saving patches), avoiding ambient temperatures that are too high or too low, letting the screen automatically dim, and turning off location-based services. Also turn off Wi-Fi if you\u2019re away from your network or not using Wi-Fi, because if it\u2019s on and not connected, the phone will continually search for Wi-Fi connections. You should also disconnect peripherals and quit applications that are not in use. (Bluetooth, for example, uses power when enabled, even if you are not using it to connect to anything.) A reset to factory defaults won\u2019t help with battery life, and you\u2019ll lose all your stuff! Installing an antivirus app also won\u2019t help here.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      225,
      223,
      224,
      221,
      222
    ],
    "source": "9781394330348"
  },
  {
    "id": 1065,
    "question": "A laptop user is unable to access the Wi-Fi network and is receiving an error message that a duplicate IP exists on the system. You are confused because you have a DHCP server. What do you need to do next?",
    "choice_a": "Manually configure the IP address.",
    "choice_b": "Ensure that this computer is set to obtain an IP address automatically.",
    "choice_c": "Ping the IP address from another computer to find out the name of the duplicate computer.",
    "choice_d": "At a command prompt, enter <code>ipconfig /release</code> and then <code>ipconfig /renew</code>.",
    "correct_answer": "B",
    "explanation": "Every network device must have a unique IP address. Many networks use a Dynamic Host Configuration Protocol (DHCP) server to assign IP addresses, because keeping track of them manually would create a great deal of work. If there are two identical IP addresses attempting to access a network with DHCP, then at least one of them very likely has its IP address configured manually. Ensuring that this computer is set to obtain an IP address automatically should be your first step. If it isn\u2019t, then you have found the problem. If it is, then you could ping the IP address using <code>ping -a <i>ipaddress</i></code>, substituting the duplicated IP address for the variable <code><i>ipaddress</i></code> in the command. This will return the hostname of the other computer. Every network admin should have a list of computer names and where they are located. You could then ensure that the other computer is also set to obtain an IP address automatically, or if the other device requires a static IP, remove the IP address in question from the available pool of addresses on the DHCP server. Manually configuring an IP address is what caused the problem. The <code>ipconfig /release</code> and <code>ipconfig /renew</code> commands wouldn\u2019t help in this situation.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      201,
      208,
      212,
      215,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1066,
    "question": "You are working on your Windows computer and a security alert pops up, as shown in this graphic. What should your next action be?<img src=\"/question_assets/220-1202/c08f002.png\" alt=\"Screenshot of Windows Security Alert warning about an infected file due to the Conficker dot Worm Virus, with Protect Now option.\"/>\n\n<figcaption>Screenshot of Windows Security Alert warning about an infected file due to the Conficker dot Worm Virus, with Protect Now option.</figcaption>",
    "choice_a": "Click the Protect Now button.",
    "choice_b": "Click the X in the upper-right corner to close the alert.",
    "choice_c": "Shut down your computer. Reboot it using an anti-malware boot device, and then initiate a malware scan.",
    "choice_d": "Use System Restore to create a snapshot, and then click the Protect Now button.",
    "correct_answer": "C",
    "explanation": "Don\u2019t click anywhere on the warning! This is a fake security warning. It is either a hoax, or when you click on the pop-up, it will install malware. Even clicking the X to close the window may install malware, so don\u2019t do it. Your best course of action is to shut down the computer, reboot, and initiate a malware scan using your anti-malware software. Note that if the computer is on a wired network, you should disconnect the cable before restarting, or if on Wi-Fi, disable Wi-Fi before restarting to protect the rest of the network.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      219,
      218,
      231,
      215,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1067,
    "question": "You have a Windows workstation that is spontaneously shutting down and restarting. What should you do to troubleshoot and resolve the issue?",
    "choice_a": "Check the system BIOS/UEFI settings to ensure that the boot order is set properly.",
    "choice_b": "Boot to the Windows installation media, and navigate to the WinRE command prompt.",
    "choice_c": "Boot into safe mode and see if the problem still persists.",
    "choice_d": "Reinstall Windows.",
    "correct_answer": "C",
    "explanation": "Occasionally, a rogue system will begin automatically shutting down and/or restarting while in use. Although it could be indicative of a hardware problem (e.g., a malfunctioning motherboard or faulty internal connector), it can also indicate a setting misconfiguration or driver problem. The most likely setting problem is with sleep settings, such as hibernation mode. If that\u2019s not it, then it could be a corrupt driver. To begin ruling out possibilities, boot the system into safe mode, and then see whether the problem continues. If the problem does not occur while in safe mode, then boot normally and begin testing what occurs as you eliminate drivers/devices one by one (e.g., sound, video, etc.) until you find the culprit. The boot order in the basic input/output system/unified extensible firmware interface (BIOS/UEFI) settings would have nothing to do with this problem. While you might need to go into Windows Recovery Environment (WinRE) to fix the problem, that would not be your next step. You certainly don\u2019t need to reinstall Windows, at least not yet.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      205,
      204,
      203,
      208,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1068,
    "question": "A Windows desktop computer always shuts down about 10 minutes after the user boots it up. The computer works fine for those first 10 minutes, and if they boot up again a few minutes after a shutdown, it works fine again for 10 minutes. How might you fix this? (Choose two.)",
    "choice_a": "Reinstall Windows.",
    "choice_b": "Use compressed air or an ESD vacuum to clean dust and debris from the system.",
    "choice_c": "Use SFC to search for and repair corrupted system files.",
    "choice_d": "Replace the thermal paste on the processor.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Although it may appear to be a problem with the operating system (OS), this is classic behavior for a system that is overheating. There are a few things to do here. Ensure that all system vents are free of dust and debris, so that air can move freely through. Use compressed air or an antistatic computer vacuum to remove dust from inside the case. Note that the vacuum cleaner must be one designed for use on electronics. Other vacuums cause static, which can damage the computer. Dust on a motherboard can act as a blanket holding heat in, or worse, conductive particles in dust can cause a short circuit and damage the motherboard. Make sure there is adequate room around the case for airflow; if the system is overclocked, revert to running the central processing unit (CPU) at its manufacturer\u2019s recommended speed. If none of those remedy the situation, try replacing the processor\u2019s thermal paste with new thermal paste. Reinstalling Windows or checking system files is not necessary when the computer is overheating.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      204,
      201,
      205,
      225,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1069,
    "question": "Your Windows computer was working fine yesterday, but today it is exhibiting slow (degraded) performance. Which of the following tools should be used to check for a potential problem causing the slowdown? (Choose two.)",
    "choice_a": "Anti-malware software",
    "choice_b": "Event Viewer",
    "choice_c": "Task Manager, Processes tab",
    "choice_d": "Programs and Features in the Control Panel",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "If the computer was fine yesterday and slow today, your first thought should be that it might have been attacked by malware. Malware running in the background is notorious for taking up system resources. Scan your system with anti-malware, or shut down the system and restart with an anti-malware boot device (which can detect malware loaded before the operating system [OS] is loaded). If malware is not found on your system, look next at the Processes tab of Task Manager. Click Memory at the top to sort the list by how much memory each program is using. It may be software launched at startup that you don\u2019t need or another program that doesn\u2019t need to run all the time. Based on what you find there, take appropriate action.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      201,
      219,
      204,
      207,
      215
    ],
    "source": "9781394330348"
  },
  {
    "id": 1070,
    "question": "A user on your Active Directory domain is complaining that their profile is taking a long time to load. They\u2019ve been waiting several minutes. Upon questioning, you find out that this is their first logon at a different computer. What is happening here?",
    "choice_a": "They are not listed as a user on this computer.",
    "choice_b": "Their roaming profile is downloading to this computer, and it takes longer the first time a user logs on to a different PC.",
    "choice_c": "A peripheral is not connected as it should be, causing a loop in the boot process.",
    "choice_d": "They entered the wrong password.",
    "correct_answer": "B",
    "explanation": "Active Directory (AD) stores user information on a Windows domain, including their profile. The first time a user logs on to a machine on the domain, the entire profile is downloaded, which may take a few minutes. For subsequent logons on the same machine, only the changes to the profile are downloaded, making the process much faster. If the user then logs in to a different machine, the entire profile must be downloaded so that the logon won\u2019t be as fast as the user is accustomed to. They don\u2019t need to be listed as a user on this computer as long as they are a user on the Active Directory. A peripheral being connected or not should not affect the profile download, and entering the wrong password would quickly generate an error message stating that fact.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [],
    "source": "9781394330348"
  },
  {
    "id": 1071,
    "question": "A Windows user at your office receives the message shown in the graphic when trying to print a document. They know that there were two printers listed yesterday. What is most likely the problem?<img src=\"/question_assets/220-1202/c08f003.png\" alt=\"Screenshot of Adobe Acrobat dialog box with a printer installation message and an OK button.\"/>\n\n<figcaption>Screenshot of Adobe Acrobat dialog box with a printer installation message and an OK button.</figcaption>",
    "choice_a": "Someone has deleted their printers.",
    "choice_b": "Both printers are offline.",
    "choice_c": "Both printers are out of paper.",
    "choice_d": "The print spooler service needs to be restarted.",
    "correct_answer": "D",
    "explanation": "When the Print Spooler service is not running, a user will not be able to see or print to any of their devices. Open the Services console and restart the Print Spooler to remedy the situation. It\u2019s unlikely that someone deleted their printers, but if that\u2019s the case you have security concerns to address. If the printers were offline or out of paper, most likely the printer would send a message stating this fact to the user\u2019s screen.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      206,
      204,
      201,
      208,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1072,
    "question": "The time on your Windows computer is always off by a few minutes, called time drift. You need to ensure that it will keep the right time, because an incorrect time will not allow it to log in to your server. Which of the following actions will not help?",
    "choice_a": "In Settings, select Time & Language, then Date & time, and ensure that Set Time Zone Automatically and Set Time Automatically are set to On.",
    "choice_b": "Right-click on the time on the taskbar and choose Internet Time, and then choose a different time server.",
    "choice_c": "Open the Services console and ensure that the Windows Time service start is set to Automatic and that the service is started.",
    "choice_d": "In Settings, select Time & Language and then Date & Time, and click Sync Now.",
    "correct_answer": "B",
    "explanation": "The option you would choose when right-clicking the time on the taskbar is Adjust Date and Time, not Internet Time. Occasionally, the time on a computer is off because of errors in settings in Windows or a domain controller. If the time is off by exactly an hour, or exactly several hours, then most likely the time zone is set manually and incorrectly. If it\u2019s off by minutes, then it\u2019s something else causing it, but you can sync the time now and correct the settings using the Date & Time options on the Time & LANGUAGE tab in the Settings app. On an Active Directory (AD) domain, the domain controller uses the Windows time service and Network Time Protocol (NTP) to synchronize the time of all the computers on the domain, so it\u2019s important to ensure that the Window Time service is running.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      206,
      213,
      204,
      216,
      202
    ],
    "source": "9781394330348"
  },
  {
    "id": 1073,
    "question": "A Windows workstation that is set to boot from the <code>C:</code> drive, and normally boots just fine, will not boot properly. Instead, there is an error message stating that no OS is found. What steps should you take to fix this problem?",
    "choice_a": "Boot to installation media, navigate to a command prompt, type <code><b>startup repair</b></code>, and press Enter.",
    "choice_b": "Boot to the installation media, open SFC, and choose Startup Repair.",
    "choice_c": "Boot to the installation media, and then navigate to Startup Repair.",
    "choice_d": "Boot to safe mode.",
    "correct_answer": "C",
    "explanation": "If the operating system (OS) is missing, it could be due to a bad or corrupted boot sector on the hard drive, or the OS may indeed be missing. Your first step would be to ensure that the boot files are not corrupted. To do this, boot to the installation media (you might have to set your basic input/output system/unified extensible firmware interface [BIOS/UEFI] to boot to the installation media drive), then navigate to Startup Repair and follow the onscreen prompts. Typing <b>startup repair</b> at a command prompt returns an error message. System file checker (SFC) is used to verify OS files, not a program you can open and choose something in, and you wouldn\u2019t be able to boot into safe mode because the computer thinks the OS is missing. You might be thinking it could be non-bootable media in a drive, but the question states that the computer is set to boot from the C: drive.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      203,
      202,
      212,
      219,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1074,
    "question": "A Windows workstation is running slowly. You have already verified that there is no malware in the system. What will you do next? (Choose two.)",
    "choice_a": "Check available physical memory.",
    "choice_b": "Check available virtual memory.",
    "choice_c": "Roll back the OS update to a prior one.",
    "choice_d": "Restore from a restore point.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "There are many reasons why a system would be running slowly. If it suddenly starts running slowly, suspect that malware might be involved and take steps to locate and remove it. If no malware is found, check the physical and virtual memory. You might need to increase the physical random access memory (RAM) or change virtual memory settings. It could also be that a RAM module has failed or needs to be reseated. Other possibilities are a too-full hard drive (which rarely happens with today\u2019s huge hard drives) or a problem with hardware. Ensuring that the operating system (OS) is up to date is always a good idea. You would not roll back to a prior update, and restoring from a restore point would not necessarily help here.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      207,
      204,
      216,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1075,
    "question": "An application on your Windows workstation isn\u2019t working properly, and when you research the error message online, the result is that you need to update the application. Where can you go to do this? (Choose two.)",
    "choice_a": "Check for an Update option in the software.",
    "choice_b": "In the Control Panel, click Programs and Features.",
    "choice_c": "Check the application\u2019s company website.",
    "choice_d": "In the Settings app, select Apps and then Apps & Features.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The first place to look for updates would be an option on the application\u2019s menu. If nothing is found there, check the application\u2019s company website. Programs and Features in the Control Panel and Apps & Features in the Settings app have options to uninstall, change, or repair, but not update, applications.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      208,
      216,
      222,
      221,
      204
    ],
    "source": "9781394330348"
  },
  {
    "id": 1076,
    "question": "You\u2019re trying to launch an application on your Windows workstation, but the application won\u2019t load. You\u2019ve tried uninstalling and reinstalling the application, but it didn\u2019t help. Which of the following should you do next?",
    "choice_a": "Check the application\u2019s website for updates.",
    "choice_b": "Verify that your system meets the application requirements.",
    "choice_c": "Choose a different application that does the same thing.",
    "choice_d": "Reinstall Windows.",
    "correct_answer": "B",
    "explanation": "With all due respect, you should have verified that your system meets the application\u2019s minimum requirements before you even purchased or downloaded it. Remember, too, that you\u2019ll need enough random access memory (RAM) for all the programs that are running at the same time. If your operating system (OS) is newer than the application\u2019s required OS, you could check the manufacturer\u2019s website for an update, but that would happen after you compare your system to the application\u2019s requirements. You certainly would not reinstall Windows because an application won\u2019t start, and although you could find a different application that meets your needs, that\u2019s not the best solution here.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      208,
      201,
      207,
      204,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1077,
    "question": "You\u2019re in Microsoft Word and want to open a file that you used yesterday. You know that you saved the file, and it shows in the list of recently used files, but when you click on it a message says that the file can\u2019t be found. You then go to the folder where the file is stored and see that the file extension has been changed. What should you immediately suspect?",
    "choice_a": "The drive is corrupted, and you need to reinstall Windows.",
    "choice_b": "The Word program is corrupted, and you need to reinstall Word.",
    "choice_c": "A coworker has been playing with your computer and opened and saved your file using a different program.",
    "choice_d": "Your computer has been infected by malware.",
    "correct_answer": "D",
    "explanation": "Your first thought in this situation should be that there is malware on your computer. You would perform the procedures for malware removal immediately. It\u2019s unlikely that you would need to reinstall the Word program or Windows, and while it\u2019s possible that someone has been playing tricks on you, that\u2019s not the most likely reason, unless that someone is the person who wrote the malware.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      212,
      219,
      218,
      215,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1078,
    "question": "A Windows 11 computer user receives an error message that a needed service failed to start. Where can that user go to start the service? (Choose two.)",
    "choice_a": "The Services tab of Task Manager",
    "choice_b": "Computer Management",
    "choice_c": "The Services console",
    "choice_d": "Device Manager",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "All services can be found in the Services console and a link to it can be found in Computer Management. A subset of those can be found on the Services tab of Task Manager in Windows 10, but not Windows 11. If the service needed isn\u2019t there, a link at the bottom of the page will take you to the full list of services. Device Manager is intended for managing hardware devices and drivers.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      206,
      204,
      201,
      202,
      203
    ],
    "source": "9781394330348"
  },
  {
    "id": 1079,
    "question": "A Windows system is running slowly. Which of the following is not likely to be the culprit?",
    "choice_a": "The PC has too little RAM.",
    "choice_b": "The paging file is too large.",
    "choice_c": "The system is infected with malware.",
    "choice_d": "The hard drive is too large.",
    "correct_answer": "D",
    "explanation": "The first concern when a system is running too slowly is that there may be malware. Once you\u2019ve verified that there isn\u2019t any malware, if the system is still running slowly, check the page file size. The page file is the file that holds virtual memory. Virtual memory is using a part of a hard drive as if it were random access memory (RAM). A larger paging file may alleviate low memory warnings, but the price is slower performance because the hard drive is slower than RAM. To change the amount of hard drive space reserved for virtual memory, search for Advanced System Settings and select View Advanced System Settings. On the System Properties window, click the Advanced tab. Then, in the Performance box, click Settings. In the Performance Options window, choose the Advanced tab, and in the Virtual memory box, click the Change button. Deselect Automatically Manage Paging File Size for All Drives, then click Custom Size. Adjust the size by typing the appropriate value in the Initial Size (MB) box and Maximum Size (MB) box, then click Set. If you have a magnetic hard drive (HDD) and a solid-state drive (SSD), the SSD will be faster but using it for virtual memory can shorten its life. If possible, it\u2019s better to increase the physical RAM than the virtual memory. A hard drive being too large would not cause this problem.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      207,
      201,
      219,
      212,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1080,
    "question": "You are trying to apply Windows Updates to a Windows client computer. The update fails and gives you an error message. What should you do next?",
    "choice_a": "Run the Windows Update troubleshooter in the Settings app.",
    "choice_b": "Wait until the next Windows Update comes out in six months.",
    "choice_c": "Reinstall the operating system.",
    "choice_d": "Purchase an updated computer.",
    "correct_answer": "A",
    "explanation": "In Windows 10 and 11, if the update fails to work properly, search for Windows Update in Windows Settings, then scroll down to Find and Fix Problems with Windows Update. The troubleshooter will search for and attempt to resolve any problems that may prevent updates to your operating system (OS). When it has finished, check for updates again. You might need to run the troubleshooter more than once. It\u2019s important that the OS is kept up to date because updates may be patching security holes in the system. You would not want to reinstall the system, because eventually you would need to install the same update, and most likely you would not need to purchase an updated computer.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      216,
      208,
      204,
      201,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1081,
    "question": "You work for a government entity, and it insists that you use the government time server, <code>time.NIST.gov</code>, to sync the time on your computer system. Where will you go to do this?",
    "choice_a": "In the Settings app, select Time & Language and then Date & Time. Ensure that Set Time Automatically and Set time Zone Automatically are both set to On.",
    "choice_b": "Open the Services console, and ensure that Windows Time is set totime.NIST.govand that the service is started.",
    "choice_c": "In the Control Panel, select Date and Time; on the Internet Time tab, click Change Settings; and then, under Server, choosetime.NIST.gov.",
    "choice_d": "Double-click the time in the task bar, and on the Internet Time tab, under Servers, choosetime.NIST.gov.",
    "correct_answer": "C",
    "explanation": "You can choose the time server to sync with by going to the Control Panel, selecting Date and Time, and on the Internet Time tab, clicking Change Settings, then the down arrow on the right of the entry box, and choosing the correct server in the Server box. The Date and Time options in Windows Settings will allow you to change time zone settings and set time automatically, but not which server you are using. In the Services app, you can choose how and if the Windows Time service runs but again, not the time server that is being used.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [],
    "source": "9781394330348"
  },
  {
    "id": 1082,
    "question": "A Windows user complains that every day they get a message that a service they need for a particular program has not started, and they must open the Services console and start it. What will you tell the user?",
    "choice_a": "Some services behave that way. You\u2019ll need to start it every day.",
    "choice_b": "Open the Services console, double-click the service, and on the General tab, change the Startup Type to Automatic.",
    "choice_c": "Open the Services console, double-click the service, and on the General tab, change the Startup Type to Manual.",
    "choice_d": "Open the application and look for a place to have it start the service for the user.",
    "correct_answer": "B",
    "explanation": "Services will behave as you tell them to. Services can be set to Automatic so that they\u2019ll start automatically when the computer starts, or to Automatic (Delayed Start) so that the computer will start faster. They still start when the computer starts up, just two minutes later. Manual start is what the user is currently doing. Starting of the service would be set up in the Services console, not the application. A service can also be triggered to start by some event or other software, then closed again when it is no longer needed. To access the Services console, click Windows Key + R, then type <b>services.msc</b> in the box and press Enter.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      206,
      204,
      201,
      202,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1083,
    "question": "You\u2019ve noticed that lately your games freeze or crash more often, and you received a message stating that your computer is low on memory. What can you do to resolve this? (Choose two.)",
    "choice_a": "Increase virtual memory.",
    "choice_b": "Decrease virtual memory.",
    "choice_c": "Increase physical memory.",
    "choice_d": "Buy a bigger hard drive.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When you\u2019re getting messages that your computer is low on memory, you can stop some programs that are running in memory. However, more than likely you will need to increase physical memory and/or virtual memory. A rule of thumb is that virtual memory should be 1.5 times the physical memory, but you can change the setting to a larger value if you want. The downside of using more virtual memory instead of physical memory is that virtual memory resides in a page file (<code>pagefile.sys</code>) on the hard drive, and hard drives are slower than random access memory (RAM), so having a larger swap file (i.e., virtual memory) may slow the system performance. To change virtual memory, search for Advanced System Settings, and select View Advanced System Settings. On the System Properties window, click the Advanced tab and then in the Performance box, click Settings. Click the Advanced tab, and on the Performance Options window, in the Virtual Memory box, click the Change button. Deselect Automatically Manage Paging File Size for All Drives, then click Custom Size and adjust the size by typing the appropriate value in the Initial Size (MB) box and Maximum Size (MB) box. Then click Set.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      207,
      201,
      204,
      208,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1084,
    "question": "You\u2019re attempting to install an application, and it warns you that it needs 4 GB of RAM. Where will you go to see if you have sufficient RAM to run this application? (Choose two.)",
    "choice_a": "Open the case and see how many modules are installed.",
    "choice_b": "Use the System Information utility.",
    "choice_c": "Use the Performance tab in Task Manager.",
    "choice_d": "In the Control Panel, select Memory.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "There are several places in the operating system (OS) where you can see how much physical random access memory (RAM) is installed in the system. Opening the case and counting the modules is neither necessary nor an accurate measure of how much RAM you have. The System Information utility (<code>msinfo32.exe</code>) has this and much more information about your computer. The Performance tab in Task Manager will not only show you how much physical memory you have, but it will also show you how much is being used. It can give you a better idea of whether you have enough RAM installed, because it is also taking into consideration what is normally being used in your system. Another place you can see installed RAM, not shown in the options for this question, is by searching for System in the Settings app and choosing About. There is no Memory utility in the Control Panel.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      201,
      207,
      208,
      223,
      204
    ],
    "source": "9781394330348"
  },
  {
    "id": 1085,
    "question": "A user reports that their PC was fine until an OS update was installed. However, the update had not been tested yet and is found to be incompatible with a necessary business application. What is your next step? (Choose two.)",
    "choice_a": "Roll back the update.",
    "choice_b": "Update the business application.",
    "choice_c": "Do nothing; have the user take awareness training.",
    "choice_d": "Go to the Control Panel, Programs and Features, and click on View Installed Updates.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Given the description, it might be best to roll back the update, although not all updates can be rolled back. In cases where there are mission-critical applications, it\u2019s best to pause the updates and test them in a sandbox before rolling them out. To access the screen for rolling back the update, go to the Control Panel, Programs and Features, and click on View Installed Updates. On the resulting screen, you\u2019ll see the updates and an option on the right to uninstall the offending one, if it\u2019s possible. Until the business application and update can be proven compatible, the update cannot be installed as is.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      208,
      216,
      205,
      204,
      218
    ],
    "source": "9781394330348"
  },
  {
    "id": 1086,
    "question": "While booting up a Windows PC, you find it takes a long time at the Welcome screen. A message stating \u201cYour roaming profile isn\u2019t synchronized with the server\u2026\u201d appears. Which of the following are true? (Choose two.)",
    "choice_a": "The User Profile service detected a slow connection.",
    "choice_b": "A locally cached profile was loaded.",
    "choice_c": "User Profile Service is not running.",
    "choice_d": "Screen resolution is not compatible with the user profile.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The Windows User Profile service detects when there is a slow link between the client computer and the domain controller. The service will then load the user\u2019s profile from a copy that is cached on the local machine. If the user has used a different machine since the last time they used the current one, then the profile changes will not be on the local machine. The User Profile service is running, because it is what generates the error message. Screen resolution has nothing to do with this error message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      202,
      204,
      206,
      201,
      203
    ],
    "source": "9781394330348"
  },
  {
    "id": 1087,
    "question": "You just installed new external speakers on a Windows computer, and you\u2019ve received an error message saying \u201cNot enough USB Controller Resources.\u201d What would most likely cause this error? (Choose two.)",
    "choice_a": "The motherboard is damaged.",
    "choice_b": "The USB devices are drawing more power than the limit.",
    "choice_c": "There are too many devices on a USB 3.0 hub controller.",
    "choice_d": "The speaker drivers are conflicting with the USB hub controller drivers.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Universal serial bus (USB) ports provide limited power to the devices connected to them. If that power is exceeded, one or more of the devices attached to the controller may stop working, and the error message \u201cNot enough USB Controller Resources\u201d may be generated. They also have a limited number of endpoints available on each port. Some devices use more endpoints than others, and if the limit is exceeded, the same error message will be generated. A damaged motherboard could cause many things to malfunction but likely would not generate this error message, and it is highly unlikely that the speaker drivers would conflict with the USB hub controller drivers.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      201,
      208,
      212,
      219,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1088,
    "question": "A smartphone user has complained that their phone won\u2019t let them look at anything in landscape\u2014no matter how they turn it, it will not automatically rotate. You look at their screen, and it appears as shown in the graphic. Why isn\u2019t their phone letting them look at pictures in landscape view?<img src=\"/question_assets/220-1202/c08f004.png\" alt=\"Screenshot of i O S Control Center with brightness, sound, screen rotation, and tethering optiions enabled.\"/>\n\n<figcaption>Screenshot of i O S Control Center with brightness, sound, screen rotation, and tethering optiions enabled.</figcaption>",
    "choice_a": "Their Bluetooth is off.",
    "choice_b": "Their focus is off.",
    "choice_c": "Their camera is not on.",
    "choice_d": "Their orientation is locked.",
    "correct_answer": "D",
    "explanation": "On the graphic, the third icon down on the left, just above Focus, is the screen orientation. Notice that the lock is closed. That means that their smartphone orientation is locked in Portrait mode and will not autorotate. Bluetooth, focus, and the camera have nothing to do with this problem.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      227,
      221,
      223,
      226,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1089,
    "question": "Mobile device users on your network report that the network has a very slow response time. Which of the following are likely contributors to this problem? (Choose two.)",
    "choice_a": "Low battery life",
    "choice_b": "Signal interference",
    "choice_c": "Unintended Wi-Fi connections",
    "choice_d": "Weak signal",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Slow data speeds can be caused by too much interference or by a weak signal. If there is too much interference, try changing the channel on Wi-Fi routers to less used channels; performance should increase. Fix weak signals by installing more access points or signal boosters, or by moving closer to an existing access point, or away from physical obstructions.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      226,
      223,
      230,
      231,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1090,
    "question": "Several mobile device users have reported that when they eat lunch in the garden next to the office building, they have limited Internet connectivity. What is the most likely fix for this?",
    "choice_a": "Boosting WAP signal strength",
    "choice_b": "Having all the users reboot their devices",
    "choice_c": "Rebooting the WAP",
    "choice_d": "Having the users turn on Wi-Fi on each of their devices",
    "correct_answer": "C",
    "explanation": "A limited connectivity error means that your device is able to connect to Wi-Fi but not to the Internet. Because this is happening with several users in the same area, the issue is likely caused by a problem with the wireless access point (WAP), not an individual device. The users are getting a limited connectivity error, so they\u2019re connecting to the WAP but not getting an IP address from the DHCP server or router. Try cycling the WAP off and back on to resolve the issue. If that doesn\u2019t work, troubleshoot the connection between the WAP and the router (if the router is acting as the DHCP server). You don\u2019t need to boost the signal strength, because the users are able to connect to the WAP. Having all the users reboot their devices will not solve the issue, and if they\u2019re getting a limited connectivity message, then Wi-Fi on their device is already turned on.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      226,
      231,
      221,
      223,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1091,
    "question": "You\u2019ve been looking for a specific Android app and found it at an amazing price. It almost seems too good to be true, which makes you pause to consider whether it is the real app or not. Which of the following should you do before paying for and downloading this app? (Choose three.)",
    "choice_a": "Check the reviews and the number of reviews.",
    "choice_b": "Check the developer\u2019s name and how long the app has been available.",
    "choice_c": "Verify the spelling of the app name.",
    "choice_d": "Install the free version and see if there are any problems.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "There are many bootleg, imitation/fake, and malicious apps waiting for unsuspecting users to download them. They often have names very similar to the actual app, but there are ways to identify the spoofed apps. First, check the reviews. If you see negative comments about problems with mobile devices after installing the app, beware. Look at the number of downloads or reviews. If it\u2019s a popular app, it will have a high number of both. For example, if you see a Hulu app with fewer than a million reviews, it is probably not the real app. Research the app and the company from which it originates. Check the spelling of not only the app name, but the description and the screenshots as well. Misspelled words are a sign that the app is not legitimate. How long has the app been available? Popular apps will not have been released three days ago. If there is a free version, don\u2019t download and install it without first doing your due diligence. Offering something for free is a way to get you to download and install something malicious. If you download an app and it asks for permissions that you don\u2019t think it should need, be suspicious.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      230,
      231,
      219,
      215,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1092,
    "question": "A user on your network complains that they see a message for a long time that says \u201cWaiting for the User Profile Service.\u201d and their profile is very slow to load. What could be the problem?",
    "choice_a": "There is a slow link between the domain controller and the client, but it was not correctly detected by the User Profile service.",
    "choice_b": "The user has never logged in to this computer before.",
    "choice_c": "Windows needs to be updated.",
    "choice_d": "The user entered an invalid password.",
    "correct_answer": "A",
    "explanation": "This message happens when the User Profile service incorrectly identifies the connection between the client and server as a fast connection, when it is actually slow. These settings can be configured on the domain controller. If the User Profile service detects a slow connection, it will load a cached profile from the local machine instead of the roaming profile on the server. If it\u2019s the first time the user has logged in to a particular machine, then the profile will take longer to load because the entire profile is loaded, not just the changes, and it wouldn\u2019t generate this error message. It is unlikely that a failure to update Windows would affect this message, and if a user entered an invalid password, they would see a message stating that.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      206,
      204,
      201,
      216,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1093,
    "question": "You\u2019re working on a Windows client and have received an error message saying \u201cNot Enough USB Controller Resources.\u201d Which of the following is not a possible remedy for this situation?",
    "choice_a": "Plug a USB cable from a power block into one of the USB ports on the motherboard.",
    "choice_b": "Purchase an external hub or docking station that is separately powered, and plug devices into it.",
    "choice_c": "Move devices that don\u2019t need USB 3.X speed to USB 2.0 ports.",
    "choice_d": "Disable the XHCI Mode option in the BIOS/UEFI settings.",
    "correct_answer": "A",
    "explanation": "Plugging a universal serial bus (USB) cable from a power block into a motherboard port will not solve your problem, and it will likely destroy your motherboard. The first thing you should try is rearranging the devices that are using the USB ports. USB hubs have a limit as to how much power they can provide and the number of endpoints that each port can support. A device may have multiple endpoints, and devices that are heavily involved in data transfer may use many more endpoints than other devices. Using a separately powered external hub or docking station means that the port won\u2019t be providing power to the devices, so this may resolve the issue. Disabling the XHCI Mode option in the BIOS/UEFI may help with the resource error but will effectively turn off USB 3.0 and your hubs will behave like 2.0 ports. USB 2.0 ports use fewer resources than USB 3.0 ports. Other troubleshooting options could be to update the chipset drivers for the motherboard and check the power options in the basic input/output system/unified extensible firmware interface (BIOS/UEFI). Make sure any USB controller drivers are updated. If you have plugged and unplugged devices, try going to Device Manager to scan for hardware changes and test the devices again. Also in Device Manager, uninstall all USB controllers and restart the computer. Windows will scan for hardware changes and all the USB controllers that were uninstalled should be reinstalled, which will allow the USB controllers to return an unresponsive port to a working condition.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      202,
      206,
      201,
      204,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1094,
    "question": "Your friend has complained that they can\u2019t connect their phone to their Wi-Fi network at home and they\u2019ve used all their cellular data. You look at their screen, and it appears as shown in the graphic, where the image backgrounds are as follows: airplane is gray, cellular is green, Wi-Fi is white, and Bluetooth is blue. What is the problem?<img src=\"/question_assets/220-1202/c08f005.png\" alt=\"Screenshot of i O S Control Center with brightness, sound, screen rotation, and tethering options enabled.\"/>\n\n<figcaption>Screenshot of i O S Control Center with brightness, sound, screen rotation, and tethering options enabled.</figcaption>",
    "choice_a": "Airplane mode is on.",
    "choice_b": "Their Bluetooth is turned off.",
    "choice_c": "Their Wi-Fi is turned off.",
    "choice_d": "Their cellular service is turned off.",
    "correct_answer": "C",
    "explanation": "Either Airplane mode being on or Wi-Fi turned off would keep them from connecting to their Wi-Fi, but in this case, according to the graphic, the Wi-Fi is turned off. Cellular service and Bluetooth should have no effect on their ability to connect to their home Wi-Fi network.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      226,
      221,
      223,
      225,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1095,
    "question": "You\u2019re using the most recent version of Microsoft Edge to browse the Internet on your Windows workstation. It has been working fine, but today, when you visit any website, you receive an error message that there is an invalid certificate. It happens regardless of the site you visit. What should you do?",
    "choice_a": "Check your computer\u2019s time and date.",
    "choice_b": "Refresh your certificate through the Security settings in the Control Panel.",
    "choice_c": "Set your Security Level to low for the Internet Zone in Internet Properties in the Control Panel.",
    "choice_d": "In Microsoft Edge, turn off Enhance Your Security on The Web.",
    "correct_answer": "A",
    "explanation": "If your computer is set to an incorrect time and date (I\u2019m talking years off, not just a few minutes), then it can cause invalid certificate errors for the websites you want to visit. Refreshing your certificate is not an option in the Security settings in the Control Panel, and there is no low option for the Internet Zone in Internet Properties. It\u2019s never recommended to turn off your security settings for browsing the Internet. Note that if your date and time are way off, it might be that the basic input output system/unified extensible firmware interface (BIOS/UEFI) is not retaining its settings, in which case the CMOS battery needs to be changed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      202,
      215,
      219,
      204
    ],
    "source": "9781394330348"
  },
  {
    "id": 1096,
    "question": "You use an iPad and an iPhone at work. Which of the following represent the greatest threats to leaking personal files or data? (Choose two.)",
    "choice_a": "Unauthorized root access (i.e., jailbreak)",
    "choice_b": "Unintended Wi-Fi connections",
    "choice_c": "Unauthorized location tracking",
    "choice_d": "High resource utilization",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When authorized users access devices through unintended connections or unauthorized users access absconded devices (such as with root access), they can access the data on the device. Every firm should have a policy for protecting data (i.e., encryption) and dealing with leaks when they occur.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      230,
      231,
      219,
      218,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1097,
    "question": "You receive a notice from your wireless provider that you are about to exceed your data transmission limit for the month. What type of risk does this present?",
    "choice_a": "Your account might be deactivated.",
    "choice_b": "You might incur a security breach.",
    "choice_c": "You might have to pay high fees.",
    "choice_d": "Your phone might be locked out of the system.",
    "correct_answer": "C",
    "explanation": "Going over the limit on your phone\u2019s data plan is generally not a major risk, other than to your finances. Data overage charges can be high, depending on your provider and service plan. It is unlikely that your account will be deactivated, made more vulnerable to security breaches, or locked out of the cellular system.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      230,
      226,
      225,
      224,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1098,
    "question": "Your Android-based phone has recently started rebooting randomly. Which of the following might be the cause? (Choose two.)",
    "choice_a": "You\u2019ve installed a poorly written app.",
    "choice_b": "The phone\u2019s battery is at room temperature.",
    "choice_c": "Auto-restart is enabled.",
    "choice_d": "You\u2019re typing too fast on the keyboard.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The most likely cause for an Android phone randomly restarting is a poorly written app. Any apps that you\u2019re not using should be deleted from the device. Another cause may be that on some Android phones, there is an auto-restart feature as a part of a Device Care option to boost phone performance. If it is on, turn the feature off to avoid automatic restarts. Batteries that are too hot or too cold can cause problems, but room temperature batteries are okay. Typing too fast on the keyboard wouldn\u2019t cause a reboot problem. Other problems not listed might be the battery overheating or third-party cases that don\u2019t fit just right (causing a button to stick), defective hardware, or corrupted operating system (OS) files.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      224,
      221,
      222,
      223,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1099,
    "question": "A smartphone user calls to report that their phone has no wireless connectivity. What is the first thing you should tell them to do?",
    "choice_a": "Turn the phone off and back on again.",
    "choice_b": "Check whether Airplane mode is on.",
    "choice_c": "Perform a reset to factory default.",
    "choice_d": "Adjust the Wi-Fi signal receptivity.",
    "correct_answer": "B",
    "explanation": "A common cause for lack of wireless connectivity is that the device is in Airplane mode, which can easily happen by an unintended touch on that part of the screen. Ensure that the device is not in that mode, then cycle the power if necessary. If the problem persists, you\u2019ll need to perform further troubleshooting. There is no Wi-Fi receptivity setting, and you would not reset the device to factory default without exhausting all other options first.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      226,
      221,
      223,
      224,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1100,
    "question": "Your network has several dozen mobile device users. Several of them have reported that there are areas within your office where network access is very slow. Which of the following is not likely something you can do to help them?",
    "choice_a": "Install a new WAP.",
    "choice_b": "Test the network with a Wi-Fi analyzer.",
    "choice_c": "Check for network interference and congestion.",
    "choice_d": "Get new devices for those having problems.",
    "correct_answer": "D",
    "explanation": "Multiple users have the same complaint, so it\u2019s not likely a problem with their devices. Your first step should be to use a Wi-Fi analyzer to see signal strength, channels used, and various other network metrics. Any company with a wireless network should have one for troubleshooting purposes. A Wi-Fi analyzer could be as simple as an app on your phone, to a very sophisticated and expensive device. Based on what you find, you might need to install a new wireless access point (WAP) that uses a different channel to avoid congestion or move physical obstructions to your network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      223,
      230,
      231,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1101,
    "question": "A user on your network is suddenly receiving an overwhelming number of pop-up ads on their mobile device. What is likely happening? (Choose two.)",
    "choice_a": "They contracted malware.",
    "choice_b": "Their browser\u2019s pop-up blocker is turned off.",
    "choice_c": "They are the victim of an adware attack.",
    "choice_d": "They need to reinstall their browser.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The specific behavior exhibited most likely means that their device is the victim of an adware attack, or that their browser\u2019s pop-up blocker has been turned off. Adware tracks your movements and targets you with advertisements, trying to get you to click on them and spend your money.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      215,
      231,
      230,
      219,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1102,
    "question": "An Android phone user just received a new Bluetooth headset for phone calls. They\u2019ve reported that it does not work with their phone. Both devices are powered on and appear to be operational. What is most likely the problem?",
    "choice_a": "Bluetooth is turned off on the Android device.",
    "choice_b": "Bluetooth is turned off on the mobile headset.",
    "choice_c": "The devices need to be paired.",
    "choice_d": "Airplane mode is on.",
    "correct_answer": "C",
    "explanation": "While all of the options are possible, the most likely in this scenario is that the devices need to be paired. If the Bluetooth devices have not been used together previously, they must be paired so they can work together. Pairing is usually a simple process. CompTIA\u2019s steps to configure Bluetooth devices (from Exam 220\u20131201) are:<ol><li>Enable Bluetooth.</li><li>Enable pairing.</li><li>Find a device for pairing.</li><li>Enter the appropriate PIN code.</li><li>Test connectivity.</li></ol>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      221,
      222,
      223,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1103,
    "question": "You have an unlimited data plan with your cellular provider, but today you received a notice from your provider that you are about to exceed your data transmission threshold for the month. What will likely happen?",
    "choice_a": "Your account might be deactivated.",
    "choice_b": "You might incur a security breach.",
    "choice_c": "Your data transmissions will be slower than normal.",
    "choice_d": "Your phone might be locked out of the system.",
    "correct_answer": "C",
    "explanation": "Even most unlimited plans aren\u2019t truly unlimited. Most mobile or even home Internet providers will slow down your transmission rate when you exceed a specified data threshold. It is highly unlikely that your account will be deactivated, become vulnerable to security breaches, or be locked out.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      230,
      226,
      225,
      223,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1104,
    "question": "A user complains that their Apple device is randomly restarting. They haven\u2019t installed any new software recently. What steps will you take to troubleshoot the problem? (Choose two.)",
    "choice_a": "Ensure that the iOS or iPadOS and apps are up to date.",
    "choice_b": "Check their battery health in Settings.",
    "choice_c": "Replace the battery.",
    "choice_d": "Reset the phone to factory default.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "If everything is up to date and your battery is healthy but the problem continues, you need to contact Apple Support. Most batteries are not user replaceable. Be sure to back up your data before contacting Apple Support. If you reset the phone to the factory default, you will lose everything on the phone.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      224,
      225,
      223,
      221,
      222
    ],
    "source": "9781394330348"
  },
  {
    "id": 1105,
    "question": "A very serious-looking pop-up appears on your mobile device screen and says to click it for an update to your anti-malware software that will eradicate a virus your device has contracted. Which of the following should you not do?",
    "choice_a": "Click the link to update your anti-malware.",
    "choice_b": "Restart the device in safe mode if that is an option on your device.",
    "choice_c": "Update your anti-malware as you normally do, and run a scan.",
    "choice_d": "Check online for information about this fake security warning.",
    "correct_answer": "A",
    "explanation": "This is a typical fake security warning. If you click the message, or anywhere on the message, it will likely install the malware that it is mentioning. To ensure that your device is clean, update your anti-malware software and run a scan. It\u2019s important to keep your operating system (OS) and all software updated with the latest versions. Use reliable anti-malware software, strong passwords, or a password manager; avoid using public Wi-Fi (just because it says it\u2019s Starbucks Wi-Fi doesn\u2019t necessarily mean that it is); and do your due diligence when choosing new apps to download and install, even from places like the Google Play app.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      231,
      215,
      219,
      230,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1106,
    "question": "A smartphone user is concerned about their privacy and wants to ensure that others can\u2019t hack into their phone and track down their location or access their personal data and pictures. Which of the following actions will provide them with some protection to help prevent this from happening? (Choose two.)",
    "choice_a": "Install an anti-malware app.",
    "choice_b": "Install OS updates as soon as they are available.",
    "choice_c": "Disable location services.",
    "choice_d": "Enable sync with a cloud provider.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Smartphones are susceptible to malware, just like any other computer device. Some malware can be configured to perform unauthorized location tracking. To help prevent this, always patch and update the operating system (OS) as soon as updates are available and install anti-malware software. Some services such as maps require that location services are enabled, but if the user chooses to, location services can be disabled. Exactly how to do that depends on the device, but the option is most likely in the Settings menu. Enabling sync with a cloud provider will make a backup of their data, but it does nothing to protect it from being leaked.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      219,
      218,
      230,
      231,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1107,
    "question": "You\u2019re trying to pay for coffee at your favorite shop using its NFC reader and Apple Pay, but your phone isn\u2019t communicating with it. What is most likely the problem? (Choose two.)",
    "choice_a": "Wi-Fi is disabled.",
    "choice_b": "NFC isn\u2019t enabled.",
    "choice_c": "Airplane mode is on.",
    "choice_d": "Bluetooth is disabled.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To use near-field communication (NFC) services like Apple Pay and Google Pay, you need to ensure that Airplane mode is off and NFC is enabled. Wi-Fi and Bluetooth have no effect on the NFC reader. NFC has a very short transmission range, measured in centimeters or inches.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      227,
      226,
      221,
      222,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1108,
    "question": "You\u2019re attempting to share files with an iPad user by using AirDrop. You both have Wi-Fi turned on, but you can\u2019t seem to connect. Which of the following could be causing the problem? (Choose two.)",
    "choice_a": "One of you does not have Bluetooth turned on.",
    "choice_b": "You are not listed in their contacts.",
    "choice_c": "They have their AirDrop Receiving setting set to Everyone.",
    "choice_d": "They turned off their hotspot.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "For AirDrop to work, both of you must have Wi-Fi and Bluetooth enabled, and you need to be within Wi-Fi and Bluetooth range. If either party has a hotspot on, it must be turned off. If you are not in the receiver\u2019s contact list and they have their AirDrop Receiving setting set to Contacts Only, then you will not be able to send them information. If you are in their contacts list, then your Apple ID email or your phone number must be in the contact card. If they change their AirDrop Receiving setting to Everyone, then they can receive the file even if you are not in their contacts list.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      219,
      221,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1109,
    "question": "An Android device user is suddenly receiving an overwhelming number of pop-up ads on their mobile device and has called you for help. What is most likely the reason for the pop-ups?",
    "choice_a": "Malware",
    "choice_b": "A third-party app",
    "choice_c": "A firewall",
    "choice_d": "A proxy server",
    "correct_answer": "B",
    "explanation": "Often times when a third-party app is installed, you also unknowingly give it permission to bombard you with \u201chelpful\u201d pop-up messages. While it could be malware, that doesn\u2019t happen as often. Firewalls and proxy servers provide a layer of protection, but they are not causing pop-ups. Some other issues could be that browser settings need to be updated, or the browser cache cleared. Most devices will also enable the user to block pop-ups and redirects through the Settings app.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      215,
      231,
      221,
      219,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1110,
    "question": "You\u2019re attempting to update the iOS on your iPhone, but the update fails, and you receive the message \u201cUnable to install update. Software update requires a network connection.\u201d What should you do first?",
    "choice_a": "Retry the update using the same network connection.",
    "choice_b": "Connect the iPhone to your PC and update it that way.",
    "choice_c": "Remove apps or data to make enough room on your phone for the update.",
    "choice_d": "Connect to a different network.",
    "correct_answer": "A",
    "explanation": "If the update fails once because of a lost or insufficient network connection, retry the update using the same network connection. If it fails again, connect the iPhone to your computer to perform the update. This error message has nothing to do with insufficient room on your iPhone, and connecting to a different network might solve the problem, but that isn\u2019t what you would do first.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      224,
      222,
      221,
      226,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1111,
    "question": "An application failed to update on a user\u2019s phone. Which of the following are likely to be the problem? (Choose two.)",
    "choice_a": "The phone is plugged into power.",
    "choice_b": "There is insufficient space on the phone.",
    "choice_c": "They're using Wi-Fi instead of Ethernet.",
    "choice_d": "The Internet connection is weak.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Regardless of the operating system (OS), if there is insufficient space on a smartphone or a weak Internet connection, an application is unlikely to update. Allowing the power to go too low or the device to turn off during an update may cause problems, so it\u2019s perfectly fine to have the phone plugged in while doing updates. Generally speaking, mobile devices use Wi-Fi instead of Ethernet, and you will want a strong Wi-Fi signal.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      222,
      221,
      224,
      226,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1112,
    "question": "A user reports that their mobile phone has been experiencing higher-than-normal use of resources for about a week. What two things should you immediately suspect could be causing the problem? (Choose two.)",
    "choice_a": "Unauthorized root access",
    "choice_b": "Failing battery",
    "choice_c": "Excessive number of open apps",
    "choice_d": "Stuck sync operation",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Higher than normal resource utilization can be a telltale sign that a device is running more than it should be\u2014perhaps the drives are being searched, or the camera is recording your every move. Or it could be that the user has too many apps open, and the device is struggling with available resources. The latter tends to happen more on Android smartphones than iPhones. Unauthorized root access on an Android or jailbreaking an iPhone cause the phone to be susceptible to malware attacks but don\u2019t by themselves cause more resources to be used. A stuck sync operation would not likely cause high resource utilization.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      230,
      223,
      219,
      215,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1113,
    "question": "You are visiting a customer\u2019s office in a large city high-rise building. You need to make a call on your mobile phone, but you have only one bar and the call will not complete. What should you do?",
    "choice_a": "Wait a few minutes and try again.",
    "choice_b": "Cycle the power off and on.",
    "choice_c": "Reset to factory defaults.",
    "choice_d": "Step outside or near a window.",
    "correct_answer": "D",
    "explanation": "Weak signals are a common culprit behind dropped signals. Before you engage in communication, the device\u2019s signal strength should be evaluated. If the signal is low (e.g., no bars), then change location. For example, step outside, drive out of the tunnel, or exit the elevator and try for a better signal. A low battery can affect signal strength, so keep the battery charged as much as possible. Waiting a few minutes won\u2019t help if something is blocking the signal. And cycling the power off and on probably won\u2019t help either. You certainly wouldn\u2019t reset your phone to factory defaults any time that your signal was weak!",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      226,
      225,
      224,
      223,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1114,
    "question": "The GPS app on your mobile phone keeps popping up randomly on the screen, and your phone seems to be running very slowly. Which choice will likely not help in this situation?",
    "choice_a": "Restart the phone in safe mode.",
    "choice_b": "Force-stop the application.",
    "choice_c": "Perform a malware scan.",
    "choice_d": "Uninstall the app.",
    "correct_answer": "B",
    "explanation": "You don\u2019t need to force-stop the application because it isn\u2019t unresponsive. What you should do is suspect that your phone is infected with malware. Most Android phones have a method to restart in safe mode. Once there, perform a malware scan and uninstall the offending app. Make sure your operating system (OS) and other apps are updated. If you identify any other suspicious apps (i.e., apps that are acting strangely), then they might have been infected as well and should be removed and a clean copy downloaded and installed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      231,
      219,
      221,
      223
    ],
    "source": "9781394330348"
  },
  {
    "id": 1115,
    "question": "While driving through the remote countryside, you notice that your mobile phone battery has quickly drained of power. What is the most likely cause of this?",
    "choice_a": "The battery needs to be replaced.",
    "choice_b": "The phone has been searching for a signal.",
    "choice_c": "You need to cycle the power off and on again.",
    "choice_d": "You need to replace the phone.",
    "correct_answer": "B",
    "explanation": "While apps, usage, and so on can contribute to power drain, one of the biggest offenders is the search for a cellular signal. It\u2019s unlikely that the battery needs to be replaced, power cycled off and on, or the phone replaced. Simply recharge the battery. The phone will also use battery power if it\u2019s searching for a Wi-Fi signal, so when you\u2019re traveling and not using Wi-Fi, turn the Wi-Fi off to conserve battery resources.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      225,
      223,
      230,
      226,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1116,
    "question": "A user wants to use developer mode on their Android device to make some tweaks to the system. What settings will you tell them they should not leave on? (Choose two.)",
    "choice_a": "USB configuration",
    "choice_b": "Show Touches",
    "choice_c": "Developer mode",
    "choice_d": "Debugging",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "If Developer mode and the Debugging feature are left on, then whenever the PC is connected to any computer, the Android device is essentially wide open, meaning that passwords, bank accounts, photos, and so on are visible to anyone who accesses it. There are many features that can be manipulated in Debugging mode, such as Show Touches, Pointer Location, Transition Animation Scale, and so on. Just ensure that Developer mode and Debugging are turned off when you are done with them.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      230,
      231,
      219,
      212,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1117,
    "question": "You\u2019re trying to update your iPhone\u2019s iOS, but there is not enough free space on your phone to do the update. Which of the following should you do? (Choose two.)",
    "choice_a": "Use your computer to perform the update.",
    "choice_b": "Remove content and apps that you don\u2019t use.",
    "choice_c": "Purchase more internal memory for your iPhone.",
    "choice_d": "Purchase an SD card for your iPhone.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "To update the iOS, you need to have sufficient room on your iPhone. You might be able to use your computer to do the update, because files can be temporarily stored on the computer by the update while it is working. If it still won\u2019t update using your computer, then you need to make space on your iPhone by removing apps or data that you aren\u2019t using. Adding internal storage to an iPhone is not possible, and while it is possible to use an adapter and a secure digital (SD) memory card for extra storage, the card can\u2019t be used to hold the iOS.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      224,
      223,
      221,
      222,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1118,
    "question": "You\u2019re trying to install a new application from the Play Store on your Android mobile device, but the installation isn\u2019t working. Which of the following might be the problem? (Choose two.)",
    "choice_a": "The Play Store cache is empty.",
    "choice_b": "The network speed is too fast.",
    "choice_c": "The date and time on your device are wrong.",
    "choice_d": "There are other downloads or updates pending in the Play Store queue.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The Play Store sometimes won\u2019t install updates or apps if your date or time is incorrect, so ensure that they are correct. Having updates pending in the Play Store queue could also be a problem, so you\u2019ll need to cancel those updates before installing the new software. You\u2019ll also need a good Wi-Fi connection and sufficient space on your device for the new app. The other two options are irrelevant.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      221,
      222,
      224,
      208,
      213
    ],
    "source": "9781394330348"
  },
  {
    "id": 1119,
    "question": "A user is complaining that they see a lot of ads popping up on their screen in the bottom right (i.e., the notifications area). They have run a scan using their anti-malware software, and it says their computer is clean. The constant pop-ups are interfering with their work, and they ask you what can be done about it. Which of the following is not true?",
    "choice_a": "These are push notifications, not pop-ups.",
    "choice_b": "Nothing can be done about them.",
    "choice_c": "The user allowed them at some point.",
    "choice_d": "The user can disable or block all or some.",
    "correct_answer": "B",
    "explanation": "These are push notifications, not pop-ups, because they are coming up on the desktop, not in a browser. You can definitely do something about them. In order for them to show, you would have had to innocently agreed to them at some point. And yes, you can disable or block all or some of them. You might want some notifications and not others. In Windows Settings, search for Notifications, and on the Notifications screen you\u2019ll find options for allowing or blocking notifications. Choosing which ones to allow can also be done through your browser and how depends on the browser being used. Each browser (i.e., Safari, Firefox, Opera, etc.) has its own path to the specific settings that need to be changed, and they may change over time, but all will allow you to choose which notifications to see and which to block.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      215,
      231,
      219,
      208,
      204
    ],
    "source": "9781394330348"
  },
  {
    "id": 1120,
    "question": "You\u2019re attempting to update an Android phone but receive an error message that the update failed. Which of the following could be the problem? (Choose two.)",
    "choice_a": "The device has insufficient storage space.",
    "choice_b": "There is a good Wi-Fi connection.",
    "choice_c": "There is insufficient battery power.",
    "choice_d": "The device is plugged into its charger.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "An Android device won\u2019t perform an operating system (OS) update under the following conditions: If the Wi-Fi connection is not strong enough, the battery power or storage space is too low, or the device is no longer supported. If there is insufficient storage, remove apps or data that are no longer needed to make room for the update. Ensure that there is a good Wi-Fi connection. If the battery power is insufficient, plug the device in until it is fully charged.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      224,
      223,
      221,
      222,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1121,
    "question": "You\u2019re considering installing a desktop alert system for your business, which has both in-house and remote workers. Which of the following are true regarding desktop alerts? (Choose two.)",
    "choice_a": "Desktop alerts are limited to desktops.",
    "choice_b": "Desktop alerts provide an excellent emergency communication system such as weather alerts.",
    "choice_c": "Desktop alerts are text only, not graphics.",
    "choice_d": "Desktop alert software can be made interactive and can become a security threat.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "It\u2019s possible that you\u2019ve already signed up for desktop alerts. If you receive weather warnings on your computer or phone, or school closings, power outages, or other notifications, these are desktop alerts. Desktop alerts can be displayed on wall-mounted displays, desktops, mobile devices, and phones, and they are an excellent way to provide mass notifications to affected people. They can include text and graphics, and they can be made full screen and interactive so that the receiver can respond. But like many other useful features in computer systems, they can be abused by those with malicious intent. For example, an interactive button on a desktop alert could be used to deploy malware when the user clicks it. There are many third-party vendors for desktop alert systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      219,
      215,
      230,
      231
    ],
    "source": "9781394330348"
  },
  {
    "id": 1122,
    "question": "A friend asks you what jailbreaking a device is and if they should do it. Which of the following is not true about jailbreaking?",
    "choice_a": "Jailbreaking is like cracking software or gaining root access to a phone, which makes your device more vulnerable to attack.",
    "choice_b": "Jailbreaking might be illegal depending on where you are in the world.",
    "choice_c": "Jailbreaking is a safe way to get more out of your device.",
    "choice_d": "Jailbreaking gives the user full access to the device, and on an iPhone, it allows the user to download apps not approved by Apple.",
    "correct_answer": "C",
    "explanation": "Jailbreaking does let you do more with your device, but it isn\u2019t necessarily safe or legal. Jailbreaking is most commonly done with Apple devices because they are more locked down (i.e., closed source) than Android (i.e., open-source). Jailbreaking an iPhone, for instance, allows the user to install apps that are not approved by Apple. When you open the device up for you by cracking software or gaining root access, it also opens your device up more for cybercriminals to perpetrate an attack on it. Jailbreaking also voids the warranty on your device. The device may become unstable, and with the warranty voided, you are not likely to receive support in fixing problems. Jailbreaking may even be illegal depending on where you are in the world.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      219,
      230,
      231,
      215
    ],
    "source": "9781394330348"
  },
  {
    "id": 1123,
    "question": "A user is attempting to install new features for an app from the developer\u2019s website instead of from the Google Play app store, where they originally downloaded the app. The update with the new features fails to install. Why? (Choose two.)",
    "choice_a": "The signatures don\u2019t match.",
    "choice_b": "The update is an APK format.",
    "choice_c": "Only Google can write apps for Android devices.",
    "choice_d": "The website is likely spoofed.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Apps from the Google Play app store are required to be signed by the developer, and any updates won\u2019t be installed unless the signatures for the update and the original software match. This is a security feature for Android devices. If the signatures don\u2019t match, an error message like \u201cSignatures do not match previously installed version\u201d will appear. If you\u2019ve downloaded the update from somewhere other than the Google Play store and received this error, there is a good chance that the website is a spoof of the actual developer\u2019s site, and a criminal is trying to get you to install malware. Android package (APK) source is the format for Android apps on the Google Play store prior to August 2021. Updates for existing apps may still be in this format, but any newly developed apps after August 2021 on the Google Play store will be in an Android App Bundle (AAB) format.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      222,
      221,
      219,
      231,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1124,
    "question": "Recently you\u2019ve noticed a suddenly high volume of traffic on the VLAN that is used by mobile devices at your business. You know that the number of mobile devices hasn\u2019t increased that much. What should you suspect?",
    "choice_a": "A mobile device is malfunctioning.",
    "choice_b": "One or more mobile devices is infected with malware.",
    "choice_c": "Devices are experiencing limited connectivity.",
    "choice_d": "Your monitoring software is infected.",
    "correct_answer": "B",
    "explanation": "The most likely reason for a sudden high increase in network traffic is that there is malware on the system and that malware is using your network to do something. Luckily, the mobile devices are on a virtual local area network (VLAN), so it isn\u2019t directly affecting your main network. You need to immediately identify the source of the network traffic and perform malware removal procedures. A malfunctioning mobile device is not likely to be the source of the problem. Limited connectivity would not present as an increase in network traffic, and it is unlikely that your monitoring software being infected is the problem. High network traffic is precisely the sort of incident that your monitoring software should be designed to detect.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      230,
      219,
      218,
      212,
      215
    ],
    "source": "9781394330348"
  },
  {
    "id": 1125,
    "question": "What is one of the best ways to prevent malware from being spread by desktop alerts?",
    "choice_a": "Educate the end users.",
    "choice_b": "Block all desktop alerts.",
    "choice_c": "Always log in as an administrator.",
    "choice_d": "Update anti-malware once a month.",
    "correct_answer": "A",
    "explanation": "Desktop alerts perform a valuable function, but they can be subject to misuse by cybercriminals. The best protection for this type of attack is user education. You would not want to block all desktop alerts because they serve a purpose, and you certainly don\u2019t want to log on as an administrator unless absolutely necessary to avoid an attacker gaining administrator access and to avoid accidentally doing something as an administrator that could damage a system, because administrators can do anything in a system. Anti-malware should be updated daily.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      219,
      218,
      215,
      212,
      230
    ],
    "source": "9781394330348"
  },
  {
    "id": 1126,
    "question": "You\u2019re attempting to boot a computer that worked fine yesterday, but today it says \u201cOS not found\u201d or a similar message. What will you do first?",
    "choice_a": "Verify the boot options in BIOS/UEFI.",
    "choice_b": "Verify there are no USB drives inserted.",
    "choice_c": "Restart the computer.",
    "choice_d": "Remove the HDD.",
    "correct_answer": "B",
    "explanation": "If a computer\u2019s boot order is set to boot only to a universal serial bus (USB) drive, then leaving a non-bootable media in that drive will give the error that the operating system (OS) is not found, when in fact it may be perfectly fine and residing on the hard drive. Your first course of action is to verify that there is no media inserted into USB ports. If you find it there, remove the non-bootable media and restart the computer. If it starts normally, the issue is resolved, but you shouldn\u2019t stop there. Enter the basic input/output system/unified extensible firmware interface (BIOS/UEFI) and verify the boot options. For a secure environment, you will want to disable booting to drives other than the intended boot drive, usually a hard drive. It\u2019s true that booting to alternate drives may be necessary when troubleshooting, but leaving that option always available opens the system up to potential attack.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      202,
      203,
      212,
      218,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1127,
    "question": "A user complains that their Windows 11 laptop seems to be unstable. They had installed some software, and although they have removed it, the system is still behaving strangely. You have examined the system and determined that it is not infected with malware. What will you do next?",
    "choice_a": "Boot to installation media and reformat the hard drive, and then reinstall the operating system.",
    "choice_b": "Hold the Shift key and restart the computer. The computer will restart in WinRE.",
    "choice_c": "Perform a system restore from the restore point created immediately before the software was installed.",
    "choice_d": "Delete the Registry and restart the computer.",
    "correct_answer": "C",
    "explanation": "A seemingly unstable Windows installation may be repaired by using a system restore point from a time when the system was working well. If that doesn\u2019t resolve the issue, a more involved step would be to boot into Windows Recovery Environment (WinRE), navigate to Reset this PC, and choose to keep your personal files, performing an in-place update that will reinstall the Windows 11 operating system (OS) files. There is no need to reformat the drive and reinstall the OS or delete the Registry.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      205,
      204,
      208,
      203,
      216
    ],
    "source": "9781394330348"
  },
  {
    "id": 1128,
    "question": "You are donating some old mobile devices to charity. What should you do before you give them away?",
    "choice_a": "Replace the storage media with new media, and destroy the old storage media.",
    "choice_b": "Delete all your personal/company files.",
    "choice_c": "Perform an in-place update.",
    "choice_d": "Perform a Factory Image Restore.",
    "correct_answer": "D",
    "explanation": "Whenever a device will leave your possession, whether it is being donated or recycled, you need to ensure that all data is removed from the device. The simplest way to do this is by restoring the device to its factory settings, if a restore image is available. The process for a factory image restore on phones and mobile devices will be different depending on the device. With Windows OS, boot to the Windows Recovery Environment (WinRE) and navigate to Factory Image Restore. If you are in a government or industry where data security is an absolutely essential matter, you may be required to use other means such as physically destroying the device or performing multiple zero-writes to the storage media.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      224,
      221,
      223,
      222,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1129,
    "question": "Your company uses an Active Directory domain to control resources on your network. It also uses a PC image to prepare computers for first use within your organization. One of your computer users complains that they can\u2019t print, and a few other activities are working strangely. You have determined that there is no malware on the system. What will you do to restore this computer to working order?",
    "choice_a": "Back up the user files and reinstall the operating system.",
    "choice_b": "Reinstall the company\u2019s PC image.",
    "choice_c": "Boot into WinRE and reset the PC, keeping the user files.",
    "choice_d": "Boot into WinRE and perform a Factory Image Restore.",
    "correct_answer": "B",
    "explanation": "If the computer is behaving strangely, the simplest fix is to reinstall the company\u2019s PC image. This will delete any files that exist on the computer and install any software and settings that are necessary for the company. The user can then log in to the domain. There is no need to back up their files, because on the domain their files will be saved in a home directory on a server. Booting into Windows Recovery Environment (WinRE) to reset or perform a factory restore is not the best way to resolve the problem.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      218,
      219,
      204,
      206,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1130,
    "question": "You\u2019re talking with employees about using AI productively in their jobs. Which of the following is not an appropriate use of AI?",
    "choice_a": "Generating ideas",
    "choice_b": "Performing repetitive tasks",
    "choice_c": "Prescribing medicine",
    "choice_d": "Data analysis",
    "correct_answer": "C",
    "explanation": "Artificial intelligence (AI) has many appropriate uses, but it\u2019s also important to know when not to use it. For example, AI should not be used to prescribe medicine; however, it could be used to give a doctor a list of new medications for a condition, leading the doctor to research them and choose the best one for a patient. AI excels at generating ideas and performing repetitive tasks. It can quickly analyze historical data, but a human needs to make decisions based on that data, not AI. AI is a tool to enhance human work, to streamline processes, but not to replace the human element or critical thinking.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      254,
      253,
      252,
      249,
      250
    ],
    "source": "9781394330348"
  },
  {
    "id": 1131,
    "question": "Which of the following is a way to provide proof that a computer user is aware of regulatory and business compliance requirements, and agrees to the AUP and any changes to it every time they log in to a computer connected to your network?",
    "choice_a": "Incident report",
    "choice_b": "Splash screen notice",
    "choice_c": "The act of logging in",
    "choice_d": "Signature on an AUP",
    "correct_answer": "B",
    "explanation": "A splash screen appears on a computer before a user logs in. It can contain information related to the acceptable use policy (AUP) or regulatory information to which the user must agree and adhere. This information is accepted by clicking a button, indicating agreement to it before they can log in. The act of logging in alone does not prove acceptance of the conditions unless there is a statement telling the user that they must either accept the conditions or not continue. An incident report is filed when someone identifies a breach of company policies. A signature on an AUP should always be obtained as a part of employee onboarding, but it won\u2019t include any changes to the policy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      287,
      270,
      288,
      285
    ],
    "source": "9781394330348"
  },
  {
    "id": 1132,
    "question": "You are upgrading a video card in a desktop computer. You are following appropriate safety procedures. When you open the case, what is the most common danger that you should watch out for?",
    "choice_a": "Electrical shock",
    "choice_b": "Sharp edges",
    "choice_c": "Burns",
    "choice_d": "Flying debris",
    "correct_answer": "B",
    "explanation": "One component that people frequently overlook is the case itself. Cases are generally made of metal, and some have sharp edges inside, so be careful when handling them. You can, for example, cut yourself by jamming your fingers between the case and the frame when you try to force the case back on. Motherboards and expansion cards have sharp solder projections on the bottom that can cut as can a moving fan (which would only be on if troubleshooting a power issue). Less often injuries can occur from the power supply and processor. The power supply could provide a lethal shock because it contains capacitors that hold a charge for a time after the power is turned off. You could be burned by a processor if removing it before it has had adequate time to cool off. Flying debris inside the case are very unlikely.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      259,
      263,
      278,
      261
    ],
    "source": "9781394330348"
  },
  {
    "id": 1133,
    "question": "Whenever you onboard someone into the Research and Development (R&D) department of your organization, there are several software packages that need to be installed, and configuration must be done differently than the default. What can you do to make this process easier? (Choose three.)",
    "choice_a": "Install an image via a network share.",
    "choice_b": "Create an installer package for the applications.",
    "choice_c": "Use third-party configuration management tools.",
    "choice_d": "Install each package individually.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Three ways to make the custom installation of software easier are to create an image and install it via a network share, create your own installer package for the software (in a Windows environment, it would have a Microsoft installer [.<code>msi</code>] extension), or use a third-party software tool that can automate the process for you. Installing each package individually is what you want to avoid because it can be very time consuming and is subject to human error in installation.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      287,
      238,
      235,
      286,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1134,
    "question": "You open a desktop computer case and discover some dust, particularly around the fans. What is the most appropriate way to perform dust cleanup in this desktop computer system and its fan? (Choose two.)",
    "choice_a": "Denatured isopropyl alcohol",
    "choice_b": "Demineralized water",
    "choice_c": "Computer vacuum",
    "choice_d": "Compressed air",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "One way to keep dust and debris out of your computer is to use an enclosure, which is basically an extra case. But if dust and debris do get inside your case, the best way to remove it is to use compressed air. Compressed air can be easily directed to exactly where it is needed. If the compressed air doesn\u2019t get the dust out, or you\u2019re concerned about the dust causing health problems to someone nearby, you can use a vacuum cleaner made specifically for computers. Never use a regular vacuum cleaner with electronics because it will introduce static that can damage components. Simply blow the dust from inside the computer to the outside by using a stream of compressed air. However, ensure that you don\u2019t blow dust all over your work area or yourself, and place a pen or pencil in the fan so it won\u2019t spin while you\u2019re dusting it off. Denatured isopropyl alcohol is used to clean contacts because it dries quickly, and demineralized water would not be used inside the case, except perhaps in a liquid cooling system.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      266,
      258,
      256,
      257,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1135,
    "question": "What feature of third-party software would allow a technician to demonstrate to a user how to use an application on the local desktop?",
    "choice_a": "File sharing",
    "choice_b": "SSH",
    "choice_c": "Browsing",
    "choice_d": "Screen-sharing",
    "correct_answer": "D",
    "explanation": "Third-party software that includes a screen-sharing feature would allow the technician to demonstrate a task using the user\u2019s own local desktop. File-sharing software facilitates the sharing of files, Secure Shell (SSH) is an encryption protocol and set of utilities for managing systems remotely, and browsing is not a type of screen-sharing.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      243,
      239,
      240,
      245,
      238
    ],
    "source": "9781394330348"
  },
  {
    "id": 1136,
    "question": "Which of the following is both a protocol and a suite of utilities that allow network administrators to remotely access and manage systems, while maintaining the confidentiality of authentication credentials and data?",
    "choice_a": "RDP",
    "choice_b": "SSH",
    "choice_c": "HTTPS",
    "choice_d": "FTP",
    "correct_answer": "B",
    "explanation": "The Remote Desktop Protocol (RDP), Hypertext Transfer Protocol Secure (HTTPS), and File Transfer Protocol (FTP) provide confidentiality of network traffic, but Secure Shell (SSH) provides that and a suite of utilities commonly used by network administrators to remotely control and manage networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      239,
      244,
      245,
      242
    ],
    "source": "9781394330348"
  },
  {
    "id": 1137,
    "question": "You are installing a new piece of software on your computer, and you do not agree with terms in the end-user license agreement (EULA). Which of the following statements is true?",
    "choice_a": "You can skip the EULA and continue the installation.",
    "choice_b": "You will not be able to install the software unless you agree to the terms in the EULA.",
    "choice_c": "You can click that you agree with the EULA and then provide notes to the parts you disagree with and will not be bound to those terms.",
    "choice_d": "You can install the software but will be provided with limited functionality.",
    "correct_answer": "B",
    "explanation": "An end-user license agreement (EULA) is a contract between you and the entity providing the software. When you buy an application, you aren\u2019t actually buying the application. Instead, you\u2019re buying the right to use the application in a limited way, as prescribed by the licensing agreement that comes with it. Don\u2019t like the terms? Too bad. No negotiation is allowed. If you don\u2019t accept the EULA, your only recourse is to return the software for a refund.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      287,
      284,
      311
    ],
    "source": "9781394330348"
  },
  {
    "id": 1138,
    "question": "Your company has a policy prohibiting illegal content on work computers. You have seized a workstation from an employee after finding illegal content. You\u2019re creating a document to show who has had access to the workstation since you seized it to ensure that the illegal material is managed in the correct way and that it is delivered to the proper authorities. What are you documenting? (Choose the best answer.)",
    "choice_a": "Use and storage",
    "choice_b": "Chain of custody",
    "choice_c": "Change management",
    "choice_d": "Asset management",
    "correct_answer": "B",
    "explanation": "Tracking where seized equipment or data is stored, and who has access to it, is documenting the chain of custody. After the device or data has been preserved, someone needs to keep track of it before it\u2019s handed over to the proper authorities. The next specific step depends on your documented chain of custody policy. Depending on the situation, materials may be held in a safe locked location at the office, or they may need to be turned over to local authorities. Have a documented procedure in place to follow, given a situation. Always document the findings, who has custody of the illegal materials, and if/when the custody is transferred to someone else. No one should be using the equipment or data, so you\u2019re not documenting use and storage. Change management is a specific process for approving and implementing changes in a business environment. Asset management is tracking software, hardware, and data that belongs to or is licensed to an organization.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      273,
      272,
      270,
      312,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1139,
    "question": "You just got off a repair job at a customer\u2019s site, and it was difficult. To make matters worse, the customer was argumentative and difficult to work with. Which of the following should you not do to maintain professionalism and discretion when talking about experiences and customer encounters?",
    "choice_a": "Document the situation in your work log.",
    "choice_b": "Try to put the experience out of your mind and focus on your next call.",
    "choice_c": "Call your manager and explain the situation.",
    "choice_d": "Post the experience on social media.",
    "correct_answer": "D",
    "explanation": "One of the golden rules of customer service is to be professional and use discretion when talking about a customer or work experience. Don\u2019t vent about customers on social media. You never know who will read it, and regardless, it\u2019s unprofessional to air dirty laundry. Depending on the situation, it may be advisable to discuss it with your manager or simply document it and move on with your day.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      312,
      311,
      304,
      310,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1140,
    "question": "You are fixing a broken printer on the second floor of your office building. When you get the printer running again, you notice that it\u2019s printing employee paychecks. What should you do?",
    "choice_a": "Take pictures of the paychecks and post them on social media.",
    "choice_b": "Look to see how much everyone gets paid compared to what you get paid.",
    "choice_c": "Ignore the information and focus on making sure the printer is fixed.",
    "choice_d": "Text your friends and tell them that you make more than they do.",
    "correct_answer": "C",
    "explanation": "IT professionals often deal with confidential, private, or restricted information. Other users trust that IT professionals will treat the sensitive material as such and not spread information. Ignore the paychecks and focus on doing the job professionally.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      312,
      276,
      310,
      311,
      304
    ],
    "source": "9781394330348"
  },
  {
    "id": 1141,
    "question": "When you are working at a client\u2019s site, which of the following is the most appropriate behavior you should exhibit?",
    "choice_a": "Taking personal calls",
    "choice_b": "Actively listen; don\u2019t interrupt",
    "choice_c": "Visiting social media sites",
    "choice_d": "Talking to coworkers",
    "correct_answer": "B",
    "explanation": "Avoid distraction and/or interruptions when talking with customers. You need to make them feel that their problem is important and that it has your full attention. Distractions can include personal calls, texting, social media, talking to coworkers, and other personal interruptions. Listening, taking notes, and asking appropriate questions is part of good customer service.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      313,
      307,
      304,
      310,
      308
    ],
    "source": "9781394330348"
  },
  {
    "id": 1142,
    "question": "You are in the field replacing a defective PCIe network card in a desktop computer. You realize that you forgot your ESD strap. The computer needs to be fixed quickly. What is the best way to put yourself and the computer at the same electrical potential so that you won\u2019t damage the equipment with ESD?",
    "choice_a": "Touch the ground before working on the PC.",
    "choice_b": "Touch the plastic front of the case while working on the PC.",
    "choice_c": "Stay in contact with the computer\u2019s desk while working on the PC.",
    "choice_d": "Stay in contact with the metal part of the case while working on the PC.",
    "correct_answer": "D",
    "explanation": "Putting yourself at the same electrical potential is not as effective as using proper anti-electrostatic discharge (anti-ESD) gear, but it makes up for that with its simplicity. Make sure the computer is turned off and unplugged. Then touch an exposed (but not hot or sharp!) metal part of the case. That will drain electrical charge from you. Better yet is if you can maintain constant contact with that metal part. That should keep you at the same electrical potential as the case.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      259,
      256,
      262,
      266
    ],
    "source": "9781394330348"
  },
  {
    "id": 1143,
    "question": "What Microsoft protocol allows you to connect your local system to a different Microsoft client, complete with a graphical user interface?",
    "choice_a": "RDP",
    "choice_b": "SSH",
    "choice_c": "FTP",
    "choice_d": "VPN",
    "correct_answer": "A",
    "explanation": "The Remote Desktop Protocol (RDP) lets you establish a connection to a remote client, showing the remote system\u2019s desktop. Secure Shell (SSH) lets administrators securely manage networks remotely, File Transfer Protocol (FTP) is for moving large files efficiently, and a virtual private network (VPN) uses encryption to create a private connection across a public network.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      239,
      241,
      245,
      243,
      244
    ],
    "source": "9781394330348"
  },
  {
    "id": 1144,
    "question": "When working with a customer, which of the following demonstrates proper communication technique and professionalism?",
    "choice_a": "Staring at religious artifacts hanging on the wall",
    "choice_b": "Imitating the client\u2019s accent when speaking to them",
    "choice_c": "Using the client\u2019s professional title when speaking to them",
    "choice_d": "Laughing at the client\u2019s choice of clothing",
    "correct_answer": "C",
    "explanation": "It is important for an IT technician to be culturally sensitive. Some people may have a language barrier, making it difficult to explain their issue. Others may have different habits or practices in their workplace. Be respectful of their world. In some cases, using appropriate professional titles is a sign of respect and not using them is an insult. You would never stare at their personal items, imitate their accent, or laugh at their clothing.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      313,
      304,
      307,
      308,
      310
    ],
    "source": "9781394330348"
  },
  {
    "id": 1145,
    "question": "You are practicing appropriate safety procedures as you fix computers. Which of the following are times you should wear an ESD strap? (Choose two.)",
    "choice_a": "Working inside a desktop case",
    "choice_b": "Working inside a power supply",
    "choice_c": "Working inside a laser printer",
    "choice_d": "Working inside a laptop case",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "To use the electrostatic discharge (ESD) strap, you attach one end to an Earth ground, which provides a path for electricity to flow safely away (or more typically, the computer case), and wrap the other end around your wrist. The ESD strap dissipates static electricity from your body and has a resistor to offer some protection against electrical shock, although ESD straps are designed to protect the equipment, not the user. Never wear an ESD strap if you\u2019re working inside a laser printer or power supply. If you wear one while working on the inside of these components, you increase the chance of receiving a lethal shock.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      261,
      256,
      257,
      259
    ],
    "source": "9781394330348"
  },
  {
    "id": 1146,
    "question": "While cleaning out an old filing cabinet, you discover a box filled with discarded batteries. What is the proper way to dispose of them?",
    "choice_a": "Burn them.",
    "choice_b": "Throw them in the trash.",
    "choice_c": "Crush them.",
    "choice_d": "Recycle them.",
    "correct_answer": "D",
    "explanation": "When batteries are thrown away and deposited into landfills, the heavy metals inside them will find their way into the ground. From there, they can pollute water sources and eventually find their way into the supply of drinking water. The best way to dispose of old batteries is to recycle them.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      267,
      269,
      264,
      265,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1147,
    "question": "Your company has a policy prohibiting illegal content on work computers. A user reports that another user has illegal content, and you are the scene\u2019s first responder. What are your first priorities as the first responder? (Choose two.)",
    "choice_a": "Document the chain of custody.",
    "choice_b": "Preserve the data or device.",
    "choice_c": "Identify the illegal content.",
    "choice_d": "Ask the user to delete the material.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "If you have your incident policy in place, then your incident response plan should be relatively scripted. Your first priority as the first responder is to identify the improper activity or content and preserve the data or device, which often means removing the offender\u2019s access to it. It\u2019s desirable to get someone else to verify the material or action so that it doesn\u2019t turn into a situation of your word against someone else\u2019s. You\u2019ll want to document the incident and the chain of custody, but those are not the first priority. You would never ask the user to delete the prohibited material.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      273,
      272,
      285,
      270,
      271
    ],
    "source": "9781394330348"
  },
  {
    "id": 1148,
    "question": "When communicating with customers, which of the following should you do?",
    "choice_a": "Use jargon and acronyms to prove your abilities.",
    "choice_b": "Interrupt and ask questions often to clarify.",
    "choice_c": "Use appropriate professional titles.",
    "choice_d": "Assume you know what the customer wants, even if it\u2019s not what they said.",
    "correct_answer": "C",
    "explanation": "When dealing with a customer, always display professionalism. That means avoiding slang, jargon, and acronyms; not interrupting; and clarifying what the customer wants and needs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      304,
      311,
      308,
      307,
      310
    ],
    "source": "9781394330348"
  },
  {
    "id": 1149,
    "question": "You are transporting several sticks of RAM and a few video cards from one of your offices to another. Which safety device should you use to help avoid electrically damaging components?",
    "choice_a": "Antistatic bags",
    "choice_b": "ESD strap",
    "choice_c": "ESD mat",
    "choice_d": "Rubber gloves",
    "correct_answer": "A",
    "explanation": "Static-shielding bags are important to have at your disposal when servicing electronic components, because they protect the sensitive electronic devices from stray static charges. This is in contrast to the familiar pink antistatic bags, which only prohibit static buildup found in other plastic bags, but do not shield from electrostatic discharge (ESD). By design, the static charges collect on the outside of these silver or pink bags rather than on the electronic components. Unlike antistatic mats, antistatic bags do not \u201cdrain\u201d the charges away, and they should never be used in place of an antistatic mat. Components should never be placed on top of an antistatic bag. While mats are designed to be stationary on a bench, bags are built for portability.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      258,
      260,
      266,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1150,
    "question": "You have identified illegal content on a user\u2019s computer and reported the incident to your supervisor. The workstation has been moved from the user\u2019s desk to a secure location. Because the incident involved illegal activities, not just company policy violations, what will someone do next?",
    "choice_a": "Walk the employee out of the building.",
    "choice_b": "Notify the proper authorities.",
    "choice_c": "Follow the chain of custody.",
    "choice_d": "Delete the illegal material.",
    "correct_answer": "B",
    "explanation": "After the device or data has been properly secured and preserved, because this is a matter of law, someone will need to notify the proper authorities. Whether you do or your superior does is a matter of company policy and should be part of your incident response plan. You will also need to document everything that could be relevant to the situation. Many organizations will walk an offender out of the building to prevent them from trying to cover up what they\u2019ve done. The chain of custody is a document you\u2019ll create to track where the evidence is, who has access to it, and when it changes hands. You should never delete illegal material. In fact, you\u2019ll want to make a copy of it if possible.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      273,
      285,
      287,
      277,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1151,
    "question": "You are working onsite and trying to fix a client\u2019s workstation. Their computer has a defective video card, and it will take about three days to receive a new one. Which of the following is the best course of action for you to take to set and exceed customer expectations?",
    "choice_a": "Tell them it will take three days for the video card to arrive, and you will return then to replace it.",
    "choice_b": "Tell them that the video card is defective, not fixable, and it will take a week for the new one to arrive. Then when you replace it in three days, you will have overdelivered and exceeded their expectations.",
    "choice_c": "Tell them it will take three days for the new video card to arrive, and you\u2019ll call them then to make an appointment. Offer to supply a loaner computer, which they can use in the meantime, and call them in three days.",
    "choice_d": "Tell the customer that the computer is not working, and you\u2019ll be back to fix it whenever you can fit it into your schedule.",
    "correct_answer": "C",
    "explanation": "Part of excellent customer service is setting and meeting\u2014or exceeding\u2014expectations. Be sure to communicate timelines and status with the customer. If you say you\u2019ll call them in three days, call them even if the part didn\u2019t come in. Customers want to know what\u2019s going on. In addition, offering different repair or replacement options will usually make the customer feel better because you are giving them an option in choosing a solution.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      307,
      309,
      310,
      304,
      311
    ],
    "source": "9781394330348"
  },
  {
    "id": 1152,
    "question": "You are troubleshooting a difficult problem that you have never seen before. Even after an hour, you\u2019re still not sure what is causing the problem. The customer asks what\u2019s wrong. Which of the following will you tell the customer to project a positive attitude and confidence?",
    "choice_a": "\u201cI have no idea, and it\u2019s a hard one. This is going to take a while.\u201d",
    "choice_b": "\u201cI\u2019m not sure yet, but I\u2019m confident that we will have you up and running soon.\u201d",
    "choice_c": "\u201cIt\u2019s bad. It\u2019s really bad. I\u2019m not sure if I will ever get it fixed.\u201d",
    "choice_d": "\u201cNot even our escalation line could figure it out, so I\u2019m leaving and you\u2019re on your own.\u201d",
    "correct_answer": "B",
    "explanation": "When dealing with customers, it\u2019s important to maintain a positive attitude and project confidence. Remember that if they have called you, they\u2019re already having a bad day, and they are counting on you to resolve the problem. Saying, \u201cI\u2019m not sure yet, but I\u2019m confident that we will have you up and running soon\u201d is the only option that projects both a positive attitude and confidence. Be honest but gentle when forming answers to your customers.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      311,
      304,
      310,
      307,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1153,
    "question": "You are advising a startup that handles payment transactions to employ additional security controls on credit card information. What type of compliance affects how these security controls are implemented?",
    "choice_a": "PII",
    "choice_b": "PCI DSS",
    "choice_c": "VPN",
    "choice_d": "SSH",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) applies to any organization that handles credit card data or processes or stores payment transactions from bank cards. PII is personally identifiable information, VPN stands for virtual private network, and Secure Shell (SSH) is an encryption protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      275,
      277,
      286,
      276,
      270
    ],
    "source": "9781394330348"
  },
  {
    "id": 1154,
    "question": "You just purchased a software package whose EULA allows you to use the software as long as you wish, without paying anything extra. What type of license did you purchase?",
    "choice_a": "Perpetual",
    "choice_b": "Subscription",
    "choice_c": "Open-source",
    "choice_d": "Personal use",
    "correct_answer": "A",
    "explanation": "Software that you only pay for one time and are allowed to use forever has a perpetual license. Contrast this with most licenses, which are subscription in nature, where you pay an annual or monthly fee for the privilege of using the software. Open-source software gives the licensee permission to change the source code of the software. Many Linux distributions are open-source. A personal use license means just that\u2014you can use it for your personal use, usually just on one computer, although some personal use licenses permit you to install five copies, but the license does not permit you to use the software in a company environment. For that, you would need a corporate-use license.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      284,
      254,
      292
    ],
    "source": "9781394330348"
  },
  {
    "id": 1155,
    "question": "The graphics department has called because they\u2019re out of solid ink in one of their solid-ink laser printers. What type of change is this?",
    "choice_a": "Normal",
    "choice_b": "Incremental",
    "choice_c": "Emergency",
    "choice_d": "Standard",
    "correct_answer": "D",
    "explanation": "This is a standard change. A standard change is something that happens frequently and can be planned for. Companies can create a list of preapproved/predefined changes that are considered standard, like replacing pickup rollers in a printer. A normal change is one that goes through the entire change process. It isn\u2019t standard, but it\u2019s also not an emergency. It may be a suggestion to streamline processes. An incremental change is not a term used in change management. An emergency change will go straight to the change approval board (CAB), because it needs to be fixed now and waiting negatively impacts the organization.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      291,
      292,
      294,
      295
    ],
    "source": "9781394330348"
  },
  {
    "id": 1156,
    "question": "A desktop computer you are working on has a failed power supply. Another technician suggests that it could just be a failed capacitor inside the computer\u2019s power supply, and that you could fix it. What could you do that\u2019s in keeping with electrical safety procedures?",
    "choice_a": "Open the power supply and test the capacitors with a multimeter.",
    "choice_b": "Do not open the power supply; dispose of it properly.",
    "choice_c": "Open the power supply and test the capacitors with a voltmeter.",
    "choice_d": "Open the power supply and test the capacitors with an electrical probe.",
    "correct_answer": "B",
    "explanation": "Opening a power supply is not safe! Unless you have special training to work inside one, take the power supply to an electronics recycler. Power supplies contain several capacitors that can hold lethal charges long after they have been unplugged! It is extremely dangerous to open the case of a power supply. Besides, power supplies are relatively inexpensive. It would probably cost less to replace one than the cost of time to try to fix it and replacing it would be much safer. Only open a power supply if you have been specifically trained to repair them safely. You would not be testing capacitors inside the power supply.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      256,
      257,
      262,
      268,
      258
    ],
    "source": "9781394330348"
  },
  {
    "id": 1157,
    "question": "You are having a conversation with your manager about corporate security best practices. They ask what the company should do if users are found to have adult content or content advocating hate crimes on their workstations. How should you answer?",
    "choice_a": "Users should be allowed to keep it if it is for personal use only.",
    "choice_b": "The company should implement an AUP that forbids such material and specifies consequences for violating the policy.",
    "choice_c": "The company should not condone adult- or hate crime\u2013related content but can\u2019t legally prevent users from having it.",
    "choice_d": "The company should ignore the content that users have on their workstations.",
    "correct_answer": "B",
    "explanation": "Creating an acceptable use policy (AUP) is the most important part of dealing with prohibited content or actions. Without a policy set in place that specifically defines what is and what isn\u2019t allowed, and what actions will be taken when a violation of the policy occurs, you don\u2019t really have legal grounds to take action when a situation happens. What is in the policy depends on the company for which you work. A good policy will also contain the action steps to be taken if prohibited content or activity is spotted. Those actions may involve disciplinary action, terminating employment, or contacting law enforcement.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      270,
      273,
      277,
      287
    ],
    "source": "9781394330348"
  },
  {
    "id": 1158,
    "question": "You are training a new group of technicians on power issues. One asks if an undervoltage event or complete power failure can affect the company\u2019s computer systems. What should you say? (Choose two.)",
    "choice_a": "A complete loss of power can damage electrical components.",
    "choice_b": "An undervoltage event will not be detected by computer equipment because there is no complete power loss, so equipment won\u2019t be damaged.",
    "choice_c": "Both complete power losses and undervoltage events can damage electrical components.",
    "choice_d": "An undervoltage event might cause a monitor to flicker, but it won\u2019t damage electrical components.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Both complete power losses and undervoltage events can damage computers and other electronic devices. Even when an undervoltage event goes unnoticed because your display doesn\u2019t flicker or room lights dim, it can still be enough to shut down, restart, or damage a computer system.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      265,
      264,
      256,
      266,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1159,
    "question": "Which remote access method uses token authentication, making it subject to the vulnerability of a lost token?",
    "choice_a": "SPICE",
    "choice_b": "VNC",
    "choice_c": "SSH",
    "choice_d": "RMM",
    "correct_answer": "A",
    "explanation": "The Simple Protocol for Independent Computing Environments (SPICE) uses token authentication rather than passwords. If the token is lost or stolen, or programming is inadequate, then the system may be vulnerable. The Virtual Network Computing (VNC) method of remote access uses port 5900 and a display number, making it difficult to secure with firewalls that only allow a port number. Secure shell (SSH) and remote monitoring and management (RMM) are vulnerable when they are not patched and updated, or due to human errors like misconfiguration and inadequate passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      245,
      244,
      241,
      239,
      242
    ],
    "source": "9781394330348"
  },
  {
    "id": 1160,
    "question": "You have downloaded open-source software onto your personal laptop. Which of the following statements are true regarding open-source licenses? (Choose two.)",
    "choice_a": "You can modify the application in any way you like.",
    "choice_b": "You usually do not need to pay for the application.",
    "choice_c": "You can make changes to the applications only if they are approved by the originator.",
    "choice_d": "You pay a fee for every user of the application.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Open-source software is usually free, but what makes it open-source is that the source code (i.e., code used by programmers) is also shared to encourage others to contribute to the future development and improvement of the application. Open-source software can\u2019t be sold, although it can be bundled with commercial products that are sold. Contrast open-source with commercial licenses, where you pay per user and can\u2019t modify the program except as allowed by the developer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      244,
      282,
      284,
      277
    ],
    "source": "9781394330348"
  },
  {
    "id": 1161,
    "question": "You want to install an electrical device that lets you plug in multiple devices at the same time. It should have a fuse in it so that if there is a power surge (overvoltage event), the fuse will blow and the electronics plugged into the device won\u2019t be damaged. It does not need a battery backup. What type of device do you need?",
    "choice_a": "UPS",
    "choice_b": "Power strip",
    "choice_c": "Battery backup",
    "choice_d": "Surge suppressor",
    "correct_answer": "D",
    "explanation": "Devices that attempt to keep power surges at bay are called surge suppressors. They often look like a power strip, so it\u2019s easy to mistake one for the other, but suppressors are more expensive. They have a fuse inside them that is designed to blow if it receives too much current and not to transfer the current to the devices plugged into it. Surge suppressors may also have receptacles for Registered Jack-45 (RJ-45, Ethernet), coaxial, and universal serial bus (USB), or other connectors. Uninterruptable power supplies (UPS) contain a battery backup to keep equipment running. Power strips are only used to turn multiple devices on or off together, and a battery backup is what people sometimes call a UPS, although UPSs often have many more features.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      264,
      265,
      266,
      256,
      278
    ],
    "source": "9781394330348"
  },
  {
    "id": 1162,
    "question": "When dealing with a customer and demonstrating proper communication techniques, what is meant by actively listening? (Choose two.)",
    "choice_a": "Taking notes and making eye contact",
    "choice_b": "Repeating back to the customer what you believe they just said, starting with something like, \u201cIf I understand you correctly\u2026\u201d",
    "choice_c": "Walking over to the computer with the problem and starting to open it while listening",
    "choice_d": "Answering texts while listening",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Active listening means paying attention to your customers (eye contact is good) and taking notes. Allow them to complete their statements and avoid interrupting them. Don\u2019t do something else like texting or walking away while they are talking to you. People like to know that they are being heard and understood, and as simple an act as it is, paying attention to your customers can make all the difference in making them feel at ease with your work.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      304,
      311,
      313,
      307,
      308
    ],
    "source": "9781394330348"
  },
  {
    "id": 1163,
    "question": "You are troubleshooting a desktop computer that is prone to shorting out and rebooting. When you open the case, there is a layer of grime and dust on all the internal components. When you remove the expansion cards and memory, what should you use to clean the metal contacts on the cards?",
    "choice_a": "Demineralized water",
    "choice_b": "Mild soap and water",
    "choice_c": "Denatured isopropyl alcohol",
    "choice_d": "Compressed air",
    "correct_answer": "C",
    "explanation": "Denatured isopropyl alcohol works well for cleaning connectors. Compressed air won\u2019t likely blow grime away. Electronic connectors of computer equipment should never touch water. Instead, use a lint-free swab moistened in distilled, denatured isopropyl alcohol (also known as electronics or contact cleaner and found in electronics stores) to clean contacts. You might have heard people say they use an eraser, but that could remove some of the soft gold from the contacts and damage the component, so don\u2019t use an eraser.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      258,
      259,
      262,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1164,
    "question": "You are installing a server for a small company. The company wants to be sure that the server can be shut down properly in the event of a power failure so the company doesn't lose data. Which device should you recommend that the company plug the server into?",
    "choice_a": "UPS",
    "choice_b": "Voltage regulator",
    "choice_c": "Surge suppressor",
    "choice_d": "Power strip",
    "correct_answer": "A",
    "explanation": "The best device for power protection is called an uninterruptible power supply (UPS), also known as a battery backup. These devices can be as small as a brick or as large as an entire server rack. Inside the UPS is one or more batteries and fuses. Much like a surge suppressor, a UPS is designed to protect everything that\u2019s plugged into it from power surges. They are also designed to protect against undervoltage events and even complete power failures. Energy is stored in the batteries, and if the power fails, the batteries can power the computer for a period of time long enough, so that the administrator can then safely power it down. Voltage regulators are an electronic component found on some circuit boards. Surge suppressors and power strips will not keep equipment running until it can be safely shut down or switched to an alternate power source.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      264,
      265,
      267,
      303,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1165,
    "question": "You need to upgrade the RAM in a desktop computer. Which of the following should you do before beginning the procedure?",
    "choice_a": "Leave the computer running.",
    "choice_b": "Put the desktop into hibernate mode.",
    "choice_c": "Turn the PC off and unplug the power cord.",
    "choice_d": "Put the desktop into standby mode.",
    "correct_answer": "C",
    "explanation": "Whenever working inside the case, always turn off the power and unplug the unit from the power source. The only exception to this rule is when troubleshooting a power issue and you need to leave the computer on to figure out the problem.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      256,
      258,
      262,
      266,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1166,
    "question": "You are moving computer equipment from an old office to a new office. Which of the following are good personal safety measures to follow to avoid injuries? (Choose two.)",
    "choice_a": "Bend at the knees and lift with your legs.",
    "choice_b": "Bend at the waist and lift straight up.",
    "choice_c": "For heavy items, get a partner to help you lift and/or use a cart to move the item.",
    "choice_d": "When lifting, lift objects as high as possible to avoid running into things.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The muscles in the lower back aren\u2019t nearly as strong as those in the legs or other parts of the body. Whenever lifting, you want to reduce the strain on those lower-back muscles as much as possible. To do so, bend at the knees and lift with your legs. Also observe weight limitations and lift with a partner if needed. Better yet, lift with partner and use a cart to move items. Also, keep objects close to your body and at waist level to minimize bodily stress.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      263,
      262,
      278,
      261,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1167,
    "question": "You have opened a desktop computer case and will be upgrading the memory. To help prevent ESD, you put an ESD strap on your wrist. Where should you connect the other end?",
    "choice_a": "RAM",
    "choice_b": "Antistatic mat",
    "choice_c": "Power supply",
    "choice_d": "Plastic table",
    "correct_answer": "B",
    "explanation": "To use the electrostatic discharge (ESD) strap, you attach one end to your wrist with the supplied bracelet and the other to an Earth ground. Some ESD mats have a connector for the ESD strap. This strap and mat connection provides a safe path to ground for stray electrons (static). If you don\u2019t have an ESD mat handy, connecting the strap to a metal part of the case keeps you and the case at the same electrical potential, which will help to prevent you from accidentally damaging components with a jolt of static electricity. Never connect an ESD strap to the power supply, because it contains capacitors that can discharge and injure you. Some plastics develop a static charge, so connecting your ESD strap to a plastic table would more likely cause a static discharge than prevent one.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      258,
      259,
      256,
      260,
      262
    ],
    "source": "9781394330348"
  },
  {
    "id": 1168,
    "question": "You are purchasing new spreadsheet software for your company. Your manager has instructed you to ensure that you purchase enough licenses for everyone in the office to use the product. What type of license will you likely purchase, designed for large groups of users? (Choose two.)",
    "choice_a": "Corporate",
    "choice_b": "Single user",
    "choice_c": "Concurrent",
    "choice_d": "Shareware",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When supporting a large group of users, you\u2019re going to need either a corporate license or a concurrent license that permits at least the number of people you\u2019ll have accessing the software. A single-user license is good for only one user. You could buy a lot of single-user licenses, but that is generally more expensive than buying a corporate or concurrent license. Shareware generally does not require licensing, and payment may be handled via the honor system. But shareware is generally not a good choice for a corporate environment where you depend on the software. Some shareware will also specify that it is only free if used for personal use, but in a corporate environment, a fee must be paid.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      284,
      282,
      287,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1169,
    "question": "You have several old computers of which you need to dispose. What should you do with them? (Choose two.)",
    "choice_a": "Throw them in the trash.",
    "choice_b": "Overwrite or physically destroy storage drives.",
    "choice_c": "Donate or dispose of them in compliance with government regulations.",
    "choice_d": "Put them at the curb for someone to take for free.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "If you can\u2019t find a way to reuse the equipment, be sure to dispose of it in compliance with government regulations. Most computers contain small amounts of hazardous substances, so they should be recycled by professionals who know how to deal with those dangers. Many municipalities, states, and countries have regulations in place specifying appropriate measures to enforce their proper disposal. Search the Internet for certified recycling programs near you. To donate equipment, overwrite or physically destroy the drive to ensure that the data remains private. Never put them on the curb for free, as you don\u2019t know where they (or any stray data on them) will end up.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      269,
      267,
      268,
      275,
      284
    ],
    "source": "9781394330348"
  },
  {
    "id": 1170,
    "question": "You fixed a customer\u2019s laptop about three days ago. Which of the following demonstrates proper communication techniques and professionalism? (Choose two.)",
    "choice_a": "Call the customer to see whether they are satisfied with the repair.",
    "choice_b": "Post \u201cAnother satisfied customer!\u201d on your social media sites with a picture of their office building.",
    "choice_c": "Provide accurate documentation for the services you provided.",
    "choice_d": "Call the customer and ask if they have additional work you can do.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "You should always set expectations with the customer and then meet or exceed them. After resolving a customer\u2019s issue, follow up with them to ensure that they are satisfied with the services you provided. Your follow-up shows professionalism and may earn you future business. Never post online about a customer unless you have their permission first and calling them to ask if they have additional work for you makes you appear less professional.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      307,
      310,
      312,
      282,
      304
    ],
    "source": "9781394330348"
  },
  {
    "id": 1171,
    "question": "You are troubleshooting problems in a client\u2019s office, and the client starts arguing with you as to what the problem is. What should you do?",
    "choice_a": "Avoid arguing and becoming defensive.",
    "choice_b": "Argue back to prove that you are correct.",
    "choice_c": "Tell the client that they are making you uncomfortable and leave immediately.",
    "choice_d": "Tell the client that if they know so much, they can fix it themselves. Then leave.",
    "correct_answer": "A",
    "explanation": "In difficult situations, it can be challenging to keep a level head. It\u2019s important to do so and to avoid arguing and becoming defensive. Remember that if a client had to call you, they\u2019re likely already having a bad day and may be frustrated. Sometimes, they will take their frustration out on you. Keep a level head and work to resolve the problem. Do not engage in an argument with them. Don\u2019t leave unless you feel in danger or your company policy states to do so. Don\u2019t tell the client to fix it themselves. If they could have, they would have done so.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      311,
      306,
      313,
      310,
      312
    ],
    "source": "9781394330348"
  },
  {
    "id": 1172,
    "question": "Your company has a policy prohibiting illegal content on work computers. You have identified illegal content on a company-owned workstation. What is your next step?",
    "choice_a": "Remove the data from the offending party.",
    "choice_b": "Shut down the computer.",
    "choice_c": "Ask the user to delete the material.",
    "choice_d": "Document the incident.",
    "correct_answer": "A",
    "explanation": "If you have your policy in place, then your incident response plan should be relatively scripted. Your first priority as the first responder is to identify the improper activity or content (which you have done). Then you should always get someone else to verify the material or action so that it doesn\u2019t turn into a situation of your word against someone else\u2019s. Remove the evidence from the offending person\u2019s possession, take steps to preserve the data or device, and immediately report the situation through proper channels, whether that\u2019s management or law enforcement. You would not shut down the computer or ask the user to delete the offending content, because doing so might destroy evidence. You certainly do want to preserve the data or device by locking it in a separate location, while being conscious of the order of volatility. Documenting the chain of custody and what happened is also required, but it\u2019s not what needs to be done next.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      285,
      271,
      270
    ],
    "source": "9781394330348"
  },
  {
    "id": 1173,
    "question": "You are going to be upgrading the RAM on several desktop computers. Which of the following environmental conditions increases the risk of ESD damaging computer components?",
    "choice_a": "High temperature",
    "choice_b": "Low temperature",
    "choice_c": "High humidity",
    "choice_d": "Low humidity",
    "correct_answer": "D",
    "explanation": "When humidity gets to be very low, around 20 percent or lower, the risk of electrostatic discharge (ESD) increases. Remember that computer components can be damaged with very little voltage, even less than the shock you feel when you touch a metal doorknob after walking across a carpet. Always use ESD protection to prevent damage to components.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      260,
      258,
      259,
      266,
      264
    ],
    "source": "9781394330348"
  },
  {
    "id": 1174,
    "question": "Your company has a policy prohibiting illegal content on work computers. You have found illegal content on a user\u2019s workstation. What is the proper way to preserve the data or device?",
    "choice_a": "Ask the user to not delete the data from the device.",
    "choice_b": "Take a picture of the illegal content and email it to your manager.",
    "choice_c": "Take a picture of the illegal content and email it to yourself.",
    "choice_d": "Remove the data or device from the possession of the offending user and preserve it in a safe location.",
    "correct_answer": "D",
    "explanation": "If you have your policy in place, then your incident response plan should be relatively scripted. After identifying illegal content, you need to preserve that content. The method of preserving the data depends on exactly what format that data is in. For example, if the data is held in random access memory (RAM), you can\u2019t turn the computer off, because without power, it will no longer exist in RAM. If it is files on the storage drive, you could turn the PC off and remove the drive. In any case, the data or device should immediately be removed from the possession of the offending party and preserved. This will ensure that the data doesn\u2019t mysteriously disappear before the proper parties are notified.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      270,
      285,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1175,
    "question": "Your company maintains a database of customers\u2019 names, vehicle license plate numbers, and driver\u2019s license numbers. What type of policy should your company have regarding this information?",
    "choice_a": "This information can\u2019t be used in any damaging way; therefore, no special policy is needed.",
    "choice_b": "This information is related to motor vehicle operation, and no special policy is needed.",
    "choice_c": "This information is public information, and no special policy is needed.",
    "choice_d": "This is PII and personal government-issued information and should be kept confidential and secure.",
    "correct_answer": "D",
    "explanation": "Personally identifiable information (PII) is anything that can be used to identify an individual person on its own or in context with other information. This includes someone\u2019s full name, address, and other contact information; the names of family members; and other details that people would consider private. PII should always be kept confidential and secure. Government-issued information includes data such as Social Security numbers, license numbers, passport data, and other government identifications. Be sure that this information is properly secured and can be accessed only by authorized personnel. There are rules and regulations for how this data can be stored, accessed, and used. This is known as regulated data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      275,
      276,
      312,
      277,
      270
    ],
    "source": "9781394330348"
  },
  {
    "id": 1176,
    "question": "You are looking for a new software application for your company\u2019s financial data users, but you have a limited budget. Which of the following types of software licensing would you expect to not have to pay for? (Choose two.)",
    "choice_a": "Corporate",
    "choice_b": "Freeware",
    "choice_c": "Personal-use",
    "choice_d": "Open-source",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Freeware is an easy choice, because it\u2019s free. Open-source software is often also free, and you can modify the code free of charge as well (if you have the skills to do so). Some shareware is free, but it depends on the program. Single-user and corporate licenses generally cost money. The downside of freeware or open-source software is that there might not be sufficient support for it if you run into any difficulties.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      284,
      282,
      279,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1177,
    "question": "You are setting up a repair shop for PCs. To reduce the risk of damaging computer components with static electricity, which of the following devices should you use? (Choose two.)",
    "choice_a": "Magnetic screwdrivers",
    "choice_b": "ESD mats",
    "choice_c": "ESD straps",
    "choice_d": "A dehumidifier",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "It is possible to damage a device by simply laying it on a benchtop. For this reason, you should have an electrostatic discharge (ESD) mat in addition to an ESD strap. The mat drains excess charge away from any item coming into contact with it. ESD mats are also sold as mouse/keyboard pads to prevent ESD charges from interfering with the operation of the computer. Many ESD wrist straps can be connected to the mat, thus causing the technician and any equipment in contact with the mat to be at the same electrical potential and eliminating ESD. Magnetic screwdrivers are not a good idea, because they could damage a computer chip if they inadvertently come into contact with it. A dehumidifier removes excess moisture from the air. The correct air moisture content for working on computer equipment is about 50 percent. In cold climates, you\u2019re more likely to need a humidifier, to add moisture to air, because too little moisture creates more static electricity. Too much moisture can cause components to corrode.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      258,
      259,
      260,
      262,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1178,
    "question": "You have chosen to use compressed air to clean away dirt and debris from the inside of a desktop computer case. What is the recommended safety gear you should wear?",
    "choice_a": "Safety goggles and an air filter mask",
    "choice_b": "Safety goggles and a respirator",
    "choice_c": "Safety goggles, a respirator, and a hair net",
    "choice_d": "A biohazard suit",
    "correct_answer": "A",
    "explanation": "When compressed air is used, particles of dirt and debris can become airborne, and be inhaled or get into your eyes. Always wear proper safety gear, such as safety goggles and an air filtration mask. In most situations, the other options would be unnecessary.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      258,
      259,
      268,
      261
    ],
    "source": "9781394330348"
  },
  {
    "id": 1179,
    "question": "What type of information likely needs access safeguards per regulatory requirements as it relates to an individual\u2019s medical records?",
    "choice_a": "Personally identifiable information",
    "choice_b": "Protected healthcare data",
    "choice_c": "Driver\u2019s license number",
    "choice_d": "Place of employment",
    "correct_answer": "B",
    "explanation": "A person\u2019s medical records and health information is classified as protected health information (PHI) (listed as Healthcare data on the CompTIA A+ objectives) and must be protected according to regulatory requirements such as the Health Insurance Portability and Accountability Act (HIPAA). A driver\u2019s license number and place of employment may be considered personally identifiable information (PII).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      275,
      312,
      276,
      287,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1180,
    "question": "You need to dispose of a chemical solvent but are unsure how to properly do so. Where will you find information on this, as well as the potential dangers the solvent possesses?",
    "choice_a": "MSDS/SDS",
    "choice_b": "OSHA",
    "choice_c": "Warning label",
    "choice_d": "Bottom of the container",
    "correct_answer": "A",
    "explanation": "A safety data sheet (SDS) is required for any chemicals that are sold and include information such as the physical product data (e.g., boiling point, melting point, flash point, etc.), potential health risks, storage and disposal recommendations, and spill/leak procedures. With this information, technicians and emergency personnel know how to handle the product as well as respond in the event of an emergency. The term material safety data sheet (MSDS) was replaced with the term safety data sheet in 2015, but you still see MSDS used on the CompTIA A+ exam and objectives. The Occupational Safety and Health Administration (OSHA) is a U.S. government agency that enforces safe working practices. Warning labels can be found on chemicals and equipment and may be required by local or national governments. It\u2019s unlikely that instructions can be found on the bottom of containers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      268,
      269,
      267,
      266,
      261
    ],
    "source": "9781394330348"
  },
  {
    "id": 1181,
    "question": "You are discussing the placement of several new computers with one of your coworkers. Which of the following are the best places to put them? (Choose two.)",
    "choice_a": "In the corner of a room that is typically about 15\u00b0 warmer than room temperature",
    "choice_b": "In an open area at room temperature",
    "choice_c": "In a room that is typically about 15\u00b0 colder than room temperature",
    "choice_d": "In an enclosed kiosk so that no users can damage the system",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Computers generally tolerate temperature and humidity levels about the same as humans do, except electronic devices do like it a bit colder. The general rule of thumb is room temperature or cooler, average humidity, and good ventilation.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      260,
      265,
      284,
      307,
      309
    ],
    "source": "9781394330348"
  },
  {
    "id": 1182,
    "question": "A user\u2019s work area is littered with debris and crumbs, and they report that keys on their keyboard stick or sometimes make a crunching sound. What should be the first option for cleaning this keyboard?",
    "choice_a": "Denatured isopropyl alcohol",
    "choice_b": "Demineralized water",
    "choice_c": "Vacuum cleaner",
    "choice_d": "Compressed air",
    "correct_answer": "D",
    "explanation": "The first option should be a few quick blasts of compressed air to immediately blow out the crumbs and debris. If that first option does not work, then demineralized water should clean anything spilled on a keyboard. Bear in mind that when you use demineralized water, it will then take a few days to dry out the keyboard, and it shouldn\u2019t be used until it\u2019s completely dry. Isopropyl alcohol is used to clean electrical contacts, not keyboards, and a regular vacuum cleaner can introduce static, which can damage computer components, so don\u2019t use it!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      258,
      262,
      257,
      267
    ],
    "source": "9781394330348"
  },
  {
    "id": 1183,
    "question": "You are performing a safety audit for your company and are examining the company\u2019s fire extinguishers. Which type of fire extinguisher is designed to put out electrical fires?",
    "choice_a": "Class A",
    "choice_b": "Class B",
    "choice_c": "Class C",
    "choice_d": "Class D",
    "correct_answer": "C",
    "explanation": "Four major classes of fire extinguishers are available, one for each type of flammable substance: Class A for wood and paper fires, Class B for flammable liquids, Class C for electrical fires, and Class D (for metal powder or NaCl [salt]) for flammable metals such as phosphorus and sodium. The most popular type of fire extinguisher today is the multipurpose, or ABC-rated, extinguisher. It contains a dry chemical powder that smothers the fire and cools it at the same time. For electrical fires (which may be related to a shortened-out wire in a power supply), make sure the fire extinguisher will work for Class C fires.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      256,
      257,
      266,
      269,
      278
    ],
    "source": "9781394330348"
  },
  {
    "id": 1184,
    "question": "You have a set meeting time with a client to upgrade their computer. Your prior service call runs long, and you will be late for the meeting. What should you do?",
    "choice_a": "Get to the meeting as soon as you are able.",
    "choice_b": "Take your time; you\u2019re already late and a few more minutes won\u2019t matter.",
    "choice_c": "Don\u2019t show up. Call the client later and tell them you were tied up.",
    "choice_d": "Call the client, apologize for being late, and explain that your last call went over. You will be there as soon as possible or can reschedule if they would prefer.",
    "correct_answer": "D",
    "explanation": "Be on time, or five minutes early. If you\u2019re going to be late, be sure to contact your customer. Not doing so indicates that you think their problem isn\u2019t important. Don\u2019t simply show up late and assume that\u2019s okay. They may have other things scheduled. If they\u2019ve been waiting around for you and you don\u2019t call them until later, they may have already called someone else for help.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      309,
      307,
      304,
      311,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1185,
    "question": "You are asked to help a client who is unable to send or receive email. When you get to the client\u2019s desk, what should you do?",
    "choice_a": "Tell them that this issue is nothing and you have dealt with far worse issues today.",
    "choice_b": "Ask what they did to cause the issue.",
    "choice_c": "Tell them that you would rather be working on updating the server, but you suppose you\u2019ll deal with this issue first.",
    "choice_d": "Clarify the scope of the issue and verify that you understand exactly what isn\u2019t working correctly.",
    "correct_answer": "D",
    "explanation": "Providing good customer service involves proper communication and professionalism. Clarifying the scope of the issue and verifying that you understand what isn\u2019t working are ways to show the customer that you\u2019re listening to them. Dismissing customer problems is never a good tactic. Neither is asking accusatory questions or telling them there are other things that are more important. Clarify the scope of the problem and ask clarifying questions to ensure that you understand what isn\u2019t working properly.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      306,
      304,
      307,
      311,
      310
    ],
    "source": "9781394330348"
  },
  {
    "id": 1186,
    "question": "Which of the following small devices should not be disposed of at a normal landfill but instead be regarded as containing toxic chemicals? (Choose two.)",
    "choice_a": "Tablet computer",
    "choice_b": "Phone packaging",
    "choice_c": "Light cardboard",
    "choice_d": "Cell phone",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Both tablet computers and cell phones contain toxic chemicals such as beryllium, arsenic, and lead as well as rare-Earth metals that could be recycled. None of what is inside most electronic devices belongs in a landfill. The other two options arguably belong elsewhere as well, but may not be considered toxic, and are not devices.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      269,
      267,
      257,
      256,
      275
    ],
    "source": "9781394330348"
  },
  {
    "id": 1187,
    "question": "While changing a laser printer\u2019s toner cartridge, a technician spilled toner on a desk. What should they use to clean the mess up?",
    "choice_a": "Compressed air",
    "choice_b": "Mild soap and water",
    "choice_c": "Toner vacuum",
    "choice_d": "Denatured isopropyl alcohol",
    "correct_answer": "C",
    "explanation": "One unique challenge when cleaning printers is spilled toner. Getting it wet by using mild soap and water or denatured isopropyl alcohol will make an inky mess. It sticks to everything and should not be blown into the air and inhaled\u2014it\u2019s a carcinogen. Use an electronics vacuum that is designed specifically to pick up toner. A normal vacuum cleaner\u2019s filter isn\u2019t fine enough to catch all the particles, so the toner may be circulated into the air. Normal electronic vacuums may melt the toner instead of picking it up.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      266,
      261,
      268,
      262,
      258
    ],
    "source": "9781394330348"
  },
  {
    "id": 1188,
    "question": "You are holding a laptop for someone who will be out of the country for a year or so. What is the best way to store their laptop battery to preserve its life?",
    "choice_a": "Store it in a cool, dry area.",
    "choice_b": "Store it in a closet.",
    "choice_c": "Store it at room temperature.",
    "choice_d": "Store it in a freezer.",
    "correct_answer": "A",
    "explanation": "Extreme temperatures, either hot or cold, will negatively impact battery life. Batteries store best in cool (not frigid) temperatures. You might think that you should store it in a freezer, but that isn\u2019t good either because the freezer is likely a bit too cold, and they tend to have too much moisture. A closet is at room temperature, but someplace a few degrees cooler than room temperature and dry is the perfect storage area for a battery. You\u2019ll also want it to be about half charged when you store it, and bring it out periodically to charge and discharge, then store it again.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      284,
      259,
      264,
      287,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1189,
    "question": "You are repairing a desktop PC and upgrading the memory. What is the main reason that equipment grounding is an important safety procedure?",
    "choice_a": "To prevent an electrical shock to yourself",
    "choice_b": "To prevent an electrical shock from damaging components",
    "choice_c": "To prevent a fire from starting inside the case",
    "choice_d": "To prevent the desktop PC from slipping off the workspace",
    "correct_answer": "B",
    "explanation": "Enough electricity can hurt people, but tiny amounts can pose safety issues for computer components. One of the biggest concerns for components is electrostatic discharge (ESD). For the most part, ESD won\u2019t do serious damage to a person other than provide a little shock, like scuffing across a carpet then touching something metal. But little amounts of ESD, smaller than you could see a spark or feel a zap, can cause serious damage to computer components, and that damage can manifest itself by causing computers or components to hang, reboot repeatedly, or fail completely.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      258,
      259,
      260,
      256,
      264
    ],
    "source": "9781394330348"
  },
  {
    "id": 1190,
    "question": "What type of script has the filename extension <code>.ps1</code>?",
    "choice_a": "PowerShell",
    "choice_b": "Bash",
    "choice_c": "JavaScript",
    "choice_d": "Python",
    "correct_answer": "A",
    "explanation": "PowerShell uses the <code>.ps1</code> filename extension. Linux-based Bash scripts use <code>.sh</code>, JavaScript uses <code>.js</code>, and Python uses <code>.py</code>.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      237,
      234,
      233,
      235
    ],
    "source": "9781394330348"
  },
  {
    "id": 1191,
    "question": "What type of editor would you normally use to view a script with the filename extension <code>.vbs</code>?",
    "choice_a": "Vi",
    "choice_b": "Notepad",
    "choice_c": "Nano",
    "choice_d": "CoffeeCup",
    "correct_answer": "B",
    "explanation": "Visual Basic scripts, which have a <code>.vbs</code> extension, are run on Windows platforms, so Notepad or WordPad would work to edit them, but the Linux/UNIX editors vi and nano would not be used to view a VB script. CoffeeCup is for editing HTML files.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      237,
      236,
      235,
      238,
      255
    ],
    "source": "9781394330348"
  },
  {
    "id": 1192,
    "question": "What file extension is used with a plain-text script file that can be run or edited in a Windows command prompt?",
    "choice_a": "<code>.js</code>",
    "choice_b": "<code>.sh</code>",
    "choice_c": "<code>.py</code>",
    "choice_d": "<code>.bat</code>",
    "correct_answer": "D",
    "explanation": "Batch scripting, which uses the filename extension <code>.bat</code>, is typically a series of command-line commands. Such a script file would run on the Windows systems\u2019 command line. The other filename extensions\u2014.<code>js</code>,<code>.sh</code>, and <code>.py</code>\u2014are JavaScript, shell, and Python, respectively. They each require special additional software to be able to interpret the script.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      237,
      235,
      234,
      238
    ],
    "source": "9781394330348"
  },
  {
    "id": 1193,
    "question": "What programming language uses files with the <code>.js</code> extension?",
    "choice_a": "JavaScript",
    "choice_b": "Java",
    "choice_c": "Juice",
    "choice_d": "Joomla",
    "correct_answer": "A",
    "explanation": "JavaScript uses the <code>.js</code> filename extension. Java is a programming language. Juice is software to schedule the downloading of podcasts, and Joomla is a web development platform. Of the four choices, only JavaScript is on the CompTIA A+ exam, so focus on that programming language\u2019s file extension.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      233,
      238,
      236,
      249
    ],
    "source": "9781394330348"
  },
  {
    "id": 1194,
    "question": "You and the Research and Development department are writing a formal document regarding the service that the IT department will provide, and what IT won\u2019t (or can\u2019t) provide for them because of confidentiality. What type of agreement is this?",
    "choice_a": "Internal SLA",
    "choice_b": "External/third-party SLA",
    "choice_c": "SOP",
    "choice_d": "KB",
    "correct_answer": "A",
    "explanation": "An internal service level agreement (SLA) is an agreement between different departments or locations of the same organization. An external/third-party SLA, for example, could exist between the IT department and another company that supplies computer hardware. A standard operating procedure (SOP) defines what actions will be taken when various incidents occur, such as a security incident, new hires, and procuring equipment. A knowledgebase (KB) is a repository of known issues with equipment or software and how to resolve them. A knowledgebase can be either a database or consist of articles, like the Microsoft KB.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      286,
      276,
      288,
      282,
      287
    ],
    "source": "9781394330348"
  },
  {
    "id": 1195,
    "question": "You just took a new IT manager job and are sorting out a company that doesn\u2019t have a good inventory list. What best practice will you employ that helps your department in keeping track of the hardware found throughout the workplace?",
    "choice_a": "Knowledgebase articles",
    "choice_b": "Asset tagging",
    "choice_c": "Password policy",
    "choice_d": "Incident reporting",
    "correct_answer": "B",
    "explanation": "Asset tagging hardware, like desktops and laptops, can help an administrator quickly know the details of a particular asset. Inventory management is more easily accomplished with asset tagging. Knowledgebase (KB)/articles are a repository of information about known issues and how to resolve them. A password policy defines requirements for passwords, such as complexity and how often they can/must be changed. They are enforced through group policies. Incident reporting should be part of a standard operating procedure (SOP) that defines what to do when something undesirable occurs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      279,
      282,
      287
    ],
    "source": "9781394330348"
  },
  {
    "id": 1196,
    "question": "Your IT technician is looking for a solution to an error that popped up on a user\u2019s screen. What will they likely be using to help determine what to do about the error?",
    "choice_a": "Brown bagging",
    "choice_b": "Knowledgebase articles",
    "choice_c": "Change board documentation",
    "choice_d": "Change management policy",
    "correct_answer": "B",
    "explanation": "Many software and hardware companies have extensive knowledgebases/articles to document issues that have occurred and how to resolve them. Chances are that if you\u2019re having an issue with hardware or software, someone else has encountered the same issue and documented it for you. Just ensure that the knowledgebase/article you use is from a reliable source. Individual organizations sometimes keep their own knowledgebases (KBs) as a part of their systems information management procedures. A change board is usually a group that approves of proposed changes as a part of project management. Change management policy describes the procedures to be followed if a major system change is needed. Brown bagging means bringing lunch from home.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      280,
      279,
      286,
      291
    ],
    "source": "9781394330348"
  },
  {
    "id": 1197,
    "question": "You\u2019re working through the change management system for a change request that has been made by a manufacturing department. Before the change is implemented in the computer system, how will you ensure that the change will work?",
    "choice_a": "Identify the scope of the change.",
    "choice_b": "Receive change board approval.",
    "choice_c": "Perform risk/risk level analysis.",
    "choice_d": "Perform sandbox testing.",
    "correct_answer": "D",
    "explanation": "Sandbox testing is setting up a system that mimics a production system to try the change in a safe environment <i>before</i> implementing it. The scope of the change identifies what it will and will not affect. A change board approval is the last step before a kickoff meeting to initiate the change. Risk analysis should be a part of every project, with an identified risk level for each possible negative (or positive) event that might affect the project. The risk is assigned a score, and the risk level and response plans are identified so that if the risk is realized, there is a clear plan of action to handle it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      290,
      292,
      295,
      294,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1198,
    "question": "What change management detail is not necessary to document?",
    "choice_a": "Purpose of the change",
    "choice_b": "Scope of the change",
    "choice_c": "Unaffected applications",
    "choice_d": "Change board approvals",
    "correct_answer": "C",
    "explanation": "Every documented change should include the reason or purpose of the change. The reason can explain the justification to those unfamiliar with the situation before the change. The scope of the change documents what is affected by the change. The change board approval, arguably the most important part, documents the management\u2019s support of the change. Documenting what applications are not affected by the change is an unnecessary step.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      291,
      292,
      295,
      288,
      294
    ],
    "source": "9781394330348"
  },
  {
    "id": 1199,
    "question": "You work for a retailer and are near the end of a planned change implementation. People are still making suggestions to add to the project, but the busy season is about to start, and you tell them their changes will not be implemented at this time. What is happening?",
    "choice_a": "Rollback plan",
    "choice_b": "Change freeze",
    "choice_c": "Risk analysis",
    "choice_d": "End-user acceptance",
    "correct_answer": "B",
    "explanation": "A change freeze means that no new changes, or even excellent suggestions or solutions, will be implemented in a project. It often happens near the end of the project, or when systems must be stable, such as entering a busy season. The rollback plan documents the actions to take, in the event that the change must be stopped for some reason, once the process has begun. A risk analysis is performed to assess any deviations to a plan, whether good or bad, and assign them a risk number. Some risks will have contingency plans created as a part of the risk analysis. End-user acceptance isn\u2019t necessarily documented, but it means that the change is welcomed, agreed upon, and supported by end-users. End-user acceptance is important to the success of any major change that affects how the end-users do their job, and there are actions that can be taken to help ensure end-user acceptance, such as including end-users in the planning process and explaining in detail why a change affecting them must be made.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      289,
      294,
      295,
      291
    ],
    "source": "9781394330348"
  },
  {
    "id": 1200,
    "question": "A network administrator wrote and documented business continuation procedures, including a backup plan. Finally, critical data was backed up as required. What should be done next before the implementation can be considered reliable?",
    "choice_a": "Backup testing",
    "choice_b": "Documenting a checklist",
    "choice_c": "End-user acceptance",
    "choice_d": "Approval of the policy",
    "correct_answer": "A",
    "explanation": "The greatest backup procedures in the world will not help if your backups are not reliable. Backups must be tested on a regular basis to ensure that they can be restored if the need ever arises. You will most certainly want a documented checklist to follow in the backup and recovery process. End-user acceptance is not what you would do next. Approval of the policy/procedure may be required, but again, it isn\u2019t the next thing you would do.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      303,
      302,
      289,
      288,
      290
    ],
    "source": "9781394330348"
  },
  {
    "id": 1201,
    "question": "In a geographical area prone to tornados, what option for storing backups seems most sensible?",
    "choice_a": "Tape backups in the basement",
    "choice_b": "Tapes distributed among offices",
    "choice_c": "Off-site cloud storage",
    "choice_d": "Storage on a server against an inside wall",
    "correct_answer": "C",
    "explanation": "Depending on the disaster, the question of off-site cloud storage versus local storage backups can significantly affect the success of recovery. For example, for a server hardware failure or a recent malware incident, local storage provides adequate security of backups. However, a catastrophic collapse of the building could mean local storage is not accessible.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      303,
      300,
      299,
      301,
      292
    ],
    "source": "9781394330348"
  },
  {
    "id": 1202,
    "question": "Your company uses a ticketing system to track repair calls. Which of the following might not be included in the information gathered for the ticketing system when the client/customer calls?",
    "choice_a": "User information",
    "choice_b": "Device information",
    "choice_c": "Description of issues",
    "choice_d": "Inventory lists",
    "correct_answer": "D",
    "explanation": "Inventory lists are a feature of asset management, not ticketing systems. On the initial call, a user would typically gather information about the user, such as their name and contact information, the device that has an issue, and a description of the issue.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      280,
      279,
      283,
      282,
      281
    ],
    "source": "9781394330348"
  },
  {
    "id": 1203,
    "question": "What change-management document describes the procedures that will occur if you reach a critical go/no-go point in a project that makes a change to your network and you decide that it\u2019s a no-go?",
    "choice_a": "Sandbox testing",
    "choice_b": "Rollback plan",
    "choice_c": "Request forms",
    "choice_d": "Risk analysis",
    "correct_answer": "B",
    "explanation": "Whenever you\u2019re planning a change to a business system, you need to have a plan set in place to return to the old system if the planned change doesn\u2019t work out as expected. The plan to revert to the old system is known as a rollback plan. Sandbox testing is done before implementing changes to ensure that the changes will work. Request forms happen at the beginning of change management, and risk analysis examines whether to proceed with the change.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      289,
      292,
      295,
      290,
      294
    ],
    "source": "9781394330348"
  },
  {
    "id": 1204,
    "question": "What type of backup includes all files, whether or not the archive bit is set?",
    "choice_a": "Complete backup",
    "choice_b": "Incremental backup",
    "choice_c": "Full backup",
    "choice_d": "Differential backup",
    "correct_answer": "C",
    "explanation": "A full backup creates a copy of all files whether or not their archive bit is set. An incremental backup will back up files that have changed since the last backup was made. Incremental backups and full backups reset the archive bit. Differential backups will back up all changes since the last full or incremental backup was performed. Differential backups do not reset the archive bit.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      298,
      302,
      303,
      300
    ],
    "source": "9781394330348"
  },
  {
    "id": 1205,
    "question": "On Sunday, your system will automatically create a full backup of your data. At the end of each weekday, Monday through Friday, a differential backup is created. It is now Thursday morning, and you discover that your system crashed during the night. You need to restore your data. Which backups will you need to restore to get all of your data back?",
    "choice_a": "Only Wednesday\u2019s backup",
    "choice_b": "Sunday and Wednesday backups",
    "choice_c": "Sunday, Monday, Tuesday, and Wednesday backups",
    "choice_d": "Sunday and Thursday backups",
    "correct_answer": "B",
    "explanation": "When using full backups and differential backups to restore a system, you\u2019ll need the last one of each to recover all the data. Each differential backup is larger than the one before, because it includes the cumulative backup of all the changes that have happened since the last full backup. The differential backups are slower to create than incremental backups but restoring them is easier because there are fewer datasets to restore.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      298,
      303,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1206,
    "question": "Which of the following statements comparing differential and incremental backups are true? (Choose two.)",
    "choice_a": "Incremental backups are created faster than differential.",
    "choice_b": "Differential backups are created faster than incremental.",
    "choice_c": "Incremental backups are more fault tolerant than differential backups.",
    "choice_d": "Differential backups are simpler to restore than incremental backups.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Incremental backups are created faster over time than differential backups. If each weekday the same number of files were changed, an incremental backup on Wednesday would only take one-third as long as a differential backup, because the differential backup would have Monday, Tuesday, and Wednesday\u2019s changes. The Wednesday incremental backup would only have Wednesday\u2019s changes. Differential backups are easier to restore, because you would only restore the last full backup and the most recent differential backup. Incremental backups are less fault tolerant than differential, because there are more possible points of failure in the form of a greater number of backups, which would need to be restored to achieve the same result as a differential backup. Say your procedure is to perform a full backup each Sunday, and daily backups each night, then you discover on Thursday morning that your system crashed. If you needed to restore from incremental backups, you would have four backups to restore (i.e., Sunday, Monday, Tuesday, and Wednesday), whereas using differential backups would only require restoring two (i.e., Sunday and Wednesday).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      300,
      303,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1207,
    "question": "Which of the following is true about how computer components such as expansion cards and processors should be stored?",
    "choice_a": "In antistatic bags, with protective packing material",
    "choice_b": "In zippered plastic bags, stacked on plastic shelves",
    "choice_c": "In antistatic bags, neatly stacked on a grounded shelf",
    "choice_d": "On top of antistatic bags, on a shelf in a closet",
    "correct_answer": "A",
    "explanation": "Static sensitive components should be stored in (not on) antistatic bags. If possible, use protective packaging that came with them. They should not be stored in plastic bags or on plastic shelves because most plastics gather static. The exception would be shelves that are specifically made to be static-free. Expansion cards should never be stacked on top of each other, because doing so could damage or dislodge chips on the card. If you must store several of them, put each in its own box or a divided box made for that purpose. Antistatic bags are made to keep static on the outside of the bag, like a mini-Faraday cage, so placing sensitive components on an antistatic bag is like asking for trouble.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      258,
      260,
      266,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1208,
    "question": "What should always be done before moving a laser printer?",
    "choice_a": "Remove the printhead.",
    "choice_b": "Remove the stapler assembly.",
    "choice_c": "Remove the toner cartridge(s).",
    "choice_d": "Remove the paper.",
    "correct_answer": "C",
    "explanation": "If you were moving a laser printer more than from one room to another, you would certainly want to check the manufacturer\u2019s recommendations for moving the equipment. But whenever you are moving a laser printer, it\u2019s important to remove the toner cartridges first. The cartridge may get jostled during the move and toner spilled inside the machine, which would create a hazardous situation for both you and the machine. Laser printers don\u2019t have printheads like inkjet printers do. The stapler assembly should be fine but again check the manufacturer\u2019s documentation. Removing the paper is likely not necessary.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      261,
      263,
      268,
      266,
      269
    ],
    "source": "9781394330348"
  },
  {
    "id": 1209,
    "question": "A manufacturing facility asked to have a computer installed on the floor for workers to access so that they can check production information. About a week later, they called you down because the computer isn\u2019t working. When you arrive, you find that someone has wrapped the computer in plastic to protect it from the dust, and it\u2019s about 100\u00b0 Fahrenheit on the plant floor. Why did the computer stop working? (Choose two.)",
    "choice_a": "Too much dust on the plant floor",
    "choice_b": "Lack of ventilation/airflow",
    "choice_c": "Overheating",
    "choice_d": "No electricity",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Computers will shut down when the central processing unit (CPU) has exceeded an acceptable heat level. Components may start acting strangely as well if they are too warm. Not only is the ambient temperature too warm, but by wrapping it in plastic, the computer lacks the necessary airflow to keep the components from overheating. They may need to move this computer to a cooled, protective enclosure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      266,
      264,
      263,
      261,
      262
    ],
    "source": "9781394330348"
  },
  {
    "id": 1210,
    "question": "You are about to retire a computer because it\u2019s being replaced with a faster one that the new updated software needs. Which of the following needs to be done with this computer before it is recycled or donated? (Choose two.)",
    "choice_a": "Ensure that all data is removed/destroyed.",
    "choice_b": "Take it to the sandbox testing area.",
    "choice_c": "Remove it from the asset management inventory list.",
    "choice_d": "Install the new software update.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When retiring equipment, there should be a checklist of things to do. First and foremost, ensure that there is no confidential data on the equipment, then remove it from the asset management inventory list. You could then donate or recycle it. A sandbox is a testing area that is set up like your production systems but separate from them and used when testing a new configuration, software, or process. You would not install the new software update on this machine. If anything, this machine would be restored to the factory default.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      283,
      312,
      277,
      284,
      287
    ],
    "source": "9781394330348"
  },
  {
    "id": 1211,
    "question": "You work as the lead IT network engineer at an IT services company that designs and installs networks for your Fortune 500 clients. Today, you\u2019re meeting with the CIO of a large accounting firm. Which of the following are likely to be appropriate attire for your position and interaction with clients? (Choose two.)",
    "choice_a": "Matching suit coat and pants/skirt, and tie, if appropriate",
    "choice_b": "Khaki pants and polo shirt",
    "choice_c": "Business casual attire",
    "choice_d": "Business formal attire",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "If you\u2019re in a lead role where you meet with clients in larger businesses, you will likely want to dress in business formal attire, which would include matching suit coat and pants or skirt and a tie, if appropriate. Business casual attire for many techs is the familiar khaki pants and polo shirt, but it\u2019s not what you would wear to impress a potential new client.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      305,
      304,
      311,
      313,
      312
    ],
    "source": "9781394330348"
  },
  {
    "id": 1212,
    "question": "You\u2019ve just finished repairing a customer\u2019s printing problem and shown them how to avoid the problem in the future. What steps do you still need to take before the job is considered complete? (Choose two.)",
    "choice_a": "Provide proper documentation on the services provided.",
    "choice_b": "Tell them if they call you directly, they can get the same service for less money in the future.",
    "choice_c": "Follow up with the customer a few days later to ensure that they are satisfied.",
    "choice_d": "Leave without saying anything.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "You need to provide the customer with the proper documentation according to your company, but usually this will include a description of the problem, when and how long you were there, and a \u201cbig picture\u201d description of what was done. You also need to call them a few days later, to ensure that they are still happy with the service they received. You would not tell them to call you directly and you\u2019ll charge less, or you probably wouldn\u2019t have a job for long. You also would not leave without talking to the customer. Ideally, have them test the changes that you\u2019ve made to ensure things are working well for them.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      282,
      310,
      296,
      280,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1213,
    "question": "A coworker has called the Help Desk because they have a problem with their PC. When you start to sit down at their desk, you see a job application there. What do you do?",
    "choice_a": "Ask them politely if they would mind moving their paperwork while you are working there; explain that you don\u2019t want to see anything that might be confidential.",
    "choice_b": "Go to their boss and tell them that the person is looking for another job.",
    "choice_c": "Snap a picture of the job application to post on social media.",
    "choice_d": "Ask them about the job for which they are applying.",
    "correct_answer": "A",
    "explanation": "As a technician you\u2019ll probably come into contact with all sorts of confidential or privileged information, whether it is the business files on someone\u2019s computer or their personal photographs and documents. You do your best to mind your own business, but sometimes you\u2019re going to see things. Unless it\u2019s illegal or you\u2019re bound by company policy to report it, ignore it. Forget that you saw it and don\u2019t talk to anyone about it. You\u2019re there to do a job. That\u2019s all.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      312,
      313,
      275,
      270,
      307
    ],
    "source": "9781394330348"
  },
  {
    "id": 1214,
    "question": "Your company needs an occasional full backup, but your data is so large that the time it takes to back it up is considerable. Rather than do a full backup daily, you have elected to use software that combines incremental backups and a prior full backup to create a new full backup. What type of backup is this?",
    "choice_a": "Incremental",
    "choice_b": "Differential",
    "choice_c": "Synthetic full",
    "choice_d": "Grandfather-father-son",
    "correct_answer": "C",
    "explanation": "A full backup that is created from a prior full backup and one or more incremental backups is known as a synthetic full backup. The advantages are that it takes much less time to create a backup because you only need to perform incremental backups, and if you must restore from a backup, it takes less time because you can always have a full backup. Incremental only backs up what has changed since the last incremental or full backup, and differential backs up whatever has changed since the last full backup. Differential backups don\u2019t reset the archive bit, but full backups and incremental backups do. A grandfather-father-son (GFS) backup is a long-term backup where there are father and son backups between the times that the grandfather backups are made. The GFS strategy is often used where a daily backup is called the \u201cson,\u201d the weekly backup is the \u201cfather,\u201d and the monthly backup is the \u201cgrandfather.\u201d Consider, for example, that you lost all your data on the second Tuesday of the month. If the \u201cfather\u201d and \u201cson\u201d backups were incremental, and the \u201cgrandfather\u201d is a full backup, to recover all of the data, you would restore the grandfather for the end of the prior month, the first \u201cfather\u201d backup, and the \u201cson\u201d backups up to the day the data was lost.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      300,
      302,
      289,
      277
    ],
    "source": "9781394330348"
  },
  {
    "id": 1215,
    "question": "You know that a backup is only good if you can restore from it, so the backups need to be tested periodically to ensure that data can, in fact, be restored from them. Which of the following is not true regarding testing data backups?",
    "choice_a": "Test whenever there have been big system changes like new software, major updates, or major data changes.",
    "choice_b": "Test after every single backup.",
    "choice_c": "Test whenever there are going to be big system changes, like merging databases or software installations or updates.",
    "choice_d": "Test once a month.",
    "correct_answer": "B",
    "explanation": "In an ideal world, it would be great to test the backup for integrity after every backup, but that would be prohibitive in terms of the time it would take. They should be tested often, at least once a month but more often if you are able, and certainly after something significant has changed in a system. You would also want to ensure that you have a good backup before you make those big changes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      303,
      301,
      302,
      289,
      290
    ],
    "source": "9781394330348"
  },
  {
    "id": 1216,
    "question": "You work for an IT services company, and today you\u2019re acting as the lead network installer. In this job, you\u2019ll be running wires through ceilings and walls, and possibly interacting with your customer. What would be the appropriate attire to wear?",
    "choice_a": "Casual graphic T-shirt and jeans",
    "choice_b": "Sneakers",
    "choice_c": "Business formal",
    "choice_d": "Business casual",
    "correct_answer": "D",
    "explanation": "You would not want to wear business formal, which is a suit and dress shoes, if you\u2019re running wires. You also don\u2019t want to be so casual that you look unprofessional. Here, business casual is more appropriate. For some companies, it\u2019s a polo shirt with a company logo and casual pants, but exactly what business casual means will depend on the policies of your company. For many technicians, it\u2019s nice jeans or casual pants and a button-up shirt or a sweater, not a dress shirt, but also not a T-shirt or hoodie. Many companies will have attire with their logo that they prefer you wear. Sometimes, IT techs get dirty.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      305,
      313,
      311,
      312,
      287
    ],
    "source": "9781394330348"
  },
  {
    "id": 1217,
    "question": "In the United States, there is a government entity that oversees safety in the workplace and has the authority to shut down businesses that don\u2019t comply with these safety standards. What is that entity?",
    "choice_a": "OSHA",
    "choice_b": "The NEC",
    "choice_c": "FEMA",
    "choice_d": "IRS",
    "correct_answer": "A",
    "explanation": "In the United States, the Occupational Safety and Health Administration, which is known as OSHA, oversees workplace safety and enacts rules that companies must abide by, including training workers on working safely. If the company fails to make changes after an OSHA inspection, OSHA has the option to close them down. The National Electrical Code (NEC) is a document that was developed by the National Fire Protection Association (NFPA) for wiring and building buildings that are safe. Their rules have been adopted by all 50 U.S. states as a part of their building code. FEMA, which is the Federal Emergency Management Agency, helps in the event of natural disasters, and the IRS, or Internal Revenue Service, is responsible for collecting income taxes.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      268,
      277,
      270,
      313,
      312
    ],
    "source": "9781394330348"
  },
  {
    "id": 1218,
    "question": "Which information technology rule states that you need three copies of data, on two different media, with one copy off-site?",
    "choice_a": "Grandfather-father-son (GFS)",
    "choice_b": "On-site/off-site backup rule",
    "choice_c": "The rule of 78",
    "choice_d": "The 3-2-1 backup rule",
    "correct_answer": "D",
    "explanation": "The 3-2-1 backup rule states that you need three copies of data, on two different media, with one of them being off-site. Grandfather-father-son (GFS) is a rotation scheme for backup media. The rule of 78 is an accounting rule used to calculate interest payments, and there is no common rule called the on-site/off-site backup rule.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      303,
      300,
      301,
      302,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1219,
    "question": "You forgot to bring a file that you need for a presentation today. It\u2019s on your Windows Pro computer at home. Which of the following could you use to retrieve it?",
    "choice_a": "RMM",
    "choice_b": "VPN",
    "choice_c": "VNC",
    "choice_d": "MSRA",
    "correct_answer": "C",
    "explanation": "A virtual network computer (VNC) allows a user to manipulate a computer remotely. Some VNC systems allow a smartphone to control a computer remotely, and some allow for file transfer but not all. Windows Remote Desktop, which uses the Remote Desktop Protocol (RDP), is a type of VNC that is part of the Windows operating system (OS). Remote monitoring and management (RMM) is a category of software used by managed service providers to remotely manage, configure, and control the resources of many different networks. A VPN allows a user to be away from their office, such as a remote worker or traveling salesperson, and connect to the company server or other resources with their laptop or other mobile computer as if they were in the company offices. Microsoft Remote Assistance (MSRA) could not be used, as it would require someone at the home computer to send the invitation.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      239,
      244,
      242,
      240,
      245
    ],
    "source": "9781394330348"
  },
  {
    "id": 1220,
    "question": "You\u2019re having a first meeting with a potential customer at a company where you have been told that everyone wears jeans and T-shirts to work, even the CEO. What would be the appropriate attire for this meeting?",
    "choice_a": "Jeans and a T-shirt with their company logo",
    "choice_b": "Casual attire",
    "choice_c": "Business casual",
    "choice_d": "Business formal",
    "correct_answer": "D",
    "explanation": "Until (or unless) they invite you to wear casual attire, you should dress in business formal attire. Even though they are a casual company, you still need to project a professional image, especially for a first meeting.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      305,
      307,
      310,
      313,
      304
    ],
    "source": "9781394330348"
  },
  {
    "id": 1221,
    "question": "What term means a company follows state, local, federal, and even international government rules and regulations that relate to its work?",
    "choice_a": "Disobedience",
    "choice_b": "Compliance",
    "choice_c": "Information technology governance",
    "choice_d": "Information security",
    "correct_answer": "B",
    "explanation": "Regulatory compliance means that you\u2019re following all the laws that pertain to your company and its locations. These laws can be local, state or provincial, federal, or even international laws. Being out of compliance with government regulations can result in fines, company closure, or even jail time. Disobedience would be the opposite of compliance. Information technology governance means that the structures, processes, and actions of a company\u2019s IT department are in line with the overall goals and objectives of the company. Information security is ensuring the confidentiality, integrity, and availability (CIA) of an organization\u2019s information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      270,
      276,
      286
    ],
    "source": "9781394330348"
  },
  {
    "id": 1222,
    "question": "Which backup scheme ensures that there are short-term, medium-term, and long-term backups, which a business could restore from, and that in theory the business would never lose more than a day\u2019s worth of data and would always have a year\u2019s worth of backups?",
    "choice_a": "Grandfather-father-son (GFS)",
    "choice_b": "On-site/off-site backup rule",
    "choice_c": "Moore\u2019s law",
    "choice_d": "The 3-2-1 backup rule",
    "correct_answer": "A",
    "explanation": "Grandfather-father-son (GFS) is a rotation scheme for backup media. For a typical small business, the \u201cson\u201d backups would be labeled Monday, Tuesday, Wednesday, and Thursday. Seven days later, they are then overwritten. Each Friday a \u201cfather\u201d backup is made, so there would always be four or five father backups, which would be overwritten a month later. The grandfather backups are made only once a month, so they won\u2019t be overwritten for a year. The 3-2-1 backup rule states that you need three copies of data, on two different media, with one of them being off-site. Moore\u2019s law says that technology doubles every two years, and there is no common rule called the on-site/off-site backup rule.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      300,
      303,
      302,
      301,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1223,
    "question": "Part of the HIPAA regulations state that if a health-related document is created, it must be maintained for a minimum period of six years from when it was created or last in effect. What is this an example of?",
    "choice_a": "IT governance",
    "choice_b": "Data retention requirements",
    "choice_c": "GFS",
    "choice_d": "License agreement",
    "correct_answer": "B",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) is a U.S. law protecting personal health information (PHI) privacy, and there are similar laws in many other countries. The requirement to keep information for a period of time is called a data retention requirement. PHI is only one of the many types of regulated data that may affect an IT department, their processes, and the data that they are responsible for. IT governance has to do with keeping the objectives of the IT department in alignment with the goals and objectives of the organization as a whole. Grandfather-father-son (GFS) is a popular backup media rotation scheme, and a license agreement is a contract between you and the software company that is granting you a license to use their software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      312,
      276,
      286
    ],
    "source": "9781394330348"
  },
  {
    "id": 1224,
    "question": "You and your best friend intend to start an MSP company providing technical computer support to business clients. What software will you need to invest in that will enable you to manage those clients and fix many software-related issues without leaving your office?",
    "choice_a": "RMM",
    "choice_b": "VPN",
    "choice_c": "VNC",
    "choice_d": "RDP",
    "correct_answer": "A",
    "explanation": "Remote monitoring and management (RMM) is a category of software used by managed service providers (MSPs) to remotely manage, configure, and control the resources of many different IT networks. A virtual private network (VPN) allows a user to be away from their office, such as a remote worker or traveling salesperson, and connect to the company server or other resources with their laptop or other mobile computer as if they were in the company offices. A virtual network computer (VNC) allows a user to manipulate a computer remotely. Some VNC systems allow a smartphone to control a computer remotely, and Remote Desktop, which uses the Remote Desktop Protocol (RDP), is a type of VNC that is part of the Windows operating system (OS).",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      242,
      244,
      239,
      240,
      245
    ],
    "source": "9781394330348"
  },
  {
    "id": 1225,
    "question": "An employee has a personal-use license for some free diagramming software that they feel would be beneficial for your company. You have evaluated the software and determined that the software company also has corporate licenses for more than one user, for an annual licensing fee. Which of the following is most likely what the employee is allowed to do, under the terms of their personal use license?",
    "choice_a": "Make as many copies as they want.",
    "choice_b": "Bring it into work for everyone to use.",
    "choice_c": "Sell the software for download online.",
    "choice_d": "It depends on the exact terms of the software license, but most likely, they can use the software on their personal computer(s) at home only.",
    "correct_answer": "D",
    "explanation": "Personal-use software is sometimes distributed free to individuals in the hope that they will like it so much, that they will be willing to pay for premium features or purchase corporate licenses for their place of business. Some of these licenses allow users to make and distribute free copies of the software to their friends so that they can try it too. Most will not allow them to bring it into their company without paying for it, nor allow them to sell it. Exactly what you can do with any software that is licensed to you as an individual is covered in the end-user license agreement (EULA) that you agreed to when installing or downloading the software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      276,
      270,
      284,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1226,
    "question": "What technology lets authors, musicians, artists, and other creators of copyrighted material control access to their content so that it is not stolen or illegally shared?",
    "choice_a": "Personal licenses",
    "choice_b": "Digital rights management",
    "choice_c": "Corporate licenses",
    "choice_d": "Nonexpired licenses",
    "correct_answer": "B",
    "explanation": "Digital rights management (DRM) means using technology to protect the copyrighted material created by artists and others from being stolen. Musicians, programmers, movie makers, authors, and so on sometimes put immeasurable hours and great expense into creating their work. To keep others from stealing it, they can use technology to control the number of people who can access content, or sharing, printing, saving, and so on. Some DRM software can limit access to information based on IP addresses or even cause watermarks to appear when someone tries to print a document or image that they don\u2019t have the right to print.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      274,
      275,
      312,
      270,
      277
    ],
    "source": "9781394330348"
  },
  {
    "id": 1227,
    "question": "Which of the following may be undesirable results of using scripts? (Choose three.)",
    "choice_a": "Unintentionally introducing malware",
    "choice_b": "Installing applications and updates",
    "choice_c": "Inadvertently changing system settings",
    "choice_d": "Crashing browsers or systems",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Occasionally scripts have unintended results when they run. They can include, but are not limited to, unintentionally introducing malware, inadvertently changing system settings, or causing browser or system crashes because they are using too many resources. These occasional mistakes are far outweighed by their uses, such as remotely installing applications, installing updates, automating backups, and restarting machines, just to name a few.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      238,
      236,
      237,
      233,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1228,
    "question": "You need to remotely configure, monitor, and manage several servers on your own network. Which of the following are tools that will help you manage your company\u2019s endpoints? (Choose three.)",
    "choice_a": "WinRM",
    "choice_b": "RDP",
    "choice_c": "SSH",
    "choice_d": "RMM",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Windows Remote Management (WinRM) enables a network administrator to manage remote systems over port 5985, using hypertext Transfer Protocol (HTTP), or port 5986, using Hypertext Transfer Protocol Secure (HTTPS). They can configure, manage, and gather management information using WinRM. Remote Desktop, which uses the Remote Desktop Protocol (RDP), is used to control a remote computer as if you were sitting at it. It can be used on the same network or over the Internet. Secure Shell (SSH) is both a protocol and suite of tools for an administrator for the secure remote management of networked resources. Remote monitoring and management (RMM) is a category of software used by managed service providers to remotely manage, configure, and control the resources of many different networks.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      239,
      241,
      244,
      242,
      245
    ],
    "source": "9781394330348"
  },
  {
    "id": 1229,
    "question": "You\u2019re considering whether to use public or private AI. Which of the following is not an advantage of private AI?",
    "choice_a": "Keeping data secure",
    "choice_b": "Lower costs, greater speed",
    "choice_c": "Choosing the data source(s)",
    "choice_d": "Maintaining the privacy of confidential data",
    "correct_answer": "B",
    "explanation": "Creating a private artificial intelligence (AI) system instead of publicly available AI will likely cost a company more, in terms of time and cost to implement. The advantages to developing a private AI are all related to the data. A private AI system lets you choose what data will be included, control the data\u2019s security, and choose who has access to the data, keeping the data private rather than publicly available. This may even include maintaining regulatory compliance when the information includes personally identifiable information (PII) or medical information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      252,
      251,
      275,
      254,
      277
    ],
    "source": "9781394330348"
  },
  {
    "id": 1230,
    "question": "Which of the following would not be a possible consequence of the failure to maintain compliance with government regulations?",
    "choice_a": "Fines and fees",
    "choice_b": "Business shutdown",
    "choice_c": "Extra paid holidays",
    "choice_d": "Lives lost",
    "correct_answer": "C",
    "explanation": "If you fail to comply with government regulations, there are usually severe consequences. Not only fines and fees, business shutdown, or possible jail time, but if a failure to comply with rules meant that someone\u2019s health data was hacked, for example, the cost could be measured in lives lost.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      277,
      275,
      273,
      288,
      270
    ],
    "source": "9781394330348"
  },
  {
    "id": 1231,
    "question": "Which of the following is not an example of regulated data?",
    "choice_a": "Credit card payment information",
    "choice_b": "Software licensing data for software that you use",
    "choice_c": "Healthcare data",
    "choice_d": "PII",
    "correct_answer": "B",
    "explanation": "While it is important to maintain records of your software licenses, the way that licensing data set is stored, moved, and used is not regulated. Credit card payment information, healthcare data, and personally identifiable information (PII) all have industry and/or governmental rules about what happens to that data. Said data is worth far more than the hardware that it resides on, so ensuring the confidentiality, integrity, and availability (CIA) of that information is a primary concern of any IT department. Often regulated data will be concerned with not only how it is used, but also how it is stored (data-at-rest), and how long it is stored, how it is moved (data-in-transit) and how it is protected.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      275,
      277,
      312,
      274,
      286
    ],
    "source": "9781394330348"
  },
  {
    "id": 1232,
    "question": "Which of these third-party tools allows multiple users in diverse locations to see one another, possibly share a screen, and discuss information with one another as if they were in the same room?",
    "choice_a": "Screen-sharing software",
    "choice_b": "File transfer software",
    "choice_c": "Desktop management software",
    "choice_d": "Videoconferencing software",
    "correct_answer": "D",
    "explanation": "Videoconferencing software has been around for a long time. It enables people who might be on the other side of the world to take part in the same meeting, seeing the other attendees and participating in discussions. Some types of videoconferencing software allow screen sharing as well. Screen-sharing software enables you to show others a window, your entire desktop, or a section of it (such as an application window). File transfer software enables the secure and quick transfer of large files from one system to another remote system. Desktop management software is any software that allows you to manage multiple desktops remotely, often on different platforms.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      243,
      244,
      242,
      245,
      239
    ],
    "source": "9781394330348"
  },
  {
    "id": 1233,
    "question": "Which of the following file extensions is used by software in the Linux/UNIX environment?",
    "choice_a": "<code>.sh</code>",
    "choice_b": "<code>.py</code>",
    "choice_c": "<code>.vbs</code>",
    "choice_d": "<code>.ps1</code>",
    "correct_answer": "A",
    "explanation": "A filename with an <code>.sh</code> extension indicates that this is a script for Bash, which stands for Bourne-Again Shell. The other file extensions\u2014.<code>py</code>,<code>.vbs</code>, and <code>.ps1</code>\u2014are used in Python, Visual Basic, and PowerShell, respectively.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      237,
      238,
      235,
      255,
      274
    ],
    "source": "9781394330348"
  },
  {
    "id": 1234,
    "question": "Which of the following is not a type of information recorded in a ticketing system that must have very clear, concise, written communication?",
    "choice_a": "Issue descriptions",
    "choice_b": "Progress notes",
    "choice_c": "Valid licenses",
    "choice_d": "Issue resolution",
    "correct_answer": "C",
    "explanation": "Tracking valid licenses is a part of asset management, not a ticketing system. It is very important that the issue\u2019s description, progress notes, and resolution be written in clear concise language so that anyone who reads them in the future will be able to understand what transpired.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      281,
      280,
      282,
      283,
      292
    ],
    "source": "9781394330348"
  },
  {
    "id": 1235,
    "question": "What is used to initiate the change management process?",
    "choice_a": "Affected systems/impact form",
    "choice_b": "Request form",
    "choice_c": "Risk analysis documentation",
    "choice_d": "Change board approval",
    "correct_answer": "B",
    "explanation": "A request form is used to initiate the change management process. Risk analysis and a report of the affected systems and the impact on them is part of the document that is presented to the change board for their approval before the change can be implemented.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      291,
      288,
      292,
      294,
      295
    ],
    "source": "9781394330348"
  },
  {
    "id": 1236,
    "question": "Which of the following would not be included in change management documentation?",
    "choice_a": "End-user acceptance",
    "choice_b": "Responsible staff member",
    "choice_c": "Affected systems and the impact on them",
    "choice_d": "Scope of the change",
    "correct_answer": "A",
    "explanation": "End-user acceptance is a desirable result of meeting with and including end-users in the decision-making process of change management. It is a desired result, not necessarily a part of the documentation. The responsible staff member(s) needs to be listed in the documentation, along with a person who will be a champion for the project, meaning someone in a position of power who supports the change and who may or may not be listed as a responsible party. A careful analysis of the affected systems and the impact the change will have on them must be included. The change document also must include the scope of the change, which is an explanation of what will and will not be changed and how far-reaching the project is.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      288,
      291,
      292,
      295,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1237,
    "question": "What type of software includes programs like batch files, Visual Basic, PowerShell, and so on and is used for activities like basic automation, remapping network drives, automating backups, gathering information/data, and restarting machines based on triggers?",
    "choice_a": "RMM",
    "choice_b": "Screen-sharing software",
    "choice_c": "Scripting programs",
    "choice_d": "Remote access technologies",
    "correct_answer": "C",
    "explanation": "Batch files, Visual Basic, and PowerShell are all examples of scripting programs. They have many uses and are used daily by network administrators to facilitate network management. Remote monitoring and management (RMM) is a type of remote access technology. Screen-sharing software lets the user show their screen to people who are working with them remotely. Remote access technologies is a general term that encompasses any software that enables someone to access a computer system located in another place.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      238,
      236,
      242,
      233,
      244
    ],
    "source": "9781394330348"
  },
  {
    "id": 1238,
    "question": "You are newly hired at a company\u2019s Help Desk. Which one of the following is a type of information that does not need to be included on every ticket in a Help Desk\u2019s ticketing system?",
    "choice_a": "Category of the issue",
    "choice_b": "Severity of the issue",
    "choice_c": "Escalation levels",
    "choice_d": "Procurement lifecycle",
    "correct_answer": "D",
    "explanation": "Every ticket in a Help Desk ticketing system should include the category of the issue, its severity, and any escalation levels that were used. The procurement lifecycle is a part of asset management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      280,
      281,
      283,
      285,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1239,
    "question": "Which process is designed to enable changes that benefit an organization with as little disruption as possible to the IT services, to maintain the efficient function of that organization?",
    "choice_a": "Asset management",
    "choice_b": "Change management",
    "choice_c": "Ticketing systems",
    "choice_d": "Knowledgebases and articles",
    "correct_answer": "B",
    "explanation": "The aim of change management is to control change in such a way that it continues to move the organization forward with as little disruption as possible to the employees and IT processes of the organization\u2014to affect change without causing any adverse results or negative effects to the company\u2019s bottom line. Asset management is maintaining documentation on a company\u2019s IT assets. Ticketing systems allow for tracking of support issues and results, and knowledgebases and articles provide a wealth of information for resolving IT problems that have been previously encountered.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      288,
      292,
      291,
      294,
      295
    ],
    "source": "9781394330348"
  },
  {
    "id": 1240,
    "question": "What part of asset management includes processes such as a request for information (RFI), a request for proposal (RFP), and identifying the business need?",
    "choice_a": "Configuration Management Database (CMDB)",
    "choice_b": "Assigned users",
    "choice_c": "Procurement lifecycle",
    "choice_d": "Warranty and licensing",
    "correct_answer": "C",
    "explanation": "A configuration management database (CMDB) system, assigned users, and warranty and licensing, are all a part of asset management records. The procurement lifecycle is also a part of asset management, and it starts with identifying a business need for what is being purchased. The exact steps might vary by company and be different for government entities, but they often include vendor analysis, request for information (RFI), request for proposal (RFP), and request for quote (RFQ) before a decision is made regarding what vendor to use and what specific products to purchase.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      284,
      283,
      291,
      292,
      294
    ],
    "source": "9781394330348"
  },
  {
    "id": 1241,
    "question": "What feature of change management examines all the possible positive and negative events that might impact a project and then identifies a response plan if the event occurs and assigns a score to the possible event?",
    "choice_a": "Scope of the change",
    "choice_b": "Change board approval",
    "choice_c": "Risk analysis and risk level",
    "choice_d": "Sandbox testing",
    "correct_answer": "C",
    "explanation": "A part of every project should be a risk analysis with an identified risk level for each possible negative (or positive) event that might affect the project. The risk is assigned a score, known as the risk level, and response plans are identified so that in the event that the risk is realized, there is a clear plan of action on how to handle it. The scope of the change identifies what it will and will not affect. A change board approval is the last step before a kickoff meeting to initiate the change. Sandbox testing is setting up a system that mimics the production system in order to try the change in a safe environment before implementing it.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      294,
      292,
      295,
      291,
      293
    ],
    "source": "9781394330348"
  },
  {
    "id": 1242,
    "question": "Part of your job is managing IT for new hires and terminations. What items can be used to facilitate the onboarding and offboarding of employees to ensure that new employees have everything they need to do their job and that exiting employees aren\u2019t able to damage systems or take company information with them? (Choose two.)",
    "choice_a": "Incident report",
    "choice_b": "New user onboarding setup checklist",
    "choice_c": "User offboarding checklist",
    "choice_d": "Splash screens",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "It\u2019s easiest to onboard and offboard employees if you have a checklist to follow. The checklist can include items such as adding the employee to security groups based on their department or job title and ensuring that their user account is disabled when they leave. An incident report should be filed whenever an IT employee observes a breach of protocol regarding acceptable use, or whenever someone is injured. Splash screens are a way to ensure nonrepudiation (i.e., the idea that someone cannot deny the authenticity of a message or signature) of agreement to company policies each time a user logs on to a company computer system.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      287,
      276,
      285,
      283,
      280
    ],
    "source": "9781394330348"
  },
  {
    "id": 1243,
    "question": "When you are working at a client\u2019s site, which of the following are examples of distractions that should be avoided? (Choose three.)",
    "choice_a": "Taking personal calls",
    "choice_b": "Actively listening to the customer",
    "choice_c": "Texting your coworker for \u201cjust a minute\u201d",
    "choice_d": "Telling the client about the last customer",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Avoid distraction and/or interruptions when talking with customers. You need to make them feel that their problem is important and that it has your full attention. Distractions can include personal calls, texting, social media, talking to coworkers, and other personal interruptions. Listening, taking notes, and asking appropriate questions are all part of good customer service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      313,
      304,
      311,
      308,
      310
    ],
    "source": "9781394330348"
  },
  {
    "id": 1244,
    "question": "You want to ensure that employees aren\u2019t installing whatever software packages they want to because of licensing concerns and possible impacts to the company\u2019s network. What document will you use to identify and explain what the procedures are for custom installation of software packages?",
    "choice_a": "End-user termination checklist",
    "choice_b": "New-user onboarding checklist",
    "choice_c": "CMDB",
    "choice_d": "SOP",
    "correct_answer": "D",
    "explanation": "Procedures for custom installation of software packages should be spelled out in a standard operating procedures (SOP) document. This should also be a part of an acceptable use policy (AUP). The checklists for new-user onboarding and user offboarding will help ensure that all necessary steps take place, and a configuration management database (CMDB) provides a record of how devices are configured and relate to each other and is used in proving compliance and making management decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      286,
      276,
      274,
      283,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1245,
    "question": "Which of the following is not important to keep track of as part of your inventory management system, and to ensure compliance with local, regional, national, or perhaps international regulations?",
    "choice_a": "Valid licenses in use by your company",
    "choice_b": "Perpetual license agreements",
    "choice_c": "Technical jargon used by your company",
    "choice_d": "Open-source licenses being used by your company",
    "correct_answer": "C",
    "explanation": "Keeping track of technical jargon used by your company is not a part of inventory management or compliance, and most likely not done. Valid licenses are those that are not void for any reason, such as using a personal license for corporate use, having more users than are allowed by the license, or using a software with a license that has expired. Software licensing can be so complicated that there are companies who make their living ensuring that other companies are compliant with licensing agreements. Even open-source licenses that are used by a company should be documented, and a periodic accounting of all software on all computers should be performed to ensure that the company is compliant with licensing laws and agreements. Inventorying the software used by your company is just as important as keeping an inventory of the hardware.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      283,
      275,
      277,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1246,
    "question": "Which of the following would not constitute an invalid, and quite possibly illegal, use of software?",
    "choice_a": "Using a personal license in a corporate setting",
    "choice_b": "Having more software users than the license allows",
    "choice_c": "Using software whose license has expired",
    "choice_d": "Modifying open-source software",
    "correct_answer": "D",
    "explanation": "One of the great features of open-source software is that you are allowed to modify the software code to meet your needs. The other three options for this question\u2014using software licensed for personal use in a corporate setting, using more copies or having more users than the license allows, and using software whose license has expired\u2014are all invalid uses of software and may subject you or your company to fines or even jail time. It\u2019s very important to keep an inventory of your software and valid nonexpired licenses and where they are being used. You should do at least an annual accounting of all the software being used on all the computers in your organization.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      274,
      276,
      283,
      284,
      291
    ],
    "source": "9781394330348"
  },
  {
    "id": 1247,
    "question": "You found that someone left the company with confidential information. What document will you file as a part of the SOP?",
    "choice_a": "Incident report",
    "choice_b": "New user onboarding setup checklist",
    "choice_c": "User offboarding checklist",
    "choice_d": "Splash screens",
    "correct_answer": "A",
    "explanation": "An incident report should be filed whenever an IT employee observes a breach of protocol regarding acceptable use, or when someone is injured and should be a part of the organization\u2019s standard operating procedures (SOPs). It\u2019s easiest to onboard and offboard employees if you have a checklist to follow. The checklist can include items such as adding the employee to security groups based on their department or job title and ensuring that their user account is disabled when they leave. Splash screens are a way to ensure nonrepudiation of agreement to company policies each time a user logs on to a company computer system.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      285,
      287,
      273,
      286,
      271
    ],
    "source": "9781394330348"
  },
  {
    "id": 1248,
    "question": "You are updating the list of procedures that will be followed for various situations such as security incidents and new hires. What is the document that you\u2019re updating?",
    "choice_a": "CMDB",
    "choice_b": "ITAM",
    "choice_c": "SOP",
    "choice_d": "KB",
    "correct_answer": "C",
    "explanation": "A standard operating procedure (SOP) defines what actions will be taken when various incidents occur such as a security incident, new hires, and procuring equipment. A configuration management database (CMDB) keeps track of how devices and user accounts are configured, can serve as a part of proving compliance, and can be used as a tool in managing computer purchases and such. IT asset management (ITAM) is the process of keeping track of assets, such as tagging them and keeping inventory and where each asset is located. A knowledgebase (KB) is a repository of known issues with equipment or software and how to resolve them.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      286,
      287,
      285,
      288,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1249,
    "question": "The computer that manages the timing of the conveyor belt in the packaging department has failed and requires replacement as soon as possible because it\u2019s affecting production. It hasn\u2019t happened before and wasn\u2019t expected. What type of change is this?",
    "choice_a": "Normal",
    "choice_b": "Incremental",
    "choice_c": "Emergency",
    "choice_d": "Standard",
    "correct_answer": "C",
    "explanation": "This is an emergency change and will go straight to the change approval board (CAB) because it needs to be fixed now and waiting negatively impacts the organization. A standard change is something that happens frequently and can be planned for. Companies can create a list of preapproved/predefined changes that are considered standard, like replacing pickup rollers in a printer. A normal change is one that goes through the entire change process. It isn\u2019t standard, but it\u2019s also not an emergency. It may be a suggestion to streamline processes. An incremental change is not a term used in change management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      295,
      291,
      289,
      294
    ],
    "source": "9781394330348"
  },
  {
    "id": 1250,
    "question": "You\u2019re the manager of an IT department. You\u2019ve created a step-by-step plan that your department can follow to recover from either a planned change that has failed, or something unexpected that has caused a problem with your computer systems, network, or data. What type of plan have you created?",
    "choice_a": "Contingency",
    "choice_b": "Backup/backout",
    "choice_c": "Emergency",
    "choice_d": "Standard",
    "correct_answer": "B",
    "explanation": "The plan described is a backout plan, which is listed as a backup plan in the CompTIA objectives. A backout plan is a step-by-step list for IT departments to follow, so they can restore a system to the state it was in before a change, whether planned or unplanned, occurred. While rollback and backout plans are similar, the difference is that a rollback is considered, planned, and tested ahead of time for a specific planned change, while a backup/backout plan can encompass a rollback plan but also has steps to recover from unexpected issues/changes.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      289,
      295,
      290,
      292,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1251,
    "question": "Your office uses five HP LaserJet printers. An administrator has placed used toner cartridges in boxes and stacked them in the storage room. Which of the following statements is true regarding toner cartridge disposal?",
    "choice_a": "Toner is not harmful, but because the cartridges contain plastic, they should be recycled.",
    "choice_b": "Toner is not harmful, and the cartridges are made of biodegradable plastic, so they can be thrown away.",
    "choice_c": "Toner will make a mess if it gets out of the cartridge, so to avoid making a mess, cartridges should be burned.",
    "choice_d": "Toner is a carcinogen, so cartridges should be taken to an authorized recycling center.",
    "correct_answer": "D",
    "explanation": "The toner itself is a carcinogen, and toner cartridges can contain heavy metals that are bad for the environment. PC recycling centers will take old toner cartridges and properly dispose of them. Most toner cartridge manufacturers will also take them back for recycling.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      269,
      261,
      266,
      267,
      262
    ],
    "source": "9781394330348"
  },
  {
    "id": 1252,
    "question": "You\u2019re excited because the change that you recommended has gone through the change approval process and is about to start. What type of change is this?",
    "choice_a": "Normal",
    "choice_b": "Incremental",
    "choice_c": "Emergency",
    "choice_d": "Standard",
    "correct_answer": "A",
    "explanation": "This is a normal change. A normal change is one that goes through the entire change process. It isn\u2019t standard, but it\u2019s also not an emergency. It may be a suggestion to streamline processes. Incremental change is not the type of change used in change management; it is a type of backup. An emergency change will go straight to the change approval board (CAB) because it needs to be fixed now, and waiting negatively impacts the organization. A standard change is something that happens frequently and can be planned for. Companies can create a list of preapproved/predefined changes that are considered standard, like replacing pickup rollers in a printer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      295,
      291,
      292,
      294
    ],
    "source": "9781394330348"
  },
  {
    "id": 1253,
    "question": "You\u2019re working on creating a change management document for a proposed project. Which of the following will you include? (Choose two.)",
    "choice_a": "Date and time of change",
    "choice_b": "Incremental change",
    "choice_c": "Backstage testing",
    "choice_d": "Peer review",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Parts of a typical change management plan include a rollback plan, which is part of a backout/backup plan, sandbox testing, responsible staff member, request forms, purpose of the change, scope of the change, data and time of the change, affected systems/impact, risk analysis, peer review, implementation schedule, and change board approval. Incremental change isn\u2019t a type of change management and neither is backstage testing. Hopefully when all is said and done, your change will have end-user acceptance.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      292,
      291,
      289,
      294,
      295
    ],
    "source": "9781394330348"
  },
  {
    "id": 1254,
    "question": "The change that you proposed has gone through all of the parts of the change management approval process. Now you\u2019re ready to begin making the change happen. What stage have you reached?",
    "choice_a": "Risk analysis",
    "choice_b": "Implementation",
    "choice_c": "Sandbox testing",
    "choice_d": "Peer review",
    "correct_answer": "B",
    "explanation": "Parts of a typical change management plan include a rollback plan, which is part of a backout/backup plan, sandbox testing, responsible staff member, request forms, purpose of the change, scope of the change, data and time of the change, affected systems/impact, risk analysis, peer review, implementation schedule, and change board approval. Incremental change isn\u2019t a type of change management and neither is backstage testing. Hopefully when all is said and done, your change will have end-user acceptance.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      295,
      289,
      290,
      294,
      291
    ],
    "source": "9781394330348"
  },
  {
    "id": 1255,
    "question": "You\u2019ve implemented a change, and it\u2019s being tested by several people who will actually be using the new process. Getting their feedback and approval is critical to the project\u2019s success and needed before the system goes live across all your company locations. What stage have you reached?",
    "choice_a": "Risk analysis",
    "choice_b": "Peer review",
    "choice_c": "Sandbox testing",
    "choice_d": "End-user acceptance",
    "correct_answer": "D",
    "explanation": "End-user acceptance is when people who will actually be using the changed systems give their stamp of approval. Usually, a small implementation of a change is used to test the change among users. Getting end-user acceptance of a change is critical to ensure that the change will be followed and work as expected. Risk analysis lists all the issues, good or bad, that could occur during a change and assigns a risk level for each and a contingency plan for the risks that need them. Peer review happens early in a plan when the change is examined by another technical person at the same level, to ensure that the plan will meet the established goals and is in alignment with company goals, as well as whether the plan will work. Sandbox testing is creating a mockup of the system changes in an isolated setting and testing them before the changes go live to ensure that they will work as expected.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      296,
      294,
      290,
      295,
      292
    ],
    "source": "9781394330348"
  },
  {
    "id": 1256,
    "question": "Your company shuts down two weeks a year to perform a deep cleaning of its cheese-processing equipment. You\u2019ll be updating systems and performing standard changes during this time. What is this period of time known as?",
    "choice_a": "Risk analysis",
    "choice_b": "Maintenance window",
    "choice_c": "Sandbox testing",
    "choice_d": "Peer review",
    "correct_answer": "B",
    "explanation": "A maintenance window is a scheduled time when changes can be made to a system, without affecting the system\u2019s users. Often for standard changes, this is during the evening or weekend hours. Risk analysis lists all the issues, good or bad, that could occur during a change and assigns a risk level for each and a contingency plan for the risks that need them. Sandbox testing is creating a mockup of the system changes in an isolated setting and then testing them before the changes go live, to ensure that they will work as expected. Peer review happens early in a plan, when the change is examined by another technical person at the same level, to ensure that the plan will meet the established goals and is in alignment with company goals as well as whether the plan will work.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      293,
      291,
      295,
      292,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1257,
    "question": "One of your servers had an issue, and several files need to be restored so they can be used. You\u2019ve decided to put them on a different volume so you still have the original files to analyze what went wrong. What type of restore from backup are you performing?",
    "choice_a": "Incremental",
    "choice_b": "In-place/overwrite",
    "choice_c": "Alternative location",
    "choice_d": "Differential",
    "correct_answer": "C",
    "explanation": "When you\u2019re restoring files from a backup to a place that they didn\u2019t come from, this is restoring them to an alternative location. The other type of restore from a backup is an in-place/overwrite location, which means that you\u2019re placing the files back where they originally were. Incremental and differential are types of backups, not restores.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      302,
      301,
      298,
      303,
      299
    ],
    "source": "9781394330348"
  },
  {
    "id": 1258,
    "question": "You\u2019re working on a computer and need to plug a second monitor into the computer. There are no power outlets at the desk, but there is one just on the other side of the aisle. Which of the following is appropriate and safe cable management? (Choose two.)",
    "choice_a": "Run the cable across the floor\u2014it\u2019s only for a minute.",
    "choice_b": "Run the cable across the top of the cubicle dividers, across the walkway. It\u2019s about five feet high. People can duck under it if they need to.",
    "choice_c": "Plug in a power strip where you\u2019re working, and plug both monitors into it.",
    "choice_d": "Run an extension cord across the floor, but cover it with a pedestrian cable cover.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Working safely should always be your priority. Using an approved power strip to temporarily add an outlet to an area is the best of the options given, but you could also run an extension cord across the floor if it\u2019s covered with a pedestrian cable cover designed to prevent people from tripping on the wire. This is good cable management. Cables should never be run across a walkway, even for a minute. That presents a tripping hazard. Likewise, they should never be run through the air where someone walking through could run into them and get hurt.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      278,
      264,
      263,
      307,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1259,
    "question": "You\u2019ve discovered inappropriate content on a computer system. You leave it powered on to preserve data. According to the order of volatility, which of these should you preserve first?",
    "choice_a": "Data in the CPU and cache",
    "choice_b": "Data in memory",
    "choice_c": "Data on a hard drive",
    "choice_d": "Notes you\u2019ve taken on the incident",
    "correct_answer": "A",
    "explanation": "Although you want to move the computer to a secure place, it\u2019s important not to turn it off until evidence has been gathered from it, because some of that information will disappear as soon as the computer is turned off. (It\u2019s volatile.) Always gather evidence from most volatile to least. Following is the order of volatility, from most to least.<ol><li>Cache, Central Processing Unit (CPU) registers</li><li>Routing and process tables, Address Resolution Protocol (ARP) cache, and kernel statistics</li><li>Random access memory (RAM)</li><li>Swap file or other temporary file systems</li><li>Storage drives (i.e., Hard Disk Drives (HDD), Solid-State Drives (SSDs), M.2 drives, flash drives, and so on</li><li>Remote data such as logging and monitoring systems</li><li>Archival media (such as backup drives and tapes), physical configuration and network topology information, and your notes on the incident.</li></ol>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      270,
      289,
      303
    ],
    "source": "9781394330348"
  },
  {
    "id": 1260,
    "question": "Your company just finished negotiations with another company, and the companies want a legally binding contract stating that confidential, proprietary information about each other will not be disclosed. What type of document will they be signing?",
    "choice_a": "AUP",
    "choice_b": "NDA",
    "choice_c": "MNDA",
    "choice_d": "BYOD",
    "correct_answer": "C",
    "explanation": "A mutual non-disclosure agreement (MNDA) is used when both parties want legally protect their confidential or proprietary information from being shared by the other party. An acceptable use policy (AUP) states what you may and may not do with company equipment. A non-disclosure agreement (NDA) is a signed document stating what you may not reveal about your partner companies and their business dealings. A bring your own device (BYOD) policy states whether you may use your personal device for business purposes and under what conditions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      276,
      287,
      312,
      270,
      254
    ],
    "source": "9781394330348"
  },
  {
    "id": 1261,
    "question": "You\u2019re troubleshooting an issue at an end-user's computer. What is one of the best ways to find out what the problem is?",
    "choice_a": "Ask close-ended (yes/no) questions.",
    "choice_b": "Don\u2019t ask questions; examine the computer.",
    "choice_c": "Ask open-ended questions.",
    "choice_d": "Ask what they think is wrong.",
    "correct_answer": "C",
    "explanation": "Open-ended questions are those that allow the end-user to explain what\u2019s happening, and they\u2019re a great way to determine the next question to ask, or where to start looking for the offending issue. Close-ended questions require yes or no answers and are helpful in certain situations, after you\u2019ve let the user explain the issue. Going directly to the computer without asking the user anything is not only rude, but not the most productive way to solve a problem. Even if the user caused the problem, they probably don\u2019t know how or they might have been able to fix it without calling you.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      306,
      280,
      307,
      282,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1262,
    "question": "You\u2019re looking at a program that\u2019s causing an issue. You\u2019ve noticed that the file extension is <code>.py</code>. What program was this written in?",
    "choice_a": "Batch Scripting",
    "choice_b": "Python",
    "choice_c": "JavaScript",
    "choice_d": "Shell",
    "correct_answer": "B",
    "explanation": "Python uses a <code>.py</code> extension. Batch scripting, which uses the filename extension <code>.bat</code>, is typically a series of command-line commands. Such a script file would run on the Windows systems\u2019 command line. JavaScript uses a <code>.js</code> file extension, and Shell uses a <code>.sh</code> extension.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      237,
      236,
      234,
      235,
      238
    ],
    "source": "9781394330348"
  },
  {
    "id": 1263,
    "question": "You\u2019re looking for an open-source solution for remotely accessing computers on your LAN. Which of the following options is designed to meet your goal?",
    "choice_a": "JavaScript",
    "choice_b": "Linux",
    "choice_c": "macOS",
    "choice_d": "SPICE",
    "correct_answer": "D",
    "explanation": "Simple Protocol for Independent Computing Environments (SPICE) is open-source and free, designed specifically for remote access on a local area network (LAN) or wide area network (WAN). JavaScript is a programming language. Linux is the basis for many open-source operating systems (OSs), and macOS is a commercial OS that is most definitely not open-source.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      244,
      239,
      241,
      243,
      245
    ],
    "source": "9781394330348"
  },
  {
    "id": 1264,
    "question": "You\u2019re considering what to use for remote access. What are the biggest security concerns with methods like RDP, VNC, RMM, WinRM, and VPNs? (Choose two.)",
    "choice_a": "Misconfiguration",
    "choice_b": "Inadequate passwords/authentication",
    "choice_c": "Open-source",
    "choice_d": "Open ports",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The most common problems that come up when researching the Remote Desktop Protocol (RDP), virtual network computing (VNC), remote monitoring and management (RMM), Windows Remote Management (WinRM), and virtual private networks (VPNs) are misconfiguration and inadequate passwords. Requiring multifactor authentication (MFA) and enforcing strong passwords can help, along with role-based access control (RBAC), monitoring logs, and encrypting data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      245,
      239,
      244,
      242,
      240
    ],
    "source": "9781394330348"
  },
  {
    "id": 1265,
    "question": "Which remote access method requires opening port 5900 for HTTP and adds a display number, which makes securing it with a firewall more difficult, and is vulnerable because by default, remote traffic is not encrypted?",
    "choice_a": "RDP",
    "choice_b": "VNC",
    "choice_c": "SSH",
    "choice_d": "RMM",
    "correct_answer": "B",
    "explanation": "The virtual network computing (VNC) method of remote access uses port 5900 and a display number, which makes it difficult to secure with firewalls that only allow a port number. The Remote Desktop Protocol (RDP) has been compromised with dynamic link library (DLL) hijacking, and Secure Shell (SSH) and remote monitoring and management (RMM) are vulnerable when they are not patched and updated, or due to human errors like misconfiguration and inadequate passwords.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      244,
      245,
      239,
      241,
      242
    ],
    "source": "9781394330348"
  },
  {
    "id": 1266,
    "question": "When dealing with a customer, which of the following demonstrates the communication technique for using proper language?",
    "choice_a": "Use computer jargon.",
    "choice_b": "Use acronyms.",
    "choice_c": "Use slang terms.",
    "choice_d": "Use basic terms.",
    "correct_answer": "D",
    "explanation": "When talking with customers, it\u2019s important to remember that they don\u2019t have the training that you do, so they won\u2019t understand all the terminology that technicians use. Describe the situation in terms that the user will understand, but don\u2019t be condescending. Never use jargon, acronyms, or slang terms, even if they are commonly used with your peers. It takes practice to put complex concepts in simple terms, but your customers will appreciate it. More tech-savvy customers will usually let you know that they understand and you can use more advanced terms with them as needed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      304,
      311,
      308,
      307,
      313
    ],
    "source": "9781394330348"
  },
  {
    "id": 1267,
    "question": "You have an application, and you would like to add AI to enhance it. What is this process called?",
    "choice_a": "Application integration",
    "choice_b": "Artificial integration",
    "choice_c": "Updating",
    "choice_d": "Facilitating",
    "correct_answer": "A",
    "explanation": "Application integration occurs when artificial intelligence (AI) capabilities are added to an existing application. The other three terms are not related.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      254,
      252,
      253,
      251,
      249
    ],
    "source": "9781394330348"
  },
  {
    "id": 1268,
    "question": "Which of the following are limitations of using AI in a business setting? (Choose three.)",
    "choice_a": "Bias",
    "choice_b": "Hallucinations",
    "choice_c": "Manifestations",
    "choice_d": "Accuracy",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Common limitations of artificial intelligence (AI) are bias, hallucinations, and accuracy. Manifestations is not a limitation of AI. Bias can occur due to the data that is used to train an AI system or poor programming. Once learned, a bias can be exacerbated by an AI system. Hallucinations are when AI output seems factual, but in fact, is not. They can be caused by limited or outdated data sets or programming error, which causes an AI system to interpret (i.e., put together) information inaccurately, providing an incorrect output. Accuracy is one of several metrics used to determine an AI system\u2019s performance. It\u2019s a measure of how often the AI returns correct answers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      253,
      251,
      246,
      250,
      254
    ],
    "source": "9781394330348"
  },
  {
    "id": 1269,
    "question": "You\u2019re setting up a CMDB. Which of the following will you include? (Choose three.)",
    "choice_a": "Router configuration information",
    "choice_b": "Networks and interrelationships",
    "choice_c": "Knowledgebase",
    "choice_d": "Warranty and licensing",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "A configuration management database (CMDB) system stores information about the relationships between key components of an IT infrastructure and how they are configured. This can include router configuration information, networks and interrelationships, and warranty and licensing information. It can even include people. It is not asset management, which is more concerned with acquiring, monitoring, and disposing of assets. The size of the database depends on the size of the company and what the company determines should be included. In general, it helps to track compliance and make management decisions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      288,
      291,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1270,
    "question": "You\u2019re using AI while working on a research paper for your job. Which of the following constitutes plagiarism? (Choose two.)",
    "choice_a": "Using AI to check grammar on something you\u2019ve written",
    "choice_b": "Using AI to find information online",
    "choice_c": "Using an AI rephrasing tool",
    "choice_d": "Asking AI for information and posting the output as your own",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Plagiarism occurs when you take credit for someone else\u2019s work. This is true even if the \u201csomeone else\u201d is an artificial intelligence (AI) program. Using an AI rephrasing tool to rephrase what AI or someone else has generated is also plagiarism. There are ways to use AI that are perfectly acceptable, such as using AI to check your grammar or to point you to websites about what you\u2019re looking for. Remember to cite any sources whose ideas you use.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      254,
      253,
      252,
      250,
      247
    ],
    "source": "9781394330348"
  },
  {
    "id": 1271,
    "question": "One of your management employees works from home most days, but they need to have access to the server as if they were sitting there in the office, and the connection must be secure. What technology will you employ to do this?",
    "choice_a": "RMM",
    "choice_b": "VPN",
    "choice_c": "RDP",
    "choice_d": "VNC",
    "correct_answer": "B",
    "explanation": "A virtual private network (VPN) allows a user to be away from their office, such as a remote worker or traveling salesperson, and connect to the company server or other resources with their laptop or other mobile computer as if they were in the company offices. This is accomplished using tunneling protocols. It differs from a virtual network computer (VNC) in that the VNC allows a user to manipulate a computer remotely. Some VNC systems allow a smartphone to control a computer remotely. Remote monitoring and management (RMM) is a category of software used by managed service providers to remotely manage, configure, and control the resources of many different IT networks, and Remote Desktop, which uses the Remote Desktop Protocol (RDP), is a type of VNC that is part of the Windows operating system (OS).",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      240,
      241,
      244,
      245,
      239
    ],
    "source": "9781394330348"
  },
  {
    "id": 1272,
    "question": "Your Windows computer is experiencing frequent shutdowns. It typically runs five minutes and then shuts down. These shutdowns are not scheduled in the OS. What will you do first?",
    "choice_a": "Boot with an anti-malware boot media and check for malware.",
    "choice_b": "Reinstall the OS.",
    "choice_c": "Run SFC.",
    "choice_d": "Check the temperature in the case or on the CPU.",
    "correct_answer": "D",
    "explanation": "The system is most likely overheating. This is a tough question, because there are so many reasons that a computer will shut down on its own. The five-minute interval here is significant. The computer is running long enough to heat up, and when the central processing unit (CPU) gets too hot, it will shut the system down to avoid damage. If it isn\u2019t overheating, your next course of action is to check for malware. System File Checker (SFC) will attempt to fix problems with operating system (OS) files. Reinstalling the OS would be a last resort.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      204,
      205,
      201,
      219,
      212
    ],
    "source": "9781394330348"
  },
  {
    "id": 1273,
    "question": "You are on-site fixing a client\u2019s laptop that will not load the OS. You are waiting to hear about your friends\u2019 awesome party that they are hosting this weekend, and your phone starts to vibrate and keeps vibrating. You\u2019re sure that all your friends are texting information about the party. What should you do? (Choose two.)",
    "choice_a": "Turn your phone off and apologize to the client. Tell them that the phone was distracting you from your job, but it won\u2019t be a problem now.",
    "choice_b": "Ignore your phone.",
    "choice_c": "Text your friends back and tell them that you are working.",
    "choice_d": "Call your friend and tell them to wait until after this job before planning all the details because you want to help.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "When working with customers, it\u2019s important to avoid distractions, such as personal phone calls, texting, or social media sites. Exceptions can be made if it\u2019s an emergency, but in those cases notify the client that you might get a call or text, and explain that you will deal with it only if it\u2019s an emergency. Otherwise, ignore the personal interruption until you are not working with a client.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      313,
      307,
      311,
      312,
      280
    ],
    "source": "9781394330348"
  },
  {
    "id": 1274,
    "question": "You are planning on formatting a hard drive with NTFS that will be used to share files between Windows 10 and Windows 11 Pro computers. Which of the following features are present in NTFS? (Choose two.)",
    "choice_a": "Linux OS support",
    "choice_b": "File and folder encryption",
    "choice_c": "File compression",
    "choice_d": "Enhanced flash drive support",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The New Technology File System (NTFS) is available with all current versions of Windows. NTFS is an advanced filesystem that includes such features as file and folder encryption, compression, and RAID support, as well as support for extremely large file and partition sizes and disk transaction monitoring.",
    "topic_id": 1,
    "practice_test_id": 10,
    "related_articles": [
      39,
      36,
      61,
      41,
      40
    ],
    "source": "9781394330348"
  },
  {
    "id": 1275,
    "question": "You are logged in to a Linux workstation with a regular user account. You need to execute a command with root permissions. Which command do you need to use?",
    "choice_a": "<code>su</code>",
    "choice_b": "<code>sudo</code>",
    "choice_c": "<code>grep</code>",
    "choice_d": "<code>man</code>",
    "correct_answer": "B",
    "explanation": "The <code>sudo</code> (\u201csubstitute user do\u201d or \u201csuperuser do\u201d) command is used to run a command with a different privilege level than the current user logged in. Typically, this means running a command with superuser or <code>root</code> permissions. The <code>su</code> command switches to a different user, again the default is root, but with <code>sudo</code> you need to enter <code>sudo</code> before each command. With <code>su</code>, you don\u2019t. Considering best practices, you would use <code>sudo</code> if you had one command to run, and <code>su</code> if you had several. The <code>grep</code> command is used to search for patterns in a file, so if you can\u2019t remember the filename but know what is in it, you can still find it. The <code>man</code> command brings up a manual\u2014for example, <code>man grep</code> would show you how to use the <code>grep</code> command.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      98,
      100,
      104,
      62
    ],
    "source": "9781394330348"
  },
  {
    "id": 1276,
    "question": "A security consultant recommends that your secure facility implement biometrics as a form of building access control. Which of the following systems might they be referring to?",
    "choice_a": "RFID badges",
    "choice_b": "Key fobs",
    "choice_c": "Palm print scanner",
    "choice_d": "Guards",
    "correct_answer": "C",
    "explanation": "Biometric devices use physical characteristics to identify the user. Biometric systems include fingerprint/palm/hand scanners, retina scanners, and anything else that uses part of your body to identify you. To gain access to resources, you must pass a physical screening process. While it\u2019s true that guards are humans, they are not biometric devices. Radio frequency identification (RFID) badges have information on them that is read by an RFID scanner, and key fobs generate a new code every few seconds to allow access.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      115,
      113,
      120,
      108,
      169
    ],
    "source": "9781394330348"
  },
  {
    "id": 1277,
    "question": "You are looking online to find pictures to use in promotional materials that your company wants to make. Which of the following statements is true regarding online content?",
    "choice_a": "Online content is considered open-source; therefore, you may use whatever you find.",
    "choice_b": "Online content can be protected through the use of DRM.",
    "choice_c": "Online content is protected through the use of the EULA.",
    "choice_d": "Online content is protected through terms established by Microsoft.",
    "correct_answer": "B",
    "explanation": "Many companies rely on digital rights management (DRM) to protect digital assets such as online photos or videos. Unlike an end-user license agreement (EULA), which legally protects software and other objects, DRM physically protects the information by not allowing copies to be made, printing a watermark on the face of an image or document, or incorporating similar measures to prevent the use, modification, and distribution of copyrighted materials. DRM is not as established as licensing agreements are, but you should still respect the property of the owners of digital content.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      312,
      275,
      254,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1278,
    "question": "In which type of security threat will someone try to gain access to a secure area without credentials by following someone else who used their access rights into the secured area?",
    "choice_a": "Brute-force",
    "choice_b": "Shoulder surfing",
    "choice_c": "Evil twin",
    "choice_d": "Tailgating",
    "correct_answer": "D",
    "explanation": "Tailgating refers to being so close to someone when they enter a building that you can enter right behind them, without needing to use a key, card, or any other security device. Using access control vestibules, which are devices like small rooms that limit access to one or a few individuals, is a great way to stop tailgating. A brute-force attack attempts to repeatedly guess a password. Shoulder surfing is just like it sounds\u2014someone is looking over your shoulder to gain passwords and logins, and an evil twin is an unauthorized wireless access point that has the same service set identifier (SSID) as a legitimate one.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      108,
      141,
      145,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 1279,
    "question": "A management directive requires that you keep hard copies of all your workstations\u2019 system configurations. You have all Windows workstations. Which command can you use to easily gather this information for remote workstations and save a report as a text file?",
    "choice_a": "<code>msinfo32</code>",
    "choice_b": "<code>compmgmt</code>",
    "choice_c": "<code>mmc</code>",
    "choice_d": "<code>perfmon</code>",
    "correct_answer": "A",
    "explanation": "The <code>msinfo32</code> tool displays a thorough list of machine settings on the local computer. You cannot change any values from here, but you can search, export, and save reports. When run from a command prompt, the <code>/computer</code> option allows you to specify a remote computer on which to run the utility, and the <code>/report</code> option saves the report as a text file. Another option while in the <code>msinfo32</code> graphical user interface (GUI) is clicking the View menu then Remote Computer to collect information related to the chosen remote PC. The <code>compmgmt</code> command opens the Computer Management console, <code>mmc</code> opens the Microsoft Management Console, and <code>perfmon</code> opens Performance Monitor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      28,
      63,
      30,
      7
    ],
    "source": "9781394330348"
  },
  {
    "id": 1280,
    "question": "You have a situation that requires installing Windows 11 from installation media. You\u2019ll be launching Setup on the media while you are on the existing Windows 10 desktop. Which of the following is not an option?",
    "choice_a": "Full upgrade",
    "choice_b": "Keep data only",
    "choice_c": "Forensic install",
    "choice_d": "Clean install",
    "correct_answer": "C",
    "explanation": "Forensic install is not an option. The easiest way to install Windows 11 on a Windows 10 computer is through Windows Update in the Settings app. If you have a situation where that\u2019s not possible, you can create Windows 11 installation media and use it to install the operating system (OS). When you launch the installation from within Windows 10, you have three options. The first is Full Upgrade, which will keep Windows settings, drivers, personal files, and apps. The second, Keep Data Only, will keep drivers and personal files but no installed apps or Windows Settings. The third option is a Clean Install, which will wipe out everything on the drive and install a fresh copy of Windows 11.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      50,
      45,
      46,
      19,
      55
    ],
    "source": "9781394330348"
  },
  {
    "id": 1281,
    "question": "You are configuring a wireless router for a home office. Which of the following changes will have the least impact on improving the security of the network?",
    "choice_a": "Disabling guest access",
    "choice_b": "Disabling the SSID broadcast",
    "choice_c": "Configuring WPA3",
    "choice_d": "Changing the default username and password",
    "correct_answer": "B",
    "explanation": "Even if you disable the service set identifier (SSID) broadcast, potential attackers still have many simple tools available to see your wireless network traffic and get the SSID anyway. It is a weak form of security that will keep out only the most casual intruders. Disabling guest access limits who can connect to your network, but if you must have guest access, look for a setting that will isolate the guest network from your network. WPA3 is the best commonly available form of encryption for wireless routers. WPA2 is usually available alongside of WPA3 for networks that are transitioning between WPA2 and WPA3. The router may have an option that says WPA2/WPA3 or WPA3 transitional, which will allow newer devices to connect using WPA3 and older devices to connect using WPA2. Changing the wireless router default username and password is always recommended, because those are often easy to find online.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      182,
      180,
      184,
      186,
      157
    ],
    "source": "9781394330348"
  },
  {
    "id": 1282,
    "question": "You are going to move a desktop computer from one office location to another. It\u2019s on the floor, underneath the desk. Which of the following are good personal safety procedures to follow? (Choose two.)",
    "choice_a": "Bend at the waist and lift straight up.",
    "choice_b": "Bend at the knees and lift with your legs.",
    "choice_c": "Tie back any loose jewelry, long hair, or neckties.",
    "choice_d": "Leave the computer plugged in to avoid ESD.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "To ensure your personal safety, always remember some important techniques before moving equipment. The first thing is to always ensure that the equipment is unplugged. There\u2019s nothing worse (and potentially more dangerous) than getting yanked because you\u2019re still tethered to the wall. Remove any loose jewelry and secure long hair or neckties. Lift with your legs, not your back (i.e., bend at your knees when picking something up, not at the waist).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      263,
      256,
      278,
      262,
      268
    ],
    "source": "9781394330348"
  },
  {
    "id": 1283,
    "question": "A user calls the Help Desk saying that they have tried to boot their computer several times but keep receiving \u201cNo OS found\u201d errors. What will you ask them first?",
    "choice_a": "Was it working yesterday?",
    "choice_b": "What did you do to it?",
    "choice_c": "Is there a USB drive in one of the USB ports?",
    "choice_d": "Do you know how to enter UEFI?",
    "correct_answer": "C",
    "explanation": "In troubleshooting, it\u2019s often best to check the simple things first. Ask them if there is a drive in the universal serial bus (USB) port. If the system is set to check there before the hard drive for boot media, then non-bootable media in the port might prevent the system from booting. (Disabling the ability to boot from a USB port is considered a security best practice.) If it wasn\u2019t working yesterday, they likely would have called you yesterday. Never ask an end-user what they did to a system. Even if it is a user error, they probably won\u2019t know they did something wrong, and that question will make them more upset; what you want instead is to make them feel that you\u2019re professional and confident in your ability. An end-user should not be entering the Unified Extensible Firmware Interface (UEFI).",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      202,
      203,
      206,
      212,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1284,
    "question": "Which feature of Windows Pro or higher editions is designed to encrypt storage volumes, must be activated by an administrator, and can encrypt operating system startup files?",
    "choice_a": "BitLocker",
    "choice_b": "EFS",
    "choice_c": "OneDrive",
    "choice_d": "ShadowDrive",
    "correct_answer": "A",
    "explanation": "BitLocker allows the user to use drive encryption to protect files, including those needed for startup and log-on. BitLocker can be turned on or off only by administrators, and it\u2019s enabled by default in Windows 11. It is only available in Pro or higher editions of both Windows 10 and Windows 11. The encrypting file system (EFS) can encrypt data at the volume, file, or folder level but not an entire hard drive. OneDrive is Microsoft\u2019s online cloud storage service, and ShadowDrive is not a valid computer term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      172,
      167,
      170,
      156
    ],
    "source": "9781394330348"
  },
  {
    "id": 1285,
    "question": "Your iPhone has been stolen. To ensure that the thief does not have access to your data, what should you do?",
    "choice_a": "Perform a remote backup.",
    "choice_b": "Enable full-device encryption.",
    "choice_c": "Enable BitLocker.",
    "choice_d": "Perform a remote wipe.",
    "correct_answer": "D",
    "explanation": "The best way to remove data from a device is to perform a remote wipe. Ideally, you have backed up or synced the device before then, or you will lose data. Full-device encryption is a good security practice, but it should have been completed prior to the phone being stolen. BitLocker is a Microsoft Windows feature for full-drive encryption.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      196,
      193,
      232,
      156,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 1286,
    "question": "You have installed a second hard drive in a Windows workstation. In Disk Management, what type of partition can you create that will allow you to create an unlimited number of logical partitions in it?",
    "choice_a": "Extended",
    "choice_b": "Dynamic",
    "choice_c": "Logical",
    "choice_d": "GPT",
    "correct_answer": "D",
    "explanation": "When you create a partition in Windows 10, it will ask if you want to create a master boot record (MBR) or globally unique identifier (GUID) partition table (GPT) partition. GPT is newer and has far more features than MBR. One of those features is that you can create an unlimited number of logical partitions on it. Only the operating system (OS) will limit you; Windows 10 will only allow 128 partitions on one drive. Windows 11 supports only the GPT partition type. In older computer systems, there were primary and extended partitions. There could be a maximum of four partitions, and only one could be extended. Logical drives could be created in an extended partition and were limited to the remaining letters of the alphabet. If there were three primary partitions, they would likely be labeled C, D, and E. An extended partition could hold logical partitions F through Z. Dynamic drives are unique to Windows and support software RAID.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      36,
      46,
      45,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 1287,
    "question": "You have some older drives that you intend to donate to a nonprofit organization. You want to set all data on the drive to be nothing but 0s. What should you use to accomplish this?",
    "choice_a": "Drive-wiping software",
    "choice_b": "<code>format</code> command",
    "choice_c": "Degaussing",
    "choice_d": "Incinerating",
    "correct_answer": "A",
    "explanation": "Removing all data on a drive by repeatedly replacing it with binary bits, 0s or 1s, is commonly done using drive-wiping software. Government or other highly secure environments may have specific rules regarding data destruction. Drive wiping can make the data unrecoverable and make it safe to donate the drives. The <code>format</code> command will erase the file allocation table or master file table, but the files may still be able to be recovered. It is not a secure way to ensure that your data can\u2019t be read. Degaussing and incinerating are ways to physically destroy drives. Degaussing works with only magnetic media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      163,
      162,
      164,
      159,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1288,
    "question": "A small business has two servers in its telecommunications room. The business has come seeking your advice because the area has frequent power outages and the company has lost important data on its servers as a result. What will you recommend for it to protect against this issue?",
    "choice_a": "Surge suppressor.",
    "choice_b": "Power strip.",
    "choice_c": "UPS.",
    "choice_d": "Line conditioner.",
    "correct_answer": "C",
    "explanation": "An uninterruptible power supply (UPS) is designed to provide enough power to keep systems running until they can be safely shut down or switched to another power source. The UPS must provide adequate wattage for the devices connected to it as well as sufficient battery capacity. Most also offer protected and unprotected outlets; surge suppression, which protects against power surges; and line conditioning, which improves the quality of power delivered to the device, such as boosting the power when there is a sag on the input side. Power strips only give you a place to plug devices in and turn them all off at once. A smart UPS can notify an administrator that there is a power outage.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      264,
      265,
      267,
      292,
      280
    ],
    "source": "9781394330348"
  },
  {
    "id": 1289,
    "question": "You are working on a Windows workstation that is operating very slowly. You want to quickly check the system\u2019s CPU and RAM usage to see whether anything appears amiss. Which utilities can you use to do this? (Choose two.)",
    "choice_a": "Resource Monitor",
    "choice_b": "Performance Monitor",
    "choice_c": "System",
    "choice_d": "Device Manager",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "There are three tools in Windows 10 and Windows 11 that quickly show you the central processing unit (CPU) and random access memory (RAM) usage in Windows. They are Resource Monitor, Performance Monitor, and Task Manager. The easiest way to find Resource Monitor (<code>resmon.exe</code>) is to click the search icon on the taskbar and type <b>res</b>, then click on Resource Monitor. Performance Monitor (<code>perfmon.exe</code>) can be accessed through Computer Management. Task Manager (<code>taskmgr.exe</code>) can be opened in several ways, the fastest is by right-clicking the Windows icon on the taskbar and choosing Task Manager. System and Device Manager are accessed in multiple ways but do not provide the information needed.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      43,
      31,
      27,
      28,
      30
    ],
    "source": "9781394330348"
  },
  {
    "id": 1290,
    "question": "As the network administrator, you have set account lockout policies so that an account is locked out after five unsuccessful login attempts. What type of security threat will this deter?",
    "choice_a": "Shoulder surfing",
    "choice_b": "Brute-force attack",
    "choice_c": "Zero-day attack",
    "choice_d": "Spear phishing",
    "correct_answer": "B",
    "explanation": "A brute-force attack is an attempt to guess passwords until a successful guess occurs. Because of the nature of this attack, it usually occurs over a long time period. To make passwords more difficult to guess, <i>longer is better</i>, with eight characters being the minimum that should be required, or 15 for privileged accounts. Limiting the number of unsuccessful login attempts before lockout may also help thwart this type of attack. Password requirements can be set using the Local Group Policy Editor.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      148,
      160,
      157,
      126,
      158
    ],
    "source": "9781394330348"
  },
  {
    "id": 1291,
    "question": "Occasionally when visiting websites using Google Chrome, you receive a pop-up window in front of your browser. Generally, it\u2019s an advertisement trying to sell you something. Which of the following actions will stop this from happening?",
    "choice_a": "Enable Chrome\u2019s pop-up blocker.",
    "choice_b": "Install an antivirus program.",
    "choice_c": "Install an anti-malware program.",
    "choice_d": "Enable Windows Firewall.",
    "correct_answer": "A",
    "explanation": "Pop-ups are annoying but not necessarily an indication that your computer is infected with anything. Enabling Chrome\u2019s pop-up blocker should prevent them. Antivirus and anti-malware programs don\u2019t generally deal with pop-ups unless they\u2019re associated with malware and most aren\u2019t\u2014they are just coded into the website. A firewall won\u2019t help with pop-ups either.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      132,
      135,
      173,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1292,
    "question": "Your company works with confidential government files. It is illegal for employees to copy any files to flash drives. Where do you specify this rule as well as the penalties for not complying with it?",
    "choice_a": "APK",
    "choice_b": "ACL",
    "choice_c": "ADF",
    "choice_d": "AUP",
    "correct_answer": "D",
    "explanation": "Acceptable use policies (AUPs) describe how the employees in an organization can use company systems and resources, both software and hardware. This policy should also outline the consequences for misuse. In addition, the policy should address the installation of personal software on company computers and the use of personal hardware such as USB devices. The AUP is often signed during the employee onboarding process and may be part of an employee handbook but is not required to be. An Android package (APK) is a file for installing an Android app, an access control list (ACL) defines who has what permissions on an object, and an automatic document feeder (ADF) sits atop a copier or multifunction device (MFD) to send a stack of papers through, one at a time without user intervention.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      276,
      287,
      270,
      274,
      285
    ],
    "source": "9781394330348"
  },
  {
    "id": 1293,
    "question": "A Windows computer user reports that their computer just completely locked up. On the screen is a message saying that the person pictured has participated in an illegal activity. The webcam turned on by itself, and the computer user was pictured. The message also says they can resolve the charges against them by paying a $500 fine. They are understandably shaken by the incident. What should you do next?",
    "choice_a": "Tell the user that if they performed an illegal activity with their work computer, their employment will be terminated.",
    "choice_b": "Boot to a bootable media from your anti-malware provider, and run a remediation.",
    "choice_c": "Delete and reinstall Windows.",
    "choice_d": "Pay the fine.",
    "correct_answer": "B",
    "explanation": "This is a form of ransomware, which can be programmed to take control over a user\u2019s webcam. It\u2019s just another layer of complexity to scare users. Deleting and reinstalling Windows will work, but it isn\u2019t necessary. The system will be locked, so you can\u2019t open the anti-malware software. You can, however, boot to a bootable media from the anti-malware software provider and start a remediation that way.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      138,
      134,
      132,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 1294,
    "question": "One of your technicians just touched a plastic bottle containing chemicals with which you are unfamiliar. Their hand starts to feel like it\u2019s burning. Where can you find information on how to properly wash the technician\u2019s hands without making the problem worse, and how to dispose of the chemicals?",
    "choice_a": "OSHA",
    "choice_b": "Container\u2019s bottom",
    "choice_c": "Warning label",
    "choice_d": "MSDS",
    "correct_answer": "D",
    "explanation": "While it\u2019s possible that the disposal information and risks may be on the container somewhere, you will always find it on the product\u2019s material safety data sheet (MSDS). It should be stated that, while CompTIA still refers to these sheets as MSDSs as an exam objective, the name has been changed to safety data sheet (SDS). SDSs include information such as physical product data (i.e., boiling, melting, and flash point, etc.), potential health risks, storage and disposal recommendations, and spill/leak procedures. With this information, technicians and emergency personnel know how to handle the product as well as respond in the event of an emergency.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      268,
      269,
      266,
      267,
      256
    ],
    "source": "9781394330348"
  },
  {
    "id": 1295,
    "question": "You want to protect mobile device users on your network from potentially leaked files or data. Which of the following should you do to help reduce this risk? (Choose two.)",
    "choice_a": "Disable network autoconnection.",
    "choice_b": "Enforce data transmission over limits.",
    "choice_c": "Enable device encryption.",
    "choice_d": "Install mobile firewalls.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "When authorized users access devices through unintended connections or unauthorized users access stolen devices, they can access the data on the device. Disable autoconnection to avoid unintended connections and encrypt data on devices to help protect the data on them in the event they are stolen.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      232,
      156,
      198,
      155,
      124
    ],
    "source": "9781394330348"
  },
  {
    "id": 1296,
    "question": "You are at a Windows command prompt. The folder you are in has hundreds of files, so when you view a folder listing, you want it to only show one page of files at a time. Which command should you use to do this?",
    "choice_a": "<code>dir /p</code>",
    "choice_b": "<code>dir /o:s</code>",
    "choice_c": "<code>dir /w</code>",
    "choice_d": "<code>dir /s</code>",
    "correct_answer": "A",
    "explanation": "The <code>dir</code> command shows a folder (i.e., directory) listing. The <code>/p</code> switch displays only one page at a time. Think of it as the pause switch. The <code>dir /o:s</code> command lists the files in order by size, <code>dir /w</code> shows a wide format, and <code>dir /s</code> includes all the subdirectories. There are many other switches that can be used to modify the output of the <code>dir</code> command. Type <code>dir /?</code> at a command prompt to see them.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      56,
      62,
      63,
      107,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 1297,
    "question": "You have assigned the Finance group Modify permissions on the <code>D:\\MonthlyReports</code> folder. You then create a folder named <code>D:\\MonthlyReports\\January</code>. What level of permissions does the Finance group have to the <code>D:\\MonthlyReports\\January</code> folder?",
    "choice_a": "No access, because no permissions were explicitly set",
    "choice_b": "Full control, because no permissions were explicitly set",
    "choice_c": "Modify, because the folder inherits permissions from its parent folder",
    "choice_d": "Modify, because the folder inherits permissions from the Finance Group, and the Finance Group members can grant permissions to other users or groups for this folder",
    "correct_answer": "C",
    "explanation": "Inheritance is the default behavior throughout the permission structure, unless a specific setting is created to override it. For example, a user who has Read and Write permissions in one folder will have that in all the subfolders <i>unless</i> a change has been made specifically to one of the subfolders. Modify access does not give users permissions to change permissions for others. Only Full Control allows it.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      200,
      171,
      119,
      160,
      126
    ],
    "source": "9781394330348"
  },
  {
    "id": 1298,
    "question": "Your company has a policy prohibiting illegal content on company computers. You have identified and verified illegal content on a user\u2019s workstation. What is the next step you should take?",
    "choice_a": "Ask the user to delete the material.",
    "choice_b": "Delete the illegal material yourself.",
    "choice_c": "Document the situation.",
    "choice_d": "Report the incident through proper channels.",
    "correct_answer": "D",
    "explanation": "If you have your policy in place, then your incident response plan should be relatively scripted. Your first priority as the first responder is to identify the improper activity or content. Then you should always get someone else to verify the material or action, so that it doesn\u2019t turn into a situation of your word against someone else\u2019s. Immediately report the situation through proper channels and secure the drive away from the user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      272,
      273,
      285,
      270,
      276
    ],
    "source": "9781394330348"
  },
  {
    "id": 1299,
    "question": "Your Windows workstation is having intermittent video issues. The manufacturer\u2019s website suggests you install the latest driver. Which utility should you use to check the driver version installed on your computer?",
    "choice_a": "Display Settings",
    "choice_b": "Device Manager",
    "choice_c": "Services",
    "choice_d": "Disk Management",
    "correct_answer": "B",
    "explanation": "Device Manager enables you to manage all your hardware devices, including updating drivers and disabling the device. It is found within the Computer Management console and in the Control Panel, but the quickest way is to right-click the Start button and select it there.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      29,
      28,
      94,
      1,
      10
    ],
    "source": "9781394330348"
  },
  {
    "id": 1300,
    "question": "On a MacBook Pro running macOS, what is the name of the bar of icons that runs along the bottom of the screen, enabling you to quickly open apps?",
    "choice_a": "Remote Disc",
    "choice_b": "Finder",
    "choice_c": "Spotlight",
    "choice_d": "Dock",
    "correct_answer": "D",
    "explanation": "In macOS, there is a bar of icons that runs along the bottom (or side, if so configured) of your screen. That set of icons is known as the Dock, and it provides easy access to key apps that come with the Mac (such as Safari, Mail, Videos, and Music) or others that you choose to add there. Remote Disc enables Macs without optical drives to use another computer\u2019s optical drive across a network. The Finder is similar to Windows File Explorer and enables the user to drill down through files and folders to find what they are seeking. Spotlight is a search tool.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      85,
      87,
      76,
      7,
      5
    ],
    "source": "9781394330348"
  },
  {
    "id": 1301,
    "question": "A Windows workstation is not booting properly, and you believe it\u2019s a problem with system files. Which utility can scan and repair corrupt Windows system files?",
    "choice_a": "<code>chkdsk</code>",
    "choice_b": "<code>diskpart</code>",
    "choice_c": "<code>tracert</code>",
    "choice_d": "<code>sfc</code>",
    "correct_answer": "D",
    "explanation": "The purpose of the System File Checker (SFC) utility is to keep the operating system (OS) alive and well. SFC is launched at a command prompt and after the system reboots, it automatically verifies that system files have not been altered or corrupted. If a corrupted or altered file is found, a stored (cached) copy of the system file overwrites it. The check disk utility, <code>chkdsk</code>, is used to verify the integrity of the filesystem and to identify bad sectors of a hard drive. In the graphical user interface (GUI), it is called error checking. The Windows command-line utility <code>diskpart</code> allows you to perform disk partition operations. The <code>tracert</code> utility traces the route a packet takes from one computer to another.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      60,
      61,
      63,
      30,
      51
    ],
    "source": "9781394330348"
  },
  {
    "id": 1302,
    "question": "An Android phone user reports that their phone can\u2019t connect to the company\u2019s wireless network, but they have a cellular signal. What is the first thing to have them try?",
    "choice_a": "Check whether the phone is in Airplane mode.",
    "choice_b": "Check whether the phone\u2019s Wi-Fi is enabled.",
    "choice_c": "Adjust the phone\u2019s Wi-Fi signal receptivity.",
    "choice_d": "Reset the phone to factory defaults.",
    "correct_answer": "B",
    "explanation": "The user should check to ensure that the phone\u2019s Wi-Fi is enabled. A common cause for a lack of wireless connectivity is for a device to be in Airplane mode, but because the user has a cellular signal, the phone definitely isn\u2019t in this mode. The other wireless signal types (i.e., Wi-Fi and Bluetooth) can be individually disabled, so check them both. Adjusting receptivity isn\u2019t an available option on smartphones, and resetting the phone to factory defaults will wipe out the phone\u2019s data.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      226,
      221,
      223,
      224,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1303,
    "question": "You are troubleshooting a Windows Home workstation with malware on it. Following the best-practice procedures for malware removal, you have gotten to the point where you\u2019ve scheduled system scans and run anti-malware updates. What is the next step you should take?",
    "choice_a": "Educate the end user.",
    "choice_b": "Enable System Restore and create a restore point.",
    "choice_c": "Disable System Restore in Windows Home.",
    "choice_d": "Remediate the infected system.",
    "correct_answer": "B",
    "explanation": "The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected systems.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end-user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      220,
      217,
      134,
      173,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1304,
    "question": "When configuring NTFS permissions on a Windows workstation, what is the recommended method?",
    "choice_a": "Grant permissions to user accounts.",
    "choice_b": "Put user accounts into groups. Grant folder permissions to groups and file permissions to users.",
    "choice_c": "Put user accounts into groups. Grant folder permissions to users and file permissions to groups.",
    "choice_d": "Put user accounts into groups. Grant permissions to groups.",
    "correct_answer": "D",
    "explanation": "The recommended way to assign permissions on Microsoft systems is to grant them to groups. Then, users can be assigned to groups depending on their access needs. This is far less work than managing permissions on a user-by-user basis.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      126,
      171,
      117,
      119
    ],
    "source": "9781394330348"
  },
  {
    "id": 1305,
    "question": "You are at a Windows command prompt in the <code>D:\\users</code> folder. You want to use the copy command to copy the <code>D:\\users\\jdoe</code> folder to the <code>D:\\files</code> folder. Which of the following statements is true?",
    "choice_a": "You need to use the <code>robocopy</code> command to perform this task.",
    "choice_b": "You can use the command <code>copy d:\\users\\jdoe\\*.* d:\\files</code>.",
    "choice_c": "You can use the command <code>copy d:\\users\\jdoe d:\\files</code>.",
    "choice_d": "You can use the command <code>copy d:\\users\\jdoe d:\\files /y.</code>",
    "correct_answer": "A",
    "explanation": "The <code>copy</code> command makes a copy of a file in a second location. It cannot be used to copy folders. To copy a folder, you need to use the <code>robocopy</code> or <code>xcopy</code> command. The <code>robocopy</code> command is in the CompTIA A+ objectives. The <code>copy</code> and <code>xcopy</code> commands are not.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      57,
      56,
      62,
      63,
      105
    ],
    "source": "9781394330348"
  },
  {
    "id": 1306,
    "question": "You are working on your Windows computer and a security alert pops up, as shown in this graphic. What should your next action be?<img src=\"/question_assets/220-1202/c11f001.png\" alt=\"Screenshot of Computer security alert indicates 17 detected threats with options to remove all threats now or continue unprotected.\"/>\n\n<figcaption>Screenshot of Computer security alert indicates 17 detected threats with options to remove all threats now or continue unprotected.</figcaption>",
    "choice_a": "Click the Continue Unprotected button.",
    "choice_b": "Click the Remove All Threats Now button.",
    "choice_c": "Create a restore point and then click the Remove All Threats Now button.",
    "choice_d": "Shut down your computer, reboot, and initiate a malware scan using your anti-malware software.",
    "correct_answer": "D",
    "explanation": "Don\u2019t click the buttons! This is a fake security warning. When you click either button, something bad will happen\u2014something like malware being installed on your computer. Attackers are very creative about making their pop-ups look like legitimate security alerts. Shut your computer down, and after you reboot, run a malware scan, or if possible, boot with bootable media from your anti-malware company.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      211,
      210,
      139,
      209,
      220
    ],
    "source": "9781394330348"
  },
  {
    "id": 1307,
    "question": "You are instructing a new Mac user on the features of macOS. They ask if the system is capable of storing their passwords to various Internet sites. Which feature would they use for that?",
    "choice_a": "Keychain",
    "choice_b": "Mission Control",
    "choice_c": "FileVault",
    "choice_d": "Terminal",
    "correct_answer": "A",
    "explanation": "Keychain is a password management system from Apple. It enables you to store passwords for websites, mail servers, Wi-Fi, and so forth. There is an iCloud variant (i.e., iCloud Keychain) that keeps such information as Safari usernames/passwords and credit card information. Mission Control gives you a look at all the open apps, windows, and desktop spaces on your machine. FileVault provides encryption. Terminal is the command-line interface on macOS and most Linux systems. Windows 11 has the traditional Command Prompt and a new tool called Windows Terminal that opens a PowerShell prompt. Unlike Command Prompt, it enables the user to create multiple tabs. Typing <b>exit</b> in Windows Terminal exits the program instead of returning the user to a regular command prompt as it would in the Command Prompt.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      84,
      82,
      87,
      88
    ],
    "source": "9781394330348"
  },
  {
    "id": 1308,
    "question": "You are troubleshooting a malware problem with a Windows 11 computer and find that you need to boot into safe mode/safe boot, which loads with minimal drivers. Which management tool can you use to force the system to boot into safe mode when it reboots?",
    "choice_a": "Task Scheduler",
    "choice_b": "Computer Management",
    "choice_c": "System Configuration",
    "choice_d": "Task Manager",
    "correct_answer": "C",
    "explanation": "The System Configuration tool (<code>msconfig.exe</code>) allows you to force the operating system (OS) to boot into safe mode by clicking the box next to Safe Boot on the Boot tab. The System Configuration utility (<code>msconfig.exe</code>) has five tabs: General, Boot, Services, Startup, and Tools. Task Scheduler wouldn\u2019t work here because the OS loads before Task Scheduler could run. Computer Management and Task Manager don\u2019t have settings for booting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      30,
      28,
      27,
      51,
      29
    ],
    "source": "9781394330348"
  },
  {
    "id": 1309,
    "question": "Which of the following is an advantage of using share permissions over using NTFS permissions?",
    "choice_a": "Share permissions will override NTFS permissions if there is a conflict.",
    "choice_b": "Share permissions can be enabled to secure resources across the network that are not on an NTFS partition.",
    "choice_c": "Share permissions apply when users access a resource across the network, but NTFS permissions apply only to local users.",
    "choice_d": "Share permissions can be set at the file level, whereas NTFS permissions can be set only at the folder level.",
    "correct_answer": "B",
    "explanation": "The one big advantage of share permissions is that they can be used if the New Technology File System (NTFS) is not in place. Of course, share permissions are in effect only when the user connects to the resource via the network. NTFS permissions can protect at the file level. Share permissions can be applied to the folder level only. NTFS permissions can affect users logged on locally or across the network to the system where the NTFS permissions are applied.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      171,
      200,
      119,
      170,
      166
    ],
    "source": "9781394330348"
  },
  {
    "id": 1310,
    "question": "Your manager is concerned that your company could divulge PII. Which of the following types of data is not considered PII?",
    "choice_a": "First name",
    "choice_b": "Home address",
    "choice_c": "Family member names",
    "choice_d": "Employee ID number",
    "correct_answer": "A",
    "explanation": "Personally identifiable information (PII) is anything that can be used to identify an individual person on its own or in context with other information. This includes someone\u2019s full name, address, and other contact information; the names of family members; and other details that people would consider private. A first name is considered to be generally common enough that it is not PII. A first name, if not common, would be PII.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      275,
      276,
      312,
      252,
      277
    ],
    "source": "9781394330348"
  },
  {
    "id": 1311,
    "question": "You are training mobile users on potential security risks. Which of the following could make users more susceptible to an on-path attack?",
    "choice_a": "Unintended Wi-Fi connection",
    "choice_b": "Unauthorized account access",
    "choice_c": "Unauthorized location tracking",
    "choice_d": "Unauthorized camera activation",
    "correct_answer": "A",
    "explanation": "No unintended or unauthorized event is a good thing for mobile users. The one that leaves a user most susceptible to an on-path attack is an unintended Wi-Fi connection. This is because the device at the other end that the user is connecting to could be intercepting data or storing it for a possible attack later.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      149,
      145,
      155,
      232,
      195
    ],
    "source": "9781394330348"
  },
  {
    "id": 1312,
    "question": "The network you manage has a dozen Windows workstations. You want to ensure that users do not have the ability to change the boot order, so that they can\u2019t boot to an unauthorized device. Which step should you take?",
    "choice_a": "Disable AutoRun.",
    "choice_b": "Restrict user permissions.",
    "choice_c": "Set a BIOS/UEFI password.",
    "choice_d": "Enable a strong password policy.",
    "correct_answer": "C",
    "explanation": "The way to protect against this is to implement a basic input output system/unified extensible firmware interface (BIOS/UEFI) password. If a user can get into the BIOS/UEFI settings, they can change the boot sequence, boot to an unauthorized device, and then do some damage to the system. A strong Windows password will help protect Windows but does not protect the computer hardware or information before Windows loads. AutoRun is a feature of Windows and does not affect the boot process. If enabled, AutoRun will initiate any program, even if its malware, found in an <code>autorun.inf</code> file on any media that is inserted. User permissions limit what a user can do on a computer system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      174,
      161,
      117,
      170,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1313,
    "question": "A user needs to travel for a presentation and wants to be sure their laptop does not run using battery power. However, they also want to leave their files and applications running so that when they turn it back on, the applications are already open. Which of the following statements is true?",
    "choice_a": "The user will be unable to do this.",
    "choice_b": "The user should put their computer into standby mode.",
    "choice_c": "The user needs to activate the sleep power plan.",
    "choice_d": "The user should have their computer hibernate.",
    "correct_answer": "D",
    "explanation": "In Hibernate mode, the computer saves all the contents of memory to the hard drive, preserves all data and applications exactly where they are, and allows the computer to power off completely. When the system comes out of hibernation, it returns to its previous state. Sleep continues to use a small trickle of power until there is none left, then will go into Hibernate mode. Windows 10\u201311 support a feature called Modern Standby. Modern Standby must also be supported by the hardware. It is not the right answer because it also uses a small amount of power. With Modern Standby, the system will wake from the lowest power to allow short bursts (i.e., milliseconds) of software execution as the system needs them. The system uses just enough power to process background tasks but still preserve battery life. The result is that when in sleep mode, a computer can stay connected to a local area network (LAN) and reacts much like a smartphone with instant on/instant off ability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      43,
      3,
      1,
      6
    ],
    "source": "9781394330348"
  },
  {
    "id": 1314,
    "question": "A user calls the Help Desk and tells you that when they type <code>Wiley.com</code>, the browser goes to a site that looks similar but has a strange name at the top. What\u2019s happening to this user? (Choose two.)",
    "choice_a": "Browser redirection",
    "choice_b": "Malware infection",
    "choice_c": "Desktop alert",
    "choice_d": "Browser update failure",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Browser redirection is a symptom of a malware attack that has changed settings in the browser. Run anti-malware software and if necessary, change settings in the browser. Desktop alerts provide helpful notices, such as operating system (OS) updates that are needed, dangerous weather alerts, Amber (missing child) alerts, or other events. A browser update failure will either notify you or manifest as different issues.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      214,
      209,
      134,
      211,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1315,
    "question": "You have a Windows Pro workstation installed in a workgroup. There is no centralized security. Which tool should you use to help protect yourself against malicious network attacks?",
    "choice_a": "Software firewall",
    "choice_b": "NTFS Permissions",
    "choice_c": "Local Security Policy",
    "choice_d": "Computer Management",
    "correct_answer": "A",
    "explanation": "Windows 10\u201311 both incorporate a software firewall called Windows Defender Firewall with Advanced Security, which can be used to stop incoming and outgoing network traffic. Traffic is allowed or denied according to specific rules that are part of an access control list (ACL). By default, Windows Defender Firewall blocks incoming traffic. By creating exceptions, you can configure what incoming traffic you want to allow through. New Technology File System (NTFS) permissions are used to configure user access to files, folders, and volumes. Local Security Policy is used to configure items such as password policy and account lockout policies. Computer Management is a Microsoft Management Console and has several frequently used tools.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      173,
      140,
      119,
      117,
      152
    ],
    "source": "9781394330348"
  },
  {
    "id": 1316,
    "question": "You are working on a client\u2019s desktop computer, and the video card is dead. You can get a warranty replacement, but it will take three days to arrive. Or you can replace it with a more expensive card today, but the customer would need to pay the cost difference. Which of the following is the best way for you to continue the service call?",
    "choice_a": "Tell the customer that the video card is dead. It will take three days for the video card to arrive, and you will return then to replace it.",
    "choice_b": "Tell the customer that the video card is dead. It will take three days for a warranty replacement to arrive (at no cost), or you can replace it with an upgraded model today if they want to pay the difference in cost.",
    "choice_c": "Tell the customer that the video card is dead. Offer to replace it today with a more expensive video card, and they can pay the difference in cost.",
    "choice_d": "Tell the customer that they will be without a computer for three days, but then you will come back and fix it.",
    "correct_answer": "B",
    "explanation": "Set and meet, or exceed, customer expectations and communicate timelines and status. Customers want to know what is going on. In addition, giving the customer a choice in repair or replacement options will usually help the customer feel better because they have a choice in the outcome. Remember that if they have called you, their day is already more difficult than normal, so treat customers with kindness and compassion.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      307,
      304,
      309,
      310,
      311
    ],
    "source": "9781394330348"
  },
  {
    "id": 1317,
    "question": "You are attempting to update a Windows 11 workstation using Windows Update. The update fails with this message: \u201cFailure configuring Windows updates. Reverting changes.\u201d You reboot and try again but receive the same error. What should you try next? (Choose two.)",
    "choice_a": "Wait until changes are reverted. Unplug removable media from your computer and try again.",
    "choice_b": "Wait until changes are reverted. Run a malware scan and try again.",
    "choice_c": "Wait until changes are reverted. Run the Windows Update Troubleshooter.",
    "choice_d": "Ignore the update.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "If an operating system (OS) update fails, it could be a configuration issue or simply a one-time glitch in the process. Wait until Windows Update reverts the changes, then reboot and try the update again. If that does not work, you can unplug removable media from your computer and try again, or you can try the Windows Update Troubleshooter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      208,
      204,
      219,
      205
    ],
    "source": "9781394330348"
  },
  {
    "id": 1318,
    "question": "A user calls and complains that they can\u2019t see any printers when they try to print a document from their Windows computer. They say that they had three network printers showing yesterday, and they can access the server across the network. What will you do first?",
    "choice_a": "Reinstall the network printers.",
    "choice_b": "Check the status of the Print Spooler service.",
    "choice_c": "Reinstall Windows.",
    "choice_d": "Repair Windows.",
    "correct_answer": "B",
    "explanation": "Check the simple things first. If the Print Spooler service isn\u2019t running, then printers will not show. It\u2019s unlikely that you will need to reinstall or repair Windows.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      206,
      201,
      204,
      216,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1319,
    "question": "A user calls the Help Desk because they are not able to access the Internet. After asking a few questions, you discover that if they type an IP address in the browser, then the website pops up. Other users on the same switch aren\u2019t having this problem. Where will you start looking for the problem?",
    "choice_a": "File server",
    "choice_b": "Web server",
    "choice_c": "DNS settings",
    "choice_d": "DHCP settings",
    "correct_answer": "C",
    "explanation": "If you can reach a website using an Internet Protocol (IP) address, then the problem has something to do with Domain Name System (DNS) settings. The default DNS server can be configured using Dynamic Host Configuration Protocol (DHCP) settings. But because the other users aren\u2019t having this problem, it\u2019s not a setting on the DHCP server, which means it must be configured on the local computer. The user is able to reach the file server, and if they\u2019re accessing a remote website, the problem wouldn\u2019t be your company\u2019s web server.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [],
    "source": "9781394330348"
  },
  {
    "id": 1320,
    "question": "Whenever you log in to a computer at work, a screen with the company\u2019s name and some text appears. You must click OK before you can access the company network. What is a common security purpose of a company\u2019s custom splash screen?",
    "choice_a": "Announce upcoming events",
    "choice_b": "Advertising their products",
    "choice_c": "Tracking employee time",
    "choice_d": "Confirming agreement to an AUP",
    "correct_answer": "D",
    "explanation": "An acceptable use policy (AUP) describes what users are and are not allowed to do on the company\u2019s network. Often, companies will use a splash screen to confirm that the employee has read and agrees to the AUP or other company policies before they can use the network. In different environments such as a kiosk or app, a splash screen can display while the program is loading, and in those situations, it may be used to reinforce a brand or advertise products. There are ways to track employee time on the network, but that\u2019s not the job of the splash screen.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      126,
      117,
      159,
      210
    ],
    "source": "9781394330348"
  },
  {
    "id": 1321,
    "question": "Which of the following features are not available in the Home edition of Windows but are available in Pro and higher editions? (Choose three.)",
    "choice_a": "File compression",
    "choice_b": "Joining a Windows Domain",
    "choice_c": "Group Policy Editor (<code>gpedit.msc</code>)",
    "choice_d": "RDP host",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Windows 10\u201311 treat these items the same. The difference lies in whether the Home or Pro edition is being used. All Windows editions support the New Technology File System (NTFS) file compression. Only Windows editions that are Pro or higher support joining a domain, using the Group Policy Editor (<code>gpedit.msc</code>), and being a Remote Desktop Protocol (RDP) host. Windows Home editions <i>can</i> be a client connecting to an RDP host, but not an RDP host.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      18,
      20,
      21,
      60,
      72
    ],
    "source": "9781394330348"
  },
  {
    "id": 1322,
    "question": "You\u2019re configuring a remote connection and need a protocol or process to ensure that both parties to a transaction are who they say they are, and to encrypt their user information as it passes from one to the other. Which of the following will you use?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Kerberos",
    "choice_c": "RADIUS",
    "choice_d": "TKIP",
    "correct_answer": "B",
    "explanation": "When a client wants to authenticate to a server over a public network, Kerberos works with an authentication server (AS) to ensure that each party to the connection is who they say they are. Multifactor authentication (MFA) requires two or more factors for the user to prove their identity, such as a password and biometric login. The four available factors are what you know, what you have, who you are, and where you are. Remote authentication dial-in user service (RADIUS) is a protocol used specifically between a remote connection and server. It authenticates the remote user, and if the RADIUS server has the remote user configured as a client, it will send configuration information back to the user. RADIUS authenticates the remote user, not both parties. Temporal Key Integrity Protocol (TKIP) was used to encrypt information on wireless networks, but it is no longer considered secure.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      183,
      168,
      156,
      169,
      120
    ],
    "source": "9781394330348"
  },
  {
    "id": 1323,
    "question": "A user called the Help Desk because their mouse pointer is moving across the screen and windows are opening and closing. They believe it\u2019s not malware, because they said they didn\u2019t do anything; they just opened an email with a strange subject. Which of the following will be most important to prevent malware on this computer going forward?",
    "choice_a": "Educate users regarding threats.",
    "choice_b": "Install anti-malware and set it to update automatically.",
    "choice_c": "Enable and configure software firewalls.",
    "choice_d": "Enable and configure hardware firewalls.",
    "correct_answer": "A",
    "explanation": "While all four of these options will help to keep a computer system safe, all it takes is one employee who doesn\u2019t know how to recognize dangers and a malicious software can be unleashed on a computer system. Regular user education regarding common threats should be a part of your company\u2019s security plan.",
    "topic_id": 2,
    "practice_test_id": 10,
    "related_articles": [
      139,
      141,
      220,
      210,
      211
    ],
    "source": "9781394330348"
  },
  {
    "id": 1324,
    "question": "When your friend launches their new favorite game, they often get low-memory warnings. Which of the following can you do to prevent this problem from happening in the future? (Choose two.)",
    "choice_a": "Use Task Manager to end unnecessary programs.",
    "choice_b": "Increase virtual memory.",
    "choice_c": "Increase physical memory.",
    "choice_d": "Put in a faster NIC.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "If you\u2019re running low on memory, you have two options. You can modify the virtual memory settings, or you can add more physical memory if the motherboard will support it. Using Task Manager to close unnecessary programs will help in the short term but not in the long term if you often have those programs running. A faster network interface card (NIC) won\u2019t help here.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      43,
      31,
      9,
      42
    ],
    "source": "9781394330348"
  },
  {
    "id": 1325,
    "question": "A friend is having trouble with the network connection on their Windows 11 computer, so you open Network and Internet in the Settings app. Which of the following is not an option there?",
    "choice_a": "Advanced network settings",
    "choice_b": "Mobile Hotspot",
    "choice_c": "VPN",
    "choice_d": "Share a Printer",
    "correct_answer": "D",
    "explanation": "There are many settings that can be reached through Network & Internet in the Settings app. Of them, Advanced Network Settings, Mobile Hotspot, and Virtual Private Network (VPN) are just a few. The main menu items here include Wi-Fi, VPN, Mobile Hotspot, Airplane Mode, Proxy, Dial-up, Properties (for the connection), and Advanced Network Settings.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      66,
      67,
      70,
      32
    ],
    "source": "9781394330348"
  },
  {
    "id": 1326,
    "question": "You need to manually configure the IP address for a server. Which of the following pieces of information is not needed to configure IPv6?",
    "choice_a": "IPv6 address",
    "choice_b": "Subnet mask",
    "choice_c": "Subnet prefix length",
    "choice_d": "Default gateway",
    "correct_answer": "B",
    "explanation": "When configuring a static Internet Protocol (IP) address in IPv6 networking, a subnet mask is not needed, but you do need to know the subnet prefix length. That\u2019s the only difference between configuring IPv4 and IPv6. In addition to the IPv6 address and default gateway, you\u2019ll need to know the address of the preferred Domain Name System (DNS) server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      71,
      32,
      62,
      9
    ],
    "source": "9781394330348"
  },
  {
    "id": 1327,
    "question": "A user is trying to use Google Chrome on their Windows computer, but they receive the error message \u201cUnable to access the network.\u201d If they use Microsoft Edge, they are able to access websites with no problem. What do you need to do?",
    "choice_a": "Uninstall and reinstall Google Chrome.",
    "choice_b": "Instruct the user to only use Microsoft Edge.",
    "choice_c": "Ensure that Google Chrome is a permitted program in Windows Defender Firewall.",
    "choice_d": "Reinstall the operating system.",
    "correct_answer": "C",
    "explanation": "If they are able to access the Internet using Microsoft Edge, then the issue is with Google Chrome. The most likely problem is that the firewall isn\u2019t allowing it. To resolve the problem, go into Windows Defender Firewall, and in the inbound rules, add Google Chrome and allow it to send information through the firewall.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      173,
      140,
      175,
      119,
      170
    ],
    "source": "9781394330348"
  },
  {
    "id": 1328,
    "question": "Which of the following is not done/created before the change board approves a change?",
    "choice_a": "Rollback plan",
    "choice_b": "Sandbox testing",
    "choice_c": "Risk analysis",
    "choice_d": "Change freeze",
    "correct_answer": "D",
    "explanation": "If you\u2019re planning a change to an IT system, it\u2019s important to have a rollback plan, in case the change fails, and to test the change in a sandbox before you go live with it. You\u2019ll also want to do a thorough risk analysis and identify the systems that will be affected or impacted by the change. Getting end-user acceptance is also helpful, so be sure to explain to users why the change is necessary and involve them in the changes that will affect them, such as user input screens. A change freeze happens near the end of the project, when no more material changes to the project are allowed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      295,
      294,
      290,
      289,
      291
    ],
    "source": "9781394330348"
  },
  {
    "id": 1329,
    "question": "Your company makes a full backup every Sunday. Monday through Friday, the company creates differential backups. It keeps the weekly backup for a month, the daily backups are overwritten each week, and the company creates a backup once a month that is kept for a year. What is this backup scheme called?",
    "choice_a": "On-site/off-site",
    "choice_b": "Grandfather-father-son (GFS)",
    "choice_c": "3-2-1 backup rule",
    "choice_d": "Synthetic",
    "correct_answer": "B",
    "explanation": "The grandfather-father-son (GFS) method of backing up, as described in the question, ensures that there are short-term, medium-term, and long-term backups of a system. You should have backups both on-site and off-site. The 3-2-1 backup rule says you should have three copies of data, using two different types of media, with one of them being off-site. A synthetic backup is a full backup created by combining a recent full backup and the changes since then to create new files. It can be done outside the system, so there is no downtime and it\u2019s faster than doing a full backup.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      300,
      301,
      303,
      302,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1330,
    "question": "A user has called the Help Desk, and you\u2019ve entered their ticket. The problem they describe is beyond your training. What do you do?",
    "choice_a": "Hang up and tell them to call the PC manufacturer.",
    "choice_b": "Put them on hold for an hour while you figure it out.",
    "choice_c": "Escalate the problem to the next level.",
    "choice_d": "Tell them to perform a factory installation of their operating system.",
    "correct_answer": "C",
    "explanation": "If a problem is beyond your abilities, of course, you will follow the company policy. However, in most cases, you will escalate the problem to someone else who has appropriate training or experience to resolve the issue. Any of the other options might lose a customer permanently.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      310,
      280,
      308,
      254,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1331,
    "question": "Your friend has a new Windows 11 computer, and they\u2019re getting way too many notifications while they\u2019re trying to work. What will you tell them?",
    "choice_a": "Yes, we all do. It\u2019s just something we have to deal with.",
    "choice_b": "I can help you fix that. It\u2019s easy.",
    "choice_c": "We can turn them all off or all on; you don\u2019t get to choose.",
    "choice_d": "You have to reinstall your apps and tell them no when they ask if you want to allow notifications.",
    "correct_answer": "B",
    "explanation": "It\u2019s easy to pick and choose which notifications you want popping up on your screen. In the Windows 11 Settings application, search for Notifications and click the link. Once there, you can choose the application from which you want to receive notifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      34,
      23,
      49,
      48,
      22
    ],
    "source": "9781394330348"
  },
  {
    "id": 1332,
    "question": "Your client has computers using macOS and other computers that are Windows-based. They want to have a shared drive configured so that both operating systems can access it. The files are very large, some of them exceeding 4 GB. What filesystem should you use to format the shared drive?",
    "choice_a": "NTFS",
    "choice_b": "ext4",
    "choice_c": "exFAT",
    "choice_d": "FAT32",
    "correct_answer": "C",
    "explanation": "FAT32 and exFAT are both compatible with both Windows and macOS systems, but the exFAT filesystem supports files greater than 4 GB; FAT32 does not. New Technology File System (NTFS) is only compatible with Windows, ext4 is used in Linux/UNIX systems, and Apple File System (APFS) is the filesystem for macOS 10.13 and later.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      37,
      38,
      39,
      36,
      61
    ],
    "source": "9781394330348"
  },
  {
    "id": 1333,
    "question": "A user wants to have Full Control over their <code>C:</code> drive and all the contents of it, because they have one program that defaults to saving files in a folder there. Why will you not give them this access? (Choose two.)",
    "choice_a": "It is a security risk.",
    "choice_b": "It violates the Windows EULA.",
    "choice_c": "Only administrators can have access to the <code>C:</code> drive.",
    "choice_d": "It violates the principle of least privilege.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "It sounds like the user needs Read, Write, and perhaps Modify permissions to the folder on the C: drive, and they don\u2019t need any other access on that drive. The principle of least privilege is one of the most important security rules in computer systems. It says that you give a user only the access that they need to perform their job duties and nothing more. If they have access to the entire C: drive, and an attacker gets in on their account, then the attacker will have complete access too and can cause all sorts of trouble. Limiting them to only the folder they need also limits their exposure. The other two options are simply not true.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      117,
      167,
      170,
      200,
      171
    ],
    "source": "9781394330348"
  },
  {
    "id": 1334,
    "question": "A user has a computer that suddenly started running very sluggishly. Upon inquiry, you find that they went to some websites yesterday that they don\u2019t normally visit, so you decide to follow the best-practice procedures for malware removal. What is the first step?",
    "choice_a": "Quarantine infected systems.",
    "choice_b": "Disable System Restore in Windows Home.",
    "choice_c": "Investigate and verify malware symptoms.",
    "choice_d": "Schedule scans and run updates.",
    "correct_answer": "C",
    "explanation": "The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end-user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      217,
      209,
      220,
      138,
      134
    ],
    "source": "9781394330348"
  },
  {
    "id": 1335,
    "question": "A user tells you that they received a BSOD error on a Windows computer. No changes have been made to this computer recently. What is the best way to restart Windows to see whether you can isolate the issue?",
    "choice_a": "Boot to the Windows installation media and start the WinRE.",
    "choice_b": "Boot to safe mode.",
    "choice_c": "Boot using an anti-malware boot drive.",
    "choice_d": "Boot normally and see whether the error happens again.",
    "correct_answer": "D",
    "explanation": "If this is the first time the error has occurred, simply reboot and see if it goes away. Windows is quite stable, but occasionally a blue screen of death (BSOD) occurs, and you must reboot. If it doesn\u2019t happen again, there likely isn\u2019t a problem. If it continues to happen, look for any error message on the screen that will give you a clue about what the problem is, and then troubleshoot from there. If there is no error message, assume the problem is hardware or a corrupted driver and boot into safe mode to fix the issue.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      205,
      204,
      203,
      202,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1336,
    "question": "A user is attempting to log in to the computer that they normally use at work. The user reports that their profile is very slow to load and then they get an error message that says \u201cUnable to load profile.\u201d What should you suspect?",
    "choice_a": "The profile is too large.",
    "choice_b": "The profile is corrupted.",
    "choice_c": "The user logged on using the wrong password.",
    "choice_d": "They need to reboot and try again.",
    "correct_answer": "B",
    "explanation": "If a user profile is very large, it may be slow to load but should eventually get there. If there is an error message that it is unable to load, suspect a corrupted profile. To verify that\u2019s the problem, create a new user and copy the existing user profile to the new user, then try to log on as the new user. If the same error occurs, the profile is corrupted. You\u2019ll need to delete the corrupted profile and when the user logs on again, a new profile will be created.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      204,
      201,
      208,
      212,
      219
    ],
    "source": "9781394330348"
  },
  {
    "id": 1337,
    "question": "An app on your Android-based device won\u2019t open. What will you try first?",
    "choice_a": "Check for Android updates.",
    "choice_b": "Check for app updates.",
    "choice_c": "Restart the device.",
    "choice_d": "Clear the app\u2019s data and cache.",
    "correct_answer": "C",
    "explanation": "The first thing to try for an Android-based device that won\u2019t load an app is to restart the device and try the app again. If that doesn\u2019t work, try each of the following and restart between them, then see if the app will launch. First, check for Android updates. Next, check for app updates. Finally, clear the app\u2019s data and cache. If none of these solutions work, you might need to contact the app developer.",
    "topic_id": 3,
    "practice_test_id": 10,
    "related_articles": [
      221,
      222,
      223,
      224,
      208
    ],
    "source": "9781394330348"
  },
  {
    "id": 1338,
    "question": "You\u2019re installing a new video card in a computer. It was an expensive card, and you want to ensure that it isn\u2019t damaged by ESD. Until you are ready to place the card in the slot, what is the safest place for the card?",
    "choice_a": "Lying on the antistatic mat",
    "choice_b": "Lying on the antistatic bag",
    "choice_c": "Inside its antistatic bag",
    "choice_d": "Lying on the edge of the computer so that it\u2019s grounded",
    "correct_answer": "C",
    "explanation": "When you\u2019re installing a new component, the safest place for it is inside (not lying on) the antistatic bag in which it arrived. If an antistatic bag isn\u2019t available, the next safest place is lying on a grounded antistatic mat. You would never leave a new card teetering on the case\u2019s edge, and antistatic bags are essentially a Faraday cage, designed to keep static on the outside, so lying the component on the bag is not a good idea.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      259,
      258,
      260,
      256,
      267
    ],
    "source": "9781394330348"
  },
  {
    "id": 1339,
    "question": "Your company is an MSP. A client in another state is having a problem with their Windows 11 Desktop station and wants your help. What tool will you most likely use to assist them?",
    "choice_a": "RDP",
    "choice_b": "VPN",
    "choice_c": "VNC",
    "choice_d": "RMM",
    "correct_answer": "D",
    "explanation": "As a managed services provider (MSP), you\u2019ll already likely have remote monitoring and management (RMM) software set up to manage your client\u2019s computers and infrastructure. Remote Desktop Protocol (RDP) will let you take control of their system but requires user interaction, and a virtual private network (VPN) is used for connecting remotely to a network as if you were sitting in the office. A virtual network connection (VNC) is for connecting to a single client and it may be a part of an RMM product, but RMM is the best answer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      242,
      239,
      244,
      243,
      245
    ],
    "source": "9781394330348"
  },
  {
    "id": 1340,
    "question": "You are writing a script in Microsoft PowerShell to automate some processes that you perform daily. What file extension will the script file have?",
    "choice_a": "<code>.bat</code>",
    "choice_b": "<code>.ps1</code>",
    "choice_c": "<code>.vbs</code>",
    "choice_d": "<code>.py</code>",
    "correct_answer": "B",
    "explanation": "Script files can be used to make repeated tasks much easier by automating the process. PowerShell is a very popular scripting program among network administrators, and PowerShell files use a <code>.ps1</code> extension. A batch file has a <code>.bat</code> extension, Visual Basic scripts have a <code>.vbs</code> extension, and Python files have a <code>.py</code> extension. Others are <code>.sh</code>, for Bash (Linux) scripts and <code>.js</code>, for JavaScript.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      237,
      233,
      234,
      235
    ],
    "source": "9781394330348"
  },
  {
    "id": 1341,
    "question": "You need to add a new user on a Windows Pro desktop computer. What tool can you use to do this? (Choose two.)",
    "choice_a": "Local Users & Groups",
    "choice_b": "<code>gpedit.msc</code>",
    "choice_c": "<code>lusrmgr.msc</code>",
    "choice_d": "Certificate Manager",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "To add or manage users on a computer with Windows Pro edition installed, use the Local Users & Groups utility, which can be launched by running <code>lusrmgr.msc</code>, or search for user in the Settings application, or use the User Accounts applet of the Control Panel. The group policy editor filename is <code>gpedit.msc</code>, and Certificate Manager (<code>certmgr.msc</code>) stores digital certificates, which verify that websites and other computers have proven who they are and provided a valid certificate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      32,
      28,
      34,
      21,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 1342,
    "question": "A user who is less comfortable with technology is having to navigate through File Explorer to a network shared resource several times a day. The user asks if there is an easier way. What will you configure for this user?",
    "choice_a": "Mapped drive",
    "choice_b": "Domain name",
    "choice_c": "Subnet mask",
    "choice_d": "Gateway",
    "correct_answer": "A",
    "explanation": "Mapping a network drive for this user will make navigating to the resource much easier. A domain name identifies a Windows Active Directory domain. A subnet mask is used in Internet Protocol version 4 (IPv4) networking, and a gateway is the proxy server, router, or other device that connects a user to other networks, including the Internet.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      68,
      25,
      59,
      20,
      64
    ],
    "source": "9781394330348"
  },
  {
    "id": 1343,
    "question": "One of the users you are responsible for called the Help Desk because when they turned the computer on this morning, instead of booting into Windows, it showed a green screen with 1s and 0s running down it. What will you do?",
    "choice_a": "Turn the computer off and boot using boot media from your antivirus/anti-malware company.",
    "choice_b": "Go into WinRE and repair the operating system installation.",
    "choice_c": "Go into WinRE and perform a clean installation of the operating system.",
    "choice_d": "Boot into safe mode and restore from a recent restore point.",
    "correct_answer": "A",
    "explanation": "The computer is running a virus program before the operating system (OS) even boots, which indicates that there is a boot sector virus. The best way to remove this malware is using boot media from your antivirus company to clean the computer. You might need to go into the basic input output system/unified extensible firmware interface (BIOS/UEFI) settings and change the boot order to boot to the anti-malware media. You wouldn\u2019t need to repair or replace the operating system (OS) yet, although as part of the remediation you may need to replace it. It is unlikely with this scenario that you would be able to boot into safe mode, and even if you did, the malware could be lurking in the restore point. Part of the best practice procedures for malware removal is to disable System Restore in Windows Home.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      130,
      134,
      138,
      220,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 1344,
    "question": "Your mobile device locks after a short inactivity period for security reasons. Which of the following are common biometric devices for opening a mobile device whose screen is locked? (Choose two.)",
    "choice_a": "Facial recognition",
    "choice_b": "Fingerprint readers",
    "choice_c": "PIN codes",
    "choice_d": "Swipe to unlock",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Facial recognition and fingerprint readers are common methods of biometric identification on smartphones, tablets, and laptops. A personal identification number (PIN) code is a number, which is not biometric. Swipe to unlock offers virtually no security on a mobile device and is not a biometric method.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      191,
      115,
      169,
      192,
      193
    ],
    "source": "9781394330348"
  },
  {
    "id": 1345,
    "question": "A user logs on to their computer system and notices that several of their files are missing. What should you do?",
    "choice_a": "Begin the malware removal process.",
    "choice_b": "Reimage the machine.",
    "choice_c": "Restore the files from a backup.",
    "choice_d": "Restore from the last restore point.",
    "correct_answer": "A",
    "explanation": "This is a classic symptom of malware. The ten steps of the malware removal process are as follows:<ol><li>Investigate and verify malware symptoms.</li><li>Quarantine infected system.</li><li>Disable System Restore in Windows Home.</li><li>Remediate infected systems.</li><li>Update anti-malware software.</li><li>Scan and removal techniques (e.g., safe mode, preinstallation environment).</li><li>Reimage/reinstall.</li><li>Schedule scans and run updates.</li><li>Enable System Restore and create a restore point in Windows Home.</li><li>Educate the end-user.</li></ol>",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      217,
      220,
      134,
      209,
      127
    ],
    "source": "9781394330348"
  },
  {
    "id": 1346,
    "question": "A new network admin wants to try their hand at writing a PowerShell script. You tell them that\u2019s fine but to show it to you before they run it. What are possible undesirable effects of running a script file? (Choose two.)",
    "choice_a": "Inadvertently changing system settings",
    "choice_b": "Saving time in remapping network drives",
    "choice_c": "Browser or system crashes due to mishandling of resources",
    "choice_d": "Automating backups",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Possible undesirable outcomes of running or allowing script files to be run are inadvertently changing system settings, browser or system crashes, and unintentionally introducing malware. The other options listed are advantages of script files.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      236,
      290,
      292,
      289,
      233
    ],
    "source": "9781394330348"
  },
  {
    "id": 1347,
    "question": "A user has called the Help Desk and told you that all of their Microsoft Word documents now have a <code>.boo</code> extension. What is your first course of action?",
    "choice_a": "Ask the user to restart the computer.",
    "choice_b": "Ask the user to rename all the files to a <code>.doc</code> extension.",
    "choice_c": "Run anti-malware.",
    "choice_d": "Isolate the system from the network.",
    "correct_answer": "D",
    "explanation": "Renamed files is a symptom of a malware attack. Isolate the system from the network (i.e., unplug the patch cable or turn off Wi-Fi), and then run anti-malware. Restarting the computer or manually renaming the files won\u2019t remove the malware.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      127,
      134,
      138,
      128,
      139
    ],
    "source": "9781394330348"
  },
  {
    "id": 1348,
    "question": "You have a macOS computer that is behaving in an unstable manner, so you press the Command+R keys while it is booting and enter Disk Utility. What option in Disk Utility will check and repair the filesystem?",
    "choice_a": "First Aid",
    "choice_b": "Partition",
    "choice_c": "Erase",
    "choice_d": "Restore",
    "correct_answer": "A",
    "explanation": "First Aid in the macOS Disk Utility will check and repair the filesystem, similar to Windows Error Checking. From Disk Utility, you can also erase, create, and restore partitions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      77,
      102,
      61,
      78,
      36
    ],
    "source": "9781394330348"
  },
  {
    "id": 1349,
    "question": "You need to configure encryption for the data-at-rest on a new Windows Pro workstation. Which of the following are options? (Choose two.)",
    "choice_a": "Kerberos",
    "choice_b": "EFS",
    "choice_c": "BitLocker",
    "choice_d": "RADIUS",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "For data-at-rest, which means it\u2019s on a storage media, your options are Encrypting File System (EFS) and BitLocker. BitLocker is more secure and would be preferred. Kerberos and remote authentication dial-in user service (RADIUS) secure information that is moving (i.e., data-in-transit/motion) between two points.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      174,
      156,
      172,
      168,
      183
    ],
    "source": "9781394330348"
  },
  {
    "id": 1350,
    "question": "An employee using their own smartphone for work (i.e., BYOD) calls the Help Desk and tells you that they have no Internet connectivity and can\u2019t even make phone calls. They are panicking, thinking their phone is broken. What might solve the problem?",
    "choice_a": "Turning Bluetooth on",
    "choice_b": "Turning Airplane mode off",
    "choice_c": "Restarting the smartphone",
    "choice_d": "Turning on their hotspots",
    "correct_answer": "B",
    "explanation": "Airplane mode disables all wireless communication. Because the user can\u2019t make calls or connect to the Internet, ask them to ensure that Airplane mode is off.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      226,
      225,
      224,
      223,
      221
    ],
    "source": "9781394330348"
  },
  {
    "id": 1351,
    "question": "A user has a Windows 10 Pro laptop that they have installed and tested lots of software on, and now it will barely run. There is nothing that they want to save on it, and they\u2019ve asked if you can just make it run like new again. What is the easiest way to do this?",
    "choice_a": "Create installation media from the Microsoft website and perform a repair installation.",
    "choice_b": "Create installation media from the Microsoft website and perform a clean installation.",
    "choice_c": "Boot to a recovery partition and perform a factory installation.",
    "choice_d": "Install a new hard drive and perform a clean installation from Microsoft installation media.",
    "correct_answer": "C",
    "explanation": "Most laptops, and many commercial desktop computers, have a recovery partition that can be used to restore the computer to factory defaults. Usually, you can get there by pressing a key or group of keys during the bootup. This would be better than using installation media made from the Microsoft website, because it will have the proper drivers and other software that came with the computer. There is no need to buy a new hard drive, unless the drive is physically damaged.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      51,
      45,
      46,
      55,
      1
    ],
    "source": "9781394330348"
  },
  {
    "id": 1352,
    "question": "You\u2019re verifying settings on your router and notice that it only has WPA2, not WPA3. Your devices have all been working with WPA2, and you have some older and some newer devices. What should your next steps be? (Choose two.)",
    "choice_a": "Update the router\u2019s firmware.",
    "choice_b": "Choose WPA2/WPA3 Transitional.",
    "choice_c": "Choose WPA3 Personal.",
    "choice_d": "Choose WPA2 Personal (AES).",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Many routers that don\u2019t have a setting for WPA3 can get it by updating the router\u2019s firmware. If some of your devices are older, they may not work with WPA3. WPA2/WPA3 Transitional (also known as WPA2/WPA3 mixed mode) is a mode that allows older devices to still work with WPA2, but they should be replaced or updated to WPA3 as soon as practicable. If you choose WPA3 Personal, some devices might not work. If you choose WPA2 Personal, your network is not as secure as it should be.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      180,
      198,
      124,
      139,
      194
    ],
    "source": "9781394330348"
  },
  {
    "id": 1353,
    "question": "Your client has a computer on their network that they have configured to be a secure web server. How should you configure their router to ensure that traffic for the server is going to the server? (Choose two.)",
    "choice_a": "Forward outgoing requests for port 443 to the web server\u2019s IP address.",
    "choice_b": "Forward incoming requests for port 443 to the web server\u2019s IP address.",
    "choice_c": "Set the router to use UPnP.",
    "choice_d": "Create a screened subnet for the web server.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Creating a screened subnet will protect your network from traffic interacting with the server and can be done with one router, as long as the web server, outside world, and internal network are on different router ports. Incoming requests for HTTPS port 443 should be forwarded to the web server. Universal Plug and Play (UPnP) is considered unsafe, but it is irrelevant to this web server question. You wouldn\u2019t forward outgoing requests.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      188,
      189,
      187,
      119,
      186
    ],
    "source": "9781394330348"
  },
  {
    "id": 1354,
    "question": "You\u2019ve tried to access a website that you\u2019re sure is safe, but you\u2019re getting an invalid certificate warning. What should you do?",
    "choice_a": "Verify the date and time on your computer.",
    "choice_b": "Run anti-malware.",
    "choice_c": "Report the website as dangerous.",
    "choice_d": "Delete the certificate from your computer.",
    "correct_answer": "A",
    "explanation": "Always try the simplest things first. An invalid certificate warning can come up if your date and time are incorrect, making them fall outside of the time the certificate is valid. That\u2019s the easiest fix.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      166,
      168,
      157,
      138,
      180
    ],
    "source": "9781394330348"
  },
  {
    "id": 1355,
    "question": "A friend asks you what it means to gain root access to an Android device and if they should do it. Which of the following is not true about Android root access?",
    "choice_a": "Android root access is like cracking software or jailbreaking an iPhone, which makes your device more vulnerable to attack.",
    "choice_b": "Android root access might not be illegal; however, it may void your device\u2019s warranty.",
    "choice_c": "Android root access is a safe way to get more out of your device.",
    "choice_d": "Android root access gives the user full access to the device, opening the potential to accidentally make undesirable changes.",
    "correct_answer": "C",
    "explanation": "Gaining Android root access does let you do more with your device, but it isn\u2019t necessarily safe. Jailbreaking is most commonly done with Apple devices because they are more locked down than Android devices are. Jailbreaking an iPhone, for instance, enables the user to install apps that are not approved by Apple. When you open any device up for your own use by cracking software or gaining root access, it also opens your device up more for cybercriminals to perpetrate an attack on it. Jailbreaking and gaining root access often void the warranty on your device. The device may become unstable due to changes made in that mode, and with the warranty voided, you are not likely to receive support in fixing problems. Jailbreaking may be illegal, depending on where you are in the world.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      228,
      117,
      155,
      139,
      197
    ],
    "source": "9781394330348"
  },
  {
    "id": 1356,
    "question": "A user calls the Help Desk and tells you that their iPhone is slow to respond. They have closed open apps, but it\u2019s still very slow. What will you check next?",
    "choice_a": "If the phone is overheating",
    "choice_b": "How much data is being used",
    "choice_c": "If they\u2019re having strange pop-ups",
    "choice_d": "How much space is on the device\u2019s storage",
    "correct_answer": "D",
    "explanation": "iPhones tend to have fewer malware incidents than other mobile devices, so it\u2019s most likely that the smartphone is too full, resulting in the device appearing to run more slowly just as it would with a desktop drive. Overheating, excessive data use, and pop-ups can be signs of a malware infection.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      223,
      221,
      230,
      225,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1357,
    "question": "A user has a 32-bit application that they want to use on a 64-bit operating system, and they have asked you if that will work. What do you tell them?",
    "choice_a": "Both 32-bit and 64-bit are interchangeable.",
    "choice_b": "Yes, a 32-bit application will work on a 64-bit operating system.",
    "choice_c": "No, the application must be 64-bit to run on a 64-bit operating system.",
    "choice_d": "A 64-bit application will run on a 32-bit operating system, but a 32-bit application will not run on a 64-bit operating system.",
    "correct_answer": "B",
    "explanation": "A 64-bit operating system (OS) will support both 32-bit and 64-bit applications. A 32-bit application will work on a 64-bit OS, but it won\u2019t take advantage of the 64-bit speed. It will essentially run half as fast as a 64-bit application would. A 32-bit OS only supports 32-bit programs; you can\u2019t run a 64-bit application on a 32-bit OS. Luckily, there aren\u2019t many computers with 32-bit OSs around anymore.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      9,
      1,
      55,
      18
    ],
    "source": "9781394330348"
  },
  {
    "id": 1358,
    "question": "You are required to enter a username, password, and a code from an authenticator app on your phone before you can access the company website. What type of authentication is this?",
    "choice_a": "Multi sign-on",
    "choice_b": "Single sign-on",
    "choice_c": "Multifactor",
    "choice_d": "Domain",
    "correct_answer": "C",
    "explanation": "This is a classic example of multifactor authentication (MFA). The username identifies you; the password (i.e., something you know) and the authenticator app code (i.e., something you have) are multiple ways to prove (i.e., authenticate) who you are. The four types of authentication are something you know, something you have, something you are (i.e., biometrics), and some place you are.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      120,
      113,
      169,
      118
    ],
    "source": "9781394330348"
  },
  {
    "id": 1359,
    "question": "You\u2019re troubleshooting a computer that appears to have contracted a boot sector virus. After following the best-practice procedures for malware removal, it seems to be booting okay now, and you have created a restore point in Windows. What is your next step?",
    "choice_a": "Schedule scans and run updates.",
    "choice_b": "Quarantine the infected system.",
    "choice_c": "Disable System Restore in Windows Home.",
    "choice_d": "Educate the end-user.",
    "correct_answer": "D",
    "explanation": "Educating the end-user on how to recognize malware and avoid it is paramount to preventing infections.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      220,
      139,
      130,
      138,
      217
    ],
    "source": "9781394330348"
  },
  {
    "id": 1360,
    "question": "Computer users are often reluctant to have anything change, so gaining their acceptance prior to the change will make a transition run more smoothly. What are two ways that you can gain end-user acceptance to a change? (Choose two.)",
    "choice_a": "Make them fill out request forms.",
    "choice_b": "Involve them in the planning process.",
    "choice_c": "Thoroughly explain why this change is necessary.",
    "choice_d": "Don\u2019t tell them, and just have the change done when they come in on a Monday.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "No one likes to have changes forced on them, but in IT there are changes every day. When you have a major change, your headaches will be less if you can gain end-user acceptance before the change occurs. One of the best ways to do this is to involve them in the parts of the planning process that affect them, such as user input screens. Have a meeting and listen to input from the people who will actually be using the system. They may have some insight that you don\u2019t. Also be sure to thoroughly explain why the change is necessary. The worst thing to do is spring the change on them by not telling them about it and having them discover it when they log in on Monday morning.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      296,
      295,
      292,
      291,
      288
    ],
    "source": "9781394330348"
  },
  {
    "id": 1361,
    "question": "Your company does a full backup every Sunday and incremental backups all the other days of the week at the end of each day. If you come in on Wednesday morning and your system has crashed overnight, what backups will need to be restored so that your system will be fully recovered?",
    "choice_a": "Sunday only",
    "choice_b": "Sunday and Monday",
    "choice_c": "Sunday and Tuesday",
    "choice_d": "Sunday, Monday, and Tuesday",
    "correct_answer": "D",
    "explanation": "Incremental backups will only back up what has changed since the last full backup or the last incremental backup. An incremental or full backup resets the archive bit, so only Monday\u2019s changes will be backed up on Monday, only Tuesday\u2019s changed files will be backed up on Tuesday, and so on. You will need to restore all three backups to get all the changes that have occurred since Sunday.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      301,
      302,
      303,
      298,
      289
    ],
    "source": "9781394330348"
  },
  {
    "id": 1362,
    "question": "You need to make a secure connection to a remote router and perform some configuration changes. What will enable you to do that securely?",
    "choice_a": "SSH",
    "choice_b": "Telnet",
    "choice_c": "Videoconferencing software",
    "choice_d": "FTP",
    "correct_answer": "A",
    "explanation": "Secure shell (SSH) has virtually replaced Telnet as a remote access protocol and program. Telnet is not secure, but SSH is. Videoconferencing software enables users to see and talk to one another as if in the same room while they may be thousands of miles apart. File Transfer Protocol (FTP) is used for efficiently transferring files, but it is not secure.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      241,
      245,
      239,
      244,
      240
    ],
    "source": "9781394330348"
  },
  {
    "id": 1363,
    "question": "What is the danger in using an operating system that has reached EOL?",
    "choice_a": "Lack of feature updates",
    "choice_b": "Lack of security updates",
    "choice_c": "No technical support",
    "choice_d": "Very expensive technical support",
    "correct_answer": "B",
    "explanation": "When an operating system (OS) has reached end-of-life (EOL) status, not only are there no more feature updates or support, but there are no security updates and patches, and therein lies the danger. Using an EOL OS might open your system up to hackers. When an OS reaches EOL, it\u2019s past the time to upgrade.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      154,
      153,
      146,
      152,
      209
    ],
    "source": "9781394330348"
  },
  {
    "id": 1364,
    "question": "A user calls the Help Desk and tells you that they\u2019re trying to watch a training video full screen, but the screen won\u2019t autorotate when they turn the phone. What will you have them do?",
    "choice_a": "Swipe down, look for the autorotate icon, and enable it.",
    "choice_b": "Restart their smartphone.",
    "choice_c": "Watch the video on their desktop computer.",
    "choice_d": "Click the full-screen icon on the video.",
    "correct_answer": "A",
    "explanation": "Although iPhones and Android smartphones use different icons for autorotate, for most smartphones a swipe from the top will reveal a quick menu showing autorotate and other commonly used features. Simply enable autorotate. Restarting the smartphone won\u2019t resolve the issue. The user may not have a desktop computer available and using it won\u2019t solve the problem. Clicking the full screen icon on the video won\u2019t help because failing to display full screen isn\u2019t the problem.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      227,
      221,
      223,
      226,
      225
    ],
    "source": "9781394330348"
  },
  {
    "id": 1365,
    "question": "You have hired a new network administrator. Assume their name is <code>NewUser</code>. How many and what types of accounts will you set up for <code>NewUser</code>?",
    "choice_a": "<code>NewUser</code>, an administrator account only",
    "choice_b": "<code>NewUser</code>, a standard user only",
    "choice_c": "<code>NewUser_Admin</code>, which is an administrator account, and <code>NewUser</code>, a standard user account",
    "choice_d": "<code>NewUser_Admin</code>, which is an administrator account, and <code>NewUser_Guest</code>, which is a guest account",
    "correct_answer": "C",
    "explanation": "Following best practices, this user would need two accounts: one is a member of the Administrators group, and another is a standard user. They should be instructed to only log on to the administrator account if they can\u2019t do what they need to from their standard user account, using features like Run As Administrator or entering their administrator password in the User Account Control (UAC) window.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      167,
      170,
      117,
      160,
      168
    ],
    "source": "9781394330348"
  },
  {
    "id": 1366,
    "question": "An application on your mobile device will not close and is unresponsive. What should be your first choice to fix it?",
    "choice_a": "Force-close the application.",
    "choice_b": "Restart the device.",
    "choice_c": "Revert to factory defaults.",
    "choice_d": "Reinstall the application.",
    "correct_answer": "A",
    "explanation": "The first step for any unresponsive app on your mobile device is to force-close it. How that is done will be different, depending on whether it is an Apple or an Android device. If the app is still causing problems, you can try restarting your device, and if that doesn\u2019t work, uninstall and reinstall the application. Reverting your mobile device to factory default shouldn\u2019t be necessary.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      222,
      208,
      223,
      224
    ],
    "source": "9781394330348"
  },
  {
    "id": 1367,
    "question": "You are running late because your morning appointment took longer than you thought it would. Your next client meeting is in 5 minutes, and they\u2019re 20 minutes away. What do you do?",
    "choice_a": "You get there when you get there. Your time is valuable.",
    "choice_b": "Skip that meeting and go on to the next, so you\u2019re not late all day.",
    "choice_c": "Call the client and apologize. Let them know the situation and ask if they would prefer to reschedule or see you a bit later.",
    "choice_d": "Call the client and tell them you\u2019re running late.",
    "correct_answer": "C",
    "explanation": "When you tell a client you will do something, you are setting their expectations. The rule is to meet or exceed the expectations that you set. Remember, people like options. Let them know that you\u2019re running late, apologize, and give them the option of how to proceed. Be sure to call the other clients scheduled for the day too.",
    "topic_id": 4,
    "practice_test_id": 10,
    "related_articles": [
      309,
      313,
      312,
      287,
      282
    ],
    "source": "9781394330348"
  },
  {
    "id": 1368,
    "question": "You have downloaded some open-source license software. What are you usually allowed to do with it?",
    "choice_a": "Modify the program to suit your needs.",
    "choice_b": "Resell the software to other people for a profit.",
    "choice_c": "Make copies but credit the original source and redistribute it under the same license under which you received it.",
    "choice_d": "Run only one copy on one machine.",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The exact terms of what you can and cannot do with the software will be spelled out in the license. However, it is common that you can use, modify, and share the source code, but not sell it for a profit, and you usually need to credit the original author of the software.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      274,
      287,
      270,
      312,
      286
    ],
    "source": "9781394330348"
  },
  {
    "id": 1369,
    "question": "You\u2019re in the middle of a major IT systems change and have gotten to a point where you realize that it\u2019s not going to work without shutting down everything for a week. This would cost the company a fortune and will put production way behind. What will you do?",
    "choice_a": "Let management know, and continue with the project.",
    "choice_b": "Follow the rollback plan.",
    "choice_c": "Fire the responsible staff member.",
    "choice_d": "Follow the AUP.",
    "correct_answer": "B",
    "explanation": "A case like this is exactly why you have a rollback plan. Occasionally, despite your best efforts, you get into a project and discover that it isn\u2019t going to work, or it will take longer than expected. Perhaps if you rework the plan, you could make the changes without a big disruption to the business. Involving management in what is going on is always a good idea. The acceptable use policy (AUP) likely doesn\u2019t have any bearing here.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      289,
      292,
      291,
      294,
      293
    ],
    "source": "9781394330348"
  },
  {
    "id": 1370,
    "question": "You\u2019re working at your desktop computer, viewing a web page you use often, when a website that you know should be updating doesn\u2019t seem to be. In fact, if you access it from a different device, the website looks different. What can you do to force the website to update on your computer? (Choose two.)",
    "choice_a": "Clear the browser\u2019s cache.",
    "choice_b": "Clear the browser\u2019s stored cookies.",
    "choice_c": "Uninstall and reinstall your browser.",
    "choice_d": "Hold the Ctrl and F keys simultaneously while on the website.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Websites store parts of pages in the cache to make loading them faster the next time. If you clear the browser\u2019s cache and cookies, then when you access the website, it must download all of the data that was previously cached, which means that it will be the updated version. It may take a little longer, but it will be up to date. If it\u2019s a site where you use cached credentials to log in, you must log in again. Uninstalling and reinstalling your browser isn\u2019t necessary. The Ctrl key and F key pressed simultaneously usually brings up a Find dialog box.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      176,
      138,
      179,
      209,
      134
    ],
    "source": "9781394330348"
  },
  {
    "id": 1371,
    "question": "You\u2019re on your smartphone and notice that the apps are all responding slowly, almost jittery when you change from one to the other. What is the first thing to do?",
    "choice_a": "Check the device\u2019s storage.",
    "choice_b": "Close some running apps.",
    "choice_c": "Suspect a virus.",
    "choice_d": "Check the battery charge.",
    "correct_answer": "D",
    "explanation": "If the battery is very low, the applications can show a slower-than-normal response time. If this continues when the phone is charged, see how full your phone is. If it\u2019s slow when you\u2019re saving or reading files, then you might need to clear out some space on your phone. Make sure your phone is updated. If it\u2019s an Android phone, ensure that your anti-malware is updated. If the problem happens with just one app, try updating the app, clearing the app\u2019s cache, or removing and reinstalling the app.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      221,
      223,
      225,
      224,
      222
    ],
    "source": "9781394330348"
  }
];
